/*! For license information please see lambda-header.js.LICENSE.txt */
!(function () {
  var e,
    n,
    t = {
      128: function (e, n, t) {
        (n = t(645)(!1)).push([
          e.id,
          ".collapsible-panel {\n  border: none;\n  border-bottom: 1px solid #d4d4d4;\n  padding: 0 16px;\n  overflow: hidden;\n  transition: border-color 0.3s ease;\n}\n\n.panel-header {\n  align-items: normal;\n  background-color: #fff;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  height: 60px;\n  justify-content: space-between;\n  padding: 12px 0 16px 0;\n  transition: background-color 0.3s ease;\n}\n\n.panel-header:focus-visible {\n  outline-color: #101010;\n}\n\n.icon-container {\n  width: 6px;\n  margin-bottom: 2px;\n}\n\n.panel-heading,\n.trailing-text {\n  color: rgb(51, 51, 51);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px;\n}\n\n.panel-heading {\n  margin-left: 10px;\n}\n\n.panel-content {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease-out, padding 0.3s ease-out;\n}\n\n.panel-content-inner {\n  padding: 0 0 12px 20px;\n  margin-top: -3px;\n}\n\n.ltch-collapsible-panel-header {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  justify-content: space-between;\n}\n\n.ltch-progress-bar-wrapper {\n  display: flex;\n  height: 8px;\n  margin: 4px 16px 0 16px;\n  width: 96%;\n}\n\n.ltch-popover-content-heading {\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ddd;\n  display: flex;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  justify-content: space-between;\n  line-height: 18px;\n  padding: 8px 16px;\n}\n\n.ltch-popover-content-subheading {\n  gap: 4px;\n  display: flex;\n}\n\n.ltch-popover-content-heading-running {\n  color: #666;\n  font-weight: 400;\n}\n\n.ltch-popover-content-footer {\n  border-bottom: 1px solid #ddd;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px;\n  padding: 16px;\n}\n",
          "",
        ]),
          (e.exports = n);
      },
      949: function (e, n, t) {
        (n = t(645)(!1)).push([
          e.id,
          'body,\nhtml {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n\n.wrapper {\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto,\n    "Helvetica Neue", Arial, sans-serif;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  -webkit-font-smoothing: antialiased;\n}\n\n.Left_Nav {\n  background-color: #161a22;\n  /* margin-top: 8px; */\n  transition: width 180ms cubic-bezier(0.4, 0, 1, 1) 0.01s;\n  width: 220px;\n}\n\n.ltch-sidebar-overlay .Left_Nav {\n  opacity: 0;\n  height: 0;\n  width: 0;\n  position: absolute;\n  top: -99999px;\n}\n\n.Top_Nav,\n.Left_Nav {\n  z-index: 99;\n}\n\n.wrapper.ltch-sidebar-overlay .Left_Nav:not(.ltch-left-nav-overlay) {\n  visibility: hidden;\n}\n\n.lambda__logo__img {\n  display: flex;\n}\n\n.ltch-left-nav-overlay.collapsed .ltch_lambda__logo {\n  width: 30px;\n}\n\n.ltch-left-nav-overlay .lambda__logo__black__text {\n  transition: opacity 180ms cubic-bezier(0.4, 0, 1, 1) 0.01s;\n  opacity: 1;\n}\n\n.ltch-left-nav-overlay.collapsed .lambda__logo__black__text {\n  opacity: 0;\n}\n\n.ltch_lambda__logo {\n  height: 48px;\n}\n\n.ltch_lambda__logo:focus-visible {\n  outline: 1px dotted #fff;\n}\n\n.ltch-left-nav-overlay .ltch_lambda__logo:focus-visible {\n  outline: 1px solid #101010;\n  outline-offset: -1px;\n}\n\n.header__top__menu.collapsed .lambda__logo__img {\n  display: initial;\n}\n\n.main_section {\n  display: flex;\n  flex-grow: 1;\n}\n\n.product_main_content {\n  background-color: #fff;\n  flex: 1;\n}\n\n.ltch_inline_flex {\n  display: inline-flex;\n}\n\n.announcekit__widget .announcekit-widget-badge {\n  background-color: #0969da !important;\n  position: absolute !important;\n  right: -5px !important;\n  width: 15px !important;\n  height: 15px !important;\n  top: -5px !important;\n}\n\n.announcekit__widget {\n  height: 24px;\n}\n\n.announcekit__widget-new {\n  background-color: #f7f7f7;\n  border-radius: 6px;\n  border: 1px solid rgba(27, 31, 36, 0.15);\n  box-shadow: 0px 1px 0px 0px rgba(27, 31, 35, 0.04);\n  color: #333;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  height: 28px;\n  width: 28px;\n  padding: 4px;\n}\n\n.announcekit__widget-new.ltch_high_contrast_item {\n  border: 1px solid #888;\n}\n\n.announcekit__widget:hover ~ .ltch-top-nav-buttons-tooltip-overlay,\n.announcekit__widget:focus-visible ~ .ltch-top-nav-buttons-tooltip-overlay {\n  visibility: visible;\n}\n\n.header__top__menu {\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 #0000000a;\n  height: 52px;\n  padding-left: 240px;\n  position: relative;\n  transition: padding-left 180ms cubic-bezier(0.4, 0, 1, 1) 0.01s;\n}\n\n.ltch-sidebar-overlay .header__top__menu {\n  box-shadow: none;\n}\n\n.header__top__menu.collapsed {\n  padding-left: 56px;\n}\n\n.ltch-sidebar-overlay .lambda__logo__wrapper {\n  width: 320px;\n  max-width: 320px;\n}\n\n.lambda__logo__wrapper {\n  align-items: center;\n  background: #161a22;\n  box-sizing: border-box;\n  display: flex;\n  height: 100%;\n  left: 0;\n  max-width: 220px;\n  padding: 0px 10px 0 18px;\n  position: absolute;\n  top: 0;\n  width: 220px;\n  transition: width 180ms cubic-bezier(0.4, 0, 1, 1) 0.01s;\n}\n\n.header__aside__menu {\n  z-index: 1000;\n}\n\n.Left_Nav.collapsed,\n.header__aside__menu.collapsed {\n  width: 56px;\n}\n\n.header__top__menu.collapsed .ltch_lambda__logo {\n  overflow: hidden;\n}\n\n.header__top__menu.collapsed .top__nav__items {\n  width: calc(100% - 56px);\n  position: absolute;\n  left: 56px;\n}\n\n.top__nav__items {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 100%;\n}\n\n.new__sidebar__top__nav__items {\n  border-bottom: 1px solid #eaeaea;\n  width: calc(100% - 56px);\n  position: absolute;\n  left: 56px;\n}\n\n.header__top__menu.collapsed .top__nav__items {\n  padding-left: 16px;\n  box-sizing: border-box;\n}\n\n.header__top__menu:not(.collapsed)\n  .new__sidebar__top__nav__items\n  .top__nav__product__title {\n  position: relative;\n  left: 16px;\n}\n\n.header__aside__menu.collapsed .aside__menu__item {\n  width: 40px;\n  transition: 180ms width;\n}\n\n/* .header__aside__menu.collapsed\n  .aside__menu__item\n  .aside__menu__link\n  .ltch-product-name-container {\n  color: #fff;\n} */\n/* \n.header__aside__menu.collapsed\n  .aside__menu__item\n  .aside__menu__link\n  .ltch-product-name {\n  opacity: 0;\n}\n\n.header__aside__menu.collapsed .aside__menu__item:hover .ltch-product-name {\n  opacity: 1;\n} */\n\n.ltch-left-nav-overlay .header__aside__menu .ltch-product-name {\n  transition: opacity 180ms cubic-bezier(0.4, 0, 1, 1) 0.01s;\n  opacity: 1;\n}\n\n.ltch-left-nav-overlay .header__aside__menu.collapsed .ltch-product-name {\n  overflow: hidden;\n  opacity: 0;\n}\n\n.ltch-left-nav-overlay\n  .header__aside__menu.collapsed\n  .ltch_high_contrast_item\n  .ltch-product-name {\n  width: 0;\n}\n\n.ltch-left-nav-overlay\n  .header__aside__menu.collapsed\n  .ltch_high_contrast_item\n  .aside__menu__link.aside__menu__link__anchor.aside__menu__link__anchor__expandable {\n  padding-left: 10px;\n}\n\n.ltch-left-nav-overlay\n  .header__aside__menu.collapsed\n  .ltch_high_contrast_item.ltch-aside__menu__item.aside__menu__secondary__item\n  .aside__menu__link.aside__menu__link__anchor {\n  padding-left: 25px;\n}\n\n.ltch-left-nav-overlay\n  .header__aside__menu.collapsed\n  .ltch_high_contrast_item\n  .aside__menu__link.aside__menu__link__anchor {\n  padding-left: 25px;\n}\n\n.header__top__menu.collapsed .lambda__logo__wrapper {\n  width: 56px;\n  z-index: 99;\n}\n\n.header__aside__menu.collapsed .aside__menu__items-useful {\n  flex-direction: column;\n  animation: animateIcons 600ms;\n}\n\n@keyframes animateIcons {\n  from {\n    flex-direction: row;\n  }\n\n  to {\n    flex-direction: column;\n  }\n}\n\n.header__aside__menu.collapsed\n  .aside__menu__item__bottom-upgrade\n  .aside__menu__item__bottom__icon {\n  margin-right: 0;\n  position: absolute;\n  left: 22px;\n}\n\n.header__aside__menu.collapsed\n  .aside__menu__item__bottom-upgrade\n  .aside__menu__item__bottom__link {\n  justify-content: initial;\n  padding-left: 56px;\n}\n\n.header__aside__menu.collapsed .aside__menu__item .arrow__icon {\n  display: none;\n}\n\n.menu__collapse__toggle {\n  background-repeat: no-repeat;\n  background-size: 20px;\n  cursor: pointer;\n  height: 20px;\n  opacity: 0;\n  position: absolute;\n  right: -10px;\n  transition: opacity 180ms;\n  width: 20px;\n  z-index: 1;\n}\n\n.menu__collapse__toggle:focus-visible {\n  opacity: 100;\n}\n\n.opened__menu__icon {\n  display: none;\n}\n\n.lambda__logo__wrapper:hover .menu__collapse__toggle,\n.ltch-left-nav-hovered .menu__collapse__toggle {\n  opacity: 1;\n}\n\n.menu__collapse__toggle:hover circle {\n  fill: #e9ecec;\n}\n\n.menu__collapse__toggle:hover path {\n  stroke: #000;\n}\n\n.lt-dropdown-toggle * {\n  pointer-events: none;\n}\n\n.lt-dropdown-menu {\n  background: #ffffff;\n  position: absolute;\n  top: 100%;\n  border-radius: 4px;\n  display: none;\n  z-index: 2;\n}\n\n.lt-dropdown.open .lt-dropdown-menu,\n.lt-dropdown.open .dropdown__icon__active {\n  display: block;\n}\n\n.top__nav__product__title {\n  align-items: center;\n  color: #333;\n  display: flex;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  letter-spacing: -0.15px;\n  line-height: 20px;\n}\n\n.navbar__header {\n  flex: 1;\n  text-align: center;\n  padding-top: 9px;\n}\n\n#promoMessage {\n  margin-bottom: 0;\n  font-size: 12px;\n  letter-spacing: 0.7px;\n  color: #4a4a4a;\n  margin-top: 0px;\n}\n\n#promoEntireDiv {\n  cursor: pointer;\n  text-align: left;\n  font-size: 12px;\n}\n\n#promoMessageDiv {\n  background-color: #ff6565;\n  border-radius: 4px;\n  padding: 2px 10px;\n  color: #fff;\n  font-weight: 700;\n  cursor: pointer;\n  text-decoration: none !important;\n  margin-left: 3px;\n  margin-right: 3px;\n}\n\n.menu__items {\n  display: flex;\n  list-style: none;\n  align-items: center;\n  padding-right: 15px;\n  margin: 0;\n}\n\n.menu__items .nav__item {\n  position: relative;\n  margin-left: 5px;\n  margin-right: 5px;\n  height: fit-content;\n}\n\n.tunnel__dropdown__toggle,\n.ltch-button {\n  align-items: center;\n  background: #f7f7f7;\n  border-radius: 6px;\n  border: 1px solid rgba(27, 31, 36, 0.15);\n  box-shadow: 0px 1px 0px 0px rgba(27, 31, 35, 0.04);\n  color: #333;\n  cursor: pointer;\n  display: flex;\n  font-size: 12px;\n  font-weight: 600;\n  height: 32px;\n  justify-content: space-between;\n  line-height: 18px;\n  min-width: 130px;\n  outline: none !important;\n  padding: 5px 8px;\n}\n\n.tunnel__dropdown__toggle.ltch_high_contrast_item,\n.ltch-button.ltch_high_contrast_item {\n  border: 1px solid #888;\n}\n\n.tunnel__dropdown__toggle-new,\n.ltch-icon-btn {\n  align-items: center;\n  background: #f7f7f7;\n  border-radius: 6px;\n  border: 1px solid rgba(27, 31, 36, 0.15);\n  box-shadow: 0px 1px 0px 0px rgba(27, 31, 35, 0.04);\n  color: #333;\n  cursor: pointer;\n  display: flex;\n  font-size: 12px;\n  font-weight: 600;\n  height: 28px;\n  justify-content: space-between;\n  line-height: 22px;\n  min-width: auto;\n  outline: none !important;\n  padding: 4px;\n  width: 28px;\n}\n\n.ltch-icon-btn {\n  justify-content: center;\n}\n\n.ltch-flex {\n  display: flex;\n}\n\n.tunnel__dropdown__toggle:hover,\n.ltch-button:hover,\n.ltch-popover-trigger:hover,\n.announcekit__widget:hover {\n  background-color: rgb(243, 244, 246);\n}\n\n.tunnel__dropdown__toggle .question__info {\n  width: 16px;\n  height: 16px;\n  border-radius: 15px;\n  display: inline-block;\n  background-color: #eaeaea;\n  font-size: 12px;\n  color: #4a4a4a;\n  text-align: center;\n  position: relative;\n  top: -1px;\n  line-height: 1.3;\n  margin-left: 3px;\n}\n\n/* .tunnel__dropdown__toggle__list {\n  display: none;\n} */\n\n.tunnel__dropdown__toggle__list .tunnel__dot {\n  background: #7ed321;\n  width: 8px;\n  height: 8px;\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 5px;\n}\n\n.tunnel__dropdown__toggle__list .tunnel__lenght {\n  border-radius: 20px;\n  background: #e7eae3;\n  font-size: 11px;\n  display: inline-block;\n  padding: 0px 8px;\n  font-weight: 500;\n  min-width: 10px;\n  margin-left: 5px;\n}\n\n#tunnel__dropdown__menu__list {\n  width: 400px;\n  padding: 0;\n}\n\n.tunnel_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: #4a4a4a11;\n}\n\n.configure__new__tunnel {\n  padding: 15px;\n  position: relative;\n  background-color: #ffffff;\n  border-radius: 4px 4px 0px 0px;\n}\n\n#tunnel__list__container {\n  background-color: #fff;\n  border-radius: 0 0 4px 4px;\n  max-height: 230px;\n  overflow-y: auto;\n  position: relative;\n}\n\n.tunnel__list__li {\n  font-size: 14px;\n  font-weight: 400;\n  color: #4a4a4a;\n  display: flex;\n  overflow: hidden;\n  padding: 15px;\n  border-top: 1px solid #eaeaea;\n  justify-content: space-between;\n}\n\n.tunnel__list__li .tunnel__close__btn {\n  cursor: pointer;\n}\n\n.tunnel__list__li .tunnel__close__btn img {\n  display: inline-block;\n  width: 12px;\n}\n\n.configure__new__tunnel__btn {\n  padding: 6px 10px !important;\n  border-radius: 3px;\n  font-size: 12px;\n  color: #fff;\n  background-color: #101010;\n  border: 0 !important;\n  outline: none !important;\n  cursor: pointer;\n}\n\n.tunnel__load__balanced__flag {\n  display: block;\n  font-weight: normal;\n  font-size: 11px;\n  color: #969595;\n  margin-top: 5px;\n}\n\n.tunnel__close__btn__disabled {\n  /* pointer-events: none; */\n  color: #c3c3c3;\n  background-color: #fff;\n  cursor: default !important;\n}\n\n.view__all__tunnels {\n  font-size: 12px;\n  color: #4ebbc6;\n  font-weight: bold;\n  letter-spacing: 0.7px;\n  background-color: #fff;\n  display: block;\n  opacity: 1;\n  position: relative;\n  padding: 15px;\n  border-top: 1px solid #eaeaea;\n  border-radius: 0px 0px 3px 3px;\n}\n\n.view__all__tunnels:hover {\n  color: #40a9ff;\n}\n\n#tunnel__dropdown__menu__configure {\n  width: 400px;\n  padding: 0px;\n}\n\n#tunnel__dropdown__menu__list.open,\n#tunnel__dropdown__menu__configure.open {\n  display: block !important;\n  left: initial;\n  right: 0;\n  top: 46px;\n  border: solid 1px #f1f0f0;\n}\n\n.tunnel__dropdown .lt-dropdown-menu::before {\n  right: 17px;\n  width: 12px;\n  height: 12px;\n  margin-left: auto;\n  margin-right: auto;\n  top: -7px;\n  position: absolute;\n  display: inline-block;\n  content: "";\n  z-index: 1;\n  background: #ffffff;\n  border-left: 1px solid #d2d2d2;\n  border-top: 1px solid #d2d2d2;\n  transform: rotate(45deg);\n}\n\n.tunnel__dropdown__header {\n  display: flex;\n  justify-content: space-between;\n  padding: 0px 25px 0px 20px;\n  height: 60px;\n  align-items: center;\n  font-size: 14px;\n  color: #666;\n  letter-spacing: 1px;\n  font-weight: 500;\n  background-color: #ffffff;\n  position: relative;\n  border-radius: 4px;\n}\n\n.tunnel__dropdown__header h4 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.tunnel_dropdown_hide {\n  cursor: pointer;\n}\n\n.tunnel_dropdown_hide:focus-visible {\n  outline-color: #101010;\n}\n\n.tunnel__dropdown__tabs .lt-nav-tabs {\n  overflow: hidden !important;\n  border-bottom: 0;\n  position: relative;\n  padding: 0;\n  margin: 0;\n}\n\n.tunnel__dropdown__tabs .lt-nav-tabs > li {\n  float: left !important;\n  width: 50%;\n  list-style-type: none;\n}\n\n.tunnel__dropdown__tabs .lt-nav-tabs > li div {\n  color: #555;\n  background-color: #fafafa;\n  border: 1px solid #fafafa !important;\n  border-bottom: 1px solid #dddddd !important;\n  cursor: default;\n  width: 100% !important;\n  display: block;\n  padding: 15px 15px;\n  text-align: center;\n  text-decoration: none !important;\n  font-size: 12px;\n  height: 50px;\n  cursor: pointer;\n  letter-spacing: 1px;\n  font-weight: 600;\n  box-sizing: border-box;\n}\n\n.tunnel__dropdown__tabs .lt-nav-tabs > li div.active {\n  border: 1px solid #dddddd !important;\n  border-bottom: 2px solid #3f3f3f !important;\n  background: #ffffff;\n  cursor: default;\n  border-radius: 4px;\n  pointer-events: none;\n}\n\n.tunnel__dropdown__tabs .lt-tab-content {\n  position: relative;\n  z-index: 1;\n  background-color: #ffffff;\n}\n\n.lt-tab-pane {\n  display: none;\n}\n\n.lt-tab-pane.open {\n  display: block;\n}\n\n.tunnel__dropdown__tabs .lt-tab-pane .part__1 {\n  padding: 25px 15px;\n}\n\n.access_key_group {\n  border-radius: 2px;\n  background-color: #101010;\n  padding: 14px 20px;\n  display: flex;\n  word-break: break-word;\n  font-size: 12px;\n  align-items: center;\n  color: #fff;\n  line-height: 20px;\n}\n\n.access__key_code span {\n  word-break: break-all;\n}\n\n.access__key__btn {\n  background-color: #c24e00;\n  border-radius: 6px;\n  border: none;\n  box-shadow: 0px 1px 0px 0px rgba(31, 31, 31, 0.04);\n  color: #fff;\n  font-size: 12px;\n  height: 32px;\n  margin-left: 20px;\n  min-width: 62px;\n  width: 140px;\n}\n\n.access__key__btn:focus-visible {\n  outline-color: #101010;\n}\n\n.access__key__type_radio {\n  padding: 20px 15px;\n  padding-bottom: 0px;\n}\n\n.access__key__type_radio .form-check-inline {\n  font-size: 13px;\n  margin-right: 30px;\n  display: inline-block;\n  font-weight: 400 !important;\n}\n\n.access__key__type_radio .form-check-label {\n  font-weight: 400 !important;\n  display: flex;\n  align-items: center;\n}\n\n.access__key__type_radio .form-check-inline .ltch-form-check-input {\n  position: relative;\n  top: 0;\n  margin: 0;\n  margin-right: 7px;\n  vertical-align: middle;\n}\n\n.access__key__type_radio .form-check-inline .ltch-form-check-input:after {\n  width: 15px;\n  height: 15px;\n  border-radius: 15px;\n  top: -1px;\n  left: 0px;\n  position: relative;\n  background-color: #ffffff;\n  content: "";\n  display: inline-block;\n  visibility: visible;\n  border: 2px solid #888;\n  box-sizing: border-box;\n}\n\n.access__key__type_radio\n  .form-check-inline\n  .ltch-form-check-input:focus-visible {\n  outline-color: #888;\n}\n\n.access__key__type_radio\n  .form-check-inline\n  .ltch-form-check-input:checked:after {\n  width: 15px;\n  height: 15px;\n  border-radius: 15px;\n  top: -1px;\n  left: 0px;\n  position: relative;\n  background-color: #ffffff;\n  content: "";\n  display: inline-block;\n  visibility: visible;\n  border: 4px solid #000000;\n}\n\n.tunnel__dropdown__tabs .lt-tab-pane .part__2 {\n  background: #fafafa;\n  padding: 20px;\n  border-radius: 0 0 6px 6px;\n  border-top: 1px solid #eaeaea;\n}\n\n.tunnel__dropdown__tabs .lt-tab-pane .part__2 .more__info h3 {\n  font-size: 12px;\n  font-weight: 500;\n  color: #4a4a4a;\n  margin-top: 5px;\n}\n\n.tunnel__dropdown__tabs .lt-tab-pane .part__2 .more__info ul {\n  margin: 0;\n  padding-left: 35px;\n}\n\n.tunnel__dropdown__tabs .lt-tab-pane .part__2 .more__info ul li {\n  font-size: 12px;\n  color: #666;\n  display: list-item;\n  list-style-type: disc;\n  line-height: 1.67;\n}\n\n.tunnel__dropdown__tabs .lt-tab-pane .part__2 .more__info ul li a {\n  color: #000000;\n  font-size: inherit;\n  font-weight: 500;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.app__download__link h3 {\n  margin: 0;\n  font-size: 14px;\n  color: #4a4a4a;\n  font-weight: 400;\n  line-height: 1.43;\n  margin-bottom: 17px !important;\n}\n\n.app__download__link .app__link__btn {\n  border-radius: 4px;\n  background-color: #101010;\n  padding: 12px 15px;\n  display: inline-flex;\n  color: #fff !important;\n  text-decoration: none !important;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  align-items: center;\n}\n\n.app__download__link .app__link__btn svg {\n  margin-left: 10px;\n}\n\n.app__download__link .app__link__btn--outline {\n  color: #101010 !important;\n  border: 1px solid #979797;\n  background: #ffffff;\n}\n\n.app__link__btn:focus,\n#downloadBinaryLink:focus,\n.ltch-configure-tunnel-more-details:focus {\n  outline: 1px solid;\n}\n\n.lt-dropdown-toggle {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n}\n\n.announcekit__widget {\n  cursor: pointer;\n}\n\n.user_initial {\n  align-items: center;\n  background-color: #eaecf3;\n  border-radius: 50%;\n  color: #101010;\n  display: inline-flex;\n  font-size: 12px;\n  height: 28px;\n  justify-content: center;\n  width: 28px;\n}\n\n#profile__dropdown:focus-visible {\n  outline: 2px solid #000;\n  padding: 0 2px;\n}\n\n.profile__dropdown .lt-dropdown-toggle {\n  padding: 0;\n}\n\n.profile__menu__item:focus-visible {\n  outline: 2px solid #000;\n}\n\n.profile__dropdown .lt-dropdown-menu,\n.ltch-icon-btn ~ .lt-dropdown-menu {\n  border: 0;\n  border: 1px solid #eaeaea;\n  border-radius: 6px;\n  box-shadow: 0 9px 16px 0 rgb(0 0 0 / 15%);\n  clear: both;\n  right: 0px;\n  top: 42px;\n  width: 260px;\n}\n\n.profile__menu__item,\n.ltch-icon-btn ~ .lt-dropdown-menu ul li {\n  border-radius: 6px;\n  color: #333;\n  cursor: pointer;\n  display: block;\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: -0.15px;\n  line-height: 20px;\n  padding: 10px 15px;\n  text-decoration: none;\n}\n\n.ltch-icon-btn ~ .lt-dropdown-menu ul li:focus-visible {\n  outline: 2px solid #101010;\n}\n\n.ltch-more-options-btn.ltch_high_contrast_item {\n  border: 1px solid #888;\n}\n\n.profile__menu__item:hover {\n  color: #343c3f;\n}\n\n.profile__menu__item.ltch_high_contrast_item:hover {\n  color: #343c3f;\n  outline: 1px solid #888;\n}\n\n.profile__dropdown .lt-dropdown-menu .profile__menu__item:last-child {\n  border-bottom: 0 solid #000;\n}\n\n.profile__dropdown__label__initial {\n  display: flex;\n}\n\n.profile__dropdown__label__initial .user_initial {\n  height: 40px;\n  margin-right: 16px;\n  width: 40px;\n}\n\n.img_with_text_center {\n  display: flex;\n  align-items: center;\n}\n\n.img_with_text_center img,\n.img_with_text_center svg {\n  margin-right: 10px;\n}\n\n.profile__dropdown__label__initial .user_profile_name {\n  color: #333;\n  line-height: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: initial;\n  max-width: 75%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-transform: initial;\n  white-space: nowrap;\n}\n\n.profile__dropdown__label__initial .user_profile_name small {\n  color: #666;\n  display: block;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-transform: initial;\n  white-space: nowrap;\n}\n\n.profile__dropdown__label {\n  pointer-events: none !important;\n  padding: 12px 8px 12px 14px;\n  border-bottom: 1px solid #ddd;\n}\n\n.ltch-profile-bubble-container {\n  align-items: center;\n  display: flex;\n  gap: 2px;\n}\n\n.ltch-profile-bubble-container .ltch-profile-bubble-arrow {\n  display: inline-flex;\n}\n\n.header__aside__menu {\n  background: #161a22;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: space-between;\n  max-width: 220px;\n  position: relative;\n  transition: width 180ms cubic-bezier(0.4, 0, 1, 1) 0.01s;\n  width: 220px;\n}\n\n.ltch-sidebar-overlay .header__aside__menu {\n  height: calc(100% - 48px);\n}\n\n.ltch-aside__menu__item {\n  background-color: #161a22;\n  border-radius: 6px;\n  display: block;\n  position: relative;\n}\n\n.aside__menu__item__product__title {\n  max-height: 40px;\n  transition: opacity 180ms cubic-bezier(0.4, 0, 1, 1) 0.01s,\n    max-height 180ms cubic-bezier(0.4, 0, 1, 1) 0.01s !important;\n  opacity: 1;\n}\n\n.aside__menu__item__product__title .aside__menu__link .aside__menu__icon {\n  height: 10px;\n  left: 16px;\n  top: 16px;\n  width: 7px;\n}\n\n.aside__menu__link.aside__menu__link__anchor {\n  display: flex;\n  padding-left: 42px;\n  height: 40px;\n  align-items: center;\n  color: #fff !important;\n  text-decoration: none !important;\n  font-size: 14px;\n  font-weight: 510;\n  padding-right: 15px;\n  justify-content: space-between;\n}\n\n.aside__menu__link .aside__menu__icon {\n  align-items: center;\n  display: inline-flex;\n  height: 18px;\n  justify-content: center;\n  left: 12px;\n  pointer-events: none;\n  position: absolute;\n  top: 12px;\n  width: 18px;\n}\n\n.ltch-aside__menu__item.aside__menu__secondary__item\n  .aside__menu__link.aside__menu__link__anchor {\n  padding-left: 42px;\n  position: relative;\n}\n\n.ltch-aside__menu__item.active,\n.ltch-aside__menu__item.active__menu {\n  background-color: #292f36;\n  color: #ffffff !important;\n}\n\n.ltch-aside__menu__item.active.ltch_high_contrast_item,\n.ltch-aside__menu__item.active__menu {\n  background-color: #657386;\n  color: #ffffff !important;\n}\n\n.ltch-aside__menu__item.active .aside__menu__link__anchor {\n  color: #fff !important;\n}\n\n.ltch-aside__menu__item:hover,\n.ltch-aside__menu__item:focus-visible {\n  background-color: rgba(41, 47, 54, 0.5);\n}\n\n.ltch-aside__menu__item.ltch_high_contrast_item:hover,\n.ltch-aside__menu__item.ltch_high_contrast_item:focus-visible {\n  background-color: #2d3138;\n  outline: 1px solid #fff;\n  outline-offset: -1px;\n}\n\n.ltch-aside__menu__item:focus-visible,\n.aside__menu__item__bottom:focus-visible,\n.aside__menu__bottom__submenu__item:focus-visible {\n  outline: none;\n}\n\n.aside__menu__item.active .aside__menu__icon svg rect {\n  stroke: #fff;\n}\n\n.aside__menu__item.active .aside__menu__icon svg path {\n  stroke: #fff;\n}\n\n.aside__menu__item__hyperexecute.active .aside__menu__icon svg path {\n  fill: #fff;\n  stroke: none;\n}\n\n.aside__menu__item.active .aside__menu__link .arrow__icon svg path {\n  fill: #fff;\n}\n\n.aside__menu__item.active .aside__menu__icon svg line {\n  stroke: #fff;\n}\n\n.aside__menu__items__level1\n  .aside__menu__item__product__title:hover\n  .aside__menu__icon\n  svg\n  path {\n  stroke: #fff;\n}\n\n.aside__menu__items__level1\n  .aside__menu__item__product__title:hover\n  .ltch-product-nav-title {\n  color: #fff;\n}\n\n.aside__menu__items__level1 .aside__menu__item.active .aside__menu__link,\n.aside__menu__items__level1 .aside__menu__item.active__menu .aside__menu__link,\n.aside__menu__items__level1 .aside__menu__item:hover .aside__menu__link {\n  cursor: pointer;\n}\n\n.aside__menu__items__level1 .aside__menu__item__product__title:hover {\n  background-color: transparent;\n}\n\n.aside__menu__secondary__item .aside__menu__link__anchor:focus-visible,\n.ltch-product-name-back-container:focus-visible,\n.ltch-aside__menu__item .aside__menu__link__anchor:focus-visible,\n.aside__menu__bottom__submenu__item:focus-visible {\n  background-color: rgba(41, 47, 54, 0.5);\n  border-radius: 6px;\n  outline: none;\n}\n\n.ltch-top-upgrade-btn:focus-visible {\n  border-radius: 4px;\n  outline: rgb(16, 16, 16) solid 2px !important;\n  outline-offset: 2px;\n}\n\n.ltch-bottom-upgrade-btn:focus-visible {\n  outline: #fff solid 2px !important;\n}\n\n.Left_Nav.collapsed .aside__menu__item__product__title {\n  max-height: 0;\n  opacity: 0;\n}\n\n.ltch_flex {\n  display: flex;\n}\n\n.ltch_items_center {\n  align-items: center;\n}\n\n.ltch_space_between {\n  justify-content: space-between;\n}\n\n.ltch_access_control {\n  cursor: pointer;\n}\n\n.ltch-copy-text {\n  font-size: 10px;\n  padding: 10px;\n}\n\n.aside__menu__item__bottom-upgrade .aside__menu__item__bottom__icon svg,\n.img_with_text_center span svg {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.aside__menu__item__main__menu {\n  cursor: pointer;\n}\n\n.aside__menu__item__bottom-upgrade .aside__menu__item__bottom__icon {\n  display: inherit;\n  margin-right: 6px;\n  vertical-align: middle;\n}\n\n.aside__menu__item__bottom__link {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none !important;\n  color: #ffffff;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.Left_Nav.collapsed\n  .aside__menu__item__bottom-upgrade\n  .aside__menu__item__bottom__link {\n  border-bottom: none;\n}\n\n.aside__menu__item__bottom__icon {\n  width: 16px;\n}\n\n.aside__menu__item__bottom-upgrade .aside__menu__item__bottom__link {\n  background-color: #c24e00;\n  border-radius: 0;\n  font-weight: 510;\n}\n\n.aside__menu__item__bottom-upgrade.aside__menu__item__bottom-upgrade-paid:not(\n    .ltch-top-upgrade-btn\n  )\n  .aside__menu__item__bottom__link {\n  border-top: 1px solid #2e2f30;\n  background-color: #161a22;\n  color: rgba(239, 108, 0, 1);\n  font-weight: 510;\n}\n\n.aside__menu__item__bottom-upgrade .aside__menu__item__bottom__icon {\n  margin-right: 6px;\n}\n\n.aside__menu__item__bottom-upgrade .aside__menu__item__bottom__icon svg {\n  width: 17px;\n}\n\n.aside__menu__items-useful {\n  display: flex;\n  justify-content: space-between;\n}\n\n.aside__menu__items-useful > .aside__menu__item__bottom {\n  flex-grow: 1;\n  padding: 8px;\n}\n\n.aside__menu__bottom__submenu__item {\n  background-color: #23282f;\n  box-shadow: 0px 1px 3px 0px rgba(27, 31, 36, 0.12),\n    0px 8px 24px 0px rgba(66, 74, 83, 0.12);\n  height: 40px;\n  display: flex;\n  align-items: center;\n  text-decoration: none !important;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 510;\n  padding-left: 14px;\n}\n\n.aside__menu__bottom__submenu:after,\n.aside__menu__bottom__submenu:before {\n  content: "";\n  border-top: 8px solid #23282f;\n  border-right: 8px solid transparent;\n  border-left: 8px solid transparent;\n  position: absolute;\n  left: 29px;\n}\n\n.aside__menu__bottom__submenu:before {\n  border-color: transparent;\n  border-width: 8px;\n  border-bottom-width: 0;\n  bottom: -9px;\n}\n\n.header__aside__menu.collapsed .aside__menu__bottom__submenu:before {\n  content: " ";\n  height: 100%;\n  left: -10%;\n  position: absolute;\n  width: 110%;\n  z-index: -1;\n}\n\n.header__aside__menu.collapsed .ltch-left-nav-menu-title {\n  height: 0;\n  opacity: 0;\n  padding: 0;\n  margin: 0;\n}\n\n.ltch-access-key-wrapper .aside__menu__bottom__submenu:after {\n  left: 102px;\n}\n\n.ltch-quick-actions-wrapper .aside__menu__bottom__submenu:after {\n  left: 177px;\n}\n\n.ltch-aside-menu-bottom-submenu-item-wrapper {\n  background: #23282f;\n  border-radius: 0 0 6px 6px;\n  padding: 0 8px 8px 8px;\n}\n\n.aside__menu__bottom__submenu__item:hover,\n.aside__menu__bottom__submenu__item:focus-visible {\n  background-color: #161a22;\n  border-radius: 6px;\n  color: #fff;\n  cursor: pointer;\n}\n\n.aside__menu__bottom__submenu__item.ltch_high_contrast_item:hover,\n.aside__menu__bottom__submenu__item.ltch_high_contrast_item:focus-visible {\n  background-color: #657386;\n  border-radius: 6px;\n  color: #fff;\n  cursor: pointer;\n}\n\n.aside__menu__bottom__submenu__item-title:hover,\n.aside__menu__bottom__submenu__item-title:focus-visible {\n  background-color: #23282f;\n  border-radius: 6px 6px 0 0;\n  color: #999;\n}\n\n.aside__menu__bottom__submenu__item__icon {\n  display: block;\n  height: 16px;\n  margin-right: 15px;\n  width: 16px;\n}\n\n.aside__menu__item__bottom__link .aside__menu__bottom__submenu__item__icon {\n  height: 16px;\n  margin-right: 0;\n}\n\n.aside__menu__bottom__submenu__item-title {\n  border-radius: 6px 6px 0px 0px;\n  color: #999;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  padding-left: 16px;\n}\n\n.aside__menu__bottom__submenu__item-link {\n  color: #fff;\n  font-weight: 510;\n  justify-content: space-between;\n}\n\n.aside__menu__bottom__submenu__item-link\n  .aside__menu__bottom__submenu__item__icon {\n  width: 18px;\n  display: inline-block;\n  margin-top: 2px;\n  margin-left: 2px;\n}\n\n.aside__menu__items-useful {\n  position: relative;\n}\n\n.aside__menu__bottom__submenu {\n  border-radius: 6px;\n  bottom: 100%;\n  box-shadow: 1px 3px 0px rgba(27, 31, 36, 0.12),\n    0px 8px 24px 0px rgba(66, 74, 83, 0.12);\n  left: 0;\n  margin-bottom: 3px;\n  padding: 0 8px;\n  pointer-events: all;\n  position: absolute;\n  transition: opacity 180ms cubic-bezier(0.4, 0, 1, 1) 0.01s;\n  width: 100%;\n}\n\n.aside__menu__item__bottom:hover .aside__menu__item__bottom__link,\n.aside__menu__item__bottom:focus-within .aside__menu__item__bottom__link {\n  background: rgba(41, 47, 54, 0.5);\n  border-radius: 6px;\n}\n\n.aside__menu__item__bottom.ltch_high_contrast_item:hover\n  .aside__menu__item__bottom__link,\n.aside__menu__item__bottom.ltch_high_contrast_item:focus-within\n  .aside__menu__item__bottom__link {\n  background: #657386;\n  border-radius: 6px;\n}\n\n.aside__menu__item__bottom-upgrade:hover .aside__menu__item__bottom__link,\n.aside__menu__item__bottom-upgrade:focus-visible\n  .aside__menu__item__bottom__link {\n  background-color: #d96200;\n  border-radius: 0;\n}\n\n.aside__menu__item__bottom-upgrade.aside__menu__item__bottom-upgrade-paid:hover\n  .aside__menu__item__bottom__link {\n  background-color: #c95100;\n  color: #fff;\n}\n\n.aside__menu__item__bottom-upgrade.aside__menu__item__bottom-upgrade-paid.ltch-top-upgrade-btn\n  path,\n.aside__menu__item__bottom-upgrade.aside__menu__item__bottom-upgrade-paid.ltch-top-upgrade-btn\n  circle {\n  stroke: #fff;\n}\n\n.aside__menu__item__bottom-upgrade.aside__menu__item__bottom-upgrade-paid:hover\n  path,\n.aside__menu__item__bottom-upgrade.aside__menu__item__bottom-upgrade-paid:hover\n  circle {\n  stroke: #fff;\n}\n\n.header__aside__menu.collapsed .aside__menu__item__bottom {\n  position: relative;\n}\n\n.header__aside__menu.collapsed .aside__menu__bottom__submenu {\n  left: 100%;\n  bottom: 8px;\n  width: 216px;\n  border-radius: 6px;\n  box-shadow: none;\n  margin: 0;\n}\n\n.header__aside__menu.collapsed .aside__menu__bottom__submenu:after {\n  border: none;\n}\n\n.ltch-test-concurrency-container {\n  display: flex;\n  gap: 8px;\n  margin: 0 3px 0 0;\n}\n\n.ltch-test-concurrency-container-col {\n  flex-direction: column;\n  padding: 6px 16px;\n  margin: 0;\n}\n\n.ltch-test-concurrency-container:empty {\n  margin-left: 2px;\n  margin-right: 0;\n}\n\n.ltch-test-concurrency {\n  align-items: center;\n  background: #fff;\n  border-radius: 6px;\n  border: 1px solid rgba(27, 31, 36, 0.15);\n  box-shadow: 0px 1px 0px 0px rgba(27, 31, 35, 0.04);\n  display: flex;\n  gap: 4px;\n  padding: 5px 8px;\n}\n\n.ltch-test-concurrency.ltch_high_contrast_item {\n  border: 1px solid #888;\n}\n\n.ltch-test-concurrency-col.ltch_high_contrast_item {\n  border: none;\n}\n\n.ltch-test-concurrency-col {\n  border: none;\n  box-shadow: none;\n  padding: 0;\n}\n\n.ltch-more-options-item.ltch_high_contrast_item:hover {\n  outline: 1px solid #888;\n}\n\n.ltch-more-options-item-read-only {\n  pointer-events: none;\n}\n\n.ltch-count-running {\n  color: #333;\n  font-size: 12px;\n  font-weight: 600;\n  padding-left: 5px;\n}\n\n.ltch-test-concurrency-header {\n  color: #333;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 18px;\n}\n\n.ltch-test-concurrency-paragraph {\n  align-items: center;\n  display: flex;\n  line-height: 20px;\n  margin: 0;\n}\n\n.ltch-test-concurrency-paragraph-col {\n  flex: 1;\n  justify-content: space-between;\n}\n\n.ltch-concurrency-low-res-separator {\n  border-bottom: 1px solid #ddd;\n  margin-bottom: 8px;\n}\n\n.ltch-section-separator {\n  border-left: 1px solid #ddd;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.progress0 {\n  background: #f4f6f8;\n  width: 100%;\n}\n\n.ltch-test-concurrency-value-wrapper {\n  background: #f4f6f8;\n  border-radius: 50%;\n  height: 16px;\n  width: 16px;\n}\n\n.baseProgressClass {\n  min-width: 4px;\n  display: block;\n  height: 3px;\n}\n\n.queuedProgress {\n  background: #ffaf90;\n}\n\n.runningProgress {\n  background: #20d980;\n}\n\n.progress1 {\n  width: 20%;\n}\n\n.progress2 {\n  width: 40%;\n}\n\n.progress3 {\n  width: 60%;\n}\n\n.progress4 {\n  width: 80%;\n}\n\n.progress5 {\n  width: 100%;\n}\n\n.ltch-promo-banner-container {\n  align-items: center;\n  background-color: rgba(239, 108, 0, 0.15);\n  color: white;\n  display: flex;\n  font-size: 14px;\n  height: 100%;\n  justify-content: space-between;\n}\n\n#top_promo {\n  height: 42px;\n}\n\n.ltch-wallet-promo {\n  align-items: center;\n  gap: 5px;\n  justify-content: center;\n}\n\n#promoEntireDivTop {\n  color: #101010;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 18px;\n}\n\n.ltch-promo-duration {\n  color: #101010;\n  margin-left: 3px;\n}\n\n#close_top_promo {\n  margin-right: 50px;\n  cursor: pointer;\n  font-size: 16px;\n  color: #101010;\n}\n\n.ltch-promo-discount {\n  color: #101010;\n  cursor: pointer;\n  margin-left: 7px;\n  font-weight: 600;\n}\n\n.ltch-promo-wrapper {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.ltch-wallet-promo-icon {\n  height: 28px;\n  padding-bottom: 2px;\n  width: 28px;\n}\n\n#ltch-demo-form-wrapper {\n  align-items: center;\n  backdrop-filter: blur(2px);\n  background: rgba(0, 0, 0, 0.8);\n  bottom: 0;\n  display: flex;\n  height: 100%;\n  left: 0;\n  opacity: 1;\n  position: fixed;\n  right: 0;\n  top: 0;\n  transition: opacity 500ms;\n  width: 100%;\n  z-index: 1001;\n}\n\n.ltch-flex-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.ltch-flex {\n  display: flex;\n}\n\n.ltch-demo-form-header {\n  align-items: center;\n  border-bottom: 1px solid #ddd;\n  border-radius: 6px 6px 0px 0px;\n  display: flex;\n  font-size: 14px;\n  font-weight: 600;\n  height: 48px;\n  justify-content: space-between;\n  letter-spacing: -0.15px;\n  line-height: 20px;\n  padding: 10px 10px 10px 16px;\n  position: relative;\n}\n\n.ltch-demo-form-close {\n  cursor: pointer;\n  font-size: 20px;\n  font-weight: 400;\n}\n\n.ltch-demo-form-close:focus-visible {\n  outline: 2px solid #101010;\n}\n\n.ltch-demo-form-asteriek {\n  color: #eb5757;\n  font-size: 14px;\n}\n\n.ltch-demo-form-container {\n  background-color: #ffffff;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),\n    0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  border-radius: 6px;\n  margin: auto;\n  padding-bottom: 48px;\n  width: 33%;\n  padding: 0;\n  color: #333333;\n}\n\n.ltch-demo-form-submit,\n.ltch-book-a-demo-btn {\n  align-items: center;\n  background-color: rgb(16, 16, 16);\n  border-image: initial;\n  border-radius: 6px;\n  border: 1px solid rgba(31, 35, 40, 0.15);\n  box-shadow: rgba(31, 35, 40, 0.1) 0px 1px 0px;\n  color: #fff;\n  cursor: pointer;\n  cursor: pointer;\n  display: flex;\n  font-size: 14px;\n  font-weight: 600;\n  gap: 4px;\n  height: 32px;\n  line-height: 20px;\n  justify-content: center;\n  min-width: max-content;\n  padding: 0px 8px;\n  text-align: center;\n  text-decoration: none;\n  text-transform: capitalize;\n  width: 100%;\n}\n\n.ltch-demo-form-submit:focus-visible,\n.ltch-book-a-demo-btn:focus-visible {\n  box-shadow: 0px 0px 0px 3px inset;\n  outline: #101010 solid 2px !important;\n  outline-offset: -2px;\n}\n\n.ltch-book-a-demo-btn {\n  align-items: center;\n  border-radius: 26px;\n  bottom: 24px;\n  box-shadow: 0px 48px 96px -24px rgba(66, 74, 83, 0.08),\n    0px 24px 48px -12px rgba(66, 74, 83, 0.08),\n    0px 4px 32px -4px rgba(66, 74, 83, 0.08),\n    0px 8px 16px -4px rgba(66, 74, 83, 0.08);\n  display: flex;\n  gap: 4px;\n  height: 40px;\n  padding: 10px 12px;\n  position: absolute;\n  right: 24px;\n  width: max-content;\n}\n\n.ltch-book-a-demo-btn span {\n  align-self: baseline;\n  display: flex;\n}\n\n.ltch-demo-form-field-container {\n  margin-bottom: 16px;\n}\n\n.ltch-demo-form-fields-wrapper {\n  padding: 16px 16px 0 16px;\n}\n\n.ltch-demo-form-name-fields {\n  justify-content: space-between;\n}\n\n.ltch-demo-form-name-fields .ltch-demo-form-field-container {\n  width: 50%;\n}\n\n.ltch-demo-form-name-fields .ltch-demo-form-field-container:first-child {\n  margin-right: 20px;\n}\n\n.ltch-demo-form-field-container label {\n  color: #333;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  letter-spacing: -0.15px;\n  line-height: 20px;\n  margin-bottom: 4px;\n}\n\n.ltch-demo-form-field-container input {\n  align-items: stretch;\n  background-color: rgb(247, 247, 247);\n  box-shadow: rgba(208, 215, 222, 0.2) 0px 1px 0px inset;\n  color: rgb(51, 51, 51);\n  display: inline-flex;\n  font-size: 12px;\n  height: 32px;\n  line-height: 20px;\n  outline: none;\n  padding: 6px 12px;\n  vertical-align: middle;\n}\n\n.ltch-demo-form-field-container input,\n.ltch-demo-form-field-container textarea {\n  border: 1px solid #d4d4d4;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 400;\n  padding-left: 8px;\n  outline: none;\n  letter-spacing: -0.15px;\n}\n\n.ltch-demo-form-field-container input[aria-invalid="true"],\n.ltch-demo-form-field-container textarea[aria-invalid="true"] {\n  border: 1px solid rgb(207, 34, 46);\n}\n\n.ltch-demo-form-field-container input:focus-visible,\n.ltch-demo-form-field-container textarea:focus-visible {\n  outline: 2px solid #101010;\n  border-color: transparent;\n}\n\n.ltch-demo-form-field-container textarea {\n  align-items: stretch;\n  background: rgb(247, 247, 247);\n  box-shadow: rgba(208, 215, 222, 0.2) 0px 1px 0px inset;\n  color: rgb(51, 51, 51);\n  display: inline-flex;\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto,\n    "Helvetica Neue", Arial, sans-serif;\n  font-size: 14px;\n  height: 88px;\n  line-height: 20px;\n  min-height: 32px;\n  outline: none;\n  padding: 12px;\n  resize: none;\n  vertical-align: middle;\n}\n\n.ltch-demo-form-submit-btn-container {\n  border-top: 1px solid #ddd;\n  padding: 16px;\n}\n\n.ltch-demo-form-warning {\n  align-items: center;\n  background: #ffebe9;\n  border: 1px solid rgba(255, 129, 130, 0.4);\n  box-sizing: border-box;\n  display: flex;\n  font-size: 14px;\n  grid-gap: 16px;\n  gap: 16px;\n  line-height: 20px;\n  padding: 8px 16px;\n  width: 100%;\n}\n\n.ltch-toast-wrapper {\n  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;\n  align-items: center;\n  animation: fadein 0.5s, fadeout 0.5s 2.5s;\n  background-color: #f5fbf8;\n  border-radius: 8px;\n  border: 1px solid #5fc8af;\n  box-shadow: 0px 4px 8px rgba(49, 113, 89, 0.16);\n  color: #397869;\n  display: flex;\n  font-size: 14px;\n  font-weight: 500;\n  height: 44px;\n  line-height: 24px;\n  padding-right: 15px;\n  position: fixed;\n  right: 10px;\n  top: 12px;\n  visibility: visible;\n  z-index: 9999;\n}\n\n.ltch-toast-wrapper_error {\n  background-color: #ffebe9;\n  border: 1px solid rgba(255, 129, 130, 0.64);\n  color: #24292f;\n}\n\n.ltch-toast-icon {\n  align-items: center;\n  display: flex;\n  margin-left: 16px;\n  margin-right: 16px;\n}\n\n.ltch-toast-close-icon {\n  color: #317159;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  margin-left: 20px;\n}\n\n.ltch-product-name-container,\n.ltch-upgrade-btn-text,\n.ltch-toggle-right-label,\n.ltch-toggle-left-label {\n  flex-shrink: 0;\n}\n\n.ltch-tunnel-btn-download-container {\n  display: flex;\n  list-style: none;\n  gap: 10px;\n  justify-content: center;\n}\n\n.ltch-product-nav-title {\n  color: #80858f;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 590;\n  line-height: normal;\n}\n\n/* Tooltip */\n.ltch-tooltip {\n  position: relative;\n  display: inline-block;\n}\n\n.ltch-hidden {\n  display: none;\n}\n\n.ltch-beta-tag {\n  background-color: #bfbfbf;\n  border-radius: 4px;\n  color: #101010;\n  font-size: 10px;\n  margin-left: 6px;\n  padding: 4px 6px;\n  text-transform: uppercase;\n}\n\n.ltch-aside__menu__item:hover .ltch-beta-tag {\n  background-color: #bfbfbf;\n  border: none;\n  color: #101010;\n}\n\n.ltch-product-name {\n  align-items: center;\n  display: flex;\n}\n\n.assumed_identity {\n  color: #000;\n  font-size: 14px;\n  font-weight: 600;\n  padding-top: 15px;\n  padding-left: 15px;\n}\n\n#tunnel__dropdown__toggle__configure:focus,\n.ltch-icon-btn:focus,\n.ltch-button:focus,\n.announcekit-widget:focus-visible,\n.ltch-tunnel-btn:focus-visible {\n  border: 2px solid #101010;\n}\n\n#tunnel__dropdown__toggle__configure2:focus-visible,\n.view__all__tunnels:focus-visible {\n  outline: 2px solid #101010 !important;\n  outline-offset: 1px;\n}\n\n.announcekit-widget:focus-visible {\n  outline: none;\n}\n\n.tunnel__dropdown__tabs .lt-nav-tabs > li:focus-visible {\n  outline: 1px auto #101010 !important;\n}\n\n.ltch-promo-upgrade-button {\n  background-color: #c24e00;\n  border-radius: 5px;\n  border: transparent;\n  color: white;\n  cursor: pointer;\n  font-size: 14px;\n  height: 32px;\n  margin-left: 8px;\n  width: 122px;\n}\n\n.ltch-top-upgrade-btn {\n  margin-left: 4px;\n}\n\n.ltch-top-upgrade-btn .aside__menu__item__bottom__link {\n  border-radius: 6px !important;\n  border: 1px solid rgba(27, 31, 36, 0.15);\n  box-shadow: 0 1px 0px 0px rgba(27, 31, 35, 0.04);\n  box-sizing: border-box;\n  display: flex;\n  font-size: 12px;\n  height: 28px;\n  line-height: 20px;\n  padding: 6px 12px;\n}\n\n.ltch-top-upgrade-btn:hover .aside__menu__item__bottom__link,\n.ltch-top-upgrade-btn:focus-within .aside__menu__item__bottom__link {\n  background-color: #c95100;\n}\n\n.ltch-top-upgrade-btn .aside__menu__item__bottom__link:active {\n  border: 1px solid rgba(27, 31, 36, 0.15);\n  background: #c95100;\n  box-shadow: 0px 1px 0px 0px rgba(27, 31, 35, 0.04),\n    0px 2px 0px 0px rgba(0, 0, 0, 0.25) inset;\n}\n\n.ltch-promo-offer-separator {\n  padding: 0 5px;\n}\n\n.ltch-promo-offer-claim {\n  border-bottom: 1px solid;\n  font-weight: 600;\n}\n\n.ltch-promo-offer-celebration {\n  margin: 0 5px;\n}\n\n.share_feedback {\n  border: none;\n  width: 100%;\n}\n\n.aside__menu__items {\n  list-style: none;\n  margin-block-end: inherit;\n  margin-block-start: inherit;\n  padding: 0 8px;\n}\n\n.wrapper svg {\n  vertical-align: initial;\n}\n\n.collapsed .aside__menu__items-useful > .aside__menu__item__bottom {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.collapsed\n  .aside__menu__items-useful\n  > .aside__menu__item__bottom.ltch-quick-actions-wrapper {\n  padding-bottom: 8px;\n}\n\n.ltch-product-name-tooltip-overlay,\n.ltch-upgrade-btn-tooltip-overlay,\n.ltch-top-nav-buttons-tooltip-overlay {\n  align-items: center;\n  background-color: #161a22;\n  border-radius: 6px;\n  color: #fff;\n  display: flex;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  justify-content: center;\n  left: 60px;\n  line-height: 18px;\n  padding: 5.5px 8.25px;\n  position: absolute;\n  text-align: center;\n  visibility: hidden;\n  width: max-content;\n  z-index: 999;\n}\n\n.ltch-top-nav-buttons-tooltip-overlay {\n  border-radius: 3px;\n  background-color: #333;\n  left: -40px;\n  top: 40px;\n}\n\n.ltch-product-name-tooltip-overlay:before,\n.ltch-upgrade-btn-tooltip-overlay:before,\n.ltch-top-nav-buttons-tooltip-overlay:before {\n  content: "";\n  position: absolute;\n  top: 50%;\n  right: 100%;\n  margin-top: -4px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent #161a22 transparent transparent;\n}\n\n.ltch-top-nav-buttons-tooltip-overlay:before {\n  border-color: transparent transparent #333 transparent;\n  top: -5px;\n  left: 45%;\n}\n\n.header__aside__menu.collapsed\n  .aside__menu__item:hover\n  .ltch-product-name-tooltip-overlay,\n.header__aside__menu.collapsed\n  .aside__menu__item__bottom-upgrade:hover\n  .ltch-upgrade-btn-tooltip-overlay {\n  visibility: visible;\n}\n\n.tunnel__dropdown__toggle__configure:hover\n  ~ .ltch-top-nav-buttons-tooltip-overlay,\n.tunnel__dropdown__toggle__configure:focus-visible\n  ~ .ltch-top-nav-buttons-tooltip-overlay,\n.ltch-tunnel-btn:hover ~ .ltch-top-nav-buttons-tooltip-overlay,\n.ltch-tunnel-btn:focus-visible ~ .ltch-top-nav-buttons-tooltip-overlay {\n  visibility: visible;\n}\n\n.ltch-tunnel-btn:hover ~ .ltch-top-nav-buttons-tooltip-overlay,\n.ltch-tunnel-btn:focus-visible ~ .ltch-top-nav-buttons-tooltip-overlay {\n  left: -32px;\n}\n\n.header__aside__menu .aside__menu__item__bottom-upgrade .ltch-upgrade-btn-text {\n  transition: opacity 180ms cubic-bezier(0.4, 0, 1, 1) 0.01s;\n  opacity: 1;\n}\n\n.header__aside__menu.collapsed\n  .aside__menu__item__bottom-upgrade\n  .ltch-upgrade-btn-text {\n  opacity: 0;\n}\n\n.ltch-top-nav-profile-items-wrapper,\n.ltch-icon-btn ~ .lt-dropdown-menu ul {\n  list-style: none;\n  padding: 8px;\n  margin: 0;\n}\n\n.ltch-icon-btn ~ .lt-dropdown-menu ul {\n  padding: 8px 0;\n}\n\n.ltch-top-nav-profile-items-wrapper .profile__menu__item,\n.ltch-icon-btn ~ .lt-dropdown-menu ul li {\n  padding: 6px 8px;\n}\n\n.ltch-icon-btn ~ .lt-dropdown-menu ul li {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin: 0 8px;\n}\n\n.ltch-icon-btn ~ .lt-dropdown-menu ul li.ltch-concurrency-low-res-wrapper {\n  display: block;\n  padding: 0;\n  margin: 0;\n}\n\n.ltch-manage-credentials .aside__menu__bottom__submenu__item__icon {\n  margin-top: -5px;\n  width: 14px;\n}\n\n.ltch-top-nav-profile-items-wrapper .profile__menu__item:hover,\n.ltch-icon-btn ~ .lt-dropdown-menu ul li:hover {\n  background-color: #f7f5f5;\n  border-radius: 6px;\n}\n\n.ltch-icon-btn\n  ~ .lt-dropdown-menu\n  ul\n  li.ltch-concurrency-low-res-wrapper:hover {\n  background-color: transparent;\n}\n\n.ltch-responsive_parent {\n  align-items: center;\n  background: #ffebe9;\n  border: 1px rgba(255, 129, 130, 0.4) solid;\n  box-sizing: border-box;\n  display: none;\n  font-size: 14px;\n  height: 68px;\n  line-height: 20px;\n  padding-left: 16px;\n  width: 100%;\n}\n\n@media (max-width: 1279px) {\n  .ltch-responsive_parent {\n    gap: 10px;\n    display: flex;\n  }\n}\n\n@media (max-width: 600px) {\n  .ltch-responsive_parent {\n    display: flex;\n  }\n\n  .ltch-responsive_parent {\n    font-size: 10px;\n    height: 90px;\n  }\n}\n\n.ltch-responsive_title {\n  font-weight: 600;\n}\n\n.aside__menu__link:focus-visible,\n.aside__menu__bottom__submenu__item:focus-visible {\n  border: 1px solid #fff;\n}\n\n.aside__menu__item__bottom__link:focus-visible {\n  outline: 1px solid #fff;\n  outline-offset: -1px;\n  border-radius: 6px;\n}\n\n.ltch-tunnel-btn {\n  position: relative;\n  height: 28px;\n  line-height: 22px;\n  min-width: auto;\n  outline: none !important;\n  padding: 4px;\n  width: 28px;\n}\n\n.ltch-tunnel-count-container {\n  align-items: center;\n  background: #0969da;\n  border-radius: 10px;\n  border: 2px solid #f7f7f7;\n  display: flex;\n  height: 18px;\n  justify-content: center;\n  position: absolute;\n  right: -8px;\n  top: -10px;\n  width: 18px;\n}\n\n.ltch-tunnel-count {\n  color: #fff;\n  font-size: 6px;\n  font-weight: 600;\n  line-height: 9px;\n}\n\n.ltch-top-nav-custom-info-wrapper {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n}\n\n#launch__tunnel__app:focus {\n  box-shadow: inset 0 0 0 3px;\n  border: 1px solid #101010;\n}\n\n.ltch-tunnel-legend {\n  position: absolute;\n  left: -9999px;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n\n.ltch-tunnel-fieldset {\n  border: none;\n  margin: 0;\n  padding: 0;\n}\n\nul.aside__menu__items-useful {\n  list-style-type: none;\n  margin: 0px;\n  padding: 0px;\n}\n\nul.ltch-aside-menu-bottom-submenu-item-wrapper {\n  list-style-type: none;\n  margin: 0px;\n}\n\n.ltch-top-nav-hamburger-menu {\n  align-items: center;\n  align-self: center;\n  background: #f7f7f7;\n  border-radius: 6px;\n  border: 1px solid #d4d4d4;\n  box-shadow: 0px 1px 0px 0px rgba(31, 31, 31, 0.04);\n  color: white;\n  cursor: pointer;\n  display: none;\n  height: 32px;\n  justify-content: center;\n  left: 10px;\n  position: absolute;\n  width: 32px;\n}\n\n.ltch-top-nav-hamburger-menu-high-res {\n  border-color: rgb(136, 136, 136);\n}\n\n.ltch-sidebar-overlay .ltch-top-nav-hamburger-menu {\n  display: flex;\n}\n\n.ltch-top-nav-hamburger-menu:focus-visible {\n  outline: 2px solid #101010;\n  outline-offset: -2px;\n}\n\n.lambda__logo__wrapper__left__nav {\n  opacity: 1;\n}\n\n.Left_Nav:not(.ltch-left-nav-overlay) .lambda__logo__wrapper__left__nav {\n  display: none;\n}\n\n.Left_Nav:not(.ltch-left-nav-overlay)\n  .header__aside__menu.collapsed\n  .aside__menu__item\n  .ltch-product-name {\n  display: none;\n}\n\n.Left_Nav:not(.ltch-left-nav-overlay)\n  .collapsed\n  .aside__menu__link.aside__menu__link__anchor {\n  padding-left: 0;\n  padding-right: 0;\n  width: 100%;\n}\n\n.ltch-sidebar-overlay .lambda__logo__wrapper__left__nav {\n  display: flex;\n  position: relative;\n  height: 52px;\n  z-index: 2;\n}\n\n.ltch-top-upgrade-btn .ltch-upgrade-icon {\n  display: none;\n}\n\n.ltch-topnav-aside-menu {\n  display: flex;\n  align-items: center;\n}\n\n.ltch-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  /* Semi-transparent background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ltch-popup-content {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n  max-width: 80%;\n  max-height: 80%;\n  overflow: auto;\n}\n\n.ltch-more-options-wrapper {\n  display: none;\n}\n\n.ltch-tunnel-modal-wrapper {\n  position: inherit;\n}\n\n.ltch-left-nav-overlay {\n  -webkit-font-smoothing: auto;\n  background-color: #fff;\n  border: 0;\n  border-top-right-radius: 12px;\n  border-bottom-right-radius: 12px;\n  box-shadow: 0 1px 3px rgba(31, 35, 40, 0.12),\n    0 8px 24px rgba(66, 74, 83, 0.12);\n  display: flex;\n  flex-direction: column;\n  height: 100% !important;\n  margin: 0;\n  padding: 0;\n  opacity: 1 !important;\n  transition: 180ms cubic-bezier(0.4, 0, 1, 1) 0.01s;\n  overflow-y: auto;\n  position: absolute;\n  top: 0 !important;\n  width: 320px !important;\n  z-index: 9999999;\n  overflow-x: hidden;\n}\n\n.ltch-left-nav-overlay.collapsed {\n  width: 56px !important;\n  max-width: 320px;\n  box-shadow: 0px 3px 6px 0px #424a531f;\n  position: absolute !important;\n  border-bottom-right-radius: 0px;\n  border-top-right-radius: 0px;\n  z-index: 99;\n  overflow: hidden;\n}\n\n.ltch-left-nav-overlay nav {\n  flex: 1;\n}\n\n.ltch-left-nav-overlay:not(.collapsed)::after {\n  content: "";\n  position: fixed;\n  inset: 0px;\n  background: rgba(175, 184, 193, 0.2);\n  pointer-events: none;\n}\n\n.ltch-left-nav-logo-wrapper {\n  padding-left: 2px;\n  align-items: center;\n  display: flex;\n  gap: 8px;\n}\n\n.ltch-left-nav-overlay .lambda__logo__wrapper,\n.ltch-left-nav-overlay .header__aside__menu {\n  background-color: #fff;\n  max-width: 320px;\n  width: 320px;\n}\n\n.ltch-left-nav-overlay.collapsed .lambda__logo__wrapper,\n.ltch-left-nav-overlay.collapsed .header__aside__menu {\n  background-color: #fff;\n  width: 56px;\n  max-width: 320px;\n}\n\n.ltch-left-nav-overlay .lambda__logo__wrapper {\n  justify-content: space-between;\n  padding: 0 16px;\n}\n\n.ltch-left-nav-close {\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  padding: 8px;\n}\n\n.ltch-left-nav-close:hover {\n  background-color: #f3f4f6;\n}\n\n.ltch-left-nav-close.ltch_high_contrast_item:hover,\n.ltch-left-nav-close.ltch_high_contrast_item:focus-visible {\n  outline: 1px solid rgb(136, 136, 136);\n  outline-offset: -1px;\n}\n\n.ltch-left-nav-close:focus-visible {\n  outline: 2px solid #101010;\n}\n\n.ltch-left-nav-close span {\n  cursor: pointer;\n  display: flex;\n}\n\n.ltch-left-nav-overlay .header__aside__menu,\n.ltch-left-nav-overlay .ltch-aside__menu__item,\n.ltch-left-nav-overlay .Left_Nav,\n.ltch-left-nav-overlay .aside__menu__items,\n.ltch-left-nav-overlay ul.aside__menu__items-useful {\n  background-color: #fff;\n}\n\n.ltch-left-nav-overlay .aside__menu__link.aside__menu__link__anchor {\n  color: #333333 !important;\n}\n\n.ltch-left-nav-overlay .header__aside__menu:before {\n  background: #ddd;\n}\n\n.ltch-left-nav-overlay .aside__menu__item .aside__menu__icon svg rect {\n  stroke: #666;\n}\n\n.ltch-left-nav-overlay .aside__menu__item .aside__menu__icon svg path {\n  stroke: #666;\n}\n\n/* RealTime icon */\n.ltch-left-nav-overlay\n  .aside__menu__item.aside__menu__item__realtime\n  .aside__menu__icon\n  svg\n  path {\n  stroke: none;\n  fill: #666;\n}\n\n/* RealTime icon for Old Dashboard */\n.ltch-left-nav-overlay\n  .aside__menu__item.aside__menu__item__realtime.ltch-old-dashboard-item\n  .aside__menu__icon\n  svg\n  path {\n  stroke: #666;\n  fill: none;\n}\n/* RealTime icon for New Dashboard (W/O new sidebar) */\n.aside__menu__item.aside__menu__item__realtime.ltch-new-dashboard-item.active\n  .aside__menu__icon\n  svg\n  path {\n  stroke: none;\n  fill: #fff;\n}\n/* RealTime icon for New Dashboard (W new sidebar) */\n.ltch-left-nav-overlay\n  .aside__menu__item.aside__menu__item__realtime.ltch-new-dashboard-item.active\n  .aside__menu__icon\n  svg\n  path {\n  stroke: none;\n  fill: #333;\n}\n\n/* KaneAI icon */\n.ltch-left-nav-overlay\n  .aside__menu__item.aside__menu__item__kaneai\n  .aside__menu__icon\n  svg\n  path {\n  stroke: none;\n  fill: #666;\n}\n\n/* KaneAI active icon  (W/O new sidebar) */\n.aside__menu__item.aside__menu__item__kaneai.ltch-new-dashboard-item.active\n  .aside__menu__icon\n  svg\n  path {\n  stroke: none;\n  fill: #fff;\n}\n\n/* KaneAI active icon (W/ new sidebar) */\n.ltch-left-nav-overlay\n  .aside__menu__item.aside__menu__item__kaneai.ltch-new-dashboard-item.active\n  .aside__menu__icon\n  svg\n  path {\n  stroke: none;\n  fill: #333;\n}\n\n/* Accessibility Icon */\n.ltch-left-nav-overlay\n  .aside__menu__item.aside__menu__item__accessibility\n  .aside__menu__icon\n  svg\n  path:nth-child(2) {\n  fill: #666;\n  stroke: none;\n}\n\n.ltch-left-nav-overlay\n  .aside__menu__item__hyperexecute\n  .aside__menu__icon\n  svg\n  path {\n  fill: #666;\n  stroke: none;\n}\n\n.ltch-left-nav-overlay\n  .aside__menu__item\n  .aside__menu__link\n  .arrow__icon\n  svg\n  path {\n  fill: #666;\n}\n\n.ltch-left-nav-overlay .aside__menu__item .aside__menu__icon svg line {\n  stroke: #666;\n}\n\n.ltch-left-nav-overlay\n  .aside__menu__items__level1\n  .aside__menu__item__product__title:hover\n  .aside__menu__icon\n  svg\n  path {\n  stroke: #333;\n}\n\n.ltch-left-nav-overlay .aside__menu__item.active .aside__menu__icon svg rect {\n  stroke: #333;\n}\n\n.ltch-left-nav-overlay .aside__menu__item.active .aside__menu__icon svg path {\n  stroke: #333;\n}\n\n.ltch-left-nav-overlay\n  .aside__menu__item__hyperexecute.active\n  .aside__menu__icon\n  svg\n  path,\n.ltch-left-nav-overlay\n  .aside__menu__item__realtime.active\n  .aside__menu__icon\n  svg\n  path {\n  fill: #333;\n  stroke: none;\n}\n\n.ltch-left-nav-overlay\n  .aside__menu__item.active\n  .aside__menu__link\n  .arrow__icon\n  svg\n  path {\n  fill: #333;\n}\n\n.ltch-left-nav-overlay .aside__menu__item.active .aside__menu__icon svg line {\n  stroke: #333;\n}\n\n.ltch-left-nav-overlay .aside__menu__bottom__submenu__item__icon svg path {\n  stroke: #666;\n}\n\n/* TMS Icon */\n.ltch-left-nav-overlay\n  .aside__menu__item.aside__menu__item__testManager.ltch_high_contrast_item\n  .aside__menu__icon\n  svg\n  path:last-child {\n  fill: #666;\n}\n\n.ltch-left-nav-overlay\n  .aside__menu__item__bottom_help\n  .aside__menu__bottom__submenu__item__icon\n  svg\n  path:nth-child(2),\n.ltch-left-nav-overlay\n  .aside__menu__bottom__submenu__item__faq\n  .aside__menu__bottom__submenu__item__icon\n  svg\n  path:nth-child(2),\n.ltch-left-nav-overlay\n  .ltch-manage-credentials\n  .aside__menu__bottom__submenu__item__icon\n  svg\n  path:nth-child(2) {\n  stroke: none;\n  fill: #666;\n}\n\n.ltch-left-nav-overlay .ltch-copy-tick svg path {\n  stroke: none;\n}\n\n.ltch-left-nav-overlay .aside__menu__bottom__submenu:after,\n.ltch-left-nav-overlay .aside__menu__bottom__submenu:before {\n  left: 36px;\n}\n\n.ltch-left-nav-overlay\n  .ltch-quick-actions-wrapper\n  .aside__menu__bottom__submenu:after,\n.ltch-left-nav-overlay\n  .ltch-quick-actions-wrapper\n  .aside__menu__bottom__submenu:before {\n  left: 250px;\n}\n\n.ltch-left-nav-overlay\n  .ltch-access-key-wrapper\n  .aside__menu__bottom__submenu:after,\n.ltch-left-nav-overlay\n  .ltch-access-key-wrapper\n  .aside__menu__bottom__submenu:before {\n  left: 143px;\n}\n\n/* Hover / Active colors */\n.ltch-left-nav-overlay .ltch-aside__menu__item.active,\n.ltch-left-nav-overlay .ltch-aside__menu__item.active__menu {\n  background-color: #dddddd66;\n}\n\n.ltch-left-nav-overlay\n  .ltch-aside__menu__item.active\n  .ltch-left-nav-menu-title {\n  background-color: #fff !important;\n}\n\n.ltch-left-nav-overlay\n  .aside__menu__secondary__item\n  .aside__menu__link__anchor:focus-visible,\n.ltch-left-nav-overlay .ltch-product-name-back-container:focus-visible,\n.ltch-left-nav-overlay\n  .ltch-aside__menu__item\n  .aside__menu__link__anchor:focus-visible,\n.ltch-left-nav-overlay .aside__menu__bottom__submenu__item:focus-visible {\n  background-color: #dddddd33;\n  border: none;\n}\n\n.ltch-left-nav-overlay\n  .aside__menu__bottom__submenu__item.ltch_high_contrast_item:hover,\n.ltch-left-nav-overlay\n  .aside__menu__bottom__submenu__item.ltch_high_contrast_item:focus-visible {\n  color: #333;\n}\n\n.ltch-left-nav-overlay\n  .aside__menu__items__level1\n  .aside__menu__item__product__title\n  .ltch-product-nav-title {\n  color: #666;\n}\n\n.ltch-left-nav-overlay\n  .aside__menu__items__level1\n  .aside__menu__item__product__title:hover\n  .ltch-product-nav-title,\n.ltch-left-nav-overlay\n  .aside__menu__items__level1\n  .aside__menu__item__product__title:focus-visible\n  .ltch-product-nav-title {\n  color: #333;\n}\n\n.ltch-left-nav-overlay\n  .aside__menu__item__bottom-upgrade.aside__menu__item__bottom-upgrade-paid\n  .aside__menu__item__bottom__link {\n  border-top: 1px solid #2e2f30;\n  background-color: #c24e00;\n  color: #fff;\n}\n\n.ltch-left-nav-overlay\n  .aside__menu__item__bottom-upgrade.aside__menu__item__bottom-upgrade-paid\n  svg\n  path,\n.ltch-left-nav-overlay\n  .aside__menu__item__bottom-upgrade.aside__menu__item__bottom-upgrade-paid\n  svg\n  circle {\n  stroke: #fff;\n}\n.ltch-left-nav-overlay .ltch-aside__menu__item:hover,\n.ltch-left-nav-overlay .ltch-aside__menu__item:focus-visible,\n.ltch-left-nav-overlay\n  .aside__menu__item__bottom:hover\n  .aside__menu__item__bottom__link,\n.ltch-left-nav-overlay\n  .aside__menu__item__bottom:focus-within\n  .aside__menu__item__bottom__link {\n  background-color: #dddddd33;\n}\n\n.ltch-left-nav-overlay .ltch-aside__menu__item:hover .ltch-left-nav-menu-title {\n  background-color: #fff !important;\n}\n\n.ltch-left-nav-overlay\n  .ltch-aside__menu__item.ltch_high_contrast_item.active\n  .aside__menu__link__anchor {\n  border-radius: 6px;\n}\n\n.ltch-left-nav-overlay\n  .aside__menu__secondary__item.ltch_high_contrast_item\n  .aside__menu__link__anchor:focus-visible,\n.ltch-left-nav-overlay\n  .ltch-product-name-back-container.ltch_high_contrast_item:focus-visible,\n.ltch-left-nav-overlay\n  .ltch-aside__menu__item.ltch_high_contrast_item\n  .aside__menu__link__anchor:focus-visible,\n.ltch-left-nav-overlay\n  .ltch-aside__menu__item.ltch_high_contrast_item.active\n  .aside__menu__link__anchor,\n.ltch-left-nav-overlay\n  .aside__menu__bottom__submenu__item.ltch_high_contrast_item:focus-visible,\n.ltch-left-nav-overlay\n  .aside__menu__bottom__submenu__item.ltch_high_contrast_item:hover,\n.ltch-left-nav-overlay\n  .aside__menu__bottom__submenu__item.ltch_high_contrast_item:focus-visible,\n.ltch-left-nav-overlay .ltch-aside__menu__item.ltch_high_contrast_item:hover,\n.ltch-left-nav-overlay\n  .ltch-aside__menu__item.ltch_high_contrast_item:focus-visible,\n.ltch-left-nav-overlay\n  .aside__menu__item__bottom.ltch_high_contrast_item\n  .aside__menu__item__bottom__link:focus-visible,\n.ltch-left-nav-overlay\n  .aside__menu__item__bottom.ltch_high_contrast_item:hover\n  .aside__menu__item__bottom__link,\n.ltch-left-nav-overlay\n  .aside__menu__item__bottom.ltch_high_contrast_item:focus-within\n  .aside__menu__item__bottom__link {\n  outline: 1px solid rgb(136, 136, 136) !important;\n  outline-offset: -1px;\n}\n\n.ltch-left-nav-overlay\n  .aside__menu__items__level1\n  .aside__menu__item__product__title:hover,\n.ltch-left-nav-overlay\n  .aside__menu__items__level1\n  .aside__menu__item__product__title:focus-visible {\n  background-color: transparent;\n}\n\n.ltch-left-nav-overlay\n  .aside__menu__item__bottom-upgrade:hover\n  .aside__menu__item__bottom__link,\n.ltch-left-nav-overlay\n  .aside__menu__item__bottom-upgrade:focus-visible\n  .aside__menu__item__bottom__link {\n  background-color: #c95100;\n}\n\n.ltch-left-nav-overlay .ltch-bottom-upgrade-btn:focus-visible {\n  outline: 2px solid #101010 !important;\n  outline-offset: -2px;\n}\n\n.ltch-left-nav-overlay .ltch-aside-menu-bottom-submenu-item-wrapper,\n.ltch-left-nav-overlay .aside__menu__bottom__submenu__item {\n  background-color: #fff;\n  box-shadow: none;\n  color: #333;\n  padding-left: 12px;\n}\n\n.ltch-left-nav-overlay .ltch-aside-menu-bottom-submenu-item-wrapper {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.ltch-left-nav-overlay .aside__menu__bottom__submenu__item:hover,\n.ltch-left-nav-overlay .aside__menu__bottom__submenu__item:focus-visible {\n  background-color: #dddddd33;\n}\n\n.ltch-left-nav-overlay .aside__menu__bottom__submenu {\n  background-color: #fff;\n  border: 1px solid #d4d4d4;\n  box-shadow: 0px 8px 24px 0px rgba(140, 149, 159, 0.2);\n  box-sizing: border-box;\n  z-index: 2;\n}\n\n.ltch-left-nav-overlay:not(.collapsed) .aside__menu__bottom__submenu:before {\n  border-top-color: #d4d4d4;\n}\n\n.ltch-left-nav-overlay .aside__menu__bottom__submenu {\n  left: 8px;\n  width: 304px;\n}\n\n.ltch-left-nav-overlay .aside__menu__bottom__submenu__item-title {\n  padding-left: 8px;\n  color: #666;\n}\n\n.ltch-left-nav-overlay .aside__menu__bottom__submenu__item-title:hover,\n.ltch-left-nav-overlay .aside__menu__bottom__submenu__item-title:focus-visible {\n  background-color: #fff;\n}\n\n.ltch-left-nav-overlay .aside__menu__bottom__submenu:after {\n  border-top-color: #fff;\n}\n\n.ltch-left-nav-overlay .ltch_lambda__logo {\n  display: flex;\n  height: 52px;\n}\n\n.ltch-tunnel-name {\n  justify-content: space-between;\n  display: flex;\n  flex: 1;\n}\n\n.ltch-more-options-menu-item-icon {\n  display: flex;\n}\n\n.ltch-left-nav-overlay ~ .product_main_content {\n  margin-left: 56px;\n}\n\n@media only screen and (max-width: 1024px) {\n  /* .ltch-top-nav-hamburger-menu {\n    display: flex;\n  } */\n\n  /* .Left_Nav {\n    opacity: 0;\n    height: 0;\n    width: 0;\n    position: absolute;\n    top: -99999px;\n  } */\n\n  .ltch-more-options-wrapper {\n    display: list-item;\n  }\n\n  /* .lambda__logo__wrapper {\n    display: none;\n  } */\n\n  .ltch-high-res-items {\n    display: none;\n  }\n\n  /* .header__top__menu,\n  .header__top__menu.collapsed {\n    padding-left: 50px;\n  } */\n\n  /* .lambda__logo__wrapper__left__nav {\n    display: block;\n    position: relative;\n    height: 48px;\n    z-index: 2;\n  } */\n\n  /* .menu__collapse__toggle {\n    opacity: 0 !important;\n  } */\n\n  .product_main_content {\n    padding-left: 10px;\n  }\n\n  .announcekit__widget__li {\n    display: none;\n  }\n\n  .ltch-top-upgrade-btn .ltch-upgrade-icon {\n    display: flex;\n    margin-right: 0;\n  }\n\n  .ltch-top-upgrade-btn .ltch-upgrade-btn-text {\n    display: none;\n  }\n  .ltch-top-upgrade-btn .aside__menu__item__bottom__link {\n    width: 28px;\n  }\n}\n\n@media only screen and (max-width: 320px) {\n  .aside__menu__items-useful {\n    display: none;\n  }\n  .menu__items .nav__item {\n    margin-left: 2px;\n  }\n\n  .ltch-icon-btn ~ .lt-dropdown-menu {\n    width: 200px;\n  }\n\n  .ltch-concurrency-low-res-separator {\n    margin-bottom: 0;\n  }\n}\n\n@media only screen and (max-width: 450px) {\n  .ltch-left-nav-overlay.collapsed {\n    overflow-y: auto;\n  }\n}\n\n/* Skip to content */\n.ltch-skip-to-content {\n  background-color: #0969da;\n  color: #fff !important;\n  padding: 16px;\n  position: absolute !important;\n}\n\n.ltch-start-of-content {\n  position: absolute;\n}\n\n.ltch-skip-to-content:focus {\n  z-index: 999;\n}\n\n.ltch-skip-to-content:not(:focus),\n.ltch-start-of-content:not(:focus) {\n  width: 1px;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  border: 0 !important;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  word-wrap: normal;\n}\n\n@keyframes Overlay-slideRight {\n  from {\n    transform: translateX(-100%);\n  }\n}\n\n.ltch-left-nav-menu-title {\n  color: #666;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  gap: 12px;\n  line-height: normal;\n  padding: 12px 16px 12px 12px;\n  opacity: 1;\n  transition: opacity 180ms cubic-bezier(0.4, 0, 1, 1) 0.01s,\n    height 180ms cubic-bezier(0.4, 0, 1, 1) 0.01s,\n    padding 180ms cubic-bezier(0.4, 0, 1, 1) 0.01s,\n    margin 180ms cubic-bezier(0.4, 0, 1, 1) 0.01s;\n  white-space: nowrap;\n}\n\n.ltch-left-nav-menu-title-with-border {\n  margin-top: 10px;\n  border-top: 1px solid #ddd;\n}\n\n.Left_Nav:not(.ltch-left-nav-overlay) .ltch-left-nav-menu-title-with-border {\n  border-top-color: #24272e;\n}\n\n.Left_Nav:not(.ltch-left-nav-overlay)\n  .ltch-aside__menu__item.active\n  .ltch-left-nav-menu-title {\n  background-color: #161a22 !important;\n}\n\n.Left_Nav:not(.ltch-left-nav-overlay)\n  .ltch-aside__menu__item:hover\n  .ltch-left-nav-menu-title {\n  background-color: #161a22 !important;\n}\n\n.Left_Nav.collapsed:not(.ltch-left-nav-overlay) .ltch-left-nav-menu-title {\n  display: none;\n}\n\n.aside__menu__item__bottom-upgrade.ltch-high-contrast-item\n  .aside__menu__item__bottom__link {\n  border-color: #101010;\n}\n\n.ltch-caret-right {\n  margin-top: 5px;\n  opacity: 1;\n  transition: opacity 180ms cubic-bezier(0.4, 0, 1, 1) 0.2s;\n}\n\n/* When the menu is collapsed, hide the caret */\n.header__aside__menu.collapsed .ltch-caret-right {\n  opacity: 0;\n  transition: none;\n}\n\n/* progress bar styles */\n.ltch-progress-bar-title {\n  font-size: 16px;\n  margin-bottom: 8px;\n}\n\n.ltch-progress-bar {\n  display: flex;\n  height: 8px;\n  width: 100%;\n  border-radius: 6px;\n  border: 1px solid #d4d4d4;\n}\n\n.ltch-progress-bar-segment {\n  height: 100%;\n  transition: width 0.5s ease;\n}\n\n.ltch-progress-bar-divider {\n  position: relative;\n  bottom: 5px;\n  height: 16px;\n  width: 2px;\n  background-color: black;\n  margin-left: -1px;\n}\n\n.ltch-progress-bar-used-segment {\n  background-color: #0968da;\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.ltch-progress-bar-used-by-other-products-segment {\n  background-color: #dcecff;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n/* popover styles */\n\n.ltch-popover-container {\n  position: relative;\n  display: inline-block;\n}\n\n.ltch-popover-trigger {\n  background-color: #f7f7f7;\n  border-radius: 6px;\n  border: 1px solid rgba(27, 31, 36, 0.15);\n  box-shadow: 0px 1px 0px 0px rgba(27, 31, 35, 0.04);\n  box-sizing: border-box;\n  color: #333;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  height: 32px;\n  padding: 5px 8px;\n  margin-right: 8px;\n}\n\n.ltch-popover-trigger:focus-visible {\n  outline-color: #101010;\n}\n\n.ltch-popover-content {\n  background-color: #fff;\n  border: 1px solid #ddd;\n  box-shadow: rgba(31, 35, 40, 0.12) 0px 1px 3px,\n    rgba(66, 74, 83, 0.12) 0px 8px 24px;\n  border-radius: 12px;\n  margin-top: 8px;\n  max-height: 400px;\n  min-width: 400px;\n  overflow: auto;\n  padding: 0;\n  position: absolute;\n  right: 5px;\n  top: 100%;\n  white-space: nowrap;\n  z-index: 1000;\n}\n\n/* concurrency v2 styles */\n.ltch-segment-detail {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n.ltch-segment-heading,\n.ltch-segment-trailing-text {\n  font-weight: 400;\n  font-size: 14px;\n  color: rgb(51, 51, 51);\n}\n\n.ltch-segment-leading-icon {\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n  border: 1px solid #d4d4d4;\n}\n\n.ltch-segment-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ltch-segment-sub-heading,\n.ltch-segment-sub-heading-trailing-text {\n  font-weight: 500;\n  font-size: 12px;\n  color: rgb(102, 102, 102);\n}\n\n.ltch-sub-segment {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n  padding-left: 16px;\n}\n\n.ltch-sub-segment-detail {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  top: 3px;\n}\n\n.ltch-concurrency-header-items-container,\n.ltch-concurrency-header-items {\n  display: flex;\n  gap: 8px;\n}\n\n.ltch-concurrency-header-items {\n  gap: 4px;\n}\n',
          "",
        ]),
          (e.exports = n);
      },
      770: function (e, n, t) {
        (n = t(645)(!1)).push([
          e.id,
          '/* reset */\n.lt-tooltip-trigger {\n  z-index: 2;\n}\n\n.TooltipArrow {\n  fill: #333;\n}\n\n.tooltipChildrenWrapper {\n  display: flex;\n}\n\n.TooltipContent {\n  animation-duration: 400ms;\n  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);\n  background-color: #333;\n  border-radius: 4px;\n  box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px,\n      hsl(206 22% 7% / 20%) 0px 10px 20px -15px;\n  color: #fff;\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto,\n      "Helvetica Neue", Arial, sans-serif;\n  font-size: 12px;\n  line-height: 18px;\n  max-height: var(--radix-tooltip-content-available-height);\n  max-width: 200px;\n  padding: 4px 8px;\n  user-select: none;\n  word-break: break-all;\n  will-change: transform, opacity;\n}\n\n.TooltipContent[data-state="delayed-open"][data-side="top"] {\n  animation-name: slideDownAndFade;\n}\n\n.TooltipContent[data-state="delayed-open"][data-side="right"] {\n  animation-name: slideLeftAndFade;\n}\n\n.TooltipContent[data-state="delayed-open"][data-side="bottom"] {\n  animation-name: slideUpAndFade;\n}\n\n.TooltipContent[data-state="delayed-open"][data-side="left"] {\n  animation-name: slideRightAndFade;\n}\n\n.IconButton {\n  font-family: inherit;\n  border-radius: 100%;\n  height: 35px;\n  width: 35px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--violet-11);\n  background-color: white;\n  box-shadow: 0 2px 10px #333;\n}\n\n.IconButton:hover {\n  background-color: grey;\n}\n\n.IconButton:focus {\n  box-shadow: 0 0 0 2px black;\n}\n\ndiv[data-radix-popper-content-wrapper] {\n  z-index: 9999999999 !important;\n}\n\n@keyframes slideUpAndFade {\n  from {\n    opacity: 0;\n    transform: translateY(2px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideRightAndFade {\n  from {\n    opacity: 0;\n    transform: translateX(-2px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideDownAndFade {\n  from {\n    opacity: 0;\n    transform: translateY(-2px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideLeftAndFade {\n  from {\n    opacity: 0;\n    transform: translateX(2px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n',
          "",
        ]),
          (e.exports = n);
      },
      645: function (e) {
        "use strict";
        e.exports = function (e) {
          var n = [];
          return (
            (n.toString = function () {
              return this.map(function (n) {
                var t = (function (e, n) {
                  var t,
                    r,
                    o,
                    i = e[1] || "",
                    a = e[3];
                  if (!a) return i;
                  if (n && "function" == typeof btoa) {
                    var l =
                        ((t = a),
                        (r = btoa(
                          unescape(encodeURIComponent(JSON.stringify(t)))
                        )),
                        (o =
                          "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(
                            r
                          )),
                        "/*# ".concat(o, " */")),
                      s = a.sources.map(function (e) {
                        return "/*# sourceURL="
                          .concat(a.sourceRoot || "")
                          .concat(e, " */");
                      });
                    return [i].concat(s).concat([l]).join("\n");
                  }
                  return [i].join("\n");
                })(n, e);
                return n[2] ? "@media ".concat(n[2], " {").concat(t, "}") : t;
              }).join("");
            }),
            (n.i = function (e, t, r) {
              "string" == typeof e && (e = [[null, e, ""]]);
              var o = {};
              if (r)
                for (var i = 0; i < this.length; i++) {
                  var a = this[i][0];
                  null != a && (o[a] = !0);
                }
              for (var l = 0; l < e.length; l++) {
                var s = [].concat(e[l]);
                (r && o[s[0]]) ||
                  (t &&
                    (s[2]
                      ? (s[2] = "".concat(t, " and ").concat(s[2]))
                      : (s[2] = t)),
                  n.push(s));
              }
            }),
            n
          );
        };
      },
      418: function (e) {
        "use strict";
        var n = Object.getOwnPropertySymbols,
          t = Object.prototype.hasOwnProperty,
          r = Object.prototype.propertyIsEnumerable;
        function o(e) {
          if (null == e)
            throw new TypeError(
              "Object.assign cannot be called with null or undefined"
            );
          return Object(e);
        }
        e.exports = (function () {
          try {
            if (!Object.assign) return !1;
            var e = new String("abc");
            if (((e[5] = "de"), "5" === Object.getOwnPropertyNames(e)[0]))
              return !1;
            for (var n = {}, t = 0; t < 10; t++)
              n["_" + String.fromCharCode(t)] = t;
            if (
              "0123456789" !==
              Object.getOwnPropertyNames(n)
                .map(function (e) {
                  return n[e];
                })
                .join("")
            )
              return !1;
            var r = {};
            return (
              "abcdefghijklmnopqrst".split("").forEach(function (e) {
                r[e] = e;
              }),
              "abcdefghijklmnopqrst" ===
                Object.keys(Object.assign({}, r)).join("")
            );
          } catch (e) {
            return !1;
          }
        })()
          ? Object.assign
          : function (e, i) {
              for (var a, l, s = o(e), c = 1; c < arguments.length; c++) {
                for (var u in (a = Object(arguments[c])))
                  t.call(a, u) && (s[u] = a[u]);
                if (n) {
                  l = n(a);
                  for (var d = 0; d < l.length; d++)
                    r.call(a, l[d]) && (s[l[d]] = a[l[d]]);
                }
              }
              return s;
            };
      },
      448: function (e, n, t) {
        "use strict";
        var r = t(497),
          o = t(418),
          i = t(840);
        function a(e) {
          for (
            var n =
                "https://reactjs.org/docs/error-decoder.html?invariant=" + e,
              t = 1;
            t < arguments.length;
            t++
          )
            n += "&args[]=" + encodeURIComponent(arguments[t]);
          return (
            "Minified React error #" +
            e +
            "; visit " +
            n +
            " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
          );
        }
        if (!r) throw Error(a(227));
        var l = new Set(),
          s = {};
        function c(e, n) {
          u(e, n), u(e + "Capture", n);
        }
        function u(e, n) {
          for (s[e] = n, e = 0; e < n.length; e++) l.add(n[e]);
        }
        var d = !(
            "undefined" == typeof window ||
            void 0 === window.document ||
            void 0 === window.document.createElement
          ),
          p =
            /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
          f = Object.prototype.hasOwnProperty,
          h = {},
          m = {};
        function _(e, n, t, r, o, i, a) {
          (this.acceptsBooleans = 2 === n || 3 === n || 4 === n),
            (this.attributeName = r),
            (this.attributeNamespace = o),
            (this.mustUseProperty = t),
            (this.propertyName = e),
            (this.type = n),
            (this.sanitizeURL = i),
            (this.removeEmptyString = a);
        }
        var g = {};
        "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style"
          .split(" ")
          .forEach(function (e) {
            g[e] = new _(e, 0, !1, e, null, !1, !1);
          }),
          [
            ["acceptCharset", "accept-charset"],
            ["className", "class"],
            ["htmlFor", "for"],
            ["httpEquiv", "http-equiv"],
          ].forEach(function (e) {
            var n = e[0];
            g[n] = new _(n, 1, !1, e[1], null, !1, !1);
          }),
          ["contentEditable", "draggable", "spellCheck", "value"].forEach(
            function (e) {
              g[e] = new _(e, 2, !1, e.toLowerCase(), null, !1, !1);
            }
          ),
          [
            "autoReverse",
            "externalResourcesRequired",
            "focusable",
            "preserveAlpha",
          ].forEach(function (e) {
            g[e] = new _(e, 2, !1, e, null, !1, !1);
          }),
          "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope"
            .split(" ")
            .forEach(function (e) {
              g[e] = new _(e, 3, !1, e.toLowerCase(), null, !1, !1);
            }),
          ["checked", "multiple", "muted", "selected"].forEach(function (e) {
            g[e] = new _(e, 3, !0, e, null, !1, !1);
          }),
          ["capture", "download"].forEach(function (e) {
            g[e] = new _(e, 4, !1, e, null, !1, !1);
          }),
          ["cols", "rows", "size", "span"].forEach(function (e) {
            g[e] = new _(e, 6, !1, e, null, !1, !1);
          }),
          ["rowSpan", "start"].forEach(function (e) {
            g[e] = new _(e, 5, !1, e.toLowerCase(), null, !1, !1);
          });
        var v = /[\-:]([a-z])/g;
        function C(e) {
          return e[1].toUpperCase();
        }
        function b(e, n, t, r) {
          var o = g.hasOwnProperty(n) ? g[n] : null;
          (null !== o
            ? 0 === o.type
            : !r &&
              2 < n.length &&
              ("o" === n[0] || "O" === n[0]) &&
              ("n" === n[1] || "N" === n[1])) ||
            ((function (e, n, t, r) {
              if (
                null == n ||
                (function (e, n, t, r) {
                  if (null !== t && 0 === t.type) return !1;
                  switch (typeof n) {
                    case "function":
                    case "symbol":
                      return !0;
                    case "boolean":
                      return (
                        !r &&
                        (null !== t
                          ? !t.acceptsBooleans
                          : "data-" !== (e = e.toLowerCase().slice(0, 5)) &&
                            "aria-" !== e)
                      );
                    default:
                      return !1;
                  }
                })(e, n, t, r)
              )
                return !0;
              if (r) return !1;
              if (null !== t)
                switch (t.type) {
                  case 3:
                    return !n;
                  case 4:
                    return !1 === n;
                  case 5:
                    return isNaN(n);
                  case 6:
                    return isNaN(n) || 1 > n;
                }
              return !1;
            })(n, t, o, r) && (t = null),
            r || null === o
              ? (function (e) {
                  return (
                    !!f.call(m, e) ||
                    (!f.call(h, e) &&
                      (p.test(e) ? (m[e] = !0) : ((h[e] = !0), !1)))
                  );
                })(n) &&
                (null === t ? e.removeAttribute(n) : e.setAttribute(n, "" + t))
              : o.mustUseProperty
              ? (e[o.propertyName] = null === t ? 3 !== o.type && "" : t)
              : ((n = o.attributeName),
                (r = o.attributeNamespace),
                null === t
                  ? e.removeAttribute(n)
                  : ((t =
                      3 === (o = o.type) || (4 === o && !0 === t)
                        ? ""
                        : "" + t),
                    r ? e.setAttributeNS(r, n, t) : e.setAttribute(n, t))));
        }
        "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height"
          .split(" ")
          .forEach(function (e) {
            var n = e.replace(v, C);
            g[n] = new _(n, 1, !1, e, null, !1, !1);
          }),
          "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type"
            .split(" ")
            .forEach(function (e) {
              var n = e.replace(v, C);
              g[n] = new _(n, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
            }),
          ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
            var n = e.replace(v, C);
            g[n] = new _(
              n,
              1,
              !1,
              e,
              "http://www.w3.org/XML/1998/namespace",
              !1,
              !1
            );
          }),
          ["tabIndex", "crossOrigin"].forEach(function (e) {
            g[e] = new _(e, 1, !1, e.toLowerCase(), null, !1, !1);
          }),
          (g.xlinkHref = new _(
            "xlinkHref",
            1,
            !1,
            "xlink:href",
            "http://www.w3.org/1999/xlink",
            !0,
            !1
          )),
          ["src", "href", "action", "formAction"].forEach(function (e) {
            g[e] = new _(e, 1, !1, e.toLowerCase(), null, !0, !0);
          });
        var x = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
          y = 60103,
          w = 60106,
          k = 60107,
          L = 60108,
          j = 60114,
          E = 60109,
          S = 60110,
          M = 60112,
          T = 60113,
          N = 60120,
          O = 60115,
          A = 60116,
          I = 60121,
          P = 60128,
          R = 60129,
          H = 60130,
          V = 60131;
        if ("function" == typeof Symbol && Symbol.for) {
          var D = Symbol.for;
          (y = D("react.element")),
            (w = D("react.portal")),
            (k = D("react.fragment")),
            (L = D("react.strict_mode")),
            (j = D("react.profiler")),
            (E = D("react.provider")),
            (S = D("react.context")),
            (M = D("react.forward_ref")),
            (T = D("react.suspense")),
            (N = D("react.suspense_list")),
            (O = D("react.memo")),
            (A = D("react.lazy")),
            (I = D("react.block")),
            D("react.scope"),
            (P = D("react.opaque.id")),
            (R = D("react.debug_trace_mode")),
            (H = D("react.offscreen")),
            (V = D("react.legacy_hidden"));
        }
        var B,
          W = "function" == typeof Symbol && Symbol.iterator;
        function z(e) {
          return null === e || "object" != typeof e
            ? null
            : "function" == typeof (e = (W && e[W]) || e["@@iterator"])
            ? e
            : null;
        }
        function Z(e) {
          if (void 0 === B)
            try {
              throw Error();
            } catch (e) {
              var n = e.stack.trim().match(/\n( *(at )?)/);
              B = (n && n[1]) || "";
            }
          return "\n" + B + e;
        }
        var F = !1;
        function U(e, n) {
          if (!e || F) return "";
          F = !0;
          var t = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          try {
            if (n)
              if (
                ((n = function () {
                  throw Error();
                }),
                Object.defineProperty(n.prototype, "props", {
                  set: function () {
                    throw Error();
                  },
                }),
                "object" == typeof Reflect && Reflect.construct)
              ) {
                try {
                  Reflect.construct(n, []);
                } catch (e) {
                  var r = e;
                }
                Reflect.construct(e, [], n);
              } else {
                try {
                  n.call();
                } catch (e) {
                  r = e;
                }
                e.call(n.prototype);
              }
            else {
              try {
                throw Error();
              } catch (e) {
                r = e;
              }
              e();
            }
          } catch (e) {
            if (e && r && "string" == typeof e.stack) {
              for (
                var o = e.stack.split("\n"),
                  i = r.stack.split("\n"),
                  a = o.length - 1,
                  l = i.length - 1;
                1 <= a && 0 <= l && o[a] !== i[l];

              )
                l--;
              for (; 1 <= a && 0 <= l; a--, l--)
                if (o[a] !== i[l]) {
                  if (1 !== a || 1 !== l)
                    do {
                      if ((a--, 0 > --l || o[a] !== i[l]))
                        return "\n" + o[a].replace(" at new ", " at ");
                    } while (1 <= a && 0 <= l);
                  break;
                }
            }
          } finally {
            (F = !1), (Error.prepareStackTrace = t);
          }
          return (e = e ? e.displayName || e.name : "") ? Z(e) : "";
        }
        function K(e) {
          switch (e.tag) {
            case 5:
              return Z(e.type);
            case 16:
              return Z("Lazy");
            case 13:
              return Z("Suspense");
            case 19:
              return Z("SuspenseList");
            case 0:
            case 2:
            case 15:
              return U(e.type, !1);
            case 11:
              return U(e.type.render, !1);
            case 22:
              return U(e.type._render, !1);
            case 1:
              return U(e.type, !0);
            default:
              return "";
          }
        }
        function G(e) {
          if (null == e) return null;
          if ("function" == typeof e) return e.displayName || e.name || null;
          if ("string" == typeof e) return e;
          switch (e) {
            case k:
              return "Fragment";
            case w:
              return "Portal";
            case j:
              return "Profiler";
            case L:
              return "StrictMode";
            case T:
              return "Suspense";
            case N:
              return "SuspenseList";
          }
          if ("object" == typeof e)
            switch (e.$$typeof) {
              case S:
                return (e.displayName || "Context") + ".Consumer";
              case E:
                return (e._context.displayName || "Context") + ".Provider";
              case M:
                var n = e.render;
                return (
                  (n = n.displayName || n.name || ""),
                  e.displayName ||
                    ("" !== n ? "ForwardRef(" + n + ")" : "ForwardRef")
                );
              case O:
                return G(e.type);
              case I:
                return G(e._render);
              case A:
                (n = e._payload), (e = e._init);
                try {
                  return G(e(n));
                } catch (e) {}
            }
          return null;
        }
        function Y(e) {
          switch (typeof e) {
            case "boolean":
            case "number":
            case "object":
            case "string":
            case "undefined":
              return e;
            default:
              return "";
          }
        }
        function $(e) {
          var n = e.type;
          return (
            (e = e.nodeName) &&
            "input" === e.toLowerCase() &&
            ("checkbox" === n || "radio" === n)
          );
        }
        function q(e) {
          e._valueTracker ||
            (e._valueTracker = (function (e) {
              var n = $(e) ? "checked" : "value",
                t = Object.getOwnPropertyDescriptor(e.constructor.prototype, n),
                r = "" + e[n];
              if (
                !e.hasOwnProperty(n) &&
                void 0 !== t &&
                "function" == typeof t.get &&
                "function" == typeof t.set
              ) {
                var o = t.get,
                  i = t.set;
                return (
                  Object.defineProperty(e, n, {
                    configurable: !0,
                    get: function () {
                      return o.call(this);
                    },
                    set: function (e) {
                      (r = "" + e), i.call(this, e);
                    },
                  }),
                  Object.defineProperty(e, n, { enumerable: t.enumerable }),
                  {
                    getValue: function () {
                      return r;
                    },
                    setValue: function (e) {
                      r = "" + e;
                    },
                    stopTracking: function () {
                      (e._valueTracker = null), delete e[n];
                    },
                  }
                );
              }
            })(e));
        }
        function Q(e) {
          if (!e) return !1;
          var n = e._valueTracker;
          if (!n) return !0;
          var t = n.getValue(),
            r = "";
          return (
            e && (r = $(e) ? (e.checked ? "true" : "false") : e.value),
            (e = r) !== t && (n.setValue(e), !0)
          );
        }
        function X(e) {
          if (
            void 0 ===
            (e = e || ("undefined" != typeof document ? document : void 0))
          )
            return null;
          try {
            return e.activeElement || e.body;
          } catch (n) {
            return e.body;
          }
        }
        function J(e, n) {
          var t = n.checked;
          return o({}, n, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: void 0,
            checked: null != t ? t : e._wrapperState.initialChecked,
          });
        }
        function ee(e, n) {
          var t = null == n.defaultValue ? "" : n.defaultValue,
            r = null != n.checked ? n.checked : n.defaultChecked;
          (t = Y(null != n.value ? n.value : t)),
            (e._wrapperState = {
              initialChecked: r,
              initialValue: t,
              controlled:
                "checkbox" === n.type || "radio" === n.type
                  ? null != n.checked
                  : null != n.value,
            });
        }
        function ne(e, n) {
          null != (n = n.checked) && b(e, "checked", n, !1);
        }
        function te(e, n) {
          ne(e, n);
          var t = Y(n.value),
            r = n.type;
          if (null != t)
            "number" === r
              ? ((0 === t && "" === e.value) || e.value != t) &&
                (e.value = "" + t)
              : e.value !== "" + t && (e.value = "" + t);
          else if ("submit" === r || "reset" === r)
            return void e.removeAttribute("value");
          n.hasOwnProperty("value")
            ? oe(e, n.type, t)
            : n.hasOwnProperty("defaultValue") &&
              oe(e, n.type, Y(n.defaultValue)),
            null == n.checked &&
              null != n.defaultChecked &&
              (e.defaultChecked = !!n.defaultChecked);
        }
        function re(e, n, t) {
          if (n.hasOwnProperty("value") || n.hasOwnProperty("defaultValue")) {
            var r = n.type;
            if (
              !(
                ("submit" !== r && "reset" !== r) ||
                (void 0 !== n.value && null !== n.value)
              )
            )
              return;
            (n = "" + e._wrapperState.initialValue),
              t || n === e.value || (e.value = n),
              (e.defaultValue = n);
          }
          "" !== (t = e.name) && (e.name = ""),
            (e.defaultChecked = !!e._wrapperState.initialChecked),
            "" !== t && (e.name = t);
        }
        function oe(e, n, t) {
          ("number" === n && X(e.ownerDocument) === e) ||
            (null == t
              ? (e.defaultValue = "" + e._wrapperState.initialValue)
              : e.defaultValue !== "" + t && (e.defaultValue = "" + t));
        }
        function ie(e, n) {
          return (
            (e = o({ children: void 0 }, n)),
            (n = (function (e) {
              var n = "";
              return (
                r.Children.forEach(e, function (e) {
                  null != e && (n += e);
                }),
                n
              );
            })(n.children)) && (e.children = n),
            e
          );
        }
        function ae(e, n, t, r) {
          if (((e = e.options), n)) {
            n = {};
            for (var o = 0; o < t.length; o++) n["$" + t[o]] = !0;
            for (t = 0; t < e.length; t++)
              (o = n.hasOwnProperty("$" + e[t].value)),
                e[t].selected !== o && (e[t].selected = o),
                o && r && (e[t].defaultSelected = !0);
          } else {
            for (t = "" + Y(t), n = null, o = 0; o < e.length; o++) {
              if (e[o].value === t)
                return (
                  (e[o].selected = !0), void (r && (e[o].defaultSelected = !0))
                );
              null !== n || e[o].disabled || (n = e[o]);
            }
            null !== n && (n.selected = !0);
          }
        }
        function le(e, n) {
          if (null != n.dangerouslySetInnerHTML) throw Error(a(91));
          return o({}, n, {
            value: void 0,
            defaultValue: void 0,
            children: "" + e._wrapperState.initialValue,
          });
        }
        function se(e, n) {
          var t = n.value;
          if (null == t) {
            if (((t = n.children), (n = n.defaultValue), null != t)) {
              if (null != n) throw Error(a(92));
              if (Array.isArray(t)) {
                if (!(1 >= t.length)) throw Error(a(93));
                t = t[0];
              }
              n = t;
            }
            null == n && (n = ""), (t = n);
          }
          e._wrapperState = { initialValue: Y(t) };
        }
        function ce(e, n) {
          var t = Y(n.value),
            r = Y(n.defaultValue);
          null != t &&
            ((t = "" + t) !== e.value && (e.value = t),
            null == n.defaultValue &&
              e.defaultValue !== t &&
              (e.defaultValue = t)),
            null != r && (e.defaultValue = "" + r);
        }
        function ue(e) {
          var n = e.textContent;
          n === e._wrapperState.initialValue &&
            "" !== n &&
            null !== n &&
            (e.value = n);
        }
        var de = "http://www.w3.org/1999/xhtml";
        function pe(e) {
          switch (e) {
            case "svg":
              return "http://www.w3.org/2000/svg";
            case "math":
              return "http://www.w3.org/1998/Math/MathML";
            default:
              return "http://www.w3.org/1999/xhtml";
          }
        }
        function fe(e, n) {
          return null == e || "http://www.w3.org/1999/xhtml" === e
            ? pe(n)
            : "http://www.w3.org/2000/svg" === e && "foreignObject" === n
            ? "http://www.w3.org/1999/xhtml"
            : e;
        }
        var he,
          me,
          _e =
            ((me = function (e, n) {
              if (
                "http://www.w3.org/2000/svg" !== e.namespaceURI ||
                "innerHTML" in e
              )
                e.innerHTML = n;
              else {
                for (
                  (he = he || document.createElement("div")).innerHTML =
                    "<svg>" + n.valueOf().toString() + "</svg>",
                    n = he.firstChild;
                  e.firstChild;

                )
                  e.removeChild(e.firstChild);
                for (; n.firstChild; ) e.appendChild(n.firstChild);
              }
            }),
            "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction
              ? function (e, n, t, r) {
                  MSApp.execUnsafeLocalFunction(function () {
                    return me(e, n);
                  });
                }
              : me);
        function ge(e, n) {
          if (n) {
            var t = e.firstChild;
            if (t && t === e.lastChild && 3 === t.nodeType)
              return void (t.nodeValue = n);
          }
          e.textContent = n;
        }
        var ve = {
            animationIterationCount: !0,
            borderImageOutset: !0,
            borderImageSlice: !0,
            borderImageWidth: !0,
            boxFlex: !0,
            boxFlexGroup: !0,
            boxOrdinalGroup: !0,
            columnCount: !0,
            columns: !0,
            flex: !0,
            flexGrow: !0,
            flexPositive: !0,
            flexShrink: !0,
            flexNegative: !0,
            flexOrder: !0,
            gridArea: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowSpan: !0,
            gridRowStart: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnSpan: !0,
            gridColumnStart: !0,
            fontWeight: !0,
            lineClamp: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            tabSize: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
            fillOpacity: !0,
            floodOpacity: !0,
            stopOpacity: !0,
            strokeDasharray: !0,
            strokeDashoffset: !0,
            strokeMiterlimit: !0,
            strokeOpacity: !0,
            strokeWidth: !0,
          },
          Ce = ["Webkit", "ms", "Moz", "O"];
        function be(e, n, t) {
          return null == n || "boolean" == typeof n || "" === n
            ? ""
            : t ||
              "number" != typeof n ||
              0 === n ||
              (ve.hasOwnProperty(e) && ve[e])
            ? ("" + n).trim()
            : n + "px";
        }
        function xe(e, n) {
          for (var t in ((e = e.style), n))
            if (n.hasOwnProperty(t)) {
              var r = 0 === t.indexOf("--"),
                o = be(t, n[t], r);
              "float" === t && (t = "cssFloat"),
                r ? e.setProperty(t, o) : (e[t] = o);
            }
        }
        Object.keys(ve).forEach(function (e) {
          Ce.forEach(function (n) {
            (n = n + e.charAt(0).toUpperCase() + e.substring(1)),
              (ve[n] = ve[e]);
          });
        });
        var ye = o(
          { menuitem: !0 },
          {
            area: !0,
            base: !0,
            br: !0,
            col: !0,
            embed: !0,
            hr: !0,
            img: !0,
            input: !0,
            keygen: !0,
            link: !0,
            meta: !0,
            param: !0,
            source: !0,
            track: !0,
            wbr: !0,
          }
        );
        function we(e, n) {
          if (n) {
            if (
              ye[e] &&
              (null != n.children || null != n.dangerouslySetInnerHTML)
            )
              throw Error(a(137, e));
            if (null != n.dangerouslySetInnerHTML) {
              if (null != n.children) throw Error(a(60));
              if (
                "object" != typeof n.dangerouslySetInnerHTML ||
                !("__html" in n.dangerouslySetInnerHTML)
              )
                throw Error(a(61));
            }
            if (null != n.style && "object" != typeof n.style)
              throw Error(a(62));
          }
        }
        function ke(e, n) {
          if (-1 === e.indexOf("-")) return "string" == typeof n.is;
          switch (e) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              return !1;
            default:
              return !0;
          }
        }
        function Le(e) {
          return (
            (e = e.target || e.srcElement || window).correspondingUseElement &&
              (e = e.correspondingUseElement),
            3 === e.nodeType ? e.parentNode : e
          );
        }
        var je = null,
          Ee = null,
          Se = null;
        function Me(e) {
          if ((e = to(e))) {
            if ("function" != typeof je) throw Error(a(280));
            var n = e.stateNode;
            n && ((n = oo(n)), je(e.stateNode, e.type, n));
          }
        }
        function Te(e) {
          Ee ? (Se ? Se.push(e) : (Se = [e])) : (Ee = e);
        }
        function Ne() {
          if (Ee) {
            var e = Ee,
              n = Se;
            if (((Se = Ee = null), Me(e), n))
              for (e = 0; e < n.length; e++) Me(n[e]);
          }
        }
        function Oe(e, n) {
          return e(n);
        }
        function Ae(e, n, t, r, o) {
          return e(n, t, r, o);
        }
        function Ie() {}
        var Pe = Oe,
          Re = !1,
          He = !1;
        function Ve() {
          (null === Ee && null === Se) || (Ie(), Ne());
        }
        function De(e, n) {
          var t = e.stateNode;
          if (null === t) return null;
          var r = oo(t);
          if (null === r) return null;
          t = r[n];
          e: switch (n) {
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
              (r = !r.disabled) ||
                (r = !(
                  "button" === (e = e.type) ||
                  "input" === e ||
                  "select" === e ||
                  "textarea" === e
                )),
                (e = !r);
              break e;
            default:
              e = !1;
          }
          if (e) return null;
          if (t && "function" != typeof t) throw Error(a(231, n, typeof t));
          return t;
        }
        var Be = !1;
        if (d)
          try {
            var We = {};
            Object.defineProperty(We, "passive", {
              get: function () {
                Be = !0;
              },
            }),
              window.addEventListener("test", We, We),
              window.removeEventListener("test", We, We);
          } catch (me) {
            Be = !1;
          }
        function ze(e, n, t, r, o, i, a, l, s) {
          var c = Array.prototype.slice.call(arguments, 3);
          try {
            n.apply(t, c);
          } catch (e) {
            this.onError(e);
          }
        }
        var Ze = !1,
          Fe = null,
          Ue = !1,
          Ke = null,
          Ge = {
            onError: function (e) {
              (Ze = !0), (Fe = e);
            },
          };
        function Ye(e, n, t, r, o, i, a, l, s) {
          (Ze = !1), (Fe = null), ze.apply(Ge, arguments);
        }
        function $e(e) {
          var n = e,
            t = e;
          if (e.alternate) for (; n.return; ) n = n.return;
          else {
            e = n;
            do {
              0 != (1026 & (n = e).flags) && (t = n.return), (e = n.return);
            } while (e);
          }
          return 3 === n.tag ? t : null;
        }
        function qe(e) {
          if (13 === e.tag) {
            var n = e.memoizedState;
            if (
              (null === n &&
                null !== (e = e.alternate) &&
                (n = e.memoizedState),
              null !== n)
            )
              return n.dehydrated;
          }
          return null;
        }
        function Qe(e) {
          if ($e(e) !== e) throw Error(a(188));
        }
        function Xe(e) {
          if (
            ((e = (function (e) {
              var n = e.alternate;
              if (!n) {
                if (null === (n = $e(e))) throw Error(a(188));
                return n !== e ? null : e;
              }
              for (var t = e, r = n; ; ) {
                var o = t.return;
                if (null === o) break;
                var i = o.alternate;
                if (null === i) {
                  if (null !== (r = o.return)) {
                    t = r;
                    continue;
                  }
                  break;
                }
                if (o.child === i.child) {
                  for (i = o.child; i; ) {
                    if (i === t) return Qe(o), e;
                    if (i === r) return Qe(o), n;
                    i = i.sibling;
                  }
                  throw Error(a(188));
                }
                if (t.return !== r.return) (t = o), (r = i);
                else {
                  for (var l = !1, s = o.child; s; ) {
                    if (s === t) {
                      (l = !0), (t = o), (r = i);
                      break;
                    }
                    if (s === r) {
                      (l = !0), (r = o), (t = i);
                      break;
                    }
                    s = s.sibling;
                  }
                  if (!l) {
                    for (s = i.child; s; ) {
                      if (s === t) {
                        (l = !0), (t = i), (r = o);
                        break;
                      }
                      if (s === r) {
                        (l = !0), (r = i), (t = o);
                        break;
                      }
                      s = s.sibling;
                    }
                    if (!l) throw Error(a(189));
                  }
                }
                if (t.alternate !== r) throw Error(a(190));
              }
              if (3 !== t.tag) throw Error(a(188));
              return t.stateNode.current === t ? e : n;
            })(e)),
            !e)
          )
            return null;
          for (var n = e; ; ) {
            if (5 === n.tag || 6 === n.tag) return n;
            if (n.child) (n.child.return = n), (n = n.child);
            else {
              if (n === e) break;
              for (; !n.sibling; ) {
                if (!n.return || n.return === e) return null;
                n = n.return;
              }
              (n.sibling.return = n.return), (n = n.sibling);
            }
          }
          return null;
        }
        function Je(e, n) {
          for (var t = e.alternate; null !== n; ) {
            if (n === e || n === t) return !0;
            n = n.return;
          }
          return !1;
        }
        var en,
          nn,
          tn,
          rn,
          on = !1,
          an = [],
          ln = null,
          sn = null,
          cn = null,
          un = new Map(),
          dn = new Map(),
          pn = [],
          fn =
            "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(
              " "
            );
        function hn(e, n, t, r, o) {
          return {
            blockedOn: e,
            domEventName: n,
            eventSystemFlags: 16 | t,
            nativeEvent: o,
            targetContainers: [r],
          };
        }
        function mn(e, n) {
          switch (e) {
            case "focusin":
            case "focusout":
              ln = null;
              break;
            case "dragenter":
            case "dragleave":
              sn = null;
              break;
            case "mouseover":
            case "mouseout":
              cn = null;
              break;
            case "pointerover":
            case "pointerout":
              un.delete(n.pointerId);
              break;
            case "gotpointercapture":
            case "lostpointercapture":
              dn.delete(n.pointerId);
          }
        }
        function _n(e, n, t, r, o, i) {
          return null === e || e.nativeEvent !== i
            ? ((e = hn(n, t, r, o, i)),
              null !== n && null !== (n = to(n)) && nn(n),
              e)
            : ((e.eventSystemFlags |= r),
              (n = e.targetContainers),
              null !== o && -1 === n.indexOf(o) && n.push(o),
              e);
        }
        function gn(e) {
          var n = no(e.target);
          if (null !== n) {
            var t = $e(n);
            if (null !== t)
              if (13 === (n = t.tag)) {
                if (null !== (n = qe(t)))
                  return (
                    (e.blockedOn = n),
                    void rn(e.lanePriority, function () {
                      i.unstable_runWithPriority(e.priority, function () {
                        tn(t);
                      });
                    })
                  );
              } else if (3 === n && t.stateNode.hydrate)
                return void (e.blockedOn =
                  3 === t.tag ? t.stateNode.containerInfo : null);
          }
          e.blockedOn = null;
        }
        function vn(e) {
          if (null !== e.blockedOn) return !1;
          for (var n = e.targetContainers; 0 < n.length; ) {
            var t = Jn(e.domEventName, e.eventSystemFlags, n[0], e.nativeEvent);
            if (null !== t)
              return null !== (n = to(t)) && nn(n), (e.blockedOn = t), !1;
            n.shift();
          }
          return !0;
        }
        function Cn(e, n, t) {
          vn(e) && t.delete(n);
        }
        function bn() {
          for (on = !1; 0 < an.length; ) {
            var e = an[0];
            if (null !== e.blockedOn) {
              null !== (e = to(e.blockedOn)) && en(e);
              break;
            }
            for (var n = e.targetContainers; 0 < n.length; ) {
              var t = Jn(
                e.domEventName,
                e.eventSystemFlags,
                n[0],
                e.nativeEvent
              );
              if (null !== t) {
                e.blockedOn = t;
                break;
              }
              n.shift();
            }
            null === e.blockedOn && an.shift();
          }
          null !== ln && vn(ln) && (ln = null),
            null !== sn && vn(sn) && (sn = null),
            null !== cn && vn(cn) && (cn = null),
            un.forEach(Cn),
            dn.forEach(Cn);
        }
        function xn(e, n) {
          e.blockedOn === n &&
            ((e.blockedOn = null),
            on ||
              ((on = !0),
              i.unstable_scheduleCallback(i.unstable_NormalPriority, bn)));
        }
        function yn(e) {
          function n(n) {
            return xn(n, e);
          }
          if (0 < an.length) {
            xn(an[0], e);
            for (var t = 1; t < an.length; t++) {
              var r = an[t];
              r.blockedOn === e && (r.blockedOn = null);
            }
          }
          for (
            null !== ln && xn(ln, e),
              null !== sn && xn(sn, e),
              null !== cn && xn(cn, e),
              un.forEach(n),
              dn.forEach(n),
              t = 0;
            t < pn.length;
            t++
          )
            (r = pn[t]).blockedOn === e && (r.blockedOn = null);
          for (; 0 < pn.length && null === (t = pn[0]).blockedOn; )
            gn(t), null === t.blockedOn && pn.shift();
        }
        function wn(e, n) {
          var t = {};
          return (
            (t[e.toLowerCase()] = n.toLowerCase()),
            (t["Webkit" + e] = "webkit" + n),
            (t["Moz" + e] = "moz" + n),
            t
          );
        }
        var kn = {
            animationend: wn("Animation", "AnimationEnd"),
            animationiteration: wn("Animation", "AnimationIteration"),
            animationstart: wn("Animation", "AnimationStart"),
            transitionend: wn("Transition", "TransitionEnd"),
          },
          Ln = {},
          jn = {};
        function En(e) {
          if (Ln[e]) return Ln[e];
          if (!kn[e]) return e;
          var n,
            t = kn[e];
          for (n in t)
            if (t.hasOwnProperty(n) && n in jn) return (Ln[e] = t[n]);
          return e;
        }
        d &&
          ((jn = document.createElement("div").style),
          "AnimationEvent" in window ||
            (delete kn.animationend.animation,
            delete kn.animationiteration.animation,
            delete kn.animationstart.animation),
          "TransitionEvent" in window || delete kn.transitionend.transition);
        var Sn = En("animationend"),
          Mn = En("animationiteration"),
          Tn = En("animationstart"),
          Nn = En("transitionend"),
          On = new Map(),
          An = new Map(),
          In = [
            "abort",
            "abort",
            Sn,
            "animationEnd",
            Mn,
            "animationIteration",
            Tn,
            "animationStart",
            "canplay",
            "canPlay",
            "canplaythrough",
            "canPlayThrough",
            "durationchange",
            "durationChange",
            "emptied",
            "emptied",
            "encrypted",
            "encrypted",
            "ended",
            "ended",
            "error",
            "error",
            "gotpointercapture",
            "gotPointerCapture",
            "load",
            "load",
            "loadeddata",
            "loadedData",
            "loadedmetadata",
            "loadedMetadata",
            "loadstart",
            "loadStart",
            "lostpointercapture",
            "lostPointerCapture",
            "playing",
            "playing",
            "progress",
            "progress",
            "seeking",
            "seeking",
            "stalled",
            "stalled",
            "suspend",
            "suspend",
            "timeupdate",
            "timeUpdate",
            Nn,
            "transitionEnd",
            "waiting",
            "waiting",
          ];
        function Pn(e, n) {
          for (var t = 0; t < e.length; t += 2) {
            var r = e[t],
              o = e[t + 1];
            (o = "on" + (o[0].toUpperCase() + o.slice(1))),
              An.set(r, n),
              On.set(r, o),
              c(o, [r]);
          }
        }
        (0, i.unstable_now)();
        var Rn = 8;
        function Hn(e) {
          if (0 != (1 & e)) return (Rn = 15), 1;
          if (0 != (2 & e)) return (Rn = 14), 2;
          if (0 != (4 & e)) return (Rn = 13), 4;
          var n = 24 & e;
          return 0 !== n
            ? ((Rn = 12), n)
            : 0 != (32 & e)
            ? ((Rn = 11), 32)
            : 0 != (n = 192 & e)
            ? ((Rn = 10), n)
            : 0 != (256 & e)
            ? ((Rn = 9), 256)
            : 0 != (n = 3584 & e)
            ? ((Rn = 8), n)
            : 0 != (4096 & e)
            ? ((Rn = 7), 4096)
            : 0 != (n = 4186112 & e)
            ? ((Rn = 6), n)
            : 0 != (n = 62914560 & e)
            ? ((Rn = 5), n)
            : 67108864 & e
            ? ((Rn = 4), 67108864)
            : 0 != (134217728 & e)
            ? ((Rn = 3), 134217728)
            : 0 != (n = 805306368 & e)
            ? ((Rn = 2), n)
            : 0 != (1073741824 & e)
            ? ((Rn = 1), 1073741824)
            : ((Rn = 8), e);
        }
        function Vn(e, n) {
          var t = e.pendingLanes;
          if (0 === t) return (Rn = 0);
          var r = 0,
            o = 0,
            i = e.expiredLanes,
            a = e.suspendedLanes,
            l = e.pingedLanes;
          if (0 !== i) (r = i), (o = Rn = 15);
          else if (0 != (i = 134217727 & t)) {
            var s = i & ~a;
            0 !== s
              ? ((r = Hn(s)), (o = Rn))
              : 0 != (l &= i) && ((r = Hn(l)), (o = Rn));
          } else
            0 != (i = t & ~a)
              ? ((r = Hn(i)), (o = Rn))
              : 0 !== l && ((r = Hn(l)), (o = Rn));
          if (0 === r) return 0;
          if (
            ((r = t & (((0 > (r = 31 - Fn(r)) ? 0 : 1 << r) << 1) - 1)),
            0 !== n && n !== r && 0 == (n & a))
          ) {
            if ((Hn(n), o <= Rn)) return n;
            Rn = o;
          }
          if (0 !== (n = e.entangledLanes))
            for (e = e.entanglements, n &= r; 0 < n; )
              (o = 1 << (t = 31 - Fn(n))), (r |= e[t]), (n &= ~o);
          return r;
        }
        function Dn(e) {
          return 0 != (e = -1073741825 & e.pendingLanes)
            ? e
            : 1073741824 & e
            ? 1073741824
            : 0;
        }
        function Bn(e, n) {
          switch (e) {
            case 15:
              return 1;
            case 14:
              return 2;
            case 12:
              return 0 === (e = Wn(24 & ~n)) ? Bn(10, n) : e;
            case 10:
              return 0 === (e = Wn(192 & ~n)) ? Bn(8, n) : e;
            case 8:
              return (
                0 === (e = Wn(3584 & ~n)) &&
                  0 === (e = Wn(4186112 & ~n)) &&
                  (e = 512),
                e
              );
            case 2:
              return 0 === (n = Wn(805306368 & ~n)) && (n = 268435456), n;
          }
          throw Error(a(358, e));
        }
        function Wn(e) {
          return e & -e;
        }
        function zn(e) {
          for (var n = [], t = 0; 31 > t; t++) n.push(e);
          return n;
        }
        function Zn(e, n, t) {
          e.pendingLanes |= n;
          var r = n - 1;
          (e.suspendedLanes &= r),
            (e.pingedLanes &= r),
            ((e = e.eventTimes)[(n = 31 - Fn(n))] = t);
        }
        var Fn = Math.clz32
            ? Math.clz32
            : function (e) {
                return 0 === e ? 32 : (31 - ((Un(e) / Kn) | 0)) | 0;
              },
          Un = Math.log,
          Kn = Math.LN2,
          Gn = i.unstable_UserBlockingPriority,
          Yn = i.unstable_runWithPriority,
          $n = !0;
        function qn(e, n, t, r) {
          Re || Ie();
          var o = Xn,
            i = Re;
          Re = !0;
          try {
            Ae(o, e, n, t, r);
          } finally {
            (Re = i) || Ve();
          }
        }
        function Qn(e, n, t, r) {
          Yn(Gn, Xn.bind(null, e, n, t, r));
        }
        function Xn(e, n, t, r) {
          var o;
          if ($n)
            if ((o = 0 == (4 & n)) && 0 < an.length && -1 < fn.indexOf(e))
              (e = hn(null, e, n, t, r)), an.push(e);
            else {
              var i = Jn(e, n, t, r);
              if (null === i) o && mn(e, r);
              else {
                if (o) {
                  if (-1 < fn.indexOf(e))
                    return (e = hn(i, e, n, t, r)), void an.push(e);
                  if (
                    (function (e, n, t, r, o) {
                      switch (n) {
                        case "focusin":
                          return (ln = _n(ln, e, n, t, r, o)), !0;
                        case "dragenter":
                          return (sn = _n(sn, e, n, t, r, o)), !0;
                        case "mouseover":
                          return (cn = _n(cn, e, n, t, r, o)), !0;
                        case "pointerover":
                          var i = o.pointerId;
                          return (
                            un.set(i, _n(un.get(i) || null, e, n, t, r, o)), !0
                          );
                        case "gotpointercapture":
                          return (
                            (i = o.pointerId),
                            dn.set(i, _n(dn.get(i) || null, e, n, t, r, o)),
                            !0
                          );
                      }
                      return !1;
                    })(i, e, n, t, r)
                  )
                    return;
                  mn(e, r);
                }
                Ir(e, n, r, null, t);
              }
            }
        }
        function Jn(e, n, t, r) {
          var o = Le(r);
          if (null !== (o = no(o))) {
            var i = $e(o);
            if (null === i) o = null;
            else {
              var a = i.tag;
              if (13 === a) {
                if (null !== (o = qe(i))) return o;
                o = null;
              } else if (3 === a) {
                if (i.stateNode.hydrate)
                  return 3 === i.tag ? i.stateNode.containerInfo : null;
                o = null;
              } else i !== o && (o = null);
            }
          }
          return Ir(e, n, r, o, t), null;
        }
        var et = null,
          nt = null,
          tt = null;
        function rt() {
          if (tt) return tt;
          var e,
            n,
            t = nt,
            r = t.length,
            o = "value" in et ? et.value : et.textContent,
            i = o.length;
          for (e = 0; e < r && t[e] === o[e]; e++);
          var a = r - e;
          for (n = 1; n <= a && t[r - n] === o[i - n]; n++);
          return (tt = o.slice(e, 1 < n ? 1 - n : void 0));
        }
        function ot(e) {
          var n = e.keyCode;
          return (
            "charCode" in e
              ? 0 === (e = e.charCode) && 13 === n && (e = 13)
              : (e = n),
            10 === e && (e = 13),
            32 <= e || 13 === e ? e : 0
          );
        }
        function it() {
          return !0;
        }
        function at() {
          return !1;
        }
        function lt(e) {
          function n(n, t, r, o, i) {
            for (var a in ((this._reactName = n),
            (this._targetInst = r),
            (this.type = t),
            (this.nativeEvent = o),
            (this.target = i),
            (this.currentTarget = null),
            e))
              e.hasOwnProperty(a) && ((n = e[a]), (this[a] = n ? n(o) : o[a]));
            return (
              (this.isDefaultPrevented = (
                null != o.defaultPrevented
                  ? o.defaultPrevented
                  : !1 === o.returnValue
              )
                ? it
                : at),
              (this.isPropagationStopped = at),
              this
            );
          }
          return (
            o(n.prototype, {
              preventDefault: function () {
                this.defaultPrevented = !0;
                var e = this.nativeEvent;
                e &&
                  (e.preventDefault
                    ? e.preventDefault()
                    : "unknown" != typeof e.returnValue && (e.returnValue = !1),
                  (this.isDefaultPrevented = it));
              },
              stopPropagation: function () {
                var e = this.nativeEvent;
                e &&
                  (e.stopPropagation
                    ? e.stopPropagation()
                    : "unknown" != typeof e.cancelBubble &&
                      (e.cancelBubble = !0),
                  (this.isPropagationStopped = it));
              },
              persist: function () {},
              isPersistent: it,
            }),
            n
          );
        }
        var st,
          ct,
          ut,
          dt = {
            eventPhase: 0,
            bubbles: 0,
            cancelable: 0,
            timeStamp: function (e) {
              return e.timeStamp || Date.now();
            },
            defaultPrevented: 0,
            isTrusted: 0,
          },
          pt = lt(dt),
          ft = o({}, dt, { view: 0, detail: 0 }),
          ht = lt(ft),
          mt = o({}, ft, {
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            getModifierState: Et,
            button: 0,
            buttons: 0,
            relatedTarget: function (e) {
              return void 0 === e.relatedTarget
                ? e.fromElement === e.srcElement
                  ? e.toElement
                  : e.fromElement
                : e.relatedTarget;
            },
            movementX: function (e) {
              return "movementX" in e
                ? e.movementX
                : (e !== ut &&
                    (ut && "mousemove" === e.type
                      ? ((st = e.screenX - ut.screenX),
                        (ct = e.screenY - ut.screenY))
                      : (ct = st = 0),
                    (ut = e)),
                  st);
            },
            movementY: function (e) {
              return "movementY" in e ? e.movementY : ct;
            },
          }),
          _t = lt(mt),
          gt = lt(o({}, mt, { dataTransfer: 0 })),
          vt = lt(o({}, ft, { relatedTarget: 0 })),
          Ct = lt(
            o({}, dt, { animationName: 0, elapsedTime: 0, pseudoElement: 0 })
          ),
          bt = o({}, dt, {
            clipboardData: function (e) {
              return "clipboardData" in e
                ? e.clipboardData
                : window.clipboardData;
            },
          }),
          xt = lt(bt),
          yt = lt(o({}, dt, { data: 0 })),
          wt = {
            Esc: "Escape",
            Spacebar: " ",
            Left: "ArrowLeft",
            Up: "ArrowUp",
            Right: "ArrowRight",
            Down: "ArrowDown",
            Del: "Delete",
            Win: "OS",
            Menu: "ContextMenu",
            Apps: "ContextMenu",
            Scroll: "ScrollLock",
            MozPrintableKey: "Unidentified",
          },
          kt = {
            8: "Backspace",
            9: "Tab",
            12: "Clear",
            13: "Enter",
            16: "Shift",
            17: "Control",
            18: "Alt",
            19: "Pause",
            20: "CapsLock",
            27: "Escape",
            32: " ",
            33: "PageUp",
            34: "PageDown",
            35: "End",
            36: "Home",
            37: "ArrowLeft",
            38: "ArrowUp",
            39: "ArrowRight",
            40: "ArrowDown",
            45: "Insert",
            46: "Delete",
            112: "F1",
            113: "F2",
            114: "F3",
            115: "F4",
            116: "F5",
            117: "F6",
            118: "F7",
            119: "F8",
            120: "F9",
            121: "F10",
            122: "F11",
            123: "F12",
            144: "NumLock",
            145: "ScrollLock",
            224: "Meta",
          },
          Lt = {
            Alt: "altKey",
            Control: "ctrlKey",
            Meta: "metaKey",
            Shift: "shiftKey",
          };
        function jt(e) {
          var n = this.nativeEvent;
          return n.getModifierState
            ? n.getModifierState(e)
            : !!(e = Lt[e]) && !!n[e];
        }
        function Et() {
          return jt;
        }
        var St = o({}, ft, {
            key: function (e) {
              if (e.key) {
                var n = wt[e.key] || e.key;
                if ("Unidentified" !== n) return n;
              }
              return "keypress" === e.type
                ? 13 === (e = ot(e))
                  ? "Enter"
                  : String.fromCharCode(e)
                : "keydown" === e.type || "keyup" === e.type
                ? kt[e.keyCode] || "Unidentified"
                : "";
            },
            code: 0,
            location: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            repeat: 0,
            locale: 0,
            getModifierState: Et,
            charCode: function (e) {
              return "keypress" === e.type ? ot(e) : 0;
            },
            keyCode: function (e) {
              return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
            },
            which: function (e) {
              return "keypress" === e.type
                ? ot(e)
                : "keydown" === e.type || "keyup" === e.type
                ? e.keyCode
                : 0;
            },
          }),
          Mt = lt(St),
          Tt = lt(
            o({}, mt, {
              pointerId: 0,
              width: 0,
              height: 0,
              pressure: 0,
              tangentialPressure: 0,
              tiltX: 0,
              tiltY: 0,
              twist: 0,
              pointerType: 0,
              isPrimary: 0,
            })
          ),
          Nt = lt(
            o({}, ft, {
              touches: 0,
              targetTouches: 0,
              changedTouches: 0,
              altKey: 0,
              metaKey: 0,
              ctrlKey: 0,
              shiftKey: 0,
              getModifierState: Et,
            })
          ),
          Ot = lt(
            o({}, dt, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 })
          ),
          At = o({}, mt, {
            deltaX: function (e) {
              return "deltaX" in e
                ? e.deltaX
                : "wheelDeltaX" in e
                ? -e.wheelDeltaX
                : 0;
            },
            deltaY: function (e) {
              return "deltaY" in e
                ? e.deltaY
                : "wheelDeltaY" in e
                ? -e.wheelDeltaY
                : "wheelDelta" in e
                ? -e.wheelDelta
                : 0;
            },
            deltaZ: 0,
            deltaMode: 0,
          }),
          It = lt(At),
          Pt = [9, 13, 27, 32],
          Rt = d && "CompositionEvent" in window,
          Ht = null;
        d && "documentMode" in document && (Ht = document.documentMode);
        var Vt = d && "TextEvent" in window && !Ht,
          Dt = d && (!Rt || (Ht && 8 < Ht && 11 >= Ht)),
          Bt = String.fromCharCode(32),
          Wt = !1;
        function zt(e, n) {
          switch (e) {
            case "keyup":
              return -1 !== Pt.indexOf(n.keyCode);
            case "keydown":
              return 229 !== n.keyCode;
            case "keypress":
            case "mousedown":
            case "focusout":
              return !0;
            default:
              return !1;
          }
        }
        function Zt(e) {
          return "object" == typeof (e = e.detail) && "data" in e
            ? e.data
            : null;
        }
        var Ft = !1,
          Ut = {
            color: !0,
            date: !0,
            datetime: !0,
            "datetime-local": !0,
            email: !0,
            month: !0,
            number: !0,
            password: !0,
            range: !0,
            search: !0,
            tel: !0,
            text: !0,
            time: !0,
            url: !0,
            week: !0,
          };
        function Kt(e) {
          var n = e && e.nodeName && e.nodeName.toLowerCase();
          return "input" === n ? !!Ut[e.type] : "textarea" === n;
        }
        function Gt(e, n, t, r) {
          Te(r),
            0 < (n = Rr(n, "onChange")).length &&
              ((t = new pt("onChange", "change", null, t, r)),
              e.push({ event: t, listeners: n }));
        }
        var Yt = null,
          $t = null;
        function qt(e) {
          Sr(e, 0);
        }
        function Qt(e) {
          if (Q(ro(e))) return e;
        }
        function Xt(e, n) {
          if ("change" === e) return n;
        }
        var Jt = !1;
        if (d) {
          var er;
          if (d) {
            var nr = "oninput" in document;
            if (!nr) {
              var tr = document.createElement("div");
              tr.setAttribute("oninput", "return;"),
                (nr = "function" == typeof tr.oninput);
            }
            er = nr;
          } else er = !1;
          Jt = er && (!document.documentMode || 9 < document.documentMode);
        }
        function rr() {
          Yt && (Yt.detachEvent("onpropertychange", or), ($t = Yt = null));
        }
        function or(e) {
          if ("value" === e.propertyName && Qt($t)) {
            var n = [];
            if ((Gt(n, $t, e, Le(e)), (e = qt), Re)) e(n);
            else {
              Re = !0;
              try {
                Oe(e, n);
              } finally {
                (Re = !1), Ve();
              }
            }
          }
        }
        function ir(e, n, t) {
          "focusin" === e
            ? (rr(), ($t = t), (Yt = n).attachEvent("onpropertychange", or))
            : "focusout" === e && rr();
        }
        function ar(e) {
          if ("selectionchange" === e || "keyup" === e || "keydown" === e)
            return Qt($t);
        }
        function lr(e, n) {
          if ("click" === e) return Qt(n);
        }
        function sr(e, n) {
          if ("input" === e || "change" === e) return Qt(n);
        }
        var cr =
            "function" == typeof Object.is
              ? Object.is
              : function (e, n) {
                  return (
                    (e === n && (0 !== e || 1 / e == 1 / n)) ||
                    (e != e && n != n)
                  );
                },
          ur = Object.prototype.hasOwnProperty;
        function dr(e, n) {
          if (cr(e, n)) return !0;
          if (
            "object" != typeof e ||
            null === e ||
            "object" != typeof n ||
            null === n
          )
            return !1;
          var t = Object.keys(e),
            r = Object.keys(n);
          if (t.length !== r.length) return !1;
          for (r = 0; r < t.length; r++)
            if (!ur.call(n, t[r]) || !cr(e[t[r]], n[t[r]])) return !1;
          return !0;
        }
        function pr(e) {
          for (; e && e.firstChild; ) e = e.firstChild;
          return e;
        }
        function fr(e, n) {
          var t,
            r = pr(e);
          for (e = 0; r; ) {
            if (3 === r.nodeType) {
              if (((t = e + r.textContent.length), e <= n && t >= n))
                return { node: r, offset: n - e };
              e = t;
            }
            e: {
              for (; r; ) {
                if (r.nextSibling) {
                  r = r.nextSibling;
                  break e;
                }
                r = r.parentNode;
              }
              r = void 0;
            }
            r = pr(r);
          }
        }
        function hr(e, n) {
          return (
            !(!e || !n) &&
            (e === n ||
              ((!e || 3 !== e.nodeType) &&
                (n && 3 === n.nodeType
                  ? hr(e, n.parentNode)
                  : "contains" in e
                  ? e.contains(n)
                  : !!e.compareDocumentPosition &&
                    !!(16 & e.compareDocumentPosition(n)))))
          );
        }
        function mr() {
          for (var e = window, n = X(); n instanceof e.HTMLIFrameElement; ) {
            try {
              var t = "string" == typeof n.contentWindow.location.href;
            } catch (e) {
              t = !1;
            }
            if (!t) break;
            n = X((e = n.contentWindow).document);
          }
          return n;
        }
        function _r(e) {
          var n = e && e.nodeName && e.nodeName.toLowerCase();
          return (
            n &&
            (("input" === n &&
              ("text" === e.type ||
                "search" === e.type ||
                "tel" === e.type ||
                "url" === e.type ||
                "password" === e.type)) ||
              "textarea" === n ||
              "true" === e.contentEditable)
          );
        }
        var gr = d && "documentMode" in document && 11 >= document.documentMode,
          vr = null,
          Cr = null,
          br = null,
          xr = !1;
        function yr(e, n, t) {
          var r =
            t.window === t
              ? t.document
              : 9 === t.nodeType
              ? t
              : t.ownerDocument;
          xr ||
            null == vr ||
            vr !== X(r) ||
            ((r =
              "selectionStart" in (r = vr) && _r(r)
                ? { start: r.selectionStart, end: r.selectionEnd }
                : {
                    anchorNode: (r = (
                      (r.ownerDocument && r.ownerDocument.defaultView) ||
                      window
                    ).getSelection()).anchorNode,
                    anchorOffset: r.anchorOffset,
                    focusNode: r.focusNode,
                    focusOffset: r.focusOffset,
                  }),
            (br && dr(br, r)) ||
              ((br = r),
              0 < (r = Rr(Cr, "onSelect")).length &&
                ((n = new pt("onSelect", "select", null, n, t)),
                e.push({ event: n, listeners: r }),
                (n.target = vr))));
        }
        Pn(
          "cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(
            " "
          ),
          0
        ),
          Pn(
            "drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(
              " "
            ),
            1
          ),
          Pn(In, 2);
        for (
          var wr =
              "change selectionchange textInput compositionstart compositionend compositionupdate".split(
                " "
              ),
            kr = 0;
          kr < wr.length;
          kr++
        )
          An.set(wr[kr], 0);
        u("onMouseEnter", ["mouseout", "mouseover"]),
          u("onMouseLeave", ["mouseout", "mouseover"]),
          u("onPointerEnter", ["pointerout", "pointerover"]),
          u("onPointerLeave", ["pointerout", "pointerover"]),
          c(
            "onChange",
            "change click focusin focusout input keydown keyup selectionchange".split(
              " "
            )
          ),
          c(
            "onSelect",
            "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
              " "
            )
          ),
          c("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste",
          ]),
          c(
            "onCompositionEnd",
            "compositionend focusout keydown keypress keyup mousedown".split(
              " "
            )
          ),
          c(
            "onCompositionStart",
            "compositionstart focusout keydown keypress keyup mousedown".split(
              " "
            )
          ),
          c(
            "onCompositionUpdate",
            "compositionupdate focusout keydown keypress keyup mousedown".split(
              " "
            )
          );
        var Lr =
            "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(
              " "
            ),
          jr = new Set(
            "cancel close invalid load scroll toggle".split(" ").concat(Lr)
          );
        function Er(e, n, t) {
          var r = e.type || "unknown-event";
          (e.currentTarget = t),
            (function (e, n, t, r, o, i, l, s, c) {
              if ((Ye.apply(this, arguments), Ze)) {
                if (!Ze) throw Error(a(198));
                var u = Fe;
                (Ze = !1), (Fe = null), Ue || ((Ue = !0), (Ke = u));
              }
            })(r, n, void 0, e),
            (e.currentTarget = null);
        }
        function Sr(e, n) {
          n = 0 != (4 & n);
          for (var t = 0; t < e.length; t++) {
            var r = e[t],
              o = r.event;
            r = r.listeners;
            e: {
              var i = void 0;
              if (n)
                for (var a = r.length - 1; 0 <= a; a--) {
                  var l = r[a],
                    s = l.instance,
                    c = l.currentTarget;
                  if (((l = l.listener), s !== i && o.isPropagationStopped()))
                    break e;
                  Er(o, l, c), (i = s);
                }
              else
                for (a = 0; a < r.length; a++) {
                  if (
                    ((s = (l = r[a]).instance),
                    (c = l.currentTarget),
                    (l = l.listener),
                    s !== i && o.isPropagationStopped())
                  )
                    break e;
                  Er(o, l, c), (i = s);
                }
            }
          }
          if (Ue) throw ((e = Ke), (Ue = !1), (Ke = null), e);
        }
        function Mr(e, n) {
          var t = io(n),
            r = e + "__bubble";
          t.has(r) || (Ar(n, e, 2, !1), t.add(r));
        }
        var Tr = "_reactListening" + Math.random().toString(36).slice(2);
        function Nr(e) {
          e[Tr] ||
            ((e[Tr] = !0),
            l.forEach(function (n) {
              jr.has(n) || Or(n, !1, e, null), Or(n, !0, e, null);
            }));
        }
        function Or(e, n, t, r) {
          var o =
              4 < arguments.length && void 0 !== arguments[4]
                ? arguments[4]
                : 0,
            i = t;
          if (
            ("selectionchange" === e &&
              9 !== t.nodeType &&
              (i = t.ownerDocument),
            null !== r && !n && jr.has(e))
          ) {
            if ("scroll" !== e) return;
            (o |= 2), (i = r);
          }
          var a = io(i),
            l = e + "__" + (n ? "capture" : "bubble");
          a.has(l) || (n && (o |= 4), Ar(i, e, o, n), a.add(l));
        }
        function Ar(e, n, t, r) {
          var o = An.get(n);
          switch (void 0 === o ? 2 : o) {
            case 0:
              o = qn;
              break;
            case 1:
              o = Qn;
              break;
            default:
              o = Xn;
          }
          (t = o.bind(null, n, t, e)),
            (o = void 0),
            !Be ||
              ("touchstart" !== n && "touchmove" !== n && "wheel" !== n) ||
              (o = !0),
            r
              ? void 0 !== o
                ? e.addEventListener(n, t, { capture: !0, passive: o })
                : e.addEventListener(n, t, !0)
              : void 0 !== o
              ? e.addEventListener(n, t, { passive: o })
              : e.addEventListener(n, t, !1);
        }
        function Ir(e, n, t, r, o) {
          var i = r;
          if (0 == (1 & n) && 0 == (2 & n) && null !== r)
            e: for (;;) {
              if (null === r) return;
              var a = r.tag;
              if (3 === a || 4 === a) {
                var l = r.stateNode.containerInfo;
                if (l === o || (8 === l.nodeType && l.parentNode === o)) break;
                if (4 === a)
                  for (a = r.return; null !== a; ) {
                    var s = a.tag;
                    if (
                      (3 === s || 4 === s) &&
                      ((s = a.stateNode.containerInfo) === o ||
                        (8 === s.nodeType && s.parentNode === o))
                    )
                      return;
                    a = a.return;
                  }
                for (; null !== l; ) {
                  if (null === (a = no(l))) return;
                  if (5 === (s = a.tag) || 6 === s) {
                    r = i = a;
                    continue e;
                  }
                  l = l.parentNode;
                }
              }
              r = r.return;
            }
          !(function (e, n, t) {
            if (He) return e();
            He = !0;
            try {
              Pe(e, n, t);
            } finally {
              (He = !1), Ve();
            }
          })(function () {
            var r = i,
              o = Le(t),
              a = [];
            e: {
              var l = On.get(e);
              if (void 0 !== l) {
                var s = pt,
                  c = e;
                switch (e) {
                  case "keypress":
                    if (0 === ot(t)) break e;
                  case "keydown":
                  case "keyup":
                    s = Mt;
                    break;
                  case "focusin":
                    (c = "focus"), (s = vt);
                    break;
                  case "focusout":
                    (c = "blur"), (s = vt);
                    break;
                  case "beforeblur":
                  case "afterblur":
                    s = vt;
                    break;
                  case "click":
                    if (2 === t.button) break e;
                  case "auxclick":
                  case "dblclick":
                  case "mousedown":
                  case "mousemove":
                  case "mouseup":
                  case "mouseout":
                  case "mouseover":
                  case "contextmenu":
                    s = _t;
                    break;
                  case "drag":
                  case "dragend":
                  case "dragenter":
                  case "dragexit":
                  case "dragleave":
                  case "dragover":
                  case "dragstart":
                  case "drop":
                    s = gt;
                    break;
                  case "touchcancel":
                  case "touchend":
                  case "touchmove":
                  case "touchstart":
                    s = Nt;
                    break;
                  case Sn:
                  case Mn:
                  case Tn:
                    s = Ct;
                    break;
                  case Nn:
                    s = Ot;
                    break;
                  case "scroll":
                    s = ht;
                    break;
                  case "wheel":
                    s = It;
                    break;
                  case "copy":
                  case "cut":
                  case "paste":
                    s = xt;
                    break;
                  case "gotpointercapture":
                  case "lostpointercapture":
                  case "pointercancel":
                  case "pointerdown":
                  case "pointermove":
                  case "pointerout":
                  case "pointerover":
                  case "pointerup":
                    s = Tt;
                }
                var u = 0 != (4 & n),
                  d = !u && "scroll" === e,
                  p = u ? (null !== l ? l + "Capture" : null) : l;
                u = [];
                for (var f, h = r; null !== h; ) {
                  var m = (f = h).stateNode;
                  if (
                    (5 === f.tag &&
                      null !== m &&
                      ((f = m),
                      null !== p &&
                        null != (m = De(h, p)) &&
                        u.push(Pr(h, m, f))),
                    d)
                  )
                    break;
                  h = h.return;
                }
                0 < u.length &&
                  ((l = new s(l, c, null, t, o)),
                  a.push({ event: l, listeners: u }));
              }
            }
            if (0 == (7 & n)) {
              if (
                ((s = "mouseout" === e || "pointerout" === e),
                (!(l = "mouseover" === e || "pointerover" === e) ||
                  0 != (16 & n) ||
                  !(c = t.relatedTarget || t.fromElement) ||
                  (!no(c) && !c[Jr])) &&
                  (s || l) &&
                  ((l =
                    o.window === o
                      ? o
                      : (l = o.ownerDocument)
                      ? l.defaultView || l.parentWindow
                      : window),
                  s
                    ? ((s = r),
                      null !==
                        (c = (c = t.relatedTarget || t.toElement)
                          ? no(c)
                          : null) &&
                        (c !== (d = $e(c)) || (5 !== c.tag && 6 !== c.tag)) &&
                        (c = null))
                    : ((s = null), (c = r)),
                  s !== c))
              ) {
                if (
                  ((u = _t),
                  (m = "onMouseLeave"),
                  (p = "onMouseEnter"),
                  (h = "mouse"),
                  ("pointerout" !== e && "pointerover" !== e) ||
                    ((u = Tt),
                    (m = "onPointerLeave"),
                    (p = "onPointerEnter"),
                    (h = "pointer")),
                  (d = null == s ? l : ro(s)),
                  (f = null == c ? l : ro(c)),
                  ((l = new u(m, h + "leave", s, t, o)).target = d),
                  (l.relatedTarget = f),
                  (m = null),
                  no(o) === r &&
                    (((u = new u(p, h + "enter", c, t, o)).target = f),
                    (u.relatedTarget = d),
                    (m = u)),
                  (d = m),
                  s && c)
                )
                  e: {
                    for (p = c, h = 0, f = u = s; f; f = Hr(f)) h++;
                    for (f = 0, m = p; m; m = Hr(m)) f++;
                    for (; 0 < h - f; ) (u = Hr(u)), h--;
                    for (; 0 < f - h; ) (p = Hr(p)), f--;
                    for (; h--; ) {
                      if (u === p || (null !== p && u === p.alternate)) break e;
                      (u = Hr(u)), (p = Hr(p));
                    }
                    u = null;
                  }
                else u = null;
                null !== s && Vr(a, l, s, u, !1),
                  null !== c && null !== d && Vr(a, d, c, u, !0);
              }
              if (
                "select" ===
                  (s =
                    (l = r ? ro(r) : window).nodeName &&
                    l.nodeName.toLowerCase()) ||
                ("input" === s && "file" === l.type)
              )
                var _ = Xt;
              else if (Kt(l))
                if (Jt) _ = sr;
                else {
                  _ = ar;
                  var g = ir;
                }
              else
                (s = l.nodeName) &&
                  "input" === s.toLowerCase() &&
                  ("checkbox" === l.type || "radio" === l.type) &&
                  (_ = lr);
              switch (
                (_ && (_ = _(e, r))
                  ? Gt(a, _, t, o)
                  : (g && g(e, l, r),
                    "focusout" === e &&
                      (g = l._wrapperState) &&
                      g.controlled &&
                      "number" === l.type &&
                      oe(l, "number", l.value)),
                (g = r ? ro(r) : window),
                e)
              ) {
                case "focusin":
                  (Kt(g) || "true" === g.contentEditable) &&
                    ((vr = g), (Cr = r), (br = null));
                  break;
                case "focusout":
                  br = Cr = vr = null;
                  break;
                case "mousedown":
                  xr = !0;
                  break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                  (xr = !1), yr(a, t, o);
                  break;
                case "selectionchange":
                  if (gr) break;
                case "keydown":
                case "keyup":
                  yr(a, t, o);
              }
              var v;
              if (Rt)
                e: {
                  switch (e) {
                    case "compositionstart":
                      var C = "onCompositionStart";
                      break e;
                    case "compositionend":
                      C = "onCompositionEnd";
                      break e;
                    case "compositionupdate":
                      C = "onCompositionUpdate";
                      break e;
                  }
                  C = void 0;
                }
              else
                Ft
                  ? zt(e, t) && (C = "onCompositionEnd")
                  : "keydown" === e &&
                    229 === t.keyCode &&
                    (C = "onCompositionStart");
              C &&
                (Dt &&
                  "ko" !== t.locale &&
                  (Ft || "onCompositionStart" !== C
                    ? "onCompositionEnd" === C && Ft && (v = rt())
                    : ((nt = "value" in (et = o) ? et.value : et.textContent),
                      (Ft = !0))),
                0 < (g = Rr(r, C)).length &&
                  ((C = new yt(C, e, null, t, o)),
                  a.push({ event: C, listeners: g }),
                  (v || null !== (v = Zt(t))) && (C.data = v))),
                (v = Vt
                  ? (function (e, n) {
                      switch (e) {
                        case "compositionend":
                          return Zt(n);
                        case "keypress":
                          return 32 !== n.which ? null : ((Wt = !0), Bt);
                        case "textInput":
                          return (e = n.data) === Bt && Wt ? null : e;
                        default:
                          return null;
                      }
                    })(e, t)
                  : (function (e, n) {
                      if (Ft)
                        return "compositionend" === e || (!Rt && zt(e, n))
                          ? ((e = rt()), (tt = nt = et = null), (Ft = !1), e)
                          : null;
                      switch (e) {
                        case "paste":
                        default:
                          return null;
                        case "keypress":
                          if (
                            !(n.ctrlKey || n.altKey || n.metaKey) ||
                            (n.ctrlKey && n.altKey)
                          ) {
                            if (n.char && 1 < n.char.length) return n.char;
                            if (n.which) return String.fromCharCode(n.which);
                          }
                          return null;
                        case "compositionend":
                          return Dt && "ko" !== n.locale ? null : n.data;
                      }
                    })(e, t)) &&
                  0 < (r = Rr(r, "onBeforeInput")).length &&
                  ((o = new yt("onBeforeInput", "beforeinput", null, t, o)),
                  a.push({ event: o, listeners: r }),
                  (o.data = v));
            }
            Sr(a, n);
          });
        }
        function Pr(e, n, t) {
          return { instance: e, listener: n, currentTarget: t };
        }
        function Rr(e, n) {
          for (var t = n + "Capture", r = []; null !== e; ) {
            var o = e,
              i = o.stateNode;
            5 === o.tag &&
              null !== i &&
              ((o = i),
              null != (i = De(e, t)) && r.unshift(Pr(e, i, o)),
              null != (i = De(e, n)) && r.push(Pr(e, i, o))),
              (e = e.return);
          }
          return r;
        }
        function Hr(e) {
          if (null === e) return null;
          do {
            e = e.return;
          } while (e && 5 !== e.tag);
          return e || null;
        }
        function Vr(e, n, t, r, o) {
          for (var i = n._reactName, a = []; null !== t && t !== r; ) {
            var l = t,
              s = l.alternate,
              c = l.stateNode;
            if (null !== s && s === r) break;
            5 === l.tag &&
              null !== c &&
              ((l = c),
              o
                ? null != (s = De(t, i)) && a.unshift(Pr(t, s, l))
                : o || (null != (s = De(t, i)) && a.push(Pr(t, s, l)))),
              (t = t.return);
          }
          0 !== a.length && e.push({ event: n, listeners: a });
        }
        function Dr() {}
        var Br = null,
          Wr = null;
        function zr(e, n) {
          switch (e) {
            case "button":
            case "input":
            case "select":
            case "textarea":
              return !!n.autoFocus;
          }
          return !1;
        }
        function Zr(e, n) {
          return (
            "textarea" === e ||
            "option" === e ||
            "noscript" === e ||
            "string" == typeof n.children ||
            "number" == typeof n.children ||
            ("object" == typeof n.dangerouslySetInnerHTML &&
              null !== n.dangerouslySetInnerHTML &&
              null != n.dangerouslySetInnerHTML.__html)
          );
        }
        var Fr = "function" == typeof setTimeout ? setTimeout : void 0,
          Ur = "function" == typeof clearTimeout ? clearTimeout : void 0;
        function Kr(e) {
          (1 === e.nodeType || (9 === e.nodeType && null != (e = e.body))) &&
            (e.textContent = "");
        }
        function Gr(e) {
          for (; null != e; e = e.nextSibling) {
            var n = e.nodeType;
            if (1 === n || 3 === n) break;
          }
          return e;
        }
        function Yr(e) {
          e = e.previousSibling;
          for (var n = 0; e; ) {
            if (8 === e.nodeType) {
              var t = e.data;
              if ("$" === t || "$!" === t || "$?" === t) {
                if (0 === n) return e;
                n--;
              } else "/$" === t && n++;
            }
            e = e.previousSibling;
          }
          return null;
        }
        var $r = 0,
          qr = Math.random().toString(36).slice(2),
          Qr = "__reactFiber$" + qr,
          Xr = "__reactProps$" + qr,
          Jr = "__reactContainer$" + qr,
          eo = "__reactEvents$" + qr;
        function no(e) {
          var n = e[Qr];
          if (n) return n;
          for (var t = e.parentNode; t; ) {
            if ((n = t[Jr] || t[Qr])) {
              if (
                ((t = n.alternate),
                null !== n.child || (null !== t && null !== t.child))
              )
                for (e = Yr(e); null !== e; ) {
                  if ((t = e[Qr])) return t;
                  e = Yr(e);
                }
              return n;
            }
            t = (e = t).parentNode;
          }
          return null;
        }
        function to(e) {
          return !(e = e[Qr] || e[Jr]) ||
            (5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag)
            ? null
            : e;
        }
        function ro(e) {
          if (5 === e.tag || 6 === e.tag) return e.stateNode;
          throw Error(a(33));
        }
        function oo(e) {
          return e[Xr] || null;
        }
        function io(e) {
          var n = e[eo];
          return void 0 === n && (n = e[eo] = new Set()), n;
        }
        var ao = [],
          lo = -1;
        function so(e) {
          return { current: e };
        }
        function co(e) {
          0 > lo || ((e.current = ao[lo]), (ao[lo] = null), lo--);
        }
        function uo(e, n) {
          lo++, (ao[lo] = e.current), (e.current = n);
        }
        var po = {},
          fo = so(po),
          ho = so(!1),
          mo = po;
        function _o(e, n) {
          var t = e.type.contextTypes;
          if (!t) return po;
          var r = e.stateNode;
          if (r && r.__reactInternalMemoizedUnmaskedChildContext === n)
            return r.__reactInternalMemoizedMaskedChildContext;
          var o,
            i = {};
          for (o in t) i[o] = n[o];
          return (
            r &&
              (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext =
                n),
              (e.__reactInternalMemoizedMaskedChildContext = i)),
            i
          );
        }
        function go(e) {
          return null != e.childContextTypes;
        }
        function vo() {
          co(ho), co(fo);
        }
        function Co(e, n, t) {
          if (fo.current !== po) throw Error(a(168));
          uo(fo, n), uo(ho, t);
        }
        function bo(e, n, t) {
          var r = e.stateNode;
          if (
            ((e = n.childContextTypes), "function" != typeof r.getChildContext)
          )
            return t;
          for (var i in (r = r.getChildContext()))
            if (!(i in e)) throw Error(a(108, G(n) || "Unknown", i));
          return o({}, t, r);
        }
        function xo(e) {
          return (
            (e =
              ((e = e.stateNode) &&
                e.__reactInternalMemoizedMergedChildContext) ||
              po),
            (mo = fo.current),
            uo(fo, e),
            uo(ho, ho.current),
            !0
          );
        }
        function yo(e, n, t) {
          var r = e.stateNode;
          if (!r) throw Error(a(169));
          t
            ? ((e = bo(e, n, mo)),
              (r.__reactInternalMemoizedMergedChildContext = e),
              co(ho),
              co(fo),
              uo(fo, e))
            : co(ho),
            uo(ho, t);
        }
        var wo = null,
          ko = null,
          Lo = i.unstable_runWithPriority,
          jo = i.unstable_scheduleCallback,
          Eo = i.unstable_cancelCallback,
          So = i.unstable_shouldYield,
          Mo = i.unstable_requestPaint,
          To = i.unstable_now,
          No = i.unstable_getCurrentPriorityLevel,
          Oo = i.unstable_ImmediatePriority,
          Ao = i.unstable_UserBlockingPriority,
          Io = i.unstable_NormalPriority,
          Po = i.unstable_LowPriority,
          Ro = i.unstable_IdlePriority,
          Ho = {},
          Vo = void 0 !== Mo ? Mo : function () {},
          Do = null,
          Bo = null,
          Wo = !1,
          zo = To(),
          Zo =
            1e4 > zo
              ? To
              : function () {
                  return To() - zo;
                };
        function Fo() {
          switch (No()) {
            case Oo:
              return 99;
            case Ao:
              return 98;
            case Io:
              return 97;
            case Po:
              return 96;
            case Ro:
              return 95;
            default:
              throw Error(a(332));
          }
        }
        function Uo(e) {
          switch (e) {
            case 99:
              return Oo;
            case 98:
              return Ao;
            case 97:
              return Io;
            case 96:
              return Po;
            case 95:
              return Ro;
            default:
              throw Error(a(332));
          }
        }
        function Ko(e, n) {
          return (e = Uo(e)), Lo(e, n);
        }
        function Go(e, n, t) {
          return (e = Uo(e)), jo(e, n, t);
        }
        function Yo() {
          if (null !== Bo) {
            var e = Bo;
            (Bo = null), Eo(e);
          }
          $o();
        }
        function $o() {
          if (!Wo && null !== Do) {
            Wo = !0;
            var e = 0;
            try {
              var n = Do;
              Ko(99, function () {
                for (; e < n.length; e++) {
                  var t = n[e];
                  do {
                    t = t(!0);
                  } while (null !== t);
                }
              }),
                (Do = null);
            } catch (n) {
              throw (null !== Do && (Do = Do.slice(e + 1)), jo(Oo, Yo), n);
            } finally {
              Wo = !1;
            }
          }
        }
        var qo = x.ReactCurrentBatchConfig;
        function Qo(e, n) {
          if (e && e.defaultProps) {
            for (var t in ((n = o({}, n)), (e = e.defaultProps)))
              void 0 === n[t] && (n[t] = e[t]);
            return n;
          }
          return n;
        }
        var Xo = so(null),
          Jo = null,
          ei = null,
          ni = null;
        function ti() {
          ni = ei = Jo = null;
        }
        function ri(e) {
          var n = Xo.current;
          co(Xo), (e.type._context._currentValue = n);
        }
        function oi(e, n) {
          for (; null !== e; ) {
            var t = e.alternate;
            if ((e.childLanes & n) === n) {
              if (null === t || (t.childLanes & n) === n) break;
              t.childLanes |= n;
            } else (e.childLanes |= n), null !== t && (t.childLanes |= n);
            e = e.return;
          }
        }
        function ii(e, n) {
          (Jo = e),
            (ni = ei = null),
            null !== (e = e.dependencies) &&
              null !== e.firstContext &&
              (0 != (e.lanes & n) && (Ra = !0), (e.firstContext = null));
        }
        function ai(e, n) {
          if (ni !== e && !1 !== n && 0 !== n)
            if (
              (("number" == typeof n && 1073741823 !== n) ||
                ((ni = e), (n = 1073741823)),
              (n = { context: e, observedBits: n, next: null }),
              null === ei)
            ) {
              if (null === Jo) throw Error(a(308));
              (ei = n),
                (Jo.dependencies = {
                  lanes: 0,
                  firstContext: n,
                  responders: null,
                });
            } else ei = ei.next = n;
          return e._currentValue;
        }
        var li = !1;
        function si(e) {
          e.updateQueue = {
            baseState: e.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: { pending: null },
            effects: null,
          };
        }
        function ci(e, n) {
          (e = e.updateQueue),
            n.updateQueue === e &&
              (n.updateQueue = {
                baseState: e.baseState,
                firstBaseUpdate: e.firstBaseUpdate,
                lastBaseUpdate: e.lastBaseUpdate,
                shared: e.shared,
                effects: e.effects,
              });
        }
        function ui(e, n) {
          return {
            eventTime: e,
            lane: n,
            tag: 0,
            payload: null,
            callback: null,
            next: null,
          };
        }
        function di(e, n) {
          if (null !== (e = e.updateQueue)) {
            var t = (e = e.shared).pending;
            null === t ? (n.next = n) : ((n.next = t.next), (t.next = n)),
              (e.pending = n);
          }
        }
        function pi(e, n) {
          var t = e.updateQueue,
            r = e.alternate;
          if (null !== r && t === (r = r.updateQueue)) {
            var o = null,
              i = null;
            if (null !== (t = t.firstBaseUpdate)) {
              do {
                var a = {
                  eventTime: t.eventTime,
                  lane: t.lane,
                  tag: t.tag,
                  payload: t.payload,
                  callback: t.callback,
                  next: null,
                };
                null === i ? (o = i = a) : (i = i.next = a), (t = t.next);
              } while (null !== t);
              null === i ? (o = i = n) : (i = i.next = n);
            } else o = i = n;
            return (
              (t = {
                baseState: r.baseState,
                firstBaseUpdate: o,
                lastBaseUpdate: i,
                shared: r.shared,
                effects: r.effects,
              }),
              void (e.updateQueue = t)
            );
          }
          null === (e = t.lastBaseUpdate)
            ? (t.firstBaseUpdate = n)
            : (e.next = n),
            (t.lastBaseUpdate = n);
        }
        function fi(e, n, t, r) {
          var i = e.updateQueue;
          li = !1;
          var a = i.firstBaseUpdate,
            l = i.lastBaseUpdate,
            s = i.shared.pending;
          if (null !== s) {
            i.shared.pending = null;
            var c = s,
              u = c.next;
            (c.next = null), null === l ? (a = u) : (l.next = u), (l = c);
            var d = e.alternate;
            if (null !== d) {
              var p = (d = d.updateQueue).lastBaseUpdate;
              p !== l &&
                (null === p ? (d.firstBaseUpdate = u) : (p.next = u),
                (d.lastBaseUpdate = c));
            }
          }
          if (null !== a) {
            for (p = i.baseState, l = 0, d = u = c = null; ; ) {
              s = a.lane;
              var f = a.eventTime;
              if ((r & s) === s) {
                null !== d &&
                  (d = d.next =
                    {
                      eventTime: f,
                      lane: 0,
                      tag: a.tag,
                      payload: a.payload,
                      callback: a.callback,
                      next: null,
                    });
                e: {
                  var h = e,
                    m = a;
                  switch (((s = n), (f = t), m.tag)) {
                    case 1:
                      if ("function" == typeof (h = m.payload)) {
                        p = h.call(f, p, s);
                        break e;
                      }
                      p = h;
                      break e;
                    case 3:
                      h.flags = (-4097 & h.flags) | 64;
                    case 0:
                      if (
                        null ==
                        (s =
                          "function" == typeof (h = m.payload)
                            ? h.call(f, p, s)
                            : h)
                      )
                        break e;
                      p = o({}, p, s);
                      break e;
                    case 2:
                      li = !0;
                  }
                }
                null !== a.callback &&
                  ((e.flags |= 32),
                  null === (s = i.effects) ? (i.effects = [a]) : s.push(a));
              } else
                (f = {
                  eventTime: f,
                  lane: s,
                  tag: a.tag,
                  payload: a.payload,
                  callback: a.callback,
                  next: null,
                }),
                  null === d ? ((u = d = f), (c = p)) : (d = d.next = f),
                  (l |= s);
              if (null === (a = a.next)) {
                if (null === (s = i.shared.pending)) break;
                (a = s.next),
                  (s.next = null),
                  (i.lastBaseUpdate = s),
                  (i.shared.pending = null);
              }
            }
            null === d && (c = p),
              (i.baseState = c),
              (i.firstBaseUpdate = u),
              (i.lastBaseUpdate = d),
              (Vl |= l),
              (e.lanes = l),
              (e.memoizedState = p);
          }
        }
        function hi(e, n, t) {
          if (((e = n.effects), (n.effects = null), null !== e))
            for (n = 0; n < e.length; n++) {
              var r = e[n],
                o = r.callback;
              if (null !== o) {
                if (((r.callback = null), (r = t), "function" != typeof o))
                  throw Error(a(191, o));
                o.call(r);
              }
            }
        }
        var mi = new r.Component().refs;
        function _i(e, n, t, r) {
          (t = null == (t = t(r, (n = e.memoizedState))) ? n : o({}, n, t)),
            (e.memoizedState = t),
            0 === e.lanes && (e.updateQueue.baseState = t);
        }
        var gi = {
          isMounted: function (e) {
            return !!(e = e._reactInternals) && $e(e) === e;
          },
          enqueueSetState: function (e, n, t) {
            e = e._reactInternals;
            var r = cs(),
              o = us(e),
              i = ui(r, o);
            (i.payload = n),
              null != t && (i.callback = t),
              di(e, i),
              ds(e, o, r);
          },
          enqueueReplaceState: function (e, n, t) {
            e = e._reactInternals;
            var r = cs(),
              o = us(e),
              i = ui(r, o);
            (i.tag = 1),
              (i.payload = n),
              null != t && (i.callback = t),
              di(e, i),
              ds(e, o, r);
          },
          enqueueForceUpdate: function (e, n) {
            e = e._reactInternals;
            var t = cs(),
              r = us(e),
              o = ui(t, r);
            (o.tag = 2), null != n && (o.callback = n), di(e, o), ds(e, r, t);
          },
        };
        function vi(e, n, t, r, o, i, a) {
          return "function" == typeof (e = e.stateNode).shouldComponentUpdate
            ? e.shouldComponentUpdate(r, i, a)
            : !(
                n.prototype &&
                n.prototype.isPureReactComponent &&
                dr(t, r) &&
                dr(o, i)
              );
        }
        function Ci(e, n, t) {
          var r = !1,
            o = po,
            i = n.contextType;
          return (
            "object" == typeof i && null !== i
              ? (i = ai(i))
              : ((o = go(n) ? mo : fo.current),
                (i = (r = null != (r = n.contextTypes)) ? _o(e, o) : po)),
            (n = new n(t, i)),
            (e.memoizedState =
              null !== n.state && void 0 !== n.state ? n.state : null),
            (n.updater = gi),
            (e.stateNode = n),
            (n._reactInternals = e),
            r &&
              (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext =
                o),
              (e.__reactInternalMemoizedMaskedChildContext = i)),
            n
          );
        }
        function bi(e, n, t, r) {
          (e = n.state),
            "function" == typeof n.componentWillReceiveProps &&
              n.componentWillReceiveProps(t, r),
            "function" == typeof n.UNSAFE_componentWillReceiveProps &&
              n.UNSAFE_componentWillReceiveProps(t, r),
            n.state !== e && gi.enqueueReplaceState(n, n.state, null);
        }
        function xi(e, n, t, r) {
          var o = e.stateNode;
          (o.props = t), (o.state = e.memoizedState), (o.refs = mi), si(e);
          var i = n.contextType;
          "object" == typeof i && null !== i
            ? (o.context = ai(i))
            : ((i = go(n) ? mo : fo.current), (o.context = _o(e, i))),
            fi(e, t, o, r),
            (o.state = e.memoizedState),
            "function" == typeof (i = n.getDerivedStateFromProps) &&
              (_i(e, n, i, t), (o.state = e.memoizedState)),
            "function" == typeof n.getDerivedStateFromProps ||
              "function" == typeof o.getSnapshotBeforeUpdate ||
              ("function" != typeof o.UNSAFE_componentWillMount &&
                "function" != typeof o.componentWillMount) ||
              ((n = o.state),
              "function" == typeof o.componentWillMount &&
                o.componentWillMount(),
              "function" == typeof o.UNSAFE_componentWillMount &&
                o.UNSAFE_componentWillMount(),
              n !== o.state && gi.enqueueReplaceState(o, o.state, null),
              fi(e, t, o, r),
              (o.state = e.memoizedState)),
            "function" == typeof o.componentDidMount && (e.flags |= 4);
        }
        var yi = Array.isArray;
        function wi(e, n, t) {
          if (
            null !== (e = t.ref) &&
            "function" != typeof e &&
            "object" != typeof e
          ) {
            if (t._owner) {
              if ((t = t._owner)) {
                if (1 !== t.tag) throw Error(a(309));
                var r = t.stateNode;
              }
              if (!r) throw Error(a(147, e));
              var o = "" + e;
              return null !== n &&
                null !== n.ref &&
                "function" == typeof n.ref &&
                n.ref._stringRef === o
                ? n.ref
                : ((n = function (e) {
                    var n = r.refs;
                    n === mi && (n = r.refs = {}),
                      null === e ? delete n[o] : (n[o] = e);
                  }),
                  (n._stringRef = o),
                  n);
            }
            if ("string" != typeof e) throw Error(a(284));
            if (!t._owner) throw Error(a(290, e));
          }
          return e;
        }
        function ki(e, n) {
          if ("textarea" !== e.type)
            throw Error(
              a(
                31,
                "[object Object]" === Object.prototype.toString.call(n)
                  ? "object with keys {" + Object.keys(n).join(", ") + "}"
                  : n
              )
            );
        }
        function Li(e) {
          function n(n, t) {
            if (e) {
              var r = n.lastEffect;
              null !== r
                ? ((r.nextEffect = t), (n.lastEffect = t))
                : (n.firstEffect = n.lastEffect = t),
                (t.nextEffect = null),
                (t.flags = 8);
            }
          }
          function t(t, r) {
            if (!e) return null;
            for (; null !== r; ) n(t, r), (r = r.sibling);
            return null;
          }
          function r(e, n) {
            for (e = new Map(); null !== n; )
              null !== n.key ? e.set(n.key, n) : e.set(n.index, n),
                (n = n.sibling);
            return e;
          }
          function o(e, n) {
            return ((e = Zs(e, n)).index = 0), (e.sibling = null), e;
          }
          function i(n, t, r) {
            return (
              (n.index = r),
              e
                ? null !== (r = n.alternate)
                  ? (r = r.index) < t
                    ? ((n.flags = 2), t)
                    : r
                  : ((n.flags = 2), t)
                : t
            );
          }
          function l(n) {
            return e && null === n.alternate && (n.flags = 2), n;
          }
          function s(e, n, t, r) {
            return null === n || 6 !== n.tag
              ? (((n = Gs(t, e.mode, r)).return = e), n)
              : (((n = o(n, t)).return = e), n);
          }
          function c(e, n, t, r) {
            return null !== n && n.elementType === t.type
              ? (((r = o(n, t.props)).ref = wi(e, n, t)), (r.return = e), r)
              : (((r = Fs(t.type, t.key, t.props, null, e.mode, r)).ref = wi(
                  e,
                  n,
                  t
                )),
                (r.return = e),
                r);
          }
          function u(e, n, t, r) {
            return null === n ||
              4 !== n.tag ||
              n.stateNode.containerInfo !== t.containerInfo ||
              n.stateNode.implementation !== t.implementation
              ? (((n = Ys(t, e.mode, r)).return = e), n)
              : (((n = o(n, t.children || [])).return = e), n);
          }
          function d(e, n, t, r, i) {
            return null === n || 7 !== n.tag
              ? (((n = Us(t, e.mode, r, i)).return = e), n)
              : (((n = o(n, t)).return = e), n);
          }
          function p(e, n, t) {
            if ("string" == typeof n || "number" == typeof n)
              return ((n = Gs("" + n, e.mode, t)).return = e), n;
            if ("object" == typeof n && null !== n) {
              switch (n.$$typeof) {
                case y:
                  return (
                    ((t = Fs(n.type, n.key, n.props, null, e.mode, t)).ref = wi(
                      e,
                      null,
                      n
                    )),
                    (t.return = e),
                    t
                  );
                case w:
                  return ((n = Ys(n, e.mode, t)).return = e), n;
              }
              if (yi(n) || z(n))
                return ((n = Us(n, e.mode, t, null)).return = e), n;
              ki(e, n);
            }
            return null;
          }
          function f(e, n, t, r) {
            var o = null !== n ? n.key : null;
            if ("string" == typeof t || "number" == typeof t)
              return null !== o ? null : s(e, n, "" + t, r);
            if ("object" == typeof t && null !== t) {
              switch (t.$$typeof) {
                case y:
                  return t.key === o
                    ? t.type === k
                      ? d(e, n, t.props.children, r, o)
                      : c(e, n, t, r)
                    : null;
                case w:
                  return t.key === o ? u(e, n, t, r) : null;
              }
              if (yi(t) || z(t)) return null !== o ? null : d(e, n, t, r, null);
              ki(e, t);
            }
            return null;
          }
          function h(e, n, t, r, o) {
            if ("string" == typeof r || "number" == typeof r)
              return s(n, (e = e.get(t) || null), "" + r, o);
            if ("object" == typeof r && null !== r) {
              switch (r.$$typeof) {
                case y:
                  return (
                    (e = e.get(null === r.key ? t : r.key) || null),
                    r.type === k
                      ? d(n, e, r.props.children, o, r.key)
                      : c(n, e, r, o)
                  );
                case w:
                  return u(
                    n,
                    (e = e.get(null === r.key ? t : r.key) || null),
                    r,
                    o
                  );
              }
              if (yi(r) || z(r))
                return d(n, (e = e.get(t) || null), r, o, null);
              ki(n, r);
            }
            return null;
          }
          function m(o, a, l, s) {
            for (
              var c = null, u = null, d = a, m = (a = 0), _ = null;
              null !== d && m < l.length;
              m++
            ) {
              d.index > m ? ((_ = d), (d = null)) : (_ = d.sibling);
              var g = f(o, d, l[m], s);
              if (null === g) {
                null === d && (d = _);
                break;
              }
              e && d && null === g.alternate && n(o, d),
                (a = i(g, a, m)),
                null === u ? (c = g) : (u.sibling = g),
                (u = g),
                (d = _);
            }
            if (m === l.length) return t(o, d), c;
            if (null === d) {
              for (; m < l.length; m++)
                null !== (d = p(o, l[m], s)) &&
                  ((a = i(d, a, m)),
                  null === u ? (c = d) : (u.sibling = d),
                  (u = d));
              return c;
            }
            for (d = r(o, d); m < l.length; m++)
              null !== (_ = h(d, o, m, l[m], s)) &&
                (e &&
                  null !== _.alternate &&
                  d.delete(null === _.key ? m : _.key),
                (a = i(_, a, m)),
                null === u ? (c = _) : (u.sibling = _),
                (u = _));
            return (
              e &&
                d.forEach(function (e) {
                  return n(o, e);
                }),
              c
            );
          }
          function _(o, l, s, c) {
            var u = z(s);
            if ("function" != typeof u) throw Error(a(150));
            if (null == (s = u.call(s))) throw Error(a(151));
            for (
              var d = (u = null), m = l, _ = (l = 0), g = null, v = s.next();
              null !== m && !v.done;
              _++, v = s.next()
            ) {
              m.index > _ ? ((g = m), (m = null)) : (g = m.sibling);
              var C = f(o, m, v.value, c);
              if (null === C) {
                null === m && (m = g);
                break;
              }
              e && m && null === C.alternate && n(o, m),
                (l = i(C, l, _)),
                null === d ? (u = C) : (d.sibling = C),
                (d = C),
                (m = g);
            }
            if (v.done) return t(o, m), u;
            if (null === m) {
              for (; !v.done; _++, v = s.next())
                null !== (v = p(o, v.value, c)) &&
                  ((l = i(v, l, _)),
                  null === d ? (u = v) : (d.sibling = v),
                  (d = v));
              return u;
            }
            for (m = r(o, m); !v.done; _++, v = s.next())
              null !== (v = h(m, o, _, v.value, c)) &&
                (e &&
                  null !== v.alternate &&
                  m.delete(null === v.key ? _ : v.key),
                (l = i(v, l, _)),
                null === d ? (u = v) : (d.sibling = v),
                (d = v));
            return (
              e &&
                m.forEach(function (e) {
                  return n(o, e);
                }),
              u
            );
          }
          return function (e, r, i, s) {
            var c =
              "object" == typeof i &&
              null !== i &&
              i.type === k &&
              null === i.key;
            c && (i = i.props.children);
            var u = "object" == typeof i && null !== i;
            if (u)
              switch (i.$$typeof) {
                case y:
                  e: {
                    for (u = i.key, c = r; null !== c; ) {
                      if (c.key === u) {
                        if (7 === c.tag) {
                          if (i.type === k) {
                            t(e, c.sibling),
                              ((r = o(c, i.props.children)).return = e),
                              (e = r);
                            break e;
                          }
                        } else if (c.elementType === i.type) {
                          t(e, c.sibling),
                            ((r = o(c, i.props)).ref = wi(e, c, i)),
                            (r.return = e),
                            (e = r);
                          break e;
                        }
                        t(e, c);
                        break;
                      }
                      n(e, c), (c = c.sibling);
                    }
                    i.type === k
                      ? (((r = Us(i.props.children, e.mode, s, i.key)).return =
                          e),
                        (e = r))
                      : (((s = Fs(
                          i.type,
                          i.key,
                          i.props,
                          null,
                          e.mode,
                          s
                        )).ref = wi(e, r, i)),
                        (s.return = e),
                        (e = s));
                  }
                  return l(e);
                case w:
                  e: {
                    for (c = i.key; null !== r; ) {
                      if (r.key === c) {
                        if (
                          4 === r.tag &&
                          r.stateNode.containerInfo === i.containerInfo &&
                          r.stateNode.implementation === i.implementation
                        ) {
                          t(e, r.sibling),
                            ((r = o(r, i.children || [])).return = e),
                            (e = r);
                          break e;
                        }
                        t(e, r);
                        break;
                      }
                      n(e, r), (r = r.sibling);
                    }
                    ((r = Ys(i, e.mode, s)).return = e), (e = r);
                  }
                  return l(e);
              }
            if ("string" == typeof i || "number" == typeof i)
              return (
                (i = "" + i),
                null !== r && 6 === r.tag
                  ? (t(e, r.sibling), ((r = o(r, i)).return = e), (e = r))
                  : (t(e, r), ((r = Gs(i, e.mode, s)).return = e), (e = r)),
                l(e)
              );
            if (yi(i)) return m(e, r, i, s);
            if (z(i)) return _(e, r, i, s);
            if ((u && ki(e, i), void 0 === i && !c))
              switch (e.tag) {
                case 1:
                case 22:
                case 0:
                case 11:
                case 15:
                  throw Error(a(152, G(e.type) || "Component"));
              }
            return t(e, r);
          };
        }
        var ji = Li(!0),
          Ei = Li(!1),
          Si = {},
          Mi = so(Si),
          Ti = so(Si),
          Ni = so(Si);
        function Oi(e) {
          if (e === Si) throw Error(a(174));
          return e;
        }
        function Ai(e, n) {
          switch ((uo(Ni, n), uo(Ti, e), uo(Mi, Si), (e = n.nodeType))) {
            case 9:
            case 11:
              n = (n = n.documentElement) ? n.namespaceURI : fe(null, "");
              break;
            default:
              n = fe(
                (n = (e = 8 === e ? n.parentNode : n).namespaceURI || null),
                (e = e.tagName)
              );
          }
          co(Mi), uo(Mi, n);
        }
        function Ii() {
          co(Mi), co(Ti), co(Ni);
        }
        function Pi(e) {
          Oi(Ni.current);
          var n = Oi(Mi.current),
            t = fe(n, e.type);
          n !== t && (uo(Ti, e), uo(Mi, t));
        }
        function Ri(e) {
          Ti.current === e && (co(Mi), co(Ti));
        }
        var Hi = so(0);
        function Vi(e) {
          for (var n = e; null !== n; ) {
            if (13 === n.tag) {
              var t = n.memoizedState;
              if (
                null !== t &&
                (null === (t = t.dehydrated) ||
                  "$?" === t.data ||
                  "$!" === t.data)
              )
                return n;
            } else if (19 === n.tag && void 0 !== n.memoizedProps.revealOrder) {
              if (0 != (64 & n.flags)) return n;
            } else if (null !== n.child) {
              (n.child.return = n), (n = n.child);
              continue;
            }
            if (n === e) break;
            for (; null === n.sibling; ) {
              if (null === n.return || n.return === e) return null;
              n = n.return;
            }
            (n.sibling.return = n.return), (n = n.sibling);
          }
          return null;
        }
        var Di = null,
          Bi = null,
          Wi = !1;
        function zi(e, n) {
          var t = Ws(5, null, null, 0);
          (t.elementType = "DELETED"),
            (t.type = "DELETED"),
            (t.stateNode = n),
            (t.return = e),
            (t.flags = 8),
            null !== e.lastEffect
              ? ((e.lastEffect.nextEffect = t), (e.lastEffect = t))
              : (e.firstEffect = e.lastEffect = t);
        }
        function Zi(e, n) {
          switch (e.tag) {
            case 5:
              var t = e.type;
              return (
                null !==
                  (n =
                    1 !== n.nodeType ||
                    t.toLowerCase() !== n.nodeName.toLowerCase()
                      ? null
                      : n) && ((e.stateNode = n), !0)
              );
            case 6:
              return (
                null !==
                  (n = "" === e.pendingProps || 3 !== n.nodeType ? null : n) &&
                ((e.stateNode = n), !0)
              );
            default:
              return !1;
          }
        }
        function Fi(e) {
          if (Wi) {
            var n = Bi;
            if (n) {
              var t = n;
              if (!Zi(e, n)) {
                if (!(n = Gr(t.nextSibling)) || !Zi(e, n))
                  return (
                    (e.flags = (-1025 & e.flags) | 2), (Wi = !1), void (Di = e)
                  );
                zi(Di, t);
              }
              (Di = e), (Bi = Gr(n.firstChild));
            } else (e.flags = (-1025 & e.flags) | 2), (Wi = !1), (Di = e);
          }
        }
        function Ui(e) {
          for (
            e = e.return;
            null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;

          )
            e = e.return;
          Di = e;
        }
        function Ki(e) {
          if (e !== Di) return !1;
          if (!Wi) return Ui(e), (Wi = !0), !1;
          var n = e.type;
          if (
            5 !== e.tag ||
            ("head" !== n && "body" !== n && !Zr(n, e.memoizedProps))
          )
            for (n = Bi; n; ) zi(e, n), (n = Gr(n.nextSibling));
          if ((Ui(e), 13 === e.tag)) {
            if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null))
              throw Error(a(317));
            e: {
              for (e = e.nextSibling, n = 0; e; ) {
                if (8 === e.nodeType) {
                  var t = e.data;
                  if ("/$" === t) {
                    if (0 === n) {
                      Bi = Gr(e.nextSibling);
                      break e;
                    }
                    n--;
                  } else ("$" !== t && "$!" !== t && "$?" !== t) || n++;
                }
                e = e.nextSibling;
              }
              Bi = null;
            }
          } else Bi = Di ? Gr(e.stateNode.nextSibling) : null;
          return !0;
        }
        function Gi() {
          (Bi = Di = null), (Wi = !1);
        }
        var Yi = [];
        function $i() {
          for (var e = 0; e < Yi.length; e++)
            Yi[e]._workInProgressVersionPrimary = null;
          Yi.length = 0;
        }
        var qi = x.ReactCurrentDispatcher,
          Qi = x.ReactCurrentBatchConfig,
          Xi = 0,
          Ji = null,
          ea = null,
          na = null,
          ta = !1,
          ra = !1;
        function oa() {
          throw Error(a(321));
        }
        function ia(e, n) {
          if (null === n) return !1;
          for (var t = 0; t < n.length && t < e.length; t++)
            if (!cr(e[t], n[t])) return !1;
          return !0;
        }
        function aa(e, n, t, r, o, i) {
          if (
            ((Xi = i),
            (Ji = n),
            (n.memoizedState = null),
            (n.updateQueue = null),
            (n.lanes = 0),
            (qi.current = null === e || null === e.memoizedState ? Oa : Aa),
            (e = t(r, o)),
            ra)
          ) {
            i = 0;
            do {
              if (((ra = !1), !(25 > i))) throw Error(a(301));
              (i += 1),
                (na = ea = null),
                (n.updateQueue = null),
                (qi.current = Ia),
                (e = t(r, o));
            } while (ra);
          }
          if (
            ((qi.current = Na),
            (n = null !== ea && null !== ea.next),
            (Xi = 0),
            (na = ea = Ji = null),
            (ta = !1),
            n)
          )
            throw Error(a(300));
          return e;
        }
        function la() {
          var e = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null,
          };
          return (
            null === na ? (Ji.memoizedState = na = e) : (na = na.next = e), na
          );
        }
        function sa() {
          if (null === ea) {
            var e = Ji.alternate;
            e = null !== e ? e.memoizedState : null;
          } else e = ea.next;
          var n = null === na ? Ji.memoizedState : na.next;
          if (null !== n) (na = n), (ea = e);
          else {
            if (null === e) throw Error(a(310));
            (e = {
              memoizedState: (ea = e).memoizedState,
              baseState: ea.baseState,
              baseQueue: ea.baseQueue,
              queue: ea.queue,
              next: null,
            }),
              null === na ? (Ji.memoizedState = na = e) : (na = na.next = e);
          }
          return na;
        }
        function ca(e, n) {
          return "function" == typeof n ? n(e) : n;
        }
        function ua(e) {
          var n = sa(),
            t = n.queue;
          if (null === t) throw Error(a(311));
          t.lastRenderedReducer = e;
          var r = ea,
            o = r.baseQueue,
            i = t.pending;
          if (null !== i) {
            if (null !== o) {
              var l = o.next;
              (o.next = i.next), (i.next = l);
            }
            (r.baseQueue = o = i), (t.pending = null);
          }
          if (null !== o) {
            (o = o.next), (r = r.baseState);
            var s = (l = i = null),
              c = o;
            do {
              var u = c.lane;
              if ((Xi & u) === u)
                null !== s &&
                  (s = s.next =
                    {
                      lane: 0,
                      action: c.action,
                      eagerReducer: c.eagerReducer,
                      eagerState: c.eagerState,
                      next: null,
                    }),
                  (r = c.eagerReducer === e ? c.eagerState : e(r, c.action));
              else {
                var d = {
                  lane: u,
                  action: c.action,
                  eagerReducer: c.eagerReducer,
                  eagerState: c.eagerState,
                  next: null,
                };
                null === s ? ((l = s = d), (i = r)) : (s = s.next = d),
                  (Ji.lanes |= u),
                  (Vl |= u);
              }
              c = c.next;
            } while (null !== c && c !== o);
            null === s ? (i = r) : (s.next = l),
              cr(r, n.memoizedState) || (Ra = !0),
              (n.memoizedState = r),
              (n.baseState = i),
              (n.baseQueue = s),
              (t.lastRenderedState = r);
          }
          return [n.memoizedState, t.dispatch];
        }
        function da(e) {
          var n = sa(),
            t = n.queue;
          if (null === t) throw Error(a(311));
          t.lastRenderedReducer = e;
          var r = t.dispatch,
            o = t.pending,
            i = n.memoizedState;
          if (null !== o) {
            t.pending = null;
            var l = (o = o.next);
            do {
              (i = e(i, l.action)), (l = l.next);
            } while (l !== o);
            cr(i, n.memoizedState) || (Ra = !0),
              (n.memoizedState = i),
              null === n.baseQueue && (n.baseState = i),
              (t.lastRenderedState = i);
          }
          return [i, r];
        }
        function pa(e, n, t) {
          var r = n._getVersion;
          r = r(n._source);
          var o = n._workInProgressVersionPrimary;
          if (
            (null !== o
              ? (e = o === r)
              : ((e = e.mutableReadLanes),
                (e = (Xi & e) === e) &&
                  ((n._workInProgressVersionPrimary = r), Yi.push(n))),
            e)
          )
            return t(n._source);
          throw (Yi.push(n), Error(a(350)));
        }
        function fa(e, n, t, r) {
          var o = Tl;
          if (null === o) throw Error(a(349));
          var i = n._getVersion,
            l = i(n._source),
            s = qi.current,
            c = s.useState(function () {
              return pa(o, n, t);
            }),
            u = c[1],
            d = c[0];
          c = na;
          var p = e.memoizedState,
            f = p.refs,
            h = f.getSnapshot,
            m = p.source;
          p = p.subscribe;
          var _ = Ji;
          return (
            (e.memoizedState = { refs: f, source: n, subscribe: r }),
            s.useEffect(
              function () {
                (f.getSnapshot = t), (f.setSnapshot = u);
                var e = i(n._source);
                if (!cr(l, e)) {
                  (e = t(n._source)),
                    cr(d, e) ||
                      (u(e),
                      (e = us(_)),
                      (o.mutableReadLanes |= e & o.pendingLanes)),
                    (e = o.mutableReadLanes),
                    (o.entangledLanes |= e);
                  for (var r = o.entanglements, a = e; 0 < a; ) {
                    var s = 31 - Fn(a),
                      c = 1 << s;
                    (r[s] |= e), (a &= ~c);
                  }
                }
              },
              [t, n, r]
            ),
            s.useEffect(
              function () {
                return r(n._source, function () {
                  var e = f.getSnapshot,
                    t = f.setSnapshot;
                  try {
                    t(e(n._source));
                    var r = us(_);
                    o.mutableReadLanes |= r & o.pendingLanes;
                  } catch (e) {
                    t(function () {
                      throw e;
                    });
                  }
                });
              },
              [n, r]
            ),
            (cr(h, t) && cr(m, n) && cr(p, r)) ||
              (((e = {
                pending: null,
                dispatch: null,
                lastRenderedReducer: ca,
                lastRenderedState: d,
              }).dispatch = u =
                Ta.bind(null, Ji, e)),
              (c.queue = e),
              (c.baseQueue = null),
              (d = pa(o, n, t)),
              (c.memoizedState = c.baseState = d)),
            d
          );
        }
        function ha(e, n, t) {
          return fa(sa(), e, n, t);
        }
        function ma(e) {
          var n = la();
          return (
            "function" == typeof e && (e = e()),
            (n.memoizedState = n.baseState = e),
            (e = (e = n.queue =
              {
                pending: null,
                dispatch: null,
                lastRenderedReducer: ca,
                lastRenderedState: e,
              }).dispatch =
              Ta.bind(null, Ji, e)),
            [n.memoizedState, e]
          );
        }
        function _a(e, n, t, r) {
          return (
            (e = { tag: e, create: n, destroy: t, deps: r, next: null }),
            null === (n = Ji.updateQueue)
              ? ((n = { lastEffect: null }),
                (Ji.updateQueue = n),
                (n.lastEffect = e.next = e))
              : null === (t = n.lastEffect)
              ? (n.lastEffect = e.next = e)
              : ((r = t.next), (t.next = e), (e.next = r), (n.lastEffect = e)),
            e
          );
        }
        function ga(e) {
          return (e = { current: e }), (la().memoizedState = e);
        }
        function va() {
          return sa().memoizedState;
        }
        function Ca(e, n, t, r) {
          var o = la();
          (Ji.flags |= e),
            (o.memoizedState = _a(1 | n, t, void 0, void 0 === r ? null : r));
        }
        function ba(e, n, t, r) {
          var o = sa();
          r = void 0 === r ? null : r;
          var i = void 0;
          if (null !== ea) {
            var a = ea.memoizedState;
            if (((i = a.destroy), null !== r && ia(r, a.deps)))
              return void _a(n, t, i, r);
          }
          (Ji.flags |= e), (o.memoizedState = _a(1 | n, t, i, r));
        }
        function xa(e, n) {
          return Ca(516, 4, e, n);
        }
        function ya(e, n) {
          return ba(516, 4, e, n);
        }
        function wa(e, n) {
          return ba(4, 2, e, n);
        }
        function ka(e, n) {
          return "function" == typeof n
            ? ((e = e()),
              n(e),
              function () {
                n(null);
              })
            : null != n
            ? ((e = e()),
              (n.current = e),
              function () {
                n.current = null;
              })
            : void 0;
        }
        function La(e, n, t) {
          return (
            (t = null != t ? t.concat([e]) : null),
            ba(4, 2, ka.bind(null, n, e), t)
          );
        }
        function ja() {}
        function Ea(e, n) {
          var t = sa();
          n = void 0 === n ? null : n;
          var r = t.memoizedState;
          return null !== r && null !== n && ia(n, r[1])
            ? r[0]
            : ((t.memoizedState = [e, n]), e);
        }
        function Sa(e, n) {
          var t = sa();
          n = void 0 === n ? null : n;
          var r = t.memoizedState;
          return null !== r && null !== n && ia(n, r[1])
            ? r[0]
            : ((e = e()), (t.memoizedState = [e, n]), e);
        }
        function Ma(e, n) {
          var t = Fo();
          Ko(98 > t ? 98 : t, function () {
            e(!0);
          }),
            Ko(97 < t ? 97 : t, function () {
              var t = Qi.transition;
              Qi.transition = 1;
              try {
                e(!1), n();
              } finally {
                Qi.transition = t;
              }
            });
        }
        function Ta(e, n, t) {
          var r = cs(),
            o = us(e),
            i = {
              lane: o,
              action: t,
              eagerReducer: null,
              eagerState: null,
              next: null,
            },
            a = n.pending;
          if (
            (null === a ? (i.next = i) : ((i.next = a.next), (a.next = i)),
            (n.pending = i),
            (a = e.alternate),
            e === Ji || (null !== a && a === Ji))
          )
            ra = ta = !0;
          else {
            if (
              0 === e.lanes &&
              (null === a || 0 === a.lanes) &&
              null !== (a = n.lastRenderedReducer)
            )
              try {
                var l = n.lastRenderedState,
                  s = a(l, t);
                if (((i.eagerReducer = a), (i.eagerState = s), cr(s, l)))
                  return;
              } catch (e) {}
            ds(e, o, r);
          }
        }
        var Na = {
            readContext: ai,
            useCallback: oa,
            useContext: oa,
            useEffect: oa,
            useImperativeHandle: oa,
            useLayoutEffect: oa,
            useMemo: oa,
            useReducer: oa,
            useRef: oa,
            useState: oa,
            useDebugValue: oa,
            useDeferredValue: oa,
            useTransition: oa,
            useMutableSource: oa,
            useOpaqueIdentifier: oa,
            unstable_isNewReconciler: !1,
          },
          Oa = {
            readContext: ai,
            useCallback: function (e, n) {
              return (la().memoizedState = [e, void 0 === n ? null : n]), e;
            },
            useContext: ai,
            useEffect: xa,
            useImperativeHandle: function (e, n, t) {
              return (
                (t = null != t ? t.concat([e]) : null),
                Ca(4, 2, ka.bind(null, n, e), t)
              );
            },
            useLayoutEffect: function (e, n) {
              return Ca(4, 2, e, n);
            },
            useMemo: function (e, n) {
              var t = la();
              return (
                (n = void 0 === n ? null : n),
                (e = e()),
                (t.memoizedState = [e, n]),
                e
              );
            },
            useReducer: function (e, n, t) {
              var r = la();
              return (
                (n = void 0 !== t ? t(n) : n),
                (r.memoizedState = r.baseState = n),
                (e = (e = r.queue =
                  {
                    pending: null,
                    dispatch: null,
                    lastRenderedReducer: e,
                    lastRenderedState: n,
                  }).dispatch =
                  Ta.bind(null, Ji, e)),
                [r.memoizedState, e]
              );
            },
            useRef: ga,
            useState: ma,
            useDebugValue: ja,
            useDeferredValue: function (e) {
              var n = ma(e),
                t = n[0],
                r = n[1];
              return (
                xa(
                  function () {
                    var n = Qi.transition;
                    Qi.transition = 1;
                    try {
                      r(e);
                    } finally {
                      Qi.transition = n;
                    }
                  },
                  [e]
                ),
                t
              );
            },
            useTransition: function () {
              var e = ma(!1),
                n = e[0];
              return ga((e = Ma.bind(null, e[1]))), [e, n];
            },
            useMutableSource: function (e, n, t) {
              var r = la();
              return (
                (r.memoizedState = {
                  refs: { getSnapshot: n, setSnapshot: null },
                  source: e,
                  subscribe: t,
                }),
                fa(r, e, n, t)
              );
            },
            useOpaqueIdentifier: function () {
              if (Wi) {
                var e = !1,
                  n = (function (e) {
                    return { $$typeof: P, toString: e, valueOf: e };
                  })(function () {
                    throw (
                      (e || ((e = !0), t("r:" + ($r++).toString(36))),
                      Error(a(355)))
                    );
                  }),
                  t = ma(n)[1];
                return (
                  0 == (2 & Ji.mode) &&
                    ((Ji.flags |= 516),
                    _a(
                      5,
                      function () {
                        t("r:" + ($r++).toString(36));
                      },
                      void 0,
                      null
                    )),
                  n
                );
              }
              return ma((n = "r:" + ($r++).toString(36))), n;
            },
            unstable_isNewReconciler: !1,
          },
          Aa = {
            readContext: ai,
            useCallback: Ea,
            useContext: ai,
            useEffect: ya,
            useImperativeHandle: La,
            useLayoutEffect: wa,
            useMemo: Sa,
            useReducer: ua,
            useRef: va,
            useState: function () {
              return ua(ca);
            },
            useDebugValue: ja,
            useDeferredValue: function (e) {
              var n = ua(ca),
                t = n[0],
                r = n[1];
              return (
                ya(
                  function () {
                    var n = Qi.transition;
                    Qi.transition = 1;
                    try {
                      r(e);
                    } finally {
                      Qi.transition = n;
                    }
                  },
                  [e]
                ),
                t
              );
            },
            useTransition: function () {
              var e = ua(ca)[0];
              return [va().current, e];
            },
            useMutableSource: ha,
            useOpaqueIdentifier: function () {
              return ua(ca)[0];
            },
            unstable_isNewReconciler: !1,
          },
          Ia = {
            readContext: ai,
            useCallback: Ea,
            useContext: ai,
            useEffect: ya,
            useImperativeHandle: La,
            useLayoutEffect: wa,
            useMemo: Sa,
            useReducer: da,
            useRef: va,
            useState: function () {
              return da(ca);
            },
            useDebugValue: ja,
            useDeferredValue: function (e) {
              var n = da(ca),
                t = n[0],
                r = n[1];
              return (
                ya(
                  function () {
                    var n = Qi.transition;
                    Qi.transition = 1;
                    try {
                      r(e);
                    } finally {
                      Qi.transition = n;
                    }
                  },
                  [e]
                ),
                t
              );
            },
            useTransition: function () {
              var e = da(ca)[0];
              return [va().current, e];
            },
            useMutableSource: ha,
            useOpaqueIdentifier: function () {
              return da(ca)[0];
            },
            unstable_isNewReconciler: !1,
          },
          Pa = x.ReactCurrentOwner,
          Ra = !1;
        function Ha(e, n, t, r) {
          n.child = null === e ? Ei(n, null, t, r) : ji(n, e.child, t, r);
        }
        function Va(e, n, t, r, o) {
          t = t.render;
          var i = n.ref;
          return (
            ii(n, o),
            (r = aa(e, n, t, r, i, o)),
            null === e || Ra
              ? ((n.flags |= 1), Ha(e, n, r, o), n.child)
              : ((n.updateQueue = e.updateQueue),
                (n.flags &= -517),
                (e.lanes &= ~o),
                tl(e, n, o))
          );
        }
        function Da(e, n, t, r, o, i) {
          if (null === e) {
            var a = t.type;
            return "function" != typeof a ||
              zs(a) ||
              void 0 !== a.defaultProps ||
              null !== t.compare ||
              void 0 !== t.defaultProps
              ? (((e = Fs(t.type, null, r, n, n.mode, i)).ref = n.ref),
                (e.return = n),
                (n.child = e))
              : ((n.tag = 15), (n.type = a), Ba(e, n, a, r, o, i));
          }
          return (
            (a = e.child),
            0 == (o & i) &&
            ((o = a.memoizedProps),
            (t = null !== (t = t.compare) ? t : dr)(o, r) && e.ref === n.ref)
              ? tl(e, n, i)
              : ((n.flags |= 1),
                ((e = Zs(a, r)).ref = n.ref),
                (e.return = n),
                (n.child = e))
          );
        }
        function Ba(e, n, t, r, o, i) {
          if (null !== e && dr(e.memoizedProps, r) && e.ref === n.ref) {
            if (((Ra = !1), 0 == (i & o)))
              return (n.lanes = e.lanes), tl(e, n, i);
            0 != (16384 & e.flags) && (Ra = !0);
          }
          return Za(e, n, t, r, i);
        }
        function Wa(e, n, t) {
          var r = n.pendingProps,
            o = r.children,
            i = null !== e ? e.memoizedState : null;
          if ("hidden" === r.mode || "unstable-defer-without-hiding" === r.mode)
            if (0 == (4 & n.mode))
              (n.memoizedState = { baseLanes: 0 }), Cs(0, t);
            else {
              if (0 == (1073741824 & t))
                return (
                  (e = null !== i ? i.baseLanes | t : t),
                  (n.lanes = n.childLanes = 1073741824),
                  (n.memoizedState = { baseLanes: e }),
                  Cs(0, e),
                  null
                );
              (n.memoizedState = { baseLanes: 0 }),
                Cs(0, null !== i ? i.baseLanes : t);
            }
          else
            null !== i
              ? ((r = i.baseLanes | t), (n.memoizedState = null))
              : (r = t),
              Cs(0, r);
          return Ha(e, n, o, t), n.child;
        }
        function za(e, n) {
          var t = n.ref;
          ((null === e && null !== t) || (null !== e && e.ref !== t)) &&
            (n.flags |= 128);
        }
        function Za(e, n, t, r, o) {
          var i = go(t) ? mo : fo.current;
          return (
            (i = _o(n, i)),
            ii(n, o),
            (t = aa(e, n, t, r, i, o)),
            null === e || Ra
              ? ((n.flags |= 1), Ha(e, n, t, o), n.child)
              : ((n.updateQueue = e.updateQueue),
                (n.flags &= -517),
                (e.lanes &= ~o),
                tl(e, n, o))
          );
        }
        function Fa(e, n, t, r, o) {
          if (go(t)) {
            var i = !0;
            xo(n);
          } else i = !1;
          if ((ii(n, o), null === n.stateNode))
            null !== e &&
              ((e.alternate = null), (n.alternate = null), (n.flags |= 2)),
              Ci(n, t, r),
              xi(n, t, r, o),
              (r = !0);
          else if (null === e) {
            var a = n.stateNode,
              l = n.memoizedProps;
            a.props = l;
            var s = a.context,
              c = t.contextType;
            c =
              "object" == typeof c && null !== c
                ? ai(c)
                : _o(n, (c = go(t) ? mo : fo.current));
            var u = t.getDerivedStateFromProps,
              d =
                "function" == typeof u ||
                "function" == typeof a.getSnapshotBeforeUpdate;
            d ||
              ("function" != typeof a.UNSAFE_componentWillReceiveProps &&
                "function" != typeof a.componentWillReceiveProps) ||
              ((l !== r || s !== c) && bi(n, a, r, c)),
              (li = !1);
            var p = n.memoizedState;
            (a.state = p),
              fi(n, r, a, o),
              (s = n.memoizedState),
              l !== r || p !== s || ho.current || li
                ? ("function" == typeof u &&
                    (_i(n, t, u, r), (s = n.memoizedState)),
                  (l = li || vi(n, t, l, r, p, s, c))
                    ? (d ||
                        ("function" != typeof a.UNSAFE_componentWillMount &&
                          "function" != typeof a.componentWillMount) ||
                        ("function" == typeof a.componentWillMount &&
                          a.componentWillMount(),
                        "function" == typeof a.UNSAFE_componentWillMount &&
                          a.UNSAFE_componentWillMount()),
                      "function" == typeof a.componentDidMount &&
                        (n.flags |= 4))
                    : ("function" == typeof a.componentDidMount &&
                        (n.flags |= 4),
                      (n.memoizedProps = r),
                      (n.memoizedState = s)),
                  (a.props = r),
                  (a.state = s),
                  (a.context = c),
                  (r = l))
                : ("function" == typeof a.componentDidMount && (n.flags |= 4),
                  (r = !1));
          } else {
            (a = n.stateNode),
              ci(e, n),
              (l = n.memoizedProps),
              (c = n.type === n.elementType ? l : Qo(n.type, l)),
              (a.props = c),
              (d = n.pendingProps),
              (p = a.context),
              (s =
                "object" == typeof (s = t.contextType) && null !== s
                  ? ai(s)
                  : _o(n, (s = go(t) ? mo : fo.current)));
            var f = t.getDerivedStateFromProps;
            (u =
              "function" == typeof f ||
              "function" == typeof a.getSnapshotBeforeUpdate) ||
              ("function" != typeof a.UNSAFE_componentWillReceiveProps &&
                "function" != typeof a.componentWillReceiveProps) ||
              ((l !== d || p !== s) && bi(n, a, r, s)),
              (li = !1),
              (p = n.memoizedState),
              (a.state = p),
              fi(n, r, a, o);
            var h = n.memoizedState;
            l !== d || p !== h || ho.current || li
              ? ("function" == typeof f &&
                  (_i(n, t, f, r), (h = n.memoizedState)),
                (c = li || vi(n, t, c, r, p, h, s))
                  ? (u ||
                      ("function" != typeof a.UNSAFE_componentWillUpdate &&
                        "function" != typeof a.componentWillUpdate) ||
                      ("function" == typeof a.componentWillUpdate &&
                        a.componentWillUpdate(r, h, s),
                      "function" == typeof a.UNSAFE_componentWillUpdate &&
                        a.UNSAFE_componentWillUpdate(r, h, s)),
                    "function" == typeof a.componentDidUpdate && (n.flags |= 4),
                    "function" == typeof a.getSnapshotBeforeUpdate &&
                      (n.flags |= 256))
                  : ("function" != typeof a.componentDidUpdate ||
                      (l === e.memoizedProps && p === e.memoizedState) ||
                      (n.flags |= 4),
                    "function" != typeof a.getSnapshotBeforeUpdate ||
                      (l === e.memoizedProps && p === e.memoizedState) ||
                      (n.flags |= 256),
                    (n.memoizedProps = r),
                    (n.memoizedState = h)),
                (a.props = r),
                (a.state = h),
                (a.context = s),
                (r = c))
              : ("function" != typeof a.componentDidUpdate ||
                  (l === e.memoizedProps && p === e.memoizedState) ||
                  (n.flags |= 4),
                "function" != typeof a.getSnapshotBeforeUpdate ||
                  (l === e.memoizedProps && p === e.memoizedState) ||
                  (n.flags |= 256),
                (r = !1));
          }
          return Ua(e, n, t, r, i, o);
        }
        function Ua(e, n, t, r, o, i) {
          za(e, n);
          var a = 0 != (64 & n.flags);
          if (!r && !a) return o && yo(n, t, !1), tl(e, n, i);
          (r = n.stateNode), (Pa.current = n);
          var l =
            a && "function" != typeof t.getDerivedStateFromError
              ? null
              : r.render();
          return (
            (n.flags |= 1),
            null !== e && a
              ? ((n.child = ji(n, e.child, null, i)),
                (n.child = ji(n, null, l, i)))
              : Ha(e, n, l, i),
            (n.memoizedState = r.state),
            o && yo(n, t, !0),
            n.child
          );
        }
        function Ka(e) {
          var n = e.stateNode;
          n.pendingContext
            ? Co(0, n.pendingContext, n.pendingContext !== n.context)
            : n.context && Co(0, n.context, !1),
            Ai(e, n.containerInfo);
        }
        var Ga,
          Ya,
          $a,
          qa = { dehydrated: null, retryLane: 0 };
        function Qa(e, n, t) {
          var r,
            o = n.pendingProps,
            i = Hi.current,
            a = !1;
          return (
            (r = 0 != (64 & n.flags)) ||
              (r = (null === e || null !== e.memoizedState) && 0 != (2 & i)),
            r
              ? ((a = !0), (n.flags &= -65))
              : (null !== e && null === e.memoizedState) ||
                void 0 === o.fallback ||
                !0 === o.unstable_avoidThisFallback ||
                (i |= 1),
            uo(Hi, 1 & i),
            null === e
              ? (void 0 !== o.fallback && Fi(n),
                (e = o.children),
                (i = o.fallback),
                a
                  ? ((e = Xa(n, e, i, t)),
                    (n.child.memoizedState = { baseLanes: t }),
                    (n.memoizedState = qa),
                    e)
                  : "number" == typeof o.unstable_expectedLoadTime
                  ? ((e = Xa(n, e, i, t)),
                    (n.child.memoizedState = { baseLanes: t }),
                    (n.memoizedState = qa),
                    (n.lanes = 33554432),
                    e)
                  : (((t = Ks(
                      { mode: "visible", children: e },
                      n.mode,
                      t,
                      null
                    )).return = n),
                    (n.child = t)))
              : (e.memoizedState,
                a
                  ? ((o = (function (e, n, t, r, o) {
                      var i = n.mode,
                        a = e.child;
                      e = a.sibling;
                      var l = { mode: "hidden", children: t };
                      return (
                        0 == (2 & i) && n.child !== a
                          ? (((t = n.child).childLanes = 0),
                            (t.pendingProps = l),
                            null !== (a = t.lastEffect)
                              ? ((n.firstEffect = t.firstEffect),
                                (n.lastEffect = a),
                                (a.nextEffect = null))
                              : (n.firstEffect = n.lastEffect = null))
                          : (t = Zs(a, l)),
                        null !== e
                          ? (r = Zs(e, r))
                          : ((r = Us(r, i, o, null)).flags |= 2),
                        (r.return = n),
                        (t.return = n),
                        (t.sibling = r),
                        (n.child = t),
                        r
                      );
                    })(e, n, o.children, o.fallback, t)),
                    (a = n.child),
                    (i = e.child.memoizedState),
                    (a.memoizedState =
                      null === i
                        ? { baseLanes: t }
                        : { baseLanes: i.baseLanes | t }),
                    (a.childLanes = e.childLanes & ~t),
                    (n.memoizedState = qa),
                    o)
                  : ((t = (function (e, n, t, r) {
                      var o = e.child;
                      return (
                        (e = o.sibling),
                        (t = Zs(o, { mode: "visible", children: t })),
                        0 == (2 & n.mode) && (t.lanes = r),
                        (t.return = n),
                        (t.sibling = null),
                        null !== e &&
                          ((e.nextEffect = null),
                          (e.flags = 8),
                          (n.firstEffect = n.lastEffect = e)),
                        (n.child = t)
                      );
                    })(e, n, o.children, t)),
                    (n.memoizedState = null),
                    t))
          );
        }
        function Xa(e, n, t, r) {
          var o = e.mode,
            i = e.child;
          return (
            (n = { mode: "hidden", children: n }),
            0 == (2 & o) && null !== i
              ? ((i.childLanes = 0), (i.pendingProps = n))
              : (i = Ks(n, o, 0, null)),
            (t = Us(t, o, r, null)),
            (i.return = e),
            (t.return = e),
            (i.sibling = t),
            (e.child = i),
            t
          );
        }
        function Ja(e, n) {
          e.lanes |= n;
          var t = e.alternate;
          null !== t && (t.lanes |= n), oi(e.return, n);
        }
        function el(e, n, t, r, o, i) {
          var a = e.memoizedState;
          null === a
            ? (e.memoizedState = {
                isBackwards: n,
                rendering: null,
                renderingStartTime: 0,
                last: r,
                tail: t,
                tailMode: o,
                lastEffect: i,
              })
            : ((a.isBackwards = n),
              (a.rendering = null),
              (a.renderingStartTime = 0),
              (a.last = r),
              (a.tail = t),
              (a.tailMode = o),
              (a.lastEffect = i));
        }
        function nl(e, n, t) {
          var r = n.pendingProps,
            o = r.revealOrder,
            i = r.tail;
          if ((Ha(e, n, r.children, t), 0 != (2 & (r = Hi.current))))
            (r = (1 & r) | 2), (n.flags |= 64);
          else {
            if (null !== e && 0 != (64 & e.flags))
              e: for (e = n.child; null !== e; ) {
                if (13 === e.tag) null !== e.memoizedState && Ja(e, t);
                else if (19 === e.tag) Ja(e, t);
                else if (null !== e.child) {
                  (e.child.return = e), (e = e.child);
                  continue;
                }
                if (e === n) break e;
                for (; null === e.sibling; ) {
                  if (null === e.return || e.return === n) break e;
                  e = e.return;
                }
                (e.sibling.return = e.return), (e = e.sibling);
              }
            r &= 1;
          }
          if ((uo(Hi, r), 0 == (2 & n.mode))) n.memoizedState = null;
          else
            switch (o) {
              case "forwards":
                for (t = n.child, o = null; null !== t; )
                  null !== (e = t.alternate) && null === Vi(e) && (o = t),
                    (t = t.sibling);
                null === (t = o)
                  ? ((o = n.child), (n.child = null))
                  : ((o = t.sibling), (t.sibling = null)),
                  el(n, !1, o, t, i, n.lastEffect);
                break;
              case "backwards":
                for (t = null, o = n.child, n.child = null; null !== o; ) {
                  if (null !== (e = o.alternate) && null === Vi(e)) {
                    n.child = o;
                    break;
                  }
                  (e = o.sibling), (o.sibling = t), (t = o), (o = e);
                }
                el(n, !0, t, null, i, n.lastEffect);
                break;
              case "together":
                el(n, !1, null, null, void 0, n.lastEffect);
                break;
              default:
                n.memoizedState = null;
            }
          return n.child;
        }
        function tl(e, n, t) {
          if (
            (null !== e && (n.dependencies = e.dependencies),
            (Vl |= n.lanes),
            0 != (t & n.childLanes))
          ) {
            if (null !== e && n.child !== e.child) throw Error(a(153));
            if (null !== n.child) {
              for (
                t = Zs((e = n.child), e.pendingProps),
                  n.child = t,
                  t.return = n;
                null !== e.sibling;

              )
                (e = e.sibling),
                  ((t = t.sibling = Zs(e, e.pendingProps)).return = n);
              t.sibling = null;
            }
            return n.child;
          }
          return null;
        }
        function rl(e, n) {
          if (!Wi)
            switch (e.tailMode) {
              case "hidden":
                n = e.tail;
                for (var t = null; null !== n; )
                  null !== n.alternate && (t = n), (n = n.sibling);
                null === t ? (e.tail = null) : (t.sibling = null);
                break;
              case "collapsed":
                t = e.tail;
                for (var r = null; null !== t; )
                  null !== t.alternate && (r = t), (t = t.sibling);
                null === r
                  ? n || null === e.tail
                    ? (e.tail = null)
                    : (e.tail.sibling = null)
                  : (r.sibling = null);
            }
        }
        function ol(e, n, t) {
          var r = n.pendingProps;
          switch (n.tag) {
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
              return null;
            case 1:
            case 17:
              return go(n.type) && vo(), null;
            case 3:
              return (
                Ii(),
                co(ho),
                co(fo),
                $i(),
                (r = n.stateNode).pendingContext &&
                  ((r.context = r.pendingContext), (r.pendingContext = null)),
                (null !== e && null !== e.child) ||
                  (Ki(n) ? (n.flags |= 4) : r.hydrate || (n.flags |= 256)),
                null
              );
            case 5:
              Ri(n);
              var i = Oi(Ni.current);
              if (((t = n.type), null !== e && null != n.stateNode))
                Ya(e, n, t, r), e.ref !== n.ref && (n.flags |= 128);
              else {
                if (!r) {
                  if (null === n.stateNode) throw Error(a(166));
                  return null;
                }
                if (((e = Oi(Mi.current)), Ki(n))) {
                  (r = n.stateNode), (t = n.type);
                  var l = n.memoizedProps;
                  switch (((r[Qr] = n), (r[Xr] = l), t)) {
                    case "dialog":
                      Mr("cancel", r), Mr("close", r);
                      break;
                    case "iframe":
                    case "object":
                    case "embed":
                      Mr("load", r);
                      break;
                    case "video":
                    case "audio":
                      for (e = 0; e < Lr.length; e++) Mr(Lr[e], r);
                      break;
                    case "source":
                      Mr("error", r);
                      break;
                    case "img":
                    case "image":
                    case "link":
                      Mr("error", r), Mr("load", r);
                      break;
                    case "details":
                      Mr("toggle", r);
                      break;
                    case "input":
                      ee(r, l), Mr("invalid", r);
                      break;
                    case "select":
                      (r._wrapperState = { wasMultiple: !!l.multiple }),
                        Mr("invalid", r);
                      break;
                    case "textarea":
                      se(r, l), Mr("invalid", r);
                  }
                  for (var c in (we(t, l), (e = null), l))
                    l.hasOwnProperty(c) &&
                      ((i = l[c]),
                      "children" === c
                        ? "string" == typeof i
                          ? r.textContent !== i && (e = ["children", i])
                          : "number" == typeof i &&
                            r.textContent !== "" + i &&
                            (e = ["children", "" + i])
                        : s.hasOwnProperty(c) &&
                          null != i &&
                          "onScroll" === c &&
                          Mr("scroll", r));
                  switch (t) {
                    case "input":
                      q(r), re(r, l, !0);
                      break;
                    case "textarea":
                      q(r), ue(r);
                      break;
                    case "select":
                    case "option":
                      break;
                    default:
                      "function" == typeof l.onClick && (r.onclick = Dr);
                  }
                  (r = e), (n.updateQueue = r), null !== r && (n.flags |= 4);
                } else {
                  switch (
                    ((c = 9 === i.nodeType ? i : i.ownerDocument),
                    e === de && (e = pe(t)),
                    e === de
                      ? "script" === t
                        ? (((e = c.createElement("div")).innerHTML =
                            "<script></script>"),
                          (e = e.removeChild(e.firstChild)))
                        : "string" == typeof r.is
                        ? (e = c.createElement(t, { is: r.is }))
                        : ((e = c.createElement(t)),
                          "select" === t &&
                            ((c = e),
                            r.multiple
                              ? (c.multiple = !0)
                              : r.size && (c.size = r.size)))
                      : (e = c.createElementNS(e, t)),
                    (e[Qr] = n),
                    (e[Xr] = r),
                    Ga(e, n),
                    (n.stateNode = e),
                    (c = ke(t, r)),
                    t)
                  ) {
                    case "dialog":
                      Mr("cancel", e), Mr("close", e), (i = r);
                      break;
                    case "iframe":
                    case "object":
                    case "embed":
                      Mr("load", e), (i = r);
                      break;
                    case "video":
                    case "audio":
                      for (i = 0; i < Lr.length; i++) Mr(Lr[i], e);
                      i = r;
                      break;
                    case "source":
                      Mr("error", e), (i = r);
                      break;
                    case "img":
                    case "image":
                    case "link":
                      Mr("error", e), Mr("load", e), (i = r);
                      break;
                    case "details":
                      Mr("toggle", e), (i = r);
                      break;
                    case "input":
                      ee(e, r), (i = J(e, r)), Mr("invalid", e);
                      break;
                    case "option":
                      i = ie(e, r);
                      break;
                    case "select":
                      (e._wrapperState = { wasMultiple: !!r.multiple }),
                        (i = o({}, r, { value: void 0 })),
                        Mr("invalid", e);
                      break;
                    case "textarea":
                      se(e, r), (i = le(e, r)), Mr("invalid", e);
                      break;
                    default:
                      i = r;
                  }
                  we(t, i);
                  var u = i;
                  for (l in u)
                    if (u.hasOwnProperty(l)) {
                      var d = u[l];
                      "style" === l
                        ? xe(e, d)
                        : "dangerouslySetInnerHTML" === l
                        ? null != (d = d ? d.__html : void 0) && _e(e, d)
                        : "children" === l
                        ? "string" == typeof d
                          ? ("textarea" !== t || "" !== d) && ge(e, d)
                          : "number" == typeof d && ge(e, "" + d)
                        : "suppressContentEditableWarning" !== l &&
                          "suppressHydrationWarning" !== l &&
                          "autoFocus" !== l &&
                          (s.hasOwnProperty(l)
                            ? null != d && "onScroll" === l && Mr("scroll", e)
                            : null != d && b(e, l, d, c));
                    }
                  switch (t) {
                    case "input":
                      q(e), re(e, r, !1);
                      break;
                    case "textarea":
                      q(e), ue(e);
                      break;
                    case "option":
                      null != r.value &&
                        e.setAttribute("value", "" + Y(r.value));
                      break;
                    case "select":
                      (e.multiple = !!r.multiple),
                        null != (l = r.value)
                          ? ae(e, !!r.multiple, l, !1)
                          : null != r.defaultValue &&
                            ae(e, !!r.multiple, r.defaultValue, !0);
                      break;
                    default:
                      "function" == typeof i.onClick && (e.onclick = Dr);
                  }
                  zr(t, r) && (n.flags |= 4);
                }
                null !== n.ref && (n.flags |= 128);
              }
              return null;
            case 6:
              if (e && null != n.stateNode) $a(0, n, e.memoizedProps, r);
              else {
                if ("string" != typeof r && null === n.stateNode)
                  throw Error(a(166));
                (t = Oi(Ni.current)),
                  Oi(Mi.current),
                  Ki(n)
                    ? ((r = n.stateNode),
                      (t = n.memoizedProps),
                      (r[Qr] = n),
                      r.nodeValue !== t && (n.flags |= 4))
                    : (((r = (
                        9 === t.nodeType ? t : t.ownerDocument
                      ).createTextNode(r))[Qr] = n),
                      (n.stateNode = r));
              }
              return null;
            case 13:
              return (
                co(Hi),
                (r = n.memoizedState),
                0 != (64 & n.flags)
                  ? ((n.lanes = t), n)
                  : ((r = null !== r),
                    (t = !1),
                    null === e
                      ? void 0 !== n.memoizedProps.fallback && Ki(n)
                      : (t = null !== e.memoizedState),
                    r &&
                      !t &&
                      0 != (2 & n.mode) &&
                      ((null === e &&
                        !0 !== n.memoizedProps.unstable_avoidThisFallback) ||
                      0 != (1 & Hi.current)
                        ? 0 === Pl && (Pl = 3)
                        : ((0 !== Pl && 3 !== Pl) || (Pl = 4),
                          null === Tl ||
                            (0 == (134217727 & Vl) && 0 == (134217727 & Dl)) ||
                            ms(Tl, Ol))),
                    (r || t) && (n.flags |= 4),
                    null)
              );
            case 4:
              return Ii(), null === e && Nr(n.stateNode.containerInfo), null;
            case 10:
              return ri(n), null;
            case 19:
              if ((co(Hi), null === (r = n.memoizedState))) return null;
              if (((l = 0 != (64 & n.flags)), null === (c = r.rendering)))
                if (l) rl(r, !1);
                else {
                  if (0 !== Pl || (null !== e && 0 != (64 & e.flags)))
                    for (e = n.child; null !== e; ) {
                      if (null !== (c = Vi(e))) {
                        for (
                          n.flags |= 64,
                            rl(r, !1),
                            null !== (l = c.updateQueue) &&
                              ((n.updateQueue = l), (n.flags |= 4)),
                            null === r.lastEffect && (n.firstEffect = null),
                            n.lastEffect = r.lastEffect,
                            r = t,
                            t = n.child;
                          null !== t;

                        )
                          (e = r),
                            ((l = t).flags &= 2),
                            (l.nextEffect = null),
                            (l.firstEffect = null),
                            (l.lastEffect = null),
                            null === (c = l.alternate)
                              ? ((l.childLanes = 0),
                                (l.lanes = e),
                                (l.child = null),
                                (l.memoizedProps = null),
                                (l.memoizedState = null),
                                (l.updateQueue = null),
                                (l.dependencies = null),
                                (l.stateNode = null))
                              : ((l.childLanes = c.childLanes),
                                (l.lanes = c.lanes),
                                (l.child = c.child),
                                (l.memoizedProps = c.memoizedProps),
                                (l.memoizedState = c.memoizedState),
                                (l.updateQueue = c.updateQueue),
                                (l.type = c.type),
                                (e = c.dependencies),
                                (l.dependencies =
                                  null === e
                                    ? null
                                    : {
                                        lanes: e.lanes,
                                        firstContext: e.firstContext,
                                      })),
                            (t = t.sibling);
                        return uo(Hi, (1 & Hi.current) | 2), n.child;
                      }
                      e = e.sibling;
                    }
                  null !== r.tail &&
                    Zo() > Zl &&
                    ((n.flags |= 64),
                    (l = !0),
                    rl(r, !1),
                    (n.lanes = 33554432));
                }
              else {
                if (!l)
                  if (null !== (e = Vi(c))) {
                    if (
                      ((n.flags |= 64),
                      (l = !0),
                      null !== (t = e.updateQueue) &&
                        ((n.updateQueue = t), (n.flags |= 4)),
                      rl(r, !0),
                      null === r.tail &&
                        "hidden" === r.tailMode &&
                        !c.alternate &&
                        !Wi)
                    )
                      return (
                        null !== (n = n.lastEffect = r.lastEffect) &&
                          (n.nextEffect = null),
                        null
                      );
                  } else
                    2 * Zo() - r.renderingStartTime > Zl &&
                      1073741824 !== t &&
                      ((n.flags |= 64),
                      (l = !0),
                      rl(r, !1),
                      (n.lanes = 33554432));
                r.isBackwards
                  ? ((c.sibling = n.child), (n.child = c))
                  : (null !== (t = r.last) ? (t.sibling = c) : (n.child = c),
                    (r.last = c));
              }
              return null !== r.tail
                ? ((t = r.tail),
                  (r.rendering = t),
                  (r.tail = t.sibling),
                  (r.lastEffect = n.lastEffect),
                  (r.renderingStartTime = Zo()),
                  (t.sibling = null),
                  (n = Hi.current),
                  uo(Hi, l ? (1 & n) | 2 : 1 & n),
                  t)
                : null;
            case 23:
            case 24:
              return (
                bs(),
                null !== e &&
                  (null !== e.memoizedState) != (null !== n.memoizedState) &&
                  "unstable-defer-without-hiding" !== r.mode &&
                  (n.flags |= 4),
                null
              );
          }
          throw Error(a(156, n.tag));
        }
        function il(e) {
          switch (e.tag) {
            case 1:
              go(e.type) && vo();
              var n = e.flags;
              return 4096 & n ? ((e.flags = (-4097 & n) | 64), e) : null;
            case 3:
              if ((Ii(), co(ho), co(fo), $i(), 0 != (64 & (n = e.flags))))
                throw Error(a(285));
              return (e.flags = (-4097 & n) | 64), e;
            case 5:
              return Ri(e), null;
            case 13:
              return (
                co(Hi),
                4096 & (n = e.flags) ? ((e.flags = (-4097 & n) | 64), e) : null
              );
            case 19:
              return co(Hi), null;
            case 4:
              return Ii(), null;
            case 10:
              return ri(e), null;
            case 23:
            case 24:
              return bs(), null;
            default:
              return null;
          }
        }
        function al(e, n) {
          try {
            var t = "",
              r = n;
            do {
              (t += K(r)), (r = r.return);
            } while (r);
            var o = t;
          } catch (e) {
            o = "\nError generating stack: " + e.message + "\n" + e.stack;
          }
          return { value: e, source: n, stack: o };
        }
        function ll(e, n) {
          try {
            console.error(n.value);
          } catch (e) {
            setTimeout(function () {
              throw e;
            });
          }
        }
        (Ga = function (e, n) {
          for (var t = n.child; null !== t; ) {
            if (5 === t.tag || 6 === t.tag) e.appendChild(t.stateNode);
            else if (4 !== t.tag && null !== t.child) {
              (t.child.return = t), (t = t.child);
              continue;
            }
            if (t === n) break;
            for (; null === t.sibling; ) {
              if (null === t.return || t.return === n) return;
              t = t.return;
            }
            (t.sibling.return = t.return), (t = t.sibling);
          }
        }),
          (Ya = function (e, n, t, r) {
            var i = e.memoizedProps;
            if (i !== r) {
              (e = n.stateNode), Oi(Mi.current);
              var a,
                l = null;
              switch (t) {
                case "input":
                  (i = J(e, i)), (r = J(e, r)), (l = []);
                  break;
                case "option":
                  (i = ie(e, i)), (r = ie(e, r)), (l = []);
                  break;
                case "select":
                  (i = o({}, i, { value: void 0 })),
                    (r = o({}, r, { value: void 0 })),
                    (l = []);
                  break;
                case "textarea":
                  (i = le(e, i)), (r = le(e, r)), (l = []);
                  break;
                default:
                  "function" != typeof i.onClick &&
                    "function" == typeof r.onClick &&
                    (e.onclick = Dr);
              }
              for (d in (we(t, r), (t = null), i))
                if (!r.hasOwnProperty(d) && i.hasOwnProperty(d) && null != i[d])
                  if ("style" === d) {
                    var c = i[d];
                    for (a in c)
                      c.hasOwnProperty(a) && (t || (t = {}), (t[a] = ""));
                  } else
                    "dangerouslySetInnerHTML" !== d &&
                      "children" !== d &&
                      "suppressContentEditableWarning" !== d &&
                      "suppressHydrationWarning" !== d &&
                      "autoFocus" !== d &&
                      (s.hasOwnProperty(d)
                        ? l || (l = [])
                        : (l = l || []).push(d, null));
              for (d in r) {
                var u = r[d];
                if (
                  ((c = null != i ? i[d] : void 0),
                  r.hasOwnProperty(d) && u !== c && (null != u || null != c))
                )
                  if ("style" === d)
                    if (c) {
                      for (a in c)
                        !c.hasOwnProperty(a) ||
                          (u && u.hasOwnProperty(a)) ||
                          (t || (t = {}), (t[a] = ""));
                      for (a in u)
                        u.hasOwnProperty(a) &&
                          c[a] !== u[a] &&
                          (t || (t = {}), (t[a] = u[a]));
                    } else t || (l || (l = []), l.push(d, t)), (t = u);
                  else
                    "dangerouslySetInnerHTML" === d
                      ? ((u = u ? u.__html : void 0),
                        (c = c ? c.__html : void 0),
                        null != u && c !== u && (l = l || []).push(d, u))
                      : "children" === d
                      ? ("string" != typeof u && "number" != typeof u) ||
                        (l = l || []).push(d, "" + u)
                      : "suppressContentEditableWarning" !== d &&
                        "suppressHydrationWarning" !== d &&
                        (s.hasOwnProperty(d)
                          ? (null != u && "onScroll" === d && Mr("scroll", e),
                            l || c === u || (l = []))
                          : "object" == typeof u &&
                            null !== u &&
                            u.$$typeof === P
                          ? u.toString()
                          : (l = l || []).push(d, u));
              }
              t && (l = l || []).push("style", t);
              var d = l;
              (n.updateQueue = d) && (n.flags |= 4);
            }
          }),
          ($a = function (e, n, t, r) {
            t !== r && (n.flags |= 4);
          });
        var sl = "function" == typeof WeakMap ? WeakMap : Map;
        function cl(e, n, t) {
          ((t = ui(-1, t)).tag = 3), (t.payload = { element: null });
          var r = n.value;
          return (
            (t.callback = function () {
              Gl || ((Gl = !0), (Yl = r)), ll(0, n);
            }),
            t
          );
        }
        function ul(e, n, t) {
          (t = ui(-1, t)).tag = 3;
          var r = e.type.getDerivedStateFromError;
          if ("function" == typeof r) {
            var o = n.value;
            t.payload = function () {
              return ll(0, n), r(o);
            };
          }
          var i = e.stateNode;
          return (
            null !== i &&
              "function" == typeof i.componentDidCatch &&
              (t.callback = function () {
                "function" != typeof r &&
                  (null === $l ? ($l = new Set([this])) : $l.add(this),
                  ll(0, n));
                var e = n.stack;
                this.componentDidCatch(n.value, {
                  componentStack: null !== e ? e : "",
                });
              }),
            t
          );
        }
        var dl = "function" == typeof WeakSet ? WeakSet : Set;
        function pl(e) {
          var n = e.ref;
          if (null !== n)
            if ("function" == typeof n)
              try {
                n(null);
              } catch (n) {
                Hs(e, n);
              }
            else n.current = null;
        }
        function fl(e, n) {
          switch (n.tag) {
            case 0:
            case 11:
            case 15:
            case 22:
            case 5:
            case 6:
            case 4:
            case 17:
              return;
            case 1:
              if (256 & n.flags && null !== e) {
                var t = e.memoizedProps,
                  r = e.memoizedState;
                (n = (e = n.stateNode).getSnapshotBeforeUpdate(
                  n.elementType === n.type ? t : Qo(n.type, t),
                  r
                )),
                  (e.__reactInternalSnapshotBeforeUpdate = n);
              }
              return;
            case 3:
              return void (256 & n.flags && Kr(n.stateNode.containerInfo));
          }
          throw Error(a(163));
        }
        function hl(e, n, t) {
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
            case 22:
              if (
                null !==
                (n = null !== (n = t.updateQueue) ? n.lastEffect : null)
              ) {
                e = n = n.next;
                do {
                  if (3 == (3 & e.tag)) {
                    var r = e.create;
                    e.destroy = r();
                  }
                  e = e.next;
                } while (e !== n);
              }
              if (
                null !==
                (n = null !== (n = t.updateQueue) ? n.lastEffect : null)
              ) {
                e = n = n.next;
                do {
                  var o = e;
                  (r = o.next),
                    0 != (4 & (o = o.tag)) &&
                      0 != (1 & o) &&
                      (Is(t, e), As(t, e)),
                    (e = r);
                } while (e !== n);
              }
              return;
            case 1:
              return (
                (e = t.stateNode),
                4 & t.flags &&
                  (null === n
                    ? e.componentDidMount()
                    : ((r =
                        t.elementType === t.type
                          ? n.memoizedProps
                          : Qo(t.type, n.memoizedProps)),
                      e.componentDidUpdate(
                        r,
                        n.memoizedState,
                        e.__reactInternalSnapshotBeforeUpdate
                      ))),
                void (null !== (n = t.updateQueue) && hi(t, n, e))
              );
            case 3:
              if (null !== (n = t.updateQueue)) {
                if (((e = null), null !== t.child))
                  switch (t.child.tag) {
                    case 5:
                    case 1:
                      e = t.child.stateNode;
                  }
                hi(t, n, e);
              }
              return;
            case 5:
              return (
                (e = t.stateNode),
                void (
                  null === n &&
                  4 & t.flags &&
                  zr(t.type, t.memoizedProps) &&
                  e.focus()
                )
              );
            case 6:
            case 4:
            case 12:
            case 19:
            case 17:
            case 20:
            case 21:
            case 23:
            case 24:
              return;
            case 13:
              return void (
                null === t.memoizedState &&
                ((t = t.alternate),
                null !== t &&
                  ((t = t.memoizedState),
                  null !== t && ((t = t.dehydrated), null !== t && yn(t))))
              );
          }
          throw Error(a(163));
        }
        function ml(e, n) {
          for (var t = e; ; ) {
            if (5 === t.tag) {
              var r = t.stateNode;
              if (n)
                "function" == typeof (r = r.style).setProperty
                  ? r.setProperty("display", "none", "important")
                  : (r.display = "none");
              else {
                r = t.stateNode;
                var o = t.memoizedProps.style;
                (o =
                  null != o && o.hasOwnProperty("display") ? o.display : null),
                  (r.style.display = be("display", o));
              }
            } else if (6 === t.tag)
              t.stateNode.nodeValue = n ? "" : t.memoizedProps;
            else if (
              ((23 !== t.tag && 24 !== t.tag) ||
                null === t.memoizedState ||
                t === e) &&
              null !== t.child
            ) {
              (t.child.return = t), (t = t.child);
              continue;
            }
            if (t === e) break;
            for (; null === t.sibling; ) {
              if (null === t.return || t.return === e) return;
              t = t.return;
            }
            (t.sibling.return = t.return), (t = t.sibling);
          }
        }
        function _l(e, n) {
          if (ko && "function" == typeof ko.onCommitFiberUnmount)
            try {
              ko.onCommitFiberUnmount(wo, n);
            } catch (e) {}
          switch (n.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
            case 22:
              if (null !== (e = n.updateQueue) && null !== (e = e.lastEffect)) {
                var t = (e = e.next);
                do {
                  var r = t,
                    o = r.destroy;
                  if (((r = r.tag), void 0 !== o))
                    if (0 != (4 & r)) Is(n, t);
                    else {
                      r = n;
                      try {
                        o();
                      } catch (e) {
                        Hs(r, e);
                      }
                    }
                  t = t.next;
                } while (t !== e);
              }
              break;
            case 1:
              if (
                (pl(n),
                "function" == typeof (e = n.stateNode).componentWillUnmount)
              )
                try {
                  (e.props = n.memoizedProps),
                    (e.state = n.memoizedState),
                    e.componentWillUnmount();
                } catch (e) {
                  Hs(n, e);
                }
              break;
            case 5:
              pl(n);
              break;
            case 4:
              yl(e, n);
          }
        }
        function gl(e) {
          (e.alternate = null),
            (e.child = null),
            (e.dependencies = null),
            (e.firstEffect = null),
            (e.lastEffect = null),
            (e.memoizedProps = null),
            (e.memoizedState = null),
            (e.pendingProps = null),
            (e.return = null),
            (e.updateQueue = null);
        }
        function vl(e) {
          return 5 === e.tag || 3 === e.tag || 4 === e.tag;
        }
        function Cl(e) {
          e: {
            for (var n = e.return; null !== n; ) {
              if (vl(n)) break e;
              n = n.return;
            }
            throw Error(a(160));
          }
          var t = n;
          switch (((n = t.stateNode), t.tag)) {
            case 5:
              var r = !1;
              break;
            case 3:
            case 4:
              (n = n.containerInfo), (r = !0);
              break;
            default:
              throw Error(a(161));
          }
          16 & t.flags && (ge(n, ""), (t.flags &= -17));
          e: n: for (t = e; ; ) {
            for (; null === t.sibling; ) {
              if (null === t.return || vl(t.return)) {
                t = null;
                break e;
              }
              t = t.return;
            }
            for (
              t.sibling.return = t.return, t = t.sibling;
              5 !== t.tag && 6 !== t.tag && 18 !== t.tag;

            ) {
              if (2 & t.flags) continue n;
              if (null === t.child || 4 === t.tag) continue n;
              (t.child.return = t), (t = t.child);
            }
            if (!(2 & t.flags)) {
              t = t.stateNode;
              break e;
            }
          }
          r ? bl(e, t, n) : xl(e, t, n);
        }
        function bl(e, n, t) {
          var r = e.tag,
            o = 5 === r || 6 === r;
          if (o)
            (e = o ? e.stateNode : e.stateNode.instance),
              n
                ? 8 === t.nodeType
                  ? t.parentNode.insertBefore(e, n)
                  : t.insertBefore(e, n)
                : (8 === t.nodeType
                    ? (n = t.parentNode).insertBefore(e, t)
                    : (n = t).appendChild(e),
                  null != (t = t._reactRootContainer) ||
                    null !== n.onclick ||
                    (n.onclick = Dr));
          else if (4 !== r && null !== (e = e.child))
            for (bl(e, n, t), e = e.sibling; null !== e; )
              bl(e, n, t), (e = e.sibling);
        }
        function xl(e, n, t) {
          var r = e.tag,
            o = 5 === r || 6 === r;
          if (o)
            (e = o ? e.stateNode : e.stateNode.instance),
              n ? t.insertBefore(e, n) : t.appendChild(e);
          else if (4 !== r && null !== (e = e.child))
            for (xl(e, n, t), e = e.sibling; null !== e; )
              xl(e, n, t), (e = e.sibling);
        }
        function yl(e, n) {
          for (var t, r, o = n, i = !1; ; ) {
            if (!i) {
              i = o.return;
              e: for (;;) {
                if (null === i) throw Error(a(160));
                switch (((t = i.stateNode), i.tag)) {
                  case 5:
                    r = !1;
                    break e;
                  case 3:
                  case 4:
                    (t = t.containerInfo), (r = !0);
                    break e;
                }
                i = i.return;
              }
              i = !0;
            }
            if (5 === o.tag || 6 === o.tag) {
              e: for (var l = e, s = o, c = s; ; )
                if ((_l(l, c), null !== c.child && 4 !== c.tag))
                  (c.child.return = c), (c = c.child);
                else {
                  if (c === s) break e;
                  for (; null === c.sibling; ) {
                    if (null === c.return || c.return === s) break e;
                    c = c.return;
                  }
                  (c.sibling.return = c.return), (c = c.sibling);
                }
              r
                ? ((l = t),
                  (s = o.stateNode),
                  8 === l.nodeType
                    ? l.parentNode.removeChild(s)
                    : l.removeChild(s))
                : t.removeChild(o.stateNode);
            } else if (4 === o.tag) {
              if (null !== o.child) {
                (t = o.stateNode.containerInfo),
                  (r = !0),
                  (o.child.return = o),
                  (o = o.child);
                continue;
              }
            } else if ((_l(e, o), null !== o.child)) {
              (o.child.return = o), (o = o.child);
              continue;
            }
            if (o === n) break;
            for (; null === o.sibling; ) {
              if (null === o.return || o.return === n) return;
              4 === (o = o.return).tag && (i = !1);
            }
            (o.sibling.return = o.return), (o = o.sibling);
          }
        }
        function wl(e, n) {
          switch (n.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
            case 22:
              var t = n.updateQueue;
              if (null !== (t = null !== t ? t.lastEffect : null)) {
                var r = (t = t.next);
                do {
                  3 == (3 & r.tag) &&
                    ((e = r.destroy),
                    (r.destroy = void 0),
                    void 0 !== e && e()),
                    (r = r.next);
                } while (r !== t);
              }
              return;
            case 1:
            case 12:
            case 17:
              return;
            case 5:
              if (null != (t = n.stateNode)) {
                r = n.memoizedProps;
                var o = null !== e ? e.memoizedProps : r;
                e = n.type;
                var i = n.updateQueue;
                if (((n.updateQueue = null), null !== i)) {
                  for (
                    t[Xr] = r,
                      "input" === e &&
                        "radio" === r.type &&
                        null != r.name &&
                        ne(t, r),
                      ke(e, o),
                      n = ke(e, r),
                      o = 0;
                    o < i.length;
                    o += 2
                  ) {
                    var l = i[o],
                      s = i[o + 1];
                    "style" === l
                      ? xe(t, s)
                      : "dangerouslySetInnerHTML" === l
                      ? _e(t, s)
                      : "children" === l
                      ? ge(t, s)
                      : b(t, l, s, n);
                  }
                  switch (e) {
                    case "input":
                      te(t, r);
                      break;
                    case "textarea":
                      ce(t, r);
                      break;
                    case "select":
                      (e = t._wrapperState.wasMultiple),
                        (t._wrapperState.wasMultiple = !!r.multiple),
                        null != (i = r.value)
                          ? ae(t, !!r.multiple, i, !1)
                          : e !== !!r.multiple &&
                            (null != r.defaultValue
                              ? ae(t, !!r.multiple, r.defaultValue, !0)
                              : ae(t, !!r.multiple, r.multiple ? [] : "", !1));
                  }
                }
              }
              return;
            case 6:
              if (null === n.stateNode) throw Error(a(162));
              return void (n.stateNode.nodeValue = n.memoizedProps);
            case 3:
              return void (
                (t = n.stateNode).hydrate &&
                ((t.hydrate = !1), yn(t.containerInfo))
              );
            case 13:
              return (
                null !== n.memoizedState && ((zl = Zo()), ml(n.child, !0)),
                void kl(n)
              );
            case 19:
              return void kl(n);
            case 23:
            case 24:
              return void ml(n, null !== n.memoizedState);
          }
          throw Error(a(163));
        }
        function kl(e) {
          var n = e.updateQueue;
          if (null !== n) {
            e.updateQueue = null;
            var t = e.stateNode;
            null === t && (t = e.stateNode = new dl()),
              n.forEach(function (n) {
                var r = Ds.bind(null, e, n);
                t.has(n) || (t.add(n), n.then(r, r));
              });
          }
        }
        function Ll(e, n) {
          return (
            null !== e &&
            (null === (e = e.memoizedState) || null !== e.dehydrated) &&
            null !== (n = n.memoizedState) &&
            null === n.dehydrated
          );
        }
        var jl = Math.ceil,
          El = x.ReactCurrentDispatcher,
          Sl = x.ReactCurrentOwner,
          Ml = 0,
          Tl = null,
          Nl = null,
          Ol = 0,
          Al = 0,
          Il = so(0),
          Pl = 0,
          Rl = null,
          Hl = 0,
          Vl = 0,
          Dl = 0,
          Bl = 0,
          Wl = null,
          zl = 0,
          Zl = 1 / 0;
        function Fl() {
          Zl = Zo() + 500;
        }
        var Ul,
          Kl = null,
          Gl = !1,
          Yl = null,
          $l = null,
          ql = !1,
          Ql = null,
          Xl = 90,
          Jl = [],
          es = [],
          ns = null,
          ts = 0,
          rs = null,
          os = -1,
          is = 0,
          as = 0,
          ls = null,
          ss = !1;
        function cs() {
          return 0 != (48 & Ml) ? Zo() : -1 !== os ? os : (os = Zo());
        }
        function us(e) {
          if (0 == (2 & (e = e.mode))) return 1;
          if (0 == (4 & e)) return 99 === Fo() ? 1 : 2;
          if ((0 === is && (is = Hl), 0 !== qo.transition)) {
            0 !== as && (as = null !== Wl ? Wl.pendingLanes : 0), (e = is);
            var n = 4186112 & ~as;
            return (
              0 == (n &= -n) &&
                0 == (n = (e = 4186112 & ~e) & -e) &&
                (n = 8192),
              n
            );
          }
          return (
            (e = Fo()),
            (e = Bn(
              0 != (4 & Ml) && 98 === e
                ? 12
                : (e = (function (e) {
                    switch (e) {
                      case 99:
                        return 15;
                      case 98:
                        return 10;
                      case 97:
                      case 96:
                        return 8;
                      case 95:
                        return 2;
                      default:
                        return 0;
                    }
                  })(e)),
              is
            ))
          );
        }
        function ds(e, n, t) {
          if (50 < ts) throw ((ts = 0), (rs = null), Error(a(185)));
          if (null === (e = ps(e, n))) return null;
          Zn(e, n, t), e === Tl && ((Dl |= n), 4 === Pl && ms(e, Ol));
          var r = Fo();
          1 === n
            ? 0 != (8 & Ml) && 0 == (48 & Ml)
              ? _s(e)
              : (fs(e, t), 0 === Ml && (Fl(), Yo()))
            : (0 == (4 & Ml) ||
                (98 !== r && 99 !== r) ||
                (null === ns ? (ns = new Set([e])) : ns.add(e)),
              fs(e, t)),
            (Wl = e);
        }
        function ps(e, n) {
          e.lanes |= n;
          var t = e.alternate;
          for (null !== t && (t.lanes |= n), t = e, e = e.return; null !== e; )
            (e.childLanes |= n),
              null !== (t = e.alternate) && (t.childLanes |= n),
              (t = e),
              (e = e.return);
          return 3 === t.tag ? t.stateNode : null;
        }
        function fs(e, n) {
          for (
            var t = e.callbackNode,
              r = e.suspendedLanes,
              o = e.pingedLanes,
              i = e.expirationTimes,
              l = e.pendingLanes;
            0 < l;

          ) {
            var s = 31 - Fn(l),
              c = 1 << s,
              u = i[s];
            if (-1 === u) {
              if (0 == (c & r) || 0 != (c & o)) {
                (u = n), Hn(c);
                var d = Rn;
                i[s] = 10 <= d ? u + 250 : 6 <= d ? u + 5e3 : -1;
              }
            } else u <= n && (e.expiredLanes |= c);
            l &= ~c;
          }
          if (((r = Vn(e, e === Tl ? Ol : 0)), (n = Rn), 0 === r))
            null !== t &&
              (t !== Ho && Eo(t),
              (e.callbackNode = null),
              (e.callbackPriority = 0));
          else {
            if (null !== t) {
              if (e.callbackPriority === n) return;
              t !== Ho && Eo(t);
            }
            15 === n
              ? ((t = _s.bind(null, e)),
                null === Do ? ((Do = [t]), (Bo = jo(Oo, $o))) : Do.push(t),
                (t = Ho))
              : 14 === n
              ? (t = Go(99, _s.bind(null, e)))
              : ((t = (function (e) {
                  switch (e) {
                    case 15:
                    case 14:
                      return 99;
                    case 13:
                    case 12:
                    case 11:
                    case 10:
                      return 98;
                    case 9:
                    case 8:
                    case 7:
                    case 6:
                    case 4:
                    case 5:
                      return 97;
                    case 3:
                    case 2:
                    case 1:
                      return 95;
                    case 0:
                      return 90;
                    default:
                      throw Error(a(358, e));
                  }
                })(n)),
                (t = Go(t, hs.bind(null, e)))),
              (e.callbackPriority = n),
              (e.callbackNode = t);
          }
        }
        function hs(e) {
          if (((os = -1), (as = is = 0), 0 != (48 & Ml))) throw Error(a(327));
          var n = e.callbackNode;
          if (Os() && e.callbackNode !== n) return null;
          var t = Vn(e, e === Tl ? Ol : 0);
          if (0 === t) return null;
          var r = t,
            o = Ml;
          Ml |= 16;
          var i = ws();
          for ((Tl === e && Ol === r) || (Fl(), xs(e, r)); ; )
            try {
              js();
              break;
            } catch (n) {
              ys(e, n);
            }
          if (
            (ti(),
            (El.current = i),
            (Ml = o),
            null !== Nl ? (r = 0) : ((Tl = null), (Ol = 0), (r = Pl)),
            0 != (Hl & Dl))
          )
            xs(e, 0);
          else if (0 !== r) {
            if (
              (2 === r &&
                ((Ml |= 64),
                e.hydrate && ((e.hydrate = !1), Kr(e.containerInfo)),
                0 !== (t = Dn(e)) && (r = ks(e, t))),
              1 === r)
            )
              throw ((n = Rl), xs(e, 0), ms(e, t), fs(e, Zo()), n);
            switch (
              ((e.finishedWork = e.current.alternate), (e.finishedLanes = t), r)
            ) {
              case 0:
              case 1:
                throw Error(a(345));
              case 2:
              case 5:
                Ms(e);
                break;
              case 3:
                if (
                  (ms(e, t), (62914560 & t) === t && 10 < (r = zl + 500 - Zo()))
                ) {
                  if (0 !== Vn(e, 0)) break;
                  if (((o = e.suspendedLanes) & t) !== t) {
                    cs(), (e.pingedLanes |= e.suspendedLanes & o);
                    break;
                  }
                  e.timeoutHandle = Fr(Ms.bind(null, e), r);
                  break;
                }
                Ms(e);
                break;
              case 4:
                if ((ms(e, t), (4186112 & t) === t)) break;
                for (r = e.eventTimes, o = -1; 0 < t; ) {
                  var l = 31 - Fn(t);
                  (i = 1 << l), (l = r[l]) > o && (o = l), (t &= ~i);
                }
                if (
                  ((t = o),
                  10 <
                    (t =
                      (120 > (t = Zo() - t)
                        ? 120
                        : 480 > t
                        ? 480
                        : 1080 > t
                        ? 1080
                        : 1920 > t
                        ? 1920
                        : 3e3 > t
                        ? 3e3
                        : 4320 > t
                        ? 4320
                        : 1960 * jl(t / 1960)) - t))
                ) {
                  e.timeoutHandle = Fr(Ms.bind(null, e), t);
                  break;
                }
                Ms(e);
                break;
              default:
                throw Error(a(329));
            }
          }
          return fs(e, Zo()), e.callbackNode === n ? hs.bind(null, e) : null;
        }
        function ms(e, n) {
          for (
            n &= ~Bl,
              n &= ~Dl,
              e.suspendedLanes |= n,
              e.pingedLanes &= ~n,
              e = e.expirationTimes;
            0 < n;

          ) {
            var t = 31 - Fn(n),
              r = 1 << t;
            (e[t] = -1), (n &= ~r);
          }
        }
        function _s(e) {
          if (0 != (48 & Ml)) throw Error(a(327));
          if ((Os(), e === Tl && 0 != (e.expiredLanes & Ol))) {
            var n = Ol,
              t = ks(e, n);
            0 != (Hl & Dl) && (t = ks(e, (n = Vn(e, n))));
          } else t = ks(e, (n = Vn(e, 0)));
          if (
            (0 !== e.tag &&
              2 === t &&
              ((Ml |= 64),
              e.hydrate && ((e.hydrate = !1), Kr(e.containerInfo)),
              0 !== (n = Dn(e)) && (t = ks(e, n))),
            1 === t)
          )
            throw ((t = Rl), xs(e, 0), ms(e, n), fs(e, Zo()), t);
          return (
            (e.finishedWork = e.current.alternate),
            (e.finishedLanes = n),
            Ms(e),
            fs(e, Zo()),
            null
          );
        }
        function gs(e, n) {
          var t = Ml;
          Ml |= 1;
          try {
            return e(n);
          } finally {
            0 === (Ml = t) && (Fl(), Yo());
          }
        }
        function vs(e, n) {
          var t = Ml;
          (Ml &= -2), (Ml |= 8);
          try {
            return e(n);
          } finally {
            0 === (Ml = t) && (Fl(), Yo());
          }
        }
        function Cs(e, n) {
          uo(Il, Al), (Al |= n), (Hl |= n);
        }
        function bs() {
          (Al = Il.current), co(Il);
        }
        function xs(e, n) {
          (e.finishedWork = null), (e.finishedLanes = 0);
          var t = e.timeoutHandle;
          if ((-1 !== t && ((e.timeoutHandle = -1), Ur(t)), null !== Nl))
            for (t = Nl.return; null !== t; ) {
              var r = t;
              switch (r.tag) {
                case 1:
                  null != (r = r.type.childContextTypes) && vo();
                  break;
                case 3:
                  Ii(), co(ho), co(fo), $i();
                  break;
                case 5:
                  Ri(r);
                  break;
                case 4:
                  Ii();
                  break;
                case 13:
                case 19:
                  co(Hi);
                  break;
                case 10:
                  ri(r);
                  break;
                case 23:
                case 24:
                  bs();
              }
              t = t.return;
            }
          (Tl = e),
            (Nl = Zs(e.current, null)),
            (Ol = Al = Hl = n),
            (Pl = 0),
            (Rl = null),
            (Bl = Dl = Vl = 0);
        }
        function ys(e, n) {
          for (;;) {
            var t = Nl;
            try {
              if ((ti(), (qi.current = Na), ta)) {
                for (var r = Ji.memoizedState; null !== r; ) {
                  var o = r.queue;
                  null !== o && (o.pending = null), (r = r.next);
                }
                ta = !1;
              }
              if (
                ((Xi = 0),
                (na = ea = Ji = null),
                (ra = !1),
                (Sl.current = null),
                null === t || null === t.return)
              ) {
                (Pl = 1), (Rl = n), (Nl = null);
                break;
              }
              e: {
                var i = e,
                  a = t.return,
                  l = t,
                  s = n;
                if (
                  ((n = Ol),
                  (l.flags |= 2048),
                  (l.firstEffect = l.lastEffect = null),
                  null !== s &&
                    "object" == typeof s &&
                    "function" == typeof s.then)
                ) {
                  var c = s;
                  if (0 == (2 & l.mode)) {
                    var u = l.alternate;
                    u
                      ? ((l.updateQueue = u.updateQueue),
                        (l.memoizedState = u.memoizedState),
                        (l.lanes = u.lanes))
                      : ((l.updateQueue = null), (l.memoizedState = null));
                  }
                  var d = 0 != (1 & Hi.current),
                    p = a;
                  do {
                    var f;
                    if ((f = 13 === p.tag)) {
                      var h = p.memoizedState;
                      if (null !== h) f = null !== h.dehydrated;
                      else {
                        var m = p.memoizedProps;
                        f =
                          void 0 !== m.fallback &&
                          (!0 !== m.unstable_avoidThisFallback || !d);
                      }
                    }
                    if (f) {
                      var _ = p.updateQueue;
                      if (null === _) {
                        var g = new Set();
                        g.add(c), (p.updateQueue = g);
                      } else _.add(c);
                      if (0 == (2 & p.mode)) {
                        if (
                          ((p.flags |= 64),
                          (l.flags |= 16384),
                          (l.flags &= -2981),
                          1 === l.tag)
                        )
                          if (null === l.alternate) l.tag = 17;
                          else {
                            var v = ui(-1, 1);
                            (v.tag = 2), di(l, v);
                          }
                        l.lanes |= 1;
                        break e;
                      }
                      (s = void 0), (l = n);
                      var C = i.pingCache;
                      if (
                        (null === C
                          ? ((C = i.pingCache = new sl()),
                            (s = new Set()),
                            C.set(c, s))
                          : void 0 === (s = C.get(c)) &&
                            ((s = new Set()), C.set(c, s)),
                        !s.has(l))
                      ) {
                        s.add(l);
                        var b = Vs.bind(null, i, c, l);
                        c.then(b, b);
                      }
                      (p.flags |= 4096), (p.lanes = n);
                      break e;
                    }
                    p = p.return;
                  } while (null !== p);
                  s = Error(
                    (G(l.type) || "A React component") +
                      " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."
                  );
                }
                5 !== Pl && (Pl = 2), (s = al(s, l)), (p = a);
                do {
                  switch (p.tag) {
                    case 3:
                      (i = s),
                        (p.flags |= 4096),
                        (n &= -n),
                        (p.lanes |= n),
                        pi(p, cl(0, i, n));
                      break e;
                    case 1:
                      i = s;
                      var x = p.type,
                        y = p.stateNode;
                      if (
                        0 == (64 & p.flags) &&
                        ("function" == typeof x.getDerivedStateFromError ||
                          (null !== y &&
                            "function" == typeof y.componentDidCatch &&
                            (null === $l || !$l.has(y))))
                      ) {
                        (p.flags |= 4096),
                          (n &= -n),
                          (p.lanes |= n),
                          pi(p, ul(p, i, n));
                        break e;
                      }
                  }
                  p = p.return;
                } while (null !== p);
              }
              Ss(t);
            } catch (e) {
              (n = e), Nl === t && null !== t && (Nl = t = t.return);
              continue;
            }
            break;
          }
        }
        function ws() {
          var e = El.current;
          return (El.current = Na), null === e ? Na : e;
        }
        function ks(e, n) {
          var t = Ml;
          Ml |= 16;
          var r = ws();
          for ((Tl === e && Ol === n) || xs(e, n); ; )
            try {
              Ls();
              break;
            } catch (n) {
              ys(e, n);
            }
          if ((ti(), (Ml = t), (El.current = r), null !== Nl))
            throw Error(a(261));
          return (Tl = null), (Ol = 0), Pl;
        }
        function Ls() {
          for (; null !== Nl; ) Es(Nl);
        }
        function js() {
          for (; null !== Nl && !So(); ) Es(Nl);
        }
        function Es(e) {
          var n = Ul(e.alternate, e, Al);
          (e.memoizedProps = e.pendingProps),
            null === n ? Ss(e) : (Nl = n),
            (Sl.current = null);
        }
        function Ss(e) {
          var n = e;
          do {
            var t = n.alternate;
            if (((e = n.return), 0 == (2048 & n.flags))) {
              if (null !== (t = ol(t, n, Al))) return void (Nl = t);
              if (
                (24 !== (t = n).tag && 23 !== t.tag) ||
                null === t.memoizedState ||
                0 != (1073741824 & Al) ||
                0 == (4 & t.mode)
              ) {
                for (var r = 0, o = t.child; null !== o; )
                  (r |= o.lanes | o.childLanes), (o = o.sibling);
                t.childLanes = r;
              }
              null !== e &&
                0 == (2048 & e.flags) &&
                (null === e.firstEffect && (e.firstEffect = n.firstEffect),
                null !== n.lastEffect &&
                  (null !== e.lastEffect &&
                    (e.lastEffect.nextEffect = n.firstEffect),
                  (e.lastEffect = n.lastEffect)),
                1 < n.flags &&
                  (null !== e.lastEffect
                    ? (e.lastEffect.nextEffect = n)
                    : (e.firstEffect = n),
                  (e.lastEffect = n)));
            } else {
              if (null !== (t = il(n))) return (t.flags &= 2047), void (Nl = t);
              null !== e &&
                ((e.firstEffect = e.lastEffect = null), (e.flags |= 2048));
            }
            if (null !== (n = n.sibling)) return void (Nl = n);
            Nl = n = e;
          } while (null !== n);
          0 === Pl && (Pl = 5);
        }
        function Ms(e) {
          var n = Fo();
          return Ko(99, Ts.bind(null, e, n)), null;
        }
        function Ts(e, n) {
          do {
            Os();
          } while (null !== Ql);
          if (0 != (48 & Ml)) throw Error(a(327));
          var t = e.finishedWork;
          if (null === t) return null;
          if (((e.finishedWork = null), (e.finishedLanes = 0), t === e.current))
            throw Error(a(177));
          e.callbackNode = null;
          var r = t.lanes | t.childLanes,
            o = r,
            i = e.pendingLanes & ~o;
          (e.pendingLanes = o),
            (e.suspendedLanes = 0),
            (e.pingedLanes = 0),
            (e.expiredLanes &= o),
            (e.mutableReadLanes &= o),
            (e.entangledLanes &= o),
            (o = e.entanglements);
          for (var l = e.eventTimes, s = e.expirationTimes; 0 < i; ) {
            var c = 31 - Fn(i),
              u = 1 << c;
            (o[c] = 0), (l[c] = -1), (s[c] = -1), (i &= ~u);
          }
          if (
            (null !== ns && 0 == (24 & r) && ns.has(e) && ns.delete(e),
            e === Tl && ((Nl = Tl = null), (Ol = 0)),
            1 < t.flags
              ? null !== t.lastEffect
                ? ((t.lastEffect.nextEffect = t), (r = t.firstEffect))
                : (r = t)
              : (r = t.firstEffect),
            null !== r)
          ) {
            if (
              ((o = Ml),
              (Ml |= 32),
              (Sl.current = null),
              (Br = $n),
              _r((l = mr())))
            ) {
              if ("selectionStart" in l)
                s = { start: l.selectionStart, end: l.selectionEnd };
              else
                e: if (
                  ((s = ((s = l.ownerDocument) && s.defaultView) || window),
                  (u = s.getSelection && s.getSelection()) &&
                    0 !== u.rangeCount)
                ) {
                  (s = u.anchorNode),
                    (i = u.anchorOffset),
                    (c = u.focusNode),
                    (u = u.focusOffset);
                  try {
                    s.nodeType, c.nodeType;
                  } catch (e) {
                    s = null;
                    break e;
                  }
                  var d = 0,
                    p = -1,
                    f = -1,
                    h = 0,
                    m = 0,
                    _ = l,
                    g = null;
                  n: for (;;) {
                    for (
                      var v;
                      _ !== s || (0 !== i && 3 !== _.nodeType) || (p = d + i),
                        _ !== c || (0 !== u && 3 !== _.nodeType) || (f = d + u),
                        3 === _.nodeType && (d += _.nodeValue.length),
                        null !== (v = _.firstChild);

                    )
                      (g = _), (_ = v);
                    for (;;) {
                      if (_ === l) break n;
                      if (
                        (g === s && ++h === i && (p = d),
                        g === c && ++m === u && (f = d),
                        null !== (v = _.nextSibling))
                      )
                        break;
                      g = (_ = g).parentNode;
                    }
                    _ = v;
                  }
                  s = -1 === p || -1 === f ? null : { start: p, end: f };
                } else s = null;
              s = s || { start: 0, end: 0 };
            } else s = null;
            (Wr = { focusedElem: l, selectionRange: s }),
              ($n = !1),
              (ls = null),
              (ss = !1),
              (Kl = r);
            do {
              try {
                Ns();
              } catch (e) {
                if (null === Kl) throw Error(a(330));
                Hs(Kl, e), (Kl = Kl.nextEffect);
              }
            } while (null !== Kl);
            (ls = null), (Kl = r);
            do {
              try {
                for (l = e; null !== Kl; ) {
                  var C = Kl.flags;
                  if ((16 & C && ge(Kl.stateNode, ""), 128 & C)) {
                    var b = Kl.alternate;
                    if (null !== b) {
                      var x = b.ref;
                      null !== x &&
                        ("function" == typeof x ? x(null) : (x.current = null));
                    }
                  }
                  switch (1038 & C) {
                    case 2:
                      Cl(Kl), (Kl.flags &= -3);
                      break;
                    case 6:
                      Cl(Kl), (Kl.flags &= -3), wl(Kl.alternate, Kl);
                      break;
                    case 1024:
                      Kl.flags &= -1025;
                      break;
                    case 1028:
                      (Kl.flags &= -1025), wl(Kl.alternate, Kl);
                      break;
                    case 4:
                      wl(Kl.alternate, Kl);
                      break;
                    case 8:
                      yl(l, (s = Kl));
                      var y = s.alternate;
                      gl(s), null !== y && gl(y);
                  }
                  Kl = Kl.nextEffect;
                }
              } catch (e) {
                if (null === Kl) throw Error(a(330));
                Hs(Kl, e), (Kl = Kl.nextEffect);
              }
            } while (null !== Kl);
            if (
              ((x = Wr),
              (b = mr()),
              (C = x.focusedElem),
              (l = x.selectionRange),
              b !== C &&
                C &&
                C.ownerDocument &&
                hr(C.ownerDocument.documentElement, C))
            ) {
              null !== l &&
                _r(C) &&
                ((b = l.start),
                void 0 === (x = l.end) && (x = b),
                "selectionStart" in C
                  ? ((C.selectionStart = b),
                    (C.selectionEnd = Math.min(x, C.value.length)))
                  : (x =
                      ((b = C.ownerDocument || document) && b.defaultView) ||
                      window).getSelection &&
                    ((x = x.getSelection()),
                    (s = C.textContent.length),
                    (y = Math.min(l.start, s)),
                    (l = void 0 === l.end ? y : Math.min(l.end, s)),
                    !x.extend && y > l && ((s = l), (l = y), (y = s)),
                    (s = fr(C, y)),
                    (i = fr(C, l)),
                    s &&
                      i &&
                      (1 !== x.rangeCount ||
                        x.anchorNode !== s.node ||
                        x.anchorOffset !== s.offset ||
                        x.focusNode !== i.node ||
                        x.focusOffset !== i.offset) &&
                      ((b = b.createRange()).setStart(s.node, s.offset),
                      x.removeAllRanges(),
                      y > l
                        ? (x.addRange(b), x.extend(i.node, i.offset))
                        : (b.setEnd(i.node, i.offset), x.addRange(b))))),
                (b = []);
              for (x = C; (x = x.parentNode); )
                1 === x.nodeType &&
                  b.push({ element: x, left: x.scrollLeft, top: x.scrollTop });
              for (
                "function" == typeof C.focus && C.focus(), C = 0;
                C < b.length;
                C++
              )
                ((x = b[C]).element.scrollLeft = x.left),
                  (x.element.scrollTop = x.top);
            }
            ($n = !!Br), (Wr = Br = null), (e.current = t), (Kl = r);
            do {
              try {
                for (C = e; null !== Kl; ) {
                  var w = Kl.flags;
                  if ((36 & w && hl(C, Kl.alternate, Kl), 128 & w)) {
                    b = void 0;
                    var k = Kl.ref;
                    if (null !== k) {
                      var L = Kl.stateNode;
                      Kl.tag,
                        (b = L),
                        "function" == typeof k ? k(b) : (k.current = b);
                    }
                  }
                  Kl = Kl.nextEffect;
                }
              } catch (e) {
                if (null === Kl) throw Error(a(330));
                Hs(Kl, e), (Kl = Kl.nextEffect);
              }
            } while (null !== Kl);
            (Kl = null), Vo(), (Ml = o);
          } else e.current = t;
          if (ql) (ql = !1), (Ql = e), (Xl = n);
          else
            for (Kl = r; null !== Kl; )
              (n = Kl.nextEffect),
                (Kl.nextEffect = null),
                8 & Kl.flags &&
                  (((w = Kl).sibling = null), (w.stateNode = null)),
                (Kl = n);
          if (
            (0 === (r = e.pendingLanes) && ($l = null),
            1 === r ? (e === rs ? ts++ : ((ts = 0), (rs = e))) : (ts = 0),
            (t = t.stateNode),
            ko && "function" == typeof ko.onCommitFiberRoot)
          )
            try {
              ko.onCommitFiberRoot(wo, t, void 0, 64 == (64 & t.current.flags));
            } catch (e) {}
          if ((fs(e, Zo()), Gl)) throw ((Gl = !1), (e = Yl), (Yl = null), e);
          return 0 != (8 & Ml) || Yo(), null;
        }
        function Ns() {
          for (; null !== Kl; ) {
            var e = Kl.alternate;
            ss ||
              null === ls ||
              (0 != (8 & Kl.flags)
                ? Je(Kl, ls) && (ss = !0)
                : 13 === Kl.tag && Ll(e, Kl) && Je(Kl, ls) && (ss = !0));
            var n = Kl.flags;
            0 != (256 & n) && fl(e, Kl),
              0 == (512 & n) ||
                ql ||
                ((ql = !0),
                Go(97, function () {
                  return Os(), null;
                })),
              (Kl = Kl.nextEffect);
          }
        }
        function Os() {
          if (90 !== Xl) {
            var e = 97 < Xl ? 97 : Xl;
            return (Xl = 90), Ko(e, Ps);
          }
          return !1;
        }
        function As(e, n) {
          Jl.push(n, e),
            ql ||
              ((ql = !0),
              Go(97, function () {
                return Os(), null;
              }));
        }
        function Is(e, n) {
          es.push(n, e),
            ql ||
              ((ql = !0),
              Go(97, function () {
                return Os(), null;
              }));
        }
        function Ps() {
          if (null === Ql) return !1;
          var e = Ql;
          if (((Ql = null), 0 != (48 & Ml))) throw Error(a(331));
          var n = Ml;
          Ml |= 32;
          var t = es;
          es = [];
          for (var r = 0; r < t.length; r += 2) {
            var o = t[r],
              i = t[r + 1],
              l = o.destroy;
            if (((o.destroy = void 0), "function" == typeof l))
              try {
                l();
              } catch (e) {
                if (null === i) throw Error(a(330));
                Hs(i, e);
              }
          }
          for (t = Jl, Jl = [], r = 0; r < t.length; r += 2) {
            (o = t[r]), (i = t[r + 1]);
            try {
              var s = o.create;
              o.destroy = s();
            } catch (e) {
              if (null === i) throw Error(a(330));
              Hs(i, e);
            }
          }
          for (s = e.current.firstEffect; null !== s; )
            (e = s.nextEffect),
              (s.nextEffect = null),
              8 & s.flags && ((s.sibling = null), (s.stateNode = null)),
              (s = e);
          return (Ml = n), Yo(), !0;
        }
        function Rs(e, n, t) {
          di(e, (n = cl(0, (n = al(t, n)), 1))),
            (n = cs()),
            null !== (e = ps(e, 1)) && (Zn(e, 1, n), fs(e, n));
        }
        function Hs(e, n) {
          if (3 === e.tag) Rs(e, e, n);
          else
            for (var t = e.return; null !== t; ) {
              if (3 === t.tag) {
                Rs(t, e, n);
                break;
              }
              if (1 === t.tag) {
                var r = t.stateNode;
                if (
                  "function" == typeof t.type.getDerivedStateFromError ||
                  ("function" == typeof r.componentDidCatch &&
                    (null === $l || !$l.has(r)))
                ) {
                  var o = ul(t, (e = al(n, e)), 1);
                  if ((di(t, o), (o = cs()), null !== (t = ps(t, 1))))
                    Zn(t, 1, o), fs(t, o);
                  else if (
                    "function" == typeof r.componentDidCatch &&
                    (null === $l || !$l.has(r))
                  )
                    try {
                      r.componentDidCatch(n, e);
                    } catch (e) {}
                  break;
                }
              }
              t = t.return;
            }
        }
        function Vs(e, n, t) {
          var r = e.pingCache;
          null !== r && r.delete(n),
            (n = cs()),
            (e.pingedLanes |= e.suspendedLanes & t),
            Tl === e &&
              (Ol & t) === t &&
              (4 === Pl ||
              (3 === Pl && (62914560 & Ol) === Ol && 500 > Zo() - zl)
                ? xs(e, 0)
                : (Bl |= t)),
            fs(e, n);
        }
        function Ds(e, n) {
          var t = e.stateNode;
          null !== t && t.delete(n),
            0 == (n = 0) &&
              (0 == (2 & (n = e.mode))
                ? (n = 1)
                : 0 == (4 & n)
                ? (n = 99 === Fo() ? 1 : 2)
                : (0 === is && (is = Hl),
                  0 === (n = Wn(62914560 & ~is)) && (n = 4194304))),
            (t = cs()),
            null !== (e = ps(e, n)) && (Zn(e, n, t), fs(e, t));
        }
        function Bs(e, n, t, r) {
          (this.tag = e),
            (this.key = t),
            (this.sibling =
              this.child =
              this.return =
              this.stateNode =
              this.type =
              this.elementType =
                null),
            (this.index = 0),
            (this.ref = null),
            (this.pendingProps = n),
            (this.dependencies =
              this.memoizedState =
              this.updateQueue =
              this.memoizedProps =
                null),
            (this.mode = r),
            (this.flags = 0),
            (this.lastEffect = this.firstEffect = this.nextEffect = null),
            (this.childLanes = this.lanes = 0),
            (this.alternate = null);
        }
        function Ws(e, n, t, r) {
          return new Bs(e, n, t, r);
        }
        function zs(e) {
          return !(!(e = e.prototype) || !e.isReactComponent);
        }
        function Zs(e, n) {
          var t = e.alternate;
          return (
            null === t
              ? (((t = Ws(e.tag, n, e.key, e.mode)).elementType =
                  e.elementType),
                (t.type = e.type),
                (t.stateNode = e.stateNode),
                (t.alternate = e),
                (e.alternate = t))
              : ((t.pendingProps = n),
                (t.type = e.type),
                (t.flags = 0),
                (t.nextEffect = null),
                (t.firstEffect = null),
                (t.lastEffect = null)),
            (t.childLanes = e.childLanes),
            (t.lanes = e.lanes),
            (t.child = e.child),
            (t.memoizedProps = e.memoizedProps),
            (t.memoizedState = e.memoizedState),
            (t.updateQueue = e.updateQueue),
            (n = e.dependencies),
            (t.dependencies =
              null === n
                ? null
                : { lanes: n.lanes, firstContext: n.firstContext }),
            (t.sibling = e.sibling),
            (t.index = e.index),
            (t.ref = e.ref),
            t
          );
        }
        function Fs(e, n, t, r, o, i) {
          var l = 2;
          if (((r = e), "function" == typeof e)) zs(e) && (l = 1);
          else if ("string" == typeof e) l = 5;
          else
            e: switch (e) {
              case k:
                return Us(t.children, o, i, n);
              case R:
                (l = 8), (o |= 16);
                break;
              case L:
                (l = 8), (o |= 1);
                break;
              case j:
                return (
                  ((e = Ws(12, t, n, 8 | o)).elementType = j),
                  (e.type = j),
                  (e.lanes = i),
                  e
                );
              case T:
                return (
                  ((e = Ws(13, t, n, o)).type = T),
                  (e.elementType = T),
                  (e.lanes = i),
                  e
                );
              case N:
                return (
                  ((e = Ws(19, t, n, o)).elementType = N), (e.lanes = i), e
                );
              case H:
                return Ks(t, o, i, n);
              case V:
                return (
                  ((e = Ws(24, t, n, o)).elementType = V), (e.lanes = i), e
                );
              default:
                if ("object" == typeof e && null !== e)
                  switch (e.$$typeof) {
                    case E:
                      l = 10;
                      break e;
                    case S:
                      l = 9;
                      break e;
                    case M:
                      l = 11;
                      break e;
                    case O:
                      l = 14;
                      break e;
                    case A:
                      (l = 16), (r = null);
                      break e;
                    case I:
                      l = 22;
                      break e;
                  }
                throw Error(a(130, null == e ? e : typeof e, ""));
            }
          return (
            ((n = Ws(l, t, n, o)).elementType = e),
            (n.type = r),
            (n.lanes = i),
            n
          );
        }
        function Us(e, n, t, r) {
          return ((e = Ws(7, e, r, n)).lanes = t), e;
        }
        function Ks(e, n, t, r) {
          return ((e = Ws(23, e, r, n)).elementType = H), (e.lanes = t), e;
        }
        function Gs(e, n, t) {
          return ((e = Ws(6, e, null, n)).lanes = t), e;
        }
        function Ys(e, n, t) {
          return (
            ((n = Ws(
              4,
              null !== e.children ? e.children : [],
              e.key,
              n
            )).lanes = t),
            (n.stateNode = {
              containerInfo: e.containerInfo,
              pendingChildren: null,
              implementation: e.implementation,
            }),
            n
          );
        }
        function $s(e, n, t) {
          (this.tag = n),
            (this.containerInfo = e),
            (this.finishedWork =
              this.pingCache =
              this.current =
              this.pendingChildren =
                null),
            (this.timeoutHandle = -1),
            (this.pendingContext = this.context = null),
            (this.hydrate = t),
            (this.callbackNode = null),
            (this.callbackPriority = 0),
            (this.eventTimes = zn(0)),
            (this.expirationTimes = zn(-1)),
            (this.entangledLanes =
              this.finishedLanes =
              this.mutableReadLanes =
              this.expiredLanes =
              this.pingedLanes =
              this.suspendedLanes =
              this.pendingLanes =
                0),
            (this.entanglements = zn(0)),
            (this.mutableSourceEagerHydrationData = null);
        }
        function qs(e, n, t) {
          var r =
            3 < arguments.length && void 0 !== arguments[3]
              ? arguments[3]
              : null;
          return {
            $$typeof: w,
            key: null == r ? null : "" + r,
            children: e,
            containerInfo: n,
            implementation: t,
          };
        }
        function Qs(e, n, t, r) {
          var o = n.current,
            i = cs(),
            l = us(o);
          e: if (t) {
            n: {
              if ($e((t = t._reactInternals)) !== t || 1 !== t.tag)
                throw Error(a(170));
              var s = t;
              do {
                switch (s.tag) {
                  case 3:
                    s = s.stateNode.context;
                    break n;
                  case 1:
                    if (go(s.type)) {
                      s = s.stateNode.__reactInternalMemoizedMergedChildContext;
                      break n;
                    }
                }
                s = s.return;
              } while (null !== s);
              throw Error(a(171));
            }
            if (1 === t.tag) {
              var c = t.type;
              if (go(c)) {
                t = bo(t, c, s);
                break e;
              }
            }
            t = s;
          } else t = po;
          return (
            null === n.context ? (n.context = t) : (n.pendingContext = t),
            ((n = ui(i, l)).payload = { element: e }),
            null !== (r = void 0 === r ? null : r) && (n.callback = r),
            di(o, n),
            ds(o, l, i),
            l
          );
        }
        function Xs(e) {
          return (e = e.current).child
            ? (e.child.tag, e.child.stateNode)
            : null;
        }
        function Js(e, n) {
          if (null !== (e = e.memoizedState) && null !== e.dehydrated) {
            var t = e.retryLane;
            e.retryLane = 0 !== t && t < n ? t : n;
          }
        }
        function ec(e, n) {
          Js(e, n), (e = e.alternate) && Js(e, n);
        }
        function nc(e, n, t) {
          var r =
            (null != t &&
              null != t.hydrationOptions &&
              t.hydrationOptions.mutableSources) ||
            null;
          if (
            ((t = new $s(e, n, null != t && !0 === t.hydrate)),
            (n = Ws(3, null, null, 2 === n ? 7 : 1 === n ? 3 : 0)),
            (t.current = n),
            (n.stateNode = t),
            si(n),
            (e[Jr] = t.current),
            Nr(8 === e.nodeType ? e.parentNode : e),
            r)
          )
            for (e = 0; e < r.length; e++) {
              var o = (n = r[e])._getVersion;
              (o = o(n._source)),
                null == t.mutableSourceEagerHydrationData
                  ? (t.mutableSourceEagerHydrationData = [n, o])
                  : t.mutableSourceEagerHydrationData.push(n, o);
            }
          this._internalRoot = t;
        }
        function tc(e) {
          return !(
            !e ||
            (1 !== e.nodeType &&
              9 !== e.nodeType &&
              11 !== e.nodeType &&
              (8 !== e.nodeType ||
                " react-mount-point-unstable " !== e.nodeValue))
          );
        }
        function rc(e, n, t, r, o) {
          var i = t._reactRootContainer;
          if (i) {
            var a = i._internalRoot;
            if ("function" == typeof o) {
              var l = o;
              o = function () {
                var e = Xs(a);
                l.call(e);
              };
            }
            Qs(n, a, e, o);
          } else {
            if (
              ((i = t._reactRootContainer =
                (function (e, n) {
                  if (
                    (n ||
                      (n = !(
                        !(n = e
                          ? 9 === e.nodeType
                            ? e.documentElement
                            : e.firstChild
                          : null) ||
                        1 !== n.nodeType ||
                        !n.hasAttribute("data-reactroot")
                      )),
                    !n)
                  )
                    for (var t; (t = e.lastChild); ) e.removeChild(t);
                  return new nc(e, 0, n ? { hydrate: !0 } : void 0);
                })(t, r)),
              (a = i._internalRoot),
              "function" == typeof o)
            ) {
              var s = o;
              o = function () {
                var e = Xs(a);
                s.call(e);
              };
            }
            vs(function () {
              Qs(n, a, e, o);
            });
          }
          return Xs(a);
        }
        function oc(e, n) {
          var t =
            2 < arguments.length && void 0 !== arguments[2]
              ? arguments[2]
              : null;
          if (!tc(n)) throw Error(a(200));
          return qs(e, n, null, t);
        }
        (Ul = function (e, n, t) {
          var r = n.lanes;
          if (null !== e)
            if (e.memoizedProps !== n.pendingProps || ho.current) Ra = !0;
            else {
              if (0 == (t & r)) {
                switch (((Ra = !1), n.tag)) {
                  case 3:
                    Ka(n), Gi();
                    break;
                  case 5:
                    Pi(n);
                    break;
                  case 1:
                    go(n.type) && xo(n);
                    break;
                  case 4:
                    Ai(n, n.stateNode.containerInfo);
                    break;
                  case 10:
                    r = n.memoizedProps.value;
                    var o = n.type._context;
                    uo(Xo, o._currentValue), (o._currentValue = r);
                    break;
                  case 13:
                    if (null !== n.memoizedState)
                      return 0 != (t & n.child.childLanes)
                        ? Qa(e, n, t)
                        : (uo(Hi, 1 & Hi.current),
                          null !== (n = tl(e, n, t)) ? n.sibling : null);
                    uo(Hi, 1 & Hi.current);
                    break;
                  case 19:
                    if (((r = 0 != (t & n.childLanes)), 0 != (64 & e.flags))) {
                      if (r) return nl(e, n, t);
                      n.flags |= 64;
                    }
                    if (
                      (null !== (o = n.memoizedState) &&
                        ((o.rendering = null),
                        (o.tail = null),
                        (o.lastEffect = null)),
                      uo(Hi, Hi.current),
                      r)
                    )
                      break;
                    return null;
                  case 23:
                  case 24:
                    return (n.lanes = 0), Wa(e, n, t);
                }
                return tl(e, n, t);
              }
              Ra = 0 != (16384 & e.flags);
            }
          else Ra = !1;
          switch (((n.lanes = 0), n.tag)) {
            case 2:
              if (
                ((r = n.type),
                null !== e &&
                  ((e.alternate = null), (n.alternate = null), (n.flags |= 2)),
                (e = n.pendingProps),
                (o = _o(n, fo.current)),
                ii(n, t),
                (o = aa(null, n, r, e, o, t)),
                (n.flags |= 1),
                "object" == typeof o &&
                  null !== o &&
                  "function" == typeof o.render &&
                  void 0 === o.$$typeof)
              ) {
                if (
                  ((n.tag = 1),
                  (n.memoizedState = null),
                  (n.updateQueue = null),
                  go(r))
                ) {
                  var i = !0;
                  xo(n);
                } else i = !1;
                (n.memoizedState =
                  null !== o.state && void 0 !== o.state ? o.state : null),
                  si(n);
                var l = r.getDerivedStateFromProps;
                "function" == typeof l && _i(n, r, l, e),
                  (o.updater = gi),
                  (n.stateNode = o),
                  (o._reactInternals = n),
                  xi(n, r, e, t),
                  (n = Ua(null, n, r, !0, i, t));
              } else (n.tag = 0), Ha(null, n, o, t), (n = n.child);
              return n;
            case 16:
              o = n.elementType;
              e: {
                switch (
                  (null !== e &&
                    ((e.alternate = null),
                    (n.alternate = null),
                    (n.flags |= 2)),
                  (e = n.pendingProps),
                  (o = (i = o._init)(o._payload)),
                  (n.type = o),
                  (i = n.tag =
                    (function (e) {
                      if ("function" == typeof e) return zs(e) ? 1 : 0;
                      if (null != e) {
                        if ((e = e.$$typeof) === M) return 11;
                        if (e === O) return 14;
                      }
                      return 2;
                    })(o)),
                  (e = Qo(o, e)),
                  i)
                ) {
                  case 0:
                    n = Za(null, n, o, e, t);
                    break e;
                  case 1:
                    n = Fa(null, n, o, e, t);
                    break e;
                  case 11:
                    n = Va(null, n, o, e, t);
                    break e;
                  case 14:
                    n = Da(null, n, o, Qo(o.type, e), r, t);
                    break e;
                }
                throw Error(a(306, o, ""));
              }
              return n;
            case 0:
              return (
                (r = n.type),
                (o = n.pendingProps),
                Za(e, n, r, (o = n.elementType === r ? o : Qo(r, o)), t)
              );
            case 1:
              return (
                (r = n.type),
                (o = n.pendingProps),
                Fa(e, n, r, (o = n.elementType === r ? o : Qo(r, o)), t)
              );
            case 3:
              if ((Ka(n), (r = n.updateQueue), null === e || null === r))
                throw Error(a(282));
              if (
                ((r = n.pendingProps),
                (o = null !== (o = n.memoizedState) ? o.element : null),
                ci(e, n),
                fi(n, r, null, t),
                (r = n.memoizedState.element) === o)
              )
                Gi(), (n = tl(e, n, t));
              else {
                if (
                  ((i = (o = n.stateNode).hydrate) &&
                    ((Bi = Gr(n.stateNode.containerInfo.firstChild)),
                    (Di = n),
                    (i = Wi = !0)),
                  i)
                ) {
                  if (null != (e = o.mutableSourceEagerHydrationData))
                    for (o = 0; o < e.length; o += 2)
                      ((i = e[o])._workInProgressVersionPrimary = e[o + 1]),
                        Yi.push(i);
                  for (t = Ei(n, null, r, t), n.child = t; t; )
                    (t.flags = (-3 & t.flags) | 1024), (t = t.sibling);
                } else Ha(e, n, r, t), Gi();
                n = n.child;
              }
              return n;
            case 5:
              return (
                Pi(n),
                null === e && Fi(n),
                (r = n.type),
                (o = n.pendingProps),
                (i = null !== e ? e.memoizedProps : null),
                (l = o.children),
                Zr(r, o)
                  ? (l = null)
                  : null !== i && Zr(r, i) && (n.flags |= 16),
                za(e, n),
                Ha(e, n, l, t),
                n.child
              );
            case 6:
              return null === e && Fi(n), null;
            case 13:
              return Qa(e, n, t);
            case 4:
              return (
                Ai(n, n.stateNode.containerInfo),
                (r = n.pendingProps),
                null === e ? (n.child = ji(n, null, r, t)) : Ha(e, n, r, t),
                n.child
              );
            case 11:
              return (
                (r = n.type),
                (o = n.pendingProps),
                Va(e, n, r, (o = n.elementType === r ? o : Qo(r, o)), t)
              );
            case 7:
              return Ha(e, n, n.pendingProps, t), n.child;
            case 8:
            case 12:
              return Ha(e, n, n.pendingProps.children, t), n.child;
            case 10:
              e: {
                (r = n.type._context),
                  (o = n.pendingProps),
                  (l = n.memoizedProps),
                  (i = o.value);
                var s = n.type._context;
                if (
                  (uo(Xo, s._currentValue), (s._currentValue = i), null !== l)
                )
                  if (
                    ((s = l.value),
                    0 ==
                      (i = cr(s, i)
                        ? 0
                        : 0 |
                          ("function" == typeof r._calculateChangedBits
                            ? r._calculateChangedBits(s, i)
                            : 1073741823)))
                  ) {
                    if (l.children === o.children && !ho.current) {
                      n = tl(e, n, t);
                      break e;
                    }
                  } else
                    for (
                      null !== (s = n.child) && (s.return = n);
                      null !== s;

                    ) {
                      var c = s.dependencies;
                      if (null !== c) {
                        l = s.child;
                        for (var u = c.firstContext; null !== u; ) {
                          if (u.context === r && 0 != (u.observedBits & i)) {
                            1 === s.tag &&
                              (((u = ui(-1, t & -t)).tag = 2), di(s, u)),
                              (s.lanes |= t),
                              null !== (u = s.alternate) && (u.lanes |= t),
                              oi(s.return, t),
                              (c.lanes |= t);
                            break;
                          }
                          u = u.next;
                        }
                      } else
                        l = 10 === s.tag && s.type === n.type ? null : s.child;
                      if (null !== l) l.return = s;
                      else
                        for (l = s; null !== l; ) {
                          if (l === n) {
                            l = null;
                            break;
                          }
                          if (null !== (s = l.sibling)) {
                            (s.return = l.return), (l = s);
                            break;
                          }
                          l = l.return;
                        }
                      s = l;
                    }
                Ha(e, n, o.children, t), (n = n.child);
              }
              return n;
            case 9:
              return (
                (o = n.type),
                (r = (i = n.pendingProps).children),
                ii(n, t),
                (r = r((o = ai(o, i.unstable_observedBits)))),
                (n.flags |= 1),
                Ha(e, n, r, t),
                n.child
              );
            case 14:
              return (
                (i = Qo((o = n.type), n.pendingProps)),
                Da(e, n, o, (i = Qo(o.type, i)), r, t)
              );
            case 15:
              return Ba(e, n, n.type, n.pendingProps, r, t);
            case 17:
              return (
                (r = n.type),
                (o = n.pendingProps),
                (o = n.elementType === r ? o : Qo(r, o)),
                null !== e &&
                  ((e.alternate = null), (n.alternate = null), (n.flags |= 2)),
                (n.tag = 1),
                go(r) ? ((e = !0), xo(n)) : (e = !1),
                ii(n, t),
                Ci(n, r, o),
                xi(n, r, o, t),
                Ua(null, n, r, !0, e, t)
              );
            case 19:
              return nl(e, n, t);
            case 23:
            case 24:
              return Wa(e, n, t);
          }
          throw Error(a(156, n.tag));
        }),
          (nc.prototype.render = function (e) {
            Qs(e, this._internalRoot, null, null);
          }),
          (nc.prototype.unmount = function () {
            var e = this._internalRoot,
              n = e.containerInfo;
            Qs(null, e, null, function () {
              n[Jr] = null;
            });
          }),
          (en = function (e) {
            13 === e.tag && (ds(e, 4, cs()), ec(e, 4));
          }),
          (nn = function (e) {
            13 === e.tag && (ds(e, 67108864, cs()), ec(e, 67108864));
          }),
          (tn = function (e) {
            if (13 === e.tag) {
              var n = cs(),
                t = us(e);
              ds(e, t, n), ec(e, t);
            }
          }),
          (rn = function (e, n) {
            return n();
          }),
          (je = function (e, n, t) {
            switch (n) {
              case "input":
                if ((te(e, t), (n = t.name), "radio" === t.type && null != n)) {
                  for (t = e; t.parentNode; ) t = t.parentNode;
                  for (
                    t = t.querySelectorAll(
                      "input[name=" + JSON.stringify("" + n) + '][type="radio"]'
                    ),
                      n = 0;
                    n < t.length;
                    n++
                  ) {
                    var r = t[n];
                    if (r !== e && r.form === e.form) {
                      var o = oo(r);
                      if (!o) throw Error(a(90));
                      Q(r), te(r, o);
                    }
                  }
                }
                break;
              case "textarea":
                ce(e, t);
                break;
              case "select":
                null != (n = t.value) && ae(e, !!t.multiple, n, !1);
            }
          }),
          (Oe = gs),
          (Ae = function (e, n, t, r, o) {
            var i = Ml;
            Ml |= 4;
            try {
              return Ko(98, e.bind(null, n, t, r, o));
            } finally {
              0 === (Ml = i) && (Fl(), Yo());
            }
          }),
          (Ie = function () {
            0 == (49 & Ml) &&
              ((function () {
                if (null !== ns) {
                  var e = ns;
                  (ns = null),
                    e.forEach(function (e) {
                      (e.expiredLanes |= 24 & e.pendingLanes), fs(e, Zo());
                    });
                }
                Yo();
              })(),
              Os());
          }),
          (Pe = function (e, n) {
            var t = Ml;
            Ml |= 2;
            try {
              return e(n);
            } finally {
              0 === (Ml = t) && (Fl(), Yo());
            }
          });
        var ic = { Events: [to, ro, oo, Te, Ne, Os, { current: !1 }] },
          ac = {
            findFiberByHostInstance: no,
            bundleType: 0,
            version: "17.0.2",
            rendererPackageName: "react-dom",
          },
          lc = {
            bundleType: ac.bundleType,
            version: ac.version,
            rendererPackageName: ac.rendererPackageName,
            rendererConfig: ac.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: x.ReactCurrentDispatcher,
            findHostInstanceByFiber: function (e) {
              return null === (e = Xe(e)) ? null : e.stateNode;
            },
            findFiberByHostInstance:
              ac.findFiberByHostInstance ||
              function () {
                return null;
              },
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null,
          };
        if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
          var sc = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (!sc.isDisabled && sc.supportsFiber)
            try {
              (wo = sc.inject(lc)), (ko = sc);
            } catch (me) {}
        }
        (n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ic),
          (n.createPortal = oc),
          (n.findDOMNode = function (e) {
            if (null == e) return null;
            if (1 === e.nodeType) return e;
            var n = e._reactInternals;
            if (void 0 === n) {
              if ("function" == typeof e.render) throw Error(a(188));
              throw Error(a(268, Object.keys(e)));
            }
            return null === (e = Xe(n)) ? null : e.stateNode;
          }),
          (n.flushSync = function (e, n) {
            var t = Ml;
            if (0 != (48 & t)) return e(n);
            Ml |= 1;
            try {
              if (e) return Ko(99, e.bind(null, n));
            } finally {
              (Ml = t), Yo();
            }
          }),
          (n.hydrate = function (e, n, t) {
            if (!tc(n)) throw Error(a(200));
            return rc(null, e, n, !0, t);
          }),
          (n.render = function (e, n, t) {
            if (!tc(n)) throw Error(a(200));
            return rc(null, e, n, !1, t);
          }),
          (n.unmountComponentAtNode = function (e) {
            if (!tc(e)) throw Error(a(40));
            return (
              !!e._reactRootContainer &&
              (vs(function () {
                rc(null, null, e, !1, function () {
                  (e._reactRootContainer = null), (e[Jr] = null);
                });
              }),
              !0)
            );
          }),
          (n.unstable_batchedUpdates = gs),
          (n.unstable_createPortal = function (e, n) {
            return oc(
              e,
              n,
              2 < arguments.length && void 0 !== arguments[2]
                ? arguments[2]
                : null
            );
          }),
          (n.unstable_renderSubtreeIntoContainer = function (e, n, t, r) {
            if (!tc(t)) throw Error(a(200));
            if (null == e || void 0 === e._reactInternals) throw Error(a(38));
            return rc(e, n, t, !1, r);
          }),
          (n.version = "17.0.2");
      },
      935: function (e, n, t) {
        "use strict";
        !(function e() {
          if (
            "undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
            "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
            } catch (e) {
              console.error(e);
            }
        })(),
          (e.exports = t(448));
      },
      251: function (e, n, t) {
        "use strict";
        t(418);
        var r = t(497),
          o = 60103;
        if (((n.Fragment = 60107), "function" == typeof Symbol && Symbol.for)) {
          var i = Symbol.for;
          (o = i("react.element")), (n.Fragment = i("react.fragment"));
        }
        var a =
            r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
              .ReactCurrentOwner,
          l = Object.prototype.hasOwnProperty,
          s = { key: !0, ref: !0, __self: !0, __source: !0 };
        function c(e, n, t) {
          var r,
            i = {},
            c = null,
            u = null;
          for (r in (void 0 !== t && (c = "" + t),
          void 0 !== n.key && (c = "" + n.key),
          void 0 !== n.ref && (u = n.ref),
          n))
            l.call(n, r) && !s.hasOwnProperty(r) && (i[r] = n[r]);
          if (e && e.defaultProps)
            for (r in (n = e.defaultProps)) void 0 === i[r] && (i[r] = n[r]);
          return {
            $$typeof: o,
            type: e,
            key: c,
            ref: u,
            props: i,
            _owner: a.current,
          };
        }
        (n.jsx = c), (n.jsxs = c);
      },
      893: function (e, n, t) {
        "use strict";
        e.exports = t(251);
      },
      53: function (e, n) {
        "use strict";
        var t, r, o, i;
        if (
          "object" == typeof performance &&
          "function" == typeof performance.now
        ) {
          var a = performance;
          n.unstable_now = function () {
            return a.now();
          };
        } else {
          var l = Date,
            s = l.now();
          n.unstable_now = function () {
            return l.now() - s;
          };
        }
        if (
          "undefined" == typeof window ||
          "function" != typeof MessageChannel
        ) {
          var c = null,
            u = null,
            d = function () {
              if (null !== c)
                try {
                  var e = n.unstable_now();
                  c(!0, e), (c = null);
                } catch (e) {
                  throw (setTimeout(d, 0), e);
                }
            };
          (t = function (e) {
            null !== c ? setTimeout(t, 0, e) : ((c = e), setTimeout(d, 0));
          }),
            (r = function (e, n) {
              u = setTimeout(e, n);
            }),
            (o = function () {
              clearTimeout(u);
            }),
            (n.unstable_shouldYield = function () {
              return !1;
            }),
            (i = n.unstable_forceFrameRate = function () {});
        } else {
          var p = window.setTimeout,
            f = window.clearTimeout;
          if ("undefined" != typeof console) {
            var h = window.cancelAnimationFrame;
            "function" != typeof window.requestAnimationFrame &&
              console.error(
                "This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"
              ),
              "function" != typeof h &&
                console.error(
                  "This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"
                );
          }
          var m = !1,
            _ = null,
            g = -1,
            v = 5,
            C = 0;
          (n.unstable_shouldYield = function () {
            return n.unstable_now() >= C;
          }),
            (i = function () {}),
            (n.unstable_forceFrameRate = function (e) {
              0 > e || 125 < e
                ? console.error(
                    "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
                  )
                : (v = 0 < e ? Math.floor(1e3 / e) : 5);
            });
          var b = new MessageChannel(),
            x = b.port2;
          (b.port1.onmessage = function () {
            if (null !== _) {
              var e = n.unstable_now();
              C = e + v;
              try {
                _(!0, e) ? x.postMessage(null) : ((m = !1), (_ = null));
              } catch (e) {
                throw (x.postMessage(null), e);
              }
            } else m = !1;
          }),
            (t = function (e) {
              (_ = e), m || ((m = !0), x.postMessage(null));
            }),
            (r = function (e, t) {
              g = p(function () {
                e(n.unstable_now());
              }, t);
            }),
            (o = function () {
              f(g), (g = -1);
            });
        }
        function y(e, n) {
          var t = e.length;
          e.push(n);
          e: for (;;) {
            var r = (t - 1) >>> 1,
              o = e[r];
            if (!(void 0 !== o && 0 < L(o, n))) break e;
            (e[r] = n), (e[t] = o), (t = r);
          }
        }
        function w(e) {
          return void 0 === (e = e[0]) ? null : e;
        }
        function k(e) {
          var n = e[0];
          if (void 0 !== n) {
            var t = e.pop();
            if (t !== n) {
              e[0] = t;
              e: for (var r = 0, o = e.length; r < o; ) {
                var i = 2 * (r + 1) - 1,
                  a = e[i],
                  l = i + 1,
                  s = e[l];
                if (void 0 !== a && 0 > L(a, t))
                  void 0 !== s && 0 > L(s, a)
                    ? ((e[r] = s), (e[l] = t), (r = l))
                    : ((e[r] = a), (e[i] = t), (r = i));
                else {
                  if (!(void 0 !== s && 0 > L(s, t))) break e;
                  (e[r] = s), (e[l] = t), (r = l);
                }
              }
            }
            return n;
          }
          return null;
        }
        function L(e, n) {
          var t = e.sortIndex - n.sortIndex;
          return 0 !== t ? t : e.id - n.id;
        }
        var j = [],
          E = [],
          S = 1,
          M = null,
          T = 3,
          N = !1,
          O = !1,
          A = !1;
        function I(e) {
          for (var n = w(E); null !== n; ) {
            if (null === n.callback) k(E);
            else {
              if (!(n.startTime <= e)) break;
              k(E), (n.sortIndex = n.expirationTime), y(j, n);
            }
            n = w(E);
          }
        }
        function P(e) {
          if (((A = !1), I(e), !O))
            if (null !== w(j)) (O = !0), t(R);
            else {
              var n = w(E);
              null !== n && r(P, n.startTime - e);
            }
        }
        function R(e, t) {
          (O = !1), A && ((A = !1), o()), (N = !0);
          var i = T;
          try {
            for (
              I(t), M = w(j);
              null !== M &&
              (!(M.expirationTime > t) || (e && !n.unstable_shouldYield()));

            ) {
              var a = M.callback;
              if ("function" == typeof a) {
                (M.callback = null), (T = M.priorityLevel);
                var l = a(M.expirationTime <= t);
                (t = n.unstable_now()),
                  "function" == typeof l
                    ? (M.callback = l)
                    : M === w(j) && k(j),
                  I(t);
              } else k(j);
              M = w(j);
            }
            if (null !== M) var s = !0;
            else {
              var c = w(E);
              null !== c && r(P, c.startTime - t), (s = !1);
            }
            return s;
          } finally {
            (M = null), (T = i), (N = !1);
          }
        }
        var H = i;
        (n.unstable_IdlePriority = 5),
          (n.unstable_ImmediatePriority = 1),
          (n.unstable_LowPriority = 4),
          (n.unstable_NormalPriority = 3),
          (n.unstable_Profiling = null),
          (n.unstable_UserBlockingPriority = 2),
          (n.unstable_cancelCallback = function (e) {
            e.callback = null;
          }),
          (n.unstable_continueExecution = function () {
            O || N || ((O = !0), t(R));
          }),
          (n.unstable_getCurrentPriorityLevel = function () {
            return T;
          }),
          (n.unstable_getFirstCallbackNode = function () {
            return w(j);
          }),
          (n.unstable_next = function (e) {
            switch (T) {
              case 1:
              case 2:
              case 3:
                var n = 3;
                break;
              default:
                n = T;
            }
            var t = T;
            T = n;
            try {
              return e();
            } finally {
              T = t;
            }
          }),
          (n.unstable_pauseExecution = function () {}),
          (n.unstable_requestPaint = H),
          (n.unstable_runWithPriority = function (e, n) {
            switch (e) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break;
              default:
                e = 3;
            }
            var t = T;
            T = e;
            try {
              return n();
            } finally {
              T = t;
            }
          }),
          (n.unstable_scheduleCallback = function (e, i, a) {
            var l = n.unstable_now();
            switch (
              ((a =
                "object" == typeof a &&
                null !== a &&
                "number" == typeof (a = a.delay) &&
                0 < a
                  ? l + a
                  : l),
              e)
            ) {
              case 1:
                var s = -1;
                break;
              case 2:
                s = 250;
                break;
              case 5:
                s = 1073741823;
                break;
              case 4:
                s = 1e4;
                break;
              default:
                s = 5e3;
            }
            return (
              (e = {
                id: S++,
                callback: i,
                priorityLevel: e,
                startTime: a,
                expirationTime: (s = a + s),
                sortIndex: -1,
              }),
              a > l
                ? ((e.sortIndex = a),
                  y(E, e),
                  null === w(j) &&
                    e === w(E) &&
                    (A ? o() : (A = !0), r(P, a - l)))
                : ((e.sortIndex = s), y(j, e), O || N || ((O = !0), t(R))),
              e
            );
          }),
          (n.unstable_wrapCallback = function (e) {
            var n = T;
            return function () {
              var t = T;
              T = n;
              try {
                return e.apply(this, arguments);
              } finally {
                T = t;
              }
            };
          });
      },
      840: function (e, n, t) {
        "use strict";
        e.exports = t(53);
      },
      217: function (e, n, t) {
        var r = t(379),
          o = t(128);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[e.id, o, ""]]);
        r(o, { insert: "head", singleton: !1 }), (e.exports = o.locals || {});
      },
      411: function (e, n, t) {
        var r = t(379),
          o = t(949);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[e.id, o, ""]]);
        r(o, { insert: "head", singleton: !1 }), (e.exports = o.locals || {});
      },
      413: function (e, n, t) {
        var r = t(379),
          o = t(770);
        "string" == typeof (o = o.__esModule ? o.default : o) &&
          (o = [[e.id, o, ""]]);
        r(o, { insert: "head", singleton: !1 }), (e.exports = o.locals || {});
      },
      379: function (e, n, t) {
        "use strict";
        var r,
          o = (function () {
            var e = {};
            return function (n) {
              if (void 0 === e[n]) {
                var t = document.querySelector(n);
                if (
                  window.HTMLIFrameElement &&
                  t instanceof window.HTMLIFrameElement
                )
                  try {
                    t = t.contentDocument.head;
                  } catch (e) {
                    t = null;
                  }
                e[n] = t;
              }
              return e[n];
            };
          })(),
          i = [];
        function a(e) {
          for (var n = -1, t = 0; t < i.length; t++)
            if (i[t].identifier === e) {
              n = t;
              break;
            }
          return n;
        }
        function l(e, n) {
          for (var t = {}, r = [], o = 0; o < e.length; o++) {
            var l = e[o],
              s = n.base ? l[0] + n.base : l[0],
              c = t[s] || 0,
              u = "".concat(s, " ").concat(c);
            t[s] = c + 1;
            var d = a(u),
              p = { css: l[1], media: l[2], sourceMap: l[3] };
            -1 !== d
              ? (i[d].references++, i[d].updater(p))
              : i.push({ identifier: u, updater: m(p, n), references: 1 }),
              r.push(u);
          }
          return r;
        }
        function s(e) {
          var n = document.createElement("style"),
            r = e.attributes || {};
          if (void 0 === r.nonce) {
            var i = t.nc;
            i && (r.nonce = i);
          }
          if (
            (Object.keys(r).forEach(function (e) {
              n.setAttribute(e, r[e]);
            }),
            "function" == typeof e.insert)
          )
            e.insert(n);
          else {
            var a = o(e.insert || "head");
            if (!a)
              throw new Error(
                "Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid."
              );
            a.appendChild(n);
          }
          return n;
        }
        var c,
          u =
            ((c = []),
            function (e, n) {
              return (c[e] = n), c.filter(Boolean).join("\n");
            });
        function d(e, n, t, r) {
          var o = t
            ? ""
            : r.media
            ? "@media ".concat(r.media, " {").concat(r.css, "}")
            : r.css;
          if (e.styleSheet) e.styleSheet.cssText = u(n, o);
          else {
            var i = document.createTextNode(o),
              a = e.childNodes;
            a[n] && e.removeChild(a[n]),
              a.length ? e.insertBefore(i, a[n]) : e.appendChild(i);
          }
        }
        function p(e, n, t) {
          var r = t.css,
            o = t.media,
            i = t.sourceMap;
          if (
            (o ? e.setAttribute("media", o) : e.removeAttribute("media"),
            i &&
              "undefined" != typeof btoa &&
              (r +=
                "\n/*# sourceMappingURL=data:application/json;base64,".concat(
                  btoa(unescape(encodeURIComponent(JSON.stringify(i)))),
                  " */"
                )),
            e.styleSheet)
          )
            e.styleSheet.cssText = r;
          else {
            for (; e.firstChild; ) e.removeChild(e.firstChild);
            e.appendChild(document.createTextNode(r));
          }
        }
        var f = null,
          h = 0;
        function m(e, n) {
          var t, r, o;
          if (n.singleton) {
            var i = h++;
            (t = f || (f = s(n))),
              (r = d.bind(null, t, i, !1)),
              (o = d.bind(null, t, i, !0));
          } else
            (t = s(n)),
              (r = p.bind(null, t, n)),
              (o = function () {
                !(function (e) {
                  if (null === e.parentNode) return !1;
                  e.parentNode.removeChild(e);
                })(t);
              });
          return (
            r(e),
            function (n) {
              if (n) {
                if (
                  n.css === e.css &&
                  n.media === e.media &&
                  n.sourceMap === e.sourceMap
                )
                  return;
                r((e = n));
              } else o();
            }
          );
        }
        e.exports = function (e, n) {
          (n = n || {}).singleton ||
            "boolean" == typeof n.singleton ||
            (n.singleton =
              (void 0 === r &&
                (r = Boolean(
                  window && document && document.all && !window.atob
                )),
              r));
          var t = l((e = e || []), n);
          return function (e) {
            if (
              ((e = e || []),
              "[object Array]" === Object.prototype.toString.call(e))
            ) {
              for (var r = 0; r < t.length; r++) {
                var o = a(t[r]);
                i[o].references--;
              }
              for (var s = l(e, n), c = 0; c < t.length; c++) {
                var u = a(t[c]);
                0 === i[u].references && (i[u].updater(), i.splice(u, 1));
              }
              t = s;
            }
          };
        };
      },
      772: function (e, n, t) {
        "use strict";
        var r = t(331);
        function o() {}
        function i() {}
        (i.resetWarningCache = o),
          (e.exports = function () {
            function e(e, n, t, o, i, a) {
              if (a !== r) {
                var l = new Error(
                  "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
                );
                throw ((l.name = "Invariant Violation"), l);
              }
            }
            function n() {
              return e;
            }
            e.isRequired = e;
            var t = {
              array: e,
              bigint: e,
              bool: e,
              func: e,
              number: e,
              object: e,
              string: e,
              symbol: e,
              any: e,
              arrayOf: n,
              element: e,
              elementType: e,
              instanceOf: n,
              node: e,
              objectOf: n,
              oneOf: n,
              oneOfType: n,
              shape: n,
              exact: n,
              checkPropTypes: i,
              resetWarningCache: o,
            };
            return (t.PropTypes = t), t;
          });
      },
      615: function (e, n, t) {
        e.exports = t(772)();
      },
      331: function (e) {
        "use strict";
        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      },
      497: function (e) {
        "use strict";
        e.exports = require("react");
      },
    },
    r = {};
  function o(e) {
    var n = r[e];
    if (void 0 !== n) return n.exports;
    var i = (r[e] = { id: e, exports: {} });
    return t[e](i, i.exports, o), i.exports;
  }
  (o.n = function (e) {
    var n =
      e && e.__esModule
        ? function () {
            return e.default;
          }
        : function () {
            return e;
          };
    return o.d(n, { a: n }), n;
  }),
    (n = Object.getPrototypeOf
      ? function (e) {
          return Object.getPrototypeOf(e);
        }
      : function (e) {
          return e.__proto__;
        }),
    (o.t = function (t, r) {
      if ((1 & r && (t = this(t)), 8 & r)) return t;
      if ("object" == typeof t && t) {
        if (4 & r && t.__esModule) return t;
        if (16 & r && "function" == typeof t.then) return t;
      }
      var i = Object.create(null);
      o.r(i);
      var a = {};
      e = e || [null, n({}), n([]), n(n)];
      for (var l = 2 & r && t; "object" == typeof l && !~e.indexOf(l); l = n(l))
        Object.getOwnPropertyNames(l).forEach(function (e) {
          a[e] = function () {
            return t[e];
          };
        });
      return (
        (a.default = function () {
          return t;
        }),
        o.d(i, a),
        i
      );
    }),
    (o.d = function (e, n) {
      for (var t in n)
        o.o(n, t) &&
          !o.o(e, t) &&
          Object.defineProperty(e, t, { enumerable: !0, get: n[t] });
    }),
    (o.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    })()),
    (o.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }),
    (o.r = function (e) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    }),
    (o.nc = void 0);
  var i = {};
  !(function () {
    "use strict";
    o.r(i),
      o.d(i, {
        default: function () {
          return Vl;
        },
      });
    var e = o(497),
      n = o.t(e, 2),
      t = o.n(e),
      r = (0, e.createContext)(),
      a = "automation",
      l = "auth/sso",
      s = "sub-organizations",
      c = "support",
      u = "private-real-device",
      d = "usage-report",
      p = "archives",
      f = "audit-logs",
      h = "billing/promotions",
      m = "build",
      _ = "dashboard",
      g = "hyperexecute/jobs",
      v = "hyperexecute/projects",
      C = "logout",
      b = "console/lt-browser",
      x = "details/profile",
      y = "detail/profile",
      w = "console/project",
      k = "app",
      L = "browser",
      j = "console/realtime/app",
      E = "console/realtime/browser/desktop",
      S = "console/realtime/browser/mobile",
      M = "console/favourites",
      T = "console/recents",
      N = "console/responsive",
      O = "console/screenshot",
      A = "billing/subscriptions",
      I = "detail/team",
      P = "members/users",
      R = "projects",
      H = "console/test-logs",
      V = "console/smart-testing",
      D = "billing/plans",
      B = "accessibility",
      W = "analytics",
      z = "automation",
      Z = "billing",
      F = "accounts",
      U = "downloads",
      K = "hyperexecute",
      G = "integrations",
      Y = "issues",
      $ = "kaneai",
      q = "appautomation",
      Q = "app",
      X = "applive",
      J = "smartui",
      ee = "test-manager",
      ne = {
        ACCESSIBILITY: "accessibility",
        ACCESSIBILITY_AUTOMATED: "accessibility-automated",
        ACCESSIBILITY_MANUAL: "accessibility-manual",
        ACCESS_KEY: "accessKey",
        ADD_TEAM: "add_team",
        ANALYTICS: "analytics",
        ANALYTICS_PRIVATE_REAL_DEVICE: "device-mobile",
        ANALYTICS_USAGE_REPORT: "usage-report",
        ANNOUNCEMENT: "announcement",
        APP_AUTOMATION: "app_automation",
        ARCHIVES: "archives",
        ARROW_CIRCLE_LEFT: "arrow-circle-left",
        ARROW_DOWN: "arrow-down",
        ARROW_LEFT: "arrow-left",
        AUTOMATION: "automation",
        BILLING: "billing",
        BUG: "bug",
        CHAT: "chat",
        COLLAPSE: "collapse",
        COPY: "copy",
        CROSS: "cross",
        CROSS_GRAY: "cross-gray",
        CROSS_RED: "cross-red",
        DASHBOARD: "dashboard",
        DOCUMENTATION: "documentation",
        DOWNLOAD: "download",
        EXPAND: "expand",
        FADERS_SETTING: "faders_setting",
        FAQ: "faq",
        FOLDER: "folder",
        GIFT: "gift",
        GLOBE: "globe",
        HAMBURGER: "hamburger",
        HEADPHONE: "headphone",
        HE_INSIGHTS: "he_insights",
        HE_JOBS: "he_jobs",
        HE_PROJECTS: "he_projects",
        HE_WORKFLOWS: "he_workflows",
        HYPEREXECUTE: "hyperexecute",
        INSIGHTS: "insights",
        INTEGRATIONS: "integrations",
        KANE_AI: "kane-ai",
        KEBAB_ELLIPSIS: "kebab_ellipsis",
        KEY: "key",
        LAMBDATEST: "lambdatest",
        LOGO: "logo",
        LOGO_BLACK: "logo_black",
        LOGO_BLACK_SMALL: "logo_black_small",
        MANAGE: "manage",
        MANAGE_TEAM: "manageTeam",
        MONITOR: "monitor",
        MORE_TOOLS: "more-tools",
        NOTIFICATION: "notification",
        NO_ACCESSIBILITY: "no_accessibility",
        OLD_AUTOMATION: "old-automation",
        OLD_DASHBOARD: "old-dashboard",
        OLD_FADERS_SETTING: "old_faders_setting",
        OLD_HYPEREXECUTE: "old_hyperexecute",
        OLD_INSIGHTS: "old-insights",
        OLD_REAL_DEVICE: "old-real-device",
        OLD_REAL_TIME: "old-real-time",
        OLD_SMART_UI: "old-smart_ui",
        ORG_SETTINGS: "org_settings",
        PHONE: "phone",
        PLAIN_CROSS: "plain-cross",
        QUESTION: "question",
        QUICK_ACTIONS: "quick-actions",
        REAL_DEVICE: "real-device",
        REAL_TIME: "real-time",
        REAL_TIME_APP: "real-time-app",
        REAL_TIME_VIRTUAL_MOBILE: "real-time-virtual-mobile",
        RESPONSIVE: "responsive",
        ROBOT: "robot",
        ROCKET: "rocket",
        SCREENSHOT: "screenshot",
        SETTINGS: "settings",
        SIGN_OUT: "sign_out",
        SMART_UI: "smart_ui",
        SMART_UI_APPROVER_PROJECTS: "smart_ui_approver_projects",
        SMART_UI_PROJECTS: "smart_ui_projects",
        SUCCESS: "success",
        TEST_MANAGER: "test-manager",
        TICK: "tick",
        TMS_PROJECTS: "tms_projects",
        TUNNEL: "tunnel",
        UPGRADE: "upgrade",
        UPTIME_MONITOR: "uptime_monitor",
        USER: "user",
        USER_CIRCLE: "userCircle",
        USER_FEEDBACK: "user_feedback",
        USER_LOCK: "user_lock",
        VISUAL: "visual",
        WALLET: "wallet",
        WEB_AUTOMATION: "web_automation",
        WINDOW: "window",
      },
      te = "concurrency-virtual-mobile",
      re = "concurrency-desktop-automation",
      oe = "concurrency-rd-automation-pvt-cloud",
      ie = "concurrency-rd-automation",
      ae = "concurrency-hyperexecute",
      le = "concurrency-responsive",
      se = "auth",
      ce = "billing-api",
      ue = "ts",
      de = [se, ue, F, U, W, z, K],
      pe = [z, F, K, "dashboard"],
      fe = [33185191, 993697, 1419669, 1607715, 1543565, 1540356],
      he = [F, B, W, Z, G, J, ee, H, V, b, w];
    function me(e) {
      return (
        (function (e) {
          if (Array.isArray(e)) return _e(e);
        })(e) ||
        (function (e) {
          if (
            ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
            null != e["@@iterator"]
          )
            return Array.from(e);
        })(e) ||
        (function (e, n) {
          if (e) {
            if ("string" == typeof e) return _e(e, n);
            var t = Object.prototype.toString.call(e).slice(8, -1);
            return (
              "Object" === t && e.constructor && (t = e.constructor.name),
              "Map" === t || "Set" === t
                ? Array.from(e)
                : "Arguments" === t ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
                ? _e(e, n)
                : void 0
            );
          }
        })(e) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        })()
      );
    }
    function _e(e, n) {
      (null == n || n > e.length) && (n = e.length);
      for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
      return r;
    }
    function ge(e, n, t) {
      return (
        n in e
          ? Object.defineProperty(e, n, {
              value: t,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[n] = t),
        e
      );
    }
    var ve = function (e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
        t =
          arguments.length > 2 && void 0 !== arguments[2]
            ? arguments[2]
            : "https",
        r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "",
        o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "",
        i = window.location.origin;
      if ("https://pre-prod-app.lambdatest.com" === i && e === Q)
        return "https://pre-prod-app.lambdatest.com";
      if ("https://eu-pre-prod-app-new.lambdatest.com" === i && e === Q)
        return "https://eu-pre-prod-app-new.lambdatest.com";
      if ("https://app-beta.lambdatest.com" === i && e === Q)
        return "https://app-beta.lambdatest.com";
      if ("http://eu-beta-app.lambdatest.com" === i && e === Q)
        return "http://eu-beta-app.lambdatest.com";
      if (i.includes("hyperexecute.cloud") || o) {
        if (de.includes(e)) {
          var a = e === K ? "dashboard" : e;
          return Ce(i, o ? "".concat(o, "-").concat(a) : a, t, n, r);
        }
        return be(e, t, n);
      }
      return Ce(i, e, t, n, r);
    };
    function Ce(e, n, t, r) {
      var o =
          arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "",
        i = xe(r),
        a = e.split(".");
      a.shift(),
        (e.includes("lambdatest") || e.includes("hyperexecute.cloud")) &&
          a.length > 2 &&
          a.shift();
      var l = ".".concat(a.join("."));
      l = l.split(":")[0];
      var s = o && pe.includes(n) ? "".concat(n, ".").concat(o) : n;
      return s ? "".concat(t, "://").concat(i).concat(s).concat(l) : l;
    }
    function be(e, n, t) {
      var r = xe(t),
        o = ye() ? ".lambdatestinternal.com" : ".lambdatest.com";
      return e ? "".concat(n, "://").concat(r).concat(e).concat(o) : o;
    }
    function xe() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
        n = window.location.hostname;
      return !e && n.startsWith("stage-eu-")
        ? "stage-eu-"
        : ye()
        ? "stage-"
        : !e && n.startsWith("eu-")
        ? "eu-"
        : "";
    }
    var ye = function () {
        var e = window.location.hostname;
        return (
          e.startsWith("stage-") ||
          (e.includes("dev") && !e.includes("hyperexecute.cloud"))
        );
      },
      we = function () {
        return window.location.origin.indexOf("eu-") >= 0;
      },
      ke = function () {
        var e = "accessToken";
        ye() && (e = "stageAccessToken");
        var n = "; ".concat(document.cookie).split("; ".concat(e, "="));
        if (2 === n.length) return n.pop().split(";").shift();
      },
      Le = function (e, n, t) {
        var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
        t || (t = 7300);
        var o = new Date();
        o.setTime(o.getTime() + 24 * t * 60 * 60 * 1e3);
        var i = "; expires=" + o.toUTCString();
        window.location.host.includes("hyperexecute.cloud") && !r
          ? (document.cookie =
              e + "=" + n + i + ";domain=.hyperexecute.cloud; path=/")
          : ye()
          ? (document.cookie =
              e + "=" + n + i + ";domain=.lambdatestinternal.com; path=/")
          : (document.cookie =
              e + "=" + n + i + ";domain=.lambdatest.com; path=/");
      },
      je = function () {
        var e = ve(U, !0),
          n = ye() ? "%20Beta" : "",
          t = ye() ? "stage" : "master";
        return Ee()
          ? ""
              .concat(e, "/underpass/")
              .concat(t, "/UnderPass")
              .concat(n, "%20Setup.exe")
          : Se()
          ? ""
              .concat(e, "/underpass/")
              .concat(t, "/UnderPass")
              .concat(n, ".AppImage")
          : ""
              .concat(e, "/underpass/")
              .concat(t, "/UnderPass")
              .concat(n, ".dmg");
      };
    function Ee() {
      return (
        navigator.platform.indexOf("Win") >= 0 ||
        navigator.appVersion.indexOf("Window") >= 0
      );
    }
    function Se() {
      return (
        navigator.platform.indexOf("Linux") >= 0 ||
        navigator.appVersion.indexOf("Linux") >= 0
      );
    }
    var Me = function () {
        var e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        if (e) {
          var n = e.split(" "),
            t = n.shift().charAt(0),
            r = n.length ? n.pop().charAt(0) : "",
            o = t + r;
          return o.toUpperCase();
        }
        return "";
      },
      Te = function (e, n, t) {
        var r = document.createElement("textarea");
        (r.style.position = "fixed"),
          (r.value = e),
          document.body.appendChild(r),
          r.focus(),
          r.select(),
          document.execCommand("copy"),
          document.body.removeChild(r),
          t(ge({}, n, !0)),
          setTimeout(function () {
            t(ge({}, n, !1));
          }, 1e3);
      },
      Ne = function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
          n = arguments.length > 1 ? arguments[1] : void 0,
          t = e ? (ye() ? "stage-eu-" : "eu-") : "",
          r = ye() ? ".lambdatestinternal.com" : ".lambdatest.com";
        return "https://".concat(t).concat(n).concat(r);
      },
      Oe = function (e, n) {
        var t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        return t
          ? "".concat(e, ".").concat(n, ".hyperexecute.cloud")
          : ye()
          ? "stage-".concat(e, ".").concat(n, ".lambdatestinternal.com")
          : "".concat(e, ".").concat(n, ".lambdatest.com");
      },
      Ae = function (e) {
        var n = new RegExp(
          "(?:^|; )" + encodeURIComponent(e) + "=([^;]*)"
        ).exec(document.cookie);
        return n ? n[1] : null;
      };
    function Ie(e) {
      var n = e.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"),
        t = decodeURIComponent(
          window
            .atob(n)
            .split("")
            .map(function (e) {
              return "%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
      return JSON.parse(t);
    }
    function Pe() {
      return window.location.origin.includes("hyperexecute.cloud");
    }
    function Re(e, n) {
      window.amplitude &&
        (window.amplitude.track
          ? window.amplitude.track(e, n)
          : window.amplitude.getInstance().logEvent(e, n));
    }
    function He() {
      var e =
          !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
        n = [".zls-sptwndw", ".announcekit-frame-wrapper"].map(function (e) {
          var n;
          return null === (n = document) || void 0 === n
            ? void 0
            : n.querySelector(e);
        }),
        t = document.getElementById("siqcht");
      [].concat(me(n), [t]).forEach(function (n) {
        n &&
          (n.setAttribute("aria-hidden", !e),
          n.setAttribute("aria-disabled", !e));
      });
    }
    function Ve(e, n, t, r) {
      var o =
          arguments.length > 4 && void 0 !== arguments[4]
            ? arguments[4]
            : document,
        i = o.getElementsByClassName(n)[0],
        a = o.getElementsByClassName(t)[0];
      try {
        De(e, i, a), "Escape" === e.key && document.getElementById(r).focus();
      } catch (e) {}
    }
    function De(e, n, t) {
      "Tab" === e.key &&
        (document.activeElement !== t || e.shiftKey
          ? document.activeElement === n &&
            e.shiftKey &&
            (e.preventDefault(), t.focus())
          : (e.preventDefault(), n.focus()));
    }
    var Be = function (e) {
        var n = e.orientation,
          t = void 0 === n ? "horizontal" : n,
          r = e.tabRef,
          o = void 0 === r ? "" : r,
          i = e.index,
          a = e.lastIndex,
          l = e.event,
          s = {
            horizontal: { prev: "ArrowLeft", next: "ArrowRight" },
            vertical: { prev: "ArrowUp", next: "ArrowDown" },
          },
          c = s[t] || s.horizontal;
        (null == l ? void 0 : l.key) === c.prev
          ? o.current[
              (function (e, n) {
                return 0 === e ? n : e - 1;
              })(i, a)
            ].focus()
          : (null == l ? void 0 : l.key) === c.next &&
            o.current[
              (function (e, n) {
                return e === n ? 0 : e + 1;
              })(i, a)
            ].focus();
      },
      We = function (e, n, t) {
        if (t && n.current) {
          var r = e.key;
          if ("ArrowUp" === r || "ArrowDown" === r) {
            e.preventDefault();
            var o = n.current.getElementsByClassName(t),
              i = Array.from(o).findIndex(function (e) {
                return document.activeElement === e;
              });
            if (o) {
              var a = o.length - 1;
              "ArrowUp" === r
                ? o[
                    (function (e, n) {
                      return 0 === e ? n : e - 1;
                    })(i, a)
                  ].focus()
                : "ArrowDown" === r &&
                  o[
                    (function (e, n) {
                      return e === n ? 0 : e + 1;
                    })(i, a)
                  ].focus();
            }
          }
        }
      },
      ze = function (e) {
        var n = e.organization,
          t = void 0 === n ? {} : n,
          r = e.organization_role,
          o = void 0 === r ? "" : r;
        return !we() && "Guest" !== o && "User" !== o && !t.is_sub_org;
      },
      Ze = function (e) {
        if (e) {
          var n = window.location.href;
          return !he.some(function (e) {
            return n.includes(e);
          });
        }
        return !1;
      };
    function Fe(e, n) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n &&
          (r = r.filter(function (n) {
            return Object.getOwnPropertyDescriptor(e, n).enumerable;
          })),
          t.push.apply(t, r);
      }
      return t;
    }
    function Ue(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2
          ? Fe(Object(t), !0).forEach(function (n) {
              Ke(e, n, t[n]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : Fe(Object(t)).forEach(function (n) {
              Object.defineProperty(
                e,
                n,
                Object.getOwnPropertyDescriptor(t, n)
              );
            });
      }
      return e;
    }
    function Ke(e, n, t) {
      return (
        n in e
          ? Object.defineProperty(e, n, {
              value: t,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[n] = t),
        e
      );
    }
    var Ge = {
        "desktop-automation": re,
        "mobile-automation": te,
        "real-mobile-automation": ie,
        "real-mobile-automation-private-cloud": oe,
        "hyperexecute-linux": ae,
        "real-mobile-app-live": ie,
        "real-mobile-live-private-cloud": oe,
        "real-mobile-app-automation": te,
        "real-mobile-app-automation-private-cloud": oe,
        "native-app-automation-virtual": ie,
        realtime: ne.REAL_TIME,
        responsive: le,
        screenshot: ne.SCREENSHOT,
      },
      Ye = [
        { hostKeyToUse: "appautomation", intentToUse: "app-automation" },
        { hostKeyToUse: "applive", intentToUse: "realtime-manual-real-device" },
        { hostKeyToUse: "app", intentToUse: "realtime-manual" },
        { hostKeyToUse: "automation", intentToUse: "web-automation" },
        { hostKeyToUse: "hyperexecute", intentToUse: "hyperexecute" },
      ],
      $e = function (e) {
        var n = {},
          t = window.location.href;
        if (t.includes("hyperexecute")) {
          var r = 0;
          Object.keys(e).map(function (n) {
            var t,
              o =
                null === (t = e[n]) || void 0 === t
                  ? void 0
                  : t.available_count;
            o > r && (r = o);
          }),
            (n = { "hyperexecute-linux": { available_count: r } });
        }
        if (t.includes("automation") && !t.includes("appautomation")) {
          var o = 0;
          Object.keys(e).map(function (t) {
            var r,
              i =
                null === (r = e[t]) || void 0 === r
                  ? void 0
                  : r.available_count;
            "desktop-automation" === t || "desktop-automation-linux" === t
              ? i > o && (o = i)
              : (n = Ue(Ue({}, n), {}, Ke({}, t, Ue({}, e[t]))));
          }),
            (n = Ue(
              Ue({}, n),
              {},
              { "desktop-automation": { available_count: o } }
            ));
        }
        if (
          (t.includes("console/responsive") &&
            (n = { responsive: Ue({}, e.responsive) }),
          t.includes("console/screenshot") &&
            (n = { screenshot: Ue({}, e.screenshot) }),
          t.includes("console/realtime"))
        ) {
          var i = {};
          Object.keys(e).forEach(function (n) {
            ("realtime" !== n && "manual-virtual-app-testing" !== n) ||
              (i[n] = e[n]);
          });
          var a = 0;
          return (
            Object.keys(i).map(function (e) {
              var n,
                t =
                  null === (n = i[e]) || void 0 === n
                    ? void 0
                    : n.available_count;
              t > a && (a = t);
            }),
            (n = { realtime: { available_count: a } })
          );
        }
        if (t.includes("applive")) {
          var l = 0,
            s = 0;
          Object.keys(e)
            .filter(function (e) {
              return "real-mobile-live" === e || "real-mobile-app-live" === e;
            })
            .forEach(function (n) {
              var t,
                r =
                  null === (t = e[n]) || void 0 === t
                    ? void 0
                    : t.available_count;
              r > l && (l = r);
            }),
            Object.keys(e)
              .filter(function (e) {
                return (
                  "real-mobile-live-private-cloud" === e ||
                  "real-mobile-app-live-private-cloud" === e
                );
              })
              .forEach(function (n) {
                var t,
                  r =
                    null === (t = e[n]) || void 0 === t
                      ? void 0
                      : t.available_count;
                r > s && (s = r);
              }),
            (n = {
              "real-mobile-app-live": { available_count: l },
              "real-mobile-live-private-cloud": { available_count: s },
            });
        }
        return t.includes("appautomation") && (n = Ue({}, e)), n;
      },
      qe = function (e) {
        var n = {};
        return (
          Object.keys(e).forEach(function (t) {
            console.log("key", t), t.includes("byod") || (n[t] = e[t]);
          }),
          n
        );
      },
      Qe = o(893);
    function Xe(e, n) {
      (null == n || n > e.length) && (n = e.length);
      for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
      return r;
    }
    var Je = function (n) {
        var t,
          r,
          o = n.children,
          i = n.content,
          a =
            ((t = (0, e.useState)(!1)),
            (r = 2),
            (function (e) {
              if (Array.isArray(e)) return e;
            })(t) ||
              (function (e, n) {
                var t =
                  null == e
                    ? null
                    : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                      e["@@iterator"];
                if (null != t) {
                  var r,
                    o,
                    i = [],
                    a = !0,
                    l = !1;
                  try {
                    for (
                      t = t.call(e);
                      !(a = (r = t.next()).done) &&
                      (i.push(r.value), !n || i.length !== n);
                      a = !0
                    );
                  } catch (e) {
                    (l = !0), (o = e);
                  } finally {
                    try {
                      a || null == t.return || t.return();
                    } finally {
                      if (l) throw o;
                    }
                  }
                  return i;
                }
              })(t, r) ||
              (function (e, n) {
                if (e) {
                  if ("string" == typeof e) return Xe(e, n);
                  var t = Object.prototype.toString.call(e).slice(8, -1);
                  return (
                    "Object" === t && e.constructor && (t = e.constructor.name),
                    "Map" === t || "Set" === t
                      ? Array.from(e)
                      : "Arguments" === t ||
                        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
                      ? Xe(e, n)
                      : void 0
                  );
                }
              })(t, r) ||
              (function () {
                throw new TypeError(
                  "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                );
              })()),
          l = a[0],
          s = a[1],
          c = (0, e.useRef)(null),
          u = (0, e.useRef)(null);
        return (
          (0, e.useEffect)(function () {
            var e = function (e) {
              !c.current ||
                c.current.contains(e.target) ||
                u.current.contains(e.target) ||
                s(!1);
            };
            return (
              document.addEventListener("mousedown", e),
              function () {
                document.removeEventListener("mousedown", e);
              }
            );
          }, []),
          (0, Qe.jsxs)("div", {
            className: "ltch-popover-container",
            children: [
              (0, Qe.jsx)("button", {
                ref: u,
                onClick: function () {
                  s(!l);
                },
                className: "ltch-popover-trigger",
                "aria-haspopup": "true",
                "aria-expanded": l,
                "aria-controls": "popover-content",
                children: o,
              }),
              l &&
                (0, Qe.jsx)("div", {
                  id: "popover-content",
                  ref: c,
                  className: "ltch-popover-content",
                  role: "dialog",
                  "aria-modal": "true",
                  children: i,
                }),
            ],
          })
        );
      },
      en =
        (o(217),
        function () {
          return (0, Qe.jsx)("svg", {
            width: "10",
            height: "6",
            viewBox: "0 0 10 6",
            fill: "none",
            role: "img",
            "aria-hidden": "true",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, Qe.jsx)("path", {
              xmlns: "http://www.w3.org/2000/svg",
              d: "M1 1L5 5L9 1",
              stroke: "#666666",
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          });
        }),
      nn = function () {
        return (0, Qe.jsx)("svg", {
          width: "6",
          height: "10",
          viewBox: "0 0 6 10",
          fill: "none",
          role: "img",
          "aria-hidden": "true",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("path", {
            xmlns: "http://www.w3.org/2000/svg",
            d: "M1 9L5 5L1 1",
            stroke: "#666666",
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }),
        });
      };
    function tn(e, n) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n &&
          (r = r.filter(function (n) {
            return Object.getOwnPropertyDescriptor(e, n).enumerable;
          })),
          t.push.apply(t, r);
      }
      return t;
    }
    function rn(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2
          ? tn(Object(t), !0).forEach(function (n) {
              on(e, n, t[n]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : tn(Object(t)).forEach(function (n) {
              Object.defineProperty(
                e,
                n,
                Object.getOwnPropertyDescriptor(t, n)
              );
            });
      }
      return e;
    }
    function on(e, n, t) {
      return (
        n in e
          ? Object.defineProperty(e, n, {
              value: t,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[n] = t),
        e
      );
    }
    var an = function (e) {
      var n = e.available,
        t = e.total,
        r = e.used,
        o = e.usedByOtherProducts,
        i = e.textStyles,
        a = e.title,
        l = (Number(r) / t) * 100,
        s = (Number(n) / t) * 100,
        c = (Number(o) / t) * 100;
      return (0, Qe.jsxs)(Qe.Fragment, {
        children: [
          a &&
            (0, Qe.jsx)("p", {
              className: "ltch-progress-bar-title",
              style: rn({}, i),
              children: a,
            }),
          (0, Qe.jsxs)("div", {
            className: "ltch-progress-bar",
            children: [
              (0, Qe.jsx)("div", {
                className:
                  "ltch-progress-bar-segment ltch-progress-bar-used-segment",
                style: { width: "".concat(l, "%") },
              }),
              (0, Qe.jsx)("div", {
                className:
                  "ltch-progress-bar-segment progress-bar-available-segment",
                style: { width: "".concat(s, "%") },
              }),
              o > 0 &&
                (0, Qe.jsx)("div", { className: "ltch-progress-bar-divider" }),
              (0, Qe.jsx)("div", {
                className:
                  "ltch-progress-bar-segment ltch-progress-bar-used-by-other-products-segment",
                style: { width: "".concat(c, "%") },
              }),
            ],
          }),
        ],
      });
    };
    function ln(e, n) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, n) {
          var t =
            null == e
              ? null
              : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                e["@@iterator"];
          if (null != t) {
            var r,
              o,
              i = [],
              a = !0,
              l = !1;
            try {
              for (
                t = t.call(e);
                !(a = (r = t.next()).done) &&
                (i.push(r.value), !n || i.length !== n);
                a = !0
              );
            } catch (e) {
              (l = !0), (o = e);
            } finally {
              try {
                a || null == t.return || t.return();
              } finally {
                if (l) throw o;
              }
            }
            return i;
          }
        })(e, n) ||
        (function (e, n) {
          if (e) {
            if ("string" == typeof e) return sn(e, n);
            var t = Object.prototype.toString.call(e).slice(8, -1);
            return (
              "Object" === t && e.constructor && (t = e.constructor.name),
              "Map" === t || "Set" === t
                ? Array.from(e)
                : "Arguments" === t ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
                ? sn(e, n)
                : void 0
            );
          }
        })(e, n) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        })()
      );
    }
    function sn(e, n) {
      (null == n || n > e.length) && (n = e.length);
      for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
      return r;
    }
    var cn = function (n) {
        var t = n.concurrencyInfo,
          r = void 0 === t ? {} : t,
          o = n.children,
          i = n.name,
          a = void 0 === i ? "" : i,
          l = n.keyToSet,
          s = void 0 === l ? "" : l,
          c = n.open,
          u = void 0 !== c && c,
          d = n.setCurrentOpenPanel,
          p = void 0 === d ? function () {} : d,
          f = n.tabPrefix,
          h = void 0 === f ? "panel" : f,
          m = n.title,
          _ = n.trailingText,
          g = r.available,
          v = void 0 === g ? 0 : g,
          C = r.total,
          b = void 0 === C ? 0 : C,
          x = r.used,
          y = void 0 === x ? 0 : x,
          w = r.usedByOtherProducts,
          k = void 0 === w ? 0 : w,
          L = ln((0, e.useState)(u), 2),
          j = L[0],
          E = L[1],
          S = ln((0, e.useState)(0), 2),
          M = S[0],
          T = S[1],
          N = (0, e.useRef)(null);
        (0, e.useEffect)(
          function () {
            E(u);
          },
          [u]
        ),
          (0, e.useEffect)(
            function () {
              T(j ? N.current.scrollHeight : 0);
            },
            [j]
          );
        var O = function () {
            E(!j), p(a);
          },
          A = ""
            .concat(h, "-content-")
            .concat(m.replace(/\s+/g, "-").toLowerCase());
        return (0, Qe.jsxs)(
          "div",
          {
            className: "collapsible-panel",
            children: [
              (0, Qe.jsxs)("div", {
                id: "".concat(A, "-header"),
                "aria-controls": A,
                "aria-expanded": j,
                className: "panel-header",
                onClick: O,
                onKeyDown: function (e) {
                  ("Enter" !== e.key && "Space" !== e.code) || O();
                },
                role: "button",
                tabIndex: 0,
                children: [
                  (0, Qe.jsxs)("div", {
                    className: "ltch-collapsible-panel-header",
                    children: [
                      (0, Qe.jsxs)("div", {
                        style: { display: "flex", alignItems: "center" },
                        children: [
                          (0, Qe.jsx)("div", {
                            className: "icon-container",
                            children: j
                              ? (0, Qe.jsx)(en, {})
                              : (0, Qe.jsx)(nn, {}),
                          }),
                          (0, Qe.jsx)("div", {
                            className: "panel-heading",
                            children: m,
                          }),
                        ],
                      }),
                      (0, Qe.jsx)("div", {
                        className: "trailing-text",
                        children: _,
                      }),
                    ],
                  }),
                  (0, Qe.jsx)("div", {
                    className: "ltch-progress-bar-wrapper",
                    children: (0, Qe.jsx)(an, {
                      available: v,
                      total: b,
                      used: y,
                      usedByOtherProducts: k,
                    }),
                  }),
                ],
              }),
              (0, Qe.jsx)("div", {
                id: A,
                "aria-labelledby": "".concat(A, "-header"),
                className: "panel-content",
                ref: N,
                style: { maxHeight: "".concat(M, "px") },
                children: (0, Qe.jsx)("div", {
                  className: "panel-content-inner",
                  children: o,
                }),
              }),
            ],
          },
          s
        );
      },
      un = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-label": "Access Key",
          width: "16",
          height: "17",
          viewBox: "0 0 16 17",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          role: "img",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M8.95714 8.83493C9.34741 8.61776 9.65571 8.27403 9.83334 7.85804C10.011 7.44205 10.0478 6.9775 9.93806 6.53775C9.82831 6.09799 9.5782 5.7081 9.22725 5.42963C8.87629 5.15117 8.44448 5 8 5C7.55552 5 7.12371 5.15117 6.77275 5.42963C6.4218 5.7081 6.17169 6.09799 6.06194 6.53775C5.95218 6.9775 5.98903 7.44205 6.16666 7.85804C6.34429 8.27403 6.65259 8.61776 7.04286 8.83493L6.05714 11.1832C6.01927 11.2718 6.00355 11.3686 6.01141 11.465C6.01926 11.5613 6.10214 11.7352 6.10214 11.7352C6.15385 11.8161 6.22445 11.8827 6.30761 11.929C6.39078 11.9752 6.48388 11.9996 6.57857 12H9.42143C9.51611 11.9996 9.60922 11.9752 9.69238 11.929C9.77555 11.8827 9.84615 11.8161 9.89785 11.7352C9.94956 11.6542 9.98074 11.5613 9.98859 11.465C9.99645 11.3686 9.98073 11.2718 9.94286 11.1832L8.95714 8.83493Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
            ],
          }),
        });
      },
      dn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          role: "img",
          "aria-hidden": !0,
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsxs)("g", {
              children: [
                (0, Qe.jsx)("path", {
                  d: "M14.5 3.61467V4.90315V7.48011C14.5 8.90122 14.2878 10.6445 12.7845 12.3186C10.6947 14.4109 8.15646 15.2486 8.00232 15.25C7.84818 15.2514 5.14604 14.3162 3.22761 12.3186C1.75907 10.7883 1.5 8.89712 1.5 7.47966V2.89554C1.50004 2.68851 1.57209 2.48767 1.70428 2.32619C1.83646 2.1647 2.02087 2.05221 2.22707 2.00729L8 0.75L10.8865 1.37864L11.531 1.54766",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M13.75 4.5C14.9926 4.5 16 3.49264 16 2.25C16 1.00736 14.9926 0 13.75 0C12.5074 0 11.5 1.00736 11.5 2.25C11.5 3.49264 12.5074 4.5 13.75 4.5ZM14.982 2.04463C15.1447 1.91651 15.1728 1.68073 15.0446 1.51801C14.9165 1.35529 14.6807 1.32725 14.518 1.45537L13.5071 2.25139L13.2625 2.01166C13.1146 1.86667 12.8772 1.86902 12.7322 2.01691C12.5872 2.1648 12.5896 2.40223 12.7375 2.54722L13.2175 3.01778L13.4529 3.24861L13.712 3.04463L14.982 2.04463Z",
                  fill: t,
                }),
                (0, Qe.jsx)("path", {
                  d: "M8 4.5C8.55228 4.5 9 4.05228 9 3.5C9 2.94772 8.55228 2.5 8 2.5C7.44772 2.5 7 2.94772 7 3.5C7 4.05228 7.44772 4.5 8 4.5Z",
                  fill: t,
                }),
                (0, Qe.jsx)("path", {
                  d: "M6.40625 11.6937L8 7.78906M8 7.78906L9.59375 11.6937M8 7.78906V6.11562M4.8125 5L8 6.11562M8 6.11562L11.1875 5",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
              ],
            }),
            (0, Qe.jsx)("defs", {
              children: (0, Qe.jsx)("clipPath", {
                children: (0, Qe.jsx)("rect", {
                  width: "16",
                  height: "16",
                  fill: "white",
                }),
              }),
            }),
          ],
        });
      },
      pn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M4.66667 3.33333H2M3.33333 4.66667V2",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M7.33311 2.27333C7.75465 2.09346 8.20814 2.0005 8.66645 2C9.2672 2.00089 9.85655 2.16412 10.3722 2.47243C10.8878 2.78074 11.3105 3.22266 11.5956 3.75146C11.8807 4.28026 12.0176 4.87628 11.9918 5.47648C11.966 6.07668 11.7784 6.65876 11.449 7.16114C11.1196 7.66352 10.6605 8.06754 10.1204 8.33047C9.58019 8.59339 8.97901 8.70545 8.38039 8.65479C7.78177 8.60413 7.20797 8.39263 6.71968 8.04266C6.23139 7.69269 5.84675 7.21727 5.60645 6.66667",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M7.99967 8.66699H9.33301C10.5707 8.66699 11.7577 9.15866 12.6328 10.0338C13.508 10.909 13.9997 12.096 13.9997 13.3337C13.9997 13.5105 13.9294 13.68 13.8044 13.8051C13.6794 13.9301 13.5098 14.0003 13.333 14.0003H3.99967C3.82286 14.0003 3.65329 13.9301 3.52827 13.8051C3.40325 13.68 3.33301 13.5105 3.33301 13.3337C3.33301 12.096 3.82467 10.909 4.69984 10.0338C5.57501 9.15866 6.762 8.66699 7.99967 8.66699Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      },
      fn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          role: "img",
          "aria-hidden": !0,
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            id: "Plus",
            children: [
              (0, Qe.jsx)("rect", {
                id: "Rectangle 2109",
                x: "1",
                y: "1",
                width: "6",
                height: "3",
                rx: "0.5",
                stroke: t,
                strokeWidth: "1.25",
              }),
              (0, Qe.jsx)("rect", {
                id: "Rectangle 2110",
                x: "9",
                y: "1",
                width: "6",
                height: "8",
                rx: "0.5",
                stroke: t,
                strokeWidth: "1.25",
              }),
              (0, Qe.jsx)("rect", {
                id: "Rectangle 2112",
                x: "9",
                y: "12",
                width: "6",
                height: "3",
                rx: "0.5",
                stroke: t,
                strokeWidth: "1.25",
              }),
              (0, Qe.jsx)("rect", {
                id: "Rectangle 2111",
                x: "1",
                y: "7",
                width: "6",
                height: "8",
                rx: "0.5",
                stroke: t,
                strokeWidth: "1.25",
              }),
            ],
          }),
        });
      },
      hn = function () {
        return (0, Qe.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-hidden": "true",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M6.49998 5V12.7312C6.50074 12.8143 6.48052 12.8963 6.44119 12.9695C6.40186 13.0427 6.34469 13.1048 6.27498 13.15L5.58748 13.6062C5.52088 13.6507 5.44457 13.6785 5.36497 13.6874C5.28538 13.6962 5.20483 13.6858 5.1301 13.657C5.05537 13.6282 4.98865 13.5819 4.93555 13.5219C4.88245 13.462 4.84453 13.3902 4.82498 13.3125L3.99998 10",
                stroke: "#666666",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M4 10.0001C3.33696 10.0001 2.70107 9.73675 2.23223 9.26791C1.76339 8.79907 1.5 8.16318 1.5 7.50014C1.5 6.8371 1.76339 6.20121 2.23223 5.73237C2.70107 5.26353 3.33696 5.00014 4 5.00014H6.5C6.5 5.00014 9.90625 5.00014 13.1813 2.25639C13.2541 2.19611 13.3425 2.15772 13.4363 2.14568C13.5301 2.13363 13.6254 2.14842 13.7111 2.18833C13.7968 2.22825 13.8694 2.29164 13.9206 2.37117C13.9717 2.4507 13.9993 2.54309 14 2.63764V12.3626C13.9993 12.4572 13.9717 12.5496 13.9206 12.6291C13.8694 12.7086 13.7968 12.772 13.7111 12.8119C13.6254 12.8519 13.5301 12.8666 13.4363 12.8546C13.3425 12.8426 13.2541 12.8042 13.1813 12.7439C9.90625 10.0001 6.5 10.0001 6.5 10.0001H4Z",
                stroke: "#666666",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      },
      mn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            id: "AppWindow",
            children: [
              (0, Qe.jsx)("path", {
                d: "M14.4167 2H1.58333C1.26117 2 1 2.26117 1 2.58333V2.6V13.4V13.4167C1 13.7388 1.26117 14 1.58333 14H14.4167C14.7388 14 15 13.7388 15 13.4167V13.4V2.6V2.58333C15 2.26117 14.7388 2 14.4167 2Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M4 4.75C4 4.88807 3.88807 5 3.75 5C3.61193 5 3.5 4.88807 3.5 4.75C3.5 4.61193 3.61193 4.5 3.75 4.5C3.88807 4.5 4 4.61193 4 4.75Z",
                fill: t,
                stroke: t,
              }),
              (0, Qe.jsx)("path", {
                d: "M6.5 4.75C6.5 4.88807 6.38807 5 6.25 5C6.11193 5 6 4.88807 6 4.75C6 4.61193 6.11193 4.5 6.25 4.5C6.38807 4.5 6.5 4.61193 6.5 4.75Z",
                fill: t,
                stroke: t,
              }),
            ],
          }),
        });
      },
      _n = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsxs)("g", {
              id: "Archive",
              clipPath: "url(#clip0_12285_5508)",
              children: [
                (0, Qe.jsx)("path", {
                  d: "M14.4615 2H1.53846C1.24108 2 1 2.35817 1 2.8V5.2C1 5.64183 1.24108 6 1.53846 6H14.4615C14.7589 6 15 5.64183 15 5.2V2.8C15 2.35817 14.7589 2 14.4615 2Z",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M14 6V14.3077C14 14.4913 13.9425 14.6674 13.8402 14.7972C13.7379 14.9271 13.5992 15 13.4545 15H2.54545C2.40079 15 2.26205 14.9271 2.15976 14.7972C2.05747 14.6674 2 14.4913 2 14.3077V6",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M6 9H10",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
              ],
            }),
            (0, Qe.jsx)("defs", {
              children: (0, Qe.jsx)("clipPath", {
                id: "clip0_12285_5508",
                children: (0, Qe.jsx)("rect", {
                  width: "16",
                  height: "16",
                  fill: "white",
                }),
              }),
            }),
          ],
        });
      },
      gn = function () {
        return (0, Qe.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("path", {
            d: "M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM8 13.5C6.91221 13.5 5.84884 13.1774 4.94437 12.5731C4.0399 11.9687 3.33495 11.1098 2.91867 10.1048C2.50238 9.09977 2.39347 7.9939 2.60568 6.927C2.8179 5.86011 3.34173 4.8801 4.11092 4.11091C4.8801 3.34172 5.86011 2.8179 6.92701 2.60568C7.9939 2.39346 9.09977 2.50238 10.1048 2.91866C11.1098 3.33494 11.9687 4.03989 12.5731 4.94436C13.1774 5.84883 13.5 6.9122 13.5 8C13.4983 9.45818 12.9184 10.8562 11.8873 11.8873C10.8562 12.9184 9.45819 13.4983 8 13.5ZM11 8C11 8.13261 10.9473 8.25979 10.8536 8.35355C10.7598 8.44732 10.6326 8.5 10.5 8.5H6.70688L7.85375 9.64625C7.90021 9.69271 7.93706 9.74786 7.9622 9.80855C7.98734 9.86925 8.00028 9.9343 8.00028 10C8.00028 10.0657 7.98734 10.1308 7.9622 10.1914C7.93706 10.2521 7.90021 10.3073 7.85375 10.3538C7.8073 10.4002 7.75215 10.4371 7.69145 10.4622C7.63075 10.4873 7.5657 10.5003 7.5 10.5003C7.43431 10.5003 7.36925 10.4873 7.30855 10.4622C7.24786 10.4371 7.19271 10.4002 7.14625 10.3538L5.14625 8.35375C5.09976 8.30731 5.06289 8.25217 5.03772 8.19147C5.01256 8.13077 4.99961 8.06571 4.99961 8C4.99961 7.93429 5.01256 7.86923 5.03772 7.80853C5.06289 7.74783 5.09976 7.69269 5.14625 7.64625L7.14625 5.64625C7.24007 5.55243 7.36732 5.49972 7.5 5.49972C7.63268 5.49972 7.75993 5.55243 7.85375 5.64625C7.94757 5.74007 8.00028 5.86732 8.00028 6C8.00028 6.13268 7.94757 6.25993 7.85375 6.35375L6.70688 7.5H10.5C10.6326 7.5 10.7598 7.55268 10.8536 7.64645C10.9473 7.74021 11 7.86739 11 8Z",
            fill: "#e9ecec",
          }),
        });
      },
      vn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          width: "7",
          height: "10",
          viewBox: "0 0 7 10",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-label": "arrow left",
          role: "img",
          children: (0, Qe.jsx)("path", {
            d: "M6 9L2 5L6 1",
            stroke: t,
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }),
        });
      },
      Cn = function () {
        return (0, Qe.jsx)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "8",
          viewBox: "0 0 16 8",
          fill: "none",
          "aria-label": "profile dropdown",
          role: "img",
          "aria-hidden": !0,
          children: (0, Qe.jsx)("g", {
            id: "Frame 1000002827",
            children: (0, Qe.jsx)("path", {
              d: "M4.5 2.5L8.2258 5.5L11.5 2.5",
              stroke: "#333333",
              strokeWidth: "1.25",
              strokeLinecap: "round",
            }),
          }),
        });
      },
      bn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          role: "img",
          "aria-hidden": !0,
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("path", {
              d: "M14.25 8.00002C14.25 11.4321 11.4518 14.2143 8 14.2143M8 14.2143L8.82521 13.0012M8 14.2143L9.04167 15.25",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M1.75 7.99998C1.75 4.56792 4.54822 1.78569 8 1.78569M8 1.78569L7.17479 2.99875M8 1.78569L6.95833 0.749999",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M10.1875 6.38869L11.6459 7.9998L10.1875 9.61091M7.27085 10.4165L8.72919 5.58313M5.81252 9.61091L4.35419 7.9998L5.81252 6.38869",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M8 1.78577C6.22553 1.78577 4.62378 2.52103 3.48611 3.70186C2.41073 4.81804 1.75 6.33232 1.75 8.00005C1.75 8.85722 1.92454 9.67384 2.24021 10.4167",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M8 14.2142C9.77447 14.2142 11.3762 13.479 12.5139 12.2981C13.5893 11.182 14.25 9.66768 14.25 7.99995C14.25 7.14278 14.0755 6.32616 13.7598 5.58328",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
            }),
          ],
        });
      };
    function xn() {
      return (
        (xn = Object.assign
          ? Object.assign.bind()
          : function (e) {
              for (var n = 1; n < arguments.length; n++) {
                var t = arguments[n];
                for (var r in t)
                  Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
              }
              return e;
            }),
        xn.apply(this, arguments)
      );
    }
    var yn = function (e) {
        var n = xn(
            {},
            ((function (e) {
              if (null == e) throw new TypeError("Cannot destructure " + e);
            })(e),
            e)
          ).color,
          t = void 0 === n ? "#fff" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": "true",
          width: "16",
          height: "16",
          role: "img",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            id: "CurrencyCircleDollar",
            children: [
              (0, Qe.jsx)("path", {
                d: "M8 4.5V5.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M8 10.5V11.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M6.5 10.5H8.75C9.08152 10.5 9.39946 10.3683 9.63388 10.1339C9.8683 9.89946 10 9.58152 10 9.25C10 8.91848 9.8683 8.60054 9.63388 8.36612C9.39946 8.1317 9.08152 8 8.75 8H7.25C6.91848 8 6.60054 7.8683 6.36612 7.63388C6.1317 7.39946 6 7.08152 6 6.75C6 6.41848 6.1317 6.10054 6.36612 5.86612C6.60054 5.6317 6.91848 5.5 7.25 5.5H9.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      },
      wn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          width: "14",
          height: "14",
          viewBox: "0 0 14 14",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            id: "Bug",
            children: [
              (0, Qe.jsx)("path", {
                id: "Stroke-447",
                d: "M13.0012 7.53613H10",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                id: "Stroke-448",
                d: "M3.99824 7.53613H0.99707",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                id: "Stroke-449",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.99838 6.03581V9.03646C9.99838 9.20647 9.98377 9.37647 9.95353 9.53657C9.71833 10.9571 8.48345 12.0371 6.99772 12.0371C5.512 12.0371 4.27711 10.9571 4.04192 9.53657C4.01219 9.37647 3.99707 9.20647 3.99707 9.03646V6.03581C3.99707 5.8658 4.01219 5.6958 4.04192 5.5357C4.27711 4.11516 5.512 3.03516 6.99772 3.03516C7.82793 3.03516 8.57784 3.36995 9.11862 3.91543C9.55302 4.34514 9.85392 4.90574 9.95353 5.5357C9.98377 5.6958 9.99838 5.8658 9.99838 6.03581Z",
                stroke: t,
                strokeWidth: "1.25",
              }),
              (0, Qe.jsx)("path", {
                id: "Stroke-450",
                d: "M1.49805 2.53516V2.95861C1.49805 3.62872 1.76088 4.27224 2.2297 4.75097L2.24534 4.76713C2.72668 5.2589 3.38636 5.53581 4.07473 5.53581H9.9394C10.6189 5.53581 11.2702 5.2662 11.7511 4.78538C12.2313 4.30561 12.5015 3.65375 12.5015 2.97477V2.53516",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                id: "Stroke-451",
                d: "M9.95508 9.53613H9.96916C10.6294 9.53613 11.2625 9.79792 11.7292 10.2647L11.7714 10.3074C12.2387 10.7741 12.501 11.4072 12.501 12.0674V12.5368",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                id: "Stroke-452",
                d: "M0.873047 12.5368C0.873047 12.882 1.15287 13.1618 1.49805 13.1618C1.84322 13.1618 2.12305 12.882 2.12305 12.5368H0.873047ZM2.20936 10.3408L1.76543 9.90083L1.76294 9.90338L2.20936 10.3408ZM2.26724 10.2824L2.71117 10.7223L2.71355 10.7199L2.26724 10.2824ZM2.12305 12.5368V12.0831H0.873047V12.5368H2.12305ZM2.12305 12.0831C2.12305 11.5949 2.3144 11.1266 2.65578 10.7782L1.76294 9.90338C1.19275 10.4853 0.873047 11.2676 0.873047 12.0831H2.12305ZM2.65328 10.7807L2.71116 10.7223L1.82333 9.84243L1.76544 9.90084L2.65328 10.7807ZM2.71355 10.7199C3.06379 10.3626 3.54334 10.1611 4.04396 10.1611V8.91113C3.20748 8.91113 2.40625 9.2478 1.82093 9.84485L2.71355 10.7199Z",
                fill: t,
              }),
              (0, Qe.jsx)("path", {
                id: "Stroke-453",
                d: "M7.00098 5.53516V12.0366",
                stroke: t,
                strokeWidth: "1.25",
              }),
              (0, Qe.jsx)("path", {
                id: "Stroke-455",
                d: "M8.99837 3.80478V2.53443C8.99837 1.88183 8.58178 1.32659 8 1.12012",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                id: "Stroke-456",
                d: "M4.99902 3.8049V2.53455C4.99902 1.93773 5.34745 1.42233 5.85201 1.18066",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
            ],
          }),
        });
      },
      kn = function () {
        return (0, Qe.jsxs)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("path", {
              d: "M4.475 9L2 11V3C2 2.86739 2.05268 2.74021 2.14645 2.64645C2.24021 2.55268 2.36739 2.5 2.5 2.5H10.5C10.6326 2.5 10.7598 2.55268 10.8536 2.64645C10.9473 2.74021 11 2.86739 11 3V8.5C11 8.63261 10.9473 8.75979 10.8536 8.85355C10.7598 8.94732 10.6326 9 10.5 9H4.475Z",
              stroke: "#e9ecec",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M5 9V11.5C5 11.6326 5.05268 11.7598 5.14645 11.8536C5.24021 11.9473 5.36739 12 5.5 12H11.525L14 14V6C14 5.86739 13.9473 5.74021 13.8536 5.64645C13.7598 5.55268 13.6326 5.5 13.5 5.5H11",
              stroke: "#e9ecec",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      Ln = function () {
        return (0, Qe.jsxs)("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          role: "presentation",
          children: [
            (0, Qe.jsx)("circle", {
              cx: "10",
              cy: "10",
              r: "9.3",
              transform: "rotate(-180 10 10)",
              fill: "white",
              stroke: "#101010",
              strokeWidth: "1.4",
            }),
            (0, Qe.jsx)("path", {
              d: "M10.8333 13.3359L7.5 10.0026L10.8333 6.66927",
              stroke: "#101010",
              strokeWidth: "1.4",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      jn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M10.1774 12.5965V14.5319C10.1774 15.0664 9.74415 15.4997 9.20968 15.4997H1.46774C0.933273 15.4997 0.5 15.0664 0.5 14.5319V6.79001C0.5 6.25554 0.933273 5.82227 1.46774 5.82227H3.40323",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M14.5322 0.5H6.79031C6.25584 0.5 5.82257 0.933273 5.82257 1.46774V9.20968C5.82257 9.74415 6.25584 10.1774 6.79031 10.1774H14.5322C15.0667 10.1774 15.5 9.74415 15.5 9.20968V1.46774C15.5 0.933273 15.0667 0.5 14.5322 0.5Z",
                stroke: t,
                strokeWidth: "1.25",
              }),
            ],
          }),
        });
      },
      En = function () {
        return (0, Qe.jsx)("svg", {
          width: "12px",
          height: "12px",
          viewBox: "0 0 12 12",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("g", {
            id: "Webapp-Tunnel",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, Qe.jsx)("g", {
              id: "Menus",
              transform: "translate(-1276.000000, -685.000000)",
              fill: "#E5E5E5",
              fillRule: "nonzero",
              children: (0, Qe.jsx)("g", {
                transform: "translate(1107.000000, 486.000000)",
                children: (0, Qe.jsx)("g", {
                  id: "Tunnel-Drop-Down",
                  transform: "translate(0.000000, 30.000000)",
                  children: (0, Qe.jsx)("g", {
                    id: "c-remove",
                    transform: "translate(169.000000, 79.000000)",
                    children: (0, Qe.jsx)("path", {
                      d: "M6,90 C2.7,90 0,92.7 0,96 C0,99.3 2.7,102 6,102 C9.3,102 12,99.3 12,96 C12,92.7 9.3,90 6,90 Z M8.625,97.575 L7.575,98.625 L6,97.05 L4.425,98.625 L3.375,97.575 L4.95,96 L3.375,94.425 L4.425,93.375 L6,94.95 L7.575,93.375 L8.625,94.425 L7.05,96 L8.625,97.575 Z",
                      id: "Shape",
                    }),
                  }),
                }),
              }),
            }),
          }),
        });
      },
      Sn = function () {
        return (0, Qe.jsx)("svg", {
          width: "12px",
          height: "12px",
          viewBox: "0 0 12 12",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("g", {
            id: "Webapp-Tunnel",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: (0, Qe.jsx)("g", {
              id: "Menus",
              transform: "translate(-1276.000000, -595.000000)",
              fill: "#FF6565",
              fillRule: "nonzero",
              children: (0, Qe.jsx)("g", {
                transform: "translate(1107.000000, 486.000000)",
                children: (0, Qe.jsx)("g", {
                  id: "Tunnel-Drop-Down",
                  transform: "translate(0.000000, 30.000000)",
                  children: (0, Qe.jsx)("g", {
                    id: "c-remove",
                    transform: "translate(169.000000, 79.000000)",
                    children: (0, Qe.jsx)("path", {
                      d: "M6,0 C2.7,0 0,2.7 0,6 C0,9.3 2.7,12 6,12 C9.3,12 12,9.3 12,6 C12,2.7 9.3,0 6,0 Z M8.625,7.575 L7.575,8.625 L6,7.05 L4.425,8.625 L3.375,7.575 L4.95,6 L3.375,4.425 L4.425,3.375 L6,4.95 L7.575,3.375 L8.625,4.425 L7.05,6 L8.625,7.575 Z",
                      id: "Shape",
                    }),
                  }),
                }),
              }),
            }),
          }),
        });
      },
      Mn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          role: "img",
          "aria-hidden": !0,
          width: "16",
          height: "20",
          viewBox: "0 0 16 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("g", {
              children: (0, Qe.jsx)("path", {
                d: "M0 11L8 3L16 11M1.78125 9.22266V16.3338C1.78125 16.8247 2.17922 17.2227 2.67014 17.2227H5.33681C5.82773 17.2227 6.22569 16.8247 6.22569 16.3338V12.7782C6.22569 12.2873 6.62366 11.8893 7.11458 11.8893H8.89236C9.38328 11.8893 9.78125 12.2873 9.78125 12.7782V16.3338C9.78125 16.8247 10.1792 17.2227 10.6701 17.2227H13.3368C13.8277 17.2227 14.2257 16.8247 14.2257 16.3338V9.22266",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            }),
            (0, Qe.jsx)("defs", {
              children: (0, Qe.jsx)("clipPath", {
                children: (0, Qe.jsx)("rect", {
                  width: "16",
                  height: "20",
                  fill: "white",
                }),
              }),
            }),
          ],
        });
      };
    function Tn(e, n, t) {
      return (
        n in e
          ? Object.defineProperty(e, n, {
              value: t,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[n] = t),
        e
      );
    }
    var Nn = function (e) {
        var n,
          t = e.color,
          r = void 0 === t ? "#80858F" : t;
        return (0, Qe.jsxs)("svg", {
          role: "img",
          "aria-hidden": !0,
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("g", {
              "clip-path": "url(#clip0_12015_10115)",
              children: (0, Qe.jsx)(
                "path",
                ((n = {
                  stroke: r,
                  strokeWidth: "1.25",
                  d: "M4.77778 11.7976H6.38889M10.4167 10.4167V12.6723C10.4167 13.5745 10.4165 14.0256 10.2554 14.372C10.0943 14.67 9.85309 14.9197 9.53087 15.0728C9.20865 15.25 8.72484 15.25 7.83873 15.25H3.32794C2.44182 15.25 1.95802 15.25 1.6358 15.0728C1.31357 14.9197 1.07238 14.67 0.911268 14.372C0.750157 14.0256 0.75 13.5745 0.75 12.6723V3.32774C0.75 2.42552 0.750157 1.97442 0.911268 1.62803C1.07238 1.32997 1.31357 1.08025 1.6358 0.927199C1.95802 0.749976 2.44182 0.75 3.32794 0.75H5.58333M8.80556 4.01254C9.61111 4.17365 10.2556 4.55225 10.8194 5.10808C11.3833 5.67197 11.7864 6.38079 11.9475 7.15413M8.80556 0.75C10.4167 0.935278 11.9475 1.6683 13.1559 2.8283C14.2836 3.99635 15.0083 5.51885 15.25 7.15413",
                }),
                Tn(n, "stroke", "#666666"),
                Tn(n, "stroke-width", "1.25"),
                Tn(n, "stroke-linecap", "round"),
                Tn(n, "stroke-linejoin", "round"),
                n)
              ),
            }),
            (0, Qe.jsx)("defs", {
              children: (0, Qe.jsx)("clipPath", {
                id: "clip0_12015_10115",
                children: (0, Qe.jsx)("rect", {
                  stroke: r,
                  strokeWidth: "1.25",
                  width: "16",
                  height: "16",
                  fill: "white",
                }),
              }),
            }),
          ],
        });
      },
      On = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          role: "img",
          "aria-hidden": !0,
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("path", {
              d: "M13.4 15H2.6C2.59475 15 2.5892 15 2.58337 15C2.26121 15 2 14.7388 2 14.4167V14.4167V1.58333V1.58333C2 1.26117 2.26121 1 2.58337 1C2.5892 1 2.59475 1 2.6 1H10.197C10.3272 1 10.4522 1.05076 10.5455 1.1415L13.6971 4.20549C13.8907 4.39377 14 4.65239 14 4.92249V14.4167V14.4167C14 14.7388 13.7388 15 13.4166 15C13.4108 15 13.4052 15 13.4 15Z",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M9.5 2V5C9.5 5.27614 9.72386 5.5 10 5.5H13",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "square",
            }),
            (0, Qe.jsx)("path", {
              d: "M5 9H11",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M5 12H11",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      An = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            id: "FileText",
            children: [
              (0, Qe.jsx)("path", {
                d: "M13.4 15H2.6C2.59475 15 2.5892 15 2.58337 15C2.26121 15 2 14.7388 2 14.4167V14.4167V1.58333V1.58333C2 1.26117 2.26121 1 2.58337 1C2.5892 1 2.59475 1 2.6 1H10.197C10.3272 1 10.4522 1.05076 10.5455 1.1415L13.6971 4.20549C13.8907 4.39377 14 4.65239 14 4.92249V14.4167V14.4167C14 14.7388 13.7388 15 13.4166 15C13.4108 15 13.4052 15 13.4 15Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M9.5 2V5C9.5 5.27614 9.72386 5.5 10 5.5H13",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "square",
              }),
              (0, Qe.jsx)("path", {
                d: "M5 9H11",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M5 12H11",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      },
      In = function () {
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          xmlns: "http://www.w3.org/2000/svg",
          width: "12",
          height: "12",
          viewBox: "0 0 12 12",
          children: (0, Qe.jsx)("path", {
            fill: "#101010",
            d: "M2.466 5.529l.925-.938c.089-.09.235-.09.324 0l1.402 1.42V.233c0-.127.103-.232.229-.232h1.308c.126 0 .23.104.23.232v5.78l1.401-1.42c.09-.091.235-.091.324 0l.925.937c.09.09.09.238 0 .328l-3.36 3.406c-.048.048-.111.07-.174.067-.063.003-.126-.019-.174-.067l-3.36-3.406c-.09-.09-.09-.238 0-.328zM12 11.795V6.432s0-.072-.062-.132c-.049-.046-.118-.046-.118-.046h-1.217s-.052 0-.107.05c-.057.053-.057.12-.057.12v3.994H1.561V6.432s0-.072-.062-.132c-.049-.046-.118-.046-.118-.046H.163s-.051 0-.106.05C0 6.358 0 6.425 0 6.425v5.374c0 .111.09.202.199.202h11.599c.11 0 .202-.092.202-.205z",
          }),
        });
      },
      Pn = function () {
        return (0, Qe.jsxs)("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          role: "presentation",
          children: [
            (0, Qe.jsx)("circle", {
              cx: "10",
              cy: "10",
              r: "9.3",
              transform: "rotate(-180 10 10)",
              fill: "white",
              stroke: "#101010",
              strokeWidth: "1.4",
            }),
            (0, Qe.jsx)("path", {
              d: "M9.16667 6.66406L12.5 9.9974L9.16667 13.3307",
              stroke: "#101010",
              strokeWidth: "1.4",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      Rn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          role: "img",
          "aria-hidden": !0,
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsxs)("g", {
              children: [
                (0, Qe.jsx)("path", {
                  d: "M14.0561 5.76594L13.7904 5.61817C13.7492 5.59523 13.7289 5.58372 13.709 5.57178C13.5109 5.45314 13.344 5.28921 13.2222 5.09309C13.2099 5.07336 13.1984 5.05266 13.1747 5.01176C13.1511 4.97091 13.1392 4.95021 13.1282 4.92972C13.0189 4.72569 12.9598 4.4983 12.9563 4.26687C12.9559 4.24361 12.956 4.21983 12.9568 4.17257L12.962 3.86414C12.9703 3.37056 12.9745 3.12301 12.9051 2.90085C12.8435 2.70351 12.7404 2.52175 12.6028 2.3675C12.4472 2.19314 12.2318 2.06875 11.8006 1.82028L11.4425 1.61389C11.0125 1.36612 10.7974 1.24219 10.5692 1.19494C10.3672 1.15315 10.1588 1.15508 9.95758 1.20026C9.73047 1.25124 9.51811 1.3784 9.09362 1.63257L9.09121 1.63373L8.83459 1.78738C8.79401 1.81168 8.77347 1.82393 8.75313 1.83524C8.5513 1.94745 8.32598 2.0095 8.09518 2.01691C8.07192 2.01765 8.04825 2.01765 8.00094 2.01765C7.95391 2.01765 7.92924 2.01765 7.90603 2.01691C7.67472 2.00947 7.44893 1.94708 7.24679 1.8344C7.22642 1.82305 7.20626 1.8107 7.1656 1.78629L6.90735 1.63125C6.47996 1.37467 6.26594 1.24618 6.03757 1.19494C5.83553 1.14961 5.62641 1.14836 5.42372 1.1907C5.19486 1.2385 4.97974 1.36335 4.54952 1.61304L4.54761 1.61389L4.19391 1.81917L4.19 1.82157C3.76365 2.06902 3.54996 2.19304 3.39568 2.36669C3.25877 2.52078 3.15644 2.70226 3.09519 2.89907C3.02596 3.12154 3.02965 3.36963 3.03799 3.86553L3.04318 4.17353C3.04396 4.22017 3.04532 4.24334 3.04498 4.26628C3.04155 4.49819 2.98166 4.72603 2.87206 4.93043C2.86122 4.95065 2.84954 4.97086 2.82622 5.01124C2.80288 5.05165 2.79157 5.07174 2.77947 5.09124C2.6571 5.28841 2.4894 5.45329 2.29008 5.57214C2.27037 5.58389 2.24959 5.5952 2.20877 5.61782L1.94653 5.76314C1.51022 6.00493 1.29212 6.12593 1.13342 6.29812C0.993025 6.45045 0.886967 6.63114 0.822226 6.82792C0.749044 7.05037 0.749106 7.2998 0.750239 7.79862L0.751165 8.20633C0.752291 8.70182 0.753834 8.94939 0.82718 9.17033C0.892068 9.36579 0.997353 9.54541 1.13696 9.69682C1.29477 9.86797 1.5107 9.98822 1.9437 10.2291L2.20359 10.3737C2.24783 10.3983 2.27008 10.4104 2.29141 10.4233C2.48892 10.5422 2.65531 10.7066 2.77664 10.9027C2.78975 10.9239 2.80233 10.9458 2.82749 10.9898C2.85234 11.0332 2.86506 11.0549 2.87655 11.0767C2.98293 11.2781 3.03988 11.5019 3.04377 11.7296C3.04419 11.7542 3.04383 11.7791 3.04298 11.8291L3.03799 12.1247C3.02959 12.6223 3.02593 12.8714 3.09557 13.0944C3.15718 13.2918 3.26015 13.4735 3.3978 13.6278C3.55339 13.8022 3.76909 13.9265 4.20029 14.1749L4.55836 14.3813C4.98835 14.6291 5.20326 14.7528 5.43154 14.8001C5.63349 14.8419 5.84202 14.8403 6.04324 14.7951C6.27067 14.744 6.48377 14.6164 6.90947 14.3615L7.16609 14.2079C7.20669 14.1836 7.22725 14.1714 7.24759 14.1601C7.44942 14.0479 7.67451 13.9855 7.90532 13.9781C7.92858 13.9773 7.95224 13.9773 7.99956 13.9773C8.04698 13.9773 8.07062 13.9773 8.09393 13.9781C8.32524 13.9855 8.5517 14.0481 8.75384 14.1608C8.77163 14.1707 8.78945 14.1814 8.82074 14.2002L9.09355 14.364C9.521 14.6206 9.73455 14.7487 9.96294 14.7999C10.165 14.8453 10.3743 14.8471 10.577 14.8048C10.8058 14.757 11.0213 14.6319 11.4513 14.3823L11.8103 14.174C12.2369 13.9264 12.4509 13.8022 12.6052 13.6285C12.7421 13.4744 12.8445 13.293 12.9058 13.0962C12.9745 12.8753 12.9704 12.6292 12.9622 12.1404L12.9568 11.8217C12.956 11.775 12.9559 11.7518 12.9563 11.7289C12.9597 11.497 13.0186 11.269 13.1282 11.0646C13.139 11.0444 13.1508 11.024 13.174 10.9838C13.1974 10.9434 13.2095 10.9232 13.2216 10.9037C13.3439 10.7066 13.5118 10.5415 13.7111 10.4227C13.7306 10.4111 13.7506 10.4 13.7905 10.3779L13.7919 10.3773L14.0541 10.2319C14.4904 9.99015 14.7089 9.86902 14.8676 9.69682C15.008 9.54449 15.1139 9.36406 15.1787 9.16728C15.2514 8.94614 15.2509 8.69815 15.2497 8.20516L15.2488 7.78871C15.2477 7.29322 15.2471 7.04567 15.1737 6.82474C15.1088 6.62927 15.003 6.44964 14.8634 6.29823C14.7057 6.12726 14.4895 6.00697 14.0573 5.76655L14.0561 5.76594Z",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M5.0991 7.99765C5.0991 9.5999 6.39798 10.8988 8.00023 10.8988C9.60248 10.8988 10.9014 9.5999 10.9014 7.99765C10.9014 6.3954 9.60248 5.09652 8.00023 5.09652C6.39798 5.09652 5.0991 6.3954 5.0991 7.99765Z",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
              ],
            }),
            (0, Qe.jsx)("defs", {
              children: (0, Qe.jsx)("clipPath", {
                children: (0, Qe.jsx)("rect", {
                  width: "16",
                  height: "16",
                  fill: "white",
                }),
              }),
            }),
          ],
        });
      },
      Hn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            id: "Sliders",
            children: [
              (0, Qe.jsx)("path", {
                d: "M8 6.75V13.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M8 2.5V4.25",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M8 6.75C8.69036 6.75 9.25 6.19036 9.25 5.5C9.25 4.80964 8.69036 4.25 8 4.25C7.30964 4.25 6.75 4.80964 6.75 5.5C6.75 6.19036 7.30964 6.75 8 6.75Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M12.5 11.75V13.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M12.5 2.5V9.25",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M12.5 11.75C13.1904 11.75 13.75 11.1904 13.75 10.5C13.75 9.80964 13.1904 9.25 12.5 9.25C11.8096 9.25 11.25 9.80964 11.25 10.5C11.25 11.1904 11.8096 11.75 12.5 11.75Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M3.5 9.75V13.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M3.5 2.5V7.25",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M3.5 9.75C4.19036 9.75 4.75 9.19036 4.75 8.5C4.75 7.80964 4.19036 7.25 3.5 7.25C2.80964 7.25 2.25 7.80964 2.25 8.5C2.25 9.19036 2.80964 9.75 3.5 9.75Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      },
      Vn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("path", {
            d: "M2 5.5V13C2 13.2761 2.22386 13.5 2.5 13.5H13.5C13.7761 13.5 14 13.2761 14 13V6C14 5.72386 13.7761 5.5 13.5 5.5H9M2 5.5H9M2 5.5V3C2 2.72386 2.22386 2.5 2.5 2.5H5.79289C5.9255 2.5 6.05268 2.55268 6.14645 2.64645L9 5.5",
            stroke: t,
            strokeWidth: "1.25",
          }),
        });
      },
      Dn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("path", {
              d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
              stroke: t,
              strokeWidth: "1.25",
              strokMiterlimit: "10",
            }),
            (0, Qe.jsx)("path", {
              d: "M1.40039 5.66699H14.5983",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M1.40039 10.333H14.5983",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M8.00065 14.8103C9.61148 14.8103 10.9173 11.7612 10.9173 7.99987C10.9173 4.23858 9.61148 1.18945 8.00065 1.18945C6.38982 1.18945 5.08398 4.23858 5.08398 7.99987C5.08398 11.7612 6.38982 14.8103 8.00065 14.8103Z",
              stroke: t,
              strokeWidth: "1.25",
              strokMiterlimit: "10",
            }),
          ],
        });
      },
      Bn = function () {
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            id: "Menu Icons",
            children: [
              (0, Qe.jsx)("path", {
                d: "M14.5 3.5L9.03033 8.96967C8.73744 9.26256 8.26256 9.26256 7.96967 8.96967L6.53033 7.53033C6.23744 7.23744 5.76256 7.23744 5.46967 7.53033L1.5 11.5",
                stroke: "#fff",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M14.5 7.5V3.5H10.5",
                stroke: "#fff",
                strokeWidth: "1.5",
                strokeLinecap: "round",
              }),
            ],
          }),
        });
      },
      Wn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("path", {
              d: "M2 9.0929V2.57153V2.57153C2 2.25596 2.25586 2.00005 2.57143 2.00011V2.00011C6.81141 2.00011 9.18859 2.00011 13.4286 2.00011V2.00011C13.7442 2.00011 14 2.25595 14 2.57153V2.57153V13.4286V13.4286C14 13.7442 13.7442 14 13.4286 14V14H8.54286",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M8 10L3.98412 13.4422C3.60963 13.7632 3.05703 13.7632 2.68254 13.4422L1 12",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      zn = function () {
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("path", {
            d: "M2 5.5V13C2 13.2761 2.22386 13.5 2.5 13.5H13.5C13.7761 13.5 14 13.2761 14 13V6C14 5.72386 13.7761 5.5 13.5 5.5H9M2 5.5H9M2 5.5V3C2 2.72386 2.22386 2.5 2.5 2.5H5.79289C5.9255 2.5 6.05268 2.55268 6.14645 2.64645L9 5.5",
            stroke: "#fff",
            strokeWidth: "1.25",
          }),
        });
      },
      Zn = function () {
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M2.90909 2.875H13.0909C13.8353 2.875 14.375 3.4352 14.375 4.05V12.45C14.375 13.0648 13.8353 13.625 13.0909 13.625H2.90909C2.16475 13.625 1.625 13.0648 1.625 12.45V4.05C1.625 3.43521 2.16475 2.875 2.90909 2.875Z",
                stroke: "#fff",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M2 6.25L14 6.25",
                stroke: "#fff",
                strokeWidth: "1.25",
                strokeLinecap: "square",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M4 3.5V1.5",
                stroke: "#fff",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M12 3.5V1.5",
                stroke: "#fff",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      },
      Fn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z",
                fill: t,
              }),
              (0, Qe.jsx)("path", {
                d: "M8 9V8.375C8.39556 8.375 8.78224 8.24671 9.11114 8.00634C9.44004 7.76597 9.69638 7.42433 9.84776 7.02462C9.99913 6.62491 10.0387 6.18507 9.96157 5.76074C9.8844 5.33641 9.69392 4.94663 9.41421 4.64071C9.13451 4.33478 8.77814 4.12644 8.39018 4.04203C8.00222 3.95763 7.60009 4.00095 7.23463 4.16651C6.86918 4.33208 6.55682 4.61246 6.33706 4.97219C6.1173 5.33192 6 5.75485 6 6.1875",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      },
      Un = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          role: "img",
          "aria-hidden": !0,
          width: "16",
          height: "20",
          viewBox: "0 0 16 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("rect", {
              x: "0.625",
              y: "2.625",
              width: "14.75",
              height: "14.75",
              rx: "2.375",
              fill: "transparent",
            }),
            (0, Qe.jsx)("rect", {
              x: "0.625",
              y: "2.625",
              width: "14.75",
              height: "14.75",
              rx: "2.375",
              stroke: t,
              strokeWidth: "1.25",
            }),
            (0, Qe.jsx)("path", {
              d: "M8.60012 8.92558L9.56173 6.64254C9.83667 6.10535 9.14999 5.8368 8.87505 6.10535L5.44168 9.32849C5.16674 9.59713 5.16674 9.86568 5.57847 9.99996L7.5017 11.0744L6.54009 13.3575C6.40329 13.8946 6.95183 14.1632 7.22676 13.8946L10.6601 10.6715C10.7969 10.5371 10.7969 10.1343 10.5233 9.99996L8.60012 8.92558Z",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      Kn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("rect", {
                x: "1",
                y: "1",
                width: "14",
                height: "14",
                rx: "2",
                stroke: t,
                "stroke-width": "1.25",
              }),
              (0, Qe.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.25241 3.18183C9.28697 3.02338 9.07969 2.93118 8.98516 3.06297L5.02827 8.57956C4.95647 8.67967 5.02994 8.81876 5.15311 8.81588L8.04359 8.74826C8.07801 8.74746 8.10946 8.75819 8.13477 8.77662C8.18058 8.80997 8.20626 8.86851 8.19298 8.92938L7.34467 12.8182C7.3101 12.9766 7.51739 13.0688 7.61192 12.937L11.5688 7.42044C11.6406 7.32033 11.5671 7.18123 11.444 7.18412L8.55348 7.25174C8.51907 7.25254 8.48761 7.24181 8.4623 7.22338C8.4165 7.19003 8.39081 7.13149 8.40409 7.07062L9.25241 3.18183Z",
                fill: t,
              }),
            ],
          }),
        });
      },
      Gn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M14.5 3.5L9.03033 8.96967C8.73744 9.26256 8.26256 9.26256 7.96967 8.96967L6.53033 7.53033C6.23744 7.23744 5.76256 7.23744 5.46967 7.53033L1.5 11.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M14.5 7.5V3.5H10.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
            ],
          }),
        });
      },
      Yn = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          role: "img",
          "aria-hidden": !0,
          width: "16",
          height: "20",
          viewBox: "0 0 16 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("path", {
              d: "M2.16667 17.0709C1.54444 17.0709 1 16.5497 1 15.9042C1 15.2586 1.54444 14.7375 2.16667 14.7375C2.47778 14.7375 2.78859 14.8697 3.02192 15.0797C3.17747 15.2897 3.33333 15.5853 3.33333 15.9042C3.33333 16.5497 2.78889 17.0709 2.16667 17.0709ZM6.05556 10.8486C6.67778 10.8486 7.22222 11.3697 7.22222 12.0153C7.22222 12.3342 7.06636 12.6298 6.91081 12.8398C6.67747 13.0498 6.36667 13.182 6.05556 13.182C5.74444 13.182 5.43364 13.0498 5.2003 12.8398C5.04475 12.6298 4.88889 12.3342 4.88889 12.0153C4.88889 11.3697 5.43333 10.8486 6.05556 10.8486ZM9.94444 17.0709C9.32222 17.0709 8.77778 16.5497 8.77778 15.9042C8.77778 15.5853 8.93364 15.2897 9.08919 15.0797C9.32253 14.8697 9.63333 14.7375 9.94444 14.7375C10.2556 14.7375 10.5664 14.8697 10.7997 15.0797C10.9553 15.2897 11.1111 15.5853 11.1111 15.9042C11.1111 16.5497 10.5667 17.0709 9.94444 17.0709ZM13.8333 13.182C13.5222 13.182 13.2114 13.0498 12.9781 12.8398C12.8225 12.6298 12.6667 12.3342 12.6667 12.0153C12.6667 11.3697 13.2111 10.8486 13.8333 10.8486C14.4556 10.8486 15 11.3697 15 12.0153C15 12.6609 14.4556 13.182 13.8333 13.182Z",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M3 15.0769L5.17661 12.8389L3 15.0769ZM6.88571 12.8389L9.06232 15.0769L6.88571 12.8389ZM10.7714 15.0769L12.948 12.8389L10.7714 15.0769Z",
              fill: t,
            }),
            (0, Qe.jsx)("path", {
              d: "M3 15.0769L5.17661 12.8389M6.88571 12.8389L9.06232 15.0769M10.7714 15.0769L12.948 12.8389",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M2.17857 4.79928C2.13571 4.9 2.1142 4.95143 2.09277 4.99429C2.07134 5.03286 2.02849 5.06714 1.98563 5.09285C1.94277 5.12499 1.89983 5.14429 1.79269 5.18501L1 5.5L1.79269 5.81499C1.89983 5.85571 1.94277 5.87501 1.98563 5.90715C2.02849 5.93286 2.07134 5.96714 2.09277 6.00571C2.1142 6.04857 2.13571 6.1 2.17857 6.20072L2.5 7L2.82143 6.20072C2.86429 6.1 2.8858 6.04857 2.90723 6.00571C2.92866 5.96714 2.97151 5.93286 3.01437 5.90715C3.05723 5.87501 3.10017 5.85571 3.20731 5.81499L4 5.5L3.20731 5.18501C3.10017 5.14429 3.05723 5.12499 3.01437 5.09285C2.97151 5.06714 2.92866 5.03286 2.90723 4.99429C2.8858 4.95143 2.86429 4.9 2.82143 4.79928L2.5 4L2.17857 4.79928Z",
              stroke: t,
              strokeWidth: "1.125",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M13.4286 3.54928C13.3857 3.65 13.3642 3.70143 13.3428 3.74429C13.3213 3.78286 13.2785 3.81714 13.2356 3.84285C13.1928 3.87499 13.1498 3.89429 13.0427 3.93501L12.25 4.25L13.0427 4.56499C13.1498 4.60571 13.1928 4.625 13.2356 4.65715C13.2785 4.68286 13.3213 4.71714 13.3428 4.75571C13.3642 4.79857 13.3857 4.85 13.4286 4.95072L13.75 5.75L14.0714 4.95072C14.1143 4.85 14.1358 4.79857 14.1572 4.75571C14.1787 4.71714 14.2215 4.68286 14.2644 4.65715C14.3072 4.625 14.3502 4.60571 14.4573 4.56499L15.25 4.25L14.4573 3.93501C14.3502 3.89429 14.3072 3.87499 14.2644 3.84285C14.2215 3.81714 14.1787 3.78286 14.1572 3.74429C14.1358 3.70143 14.1143 3.65 14.0714 3.54928L13.75 2.75L13.4286 3.54928Z",
              stroke: t,
              strokeWidth: "1.125",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M7.76786 5.94892C7.70357 6.09999 7.6713 6.17715 7.63916 6.24143C7.60702 6.29929 7.54273 6.35071 7.47845 6.38928C7.41416 6.43749 7.34975 6.46644 7.18903 6.52751L6 7L7.18903 7.47249C7.34975 7.53356 7.41416 7.56251 7.47845 7.61072C7.54273 7.64929 7.60702 7.70071 7.63916 7.75857C7.6713 7.82285 7.70357 7.90001 7.76786 8.05108L8.25 9.25L8.73214 8.05108C8.79643 7.90001 8.8287 7.82285 8.86084 7.75857C8.89298 7.70071 8.95727 7.64929 9.02155 7.61072C9.08584 7.56251 9.15025 7.53356 9.31097 7.47249L10.5 7L9.31097 6.52751C9.15025 6.46644 9.08584 6.43749 9.02155 6.38928C8.95727 6.35071 8.89298 6.29929 8.86084 6.24143C8.8287 6.17715 8.79643 6.09999 8.73214 5.94892L8.25 4.75L7.76786 5.94892Z",
              stroke: t,
              strokeWidth: "1.125",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      $n = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            id: "Integration",
            children: [
              (0, Qe.jsx)("path", {
                d: "M8.24978 11.25L6.31228 13.1875C6.17292 13.3273 6.00733 13.4383 5.825 13.514C5.64268 13.5897 5.4472 13.6287 5.24978 13.6287C5.05236 13.6287 4.85688 13.5897 4.67455 13.514C4.49222 13.4383 4.32663 13.3273 4.18728 13.1875L2.81228 11.8125C2.67244 11.6731 2.56148 11.5076 2.48577 11.3252C2.41007 11.1429 2.37109 10.9474 2.37109 10.75C2.37109 10.5526 2.41007 10.3571 2.48577 10.1748C2.56148 9.99244 2.67244 9.82686 2.81228 9.6875L4.74978 7.75",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M3.5 12.5L1.5 14.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M14.5 1.5L12.5 3.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M9 9L7.5 10.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M7 7L5.5 8.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M11.25 8.24978L13.1875 6.31228C13.3273 6.17292 13.4383 6.00733 13.514 5.825C13.5897 5.64268 13.6287 5.4472 13.6287 5.24978C13.6287 5.05236 13.5897 4.85688 13.514 4.67455C13.4383 4.49222 13.3273 4.32663 13.1875 4.18728L11.8125 2.81228C11.6731 2.67244 11.5076 2.56148 11.3252 2.48577C11.1429 2.41007 10.9474 2.37109 10.75 2.37109C10.5526 2.37109 10.3571 2.41007 10.1748 2.48577C9.99244 2.56148 9.82686 2.67244 9.6875 2.81228L7.75 4.74978",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M7.25 4.25L11.75 8.75",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M4.25 7.25L8.75 11.75",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      };
    function qn() {
      return (
        (qn = Object.assign
          ? Object.assign.bind()
          : function (e) {
              for (var n = 1; n < arguments.length; n++) {
                var t = arguments[n];
                for (var r in t)
                  Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
              }
              return e;
            }),
        qn.apply(this, arguments)
      );
    }
    var Qn = function (e) {
        var n = qn(
            {},
            ((function (e) {
              if (null == e) throw new TypeError("Cannot destructure " + e);
            })(e),
            e)
          ).color,
          t = void 0 === n ? "#fff" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": "true",
          width: "16",
          height: "16",
          role: "img",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M5.825 7.675C5.60826 7.14327 5.49784 6.57421 5.5 6C5.5 5.10999 5.76392 4.23996 6.25839 3.49994C6.75285 2.75991 7.45566 2.18314 8.27792 1.84254C9.10019 1.50195 10.005 1.41283 10.8779 1.58647C11.7508 1.7601 12.5526 2.18869 13.182 2.81802C13.8113 3.44736 14.2399 4.24918 14.4135 5.1221C14.5872 5.99501 14.4981 6.89981 14.1575 7.72208C13.8169 8.54434 13.2401 9.24715 12.5001 9.74162C11.76 10.2361 10.89 10.5 10 10.5C9.42579 10.5022 8.85673 10.3917 8.325 10.175L7.5 11H6V12.5H4.5V14H2V11.5L5.825 7.675Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M11.375 4.75C11.375 4.81904 11.319 4.875 11.25 4.875C11.181 4.875 11.125 4.81904 11.125 4.75C11.125 4.68096 11.181 4.625 11.25 4.625C11.319 4.625 11.375 4.68096 11.375 4.75Z",
                fill: t,
                stroke: t,
                strokeWidth: "1.25",
              }),
            ],
          }),
        });
      },
      Xn = function () {
        return (0, Qe.jsxs)("svg", {
          width: "186",
          height: "48",
          viewBox: "0 0 186 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-hidden": !0,
          children: [
            (0, Qe.jsx)("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.36806 31.0443V33.0385C7.36806 33.5238 6.82206 33.8229 6.38626 33.5675L5.43468 32.9743L5.20589 32.849C5.18924 32.8398 3.87671 32.1032 0.996801 30.4866L0.768558 30.3596C0.530936 30.2264 0.335906 30.0358 0.201083 29.8057C0.0678324 29.5775 -0.00151093 29.3185 0.00109508 29.0616L0 24.0951V19.1205C0 18.8413 0.0812403 18.5686 0.232238 18.3346C0.381869 18.0994 0.598542 17.9062 0.820616 17.8022L4.97153 15.4734L5.19879 15.3443C5.27438 15.3022 5.27446 15.3022 5.42688 15.2179L5.42737 15.2176L9.40274 12.9896L9.63559 12.8557C9.89138 12.7127 10.1809 12.6446 10.4744 12.6579C10.7594 12.6713 11.0403 12.762 11.2334 12.8957L15.3701 15.2164L15.5994 15.342L19.8057 17.7029L20.0354 17.8305C20.2729 17.9639 20.4675 18.1542 20.6022 18.3843C20.7352 18.6119 20.8045 18.8709 20.8023 19.1285L20.8031 23.651C20.8032 24.1311 20.2677 24.431 19.8395 24.1908L18.0543 23.189C17.8558 23.0777 17.7335 22.872 17.7335 22.6494V19.9785L14.145 17.9639C14.111 17.9476 14.0414 17.909 13.8415 17.7966L10.4013 15.8637L6.82463 17.8689L6.82457 17.8689L6.82455 17.869C6.7898 17.8912 6.78978 17.8912 6.76741 17.905C6.75393 17.913 6.50861 18.0512 6.50861 18.0512L3.06984 19.9788V28.2114L6.6604 30.2268C6.68607 30.2393 6.73294 30.2653 6.96988 30.3981L7.06979 30.4842L7.1252 30.5561C7.27759 30.6735 7.36806 30.8529 7.36806 31.0443ZM6.71511 31.0626L6.70908 31.0572C6.71071 31.0593 6.71274 31.0612 6.71511 31.0626ZM18.7 25.3785C18.2718 25.1391 17.7372 25.4391 17.7372 25.9186V26.2859L8.63799 21.1818L8.32825 21.0067C8.01895 20.8334 7.63732 20.8515 7.34939 21.0504L7.111 21.1805L5.74955 21.9412L5.20047 22.2472C4.76099 22.4939 4.62353 23.0339 4.88005 23.4635L5.19219 23.986L5.50713 24.5142C5.76179 24.9406 6.31925 25.0736 6.76045 24.823C7.29794 24.5219 7.32327 24.5077 7.34721 24.4915C7.34936 24.4901 7.3515 24.4886 7.35401 24.4869L7.8713 24.1985L8.90628 24.7792L8.90523 34.4721C8.90523 34.9573 9.31029 35.3507 9.81005 35.3507C10.0393 35.3507 10.2584 35.2667 10.4257 35.1163C11.2623 34.4605 11.4059 34.348 11.5494 34.2354C11.5791 34.2121 11.6088 34.1887 11.6447 34.1606C11.8801 33.9765 12.0039 33.6918 11.9782 33.4009L11.9801 26.5045L18.4889 30.1672C18.9434 30.4213 19.4498 30.251 19.7884 29.8309L20.624 29.0048C20.7413 28.888 20.8068 28.7318 20.8068 28.5692V26.9167C20.8068 26.6938 20.6841 26.4879 20.4851 26.3766L18.7 25.3785Z",
              fill: "#0EBAC5",
            }),
            (0, Qe.jsx)("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M29.2175 29.6752C29.1086 29.6752 29.0132 29.6346 28.9313 29.5536C28.8497 29.4724 28.8086 29.3778 28.8086 29.2697V18.7241C28.8086 18.6053 28.8497 18.5079 28.9313 18.4323C29.0132 18.3564 29.1086 18.3186 29.2175 18.3186H31.5066C31.6265 18.3186 31.7245 18.3564 31.8009 18.4323C31.8771 18.5079 31.9152 18.6053 31.9152 18.7241V27.1282H36.8205C36.9402 27.1282 37.0412 27.1686 37.1228 27.2498C37.2046 27.331 37.2455 27.431 37.2455 27.55V29.2697C37.2455 29.3887 37.2046 29.4861 37.1228 29.5617C37.0412 29.6374 36.9402 29.6752 36.8205 29.6752H29.2175ZM37.9819 29.6752C37.8947 29.6752 37.8155 29.6402 37.7449 29.5696C37.6738 29.4993 37.6385 29.4209 37.6385 29.3344C37.6385 29.2697 37.6441 29.221 37.6548 29.1885L41.4645 18.7891C41.5735 18.4754 41.7914 18.3186 42.1184 18.3186H44.6691C44.996 18.3186 45.2141 18.4754 45.323 18.7891L49.1327 29.1885C49.1437 29.221 49.1491 29.2697 49.1491 29.3344C49.1491 29.4209 49.1135 29.4993 49.0427 29.5696C48.9719 29.6402 48.8928 29.6752 48.8056 29.6752H46.68C46.4186 29.6752 46.2332 29.5562 46.1242 29.3182L45.5356 27.7446H41.252L40.6633 29.3182C40.5544 29.5562 40.369 29.6752 40.1073 29.6752H37.9819ZM41.9413 25.3111H44.8515L43.3964 21.1739L41.9413 25.3111ZM50.8189 29.6752C50.699 29.6752 50.5982 29.6374 50.5164 29.5617C50.4348 29.4861 50.3939 29.3887 50.3939 29.2697V18.7403C50.3939 18.6216 50.4348 18.5213 50.5164 18.4404C50.5982 18.3592 50.699 18.3186 50.8189 18.3186H52.6666C52.939 18.3186 53.1354 18.4376 53.2551 18.6754L56.0674 23.6723L58.896 18.6754C59.0157 18.4376 59.2121 18.3186 59.4845 18.3186H61.3322C61.4521 18.3186 61.5529 18.3592 61.6347 18.4404C61.7163 18.5213 61.7572 18.6216 61.7572 18.7403V29.2697C61.7572 29.3887 61.7163 29.4861 61.6347 29.5617C61.5529 29.6374 61.4521 29.6752 61.3322 29.6752H59.2556C59.1467 29.6752 59.0513 29.6346 58.9694 29.5536C58.8878 29.4724 58.8469 29.3778 58.8469 29.2697V23.364L57.0811 26.5766C56.9394 26.8252 56.7486 26.9496 56.5088 26.9496H55.626C55.4078 26.9496 55.2171 26.8252 55.0536 26.5766L53.3042 23.364V29.2697C53.3042 29.3887 53.2632 29.4861 53.1817 29.5617C53.0998 29.6374 52.9991 29.6752 52.8791 29.6752H50.8189ZM64.3839 29.6752C64.2749 29.6752 64.1795 29.6346 64.0979 29.5536C64.0161 29.4724 63.9752 29.3778 63.9752 29.2697V18.7403C63.9752 18.6216 64.0133 18.5213 64.0895 18.4404C64.166 18.3592 64.2642 18.3186 64.3839 18.3186H69.4362C70.8204 18.3186 71.8505 18.5998 72.5264 19.1623C73.2021 19.7247 73.5402 20.525 73.5402 21.5634C73.5402 22.0825 73.4011 22.5314 73.1233 22.9098C72.8453 23.2884 72.5372 23.5642 72.1994 23.7373C72.6464 23.9319 73.0223 24.2537 73.3276 24.7026C73.6327 25.1515 73.7854 25.6572 73.7854 26.2195C73.7854 27.3117 73.4228 28.161 72.698 28.7667C71.9733 29.3722 70.935 29.6752 69.5832 29.6752H64.3839ZM69.098 22.8122C69.5013 22.8122 69.812 22.7041 70.0302 22.4877C70.2481 22.2712 70.3573 21.9903 70.3573 21.6442C70.3573 21.3087 70.2509 21.0357 70.0384 20.8248C69.8258 20.6137 69.5123 20.5084 69.098 20.5084H67.0545V22.8122H69.098ZM69.2453 27.4849C69.6704 27.4849 70.0002 27.3631 70.2345 27.1197C70.4688 26.8766 70.5861 26.5764 70.5861 26.2194C70.5861 25.8517 70.4662 25.5462 70.2263 25.3026C69.9865 25.0595 69.6596 24.9377 69.2453 24.9377H67.0545V27.4849H69.2453ZM75.9466 29.6752C75.8374 29.6752 75.7422 29.6346 75.6604 29.5536C75.5786 29.4724 75.5377 29.3778 75.5377 29.2697V18.7403C75.5377 18.6216 75.576 18.5213 75.6522 18.4404C75.7284 18.3592 75.8266 18.3186 75.9466 18.3186H80.2467C81.8599 18.3186 83.1133 18.6997 84.0073 19.4625C84.9009 20.2248 85.3699 21.32 85.4131 22.7476C85.4241 23.0613 85.4297 23.4777 85.4297 23.9969C85.4297 24.5161 85.4241 24.9269 85.4131 25.2299C85.3042 28.1933 83.6092 29.6752 80.3283 29.6752H75.9466ZM80.2419 27.2414C80.9283 27.2414 81.4351 27.0793 81.7625 26.7547C82.0893 26.4304 82.2637 25.911 82.2855 25.1972C82.3074 24.8835 82.3182 24.478 82.3182 23.9804C82.3182 23.4828 82.3074 23.0826 82.2855 22.7799C82.2637 22.0877 82.0755 21.5766 81.7215 21.2467C81.3671 20.9168 80.8469 20.7519 80.16 20.7519H78.6067V27.2414H80.2419ZM86.6585 29.6752C86.5713 29.6752 86.4922 29.6402 86.4214 29.5696C86.3503 29.4993 86.315 29.4209 86.315 29.3344C86.315 29.2697 86.3204 29.221 86.3314 29.1885L90.1408 18.7891C90.25 18.4754 90.4681 18.3186 90.795 18.3186H93.3457C93.6727 18.3186 93.8906 18.4754 93.9996 18.7891L97.8092 29.1885C97.8202 29.221 97.8254 29.2697 97.8254 29.3344C97.8254 29.4209 97.7901 29.4993 97.7192 29.5696C97.6486 29.6402 97.5696 29.6752 97.4822 29.6752H95.3568C95.0951 29.6752 94.9097 29.5562 94.8008 29.3182L94.2121 27.7446H89.9283L89.3396 29.3182C89.2309 29.5562 89.0457 29.6752 88.7841 29.6752H86.6585ZM90.6076 25.3111H93.5179L92.0627 21.1739L90.6076 25.3111ZM102.003 29.6752C101.883 29.6752 101.783 29.6374 101.7 29.5617C101.619 29.4861 101.578 29.3887 101.578 29.2697V20.963H98.7004C98.5805 20.963 98.4797 20.9252 98.3979 20.8495C98.3161 20.7737 98.2751 20.6765 98.2751 20.5575V18.7403C98.2751 18.6216 98.3161 18.5213 98.3979 18.4404C98.4797 18.3592 98.5805 18.3186 98.7004 18.3186H107.578C107.698 18.3186 107.799 18.3592 107.881 18.4404C107.963 18.5213 108.004 18.6216 108.004 18.7403V20.5575C108.004 20.6765 107.963 20.7737 107.881 20.8495C107.799 20.9252 107.698 20.963 107.578 20.963H104.701V29.2697C104.701 29.3887 104.66 29.4861 104.578 29.5617C104.496 29.6374 104.396 29.6752 104.276 29.6752H102.003ZM109.859 29.6752C109.75 29.6752 109.654 29.6346 109.573 29.5536C109.491 29.4724 109.45 29.3778 109.45 29.2697V18.7403C109.45 18.6216 109.488 18.5213 109.565 18.4404C109.641 18.3592 109.739 18.3186 109.859 18.3186H117.576C117.696 18.3186 117.797 18.3592 117.879 18.4404C117.96 18.5213 118.001 18.6216 118.001 18.7403V20.3466C118.001 20.4656 117.96 20.5628 117.879 20.6384C117.797 20.7143 117.696 20.7521 117.576 20.7521H112.41V22.8126H117.217C117.336 22.8126 117.437 22.8532 117.519 22.9342C117.601 23.0154 117.642 23.1153 117.642 23.2344V24.7107C117.642 24.8297 117.601 24.9297 117.519 25.0109C117.437 25.0919 117.336 25.1327 117.217 25.1327H112.41V27.2417H117.707C117.827 27.2417 117.928 27.2823 118.01 27.3632C118.091 27.4444 118.132 27.5444 118.132 27.6634V29.2697C118.132 29.3887 118.091 29.4861 118.01 29.5617C117.928 29.6374 117.827 29.6752 117.707 29.6752H109.859ZM124.276 29.8372C123.219 29.8372 122.32 29.6859 121.578 29.3829C120.837 29.0802 120.276 28.68 119.894 28.1822C119.513 27.685 119.311 27.144 119.289 26.5599C119.289 26.4627 119.325 26.3815 119.396 26.3166C119.466 26.2518 119.551 26.2193 119.649 26.2193H121.824C121.954 26.2193 122.061 26.2409 122.142 26.2843C122.224 26.3275 122.314 26.4031 122.412 26.5112C122.554 26.7708 122.775 26.9844 123.074 27.1522C123.374 27.3199 123.775 27.4036 124.276 27.4036C124.865 27.4036 125.317 27.3143 125.633 27.1362C125.949 26.9575 126.107 26.7116 126.107 26.3977C126.107 26.1709 126.026 25.9841 125.862 25.8382C125.699 25.692 125.437 25.5621 125.077 25.4487C124.718 25.3353 124.2 25.2081 123.524 25.0675C122.205 24.808 121.219 24.4131 120.565 23.883C119.911 23.3532 119.584 22.596 119.584 21.6119C119.584 20.9412 119.772 20.3436 120.148 19.8191C120.524 19.2944 121.058 18.8863 121.75 18.5942C122.442 18.3022 123.246 18.1562 124.162 18.1562C125.121 18.1562 125.952 18.3212 126.655 18.6508C127.358 18.981 127.898 19.3918 128.274 19.8838C128.65 20.3761 128.849 20.86 128.871 21.3361C128.871 21.4333 128.838 21.5172 128.772 21.5875C128.707 21.6578 128.625 21.6929 128.527 21.6929H126.238C125.998 21.6929 125.813 21.5957 125.682 21.4008C125.617 21.1737 125.448 20.9818 125.175 20.825C124.903 20.6682 124.565 20.5898 124.162 20.5898C123.704 20.5898 123.35 20.671 123.099 20.8331C122.848 20.9953 122.723 21.2333 122.723 21.5469C122.723 21.8606 122.887 22.1067 123.213 22.2851C123.541 22.4637 124.151 22.6447 125.045 22.8287C126.069 23.0124 126.884 23.2423 127.489 23.5181C128.094 23.7937 128.541 24.151 128.83 24.5887C129.119 25.0269 129.263 25.5814 129.263 26.2518C129.263 26.9872 129.05 27.6254 128.625 28.1662C128.2 28.7069 127.612 29.1206 126.859 29.4073C126.107 29.694 125.246 29.8372 124.276 29.8372ZM133.774 29.6752C133.654 29.6752 133.553 29.6374 133.472 29.5617C133.39 29.4861 133.349 29.3887 133.349 29.2697V20.963H130.471C130.351 20.963 130.251 20.9252 130.169 20.8495C130.087 20.7737 130.046 20.6765 130.046 20.5575V18.7403C130.046 18.6216 130.087 18.5213 130.169 18.4404C130.251 18.3592 130.351 18.3186 130.471 18.3186H139.349C139.469 18.3186 139.57 18.3592 139.652 18.4404C139.734 18.5213 139.775 18.6216 139.775 18.7403V20.5575C139.775 20.6765 139.734 20.7737 139.652 20.8495C139.57 20.9252 139.469 20.963 139.349 20.963H136.472V29.2697C136.472 29.3887 136.431 29.4861 136.349 29.5617C136.267 29.6374 136.167 29.6752 136.047 29.6752H133.774Z",
              fill: "white",
            }),
          ],
        });
      },
      Jn = function () {
        return (0, Qe.jsxs)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("rect", {
              x: "1",
              y: "1",
              width: "5.86047",
              height: "5.86047",
              stroke: "#e9ecec",
            }),
            (0, Qe.jsx)("rect", {
              x: "8.8125",
              y: "1",
              width: "5.86047",
              height: "5.86047",
              stroke: "#e9ecec",
            }),
            (0, Qe.jsx)("rect", {
              x: "1",
              y: "8.81409",
              width: "5.86047",
              height: "5.86047",
              stroke: "#e9ecec",
            }),
            (0, Qe.jsx)("line", {
              x1: "11.5938",
              y1: "8.48853",
              x2: "11.5938",
              y2: "15.0002",
              stroke: "#e9ecec",
            }),
            (0, Qe.jsx)("line", {
              x1: "8.48828",
              y1: "11.8953",
              x2: "14.9999",
              y2: "11.8953",
              stroke: "#e9ecec",
            }),
          ],
        });
      },
      et = function () {
        return (0, Qe.jsxs)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("path", {
              d: "M5.5 10C7.29493 10 8.75 8.54493 8.75 6.75C8.75 4.95507 7.29493 3.5 5.5 3.5C3.70507 3.5 2.25 4.95507 2.25 6.75C2.25 8.54493 3.70507 10 5.5 10Z",
              stroke: "#e9ecec",
              strokeMiterlimit: "10",
            }),
            (0, Qe.jsx)("path", {
              d: "M9.71094 3.61875C9.99824 3.54083 10.2945 3.50091 10.5922 3.5C11.4541 3.5 12.2808 3.84241 12.8903 4.4519C13.4998 5.0614 13.8422 5.88805 13.8422 6.75C13.8422 7.61195 13.4998 8.4386 12.8903 9.0481C12.2808 9.65759 11.4541 10 10.5922 10",
              stroke: "#e9ecec",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M1 12.3375C1.50747 11.6153 2.18127 11.0259 2.9645 10.6191C3.74774 10.2122 4.61739 9.99976 5.5 9.99976C6.38261 9.99976 7.25226 10.2122 8.0355 10.6191C8.81873 11.0259 9.49253 11.6153 10 12.3375",
              stroke: "#e9ecec",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M10.5938 10C11.4764 9.99945 12.3463 10.2116 13.1296 10.6185C13.9129 11.0254 14.5866 11.615 15.0938 12.3375",
              stroke: "#e9ecec",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      nt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            id: "MonitorPlay",
            children: [
              (0, Qe.jsx)("path", {
                d: "M1.909 11.6367L14.0908 11.6367C14.6431 11.6367 15.0908 11.189 15.0908 10.6367V10.4549L15.0908 2.18217V2.00035C15.0908 1.44807 14.6431 1.00035 14.0908 1.00035L1.909 1.00035C1.35672 1.00035 0.909002 1.44807 0.909002 2.00035V2.18217L0.909002 10.4549V10.6367C0.909002 11.189 1.35672 11.6367 1.909 11.6367Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M10.364 14H5.63672",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M9.73344 6.52673C9.88187 6.42777 9.88187 6.20966 9.73344 6.1107L6.88867 4.21419C6.72254 4.10344 6.5 4.22253 6.5 4.42221V8.21522C6.5 8.4149 6.72254 8.53399 6.88868 8.42323L9.73344 6.52673Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
            ],
          }),
        });
      },
      tt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          role: "img",
          "aria-hidden": !0,
          width: "16",
          height: "20",
          viewBox: "0 0 16 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("path", {
              d: "M8 6.5V13.5M11.5 10H4.5",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("rect", {
              x: "1",
              y: "3",
              width: "14",
              height: "14",
              rx: "2",
              stroke: t,
              strokeWidth: "1.25",
            }),
          ],
        });
      },
      rt = function () {
        return (0, Qe.jsxs)("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-label": "notification",
          role: "img",
          "aria-hidden": !0,
          children: [
            (0, Qe.jsx)("path", {
              d: "M9.74997 7.5V19.0969C9.75111 19.2215 9.72078 19.3444 9.66179 19.4542C9.60279 19.564 9.51704 19.6572 9.41247 19.725L8.38122 20.4094C8.28131 20.4761 8.16685 20.5178 8.04746 20.531C7.92807 20.5443 7.80724 20.5287 7.69515 20.4855C7.58306 20.4423 7.48297 20.3728 7.40333 20.2829C7.32368 20.193 7.2668 20.0852 7.23747 19.9688L5.99997 15",
              stroke: "#101010",
              strokeWidth: "1.2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M6 15C5.00544 15 4.05161 14.6049 3.34835 13.9016C2.64509 13.1984 2.25 12.2445 2.25 11.25C2.25 10.2554 2.64509 9.30158 3.34835 8.59831C4.05161 7.89505 5.00544 7.49997 6 7.49997H9.75C9.75 7.49997 14.8594 7.49996 19.7719 3.38434C19.8811 3.29392 20.0138 3.23634 20.1545 3.21827C20.2951 3.2002 20.4381 3.22239 20.5666 3.28226C20.6952 3.34212 20.8041 3.43722 20.8809 3.55651C20.9576 3.6758 20.9989 3.8144 21 3.95622V18.5437C20.9989 18.6855 20.9576 18.8241 20.8809 18.9434C20.8041 19.0627 20.6952 19.1578 20.5666 19.2177C20.4381 19.2775 20.2951 19.2997 20.1545 19.2817C20.0138 19.2636 19.8811 19.206 19.7719 19.1156C14.8594 15 9.75 15 9.75 15H6Z",
              stroke: "#101010",
              strokeWidth: "1.2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      ot = function () {
        return (0, Qe.jsxs)("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsxs)("g", {
              clipPath: "url(#clip0_13321_104554)",
              children: [
                (0, Qe.jsx)("circle", {
                  cx: "12",
                  cy: "12",
                  r: "11.375",
                  stroke: "#CF222E",
                  strokeWidth: "1.25",
                }),
                (0, Qe.jsx)("line", {
                  x1: "3.55806",
                  y1: "19.5581",
                  x2: "19.8215",
                  y2: "3.2946",
                  stroke: "#CF222E",
                  strokeWidth: "1.25",
                }),
                (0, Qe.jsx)("path", {
                  d: "M12.25 6.75C12.7332 6.75 13.125 6.35825 13.125 5.875C13.125 5.39175 12.7332 5 12.25 5C11.7668 5 11.375 5.39175 11.375 5.875C11.375 6.35825 11.7668 6.75 12.25 6.75Z",
                  stroke: "#FFEBE9",
                  strokeWidth: "2.75",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M9.625 19L12.25 13.75L14.875 19",
                  stroke: "#FFEBE9",
                  strokeWidth: "3",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M7 8.5L12.25 10.25L17.5 8.5",
                  stroke: "#FFEBE9",
                  strokeWidth: "3",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M12.25 10.25V13.75",
                  stroke: "#FFEBE9",
                  strokeWidth: "3",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M12.25 6.75C12.7332 6.75 13.125 6.35825 13.125 5.875C13.125 5.39175 12.7332 5 12.25 5C11.7668 5 11.375 5.39175 11.375 5.875C11.375 6.35825 11.7668 6.75 12.25 6.75Z",
                  stroke: "#CF222E",
                  strokeWidth: "1.75",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M9.625 19L12.25 13.75L14.875 19",
                  stroke: "#CF222E",
                  strokeWidth: "2",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M7 8.5L12.25 10.25L17.5 8.5",
                  stroke: "#CF222E",
                  strokeWidth: "2",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M12.25 10.25V13.75",
                  stroke: "#CF222E",
                  strokeWidth: "2",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
              ],
            }),
            (0, Qe.jsx)("defs", {
              children: (0, Qe.jsx)("clipPath", {
                children: (0, Qe.jsx)("rect", {
                  width: "24",
                  height: "24",
                  fill: "white",
                }),
              }),
            }),
          ],
        });
      };
    function it() {
      return (
        (it = Object.assign
          ? Object.assign.bind()
          : function (e) {
              for (var n = 1; n < arguments.length; n++) {
                var t = arguments[n];
                for (var r in t)
                  Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
              }
              return e;
            }),
        it.apply(this, arguments)
      );
    }
    var at = function (e) {
        var n = it(
            {},
            ((function (e) {
              if (null == e) throw new TypeError("Cannot destructure " + e);
            })(e),
            e)
          ).color,
          t = void 0 === n ? "#fff" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": "true",
          width: "16",
          height: "16",
          role: "img",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            id: "Buildings",
            children: [
              (0, Qe.jsx)("path", {
                d: "M8.5 13.4997V1.9997C8.49995 1.90921 8.47534 1.82043 8.42879 1.74283C8.38225 1.66523 8.31552 1.60171 8.23572 1.55905C8.15591 1.51639 8.06603 1.49619 7.97565 1.50059C7.88527 1.505 7.79777 1.53385 7.7225 1.58408L2.7225 4.9172C2.65392 4.96296 2.59772 5.02496 2.5589 5.09769C2.52008 5.17043 2.49984 5.25163 2.5 5.33407V13.4997",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M8.5 5.5H13C13.1326 5.5 13.2598 5.55268 13.3536 5.64645C13.4473 5.74021 13.5 5.86739 13.5 6V13.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M1 13.5H15",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M6.5 7V8",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M4.5 7V8",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M4.5 10.5V11.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M6.5 10.5V11.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      },
      lt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("g", {
            children: (0, Qe.jsx)("path", {
              d: "M8.4232 9.63589C7.53905 9.19288 6.82114 8.47664 6.37607 7.5935L7.37848 6.06887L7.37852 6.06889L7.38264 6.06246C7.48211 5.90706 7.54184 5.72958 7.55656 5.54566C7.57122 5.36237 7.54073 5.17829 7.46777 5.00953L6.21301 2.08174C6.11847 1.85683 5.95299 1.66895 5.74173 1.54677C5.5294 1.42398 5.2826 1.37437 5.03932 1.40558L8.4232 9.63589ZM8.4232 9.63589L9.92639 8.63176C10.0823 8.52656 10.2622 8.46235 10.4495 8.4451C10.6369 8.42784 10.8256 8.45813 10.9981 8.53313C10.9989 8.53346 10.9997 8.53379 11.0004 8.53413L13.9191 9.78762C14.1438 9.88217 14.3316 10.0476 14.4537 10.2588C14.5766 10.4712 14.6262 10.718 14.5949 10.9614M8.4232 9.63589L5.03912 1.4056C4.16487 1.51766 3.36138 1.94442 2.779 2.60602C2.19658 3.26768 1.8752 4.11889 1.875 5.00037V5.00051C1.875 7.42061 2.83638 9.74159 4.54765 11.4529C6.25892 13.1641 8.5799 14.1255 11 14.1255H11.0001C11.8816 14.1253 12.7328 13.8039 13.3945 13.2215C14.0561 12.6391 14.4828 11.8356 14.5949 10.9614M14.5949 10.9614L13.975 10.8818L14.5949 10.9612C14.5949 10.9613 14.5949 10.9613 14.5949 10.9614Z",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          }),
        });
      },
      st = function () {
        return (0, Qe.jsx)("svg", {
          role: "presentation",
          fill: "#000000",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 48 48",
          width: "14px",
          height: "14px",
          children: (0, Qe.jsx)("path", {
            d: "M 39.486328 6.9785156 A 1.50015 1.50015 0 0 0 38.439453 7.4394531 L 24 21.878906 L 9.5605469 7.4394531 A 1.50015 1.50015 0 0 0 8.484375 6.984375 A 1.50015 1.50015 0 0 0 7.4394531 9.5605469 L 21.878906 24 L 7.4394531 38.439453 A 1.50015 1.50015 0 1 0 9.5605469 40.560547 L 24 26.121094 L 38.439453 40.560547 A 1.50015 1.50015 0 1 0 40.560547 38.439453 L 26.121094 24 L 40.560547 9.5605469 A 1.50015 1.50015 0 0 0 39.486328 6.9785156 z",
          }),
        });
      },
      ct = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-label": "help section",
          role: "img",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z",
                fill: t,
              }),
              (0, Qe.jsx)("path", {
                d: "M8 9V8.375C8.39556 8.375 8.78224 8.24671 9.11114 8.00634C9.44004 7.76597 9.69638 7.42433 9.84776 7.02462C9.99913 6.62491 10.0387 6.18507 9.96157 5.76074C9.8844 5.33641 9.69392 4.94663 9.41421 4.64071C9.13451 4.33478 8.77814 4.12644 8.39018 4.04203C8.00222 3.95763 7.60009 4.00095 7.23463 4.16651C6.86918 4.33208 6.55682 4.61246 6.33706 4.97219C6.1173 5.33192 6 5.75485 6 6.1875",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      },
      ut = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          width: "17",
          height: "16",
          viewBox: "0 0 17 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-label": "quick action",
          role: "img",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M12.902 6.50027L13.1218 6.33C13.716 5.86967 13.7246 4.93098 13.1391 4.45834L9.49753 1.51893C9.11522 1.21034 8.58856 1.20144 8.19721 1.49695L4.24296 4.48282C3.63742 4.94006 3.62506 5.89091 4.2185 6.36575L7.95717 9.35721C8.41194 9.72109 9.05304 9.65532 9.43389 9.20572L9.60791 9.00027",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M7.7256 6.50024L8.43092 6.00064C8.84695 5.70595 9.39782 5.7471 9.77094 6.10075L13.3188 9.46339C13.8344 9.95209 13.8021 10.8192 13.2518 11.2632L9.28204 14.4656C8.89013 14.7817 8.34813 14.7823 7.95568 14.4669L4.16442 11.4201C3.58754 10.9565 3.58278 10.0373 4.15482 9.56699L6.06044 8.00024",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
            ],
          }),
        });
      },
      dt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          role: "img",
          "aria-hidden": !0,
          width: "16",
          height: "20",
          viewBox: "0 0 16 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("g", {
              children: (0, Qe.jsx)("path", {
                d: "M4.77778 13.7976H6.38889M10.4167 12.4167V14.6723C10.4167 15.5745 10.4165 16.0256 10.2554 16.372C10.0943 16.67 9.85309 16.9197 9.53087 17.0728C9.20865 17.25 8.72484 17.25 7.83873 17.25H3.32794C2.44182 17.25 1.95802 17.25 1.6358 17.0728C1.31357 16.9197 1.07238 16.67 0.911268 16.372C0.750157 16.0256 0.75 15.5745 0.75 14.6723V5.32774C0.75 4.42552 0.750157 3.97442 0.911268 3.62803C1.07238 3.32997 1.31357 3.08025 1.6358 2.9272C1.95802 2.74998 2.44182 2.75 3.32794 2.75H5.58333M8.80556 6.01254C9.61111 6.17365 10.2556 6.55225 10.8194 7.10808C11.3833 7.67197 11.7864 8.38079 11.9475 9.15413M8.80556 2.75C10.4167 2.93528 11.9475 3.6683 13.1559 4.8283C14.2836 5.99635 15.0083 7.51885 15.25 9.15413",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            }),
            (0, Qe.jsx)("defs", {
              children: (0, Qe.jsx)("clipPath", {
                children: (0, Qe.jsx)("rect", {
                  width: "16",
                  height: "16",
                  fill: "white",
                  transform: "translate(0 2)",
                }),
              }),
            }),
          ],
        });
      },
      pt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          role: "img",
          "aria-hidden": !0,
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("g", {
            children: (0, Qe.jsx)("path", {
              d: "M1.73475 9.24589L1.173 9.51987H1.173L1.73475 9.24589ZM2.1806 10.16L2.74235 9.88604H2.74235L2.1806 10.16ZM14.7594 4.02495L14.1976 4.29893L14.7594 4.02495ZM13.4178 1.27423L13.9795 1.00025L13.4178 1.27423ZM12.0137 0.941145L11.6348 0.44404V0.44404L12.0137 0.941145ZM11.6095 6.08026L11.8835 6.64201L11.6095 6.08026ZM14.5446 4.64874L14.2706 4.087L14.5446 4.64874ZM2.8044 10.3748L2.53042 9.81307H2.53042L2.8044 10.3748ZM5.32015 9.1478L5.59414 9.70955H5.59414L5.32015 9.1478ZM4.21584 6.88362L3.83701 6.38652L4.21584 6.88362ZM1.87128 8.67034L2.25011 9.16745L1.87128 8.67034ZM7.17917 15.25C7.17917 15.5952 7.45899 15.875 7.80417 15.875C8.14935 15.875 8.42917 15.5952 8.42917 15.25H7.17917ZM8.73718 10.1184L9.28587 9.81916C9.12473 9.52375 8.75864 9.40894 8.45767 9.55942L8.73718 10.1184ZM6.87116 11.0514L6.59165 10.4924C6.49437 10.5411 6.41146 10.6143 6.35113 10.7048L6.87116 11.0514ZM10.9875 15.5493C11.1528 15.8523 11.5325 15.964 11.8355 15.7987C12.1385 15.6334 12.2502 15.2537 12.0849 14.9507L10.9875 15.5493ZM3.55209 14.9033C3.36062 15.1905 3.43823 15.5786 3.72544 15.77C4.01264 15.9615 4.40069 15.8839 4.59216 15.5967L3.55209 14.9033ZM1.173 9.51987L1.61886 10.434L2.74235 9.88604L2.29649 8.97191L1.173 9.51987ZM15.3211 3.75097L13.9795 1.00025L12.856 1.54821L14.1976 4.29893L15.3211 3.75097ZM11.6348 0.44404L9.51289 2.0611L10.2705 3.05531L12.3925 1.43825L11.6348 0.44404ZM11.8835 6.64201L14.8186 5.21049L14.2706 4.087L11.3356 5.51852L11.8835 6.64201ZM9.32997 2.83219L11.0478 6.35424L12.1713 5.80628L10.4535 2.28422L9.32997 2.83219ZM3.07838 10.9366L5.59414 9.70955L5.04617 8.58606L2.53042 9.81307L3.07838 10.9366ZM5.59414 9.70955L11.8835 6.64201L11.3356 5.51852L5.04617 8.58606L5.59414 9.70955ZM9.51289 2.0611L3.83701 6.38652L4.59467 7.38073L10.2705 3.05531L9.51289 2.0611ZM3.83701 6.38652L1.49245 8.17324L2.25011 9.16745L4.59467 7.38073L3.83701 6.38652ZM5.8819 8.87382L4.77759 6.60964L3.65409 7.1576L4.75841 9.42178L5.8819 8.87382ZM13.9795 1.00025C13.5485 0.116571 12.4168 -0.15189 11.6348 0.44404L12.3925 1.43825C12.5471 1.32044 12.7708 1.37351 12.856 1.54821L13.9795 1.00025ZM14.1976 4.29893C14.1593 4.22026 14.1919 4.12537 14.2706 4.087L14.8186 5.21049C15.3604 4.94623 15.5854 4.29278 15.3211 3.75097L14.1976 4.29893ZM1.61886 10.434C1.88312 10.9758 2.53657 11.2008 3.07838 10.9366L2.53042 9.81307C2.60909 9.7747 2.70398 9.80737 2.74235 9.88604L1.61886 10.434ZM2.29649 8.97191C2.32961 9.03981 2.3102 9.12165 2.25011 9.16745L1.49245 8.17324C1.07862 8.4886 0.944918 9.05223 1.173 9.51987L2.29649 8.97191ZM8.08368 11.144L9.01669 10.6775L8.45767 9.55942L7.52466 10.0259L8.08368 11.144ZM7.15067 11.6105L8.08368 11.144L7.52466 10.0259L6.59165 10.4924L7.15067 11.6105ZM8.1885 10.4177L10.9875 15.5493L12.0849 14.9507L9.28587 9.81916L8.1885 10.4177ZM4.59216 15.5967L7.39119 11.3981L6.35113 10.7048L3.55209 14.9033L4.59216 15.5967ZM7.17917 10.5849V15.25H8.42917V10.5849H7.17917Z",
              fill: t,
            }),
          }),
        });
      },
      ft = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M4.5 14H2.5C2.22386 14 2 13.7761 2 13.5V1.63158V1.5C2 1.22386 2.22386 1 2.5 1V1C2.63261 1 13.5 1 13.5 1C13.5 1 13.5 1 13.5 1V1C13.7761 1 14 1.22386 14 1.5V1.63158V13.5C14 13.7761 13.7761 14 13.5 14H11.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "square",
              }),
              (0, Qe.jsx)("path", {
                d: "M5.5 15C5.22386 15 5 14.7761 5 14.5V5.5C5 5.22386 5.22386 5 5.5 5H10.5C10.7761 5 11 5.22386 11 5.5V14.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "square",
              }),
              (0, Qe.jsx)("rect", {
                x: "7",
                y: "7",
                width: "2",
                height: "1",
                fill: t,
              }),
            ],
          }),
        });
      },
      ht = function () {
        return (0, Qe.jsx)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "18",
          height: "18",
          viewBox: "0 0 18 18",
          children: (0, Qe.jsx)("path", {
            fill: "#e9ecec",
            d: "M17.95.756c-.032-.382-.337-.685-.72-.714-4.94-.391-8.5 2.007-10.699 5.026-1.241-.4-2.595-.249-3.718.415C1.608 6.199.653 7.268.074 8.544c-.143.305-.075.666.168.898.243.232.607.284.904.128 1.253-.662 2.663-.536 3.51.309l3.45 3.447.018.021c.847.846.978 2.254.31 3.504-.158.298-.108.663.125.907.232.243.595.31.9.167 1.277-.58 2.346-1.537 3.062-2.744.666-1.127.814-2.486.407-3.73.865-.614 1.653-1.33 2.348-2.132C17.33 6.93 18.229 4.047 17.95.756zM2.623 7.586c.833-.83 1.902-1.325 3.015-1.129-.3.529-.567 1.076-.8 1.637-.68-.363-1.445-.538-2.215-.508zm7.797 7.792c.031-.776-.147-1.546-.516-2.23.561-.243 1.109-.517 1.64-.822.217 1.133-.284 2.213-1.124 3.052zm-1.55-3.502L6.114 9.122c1.381-3.704 4.815-7.66 10.321-7.556.18 6.558-5.232 9.39-7.564 10.31zm5.059-7.796c.43.429.497 1.102.16 1.608-.337.506-.984.703-1.546.471-.562-.232-.881-.829-.763-1.425.118-.596.64-1.025 1.249-1.026.337 0 .66.134.9.372zM2.909 12.205c-.9.904-.935 2.698-.933 3.056 0 .432.35.782.783.782h.025c.403 0 2.133-.066 3.012-.945.412-.387.65-.925.659-1.49-.01-.545-.237-1.063-.63-1.44-.982-.99-2.201-.675-2.916.037zm1.785 1.774c-.196.196-.626.323-1.069.392.077-.446.21-.877.392-1.065.097-.12.238-.196.391-.213.13.01.249.072.33.172.092.09.145.21.152.337-.02.145-.089.278-.196.377z",
          }),
        });
      },
      mt = function () {
        return (0, Qe.jsx)("svg", {
          "aria-hidden": "true",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("g", {
            children: (0, Qe.jsx)("path", {
              d: "M10.2329 10.0247L10.4605 12.5284C10.4848 12.7953 10.3657 13.055 10.1477 13.2107L9.15242 13.9216C8.85227 14.136 8.44111 14.102 8.18029 13.8411L7.29841 12.9592M10.2329 10.0247L12.9007 7.35699M10.2329 10.0247L7.29841 12.9592M6.76486 6.55667L4.2612 6.32906C3.99433 6.3048 3.73463 6.42389 3.57888 6.64194L2.868 7.63717C2.6536 7.93732 2.68763 8.34847 2.94845 8.60929L3.83034 9.49118M6.76486 6.55667L3.83034 9.49118M6.76486 6.55667L9.4326 3.88892M3.83034 9.49118L7.29841 12.9592M9.4326 3.88892L12.9007 7.35699M9.4326 3.88892C10.6218 3.14019 11.945 2.62954 13.3289 2.38533L13.6143 2.33496C14.1102 2.24745 14.5421 2.67943 14.4546 3.17529L14.4043 3.46071C14.1601 4.84457 13.6494 6.16782 12.9007 7.35699M3.56357 11.3586L1.42937 13.4928M5.16421 12.9592L4.09711 14.0263",
              stroke: "white",
              strokeLinecap: "round",
            }),
          }),
        });
      },
      _t = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M14.4167 2H1.58333C1.26117 2 1 2.26117 1 2.58333V2.6V13.4V13.4167C1 13.7388 1.26117 14 1.58333 14H14.4167C14.7388 14 15 13.7388 15 13.4167V13.4V2.6V2.58333C15 2.26117 14.7388 2 14.4167 2Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M1 10.8353L4.66771 7.17373C4.72199 7.11871 4.78669 7.07501 4.85804 7.04519C4.92939 7.01536 5.00598 7 5.08333 7C5.16069 7 5.23727 7.01536 5.30863 7.04519C5.37998 7.07501 5.44468 7.11871 5.49896 7.17373L8.75104 10.4204C8.80532 10.4754 8.87002 10.5191 8.94137 10.5489C9.01273 10.5787 9.08931 10.5941 9.16667 10.5941C9.24402 10.5941 9.32061 10.5787 9.39196 10.5489C9.46331 10.5191 9.52801 10.4754 9.58229 10.4204L11.0844 8.9208C11.1387 8.86577 11.2034 8.82208 11.2747 8.79225C11.3461 8.76242 11.4226 8.74706 11.5 8.74706C11.5774 8.74706 11.6539 8.76242 11.7253 8.79225C11.7966 8.82208 11.8613 8.86577 11.9156 8.9208L15 12",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7Z",
                fill: t,
              }),
            ],
          }),
        });
      },
      gt = ["color"];
    var vt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#fff" : n;
        return (
          (function (e, n) {
            if (null == e) return {};
            var t,
              r,
              o = (function (e, n) {
                if (null == e) return {};
                var t,
                  r,
                  o = {},
                  i = Object.keys(e);
                for (r = 0; r < i.length; r++)
                  (t = i[r]), n.indexOf(t) >= 0 || (o[t] = e[t]);
                return o;
              })(e, n);
            if (Object.getOwnPropertySymbols) {
              var i = Object.getOwnPropertySymbols(e);
              for (r = 0; r < i.length; r++)
                (t = i[r]),
                  n.indexOf(t) >= 0 ||
                    (Object.prototype.propertyIsEnumerable.call(e, t) &&
                      (o[t] = e[t]));
            }
          })(e, gt),
          (0, Qe.jsx)("svg", {
            role: "img",
            "aria-hidden": !0,
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, Qe.jsxs)("g", {
              id: "Sliders",
              children: [
                (0, Qe.jsx)("path", {
                  d: "M8 6.75V13.5",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M8 2.5V4.25",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M8 6.75C8.69036 6.75 9.25 6.19036 9.25 5.5C9.25 4.80964 8.69036 4.25 8 4.25C7.30964 4.25 6.75 4.80964 6.75 5.5C6.75 6.19036 7.30964 6.75 8 6.75Z",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M12.5 11.75V13.5",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M12.5 2.5V9.25",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M12.5 11.75C13.1904 11.75 13.75 11.1904 13.75 10.5C13.75 9.80964 13.1904 9.25 12.5 9.25C11.8096 9.25 11.25 9.80964 11.25 10.5C11.25 11.1904 11.8096 11.75 12.5 11.75Z",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M3.5 9.75V13.5",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M3.5 2.5V7.25",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M3.5 9.75C4.19036 9.75 4.75 9.19036 4.75 8.5C4.75 7.80964 4.19036 7.25 3.5 7.25C2.80964 7.25 2.25 7.80964 2.25 8.5C2.25 9.19036 2.80964 9.75 3.5 9.75Z",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
              ],
            }),
          })
        );
      },
      Ct = function () {
        return (0, Qe.jsx)("svg", {
          "aria-hidden": "true",
          width: "16",
          height: "16",
          role: "img",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            id: "Logout",
            children: [
              (0, Qe.jsxs)("g", {
                children: [
                  (0, Qe.jsx)("path", {
                    d: "M13 8L8 8L13 8Z",
                    fill: "#666666",
                  }),
                  (0, Qe.jsx)("path", {
                    d: "M13 8L8 8",
                    stroke: "#666666",
                    strokeWidth: "1.25",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                  }),
                ],
              }),
              (0, Qe.jsx)("path", {
                d: "M12 10L13.9756 8.058C14.0081 8.026 14.0081 7.974 13.9756 7.942L12 6",
                stroke: "#666666",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M10 4.11111V3.83333C10 3.37309 9.63837 3 9.19231 3H4.07692C3.48215 3 3 3.49746 3 4.11111V11.8889C3 12.5026 3.48215 13 4.07692 13H9.19231C9.63837 13 10 12.6269 10 12.1667V11.8889",
                stroke: "#666666",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      },
      bt = function () {
        return (0, Qe.jsxs)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("path", {
              d: "M2.5 2.4V13.6C2.5 13.9713 2.6475 14.3274 2.91005 14.5899C3.1726 14.8525 3.5287 15 3.9 15H12.3C12.6713 15 13.0274 14.8525 13.2899 14.5899C13.5525 14.3274 13.7 13.9713 13.7 13.6V5.4394C13.7 5.25289 13.6627 5.06827 13.5903 4.89637C13.518 4.72447 13.412 4.56877 13.2786 4.4384L10.1706 1.399C9.90905 1.14326 9.5578 1.00005 9.192 1H3.9C3.5287 1 3.1726 1.1475 2.91005 1.41005C2.6475 1.6726 2.5 2.0287 2.5 2.4Z",
              stroke: "#fff",
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M9.5 1V3.8C9.5 4.1713 9.6475 4.5274 9.91005 4.78995C10.1726 5.0525 10.5287 5.2 10.9 5.2H13.7",
              stroke: "#fff",
              strokeWidth: "1.25",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M8.75 11.5V11C8.75 10.7348 8.64464 10.4804 8.45711 10.2929C8.26957 10.1054 8.01522 10 7.75 10H6.25C5.98478 10 5.73043 10.1054 5.54289 10.2929C5.35536 10.4804 5.25 10.7348 5.25 11V11.5",
              stroke: "#fff",
              strokeWidth: "0.75",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M7 9C7.55228 9 8 8.55228 8 8C8 7.44772 7.55228 7 7 7C6.44772 7 6 7.44772 6 8C6 8.55228 6.44772 9 7 9Z",
              stroke: "#fff",
              strokeWidth: "0.75",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M10.75 11.4997V10.9997C10.7498 10.7782 10.6638 10.5629 10.5054 10.3878C10.347 10.2127 10.1253 10.0876 9.875 10.0322",
              stroke: "#fff",
              strokeWidth: "0.75",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M9 7.03223C9.25095 7.0873 9.47339 7.2124 9.63223 7.3878C9.79107 7.56321 9.87729 7.77893 9.87729 8.00098C9.87729 8.22302 9.79107 8.43875 9.63223 8.61415C9.47339 8.78955 9.25095 8.91465 9 8.96973",
              stroke: "#fff",
              strokeWidth: "0.75",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      xt = function () {
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("g", {
            children: (0, Qe.jsxs)("g", {
              children: [
                (0, Qe.jsx)("path", {
                  d: "M6 11.5H8.1M2.5 2.4V13.6C2.5 13.9713 2.6475 14.3274 2.91005 14.5899C3.1726 14.8525 3.5287 15 3.9 15H12.3C12.6713 15 13.0274 14.8525 13.2899 14.5899C13.5525 14.3274 13.7 13.9713 13.7 13.6V5.4394C13.7 5.25289 13.6627 5.06827 13.5903 4.89637C13.518 4.72447 13.412 4.56877 13.2786 4.4384L10.1706 1.399C9.90905 1.14326 9.5578 1.00005 9.192 1H3.9C3.5287 1 3.1726 1.1475 2.91005 1.41005C2.6475 1.6726 2.5 2.0287 2.5 2.4V2.4ZM6 8.7H10.2H6Z",
                  stroke: "#fff",
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M9.5 1V3.8C9.5 4.1713 9.6475 4.5274 9.91005 4.78995C10.1726 5.0525 10.5287 5.2 10.9 5.2H13.7",
                  stroke: "#fff",
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
              ],
            }),
          }),
        });
      },
      yt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          role: "img",
          "aria-hidden": !0,
          width: "16",
          height: "20",
          viewBox: "0 0 16 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsxs)("g", {
              children: [
                (0, Qe.jsx)("path", {
                  d: "M7.99979 12.4878C10.722 12.4878 13.0813 9.9989 13.8072 9.9989C13.0813 9.9989 10.722 7.51001 7.99979 7.51001M7.99979 12.4878C5.27757 12.4878 2.91831 9.9989 2.19238 9.9989C2.91831 9.9989 5.27757 7.51001 7.99979 7.51001M7.99979 12.4878C9.37437 12.4878 10.4887 11.3734 10.4887 9.99885C10.4887 8.62427 9.37437 7.51001 7.99979 7.51001M7.99979 12.4878C6.62521 12.4878 5.51093 11.3734 5.51093 9.99885C5.51093 8.62427 6.62521 7.51001 7.99979 7.51001M7.17019 9.99885C7.17019 10.457 7.54163 10.8285 7.99982 10.8285C8.45801 10.8285 8.82945 10.457 8.82945 9.99885C8.82945 9.54065 8.45801 9.16922 7.99982 9.16922C7.54163 9.16922 7.17019 9.54065 7.17019 9.99885Z",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinejoin: "round",
                }),
                (0, Qe.jsx)("path", {
                  d: "M12.1889 17.25H14.7322C15.0182 17.25 15.25 17.0181 15.25 16.7321L15.25 14.1889M3.81114 2.75H1.26789C0.981881 2.75 0.750029 2.98185 0.750029 3.26786V5.81111M0.75 14.1889V16.7321C0.75 17.0181 0.981853 17.25 1.26786 17.25H3.81111M15.25 5.81111V3.26786C15.25 2.98185 15.0181 2.75 14.7321 2.75H12.1889",
                  stroke: t,
                  strokeWidth: "1.25",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
              ],
            }),
            (0, Qe.jsx)("defs", {
              children: (0, Qe.jsx)("clipPath", {
                children: (0, Qe.jsx)("rect", {
                  width: "16",
                  height: "16",
                  fill: "white",
                  transform: "translate(0 2)",
                }),
              }),
            }),
          ],
        });
      },
      wt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          role: "img",
          "aria-hidden": !0,
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("path", {
              d: "M11.9633 5.28039V2.00391C11.9633 1.45162 11.5156 1.00391 10.9633 1.00391H8.29734H3.41031H1.9668C1.41451 1.00391 0.966797 1.45162 0.966797 2.00391V13.4439C0.966797 13.9962 1.41451 14.4439 1.9668 14.4439H5.69922",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M3.19922 4.05859H3.69922",
              stroke: t,
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M3.19922 6.50195H3.69922",
              stroke: t,
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M3.19922 8.94531H3.69922",
              stroke: t,
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M5.24219 4.05859H9.74219",
              stroke: t,
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M5.24219 6.50195L7.99219 6.5004",
              stroke: t,
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M5.21094 8.9502H7.71094",
              stroke: t,
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M3.19922 11.3887H3.69922",
              stroke: t,
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M5.20898 11.3887H6.45898",
              stroke: t,
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M10.8966 7.90714V9.85714C10.8966 9.9481 10.8713 10.0375 10.8221 10.1143C10.8221 10.1143 10.8221 10.1143 10.8221 10.1144L9.92921 11.5214H13.4731L12.5802 10.1143L12.5802 10.1142L12.6224 10.0874C12.5786 10.0186 12.5555 9.93872 12.5557 9.85714L10.8966 7.90714ZM10.8966 7.90714H12.5057H10.8966ZM15.541 12.9972L15.541 12.9972L13.4603 9.71805V7.90714H13.5527C13.6793 7.90714 13.8007 7.85669 13.8902 7.76692C13.9797 7.67716 14.03 7.55545 14.03 7.42857C14.03 7.3017 13.9797 7.17999 13.8902 7.09022C13.8007 7.00046 13.6793 6.95 13.5527 6.95H9.84966C9.72303 6.95 9.60162 7.00046 9.51212 7.09022C9.42263 7.17999 9.37239 7.3017 9.37239 7.42857C9.37239 7.55545 9.42263 7.67716 9.51212 7.76692C9.60162 7.85669 9.72303 7.90714 9.84966 7.90714H9.94208V9.71805L7.86136 12.9972L7.86135 12.9972C7.29746 13.8863 7.93396 15.05 8.98543 15.05H14.4169C15.4684 15.05 16.1049 13.8863 15.541 12.9972ZM8.66702 13.5108L8.66704 13.5108L9.3217 12.4786H14.0806L14.7353 13.5108L14.7353 13.5108C14.7717 13.5681 14.792 13.6341 14.7943 13.7019C14.7965 13.7698 14.7804 13.837 14.7479 13.8965C14.7153 13.956 14.6674 14.0056 14.6092 14.0402C14.5509 14.0747 14.4846 14.0929 14.4169 14.0929H14.4169H8.98543H8.9854C8.91779 14.0929 8.8514 14.0747 8.79318 14.0402C8.73496 14.0056 8.68705 13.956 8.65448 13.8965C8.62191 13.837 8.60588 13.7698 8.60809 13.7019C8.61029 13.6341 8.63065 13.5681 8.66702 13.5108ZM8.98543 14.1429H14.4169C14.4935 14.1429 14.5687 14.1223 14.6347 14.0832C14.7006 14.0441 14.7549 13.9879 14.7917 13.9205C14.8286 13.8532 14.8467 13.7771 14.8442 13.7003C14.8417 13.6235 14.8187 13.5488 14.7775 13.484L8.98543 14.1429Z",
              fill: t,
              stroke: t,
              strokeWidth: "0.1",
            }),
          ],
        });
      },
      kt = function () {
        return (0, Qe.jsx)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          children: (0, Qe.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0C3.58 0 0 3.58 0 8ZM11.29 5.29C11.47 5.11 11.72 5 12 5C12.55 5 13 5.45 13 6C13 6.28 12.89 6.53 12.71 6.71L7.71 11.71C7.53 11.89 7.28 12 7 12C6.72 12 6.47 11.89 6.29 11.71L3.29 8.71C3.11 8.53 3 8.28 3 8C3 7.45 3.45 7 4 7C4.28 7 4.53 7.11 4.71 7.29L7 9.59L11.29 5.29Z",
            fill: "#5FC8AF",
          }),
        });
      },
      Lt = function () {
        return (0, Qe.jsxs)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("path", {
              d: "M1.33398 4H4.00065",
              stroke: "#666666",
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M1.33398 6.66699H4.00065",
              stroke: "#666666",
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M1.33398 9.33301H4.00065",
              stroke: "#666666",
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M1.33398 12H4.00065",
              stroke: "#666666",
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M11.9993 1.33301H3.99935C3.26297 1.33301 2.66602 1.92996 2.66602 2.66634V13.333C2.66602 14.0694 3.26297 14.6663 3.99935 14.6663H11.9993C12.7357 14.6663 13.3327 14.0694 13.3327 13.333V2.66634C13.3327 1.92996 12.7357 1.33301 11.9993 1.33301Z",
              stroke: "#666666",
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M10.666 1.33301V14.6663",
              stroke: "#666666",
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      jt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#666" : n;
        return (0, Qe.jsx)("svg", {
          width: "16",
          height: "12",
          viewBox: "0 0 16 12",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-hidden": !0,
          role: "img",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M4.56294 2.39991C3.65953 3.29991 3.3584 4.70283 3.3584 6.29991V9.46338",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M1.25 5.39996V8.32568",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M5.46582 10.5V6C5.46582 3.51472 7.48817 1.5 9.98287 1.5C12.4776 1.5 14.4999 3.51472 14.4999 6V10.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M5.46582 9.29995V5.99995C5.46582 4.17741 6.94888 2.69995 8.77832 2.69995C10.6078 2.69995 12.0908 4.17741 12.0908 5.99995V9.29995",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M5.46582 8.0999V5.9999C5.46582 4.8401 6.40958 3.8999 7.57377 3.8999C8.73797 3.8999 9.68173 4.8401 9.68173 5.9999V8.0999",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      };
    function Et() {
      return (
        (Et = Object.assign
          ? Object.assign.bind()
          : function (e) {
              for (var n = 1; n < arguments.length; n++) {
                var t = arguments[n];
                for (var r in t)
                  Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
              }
              return e;
            }),
        Et.apply(this, arguments)
      );
    }
    var St = function (e) {
        var n = Et(
            {},
            ((function (e) {
              if (null == e) throw new TypeError("Cannot destructure " + e);
            })(e),
            e)
          ),
          t = n.color,
          r = void 0 === t ? "#fff" : t;
        return (
          n.strokeWidth,
          (0, Qe.jsx)("svg", {
            width: "17",
            height: "16",
            viewBox: "0 0 17 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: "presentation",
            children: (0, Qe.jsxs)("g", {
              children: [
                (0, Qe.jsx)("circle", {
                  cx: "8.5",
                  cy: "8",
                  r: "7",
                  stroke: r,
                  strokeWidth: "1.25",
                  strokeMiterlimit: "10",
                  strokeLinecap: "round",
                }),
                (0, Qe.jsxs)("g", {
                  children: [
                    (0, Qe.jsx)("path", {
                      d: "M6.25 7.25L8.5 5L10.75 7.25",
                      stroke: r,
                      strokeWidth: "1.25",
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                    }),
                    (0, Qe.jsx)("path", {
                      d: "M8.5 10.4805V5.48047",
                      stroke: r,
                      strokeWidth: "1.25",
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                    }),
                  ],
                }),
              ],
            }),
          })
        );
      },
      Mt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M1.73592 9.8804C2.31926 13.4225 5.66363 15.8211 9.20576 15.2378C12.7479 14.6544 15.1465 11.3101 14.5631 7.76794C13.9798 4.2258 10.6354 1.82722 7.0933 2.41056",
                stroke: t,
                strokeWidth: "1.25",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M7.75192 9.50021L7.74826 6.00004",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M7.73047 9.69141L10.1779 9.75497",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M0.769531 3.28809L3.01953 1.03809L5.26953 3.28809",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M3.01172 6.51855V1.51855",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      },
      Tt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "14",
          height: "12",
          viewBox: "0 0 14 12",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("g", {
            children: (0, Qe.jsx)("path", {
              d: "M10.8665 0.666992C11.5999 0.666992 12.0003 0.666973 12.2669 0.813639C12.5336 0.940306 12.7332 1.14705 12.8665 1.39372C12.9999 1.68038 13 2.05363 13 2.80029V11.3337L10.8001 10.2271C10.6001 10.1404 10.5335 10.1004 10.4668 10.0671C10.3335 10.0471 10.2665 10.027 10.1999 10.0137C10.1332 10.0003 10.0001 10.0003 9.80013 10.0003H3.13346C2.40013 10.0003 1.99974 10.0003 1.73307 9.85368C1.46641 9.72701 1.2668 9.52027 1.13346 9.2736C1.00013 8.98693 1 8.61369 1 7.86702V2.80029C1 2.05363 1.00013 1.68038 1.13346 1.39372C1.2668 1.14705 1.46641 0.940306 1.73307 0.813639C1.99974 0.666973 2.40013 0.666992 3.13346 0.666992H10.8665ZM7.66667 3.13363C8.06667 2.76696 8.6 2.76696 9 3.13363C9.4 3.50029 9.4 4.10029 9 4.46696L6.19987 7.2404C6.1332 7.3204 6.13307 7.36706 6.06641 7.40039C5.99974 7.42706 5.93359 7.45363 5.93359 7.47363C5.86693 7.49363 5.8 7.50702 5.66667 7.52702L4.33333 7.80029L4.60026 6.44694C4.60026 6.33361 4.66667 6.27371 4.66667 6.22038C4.66667 6.16704 4.73307 6.12707 4.73307 6.0804C4.79974 6.03374 4.79987 5.98706 4.86654 5.90706L7.66667 3.13363Z",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinejoin: "round",
            }),
          }),
        });
      },
      Nt = function () {
        return (0, Qe.jsxs)("svg", {
          width: "16",
          height: "17",
          viewBox: "0 0 16 17",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("path", {
              d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
              stroke: "#333333",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M8 10C9.65685 10 11 8.65685 11 7C11 5.34315 9.65685 4 8 4C6.34315 4 5 5.34315 5 7C5 8.65685 6.34315 10 8 10Z",
              stroke: "#333333",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M3 13C3.46878 12.0974 4.18408 11.3393 5.06662 10.8098C5.94916 10.2803 6.96447 10 8 10C9.03553 10 10.0508 10.2803 10.9334 10.8098C11.8159 11.3393 12.5312 12.0974 13 13",
              stroke: "#333333",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      Ot = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "17",
          viewBox: "0 0 16 17",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            id: "UserCircle",
            children: [
              (0, Qe.jsx)("path", {
                d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M8 10C9.65685 10 11 8.65685 11 7C11 5.34315 9.65685 4 8 4C6.34315 4 5 5.34315 5 7C5 8.65685 6.34315 10 8 10Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M3 13C3.46878 12.0974 4.18408 11.3393 5.06662 10.8098C5.94916 10.2803 6.96447 10 8 10C9.03553 10 10.0508 10.2803 10.9334 10.8098C11.8159 11.3393 12.5312 12.0974 13 13",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      },
      At = function () {
        return (0, Qe.jsxs)("svg", {
          width: "30",
          height: "30",
          viewBox: "0 0 30 30",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("circle", {
              cx: "15",
              cy: "15",
              r: "15",
              fill: "#F0F0F0",
            }),
            (0, Qe.jsx)("path", {
              d: "M14.04 16H9.56C8.14615 16 7 17.1939 7 18.6667V20",
              stroke: "black",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M11.8 13.3333C13.2138 13.3333 14.36 12.1394 14.36 10.6667C14.36 9.19391 13.2138 8 11.8 8C10.3861 8 9.23999 9.19391 9.23999 10.6667C9.23999 12.1394 10.3861 13.3333 11.8 13.3333Z",
              stroke: "black",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M16.4401 15.8333H21.8801C22.2225 15.8333 22.5001 16.1109 22.5001 16.4533V20.88C22.5001 21.2224 22.2225 21.5 21.8801 21.5H16.4401C16.0977 21.5 15.8201 21.2224 15.8201 20.88V16.4533C15.8201 16.1109 16.0977 15.8333 16.4401 15.8333Z",
              stroke: "black",
            }),
            (0, Qe.jsx)("path", {
              d: "M21.08 14V13.92C21.08 12.8596 20.2204 12 19.16 12V12C18.0996 12 17.24 12.8596 17.24 13.92V15.3333",
              stroke: "black",
            }),
            (0, Qe.jsx)("line", {
              x1: "19.02",
              y1: "18",
              x2: "19.02",
              y2: "19.3333",
              stroke: "black",
            }),
          ],
        });
      },
      It = function () {
        return (0, Qe.jsxs)("svg", {
          width: "16",
          height: "17",
          viewBox: "0 0 16 17",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("path", {
              d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
              stroke: "#333333",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M8 10C9.65685 10 11 8.65685 11 7C11 5.34315 9.65685 4 8 4C6.34315 4 5 5.34315 5 7C5 8.65685 6.34315 10 8 10Z",
              stroke: "#333333",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M3 13C3.46878 12.0974 4.18408 11.3393 5.06662 10.8098C5.94916 10.2803 6.96447 10 8 10C9.03553 10 10.0508 10.2803 10.9334 10.8098C11.8159 11.3393 12.5312 12.0974 13 13",
              stroke: "#333333",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      Pt = function () {
        return (0, Qe.jsxs)("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 400 400",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M192.24 23.3258C191.69 23.5108 190.541 23.6798 189.686 23.7018C188.832 23.7238 187.392 23.9358 186.486 24.1738C185.581 24.4108 184.12 24.7838 183.24 25.0018C173.166 27.5028 164.872 31.6678 156.04 38.6598C151.61 42.1668 143.25 51.6568 141.373 55.3088C141.08 55.8768 140.74 56.4318 140.615 56.5418C140.242 56.8728 136.739 64.1808 135.822 66.5418C128.734 84.7928 129.472 104.035 137.957 122.235L138.84 124.128L163.44 124.089C176.97 124.067 187.704 123.963 187.292 123.857C186.137 123.56 182.57 121.388 181.295 120.205C174.205 113.626 180.17 103.611 187.758 109.354C188.912 110.227 189.999 110.942 190.173 110.942C190.347 110.942 190.838 111.262 191.265 111.654C192.186 112.5 196.033 114.142 197.093 114.142C197.8 114.142 197.84 113.659 197.84 105.04V95.9368L196.74 95.4558C196.135 95.1908 194.92 94.6798 194.04 94.3198C190.882 93.0288 189.606 92.3698 187.384 90.8818C183.844 88.5128 182.268 86.4528 180.297 81.6228C178.865 78.1158 180.127 70.0258 182.691 66.2778C184.688 63.3588 190.468 59.3418 192.673 59.3418C193.069 59.3418 193.504 59.1618 193.64 58.9418C193.776 58.7218 194.428 58.5418 195.09 58.5418C196.984 58.5418 197.838 57.8878 197.853 56.4278C197.867 54.9668 198.417 54.0978 199.789 53.3668C201.897 52.2438 205.04 54.0278 205.04 56.3468V57.6128L208.54 58.1118C218.26 59.4968 222.047 62.5158 220.637 67.7538C219.573 71.7048 216.32 73.1298 212.578 71.2848C209.733 69.8828 207.001 68.9418 205.772 68.9418C205.062 68.9418 205.029 69.3548 205.132 77.0128L205.24 85.0828L208.84 86.6648C221.769 92.3468 226.234 103.328 220.499 115.341C219.671 117.074 215.205 122.142 214.505 122.142C214.317 122.142 213.686 122.481 213.102 122.895C212.518 123.31 211.68 123.739 211.24 123.849C210.8 123.959 221.78 124.067 235.64 124.089L260.84 124.128L261.779 122.035C262.296 120.884 262.881 119.537 263.079 119.042C263.278 118.547 263.602 117.737 263.8 117.242C263.997 116.747 264.376 115.712 264.64 114.942C264.904 114.172 265.262 113.182 265.435 112.742C266.068 111.129 267.085 106.857 267.91 102.342C268.6 98.5668 268.597 84.7528 267.906 81.3418C267.617 79.9118 267.2 77.8418 266.98 76.7418C266.76 75.6418 266.434 74.2918 266.256 73.7418C266.078 73.1918 265.701 71.9318 265.417 70.9418C265.133 69.9518 264.752 68.9708 264.57 68.7618C264.389 68.5528 264.24 68.1458 264.24 67.8578C264.24 66.9298 260.759 59.4868 258.948 56.5418C252.751 46.4648 244.847 38.5488 235.076 32.6328C232.651 31.1648 225.61 27.7418 225.015 27.7418C224.803 27.7418 224.317 27.5678 223.935 27.3548C223.055 26.8638 219.699 25.7458 217.74 25.2908C216.915 25.0988 215.475 24.7558 214.54 24.5278C209.593 23.3238 194.646 22.5178 192.24 23.3258ZM197.04 69.6088C189.813 72.0698 190.248 79.9688 197.74 82.3138L198.64 82.5958V75.9688C198.64 69.1358 198.624 69.0698 197.04 69.6088ZM204.24 106.542C204.24 110.722 204.332 114.142 204.445 114.142C204.558 114.142 204.963 113.983 205.345 113.789C205.727 113.594 206.559 113.191 207.193 112.893C211.828 110.711 211.633 103.062 206.863 99.9688C204.183 98.2308 204.24 98.0868 204.24 106.542ZM281.44 229.113C273.335 230.611 263.534 237.01 260.565 242.742C256.28 251.014 255.775 252.808 255.775 259.771C255.775 264.872 256.084 267.047 257.089 269.037C257.282 269.419 257.44 269.979 257.44 270.281C257.44 275.763 269.121 287.111 277.04 289.323C278.03 289.599 279.29 290.032 279.84 290.284C280.566 290.616 292.326 290.775 322.74 290.861L364.64 290.98V259.761V228.542L324.34 228.587C294.837 228.62 283.343 228.761 281.44 229.113Z",
              fill: "#42939C",
            }),
            (0, Qe.jsx)("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M185.316 0.156961C183.721 0.246961 182.416 0.492961 182.416 0.703961C182.416 0.913961 181.617 1.08596 180.64 1.08596C179.663 1.08596 178.752 1.26596 178.616 1.48596C178.48 1.70596 177.749 1.88596 176.992 1.88596C176.235 1.88596 175.616 2.06596 175.616 2.28596C175.616 2.50596 174.896 2.68596 174.016 2.68596C173.136 2.68596 172.416 2.86596 172.416 3.08596C172.416 3.30596 171.876 3.48596 171.216 3.48596C170.556 3.48596 170.016 3.66596 170.016 3.88596C170.016 4.10596 169.577 4.28596 169.04 4.28596C168.503 4.28596 167.952 4.46596 167.816 4.68596C167.68 4.90596 167.219 5.08596 166.792 5.08596C166.365 5.08596 166.016 5.26596 166.016 5.48596C166.016 5.70596 165.476 5.88596 164.816 5.88596C164.156 5.88596 163.616 6.06596 163.616 6.28596C163.616 6.50596 163.256 6.68596 162.816 6.68596C162.376 6.68596 162.016 6.86596 162.016 7.08596C162.016 7.30596 161.656 7.48596 161.216 7.48596C160.776 7.48596 160.416 7.66596 160.416 7.88596C160.416 8.10596 160.045 8.28596 159.592 8.28596C159.072 8.28596 158.874 8.45596 159.054 8.74796C159.239 9.04696 159.163 9.09996 158.837 8.89896C158.296 8.56496 154.416 10.194 154.416 10.754C154.416 10.937 154.056 11.086 153.616 11.086C153.176 11.086 152.816 11.244 152.816 11.437C152.816 11.631 152.276 12.013 151.616 12.286C150.956 12.559 150.416 12.941 150.416 13.135C150.416 13.328 150.096 13.486 149.704 13.486C149.313 13.486 148.733 13.846 148.416 14.286C148.099 14.726 147.591 15.086 147.288 15.086C146.985 15.086 146.233 15.626 145.616 16.286C144.999 16.946 144.342 17.486 144.156 17.486C143.177 17.488 127.616 32.235 127.616 33.161C127.616 33.398 127.288 33.883 126.888 34.239C126.487 34.595 125.812 35.516 125.388 36.286C124.963 37.056 124.301 37.977 123.916 38.333C123.531 38.689 123.216 39.208 123.216 39.486C123.216 39.764 122.9 40.283 122.513 40.639C122.127 40.995 121.543 41.826 121.216 42.486C120.889 43.146 120.305 43.977 119.919 44.333C119.532 44.689 119.216 45.274 119.216 45.633C119.216 45.992 119.036 46.286 118.816 46.286C118.596 46.286 118.416 46.646 118.416 47.086C118.416 47.526 118.236 47.886 118.016 47.886C117.796 47.886 117.616 48.246 117.616 48.686C117.616 49.126 117.436 49.486 117.216 49.486C116.996 49.486 116.816 49.846 116.816 50.286C116.816 50.726 116.636 51.086 116.416 51.086C116.196 51.086 116.016 51.446 116.016 51.886C116.016 52.326 115.836 52.686 115.616 52.686C115.396 52.686 115.216 53.046 115.216 53.486C115.216 53.926 115.036 54.286 114.816 54.286C114.596 54.286 114.416 54.826 114.416 55.486C114.416 56.146 114.236 56.686 114.016 56.686C113.796 56.686 113.616 57.046 113.616 57.486C113.616 57.926 113.436 58.286 113.216 58.286C112.996 58.286 112.816 58.725 112.816 59.262C112.816 59.799 112.636 60.35 112.416 60.486C112.196 60.622 112.016 61.162 112.016 61.686C112.016 62.21 111.836 62.75 111.616 62.886C111.396 63.022 111.216 63.562 111.216 64.086C111.216 64.61 111.036 65.15 110.816 65.286C110.596 65.422 110.416 66.142 110.416 66.886C110.416 67.63 110.264 68.333 110.077 68.448C109.891 68.563 109.723 69.193 109.705 69.847C109.686 70.501 109.468 71.414 109.221 71.877C108.974 72.339 108.802 73.025 108.84 73.402C108.877 73.778 108.887 74.297 108.862 74.555C108.828 74.899 105.071 75.078 94.7162 75.229C86.9612 75.343 79.3563 75.632 77.8163 75.872C76.2763 76.112 74.2062 76.411 73.2162 76.536C72.2262 76.661 71.2452 76.926 71.0362 77.125C70.8272 77.323 70.0733 77.486 69.3603 77.486C68.6473 77.486 67.9523 77.666 67.8163 77.886C67.6803 78.106 67.0503 78.286 66.4163 78.286C65.7823 78.286 65.1523 78.466 65.0163 78.686C64.8803 78.906 64.3293 79.086 63.7923 79.086C63.2553 79.086 62.8162 79.266 62.8162 79.486C62.8162 79.706 62.3773 79.886 61.8403 79.886C61.3033 79.886 60.7522 80.066 60.6162 80.286C60.4802 80.506 59.9293 80.686 59.3923 80.686C58.8553 80.686 58.4163 80.866 58.4163 81.086C58.4163 81.306 58.0562 81.486 57.6162 81.486C57.1762 81.486 56.8162 81.666 56.8162 81.886C56.8162 82.106 56.4563 82.286 56.0163 82.286C55.5763 82.286 55.2163 82.466 55.2163 82.686C55.2163 82.906 54.8563 83.086 54.4163 83.086C53.9763 83.086 53.6162 83.266 53.6162 83.486C53.6162 83.706 53.2562 83.886 52.8162 83.886C52.3762 83.886 52.0163 84.066 52.0163 84.286C52.0163 84.506 51.6563 84.686 51.2163 84.686C50.7763 84.686 50.4163 84.866 50.4163 85.086C50.4163 85.306 50.1803 85.486 49.8913 85.486C49.6033 85.486 48.9803 85.846 48.5083 86.286C48.0363 86.726 47.3722 87.086 47.0332 87.086C46.6942 87.086 46.4163 87.236 46.4163 87.418C46.4163 87.601 45.9212 88.006 45.3162 88.318C44.7112 88.631 43.8433 89.246 43.3883 89.686C42.9333 90.126 42.0583 90.846 41.4443 91.286C40.8303 91.726 40.1222 92.269 39.8722 92.492C39.6212 92.715 38.6073 93.525 37.6183 94.292C35.2713 96.112 32.0603 99.324 30.8273 101.086C30.2883 101.856 29.3453 102.963 28.7313 103.546C28.1183 104.13 27.6163 104.862 27.6163 105.174C27.6163 105.486 27.2113 106.122 26.7163 106.586C25.5523 107.679 25.1473 108.224 24.4163 109.686C24.0863 110.346 23.5013 111.235 23.1163 111.661C22.7313 112.088 22.4163 112.673 22.4163 112.961C22.4163 113.25 22.2363 113.486 22.0163 113.486C21.7963 113.486 21.6163 113.846 21.6163 114.286C21.6163 114.726 21.4363 115.086 21.2163 115.086C20.9963 115.086 20.8162 115.446 20.8162 115.886C20.8162 116.326 20.6363 116.686 20.4163 116.686C20.1963 116.686 20.0163 117.046 20.0163 117.486C20.0163 117.926 19.8363 118.286 19.6163 118.286C19.3963 118.286 19.2163 118.646 19.2163 119.086C19.2163 119.526 19.0362 119.886 18.8162 119.886C18.5962 119.886 18.4163 120.246 18.4163 120.686C18.4163 121.126 18.2363 121.486 18.0163 121.486C17.7963 121.486 17.6163 122.026 17.6163 122.686C17.6163 123.346 17.4363 123.886 17.2163 123.886C16.9963 123.886 16.8162 124.158 16.8162 124.491C16.8162 124.824 16.6082 125.499 16.3542 125.991C15.3312 127.97 15.2163 128.322 15.2163 129.481C15.2163 130.144 15.0363 130.686 14.8163 130.686C14.5963 130.686 14.4162 131.406 14.4162 132.286C14.4162 133.166 14.2363 133.886 14.0163 133.886C13.7963 133.886 13.6163 134.786 13.6163 135.886C13.6163 136.986 13.4363 137.886 13.2163 137.886C12.9943 137.886 12.8163 138.945 12.8163 140.262C12.8163 141.569 12.6362 142.75 12.4162 142.886C11.8612 143.229 11.8612 333.086 12.4162 333.086C12.6422 333.086 12.8163 334.219 12.8163 335.686C12.8163 337.153 12.9903 338.286 13.2163 338.286C13.4363 338.286 13.6163 339.186 13.6163 340.286C13.6163 341.386 13.7963 342.286 14.0163 342.286C14.2363 342.286 14.4162 342.905 14.4162 343.662C14.4162 344.419 14.5963 345.15 14.8163 345.286C15.0363 345.422 15.2163 346.063 15.2163 346.71C15.2163 347.357 15.3963 347.886 15.6163 347.886C15.8363 347.886 16.0163 348.426 16.0163 349.086C16.0163 349.746 16.1963 350.286 16.4163 350.286C16.6363 350.286 16.8162 350.725 16.8162 351.262C16.8162 351.799 16.9963 352.35 17.2163 352.486C17.4363 352.622 17.6163 353.083 17.6163 353.51C17.6163 353.937 17.7963 354.286 18.0163 354.286C18.2363 354.286 18.4163 354.635 18.4163 355.062C18.4163 355.489 18.5962 355.95 18.8162 356.086C19.0362 356.222 19.2163 356.683 19.2163 357.11C19.2163 357.537 19.3963 357.886 19.6163 357.886C19.8363 357.886 20.0163 358.246 20.0163 358.686C20.0163 359.126 20.1963 359.486 20.4163 359.486C20.6363 359.486 20.8162 359.764 20.8162 360.103C20.8162 360.442 21.1763 361.106 21.6163 361.578C22.0563 362.05 22.4163 362.673 22.4163 362.961C22.4163 363.25 22.5962 363.486 22.8162 363.486C23.0362 363.486 23.2163 363.806 23.2163 364.198C23.2163 364.589 23.5763 365.169 24.0163 365.486C24.4563 365.803 24.8162 366.295 24.8162 366.578C24.8162 367.153 27.5512 371.21 28.0802 371.419C28.2652 371.493 28.4163 371.737 28.4163 371.963C28.4163 372.447 39.8823 383.886 40.3673 383.886C40.5493 383.886 41.2623 384.426 41.9533 385.086C42.6443 385.746 43.3243 386.286 43.4653 386.286C43.6073 386.286 44.0133 386.614 44.3693 387.014C44.7253 387.415 45.8262 388.18 46.8162 388.714C47.8062 389.249 48.7062 389.796 48.8162 389.93C49.1922 390.389 51.5753 391.486 52.1963 391.486C52.5373 391.486 52.8162 391.666 52.8162 391.886C52.8162 392.106 53.1762 392.286 53.6162 392.286C54.0562 392.286 54.4163 392.466 54.4163 392.686C54.4163 392.906 54.7763 393.086 55.2163 393.086C55.6563 393.086 56.0163 393.266 56.0163 393.486C56.0163 393.706 56.3762 393.886 56.8162 393.886C57.2562 393.886 57.6162 394.066 57.6162 394.286C57.6162 394.506 58.0662 394.686 58.6162 394.686C59.1662 394.686 59.6162 394.866 59.6162 395.086C59.6162 395.306 60.0662 395.486 60.6162 395.486C61.1662 395.486 61.6162 395.666 61.6162 395.886C61.6162 396.106 62.0662 396.286 62.6162 396.286C63.1662 396.286 63.6162 396.466 63.6162 396.686C63.6162 396.906 64.1563 397.086 64.8163 397.086C65.4763 397.086 66.0163 397.266 66.0163 397.486C66.0163 397.706 66.7362 397.886 67.6162 397.886C68.4962 397.886 69.2162 398.066 69.2162 398.286C69.2162 398.506 69.9212 398.686 70.7832 398.686C71.6802 398.686 72.4203 398.899 72.5163 399.186C72.7613 399.922 335.271 399.922 335.516 399.186C335.608 398.911 336.208 398.686 336.849 398.686C337.491 398.686 338.016 398.506 338.016 398.286C338.016 398.066 338.556 397.886 339.216 397.886C339.876 397.886 340.416 397.706 340.416 397.486C340.416 397.266 340.686 397.086 341.016 397.086C341.346 397.086 341.616 396.906 341.616 396.686C341.616 396.466 341.976 396.286 342.416 396.286C342.856 396.286 343.216 396.106 343.216 395.886C343.216 395.666 343.576 395.486 344.016 395.486C344.456 395.486 344.816 395.306 344.816 395.086C344.816 394.866 345.176 394.686 345.616 394.686C346.056 394.686 346.416 394.506 346.416 394.286C346.416 394.066 346.651 393.886 346.938 393.886C347.225 393.886 348.109 393.301 348.902 392.586C349.695 391.871 350.853 390.926 351.476 390.486C352.098 390.046 352.969 389.273 353.411 388.768C353.854 388.263 354.891 387.093 355.716 386.168C356.541 385.243 357.216 384.379 357.216 384.247C357.216 384.116 357.576 383.593 358.016 383.086C358.456 382.579 358.816 381.831 358.816 381.425C358.816 381.018 358.996 380.686 359.216 380.686C359.436 380.686 359.616 380.326 359.616 379.886C359.616 379.446 359.796 379.086 360.016 379.086C360.236 379.086 360.416 378.726 360.416 378.286C360.416 377.846 360.596 377.486 360.816 377.486C361.036 377.486 361.216 377.126 361.216 376.686C361.216 376.246 361.396 375.886 361.616 375.886C361.836 375.886 362.016 375.447 362.016 374.91C362.016 374.373 362.196 373.822 362.416 373.686C362.636 373.55 362.816 372.999 362.816 372.462C362.816 371.925 362.996 371.486 363.216 371.486C363.436 371.486 363.616 370.766 363.616 369.886C363.616 369.006 363.796 368.286 364.016 368.286C364.273 368.286 364.416 364.219 364.416 356.886C364.416 349.553 364.273 345.486 364.016 345.486C363.796 345.486 363.616 345.126 363.616 344.686C363.616 344.246 363.436 343.886 363.216 343.886C362.996 343.886 362.816 343.675 362.816 343.417C362.816 342.292 358.248 338.686 356.821 338.686C356.378 338.686 356.016 338.506 356.016 338.286C356.016 338.053 354.683 337.886 352.816 337.886C350.949 337.886 349.616 338.053 349.616 338.286C349.616 338.506 349.076 338.686 348.416 338.686C347.756 338.686 347.216 338.866 347.216 339.086C347.216 339.306 346.928 339.486 346.576 339.486C345.801 339.486 342.347 343.051 342.649 343.54C342.767 343.73 342.718 343.887 342.54 343.889C341.546 343.899 341.216 346.364 341.216 353.766C341.216 358.646 341.069 361.486 340.816 361.486C340.596 361.486 340.416 362.296 340.416 363.286C340.416 364.276 340.236 365.086 340.016 365.086C339.796 365.086 339.616 365.586 339.616 366.198C339.616 366.851 339.286 367.547 338.816 367.886C338.376 368.203 338.016 368.697 338.016 368.983C338.016 370.42 331.53 375.486 329.69 375.486C329.429 375.486 329.216 375.621 329.216 375.786C329.216 376.359 326.173 376.374 205.516 376.388C82.2733 376.402 81.2023 376.393 77.0243 375.305C75.7173 374.964 74.1462 374.686 73.5322 374.686C72.9182 374.686 72.4163 374.506 72.4163 374.286C72.4163 374.066 72.0673 373.886 71.6403 373.886C71.2133 373.886 70.7522 373.706 70.6162 373.486C70.4802 373.266 69.9293 373.086 69.3923 373.086C68.8553 373.086 68.4163 372.906 68.4163 372.686C68.4163 372.466 68.0562 372.286 67.6162 372.286C67.1762 372.286 66.8163 372.106 66.8163 371.886C66.8163 371.666 66.4563 371.486 66.0163 371.486C65.5763 371.486 65.2162 371.306 65.2162 371.086C65.2162 370.866 64.8563 370.686 64.4163 370.686C63.9763 370.686 63.6162 370.506 63.6162 370.286C63.6162 370.066 63.2562 369.886 62.8162 369.886C62.3762 369.886 62.0163 369.706 62.0163 369.486C62.0163 369.266 61.6962 369.086 61.3042 369.086C60.9132 369.086 60.3333 368.726 60.0163 368.286C59.6993 367.846 59.3013 367.486 59.1323 367.486C58.8383 367.486 57.7123 366.641 56.6003 365.586C56.3103 365.311 55.9753 365.086 55.8543 365.086C55.7343 365.086 54.0813 363.556 52.1813 361.686C50.2823 359.816 48.5672 358.286 48.3722 358.286C48.1762 358.286 48.0163 358.043 48.0163 357.745C48.0163 357.448 47.5213 356.68 46.9163 356.038C46.3113 355.397 45.5612 354.38 45.2482 353.779C44.9362 353.178 44.5313 352.686 44.3483 352.686C44.1663 352.686 44.0163 352.366 44.0163 351.974C44.0163 351.583 43.6563 351.003 43.2163 350.686C42.7763 350.369 42.4163 349.789 42.4163 349.398C42.4163 349.006 42.2363 348.686 42.0163 348.686C41.7963 348.686 41.6162 348.404 41.6162 348.06C41.6162 347.716 41.1662 346.451 40.6162 345.249C40.0662 344.046 39.6162 342.798 39.6162 342.474C39.6162 342.151 39.4363 341.886 39.2163 341.886C38.9963 341.886 38.8162 341.346 38.8162 340.686C38.8162 340.026 38.6363 339.486 38.4163 339.486C38.1963 339.486 38.0163 338.766 38.0163 337.886C38.0163 337.006 37.8362 336.286 37.6162 336.286C37.3962 336.286 37.2163 335.386 37.2163 334.286C37.2163 333.186 37.0362 332.286 36.8162 332.286C36.5512 332.286 36.4163 308.686 36.4163 262.286C36.4163 215.886 36.5512 192.286 36.8162 192.286C37.0362 192.286 37.2163 191.487 37.2163 190.51C37.2163 189.533 37.3962 188.622 37.6162 188.486C37.8362 188.35 38.0163 187.63 38.0163 186.886C38.0163 186.142 38.1963 185.422 38.4163 185.286C38.6363 185.15 38.8162 184.61 38.8162 184.086C38.8162 183.562 38.9963 183.022 39.2163 182.886C39.4363 182.75 39.6162 182.199 39.6162 181.662C39.6162 181.125 39.7963 180.686 40.0163 180.686C40.2363 180.686 40.4163 180.437 40.4163 180.132C40.4163 179.827 40.6853 179.062 41.0143 178.432C41.3423 177.802 41.6123 176.971 41.6143 176.586C41.6153 176.201 41.7963 175.886 42.0163 175.886C42.2363 175.886 42.4163 175.616 42.4163 175.286C42.4163 174.956 42.5962 174.686 42.8162 174.686C43.0362 174.686 43.2163 174.326 43.2163 173.886C43.2163 173.446 43.3663 173.086 43.5483 173.086C43.7313 173.086 44.1353 172.591 44.4463 171.986C44.7563 171.381 45.3272 170.595 45.7132 170.239C46.1002 169.883 46.4163 169.388 46.4163 169.139C46.4163 168.89 46.5962 168.686 46.8162 168.686C47.0362 168.686 47.2163 168.5 47.2163 168.273C47.2163 167.619 56.0953 158.94 57.3273 158.389C57.9383 158.116 58.5432 157.621 58.6702 157.289C58.7972 156.958 59.2423 156.686 59.6593 156.686C60.0753 156.686 60.4163 156.528 60.4163 156.335C60.4163 156.141 60.9562 155.759 61.6162 155.486C62.2762 155.213 62.8162 154.831 62.8162 154.637C62.8162 154.444 63.1762 154.286 63.6162 154.286C64.0562 154.286 64.4163 154.106 64.4163 153.886C64.4163 153.666 64.7762 153.486 65.2162 153.486C65.6562 153.486 66.0163 153.306 66.0163 153.086C66.0163 152.866 66.3763 152.686 66.8163 152.686C67.2563 152.686 67.6162 152.506 67.6162 152.286C67.6162 152.066 67.9782 151.886 68.4212 151.886C68.8642 151.886 69.5842 151.706 70.0212 151.486C70.4582 151.266 71.1743 150.906 71.6113 150.686C72.0483 150.466 72.8582 150.286 73.4112 150.286C73.9642 150.286 74.4163 150.106 74.4163 149.886C74.4163 149.666 75.1363 149.486 76.0163 149.486C76.8963 149.486 77.6162 149.306 77.6162 149.086C77.6162 148.866 78.5953 148.686 79.7923 148.686C80.9893 148.686 82.0802 148.506 82.2162 148.286C82.3802 148.021 123.746 147.886 205.016 147.886C286.286 147.886 327.652 148.021 327.816 148.286C327.952 148.506 328.377 148.686 328.76 148.686C329.635 148.686 331.609 149.585 331.613 149.986C331.615 150.151 331.91 150.286 332.269 150.286C332.628 150.286 333.213 150.602 333.569 150.989C333.925 151.375 334.711 151.946 335.316 152.256C335.921 152.567 336.416 153.061 336.416 153.354C336.416 153.646 336.596 153.886 336.816 153.886C337.036 153.886 337.216 154.116 337.216 154.398C337.216 154.679 337.576 155.169 338.016 155.486C338.456 155.803 338.816 156.383 338.816 156.774C338.816 157.166 338.996 157.486 339.216 157.486C339.436 157.486 339.616 157.936 339.616 158.486C339.616 159.036 339.796 159.486 340.016 159.486C340.236 159.486 340.416 160.206 340.416 161.086C340.416 161.966 340.596 162.686 340.816 162.686C341.078 162.686 341.216 170.019 341.216 183.886V205.086H309.616C288.816 205.086 278.016 205.223 278.016 205.486C278.016 205.706 277.116 205.886 276.016 205.886C274.916 205.886 274.016 206.066 274.016 206.286C274.016 206.506 273.296 206.686 272.416 206.686C271.536 206.686 270.816 206.866 270.816 207.086C270.816 207.306 270.276 207.486 269.616 207.486C268.956 207.486 268.416 207.666 268.416 207.886C268.416 208.106 267.939 208.286 267.356 208.286C266.357 208.286 263.037 209.636 260.816 210.946C260.266 211.27 259.501 211.635 259.116 211.757C258.731 211.879 258.416 212.138 258.416 212.333C258.416 212.527 258.096 212.686 257.704 212.686C257.313 212.686 256.733 213.046 256.416 213.486C256.099 213.926 255.591 214.286 255.288 214.286C254.985 214.286 254.233 214.826 253.616 215.486C252.999 216.146 252.285 216.686 252.028 216.686C251.43 216.686 243.616 224.63 243.616 225.238C243.616 225.488 243.256 225.918 242.816 226.193C242.376 226.468 242.016 226.961 242.016 227.289C242.016 227.618 241.836 227.886 241.616 227.886C241.396 227.886 241.216 228.156 241.216 228.486C241.216 228.816 241.036 229.086 240.816 229.086C240.596 229.086 240.416 229.406 240.416 229.798C240.416 230.189 240.056 230.769 239.616 231.086C239.176 231.403 238.816 231.983 238.816 232.374C238.816 232.766 238.636 233.086 238.416 233.086C238.196 233.086 238.016 233.446 238.016 233.886C238.016 234.326 237.836 234.686 237.616 234.686C237.396 234.686 237.216 235.046 237.216 235.486C237.216 235.926 237.036 236.286 236.816 236.286C236.596 236.286 236.416 236.646 236.416 237.086C236.416 237.526 236.236 237.886 236.016 237.886C235.796 237.886 235.616 238.426 235.616 239.086C235.616 239.746 235.436 240.286 235.216 240.286C234.996 240.286 234.816 240.736 234.816 241.286C234.816 241.836 234.636 242.286 234.416 242.286C234.196 242.286 234.016 242.815 234.016 243.462C234.016 244.109 233.836 244.75 233.616 244.886C233.396 245.022 233.216 245.753 233.216 246.51C233.216 247.267 233.036 247.886 232.816 247.886C232.591 247.886 232.416 249.011 232.416 250.462C232.416 251.879 232.236 253.15 232.016 253.286C231.777 253.434 231.616 256.023 231.616 259.71C231.616 263.561 231.767 265.886 232.016 265.886C232.238 265.886 232.416 266.945 232.416 268.262C232.416 269.569 232.596 270.75 232.816 270.886C233.036 271.022 233.216 271.742 233.216 272.486C233.216 273.23 233.396 273.95 233.616 274.086C233.836 274.222 234.016 274.863 234.016 275.51C234.016 276.157 234.196 276.686 234.416 276.686C234.636 276.686 234.816 277.226 234.816 277.886C234.816 278.546 234.996 279.086 235.216 279.086C235.436 279.086 235.616 279.358 235.616 279.691C235.616 280.024 235.796 280.654 236.016 281.091C236.236 281.528 236.596 282.244 236.816 282.681C237.036 283.118 237.216 283.748 237.216 284.081C237.216 284.414 237.396 284.686 237.616 284.686C237.836 284.686 238.016 285.006 238.016 285.398C238.016 285.789 238.376 286.369 238.816 286.686C239.256 287.003 239.616 287.583 239.616 287.974C239.616 288.366 239.796 288.686 240.016 288.686C240.236 288.686 240.416 288.956 240.416 289.286C240.416 289.616 240.596 289.886 240.816 289.886C241.036 289.886 241.216 290.156 241.216 290.486C241.216 290.816 241.391 291.086 241.606 291.086C241.82 291.086 242.286 291.648 242.641 292.335C242.996 293.022 243.885 294.182 244.616 294.912C245.346 295.643 246.255 296.766 246.634 297.409C247.014 298.052 247.853 298.89 248.5 299.272C249.146 299.654 250.467 300.758 251.435 301.726C252.403 302.694 253.388 303.486 253.624 303.486C253.859 303.486 254.502 303.936 255.052 304.486C255.602 305.036 256.211 305.486 256.406 305.486C256.6 305.486 257.004 305.711 257.303 305.986C257.805 306.447 258.476 306.866 260.316 307.867C260.701 308.076 261.736 308.541 262.616 308.9C263.496 309.259 264.529 309.718 264.911 309.92C265.293 310.121 265.878 310.286 266.211 310.286C266.544 310.286 266.816 310.466 266.816 310.686C266.816 310.906 267.356 311.086 268.016 311.086C268.676 311.086 269.216 311.266 269.216 311.486C269.216 311.706 269.745 311.886 270.392 311.886C271.039 311.886 271.68 312.066 271.816 312.286C271.952 312.506 272.683 312.686 273.44 312.686C274.197 312.686 274.816 312.866 274.816 313.086C274.816 313.312 275.949 313.486 277.416 313.486C278.883 313.486 280.016 313.66 280.016 313.886C280.016 314.151 296.816 314.286 329.616 314.286C362.416 314.286 379.216 314.151 379.216 313.886C379.216 313.666 379.756 313.486 380.416 313.486C381.076 313.486 381.616 313.306 381.616 313.086C381.616 312.866 381.857 312.686 382.152 312.686C382.928 312.686 386.416 309.282 386.416 308.526C386.416 308.174 386.596 307.886 386.816 307.886C387.036 307.886 387.216 307.447 387.216 306.91C387.216 306.373 387.396 305.822 387.616 305.686C387.879 305.524 388.016 289.69 388.016 259.486C388.016 229.282 387.879 213.448 387.616 213.286C387.396 213.15 387.216 212.599 387.216 212.062C387.216 211.525 387.036 211.086 386.816 211.086C386.596 211.086 386.416 210.85 386.416 210.562C386.416 209.868 382.959 206.686 382.205 206.686C381.881 206.686 381.616 206.506 381.616 206.286C381.616 206.066 381.256 205.886 380.816 205.886C380.376 205.886 380.016 205.706 380.016 205.486C380.016 205.233 377.149 205.086 372.216 205.086H364.416V180.486C364.416 164.353 364.278 155.886 364.016 155.886C363.796 155.886 363.616 155.346 363.616 154.686C363.616 154.026 363.436 153.486 363.216 153.486C362.996 153.486 362.816 152.957 362.816 152.31C362.816 151.663 362.636 151.022 362.416 150.886C362.196 150.75 362.016 150.019 362.016 149.262C362.016 148.505 361.857 147.886 361.663 147.886C361.468 147.886 361.209 147.571 361.087 147.186C360.847 146.427 359.564 144.21 359.178 143.886C359.046 143.776 358.826 143.222 358.687 142.656C358.549 142.089 357.934 141.099 357.322 140.456C356.709 139.812 355.766 138.656 355.228 137.886C354.069 136.23 350.85 133.086 350.313 133.086C350.106 133.086 349.456 132.591 348.869 131.986C347.74 130.824 345.885 129.585 344.716 129.215C344.331 129.093 344.016 128.834 344.016 128.639C344.016 128.445 343.656 128.286 343.216 128.286C342.776 128.286 342.415 128.151 342.413 127.986C342.409 127.585 340.435 126.686 339.56 126.686C339.177 126.686 338.759 126.517 338.632 126.311C338.504 126.105 338.089 125.941 337.708 125.946C337.327 125.951 336.296 125.678 335.416 125.338C334.536 124.999 332.781 124.713 331.516 124.704C330.251 124.694 329.216 124.506 329.216 124.286C329.216 124.024 321.816 123.886 307.816 123.886C293.625 123.886 286.416 123.749 286.416 123.481C286.416 123.258 286.596 122.718 286.816 122.281C287.036 121.844 287.396 121.128 287.616 120.691C287.836 120.254 288.016 119.354 288.016 118.691C288.016 118.028 288.176 117.486 288.372 117.486C288.71 117.486 288.927 116.614 289.441 113.186C289.564 112.361 289.824 111.326 290.018 110.886C290.41 109.996 290.778 107.386 291.584 99.786C291.602 99.621 298.996 99.486 308.016 99.486C318.683 99.486 324.416 99.346 324.416 99.086C324.416 98.866 324.956 98.686 325.616 98.686C326.276 98.686 326.816 98.506 326.816 98.286C326.816 98.066 327.176 97.886 327.616 97.886C328.056 97.886 328.416 97.706 328.416 97.486C328.416 97.266 328.694 97.086 329.034 97.086C329.784 97.086 331.211 95.683 331.984 94.186C332.296 93.581 332.701 93.086 332.884 93.086C333.066 93.086 333.216 92.647 333.216 92.11C333.216 91.573 333.396 91.022 333.616 90.886C333.836 90.75 334.016 89.119 334.016 87.262C334.016 85.278 333.851 83.886 333.616 83.886C333.396 83.886 333.216 83.346 333.216 82.686C333.216 82.026 333.036 81.486 332.816 81.486C332.596 81.486 332.416 81.251 332.416 80.964C332.416 80.132 329.962 77.707 328.216 76.814C324.938 75.137 324.318 75.086 307.088 75.086H290.416V73.686C290.416 72.916 290.236 72.286 290.016 72.286C289.796 72.286 289.616 71.577 289.616 70.71C289.616 69.843 289.436 69.022 289.216 68.886C288.996 68.75 288.816 68.019 288.816 67.262C288.816 66.505 288.636 65.886 288.416 65.886C288.196 65.886 288.016 65.357 288.016 64.71C288.016 64.063 287.836 63.422 287.616 63.286C287.396 63.15 287.216 62.61 287.216 62.086C287.216 61.562 287.036 61.022 286.816 60.886C286.596 60.75 286.416 60.21 286.416 59.686C286.416 59.162 286.236 58.622 286.016 58.486C285.796 58.35 285.616 57.889 285.616 57.462C285.616 57.035 285.436 56.686 285.216 56.686C284.996 56.686 284.816 56.326 284.816 55.886C284.816 55.446 284.636 55.086 284.416 55.086C284.196 55.086 284.016 54.546 284.016 53.886C284.016 53.226 283.836 52.686 283.616 52.686C283.396 52.686 283.216 52.326 283.216 51.886C283.216 51.446 283.036 51.086 282.816 51.086C282.596 51.086 282.416 50.726 282.416 50.286C282.416 49.846 282.236 49.486 282.016 49.486C281.796 49.486 281.616 49.126 281.616 48.686C281.616 48.246 281.47 47.886 281.291 47.886C281.112 47.886 280.718 47.256 280.416 46.486C280.114 45.716 279.72 45.086 279.541 45.086C279.362 45.086 279.216 44.816 279.216 44.486C279.216 44.156 279.036 43.886 278.816 43.886C278.596 43.886 278.416 43.656 278.416 43.374C278.416 43.093 278.056 42.603 277.616 42.286C277.176 41.969 276.816 41.389 276.816 40.998C276.816 40.606 276.636 40.286 276.416 40.286C276.196 40.286 276.016 40.008 276.016 39.669C276.016 39.33 275.833 38.835 275.609 38.569C274.084 36.761 273.616 36.128 273.616 35.875C273.616 35.716 272.986 34.899 272.216 34.058C271.446 33.217 270.816 32.382 270.816 32.201C270.816 32.021 269.466 30.523 267.816 28.873C266.166 27.223 264.816 25.958 264.816 26.061C264.816 26.164 263.379 24.817 261.622 23.067C259.865 21.318 258.333 19.886 258.218 19.886C258.103 19.886 257.444 19.346 256.753 18.686C256.062 18.026 255.342 17.486 255.153 17.486C254.964 17.486 254.244 16.946 253.553 16.286C252.862 15.626 252.137 15.086 251.94 15.086C251.743 15.086 251.196 14.726 250.724 14.286C250.252 13.846 249.629 13.486 249.341 13.486C249.052 13.486 248.816 13.306 248.816 13.086C248.816 12.866 248.538 12.686 248.199 12.686C247.86 12.686 247.196 12.326 246.724 11.886C246.252 11.446 245.629 11.086 245.341 11.086C245.052 11.086 244.816 10.906 244.816 10.686C244.816 10.466 244.456 10.286 244.016 10.286C243.576 10.286 243.216 10.095 243.216 9.86196C243.216 9.62896 243.051 9.54096 242.848 9.66596C242.646 9.79096 242.206 9.61896 241.871 9.28396C241.536 8.94896 240.712 8.56496 240.039 8.43096C239.366 8.29596 238.816 8.02796 238.816 7.83596C238.816 7.64396 238.456 7.48596 238.016 7.48596C237.576 7.48596 237.216 7.30596 237.216 7.08596C237.216 6.86596 236.856 6.68596 236.416 6.68596C235.976 6.68596 235.616 6.50596 235.616 6.28596C235.616 6.06596 235.076 5.88596 234.416 5.88596C233.756 5.88596 233.216 5.70596 233.216 5.48596C233.216 5.26596 232.676 5.08596 232.016 5.08596C231.356 5.08596 230.816 4.90596 230.816 4.68596C230.816 4.46596 230.456 4.28596 230.016 4.28596C229.576 4.28596 229.216 4.10596 229.216 3.88596C229.216 3.66596 228.676 3.48596 228.016 3.48596C227.356 3.48596 226.816 3.30596 226.816 3.08596C226.816 2.86596 226.096 2.68596 225.216 2.68596C224.336 2.68596 223.616 2.50596 223.616 2.28596C223.616 2.06596 222.997 1.88596 222.24 1.88596C221.483 1.88596 220.752 1.70596 220.616 1.48596C220.48 1.26596 219.584 1.08596 218.626 1.08596C217.644 1.08596 216.814 0.879961 216.726 0.614961C216.567 0.138961 191.975 -0.219039 185.316 0.156961ZM209.69 22.74C210.06 22.931 211.175 23.086 212.166 23.086C213.158 23.086 214.08 23.266 214.216 23.486C214.352 23.706 215.072 23.886 215.816 23.886C216.56 23.886 217.28 24.066 217.416 24.286C217.552 24.506 218.283 24.686 219.04 24.686C219.797 24.686 220.416 24.866 220.416 25.086C220.416 25.306 220.855 25.486 221.392 25.486C221.929 25.486 222.48 25.666 222.616 25.886C222.752 26.106 223.303 26.286 223.84 26.286C224.377 26.286 224.816 26.466 224.816 26.686C224.816 26.906 225.132 27.086 225.517 27.086C226.987 27.086 235.908 31.85 239.616 34.614C240.606 35.352 241.953 36.345 242.608 36.821C250.644 42.651 260.089 55.226 264.064 65.386C264.258 65.881 264.587 66.691 264.796 67.186C268.223 75.306 269.99 89.368 268.809 99.122C268.258 103.671 267.119 109.504 266.434 111.286C266.265 111.726 265.91 112.806 265.645 113.686C265.38 114.566 265.019 115.646 264.843 116.086C264.667 116.526 264.344 117.336 264.125 117.886C263.906 118.436 263.101 120.146 262.336 121.686L260.945 124.486L234.865 124.589C208.862 124.692 208.786 124.689 209.214 123.889C209.451 123.447 209.953 123.082 210.33 123.077C210.707 123.072 211.466 122.716 212.016 122.286C212.566 121.856 213.225 121.5 213.481 121.495C215.23 121.461 220.188 114.761 221.035 111.286C223.808 99.909 219.075 91.371 207.416 86.721C203.736 85.254 203.987 86.026 204.108 76.531L204.216 68.086L206.016 68.203C207.897 68.326 209.143 68.687 211.816 69.886C215.778 71.663 215.891 71.676 217.384 70.537C220.288 68.323 220.882 64.817 218.752 62.475C218.056 61.711 217.246 61.086 216.952 61.086C216.657 61.086 216.416 60.906 216.416 60.686C216.416 60.466 215.977 60.286 215.44 60.286C214.903 60.286 214.352 60.106 214.216 59.886C214.08 59.666 213.36 59.486 212.616 59.486C211.872 59.486 211.152 59.306 211.016 59.086C210.88 58.866 209.708 58.686 208.411 58.686C205.478 58.686 204.016 58.075 204.016 56.848C204.016 54.988 203.31 53.94 201.876 53.671C199.863 53.293 198.816 53.997 198.816 55.726C198.816 57.958 198.228 58.686 196.426 58.686C195.566 58.686 194.752 58.866 194.616 59.086C194.48 59.306 194.017 59.486 193.587 59.486C193.157 59.486 192.493 59.646 192.111 59.842C191.729 60.038 190.545 60.615 189.48 61.124C178.967 66.147 176.873 81.325 185.704 88.486C186.789 89.366 187.888 90.266 188.146 90.486C188.943 91.165 192.06 92.686 192.654 92.686C192.963 92.686 193.216 92.866 193.216 93.086C193.216 93.306 193.578 93.486 194.021 93.486C194.464 93.486 195.139 93.645 195.521 93.839C195.903 94.034 196.696 94.416 197.282 94.689C198.744 95.369 198.804 95.777 198.811 105.012C198.817 115.251 198.566 115.712 194.016 113.811C192.314 113.099 189.963 111.847 189.616 111.467C189.506 111.346 188.786 110.815 188.016 110.286C187.246 109.757 186.526 109.226 186.416 109.105C184.397 106.892 179.216 108.437 179.216 111.252C179.216 111.575 179.036 111.95 178.816 112.086C175.96 113.851 183.887 123.086 188.258 123.086C188.549 123.086 188.981 123.447 189.218 123.889C189.646 124.689 189.57 124.692 163.975 124.589L138.302 124.486L137.039 122.086C136.343 120.766 135.361 118.606 134.856 117.286C134.351 115.966 133.794 114.526 133.618 114.086C129.238 103.13 129.227 79.633 133.597 69.286C133.783 68.846 134.157 67.856 134.428 67.086C135.172 64.973 139.724 55.705 140.093 55.553C140.271 55.479 140.416 55.164 140.416 54.853C140.416 54.541 140.596 54.286 140.816 54.286C141.036 54.286 141.216 54.016 141.216 53.686C141.216 53.356 141.396 53.086 141.616 53.086C141.836 53.086 142.016 52.816 142.016 52.486C142.016 52.156 142.196 51.886 142.416 51.886C142.636 51.886 142.816 51.631 142.816 51.319C142.816 51.008 142.951 50.693 143.116 50.619C143.281 50.546 144.187 49.472 145.129 48.233C147.15 45.573 152.988 39.595 155.119 38.004C155.942 37.389 157.064 36.481 157.612 35.986C158.16 35.491 158.717 35.086 158.851 35.086C158.984 35.086 159.516 34.719 160.033 34.271C161.283 33.187 167.128 29.888 170.616 28.299C172.156 27.597 173.729 26.857 174.111 26.654C174.493 26.452 175.157 26.286 175.587 26.286C176.017 26.286 176.48 26.106 176.616 25.886C176.752 25.666 177.303 25.486 177.84 25.486C178.377 25.486 178.816 25.306 178.816 25.086C178.816 24.866 179.435 24.686 180.192 24.686C180.949 24.686 181.68 24.506 181.816 24.286C181.952 24.066 182.647 23.886 183.36 23.886C184.073 23.886 184.827 23.723 185.036 23.523C186.289 22.326 207.564 21.65 209.69 22.74ZM199.125 75.595C199.251 83.76 199.221 83.825 196.102 82.237C192.06 80.18 190.62 77.751 191.122 73.834C191.443 71.334 195.49 68.137 198.016 68.387L199.016 68.486L199.125 75.595ZM205.342 97.939C213.33 102.079 212.604 114.286 204.37 114.286H203.216V106.153C203.216 96.963 203.245 96.852 205.342 97.939ZM107.616 100.606C107.616 101.222 107.782 101.897 107.985 102.106C108.306 102.437 108.736 106.388 108.793 109.532C108.803 110.107 109.075 111.209 109.398 111.981C109.72 112.753 109.871 113.498 109.733 113.636C109.595 113.774 109.678 114.292 109.919 114.787C110.36 115.696 110.695 117.013 111.088 119.386C111.207 120.101 111.464 120.686 111.66 120.686C111.856 120.686 112.016 121.125 112.016 121.662C112.016 122.199 112.196 122.75 112.416 122.886C113.8 123.742 111.664 123.886 97.6162 123.886C89.2562 123.886 82.4163 124.039 82.4163 124.225C82.4163 124.411 80.2653 124.672 77.6363 124.804C74.7533 124.949 72.4123 125.27 71.7363 125.613C71.1203 125.926 70.2203 126.118 69.7363 126.04C69.2523 125.961 68.7473 126.075 68.6133 126.292C68.4783 126.509 67.7603 126.686 67.0163 126.686C66.2723 126.686 65.5523 126.866 65.4163 127.086C65.2803 127.306 64.8173 127.486 64.3873 127.486C63.9573 127.486 63.2933 127.645 62.9113 127.839C62.5293 128.034 61.7663 128.37 61.2163 128.586C59.4623 129.275 57.8373 129.969 57.1213 130.333C56.7393 130.527 56.1543 130.686 55.8213 130.686C55.4883 130.686 55.2163 130.866 55.2163 131.086C55.2163 131.306 54.8563 131.486 54.4163 131.486C53.9763 131.486 53.6162 131.666 53.6162 131.886C53.6162 132.106 53.2562 132.286 52.8162 132.286C52.3762 132.286 52.0163 132.466 52.0163 132.686C52.0163 132.906 51.7802 133.086 51.4912 133.086C51.2032 133.086 50.5802 133.446 50.1082 133.886C49.6362 134.326 48.9723 134.686 48.6333 134.686C48.2943 134.686 48.0163 134.866 48.0163 135.086C48.0163 135.306 47.7463 135.486 47.4163 135.486C47.0863 135.486 46.8162 135.666 46.8162 135.886C46.8162 136.106 46.5463 136.286 46.2163 136.286C45.8863 136.286 45.6162 136.466 45.6162 136.686C45.6162 136.906 45.3463 137.086 45.0163 137.086C44.6863 137.086 44.4163 137.266 44.4163 137.486C44.4163 137.706 44.1863 137.886 43.9043 137.886C43.6233 137.886 43.1332 138.246 42.8162 138.686C42.4992 139.126 42.0853 139.486 41.8963 139.486C41.7083 139.486 40.8692 140.198 40.0332 141.068C39.1972 141.938 38.4013 142.538 38.2653 142.401C38.1283 142.265 38.0163 142.363 38.0163 142.619C38.0163 142.876 37.8362 143.086 37.6162 143.086C37.3962 143.086 37.2163 142.377 37.2163 141.51C37.2163 140.643 37.3962 139.822 37.6162 139.686C37.8362 139.55 38.0193 139.044 38.0223 138.562C38.0293 137.605 38.9033 134.866 39.3423 134.427C39.4933 134.276 39.6162 133.856 39.6162 133.494C39.6162 133.132 40.0662 131.903 40.6162 130.763C41.1662 129.623 41.6162 128.419 41.6162 128.088C41.6162 127.757 41.7963 127.486 42.0163 127.486C42.2363 127.486 42.4163 127.126 42.4163 126.686C42.4163 126.246 42.5962 125.886 42.8162 125.886C43.0362 125.886 43.2163 125.616 43.2163 125.286C43.2163 124.956 43.3962 124.686 43.6162 124.686C43.8362 124.686 44.0163 124.416 44.0163 124.086C44.0163 123.756 44.1963 123.486 44.4163 123.486C44.6363 123.486 44.8162 123.216 44.8162 122.886C44.8162 122.556 44.9663 122.286 45.1483 122.286C45.3313 122.286 45.7363 121.793 46.0483 121.191C46.3613 120.589 47.3632 119.342 48.2762 118.42C49.1892 117.499 50.2482 116.216 50.6302 115.57C51.0122 114.923 51.8533 114.082 52.5003 113.7C53.1463 113.318 54.4672 112.214 55.4352 111.246C56.4032 110.278 57.3803 109.486 57.6053 109.486C57.8313 109.486 58.0163 109.333 58.0163 109.147C58.0163 108.96 58.7362 108.483 59.6162 108.086C60.4962 107.689 61.2163 107.212 61.2163 107.025C61.2163 106.839 61.5612 106.686 61.9832 106.686C62.4042 106.686 62.8093 106.551 62.8833 106.386C63.0753 105.954 66.3883 104.286 67.0543 104.286C67.3633 104.286 67.6162 104.106 67.6162 103.886C67.6162 103.666 67.9763 103.486 68.4163 103.486C68.8563 103.486 69.2162 103.306 69.2162 103.086C69.2162 102.866 69.7563 102.686 70.4163 102.686C71.0763 102.686 71.6162 102.506 71.6162 102.286C71.6162 102.066 72.0552 101.886 72.5922 101.886C73.1292 101.886 73.6803 101.706 73.8163 101.486C73.9523 101.266 74.6833 101.086 75.4403 101.086C76.1973 101.086 76.8163 100.906 76.8163 100.686C76.8163 100.466 77.7053 100.286 78.7923 100.286C79.8793 100.286 80.8803 100.106 81.0163 99.886C81.1733 99.632 86.0873 99.486 94.4403 99.486H107.616V100.606ZM364.718 227.817C365.116 228.07 365.2 234.716 365.118 259.711L365.016 291.286L323.816 291.272C285.363 291.259 280.31 291.151 278.216 290.299C277.776 290.12 276.688 289.778 275.799 289.539C271.201 288.301 260.016 279.62 260.016 277.289C260.016 276.957 259.836 276.686 259.616 276.686C259.396 276.686 259.216 276.326 259.216 275.886C259.216 275.446 259.036 275.086 258.816 275.086C258.596 275.086 258.412 274.861 258.407 274.586C258.402 274.311 258.046 273.636 257.616 273.086C257.186 272.536 256.83 271.769 256.825 271.381C256.82 270.993 256.654 270.363 256.455 269.981C255.323 267.803 254.235 260.904 254.568 258.017C255.061 253.752 255.263 252.493 255.585 251.686C256.23 250.074 256.816 248.012 256.816 247.358C256.816 246.988 256.954 246.686 257.122 246.686C257.29 246.686 257.734 246.011 258.11 245.186C261.277 238.221 269.952 230.842 277.016 229.104C278.116 228.833 279.376 228.451 279.816 228.254C281.33 227.576 363.672 227.153 364.718 227.817Z",
              fill: "#D5E6FD",
            }),
            (0, Qe.jsx)("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M198.115 22.5769C198.94 22.6639 200.29 22.6639 201.115 22.5769C201.94 22.4909 201.265 22.4199 199.615 22.4199C197.965 22.4199 197.29 22.4909 198.115 22.5769ZM189.415 23.0859L187.815 23.3719L189.415 23.3889C190.295 23.3989 191.465 23.2619 192.015 23.0859L193.015 22.7659L192.015 22.7829C191.465 22.7919 190.295 22.9279 189.415 23.0859ZM207.215 23.0859C207.765 23.2619 208.845 23.4029 209.615 23.3999L211.015 23.3939L209.415 23.0629C207.278 22.6209 205.811 22.6359 207.215 23.0859ZM184.815 23.8859L183.815 24.2059L184.815 24.2179C185.365 24.2239 186.175 24.0749 186.615 23.8859L187.415 23.5419L186.615 23.5539C186.175 23.5599 185.365 23.7099 184.815 23.8859ZM212.615 23.8859C213.055 24.0749 213.775 24.2239 214.215 24.2179C214.858 24.2089 214.819 24.1429 214.015 23.8859C212.647 23.4479 211.596 23.4479 212.615 23.8859ZM181.615 24.6859L180.615 25.0059L181.615 25.0399C182.165 25.0589 182.885 24.8989 183.215 24.6859C183.979 24.1919 183.157 24.1919 181.615 24.6859ZM216.015 24.6799C216.345 24.8969 217.05 25.0769 217.582 25.0799C218.866 25.0879 218.54 24.8609 216.815 24.5439C215.83 24.3629 215.593 24.4039 216.015 24.6799ZM177.909 25.7709C176.86 26.1209 176.075 26.4799 176.165 26.5689C176.347 26.7509 180.415 25.4799 180.415 25.2399C180.415 24.9929 179.936 25.0949 177.909 25.7709ZM218.815 25.2319C218.815 25.4189 222.604 26.6939 223.09 26.6699C223.561 26.6479 221.207 25.6639 219.915 25.3429C219.31 25.1929 218.815 25.1429 218.815 25.2319ZM174.415 26.9709C172.731 27.5919 166.415 30.6739 166.415 30.8749C166.415 31.0019 166.912 30.8499 167.519 30.5359C168.126 30.2219 169.791 29.4419 171.219 28.8039C172.647 28.1649 174.265 27.4389 174.815 27.1909C175.828 26.7339 175.518 26.5629 174.415 26.9709ZM223.831 27.1119C223.958 27.3179 224.318 27.4859 224.631 27.4859C225.066 27.4859 230.22 29.7669 232.515 30.9749C232.68 31.0619 232.815 31.0409 232.815 30.9289C232.815 30.6619 226.148 27.4819 224.707 27.0609C224.036 26.8649 223.691 26.8849 223.831 27.1119ZM164.096 32.0579C163.371 32.5699 162.651 33.1249 162.496 33.2889C162.079 33.7329 164.488 32.4449 165.415 31.7289C166.69 30.7449 165.552 31.0279 164.096 32.0579ZM233.815 31.6969C234.255 32.0549 235.155 32.6119 235.815 32.9359C236.937 33.4869 236.963 33.4829 236.215 32.8749C235.775 32.5169 234.875 31.9599 234.215 31.6359C233.093 31.0849 233.067 31.0889 233.815 31.6969ZM159.295 35.2909C157.931 36.2829 156.815 37.1919 156.815 37.3099C156.815 37.5299 159.433 35.7449 161.215 34.3089C163.058 32.8239 161.802 33.4669 159.295 35.2909ZM237.324 33.7389C237.46 33.9589 238.693 34.9259 240.063 35.8869C241.433 36.8479 242.442 37.4539 242.306 37.2329C242.17 37.0129 240.937 36.0459 239.567 35.0849C238.197 34.1239 237.188 33.5179 237.324 33.7389ZM152.205 41.1759C148.308 44.8619 143.706 50.2209 142.258 52.7599C141.258 54.5119 141.778 53.9349 144.64 50.1159C147.034 46.9209 152.106 41.5199 154.957 39.1299C155.805 38.4189 156.415 37.7529 156.313 37.6509C156.211 37.5489 154.363 39.1349 152.205 41.1759ZM242.815 37.6029C242.815 37.7499 243.67 38.6259 244.715 39.5519C245.76 40.4769 248.127 42.7749 249.975 44.6599C251.823 46.5439 252.782 47.3659 252.105 46.4859C250.421 44.2959 242.815 37.0229 242.815 37.6029ZM255.015 50.7859C256.005 52.1609 256.954 53.4659 257.126 53.6859C257.297 53.9059 257.935 54.9409 258.543 55.9859C259.151 57.0309 259.739 57.8859 259.849 57.8859C260.106 57.8859 258.172 54.5569 256.711 52.4859C256.091 51.6059 255.185 50.3029 254.699 49.5909C254.213 48.8789 253.68 48.2939 253.516 48.2909C253.351 48.2879 254.026 49.4109 255.015 50.7859ZM199.215 53.2659C198.027 53.9689 198.367 54.0729 199.767 53.4349C201.785 52.5149 204.415 54.1149 204.415 56.2619C204.415 57.7309 204.572 57.8239 207.461 58.0539L209.815 58.2409L207.315 57.8079C204.862 57.3829 204.815 57.3499 204.815 56.0999C204.815 53.6459 201.451 51.9429 199.215 53.2659ZM197.882 54.5529C197.735 54.6989 197.615 55.4099 197.615 56.1329C197.615 56.9509 197.351 57.6099 196.915 57.8809C196.275 58.2779 196.284 58.3049 197.015 58.1949C197.632 58.1029 197.872 57.6649 198.064 56.2809C198.329 54.3699 198.304 54.1299 197.882 54.5529ZM137.815 60.2859C137.235 61.4299 136.838 62.4419 136.932 62.5359C137.026 62.6299 137.569 61.7639 138.14 60.6109C138.711 59.4579 139.108 58.4459 139.023 58.3609C138.938 58.2759 138.395 59.1419 137.815 60.2859ZM193.419 58.6799C193.267 58.9259 193.67 58.9799 194.495 58.8229C196.264 58.4859 196.416 58.2859 194.905 58.2859C194.222 58.2859 193.553 58.4629 193.419 58.6799ZM212.415 59.0579C213.845 59.4569 215.51 59.9809 216.115 60.2239C217.667 60.8479 217.49 60.4409 215.915 59.7659C213.736 58.8319 211.808 58.2849 210.787 58.3099C210.252 58.3229 210.985 58.6599 212.415 59.0579ZM190.508 59.6659C188.849 60.5819 188.993 60.7659 190.815 60.0559C192.978 59.2149 193.185 59.0739 192.182 59.1249C191.76 59.1469 191.007 59.3899 190.508 59.6659ZM260.815 60.0009C260.815 60.2939 262.07 62.6859 262.223 62.6859C262.499 62.6859 261.541 60.2879 261.176 60.0619C260.977 59.9389 260.815 59.9119 260.815 60.0009ZM187.015 61.5669C184.423 63.4159 180.785 67.5889 181.309 68.1139C181.404 68.2079 182.076 67.3669 182.804 66.2439C183.531 65.1209 185.201 63.4109 186.515 62.4439C187.828 61.4769 188.748 60.6919 188.559 60.6989C188.37 60.7059 187.675 61.0959 187.015 61.5669ZM218.215 61.3109C218.655 61.6399 219.346 62.3089 219.75 62.7979C220.154 63.2859 220.352 63.4159 220.19 63.0859C219.713 62.1129 218.31 60.6849 217.845 60.6989C217.609 60.7059 217.775 60.9809 218.215 61.3109ZM135.887 64.5049C135.517 65.2789 135.228 66.1319 135.243 66.3999C135.259 66.6669 135.623 66.0949 136.052 65.1279C136.986 63.0229 136.846 62.4939 135.887 64.5049ZM220.508 65.4859C220.508 66.2559 220.59 66.5709 220.691 66.1859C220.791 65.8009 220.791 65.1709 220.691 64.7859C220.59 64.4009 220.508 64.7159 220.508 65.4859ZM219.278 69.1449C218.748 70.0659 217.813 70.9859 217.085 71.3019C216.386 71.6059 216.106 71.8619 216.461 71.8699C217.38 71.8929 219.123 70.4249 219.852 69.0139C220.788 67.2039 220.336 67.3069 219.278 69.1449ZM204.682 68.5529C204.535 68.6989 204.415 72.4499 204.415 76.8879V84.9579L205.434 85.4219C206.885 86.0829 207.223 85.9669 205.915 85.2569L204.815 84.6599V76.7069C204.815 70.7179 204.939 68.7029 205.315 68.5509C205.594 68.4379 205.624 68.3349 205.382 68.3179C205.143 68.2999 204.828 68.4059 204.682 68.5529ZM196.615 69.1129C196.007 69.3949 196.128 69.4279 197.115 69.2529L198.415 69.0219V75.6809V82.3399L197.515 82.0939C196.735 81.8809 196.709 81.9069 197.318 82.2889C198.648 83.1219 198.815 82.3619 198.815 75.4619C198.815 68.1219 198.806 68.0969 196.615 69.1129ZM207.415 69.0859C208.611 69.5999 209.61 69.5999 208.815 69.0859C208.485 68.8729 207.855 68.7079 207.415 68.7199L206.615 68.7419L207.415 69.0859ZM133.815 69.8859C133.665 70.3589 133.632 70.8359 133.742 70.9459C133.852 71.0559 134.065 70.7589 134.215 70.2859C134.365 69.8129 134.398 69.3359 134.288 69.2259C134.178 69.1159 133.965 69.4129 133.815 69.8859ZM192.944 71.1859C192.499 71.6809 191.991 72.3559 191.816 72.6859C191.478 73.3229 191.57 73.2359 193.191 71.3859C193.721 70.7809 194.064 70.2859 193.954 70.2859C193.844 70.2859 193.39 70.6909 192.944 71.1859ZM179.864 71.7009C179.727 72.0589 179.636 73.0119 179.662 73.8189C179.705 75.1689 179.735 75.1279 180.041 73.2989C180.383 71.2559 180.305 70.5529 179.864 71.7009ZM213.405 71.4699C213.547 71.6989 214.132 71.8859 214.705 71.8859C215.959 71.8859 215.814 71.6939 214.281 71.3259C213.538 71.1479 213.236 71.1969 213.405 71.4699ZM133.015 72.6859C132.863 73.3769 132.822 74.0269 132.924 74.1279C133.026 74.2299 133.224 73.7389 133.365 73.0359C133.698 71.3689 133.375 71.0459 133.015 72.6859ZM265.627 72.2859C265.627 72.6159 265.802 73.1559 266.015 73.4859C266.36 74.0189 266.403 74.0189 266.403 73.4859C266.403 73.1559 266.228 72.6159 266.015 72.2859C265.67 71.7529 265.627 71.7529 265.627 72.2859ZM191.316 75.2859C191.32 76.1659 191.402 76.4789 191.498 75.9809C191.594 75.4839 191.59 74.7639 191.49 74.3809C191.39 73.9989 191.311 74.4059 191.316 75.2859ZM132.264 75.3009C132.127 75.6589 132.031 76.3419 132.051 76.8189C132.077 77.4329 132.2 77.2939 132.474 76.3419C132.872 74.9579 132.709 74.1439 132.264 75.3009ZM266.483 75.0859C266.503 76.1249 267.133 77.8319 267.147 76.8859C267.153 76.4459 267.004 75.7259 266.815 75.2859C266.604 74.7959 266.476 74.7179 266.483 75.0859ZM191.928 78.1139C192.5 79.1689 194.402 80.8899 195.615 81.4489L196.615 81.9089L195.615 81.2129C195.065 80.8299 193.916 79.8019 193.062 78.9289C192.208 78.0559 191.698 77.6889 191.928 78.1139ZM131.484 79.0419C131.336 79.7809 131.235 80.7689 131.259 81.2359C131.283 81.7029 131.462 81.2759 131.657 80.2859C131.852 79.2959 131.953 78.3089 131.882 78.0919C131.811 77.8759 131.632 78.3029 131.484 79.0419ZM179.621 79.1189C179.624 79.8709 179.807 80.7559 180.027 81.0859C180.306 81.5049 180.348 81.1439 180.165 79.8859C179.84 77.6449 179.613 77.3259 179.621 79.1189ZM267.295 79.0859C267.295 79.6359 267.439 80.5359 267.615 81.0859L267.935 82.0859V81.0859C267.935 80.5359 267.791 79.6359 267.615 79.0859L267.295 78.0859V79.0859ZM130.669 84.9419C130.353 87.2509 130.42 97.6709 130.762 99.2599C130.901 99.9059 131.015 96.5309 131.015 91.7599C131.015 82.1509 131.025 82.3469 130.669 84.9419ZM268.215 91.7069C268.215 96.2909 268.329 99.5109 268.468 98.8639C268.815 97.2469 268.833 86.8439 268.492 84.9289C268.34 84.0729 268.215 87.1229 268.215 91.7069ZM207.215 86.0809C207.215 86.2909 209.95 87.4969 210.364 87.4689C210.685 87.4479 207.916 85.9249 207.515 85.9029C207.35 85.8939 207.215 85.9739 207.215 86.0809ZM183.815 87.8399C185.821 90.0639 189.247 92.1959 193.815 94.0639C194.695 94.4239 195.91 94.9349 196.515 95.1999L197.615 95.6809V104.754C197.615 112.522 197.528 113.854 197.007 114.016C196.582 114.148 196.612 114.185 197.107 114.14C197.762 114.08 197.815 113.376 197.815 104.685V95.2949L194.41 93.8909C189.947 92.0499 186.782 90.2279 184.482 88.1759C183.024 86.8749 182.878 86.8009 183.815 87.8399ZM210.973 87.8179C211.132 88.0749 211.477 88.2879 211.739 88.2899C213.338 88.3039 218.501 93.2999 220.18 96.4579C220.749 97.5289 221.214 98.1529 221.214 97.8459C221.212 97.1169 219.879 94.9229 218.137 92.7789C216.377 90.6129 209.95 86.1629 210.973 87.8179ZM203.791 98.4059C203.684 98.6829 203.65 102.325 203.715 106.498L203.834 114.086L203.924 106.386C204.025 97.8459 203.991 97.9309 206.559 99.6739C207.36 100.217 208.015 100.526 208.015 100.36C208.015 100.048 205.967 98.7089 204.703 98.1929C204.258 98.0119 203.91 98.0929 203.791 98.4059ZM208.415 100.831C208.415 101.014 208.815 101.724 209.304 102.411C210.706 104.379 210.586 108.831 209.075 110.932L207.957 112.486L209.146 111.149C211.173 108.87 211.266 104.722 209.356 101.893C208.838 101.127 208.415 100.649 208.415 100.831ZM131.243 102.519C131.259 103.381 131.432 104.446 131.629 104.886C131.863 105.408 131.903 104.923 131.747 103.486C131.458 100.844 131.204 100.356 131.243 102.519ZM267.462 102.823C267.293 103.888 267.247 104.851 267.359 104.964C267.651 105.255 268.12 102.51 267.929 101.626C267.842 101.219 267.631 101.757 267.462 102.823ZM222.134 105.486C222.13 109.04 222.154 109.151 222.5 107.206C222.724 105.943 222.726 104.449 222.504 103.406C222.188 101.917 222.138 102.197 222.134 105.486ZM132.057 106.486C132.026 107.294 133.519 112.427 133.569 111.686C133.584 111.466 133.257 110.026 132.842 108.486C132.427 106.946 132.073 106.046 132.057 106.486ZM266.593 107.264C266.442 108.067 266.409 108.813 266.519 108.923C266.629 109.033 266.842 108.467 266.993 107.664C267.143 106.861 267.177 106.114 267.067 106.004C266.957 105.894 266.743 106.461 266.593 107.264ZM181.406 107.644C180.105 108.211 178.009 111.02 178.024 112.177C178.029 112.567 178.365 112.166 178.771 111.286C180.616 107.288 183.473 106.59 187.225 109.222C188.995 110.462 189.152 110.522 188.045 109.534C185.444 107.212 183.601 106.688 181.406 107.644ZM265.815 110.286C265.665 110.759 265.632 111.236 265.742 111.346C265.852 111.456 266.065 111.159 266.215 110.686C266.365 110.213 266.398 109.736 266.288 109.626C266.178 109.516 265.965 109.813 265.815 110.286ZM221.444 110.915C221.296 111.501 221.266 112.07 221.376 112.18C221.486 112.29 221.696 111.901 221.844 111.315C221.991 110.728 222.021 110.159 221.911 110.049C221.801 109.939 221.591 110.328 221.444 110.915ZM190.409 111.468C190.956 111.888 191.483 112.152 191.58 112.055C191.806 111.828 190.344 110.713 189.815 110.708C189.595 110.706 189.862 111.047 190.409 111.468ZM133.627 112.686C133.627 113.016 133.802 113.556 134.015 113.886C134.36 114.419 134.403 114.419 134.403 113.886C134.403 113.556 134.228 113.016 134.015 112.686C133.67 112.153 133.627 112.153 133.627 112.686ZM192.815 112.852C193.365 113.146 194.265 113.498 194.815 113.635C195.365 113.772 195.095 113.538 194.215 113.115C192.405 112.244 191.283 112.034 192.815 112.852ZM264.987 112.929C264.851 113.345 264.553 114.187 264.324 114.799C264.095 115.411 264.001 116.006 264.116 116.121C264.231 116.235 264.615 115.479 264.969 114.44C265.323 113.401 265.527 112.465 265.423 112.361C265.319 112.257 265.123 112.512 264.987 112.929ZM178.061 115.194C177.918 117.387 184.48 123.516 186.933 123.479C187.198 123.475 186.444 122.936 185.257 122.282C181.261 120.079 178.933 117.729 178.306 115.264C178.136 114.597 178.101 114.587 178.061 115.194ZM135.243 116.778C135.197 117.251 136.501 120.334 136.673 120.161C136.76 120.074 136.481 119.211 136.052 118.244C135.623 117.277 135.259 116.617 135.243 116.778ZM216.25 119.704C214.95 120.904 214.05 121.879 214.25 121.87C214.451 121.862 215.605 120.873 216.815 119.674C219.647 116.866 219.306 116.885 216.25 119.704ZM212.015 122.686C211.245 123.108 210.885 123.456 211.215 123.46C211.545 123.465 212.265 123.116 212.815 122.686C214.072 121.703 213.811 121.703 212.015 122.686ZM163.015 123.886L138.215 124.095L163.091 124.191C179.348 124.253 188.053 124.147 188.215 123.886C188.351 123.666 188.317 123.529 188.139 123.581C187.961 123.634 176.655 123.771 163.015 123.886ZM210.358 123.989C210.525 124.156 221.991 124.246 235.838 124.189L261.015 124.086L235.535 123.886C221.521 123.776 210.191 123.822 210.358 123.989ZM324.115 228.185L364.415 228.29V259.507V290.724L322.515 290.605C292.101 290.519 280.341 290.36 279.615 290.028C279.065 289.776 277.805 289.343 276.815 289.067C272.088 287.746 265.778 283.461 262.548 279.375C259.694 275.766 259.488 275.554 260.287 277.051C262.648 281.477 270.339 287.27 276.913 289.575L280.615 290.874L322.717 290.997L364.82 291.12L364.717 259.603L364.615 228.086L324.215 228.083L283.815 228.08L324.115 228.185ZM280.615 228.483C280.395 228.556 279.699 228.731 279.068 228.87C276.797 229.374 278.276 229.386 281.015 228.887C282.839 228.554 283.327 228.371 282.415 228.362C281.645 228.355 280.835 228.409 280.615 228.483ZM272.686 231.261C268.441 233.41 264.779 236.309 262.133 239.619C260.127 242.129 257.01 247.414 257.341 247.745C257.441 247.845 257.969 247.063 258.515 246.007C259.06 244.95 259.834 243.456 260.234 242.686C262.363 238.59 270.347 232.224 275.815 230.262C276.915 229.867 277.45 229.531 277.004 229.515C276.559 229.499 274.616 230.285 272.686 231.261ZM256.644 249.315C256.496 249.901 256.466 250.47 256.576 250.58C256.686 250.69 256.896 250.301 257.044 249.715C257.191 249.128 257.221 248.559 257.111 248.449C257.001 248.339 256.791 248.728 256.644 249.315ZM255.075 257.386C254.941 258.871 254.977 261.076 255.155 262.286C255.426 264.134 255.483 263.703 255.509 259.586C255.545 254.049 255.429 253.46 255.075 257.386ZM256.443 268.962C256.533 270.001 257.159 270.882 257.187 270.01C257.202 269.528 257.035 269.022 256.815 268.886C256.595 268.75 256.428 268.784 256.443 268.962ZM257.215 271.332C257.215 271.731 259.332 275.502 259.476 275.359C259.548 275.286 259.143 274.295 258.575 273.157C257.627 271.253 257.215 270.701 257.215 271.332Z",
              fill: "#7C9CB8",
            }),
            (0, Qe.jsx)("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M193.524 22.5763C194.243 22.6653 195.323 22.6633 195.924 22.5723C196.525 22.4813 195.937 22.4082 194.617 22.4102C193.297 22.4122 192.805 22.4873 193.524 22.5763ZM203.317 22.5732C203.922 22.6642 204.912 22.6642 205.517 22.5732C206.122 22.4812 205.627 22.4062 204.417 22.4062C203.207 22.4062 202.712 22.4812 203.317 22.5732ZM198.11 56.2863C198.11 57.0563 198.192 57.3712 198.293 56.9862C198.393 56.6012 198.393 55.9713 198.293 55.5863C198.192 55.2013 198.11 55.5163 198.11 56.2863ZM204.017 56.2622C204.017 56.9092 204.159 57.5273 204.333 57.6343C204.507 57.7423 204.578 57.2132 204.49 56.4582C204.293 54.7772 204.017 54.6632 204.017 56.2622ZM198.816 75.7672C198.707 79.5522 198.757 82.5082 198.927 82.3372C199.098 82.1662 199.187 79.0692 199.126 75.4562L199.015 68.8862L198.816 75.7672ZM204.184 76.6863C204.184 80.9763 204.243 82.7312 204.315 80.5862C204.387 78.4412 204.387 74.9313 204.315 72.7863C204.243 70.6413 204.184 72.3963 204.184 76.6863ZM179.718 76.4862C179.722 77.3662 179.804 77.6792 179.9 77.1812C179.996 76.6842 179.992 75.9642 179.892 75.5812C179.792 75.1992 179.713 75.6062 179.718 76.4862ZM184.217 87.8862C185.076 88.7662 185.869 89.4863 185.979 89.4863C186.089 89.4863 185.476 88.7662 184.617 87.8862C183.758 87.0062 182.965 86.2863 182.855 86.2863C182.745 86.2863 183.358 87.0062 184.217 87.8862ZM198.016 104.967C197.907 110.071 197.956 114.109 198.125 113.939C198.294 113.769 198.384 109.593 198.324 104.658L198.216 95.6862L198.016 104.967ZM179.617 118.011C179.617 118.08 180.202 118.665 180.917 119.311L182.217 120.486L181.042 119.186C179.947 117.974 179.617 117.702 179.617 118.011ZM304.917 291.386C315.862 291.445 333.772 291.445 344.717 291.386C355.662 291.327 346.707 291.278 324.817 291.278C302.927 291.278 293.972 291.327 304.917 291.386Z",
              fill: "#6587A8",
            }),
            (0, Qe.jsx)("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M198.717 22.1671C199.212 22.2631 200.022 22.2631 200.517 22.1671C201.012 22.0721 200.607 21.9941 199.617 21.9941C198.627 21.9941 198.222 22.0721 198.717 22.1671ZM189.617 22.6801C189.208 22.9401 189.527 22.9841 190.617 22.8171C192.594 22.5141 192.931 22.2831 191.384 22.2911C190.742 22.2941 189.947 22.4691 189.617 22.6801ZM206.45 22.4301C206.542 22.5101 207.418 22.6771 208.396 22.8031C209.547 22.9501 209.971 22.9011 209.596 22.6641C209.062 22.3251 206.075 22.1041 206.45 22.4301ZM163.917 31.7141C162.422 32.5251 162.513 32.8631 164.017 32.0851C164.677 31.7441 165.217 31.3791 165.217 31.2751C165.217 31.0171 165.174 31.0321 163.917 31.7141ZM161.017 33.4851C160.357 33.9221 159.997 34.2771 160.217 34.2731C160.618 34.2671 162.793 32.7081 162.417 32.6971C162.307 32.6931 161.677 33.0481 161.017 33.4851ZM158.017 35.6851C157.272 36.2351 156.832 36.6791 157.039 36.6711C157.441 36.6551 159.972 34.6901 159.595 34.6871C159.472 34.6861 158.762 35.1351 158.017 35.6851ZM153.485 39.3311C152.642 40.1141 152.024 40.8251 152.111 40.9121C152.198 40.9991 152.969 40.3541 153.824 39.4781C155.751 37.5041 155.546 37.4151 153.485 39.3311ZM244.058 38.1281C244.08 38.3251 244.98 39.2751 246.058 40.2421C247.135 41.2081 247.999 41.8381 247.976 41.6421C247.954 41.4451 247.054 40.4951 245.976 39.5281C244.899 38.5621 244.035 37.9321 244.058 38.1281ZM251.417 45.4851C252.276 46.3651 253.069 47.0851 253.179 47.0851C253.289 47.0851 252.676 46.3651 251.817 45.4851C250.958 44.6051 250.165 43.8851 250.055 43.8851C249.945 43.8851 250.558 44.6051 251.417 45.4851ZM146.992 45.9851L145.817 47.2851L147.117 46.1101C147.832 45.4641 148.417 44.8791 148.417 44.8101C148.417 44.5011 148.087 44.7731 146.992 45.9851ZM198.684 54.1521C198.537 54.2981 198.414 55.0631 198.411 55.8521C198.404 57.4371 198.116 58.0511 197.217 58.3931C196.727 58.5801 196.741 58.6281 197.293 58.6531C197.665 58.6711 198.108 58.4611 198.278 58.1871C198.536 57.7681 199.199 53.8851 199.012 53.8851C198.978 53.8851 198.83 54.0051 198.684 54.1521ZM205.263 58.3221C205.782 58.6501 209.146 58.8571 208.784 58.5381C208.692 58.4571 207.738 58.2971 206.663 58.1811C205.468 58.0531 204.924 58.1071 205.263 58.3221ZM218.451 62.1321C218.982 62.8181 219.497 63.3081 219.596 63.2201C219.694 63.1321 219.26 62.5711 218.63 61.9731L217.486 60.8851L218.451 62.1321ZM184.272 64.6681C183.252 65.7581 182.417 66.7781 182.417 66.9351C182.417 67.0911 182.474 67.1431 182.544 67.0521C182.614 66.9601 183.539 65.9401 184.599 64.7851C185.659 63.6301 186.436 62.6851 186.326 62.6851C186.216 62.6851 185.292 63.5771 184.272 64.6681ZM220.11 65.4851C220.11 66.2551 220.192 66.5701 220.293 66.1851C220.393 65.8001 220.393 65.1701 220.293 64.7851C220.192 64.4001 220.11 64.7151 220.11 65.4851ZM196.817 68.4401C196.817 68.5251 197.347 68.6721 197.996 68.7671C198.644 68.8621 199.084 68.7931 198.972 68.6131C198.774 68.2921 196.817 68.1351 196.817 68.4401ZM217.617 70.3451C216.847 71.0201 216.579 71.3901 217.021 71.1661C217.752 70.7961 219.564 69.0631 219.179 69.1011C219.09 69.1101 218.387 69.6701 217.617 70.3451ZM180.195 72.8631C180.044 73.6661 180.011 74.4121 180.121 74.5221C180.231 74.6321 180.444 74.0661 180.595 73.2631C180.745 72.4601 180.779 71.7131 180.669 71.6031C180.559 71.4931 180.345 72.0601 180.195 72.8631ZM266.261 72.4851C266.59 73.9561 266.819 74.2751 266.811 73.2521C266.808 72.8301 266.622 72.2151 266.399 71.8851C266.102 71.4471 266.065 71.6091 266.261 72.4851ZM131.666 76.0851C131.633 76.5251 131.513 77.3351 131.4 77.8851L131.194 78.8851L131.623 77.9041C131.859 77.3641 131.978 76.5541 131.889 76.1041C131.73 75.3061 131.724 75.3061 131.666 76.0851ZM180.085 78.6851C180.105 79.7241 180.735 81.4311 180.749 80.4851C180.755 80.0451 180.606 79.3251 180.417 78.8851C180.206 78.3951 180.078 78.3171 180.085 78.6851ZM268.11 80.6851C268.11 81.4551 268.192 81.7701 268.293 81.3851C268.393 81.0001 268.393 80.3701 268.293 79.9851C268.192 79.6001 268.11 79.9151 268.11 80.6851ZM130.673 81.5691C130.538 82.0731 130.444 82.8451 130.463 83.2851C130.482 83.7251 130.662 83.3831 130.863 82.5251C131.253 80.8631 131.087 80.0251 130.673 81.5691ZM194.817 81.4491C195.367 81.8991 195.997 82.2681 196.217 82.2701C196.645 82.2731 195.922 81.7191 194.617 81.0451C194.086 80.7701 194.153 80.9061 194.817 81.4491ZM181.06 82.6801C181.338 83.6981 183.169 86.6851 183.516 86.6851C183.622 86.6851 183.383 86.1901 182.984 85.5851C182.585 84.9801 181.928 83.8551 181.523 83.0851C181.028 82.1421 180.877 82.0101 181.06 82.6801ZM197.079 82.7851C197.181 82.9501 197.603 83.0851 198.017 83.0851C198.431 83.0851 198.853 82.9501 198.955 82.7851C199.057 82.6201 198.635 82.4851 198.017 82.4851C197.399 82.4851 196.977 82.6201 197.079 82.7851ZM268.975 91.6851C268.975 94.7651 269.038 95.9721 269.114 94.3671C269.19 92.7631 269.19 90.2431 269.113 88.7671C269.036 87.2921 268.974 88.6051 268.975 91.6851ZM184.017 87.2101C184.017 87.2791 184.602 87.8641 185.317 88.5101L186.617 89.6851L185.442 88.3851C184.347 87.1731 184.017 86.9011 184.017 87.2101ZM130.148 91.6851C130.15 93.2251 130.222 93.8061 130.309 92.9761C130.396 92.1461 130.394 90.8861 130.306 90.1761C130.217 89.4661 130.146 90.1451 130.148 91.6851ZM217.414 93.0861C219.31 95.3031 219.337 95.3271 218.903 94.4851C218.676 94.0451 217.979 93.2361 217.354 92.6861L216.217 91.6881L217.414 93.0861ZM198.587 104.885C198.588 109.725 198.646 111.65 198.716 109.163C198.786 106.676 198.786 102.716 198.715 100.363C198.645 98.0101 198.587 100.045 198.587 104.885ZM203.484 97.7521C203.114 98.1221 203.146 114.285 203.517 114.285C203.682 114.286 203.765 110.596 203.701 106.085C203.577 97.3051 203.549 97.4161 205.637 98.4951C206.286 98.8311 206.817 99.0161 206.817 98.9061C206.817 98.2741 203.953 97.2831 203.484 97.7521ZM130.497 100.085C130.497 100.525 130.641 101.335 130.817 101.885C131.071 102.677 131.137 102.718 131.137 102.085C131.137 101.645 130.993 100.835 130.817 100.285C130.563 99.4931 130.497 99.4521 130.497 100.085ZM207.25 99.5851C207.342 99.6401 207.957 100.135 208.617 100.685L209.817 101.685L208.847 100.585C208.314 99.9801 207.699 99.4851 207.481 99.4851C207.262 99.4851 207.159 99.5301 207.25 99.5851ZM268.118 102.485C268.122 103.365 268.204 103.678 268.3 103.18C268.396 102.683 268.392 101.963 268.292 101.58C268.192 101.198 268.113 101.605 268.118 102.485ZM221.751 105.485C221.751 107.135 221.822 107.81 221.908 106.985C221.995 106.16 221.995 104.81 221.908 103.985C221.822 103.16 221.751 103.835 221.751 105.485ZM210.675 104.685C210.992 106.41 211.219 106.736 211.211 105.452C211.208 104.92 211.028 104.215 210.811 103.885C210.535 103.463 210.494 103.7 210.675 104.685ZM131.479 106.085C131.613 106.965 131.789 107.76 131.87 107.852C132.173 108.195 131.946 106.053 131.598 105.285C131.346 104.727 131.31 104.97 131.479 106.085ZM267.31 106.685C267.31 107.455 267.392 107.77 267.493 107.385C267.593 107 267.593 106.37 267.493 105.985C267.392 105.6 267.31 105.915 267.31 106.685ZM210.871 107.152C210.842 107.519 210.701 108.149 210.558 108.552C210.358 109.118 210.412 109.181 210.792 108.831C211.063 108.582 211.204 107.952 211.105 107.431C211.007 106.911 210.901 106.785 210.871 107.152ZM180.418 108.883C179.903 109.433 179.556 109.949 179.649 110.031C179.741 110.113 180.236 109.663 180.747 109.032C181.893 107.62 181.691 107.529 180.418 108.883ZM208.032 112.324C207.27 112.963 206.82 113.479 207.032 113.472C207.493 113.457 209.772 111.504 209.563 111.304C209.483 111.226 208.794 111.685 208.032 112.324ZM134.062 115.085C134.07 115.415 134.423 116.405 134.846 117.285C135.269 118.165 135.503 118.447 135.366 117.911C134.99 116.446 134.046 114.399 134.062 115.085ZM212.017 122.321C211.353 122.864 211.286 123 211.817 122.725C213.122 122.051 213.845 121.497 213.417 121.5C213.197 121.502 212.567 121.871 212.017 122.321ZM188.406 123.47C189.614 124.234 187.441 124.296 162.951 124.191C149.279 124.133 138.177 124.22 138.279 124.385C138.791 125.213 189.661 124.714 189.217 123.885C188.982 123.445 188.57 123.088 188.303 123.091C187.993 123.095 188.03 123.232 188.406 123.47ZM209.217 123.885C208.773 124.714 260.443 125.213 260.955 124.385C261.057 124.22 249.775 124.133 235.883 124.191C211.004 124.295 208.819 124.234 210.028 123.47C210.404 123.232 210.441 123.095 210.131 123.091C209.864 123.088 209.452 123.445 209.217 123.885ZM305.688 227.785C316.396 227.844 334.035 227.844 344.887 227.785C355.738 227.726 346.977 227.677 325.417 227.677C303.857 227.677 294.979 227.726 305.688 227.785ZM279.862 228.213C279.75 228.393 280.191 228.462 280.839 228.367C281.488 228.272 282.017 228.125 282.017 228.04C282.017 227.735 280.06 227.892 279.862 228.213ZM364.817 259.565C364.707 277.099 364.753 291.309 364.919 291.143C365.086 290.976 365.176 276.63 365.119 259.263L365.017 227.685L364.817 259.565ZM270.717 231.714C269.222 232.525 269.313 232.863 270.817 232.085C271.477 231.744 272.017 231.379 272.017 231.275C272.017 231.017 271.974 231.032 270.717 231.714ZM267.493 233.985C266.247 235.218 266.242 235.234 267.398 234.288C268.069 233.74 268.788 233.155 268.997 232.988C269.206 232.821 269.248 232.685 269.091 232.685C268.934 232.685 268.215 233.27 267.493 233.985ZM263.798 237.185L262.217 238.885L263.917 237.304C265.498 235.833 265.801 235.485 265.498 235.485C265.433 235.485 264.668 236.25 263.798 237.185ZM254.667 256.335C254.356 257.888 254.409 261.772 254.757 263.009C254.9 263.517 255.017 261.942 255.017 259.509C255.017 254.584 255.017 254.585 254.667 256.335ZM264 281.985C264.981 283.03 265.836 283.885 265.9 283.885C266.201 283.885 265.883 283.526 264.117 281.868L262.217 280.085L264 281.985ZM282.217 291.085C282.657 291.274 283.557 291.42 284.217 291.41L285.417 291.39L284.217 291.085C283.557 290.917 282.657 290.771 282.217 290.76L281.417 290.741L282.217 291.085Z",
              fill: "#507498",
            }),
          ],
        });
      },
      Rt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            id: "Web Automation",
            children: [
              (0, Qe.jsx)("path", {
                d: "M11.45 4H1.55C1.24624 4 1 4.24624 1 4.55V4.625V13.375V13.45C1 13.7538 1.24624 14 1.55 14H11.45C11.7538 14 12 13.7538 12 13.45V13.375V4.625V4.55C12 4.24624 11.7538 4 11.45 4Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M12 11H14.45V11C14.7538 11 15 10.7538 15 10.45V10.375V1.625V1.55C15 1.24624 14.7538 1 14.45 1V1H4.55V1C4.24624 1 4 1.24624 4 1.55V1.625V4",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M1 7H12",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      },
      Ht = function (e) {
        var n = e.color,
          t = void 0 === n ? "white" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "14",
          height: "14",
          viewBox: "0 0 14 14",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M6.45455 2.09082H2C1.44772 2.09082 1 2.53854 1 3.09082V11.9999C1 12.5522 1.44772 12.9999 2 12.9999H10.9091C11.4614 12.9999 11.9091 12.5522 11.9091 11.9999V7.54537",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M7.10353 6.01305C6.85945 6.25713 6.85945 6.65285 7.10353 6.89693C7.34761 7.14101 7.74334 7.14101 7.98741 6.89693L7.10353 6.01305ZM7.98741 6.89693L12.8965 1.98784L12.0126 1.10396L7.10353 6.01305L7.98741 6.89693Z",
                fill: t,
              }),
              (0, Qe.jsx)("path", {
                d: "M10.2727 1H13V3.18182V3.72727",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
            ],
          }),
        });
      },
      Vt = function () {
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("g", {
            children: (0, Qe.jsx)("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M3.71995 3.72015C3.86057 3.5797 4.0512 3.50081 4.24995 3.50081C4.4487 3.50081 4.63932 3.5797 4.77995 3.72015L7.99995 6.94015L11.22 3.72015C11.2887 3.64646 11.3715 3.58736 11.4635 3.54637C11.5555 3.50538 11.6547 3.48334 11.7555 3.48156C11.8562 3.47978 11.9562 3.49831 12.0496 3.53603C12.143 3.57375 12.2277 3.62989 12.299 3.70111C12.3702 3.77233 12.4264 3.85717 12.4641 3.95055C12.5017 4.04394 12.5204 4.14397 12.5186 4.24467C12.5168 4.34538 12.4948 4.44469 12.4538 4.53669C12.4128 4.62869 12.3537 4.71149 12.28 4.78015L9.05995 8.00015L12.28 11.2202C12.3537 11.2889 12.4128 11.3717 12.4538 11.4637C12.4948 11.5557 12.5168 11.655 12.5186 11.7557C12.5204 11.8564 12.5017 11.9564 12.4641 12.0498C12.4264 12.1432 12.3702 12.228 12.299 12.2992C12.2277 12.3705 12.143 12.4266 12.0496 12.4643C11.9562 12.502 11.8562 12.5206 11.7555 12.5188C11.6547 12.517 11.5555 12.495 11.4635 12.454C11.3715 12.413 11.2887 12.3539 11.22 12.2802L7.99995 9.06015L4.77995 12.2802C4.63777 12.4127 4.44972 12.4848 4.25542 12.4814C4.06112 12.4779 3.87574 12.3992 3.73832 12.2618C3.60091 12.1244 3.5222 11.939 3.51877 11.7447C3.51534 11.5504 3.58747 11.3624 3.71995 11.2202L6.93995 8.00015L3.71995 4.78015C3.5795 4.63953 3.50061 4.4489 3.50061 4.25015C3.50061 4.0514 3.5795 3.86078 3.71995 3.72015Z",
              fill: "#666666",
            }),
          }),
        });
      },
      Dt = function () {
        return (0, Qe.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("g", {
            children: (0, Qe.jsx)("path", {
              id: "Vector",
              d: "M2 9.33333H4C4.35362 9.33333 4.69276 9.47381 4.94281 9.72386C5.19286 9.97391 5.33333 10.313 5.33333 10.6667V12.6667C5.33333 13.0203 5.19286 13.3594 4.94281 13.6095C4.69276 13.8595 4.35362 14 4 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H12C11.6464 14 11.3072 13.8595 11.0572 13.6095C10.8071 13.3594 10.6667 13.0203 10.6667 12.6667V10.6667C10.6667 10.313 10.8071 9.97391 11.0572 9.72386C11.3072 9.47381 11.6464 9.33333 12 9.33333H14",
              stroke: "white",
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          }),
        });
      },
      Bt = function () {
        return (0, Qe.jsx)("svg", {
          "aria-label": "Open Navigation",
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            id: "icon",
            children: [
              (0, Qe.jsx)("path", {
                d: "M2.66675 8H13.3334",
                stroke: "#666666",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M2.66675 4H13.3334",
                stroke: "#666666",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M2.66675 12H13.3334",
                stroke: "#666666",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      },
      Wt = function () {
        return (0, Qe.jsxs)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "38",
          height: "32",
          viewBox: "0 0 38 32",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("g", {
              children: (0, Qe.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.3892 25.9278V28.7398C18.3892 29.4239 17.6194 29.8458 17.0049 29.4857L15.6631 28.6492L15.3405 28.4725C15.317 28.4596 13.4663 27.4208 9.40552 25.1415L9.08369 24.9623C8.74864 24.7746 8.47364 24.5058 8.28353 24.1814C8.09565 23.8595 7.99787 23.4944 8.00154 23.1322L8 16.1291V9.11486C8 8.72109 8.11455 8.33662 8.32746 8.00669C8.53845 7.67508 8.84397 7.40259 9.1571 7.25594L15.01 3.97229L15.3305 3.7902C15.4371 3.73089 15.4372 3.73085 15.6523 3.6119L15.6528 3.61163L21.2582 0.470067L21.5865 0.281263C21.9472 0.0795696 22.3554 -0.0164242 22.7693 0.00229618C23.1711 0.0212281 23.5672 0.149069 23.8394 0.337678L29.6724 3.60989L29.9957 3.78696L35.9267 7.11595L36.2507 7.29583C36.5856 7.48398 36.8599 7.75237 37.0499 8.07676C37.2373 8.39773 37.3351 8.76281 37.3319 9.12611L37.3332 15.503C37.3333 16.1799 36.5781 16.6029 35.9744 16.2641L33.4572 14.8516C33.1773 14.6945 33.0049 14.4045 33.0049 14.0907V10.3247L27.9449 7.48403C27.897 7.46099 27.7988 7.4066 27.517 7.24806L22.6663 4.52265L17.623 7.35003C17.5739 7.38139 17.5739 7.38141 17.5424 7.40085L17.5423 7.40086L17.5423 7.40088C17.5233 7.41224 17.1774 7.6071 17.1774 7.6071L12.3286 10.325V21.9333L17.3914 24.7751C17.4276 24.7927 17.4937 24.8294 17.8278 25.0167L17.9686 25.1381L18.0468 25.2394C18.2617 25.405 18.3892 25.6579 18.3892 25.9278ZM17.4688 25.9542L17.4603 25.9466C17.4626 25.9496 17.4654 25.9522 17.4688 25.9542ZM34.3678 17.9386C33.7641 17.601 33.0102 18.0239 33.0102 18.7002V19.2181L20.1801 12.0211L19.7433 11.7741C19.3072 11.5298 18.7691 11.5553 18.3631 11.8357L18.027 12.0192L16.1073 13.0918L15.333 13.5233C14.7134 13.8711 14.5195 14.6326 14.8812 15.2383L15.3214 15.9751L15.7654 16.7199C16.1245 17.321 16.9106 17.5086 17.5327 17.1553C18.2906 16.7307 18.3263 16.7107 18.36 16.6879C18.3631 16.6858 18.3661 16.6838 18.3696 16.6814L19.099 16.2747L20.5584 17.0934L20.5569 30.7609C20.5569 31.445 21.128 31.9997 21.8327 31.9997C22.1559 31.9997 22.4649 31.8813 22.7008 31.6692L22.7318 31.6449C24.1249 30.5529 24.127 30.5513 24.4197 30.3216C24.7515 30.062 24.9261 29.6606 24.8899 29.2505L24.8926 19.5263L34.0703 24.6908C34.7111 25.0491 35.4251 24.809 35.9026 24.2166L37.0807 23.0517C37.2462 22.8871 37.3385 22.6668 37.3385 22.4375V20.1075C37.3385 19.7932 37.1656 19.5028 36.885 19.3459L34.3678 17.9386Z",
                fill: "#333333",
              }),
            }),
            (0, Qe.jsx)("defs", {
              children: (0, Qe.jsx)("clipPath", {
                children: (0, Qe.jsx)("rect", {
                  width: "37.3385",
                  height: "31.9997",
                  fill: "white",
                }),
              }),
            }),
          ],
        });
      },
      zt = function () {
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("g", {
            children: (0, Qe.jsx)("path", {
              d: "M8 9.5C8.39782 9.5 8.77936 9.34196 9.06066 9.06066C9.34196 8.77936 9.5 8.39782 9.5 8C9.5 7.60218 9.34196 7.22064 9.06066 6.93934C8.77936 6.65804 8.39782 6.5 8 6.5C7.60218 6.5 7.22064 6.65804 6.93934 6.93934C6.65804 7.22064 6.5 7.60218 6.5 8C6.5 8.39782 6.65804 8.77936 6.93934 9.06066C7.22064 9.34196 7.60218 9.5 8 9.5ZM1.5 9.5C1.89782 9.5 2.27936 9.34196 2.56066 9.06066C2.84196 8.77936 3 8.39782 3 8C3 7.60218 2.84196 7.22064 2.56066 6.93934C2.27936 6.65804 1.89782 6.5 1.5 6.5C1.10218 6.5 0.720644 6.65804 0.43934 6.93934C0.158035 7.22064 0 7.60218 0 8C0 8.39782 0.158035 8.77936 0.43934 9.06066C0.720644 9.34196 1.10218 9.5 1.5 9.5ZM14.5 9.5C14.8978 9.5 15.2794 9.34196 15.5607 9.06066C15.842 8.77936 16 8.39782 16 8C16 7.60218 15.842 7.22064 15.5607 6.93934C15.2794 6.65804 14.8978 6.5 14.5 6.5C14.1022 6.5 13.7206 6.65804 13.4393 6.93934C13.158 7.22064 13 7.60218 13 8C13 8.39782 13.158 8.77936 13.4393 9.06066C13.7206 9.34196 14.1022 9.5 14.5 9.5Z",
              fill: "#666666",
            }),
          }),
        });
      },
      Zt = function () {
        return (0, Qe.jsx)("svg", {
          role: "img",
          "aria-hidden": !0,
          width: "112",
          height: "12",
          viewBox: "0 0 112 12",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.21555 11.6786C1.1066 11.6786 1.01121 11.638 0.929382 11.557C0.847788 11.4758 0.806641 11.3812 0.806641 11.2731V0.72752C0.806641 0.608744 0.847788 0.51131 0.929382 0.435683C1.01121 0.359824 1.1066 0.32201 1.21555 0.32201H3.50462C3.62455 0.32201 3.72251 0.359824 3.79896 0.435683C3.87518 0.51131 3.91329 0.608744 3.91329 0.72752V9.13164H8.81851C8.93821 9.13164 9.03921 9.172 9.1208 9.2532C9.20263 9.33439 9.24355 9.43438 9.24355 9.55339V11.2731C9.24355 11.3921 9.20263 11.4895 9.1208 11.5652C9.03921 11.6408 8.93821 11.6786 8.81851 11.6786H1.21555ZM9.97997 11.6786C9.89277 11.6786 9.81351 11.6436 9.7429 11.573C9.67183 11.5028 9.63653 11.4243 9.63653 11.3378C9.63653 11.2731 9.64214 11.2244 9.65289 11.1919L13.4626 0.792476C13.5715 0.478832 13.7894 0.32201 14.1165 0.32201H16.6672C16.994 0.32201 17.2121 0.478832 17.3211 0.792476L21.1308 11.1919C21.1417 11.2244 21.1471 11.2731 21.1471 11.3378C21.1471 11.4243 21.1116 11.5028 21.0407 11.573C20.9699 11.6436 20.8909 11.6786 20.8037 11.6786H18.678C18.4166 11.6786 18.2312 11.5596 18.1223 11.3216L17.5336 9.74802H13.25L12.6613 11.3216C12.5524 11.5596 12.367 11.6786 12.1054 11.6786H9.97997ZM13.9393 7.31456H16.8496L15.3944 3.17734L13.9393 7.31456ZM22.817 11.6786C22.697 11.6786 22.5963 11.6408 22.5145 11.5652C22.4329 11.4895 22.3919 11.3921 22.3919 11.2731V0.743759C22.3919 0.624983 22.4329 0.524765 22.5145 0.443802C22.5963 0.362608 22.697 0.32201 22.817 0.32201H24.6647C24.937 0.32201 25.1334 0.441019 25.2531 0.678803L28.0654 5.67576L30.8941 0.678803C31.0138 0.441019 31.2102 0.32201 31.4825 0.32201H33.3302C33.4501 0.32201 33.5509 0.362608 33.6327 0.443802C33.7143 0.524765 33.7552 0.624983 33.7552 0.743759V11.2731C33.7552 11.3921 33.7143 11.4895 33.6327 11.5652C33.5509 11.6408 33.4501 11.6786 33.3302 11.6786H31.2537C31.1447 11.6786 31.0493 11.638 30.9675 11.557C30.8859 11.4758 30.845 11.3812 30.845 11.2731V5.36745L29.0791 8.57998C28.9375 8.82867 28.7467 8.95301 28.5068 8.95301H27.624C27.4059 8.95301 27.2151 8.82867 27.0517 8.57998L25.3022 5.36745V11.2731C25.3022 11.3921 25.2613 11.4895 25.1797 11.5652C25.0979 11.6408 24.9971 11.6786 24.8772 11.6786H22.817ZM36.3819 11.6786C36.273 11.6786 36.1776 11.638 36.096 11.557C36.0142 11.4758 35.9733 11.3812 35.9733 11.2731V0.743759C35.9733 0.624983 36.0114 0.524765 36.0876 0.443802C36.164 0.362608 36.2622 0.32201 36.3819 0.32201H41.4342C42.8185 0.32201 43.8486 0.603176 44.5245 1.16574C45.2001 1.72807 45.5382 2.52842 45.5382 3.56678C45.5382 4.08597 45.3991 4.53486 45.1214 4.91322C44.8434 5.29182 44.5352 5.56765 44.1974 5.74071C44.6444 5.93535 45.0204 6.25711 45.3257 6.706C45.6308 7.15489 45.7835 7.66062 45.7835 8.22295C45.7835 9.31514 45.4208 10.1644 44.6961 10.7701C43.9713 11.3756 42.933 11.6786 41.5813 11.6786H36.3819ZM41.0961 4.81564C41.4994 4.81564 41.8101 4.70754 42.0282 4.49109C42.2461 4.27465 42.3553 3.99372 42.3553 3.6476C42.3553 3.31215 42.2489 3.0391 42.0364 2.82823C41.8239 2.61712 41.5104 2.5118 41.0961 2.5118H39.0525V4.81564H41.0961ZM41.2434 9.48828C41.6684 9.48828 41.9983 9.36648 42.2326 9.12313C42.4668 8.88001 42.5842 8.57982 42.5842 8.2228C42.5842 7.8551 42.4642 7.54958 42.2244 7.30599C41.9845 7.06287 41.6577 6.94108 41.2434 6.94108H39.0525V9.48828H41.2434ZM47.9446 11.6786C47.8354 11.6786 47.7403 11.638 47.6585 11.557C47.5766 11.4758 47.5357 11.3812 47.5357 11.2731V0.743759C47.5357 0.624983 47.5741 0.524765 47.6503 0.443802C47.7265 0.362608 47.8247 0.32201 47.9446 0.32201H52.2448C53.858 0.32201 55.1113 0.703161 56.0054 1.46593C56.8989 2.22823 57.3679 3.32343 57.4112 4.75107C57.4221 5.06471 57.4278 5.48112 57.4278 6.00031C57.4278 6.51949 57.4221 6.93033 57.4112 7.23331C57.3022 10.1967 55.6072 11.6786 52.3264 11.6786H47.9446ZM52.2399 9.24486C52.9263 9.24486 53.4332 9.0827 53.7605 8.75815C54.0873 8.43384 54.2618 7.91442 54.2835 7.20061C54.3055 6.88696 54.3162 6.48145 54.3162 5.98385C54.3162 5.48624 54.3055 5.08606 54.2835 4.78332C54.2618 4.09108 54.0736 3.58002 53.7196 3.25014C53.3652 2.92025 52.845 2.75531 52.1581 2.75531H50.6048V9.24486H52.2399ZM58.6565 11.6786C58.5693 11.6786 58.4903 11.6436 58.4194 11.573C58.3484 11.5028 58.3131 11.4243 58.3131 11.3378C58.3131 11.2731 58.3184 11.2244 58.3294 11.1919L62.1389 0.792476C62.2481 0.478832 62.4662 0.32201 62.793 0.32201H65.3437C65.6708 0.32201 65.8887 0.478832 65.9976 0.792476L69.8073 11.1919C69.8183 11.2244 69.8234 11.2731 69.8234 11.3378C69.8234 11.4243 69.7881 11.5028 69.7173 11.573C69.6467 11.6436 69.5677 11.6786 69.4802 11.6786H67.3548C67.0932 11.6786 66.9078 11.5596 66.7988 11.3216L66.2101 9.74802H61.9263L61.3377 11.3216C61.2289 11.5596 61.0438 11.6786 60.7822 11.6786H58.6565ZM62.6057 7.31456H65.5159L64.0608 3.17734L62.6057 7.31456ZM74.001 11.6786C73.8811 11.6786 73.7806 11.6408 73.6985 11.5652C73.6167 11.4895 73.576 11.3921 73.576 11.2731V2.96641H70.6985C70.5785 2.96641 70.4778 2.92859 70.3959 2.85297C70.3141 2.77711 70.2732 2.67991 70.2732 2.5609V0.743759C70.2732 0.624983 70.3141 0.524765 70.3959 0.443802C70.4778 0.362608 70.5785 0.32201 70.6985 0.32201H79.5765C79.6962 0.32201 79.7972 0.362608 79.8791 0.443802C79.9607 0.524765 80.0016 0.624983 80.0016 0.743759V2.5609C80.0016 2.67991 79.9607 2.77711 79.8791 2.85297C79.7972 2.92859 79.6962 2.96641 79.5765 2.96641H76.6988V11.2731C76.6988 11.3921 76.6579 11.4895 76.5763 11.5652C76.4944 11.6408 76.3937 11.6786 76.274 11.6786H74.001ZM81.8569 11.6786C81.7482 11.6786 81.6525 11.638 81.5709 11.557C81.4891 11.4758 81.4482 11.3812 81.4482 11.2731V0.743759C81.4482 0.624983 81.4863 0.524765 81.5628 0.443802C81.6392 0.362608 81.7372 0.32201 81.8569 0.32201H89.5742C89.6941 0.32201 89.7949 0.362608 89.8767 0.443802C89.9585 0.524765 89.9994 0.624983 89.9994 0.743759V2.35002C89.9994 2.46903 89.9585 2.56623 89.8767 2.64186C89.7949 2.71772 89.6941 2.75553 89.5742 2.75553H84.4078V4.81602H89.2146C89.3345 4.81602 89.4351 4.85662 89.5171 4.93758C89.5989 5.01878 89.6396 5.11876 89.6396 5.23777V6.71412C89.6396 6.83313 89.5989 6.93312 89.5171 7.01431C89.4351 7.09527 89.3345 7.1361 89.2146 7.1361H84.4078V9.24508H89.7051C89.8248 9.24508 89.9258 9.28568 90.0076 9.36664C90.0892 9.44783 90.1301 9.54782 90.1301 9.66683V11.2731C90.1301 11.3921 90.0892 11.4895 90.0076 11.5652C89.9258 11.6408 89.8248 11.6786 89.7051 11.6786H81.8569ZM96.2741 11.8406C95.2171 11.8406 94.3177 11.6893 93.5764 11.3863C92.8352 11.0836 92.2739 10.6834 91.8923 10.1856C91.5108 9.68845 91.3093 9.14746 91.2875 8.56332C91.2875 8.46612 91.3228 8.38493 91.3937 8.31997C91.4645 8.25525 91.5489 8.22277 91.6471 8.22277H93.8216C93.9523 8.22277 94.0587 8.24434 94.1405 8.28772C94.2223 8.33087 94.3121 8.4065 94.4103 8.51461C94.552 8.7742 94.7727 8.98785 95.0724 9.15558C95.3724 9.3233 95.7726 9.40705 96.2741 9.40705C96.863 9.40705 97.3152 9.31774 97.6313 9.13957C97.9473 8.96094 98.1054 8.71504 98.1054 8.40116C98.1054 8.17428 98.0236 7.98753 97.8601 7.84162C97.6967 7.69547 97.4351 7.56555 97.0755 7.45211C96.7157 7.33867 96.1979 7.21155 95.522 7.07096C94.2034 6.81137 93.2168 6.41653 92.5626 5.88645C91.9087 5.35659 91.5819 4.5994 91.5819 3.61532C91.5819 2.94465 91.7696 2.34705 92.1458 1.82254C92.5217 1.29779 93.0559 0.889724 93.748 0.597655C94.4402 0.305586 95.2442 0.159668 96.1598 0.159668C97.1188 0.159668 97.9502 0.324609 98.6532 0.65426C99.3562 0.984374 99.8958 1.39522 100.272 1.88726C100.648 2.37953 100.847 2.86345 100.869 3.33949C100.869 3.43669 100.836 3.52067 100.77 3.59096C100.705 3.66125 100.623 3.69628 100.525 3.69628H98.2363C97.9964 3.69628 97.8111 3.59908 97.6804 3.40421C97.6147 3.1771 97.4461 2.98524 97.1735 2.82842C96.9011 2.6716 96.5631 2.59319 96.1598 2.59319C95.702 2.59319 95.3476 2.67438 95.0969 2.83654C94.8463 2.9987 94.7208 3.23672 94.7208 3.55036C94.7208 3.864 94.8847 4.11014 95.2115 4.28854C95.5386 4.46716 96.149 4.64811 97.0426 4.83208C98.0673 5.01581 98.8821 5.24571 99.4869 5.52154C100.092 5.79713 100.539 6.15439 100.828 6.59215C101.117 7.03037 101.261 7.58481 101.261 8.25525C101.261 8.99064 101.048 9.62883 100.623 10.1696C100.198 10.7103 99.6096 11.124 98.8575 11.4107C98.1054 11.6974 97.2441 11.8406 96.2741 11.8406ZM105.772 11.6786C105.652 11.6786 105.551 11.6408 105.47 11.5652C105.388 11.4895 105.347 11.3921 105.347 11.2731V2.96641H102.47C102.349 2.96641 102.249 2.92859 102.167 2.85297C102.085 2.77711 102.044 2.67991 102.044 2.5609V0.743759C102.044 0.624983 102.085 0.524765 102.167 0.443802C102.249 0.362608 102.349 0.32201 102.47 0.32201H111.347C111.467 0.32201 111.568 0.362608 111.65 0.443802C111.732 0.524765 111.773 0.624983 111.773 0.743759V2.5609C111.773 2.67991 111.732 2.77711 111.65 2.85297C111.568 2.92859 111.467 2.96641 111.347 2.96641H108.47V11.2731C108.47 11.3921 108.429 11.4895 108.347 11.5652C108.265 11.6408 108.165 11.6786 108.045 11.6786H105.772Z",
            fill: "#333333",
          }),
        });
      },
      Ft = function () {
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          xmlns: "http://www.w3.org/2000/svg",
          width: "21",
          height: "24",
          viewBox: "0 0 21 24",
          fill: "none",
          children: (0, Qe.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.36806 19.0408V21.0351C7.36806 21.5203 6.82206 21.8195 6.38626 21.5641L5.43468 20.9709L5.20589 20.8456C5.18924 20.8364 3.87671 20.0997 0.996801 18.4832L0.768558 18.3562C0.530936 18.223 0.335906 18.0324 0.201083 17.8023C0.0678324 17.5741 -0.00151093 17.3151 0.00109508 17.0582L0 12.0916V7.11711C0 6.83785 0.0812403 6.56518 0.232238 6.33119C0.381869 6.09601 0.598542 5.90276 0.820616 5.79876L4.97153 3.46998L5.19879 3.34085C5.27438 3.2988 5.27446 3.29876 5.42688 3.21447L5.42737 3.2142L9.40274 0.986205L9.63559 0.852304C9.89138 0.709263 10.1809 0.641184 10.4744 0.65446C10.7594 0.667887 11.0403 0.758552 11.2334 0.892314L15.3701 3.21298L15.5994 3.33855L19.8057 5.69947L20.0354 5.82705C20.2729 5.96049 20.4675 6.15083 20.6022 6.38089C20.7352 6.60852 20.8045 6.86744 20.8023 7.12509L20.8031 11.6476C20.8032 12.1277 20.2677 12.4276 19.8395 12.1873L18.0543 11.1856C17.8558 11.0742 17.7335 10.8686 17.7335 10.646V7.9751L14.145 5.96052C14.111 5.94418 14.0414 5.90561 13.8415 5.79317L10.4013 3.8603L6.82463 5.86549L6.82457 5.86553L6.82455 5.86554C6.7898 5.88774 6.78978 5.88775 6.76741 5.90155C6.75393 5.90961 6.50861 6.0478 6.50861 6.0478L3.06984 7.97534V16.2079L6.6604 18.2234C6.68607 18.2359 6.73294 18.2619 6.96988 18.3947L7.06979 18.4808L7.1252 18.5527C7.27759 18.6701 7.36806 18.8494 7.36806 19.0408ZM6.71511 19.0592L6.70908 19.0538C6.71071 19.0559 6.71274 19.0578 6.71511 19.0592ZM18.7 13.3751C18.2718 13.1357 17.7372 13.4356 17.7372 13.9152V14.2825L8.63799 9.17841L8.32825 9.00325C8.01895 8.82995 7.63732 8.84807 7.34939 9.04694L7.111 9.17709L5.74955 9.93778L5.20047 10.2438C4.76099 10.4905 4.62353 11.0305 4.88005 11.4601L5.19219 11.9826L5.50713 12.5108C5.76179 12.9371 6.31925 13.0701 6.76045 12.8196C7.29794 12.5184 7.32327 12.5043 7.34721 12.4881C7.34936 12.4867 7.3515 12.4852 7.35401 12.4835L7.8713 12.195L8.90628 12.7757L8.90523 22.4687C8.90523 22.9539 9.31029 23.3473 9.81005 23.3473C10.0393 23.3473 10.2584 23.2633 10.4257 23.1129L10.4379 23.1033C11.4356 22.3212 11.4365 22.3206 11.6447 22.1572C11.8801 21.9731 12.0039 21.6884 11.9782 21.3975L11.9801 14.5011L18.4889 18.1638C18.9434 18.4179 19.4498 18.2476 19.7884 17.8275L20.624 17.0013C20.7413 16.8846 20.8068 16.7284 20.8068 16.5658V14.9133C20.8068 14.6904 20.6841 14.4845 20.4851 14.3732L18.7 13.3751Z",
            fill: "#333333",
          }),
        });
      },
      Ut = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          "aria-hidden": !0,
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("path", {
              d: "M13.3333 5.33334H2.66667C2.29848 5.33334 2 5.63182 2 6.00001V7.33334C2 7.70153 2.29848 8.00001 2.66667 8.00001H13.3333C13.7015 8.00001 14 7.70153 14 7.33334V6.00001C14 5.63182 13.7015 5.33334 13.3333 5.33334Z",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M8 5.33334V14",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M12.6667 8V12.6667C12.6667 13.0203 12.5262 13.3594 12.2762 13.6095C12.0261 13.8595 11.687 14 11.3334 14H4.66671C4.31309 14 3.97395 13.8595 3.7239 13.6095C3.47385 13.3594 3.33337 13.0203 3.33337 12.6667V8",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M5.00004 5.33332C4.55801 5.33332 4.13409 5.15773 3.82153 4.84516C3.50897 4.5326 3.33337 4.10868 3.33337 3.66665C3.33337 3.22463 3.50897 2.8007 3.82153 2.48814C4.13409 2.17558 4.55801 1.99999 5.00004 1.99999C5.64316 1.98878 6.27339 2.30083 6.80853 2.89543C7.34367 3.49003 7.75889 4.33959 8.00004 5.33332C8.24119 4.33959 8.65641 3.49003 9.19155 2.89543C9.72669 2.30083 10.3569 1.98878 11 1.99999C11.4421 1.99999 11.866 2.17558 12.1786 2.48814C12.4911 2.8007 12.6667 3.22463 12.6667 3.66665C12.6667 4.10868 12.4911 4.5326 12.1786 4.84516C11.866 5.15773 11.4421 5.33332 11 5.33332",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      Kt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#176F2C" : n;
        return (0, Qe.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          role: "img",
          "aria-label": "Success Icon",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("g", {
            children: (0, Qe.jsx)("path", {
              d: "M13.7613 4.21934C13.9017 4.35997 13.9806 4.55059 13.9806 4.74934C13.9806 4.94809 13.9017 5.13871 13.7613 5.27934L6.51127 12.5293C6.37064 12.6698 6.18002 12.7487 5.98127 12.7487C5.78252 12.7487 5.59189 12.6698 5.45127 12.5293L2.20127 9.27934C2.06886 9.13708 1.99676 8.94903 2.00011 8.75471C2.00347 8.56039 2.08202 8.37494 2.21927 8.23734C2.35687 8.1001 2.54232 8.02154 2.73664 8.01818C2.93095 8.01483 3.11901 8.08693 3.26127 8.21934L5.98127 10.9393L12.7013 4.21934C12.8419 4.07889 13.0325 4 13.2313 4C13.43 4 13.6206 4.07889 13.7613 4.21934Z",
              fill: t,
            }),
          }),
        });
      },
      Gt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            id: "Smart UI",
            children: [
              (0, Qe.jsx)("path", {
                d: "M10 2.01074H14C14.5523 2.01074 15 2.45846 15 3.01074V13.1407C15 13.693 14.5523 14.1407 14 14.1407H10",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M6.25 14.1406H2.00032C1.44803 14.1406 1.00032 13.6929 1.00032 13.1406V3.01066C1.00032 2.45838 1.44803 2.01066 2.00032 2.01066H6.25",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M8 1L8 15",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                id: "Rectangle 2088",
                d: "M6.25 12.75C6.25 12.8881 6.13807 13 6 13L2.85355 13C2.63083 13 2.51929 12.7307 2.67678 12.5732L4.75 10.5L5.82322 9.42678C5.98071 9.26929 6.25 9.38083 6.25 9.60355L6.25 12.75Z",
                fill: t,
              }),
            ],
          }),
        });
      },
      Yt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsx)("path", {
            d: "M1 3.92105C1 4.74321 1 6.02632 1 6.02632M15 3.92105V6.02632M12.7757 14.5V11.8421C12.7757 11.566 12.5518 11.3421 12.2757 11.3421H3.85514C3.579 11.3421 3.35514 11.566 3.35514 11.8421V14.5M5.97196 4.44737V6.02632M10.1589 4.44737V6.02632M3.85514 1.5H12.2757C12.5518 1.5 12.7757 1.72386 12.7757 2V8.52611C12.7757 8.80225 12.5518 9.02611 12.2757 9.02611H3.85514C3.579 9.02611 3.35514 8.80225 3.35514 8.52611V2C3.35514 1.72386 3.579 1.5 3.85514 1.5Z",
            stroke: t,
            strokeWidth: "1.25",
            strokeLinecap: "round",
          }),
        });
      },
      $t = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          width: "12",
          height: "16",
          viewBox: "0 0 12 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M1 1H11V15H1V1Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.22222 5L4 7.4H6L5.77778 9L8 6.6H6L6.22222 5Z",
                fill: t,
                stroke: t,
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M5 12H7.5",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
            ],
          }),
        });
      },
      qt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M2.4 3.8C1.525 4.969 1 6.425 1 8C1 11.864 4.136 15 8 15C11.864 15 15 11.864 15 8C15 4.136 11.864 1 8 1C6.999 1 6.04 1.21 5.179 1.595",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M7.41699 4.5V8L10.917 10.9167",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "square",
              }),
            ],
          }),
        });
      },
      Qt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            (0, Qe.jsx)("path", {
              d: "M8.00098 1.58203V2.74865",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M1.58301 8H1.87463H2.74962",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M14.4172 8.625H15.0422V7.375H14.4172V8.625ZM13.251 7.375C12.9058 7.375 12.626 7.65482 12.626 8C12.626 8.34518 12.9058 8.625 13.251 8.625V7.375ZM14.4172 7.375H13.251V8.625H14.4172V7.375Z",
              fill: t,
            }),
            (0, Qe.jsx)("path", {
              d: "M3.33398 3.91602L3.91727 4.4993",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M12.6674 3.91602L12.084 4.4993",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M4.5 15L11.5005 15",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M13.2167 12.6666C15.7273 9.86059 15.5685 5.57128 12.8573 2.95855C10.1461 0.345847 5.85389 0.345847 3.14267 2.95855C0.431463 5.57128 0.272706 9.86059 2.78335 12.6666",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
            }),
            (0, Qe.jsx)("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9.21444 9.90401L10.3337 6.24902L7.26445 7.95402C6.37445 8.37068 6.07112 9.53068 6.70778 10.2873C6.73612 10.319 6.76445 10.3507 6.79445 10.3807C6.82445 10.4107 6.85611 10.439 6.88778 10.4673C7.63778 11.0973 8.79777 10.794 9.21444 9.90401Z",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      Xt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": "true",
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M13.4 15H2.6C2.59475 15 2.5892 15 2.58337 15C2.26121 15 2 14.7388 2 14.4167V14.4167V1.58333V1.58333C2 1.26117 2.26121 1 2.58337 1C2.5892 1 2.59475 1 2.6 1H10.197C10.3272 1 10.4522 1.05076 10.5455 1.1415L13.6971 4.20549C13.8907 4.39377 14 4.65239 14 4.92249V14.4167V14.4167C14 14.7388 13.7388 15 13.4166 15C13.4108 15 13.4052 15 13.4 15Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M5 7L6.86667 9L5 11M7.48889 11H11.2222",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M9.5 2V5C9.5 5.27614 9.72386 5.5 10 5.5H13",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "square",
              }),
            ],
          }),
        });
      },
      Jt = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": "true",
          role: "img",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: (0, Qe.jsxs)("g", {
            children: [
              (0, Qe.jsx)("path", {
                d: "M13.4 15H2.6C2.59475 15 2.5892 15 2.58337 15C2.26121 15 2 14.7388 2 14.4167V14.4167V1.58333V1.58333C2 1.26117 2.26121 1 2.58337 1C2.5892 1 2.59475 1 2.6 1H10.197C10.3272 1 10.4522 1.05076 10.5455 1.1415L13.6971 4.20549C13.8907 4.39377 14 4.65239 14 4.92249V14.4167V14.4167C14 14.7388 13.7388 15 13.4166 15C13.4108 15 13.4052 15 13.4 15Z",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M9.5 2V5C9.5 5.27614 9.72386 5.5 10 5.5H13",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "square",
              }),
              (0, Qe.jsx)("path", {
                d: "M5 9H11",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
              (0, Qe.jsx)("path", {
                d: "M5 12H11",
                stroke: t,
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            ],
          }),
        });
      },
      er = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          role: "img",
          "aria-hidden": !0,
          children: [
            (0, Qe.jsx)("path", {
              d: "M3 2C3 1.44772 3.44772 1 4 1H12C12.5523 1 13 1.44772 13 2V14C13 14.5523 12.5523 15 12 15H4C3.44772 15 3 14.5523 3 14V2Z",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M8 10.625C9.44975 10.625 10.625 9.44975 10.625 8C10.625 6.55025 9.44975 5.375 8 5.375C6.55025 5.375 5.375 6.55025 5.375 8C5.375 9.44975 6.55025 10.625 8 10.625Z",
              stroke: t,
              strokeWidth: "0.5",
              "stroke-miterlimit": "10",
            }),
            (0, Qe.jsx)("path", {
              d: "M5.52539 7.125H10.4746",
              stroke: t,
              strokeWidth: "0.5",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M5.52539 8.875H10.4746",
              stroke: t,
              strokeWidth: "0.5",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M8 10.554C8.60406 10.554 9.09375 9.41056 9.09375 8.00007C9.09375 6.58959 8.60406 5.44617 8 5.44617C7.39594 5.44617 6.90625 6.58959 6.90625 8.00007C6.90625 9.41056 7.39594 10.554 8 10.554Z",
              stroke: t,
              strokeWidth: "0.5",
              strokeMiterlimit: "10",
            }),
          ],
        });
      },
      nr = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          "aria-hidden": !0,
          role: "img",
          children: [
            (0, Qe.jsx)("path", {
              d: "M3 2C3 1.44772 3.44772 1 4 1H12C12.5523 1 13 1.44772 13 2V14C13 14.5523 12.5523 15 12 15H4C3.44772 15 3 14.5523 3 14V2Z",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M6 7.5L7.57737 8.8347C7.68451 8.92536 7.84529 8.91007 7.93342 8.80083L11 5",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M6 12H10",
              stroke: t,
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      tr = function (e) {
        var n = e.color,
          t = void 0 === n ? "#80858F" : n;
        return (0, Qe.jsxs)("svg", {
          role: "img",
          "aria-hidden": !0,
          xmlns: "http://www.w3.org/2000/svg",
          xmlnsXlink: "http://www.w3.org/1999/xlink",
          width: "17px",
          height: "16px",
          viewBox: "0 0 17 16",
          version: "1.1",
          children: [
            (0, Qe.jsx)("defs", {
              children: (0, Qe.jsx)("polygon", {
                points:
                  "-7.02996689e-16 0 17.2464743 0 17.2464743 15.5795 -7.02996689e-16 15.5795",
              }),
            }),
            (0, Qe.jsxs)("g", {
              stroke: "none",
              "stroke-width": "1",
              fill: "none",
              "fill-rule": "evenodd",
              children: [
                (0, Qe.jsxs)("g", {
                  transform: "translate(0.000526, -0.000200)",
                  children: [
                    (0, Qe.jsx)("mask", {
                      fill: "white",
                      children: (0, Qe.jsx)("use", { xlinkHref: "#path-1" }),
                    }),
                    (0, Qe.jsx)("g", {}),
                    (0, Qe.jsx)("path", {
                      d: "M14.5982743,10.6895 C14.2282743,11.4295 13.7182743,11.8795 13.0582743,12.0695 C12.1882743,12.3195 11.3182743,12.1995 10.4582743,11.7095 C10.2382743,11.5795 10.0282743,11.4395 9.80827428,11.2895 C9.65827428,11.1895 9.51827428,11.0895 9.37827428,10.9995 C9.13827428,10.8395 8.87827428,10.7595 8.61827428,10.7495 L8.59827428,10.7495 C8.33827428,10.7595 8.08827428,10.8395 7.83827428,10.9995 C7.69827428,11.0895 7.55827428,11.1795 7.37827428,11.2995 C7.17827428,11.4395 6.97827428,11.5895 6.75827428,11.7095 C5.89827428,12.1995 5.02827428,12.3195 4.15827428,12.0695 C3.49827428,11.8795 2.98827428,11.4295 2.61827428,10.6895 C2.11827428,9.6995 2.07827428,7.4795 2.52827428,6.3695 C2.97827428,5.2595 4.34827428,4.8695 5.12827428,4.7295 C6.06827428,4.5695 7.08827428,4.4895 8.35827428,4.4895 L8.85827428,4.4895 C10.1282743,4.4895 11.1582743,4.5695 12.0882743,4.7295 C12.8682743,4.8695 14.2382743,5.2595 14.6882743,6.3695 C15.1482743,7.4795 15.0982743,9.6995 14.5982743,10.6895 M10.0982743,14.1695 C9.87827428,14.2795 9.62827428,14.3295 9.36827428,14.3295 L7.86827428,14.3295 C7.60827428,14.3295 7.35827428,14.2695 7.13827428,14.1695 C6.59827428,13.8995 6.10827428,13.6395 5.67827428,13.3995 C6.24827428,13.3195 6.81827428,13.1095 7.37827428,12.7995 C7.62827428,12.6495 7.85827428,12.4895 8.11827428,12.3095 C8.25827428,12.2195 8.37827428,12.1295 8.50827428,12.0495 C8.56827428,12.0195 8.59827428,12.0095 8.60827428,12.0095 C8.62827428,12.0095 8.66827428,12.0195 8.70827428,12.0495 C8.83827428,12.1295 8.96827428,12.2195 9.10827428,12.3195 C9.34827428,12.4895 9.58827428,12.6495 9.83827428,12.7995 C10.4082743,13.1195 10.9782743,13.3195 11.5682743,13.3995 C11.1282743,13.6495 10.6382743,13.8995 10.0982743,14.1695 M3.00827428,3.1195 C3.34827428,2.2195 3.90827428,1.6395 4.65827428,1.3795 L4.65827428,1.7395 C4.65827428,2.0495 4.77827428,2.3395 4.99827428,2.5595 C5.20827428,2.7795 5.49827428,2.8995 5.80827428,2.8995 L11.4282743,2.8995 C11.7382743,2.8995 12.0282743,2.7795 12.2482743,2.5595 C12.4682743,2.3395 12.5882743,2.0495 12.5782743,1.7395 L12.5782743,1.3795 C13.3382743,1.6395 13.8882743,2.2195 14.2382743,3.1195 C14.3882743,3.4995 14.5082743,3.9095 14.6082743,4.3895 C13.8382743,3.8495 12.9282743,3.6095 12.3082743,3.4995 C11.2982743,3.3195 10.2082743,3.2395 8.85827428,3.2395 L8.35827428,3.2395 C7.01827428,3.2395 5.91827428,3.3195 4.90827428,3.4995 C4.29827428,3.6095 3.40827428,3.8495 2.63827428,4.3695 C2.73827428,3.8995 2.85827428,3.4895 3.00827428,3.1195 M17.1882743,7.7995 L16.7282743,6.4095 C16.6282743,6.1295 16.3982743,5.9395 16.1282743,5.8795 C16.0682743,5.4895 16.0082743,5.0995 15.9482743,4.7595 C15.8082743,3.9395 15.6382743,3.2695 15.3982743,2.6595 C14.7882743,1.0795 13.5782743,0.1295 12.0082743,-0.0005 C11.8282743,-0.0205 11.6582743,0.0395 11.5282743,0.1595 C11.4082743,0.2795 11.3282743,0.4495 11.3282743,0.6195 L11.3282743,1.6495 L5.90827428,1.6495 L5.90827428,0.6195 C5.90827428,0.4495 5.83827428,0.2795 5.70827428,0.1595 C5.57827428,0.0395 5.39827428,-0.0205 5.22827428,-0.0005 C3.65827428,0.1395 2.45827428,1.0795 1.83827428,2.6595 C1.59827428,3.2695 1.42827428,3.9395 1.29827428,4.7595 C1.23827428,5.0995 1.17827428,5.4995 1.11827428,5.8795 C0.838274277,5.9395 0.608274277,6.1395 0.518274277,6.4095 L0.0582742771,7.7995 C-0.0417257229,8.0995 -0.0117257229,8.4295 0.138274277,8.7095 L1.08827428,10.4695 C1.62827428,12.2695 3.12827428,13.5895 6.58827428,15.2895 C6.97827428,15.4795 7.41827428,15.5795 7.86827428,15.5795 L9.36827428,15.5795 C9.81827428,15.5795 10.2682743,15.4795 10.6582743,15.2895 C14.1082743,13.5895 15.6082743,12.2695 16.1482743,10.4695 L17.1082743,8.7095 C17.2582743,8.4295 17.2882743,8.0995 17.1882743,7.7995",
                      fill: t,
                      mask: "url(#mask-2)",
                    }),
                  ],
                }),
                (0, Qe.jsx)("path", {
                  d: "M13.0388,8.9193 C13.0288,9.1293 12.8488,9.2993 12.6388,9.2993 L12.6188,9.2993 C12.3988,9.2893 12.2288,9.0993 12.2388,8.8793 L12.2788,7.8393 C12.2888,7.5293 12.0588,7.2793 11.7488,7.2593 L9.7088,7.1793 C9.4788,7.1693 9.3088,6.9793 9.3188,6.7593 C9.3288,6.5393 9.4988,6.3793 9.7388,6.3793 L11.7788,6.4593 C12.5288,6.4893 13.1088,7.1293 13.0788,7.8693 L13.0388,8.9193 Z M11.9188,5.7193 C11.0288,5.5593 10.0488,5.4893 8.8588,5.4893 L8.3588,5.4893 C7.1788,5.4893 6.1988,5.5593 5.3088,5.7093 C4.8388,5.7993 3.7288,6.0693 3.4588,6.7493 C3.1188,7.5893 3.1488,9.5093 3.5088,10.2393 C3.8288,10.8693 4.1888,11.0393 4.4388,11.1093 C4.6388,11.1693 4.8388,11.1993 5.0388,11.1993 C5.4388,11.1993 5.8388,11.0793 6.2788,10.8293 C6.4188,10.7493 6.5488,10.6593 6.6788,10.5693 L6.8288,10.4693 C7.0088,10.3393 7.1588,10.2493 7.2988,10.1593 C7.6988,9.8993 8.1188,9.7693 8.6588,9.7493 C9.1088,9.7693 9.5488,9.9093 9.9188,10.1593 C10.0088,10.2193 10.3688,10.4593 10.3688,10.4593 C10.5688,10.5993 10.7688,10.7293 10.9588,10.8393 C11.3788,11.0793 11.7788,11.1993 12.1788,11.1993 C12.3788,11.1993 12.5788,11.1693 12.7788,11.1093 C13.0288,11.0393 13.3888,10.8693 13.7088,10.2393 C14.0788,9.5093 14.1088,7.5793 13.7588,6.7493 C13.4888,6.0693 12.3788,5.7993 11.9188,5.7193 Z",
                  fill: t,
                }),
              ],
            }),
          ],
        });
      },
      rr = function () {
        return (0, Qe.jsxs)("svg", {
          "aria-hidden": !0,
          role: "img",
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          children: [
            (0, Qe.jsxs)("g", {
              "clip-path": "url(#clip0_1336_15876)",
              children: [
                (0, Qe.jsx)("path", {
                  d: "M2.27264 11.8184H13.727C14.4303 11.8184 14.9997 11.2484 14.9997 10.5458V6.40954V2.5C14.9997 1.67157 14.3281 1 13.4997 1H7.99983H2.27264C1.56999 1 1 1.56999 1 2.2733V10.5458C1 11.2484 1.56999 11.8184 2.27264 11.8184Z",
                  stroke: "#666666",
                }),
                (0, Qe.jsx)("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M10.5455 14.9996H5.45428L6.09094 11.8184H9.90884L10.5455 14.9996Z",
                  stroke: "#666666",
                }),
                (0, Qe.jsx)("path", {
                  d: "M3.54529 15H12.4537",
                  stroke: "#666666",
                }),
                (0, Qe.jsx)("path", {
                  d: "M3.88086 11.4766L4.08072 11.3625C4.84075 10.9271 4.84075 9.83967 4.08072 9.4043L3.88086 9.29022L5.02071 7.33203L5.22097 7.44689C5.981 7.88187 6.93094 7.33795 6.93094 6.46799V6.23866H9.21143V6.46799C9.21143 7.33795 10.1614 7.88187 10.9214 7.44689L11.1217 7.33203L12.2615 9.29022L12.0616 9.4043C11.3016 9.83967 11.3016 10.9271 12.0616 11.3625L12.2615 11.4766",
                  stroke: "#666666",
                }),
                (0, Qe.jsx)("path", {
                  d: "M7.02356 10.9512C7.02356 10.3726 7.49258 9.90359 8.07114 9.90359C8.6497 9.90359 9.11872 10.3726 9.11872 10.9512",
                  stroke: "#666666",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                }),
              ],
            }),
            (0, Qe.jsx)("defs", {
              children: (0, Qe.jsx)("clipPath", {
                id: "clip0_1336_15876",
                children: (0, Qe.jsx)("rect", {
                  width: "16",
                  height: "16",
                  fill: "white",
                }),
              }),
            }),
          ],
        });
      },
      or = function () {
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          children: (0, Qe.jsx)("path", {
            d: "M6.88889 11.6667H8.44444M12.3333 10.3333V12.5111C12.3333 13.3823 12.3332 13.8178 12.1776 14.1522C12.0221 14.44 11.7892 14.6811 11.4781 14.8289C11.167 15 10.6998 15 9.84429 15H5.48904C4.63349 15 4.16636 15 3.85525 14.8289C3.54414 14.6811 3.31126 14.44 3.15571 14.1522C3.00015 13.8178 3 13.3823 3 12.5111V3.48885C3 2.61774 3.00015 2.1822 3.15571 1.84775C3.31126 1.55997 3.54414 1.31887 3.85525 1.17109C4.16636 0.999977 4.63349 1 5.48904 1H7.66667L10.8333 1C11.6618 1 12.3333 1.67157 12.3333 2.5V10.3333Z",
            stroke: "#666666",
            "stroke-width": "1.2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          }),
        });
      },
      ir = function () {
        return (0, Qe.jsxs)("svg", {
          "aria-hidden": !0,
          role: "img",
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          children: [
            (0, Qe.jsx)("path", {
              d: "M5.69582 12.1145H6.97915M10.1875 9.63945V12.8112C10.1875 13.5298 10.1874 13.8891 10.059 14.1651C9.9307 14.4025 9.73857 14.6014 9.48191 14.7233C9.22524 14.8645 8.83986 14.8645 8.13403 14.8645H4.54095C3.83511 14.8645 3.44974 14.8645 3.19307 14.7233C2.9364 14.6014 2.74428 14.4025 2.61595 14.1651C2.48761 13.8891 2.48749 13.5298 2.48749 12.8112V5.36776C2.48749 4.64909 2.48761 3.28976 2.61595 3.01385C2.74428 2.77643 2.9364 2.57752 3.19307 2.4556C3.44974 2.31443 3.83511 2.31445 4.54095 2.31445H5.69582",
              stroke: "#666666",
              strokeWidth: "1.1",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M8.26251 4.19061C8.95001 4.32898 9.50001 4.65412 9.98126 5.13149C10.4625 5.61577 10.8065 6.22452 10.944 6.88867M8.26251 1.38867C9.63751 1.54779 10.944 2.17733 11.9753 3.17356C12.9378 4.17671 13.5563 5.48426 13.7625 6.88867",
              stroke: "#666666",
              strokeWidth: "1.1",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      ar = function () {
        return (0, Qe.jsxs)("svg", {
          "aria-hidden": !0,
          role: "img",
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          children: [
            (0, Qe.jsx)("path", {
              d: "M11.7229 8.33247V12.7868C11.7229 13.5611 11.7227 13.9483 11.5845 14.2456C11.4462 14.5014 11.2392 14.7157 10.9626 14.8471C10.6861 14.9992 10.2709 14.9991 9.51039 14.9991H5.63906C4.87856 14.9991 4.46334 14.9992 4.1868 14.8471C3.91026 14.7157 3.70325 14.5014 3.56498 14.2456C3.42671 13.9483 3.42657 13.5611 3.42657 12.7868V4.767C3.42657 3.99268 3.42671 3.60553 3.56498 3.30824C3.70325 3.05244 3.91026 2.83812 4.1868 2.70677C4.46334 2.55467 4.87856 2.55469 5.63906 2.55469H8.46361",
              stroke: "#666666",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M5.6488 12.3327L5.6488 11.0882M7.42658 12.3327V10.3771M9.20436 12.3327V9.66602",
              stroke: "#666666",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M12.8771 3.99415V2.49708C12.8771 1.67026 12.2068 1 11.38 1C10.5532 1 9.88294 1.67026 9.88294 2.49708V3.99415M11.4269 5.11719V6.61426M9.64914 8.02222H13.1111C13.6021 8.02222 14 7.62425 14 7.13333V4.46667C14 3.97575 13.602 3.57778 13.1111 3.57778H9.64914C9.15822 3.57778 8.76025 3.97575 8.76025 4.46667V7.13333C8.76025 7.62425 9.15822 8.02222 9.64914 8.02222Z",
              stroke: "#666666",
            }),
          ],
        });
      },
      lr = function () {
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          xmlns: "http://www.w3.org/2000/svg",
          width: "12",
          height: "16",
          viewBox: "0 0 12 16",
          fill: "none",
          children: (0, Qe.jsx)("path", {
            d: "M6.9037 6.11976L8.59829 2.12445C9.0828 1.18437 7.87271 0.714401 7.38821 1.18437L1.33778 6.82486C0.853272 7.29498 0.853272 7.76494 1.57885 7.99993L4.96804 9.88024L3.27344 13.8756C3.03237 14.8156 3.99902 15.2856 4.48353 14.8156L10.534 9.17514C10.775 8.94001 10.775 8.23506 10.2929 7.99993L6.9037 6.11976Z",
            stroke: "#666666",
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }),
        });
      },
      sr = function () {
        return (0, Qe.jsxs)("svg", {
          "aria-hidden": !0,
          role: "img",
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          children: [
            (0, Qe.jsx)("path", {
              d: "M7.33333 5.33398H3.33333C2.59695 5.33398 2 5.93094 2 6.66732V13.334C2 14.0704 2.59695 14.6673 3.33333 14.6673H7.33333C8.06971 14.6673 8.66667 14.0704 8.66667 13.334V6.66732C8.66667 5.93094 8.06971 5.33398 7.33333 5.33398Z",
              stroke: "#666666",
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M3.33333 2.66732C3.33333 2.3137 3.4738 1.97456 3.72385 1.72451C3.9739 1.47446 4.31304 1.33398 4.66666 1.33398H12.6667C13.0203 1.33398 13.3594 1.47446 13.6095 1.72451C13.8595 1.97456 14 2.3137 14 2.66732V13.334C14 13.6876 13.8595 14.0267 13.6095 14.2768C13.3594 14.5268 13.0203 14.6673 12.6667 14.6673H11.0667",
              stroke: "#666666",
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
            (0, Qe.jsx)("path", {
              d: "M5.33333 12H5.34",
              stroke: "#666666",
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }),
          ],
        });
      },
      cr = function () {
        return (0, Qe.jsxs)("svg", {
          "aria-hidden": !0,
          role: "img",
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          children: [
            (0, Qe.jsx)("mask", {
              id: "mask0_1336_15275",
              style: "mask-type:luminance",
              maskUnits: "userSpaceOnUse",
              x: "0",
              y: "0",
              width: "16",
              height: "16",
              children: (0, Qe.jsx)("path", {
                d: "M16 0H0V16H16V0Z",
                fill: "white",
              }),
            }),
            (0, Qe.jsx)("g", {
              mask: "url(#mask0_1336_15275)",
              children: (0, Qe.jsx)("path", {
                d: "M2.66699 12.186L5.33366 9.55265C5.86699 9.01265 6.13314 8.73932 6.46647 8.63265C6.73314 8.54598 7.00059 8.53931 7.26725 8.62598C7.60059 8.72598 7.86673 8.9927 8.40007 9.51937L9.53418 10.626M2.66699 12.186C2.73366 12.3527 2.73314 12.486 2.7998 12.606C2.93314 12.8527 3.1334 13.0594 3.40007 13.186C3.66673 13.3327 4.06647 13.3327 4.7998 13.3327H11.2008C11.6675 13.3327 11.9342 13.3327 12.2008 13.306M2.66699 12.186C2.66699 11.946 2.66699 11.6394 2.66699 11.1994V4.79932C2.66699 4.05265 2.66647 3.67933 2.7998 3.39266C2.93314 3.14599 3.1334 2.93933 3.40007 2.81266C3.66673 2.666 4.06647 2.66602 4.7998 2.66602H11.2008C11.9342 2.66602 12.3339 2.666 12.6006 2.81266C12.8673 2.93933 13.0675 3.14599 13.2008 3.39266C13.3342 3.67933 13.3337 4.05265 13.3337 4.79932V10.9927M9.53418 10.626L12.2008 13.306M9.53418 10.626L9.7334 10.3993C10.2667 9.866 10.5342 9.59935 10.8675 9.49935C11.1342 9.41935 11.4003 9.41936 11.667 9.5127C12.0003 9.6127 12.2665 9.88603 12.7998 10.4327L13.3337 10.9927M12.2008 13.306C12.3342 13.286 12.4673 13.246 12.6006 13.186C12.8673 13.0594 13.0675 12.8527 13.2008 12.606C13.3342 12.3194 13.3337 11.946 13.3337 11.1994V10.9927M10.0003 7.33268C9.26699 7.33268 8.66699 6.73268 8.66699 5.99935C8.66699 5.26602 9.26699 4.66602 10.0003 4.66602C10.7337 4.66602 11.3337 5.26602 11.3337 5.99935C11.3337 6.73268 10.7337 7.33268 10.0003 7.33268Z",
                stroke: "#666666",
                "stroke-linejoin": "round",
              }),
            }),
          ],
        });
      },
      ur = function () {
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          role: "img",
          xmlns: "http://www.w3.org/2000/svg",
          width: "11",
          height: "16",
          viewBox: "0 0 11 16",
          fill: "none",
          children: (0, Qe.jsx)("path", {
            d: "M4.88889 11.6667H6.44444M10.3333 10.3333V12.5111C10.3333 13.3823 10.3332 13.8178 10.1776 14.1522C10.0221 14.44 9.78919 14.6811 9.47808 14.8289C9.16697 15 8.69985 15 7.84429 15H3.48904C2.63349 15 2.16636 15 1.85525 14.8289C1.54414 14.6811 1.31126 14.44 1.15571 14.1522C1.00015 13.8178 1 13.3823 1 12.5111V3.48885C1 2.61774 1.00015 2.1822 1.15571 1.84775C1.31126 1.55997 1.54414 1.31887 1.85525 1.17109C2.16636 0.999977 2.63349 1 3.48904 1H5.66667L8.83333 1C9.66176 1 10.3333 1.67157 10.3333 2.5V10.3333Z",
            stroke: "#666666",
            strokeWidth: "1.2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }),
        });
      },
      dr = ["isHighContrastThemeEnabled", "type"];
    function pr(e, n) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n &&
          (r = r.filter(function (n) {
            return Object.getOwnPropertyDescriptor(e, n).enumerable;
          })),
          t.push.apply(t, r);
      }
      return t;
    }
    function fr(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2
          ? pr(Object(t), !0).forEach(function (n) {
              hr(e, n, t[n]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : pr(Object(t)).forEach(function (n) {
              Object.defineProperty(
                e,
                n,
                Object.getOwnPropertyDescriptor(t, n)
              );
            });
      }
      return e;
    }
    function hr(e, n, t) {
      return (
        n in e
          ? Object.defineProperty(e, n, {
              value: t,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[n] = t),
        e
      );
    }
    var mr = function (e) {
        var n = e.isHighContrastThemeEnabled,
          t = void 0 !== n && n,
          r = e.type,
          o = void 0 === r ? "" : r,
          i = (function (e, n) {
            if (null == e) return {};
            var t,
              r,
              o = (function (e, n) {
                if (null == e) return {};
                var t,
                  r,
                  o = {},
                  i = Object.keys(e);
                for (r = 0; r < i.length; r++)
                  (t = i[r]), n.indexOf(t) >= 0 || (o[t] = e[t]);
                return o;
              })(e, n);
            if (Object.getOwnPropertySymbols) {
              var i = Object.getOwnPropertySymbols(e);
              for (r = 0; r < i.length; r++)
                (t = i[r]),
                  n.indexOf(t) >= 0 ||
                    (Object.prototype.propertyIsEnumerable.call(e, t) &&
                      (o[t] = e[t]));
            }
            return o;
          })(e, dr),
          a = null,
          l = t ? "#fff" : "#80858F";
        switch (o) {
          case ne.ACCESS_KEY:
            a = (0, Qe.jsx)(un, fr({ color: l }, i));
            break;
          case ne.ANALYTICS:
            a = (0, Qe.jsx)(fn, fr({ color: l }, i));
            break;
          case ne.ARROW_LEFT:
            a = (0, Qe.jsx)(vn, fr({ color: l }, i));
            break;
          case ne.ARROW_DOWN:
            a = (0, Qe.jsx)(Cn, fr({}, i));
            break;
          case ne.ANALYTICS_PRIVATE_REAL_DEVICE:
            a = (0, Qe.jsx)(Nn, fr({ color: l }, i));
            break;
          case ne.ANALYTICS_USAGE_REPORT:
            a = (0, Qe.jsx)(On, fr({ color: l }, i));
            break;
          case ne.WINDOW:
            a = (0, Qe.jsx)(Ht, fr({ color: l }, i));
            break;
          case ne.COPY:
            a = (0, Qe.jsx)(jn, fr({ color: l }, i));
            break;
          case ne.VISUAL:
            a = (0, Qe.jsx)(It, fr({}, i));
            break;
          case ne.USER:
            a = (0, Qe.jsx)(Nt, fr({}, i));
            break;
          case ne.USER_CIRCLE:
            a = (0, Qe.jsx)(Ot, fr({ color: l }, i));
            break;
          case ne.SIGN_OUT:
            a = (0, Qe.jsx)(Ct, fr({}, i));
            break;
          case ne.SETTINGS:
            a = (0, Qe.jsx)(vt, fr({ color: l }, i));
            break;
          case ne.ROCKET:
            a = (0, Qe.jsx)(mt, fr({}, i));
            break;
          case ne.ROBOT:
            a = (0, Qe.jsx)(ht, fr({}, i));
            break;
          case ne.REAL_TIME:
            a = (0, Qe.jsx)(pt, fr({ color: l }, i));
            break;
          case ne.OLD_REAL_TIME:
            a = (0, Qe.jsx)(qt, fr({ color: l }, i));
            break;
          case ne.REAL_DEVICE:
            a = (0, Qe.jsx)(dt, fr({ color: l }, i));
            break;
          case ne.OLD_REAL_DEVICE:
            a = (0, Qe.jsx)($t, fr({ color: l }, i));
            break;
          case ne.QUESTION:
            a = (0, Qe.jsx)(ct, fr({ color: l }, i));
            break;
          case ne.PLAIN_CROSS:
            a = (0, Qe.jsx)(st, fr({}, i));
            break;
          case ne.DASHBOARD:
            a = (0, Qe.jsx)(Mn, fr({ color: l }, i));
            break;
          case ne.OLD_DASHBOARD:
            a = (0, Qe.jsx)(Qt, fr({ color: l }, i));
            break;
          case ne.HYPEREXECUTE:
            a = (0, Qe.jsx)(Un, fr({ color: l }, i));
            break;
          case ne.OLD_HYPEREXECUTE:
            a = (0, Qe.jsx)(Kn, fr({ color: l }, i));
            break;
          case ne.INSIGHTS:
            a = (0, Qe.jsx)(Yn, fr({ color: l }, i));
            break;
          case ne.OLD_INSIGHTS:
            a = (0, Qe.jsx)(Gn, fr({ color: l }, i));
            break;
          case ne.MORE_TOOLS:
            a = (0, Qe.jsx)(tt, fr({ color: l }, i));
            break;
          case ne.MANAGE:
            a = (0, Qe.jsx)(Jn, fr({}, i));
            break;
          case ne.MONITOR:
            a = (0, Qe.jsx)(nt, fr({ color: l }, i));
            break;
          case ne.DOCUMENTATION:
            a = (0, Qe.jsx)(An, fr({ color: l }, i));
            break;
          case ne.FAQ:
            a = (0, Qe.jsx)(Fn, fr({ color: l }, i));
            break;
          case ne.KEY:
            a = (0, Qe.jsx)(Qn, fr({ color: l }, i));
            break;
          case ne.MANAGE_TEAM:
            a = (0, Qe.jsx)(et, fr({}, i));
            break;
          case ne.BILLING:
            a = (0, Qe.jsx)(yn, fr({}, i));
            break;
          case ne.LOGO:
            a = (0, Qe.jsx)(Xn, fr({}, i));
            break;
          case ne.NOTIFICATION:
            a = (0, Qe.jsx)(rt, fr({}, i));
            break;
          case ne.COLLAPSE:
            a = (0, Qe.jsx)(Ln, fr({}, i));
            break;
          case ne.EXPAND:
            a = (0, Qe.jsx)(Pn, fr({}, i));
            break;
          case ne.DOWNLOAD:
            a = (0, Qe.jsx)(In, fr({}, i));
            break;
          case ne.CROSS_RED:
            a = (0, Qe.jsx)(Sn, fr({}, i));
            break;
          case ne.CROSS_GRAY:
            a = (0, Qe.jsx)(En, fr({}, i));
            break;
          case ne.WALLET:
            a = (0, Qe.jsx)(Pt, fr({}, i));
            break;
          case ne.TICK:
            a = (0, Qe.jsx)(kt, fr({}, i));
            break;
          case ne.SMART_UI:
            a = (0, Qe.jsx)(yt, fr({ color: l }, i));
            break;
          case ne.OLD_SMART_UI:
            a = (0, Qe.jsx)(Gt, fr({ color: l }, i));
            break;
          case ne.AUTOMATION:
            a = (0, Qe.jsx)(bn, fr({ color: l }, i));
            break;
          case ne.OLD_AUTOMATION:
            a = (0, Qe.jsx)(Yt, fr({ color: l }, i));
            break;
          case ne.GLOBE:
            a = (0, Qe.jsx)(Dn, fr({}, i));
            break;
          case ne.WEB_AUTOMATION:
            a = (0, Qe.jsx)(Rt, fr({ color: l }, i));
            break;
          case ne.APP_AUTOMATION:
            a = (0, Qe.jsx)(mn, fr({ color: l }, i));
            break;
          case ne.HE_JOBS:
            a = (0, Qe.jsx)(Wn, fr({ color: l }, i));
            break;
          case ne.HE_INSIGHTS:
            a = (0, Qe.jsx)(Bn, fr({}, i));
            break;
          case ne.FOLDER:
            a = (0, Qe.jsx)(Vn, fr({ color: l }, i));
            break;
          case ne.SCREENSHOT:
            a = (0, Qe.jsx)(_t, fr({}, i));
            break;
          case ne.RESPONSIVE:
            a = (0, Qe.jsx)(ft, fr({}, i));
            break;
          case ne.BUG:
            a = (0, Qe.jsx)(wn, fr({ color: l }, i));
            break;
          case ne.PHONE:
            a = (0, Qe.jsx)(lt, fr({ color: l }, i));
            break;
          case ne.UPTIME_MONITOR:
            a = (0, Qe.jsx)(Mt, fr({ color: l }, i));
            break;
          case ne.TEST_MANAGER:
            a = (0, Qe.jsx)(wt, fr({ color: l }, i));
            break;
          case ne.TMS_PROJECTS:
            a = (0, Qe.jsx)(Lt, fr({}, i));
            break;
          case ne.ADD_TEAM:
            a = (0, Qe.jsx)(pn, fr({}, i));
            break;
          case ne.USER_FEEDBACK:
            a = (0, Qe.jsx)(Tt, fr({ color: l }, i));
            break;
          case ne.CHAT:
            a = (0, Qe.jsx)(kn, fr({}, i));
            break;
          case ne.ARCHIVES:
            a = (0, Qe.jsx)(_n, fr({ color: l }, i));
            break;
          case ne.ARROW_CIRCLE_LEFT:
            a = (0, Qe.jsx)(gn, fr({}, i));
            break;
          case ne.INTEGRATIONS:
            a = (0, Qe.jsx)($n, fr({ color: l }, i));
            break;
          case ne.HE_PROJECTS:
            a = (0, Qe.jsx)(zn, fr({}, i));
            break;
          case ne.HE_WORKFLOWS:
            a = (0, Qe.jsx)(Zn, fr({}, i));
            break;
          case ne.UPGRADE:
            a = (0, Qe.jsx)(St, fr({}, i));
            break;
          case ne.OLD_FADERS_SETTING:
            a = (0, Qe.jsx)(Hn, fr({ color: l }, i));
            break;
          case ne.FADERS_SETTING:
            a = (0, Qe.jsx)(Rn, fr({ color: l }, i));
            break;
          case ne.ORG_SETTINGS:
            a = (0, Qe.jsx)(at, fr({}, i));
            break;
          case ne.QUICK_ACTIONS:
            a = (0, Qe.jsx)(ut, fr({ color: l }, i));
            break;
          case ne.USER_LOCK:
            a = (0, Qe.jsx)(At, fr({}, i));
            break;
          case ne.SMART_UI_PROJECTS:
            a = (0, Qe.jsx)(xt, fr({}, i));
            break;
          case ne.SMART_UI_APPROVER_PROJECTS:
            a = (0, Qe.jsx)(bt, fr({}, i));
            break;
          case ne.NO_ACCESSIBILITY:
            a = (0, Qe.jsx)(ot, fr({}, i));
            break;
          case ne.TUNNEL:
            a = (0, Qe.jsx)(jt, fr({}, i));
            break;
          case ne.ANNOUNCEMENT:
            a = (0, Qe.jsx)(hn, fr({}, i));
            break;
          case ne.CROSS:
            a = (0, Qe.jsx)(Vt, fr({}, i));
            break;
          case ne.HEADPHONE:
            a = (0, Qe.jsx)(Dt, fr({}, i));
            break;
          case ne.ACCESSIBILITY:
            a = (0, Qe.jsx)(dn, fr({ color: l }, i));
            break;
          case ne.HAMBURGER:
            a = (0, Qe.jsx)(Bt, fr({}, i));
            break;
          case ne.LOGO_BLACK:
            a = (0, Qe.jsx)(Wt, fr({}, i));
            break;
          case ne.LOGO_BLACK_SMALL:
            a = (0, Qe.jsx)(Ft, fr({}, i));
            break;
          case ne.KEBAB_ELLIPSIS:
            a = (0, Qe.jsx)(zt, fr({}, i));
            break;
          case ne.LAMBDATEST:
            a = (0, Qe.jsx)(Zt, fr({}, i));
            break;
          case ne.GIFT:
            a = (0, Qe.jsx)(Ut, fr({}, i));
            break;
          case ne.SUCCESS:
            a = (0, Qe.jsx)(Kt, fr({}, i));
            break;
          case ne.ACCESSIBILITY_AUTOMATED:
            a = (0, Qe.jsx)(Xt, fr({ color: l }, i));
            break;
          case ne.ACCESSIBILITY_MANUAL:
            a = (0, Qe.jsx)(Jt, fr({ color: l }, i));
            break;
          case ne.REAL_TIME_VIRTUAL_MOBILE:
            a = (0, Qe.jsx)(er, fr({ color: l }, i));
            break;
          case ne.REAL_TIME_APP:
            a = (0, Qe.jsx)(nr, fr({ color: l }, i));
            break;
          case ne.KANE_AI:
            a = (0, Qe.jsx)(tr, fr({ color: l }, i));
            break;
          case re:
            a = (0, Qe.jsx)(rr, fr({ color: l }, i));
            break;
          case "concurrency-mobile-automation":
            a = (0, Qe.jsx)(or, fr({ color: l }, i));
            break;
          case ie:
            a = (0, Qe.jsx)(ir, fr({ color: l }, i));
            break;
          case oe:
            a = (0, Qe.jsx)(ar, fr({ color: l }, i));
            break;
          case ae:
            a = (0, Qe.jsx)(lr, fr({ color: l }, i));
            break;
          case le:
            a = (0, Qe.jsx)(sr, fr({ color: l }, i));
            break;
          case "concurrency-screenshot":
            a = (0, Qe.jsx)(cr, fr({ color: l }, i));
            break;
          case te:
            a = (0, Qe.jsx)(ur, fr({ color: l }, i));
            break;
          default:
            return null;
        }
        return (0, Qe.jsx)("span", fr(fr({}, i), {}, { children: a }));
      },
      _r = function (e) {
        var n = e.iconColor,
          t = e.title,
          r = e.trailingText,
          o = e.subList;
        return (0, Qe.jsxs)(Qe.Fragment, {
          children: [
            (0, Qe.jsxs)("div", {
              className: "ltch-segment-detail",
              children: [
                (0, Qe.jsxs)("div", {
                  style: { display: "flex", alignItems: "center", gap: "8px" },
                  children: [
                    (0, Qe.jsx)("div", {
                      className: "ltch-segment-leading-icon",
                      style: { backgroundColor: n },
                    }),
                    (0, Qe.jsx)("div", {
                      className: "ltch-segment-heading",
                      children: t,
                    }),
                  ],
                }),
                (0, Qe.jsx)("div", {
                  className: "ltch-segment-trailing-text",
                  children: r,
                }),
              ],
            }),
            o &&
              o.map(function (e, n) {
                return (0,
                Qe.jsxs)("div", { className: "ltch-sub-segment", children: [(0, Qe.jsxs)("div", { children: [(0, Qe.jsx)("span", { style: { display: "flex", height: "12px", width: "1px", backgroundColor: "rgb(102,102,102)" } }), (0, Qe.jsx)("span", { style: { display: "flex", width: "6px", height: "1px", backgroundColor: "rgb(102,102,102)" } })] }), (0, Qe.jsxs)("div", { className: "ltch-sub-segment-detail", children: [(0, Qe.jsx)("div", { className: "ltch-segment-sub-heading", children: null == e ? void 0 : e.title }), (0, Qe.jsx)("div", { className: "ltch-segment-sub-heading-trailing-text", children: null == e ? void 0 : e.trailingText })] })] }, "ltch-sub-segment".concat(n));
              }),
          ],
        });
      };
    function gr(e, n) {
      (null == n || n > e.length) && (n = e.length);
      for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
      return r;
    }
    var vr = function (n) {
      var t,
        o,
        i = n.concurrencyData,
        a =
          ((t = (0, e.useState)(null)),
          (o = 2),
          (function (e) {
            if (Array.isArray(e)) return e;
          })(t) ||
            (function (e, n) {
              var t =
                null == e
                  ? null
                  : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                    e["@@iterator"];
              if (null != t) {
                var r,
                  o,
                  i = [],
                  a = !0,
                  l = !1;
                try {
                  for (
                    t = t.call(e);
                    !(a = (r = t.next()).done) &&
                    (i.push(r.value), !n || i.length !== n);
                    a = !0
                  );
                } catch (e) {
                  (l = !0), (o = e);
                } finally {
                  try {
                    a || null == t.return || t.return();
                  } finally {
                    if (l) throw o;
                  }
                }
                return i;
              }
            })(t, o) ||
            (function (e, n) {
              if (e) {
                if ("string" == typeof e) return gr(e, n);
                var t = Object.prototype.toString.call(e).slice(8, -1);
                return (
                  "Object" === t && e.constructor && (t = e.constructor.name),
                  "Map" === t || "Set" === t
                    ? Array.from(e)
                    : "Arguments" === t ||
                      /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
                    ? gr(e, n)
                    : void 0
                );
              }
            })(t, o) ||
            (function () {
              throw new TypeError(
                "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            })()),
        l = a[0],
        s = a[1],
        c = ((0, e.useContext)(r) || {}).isHighContrastThemeEnabled,
        u = void 0 !== c && c,
        d = function (e) {
          s(e);
        },
        p = (i || {}).intent_details,
        f = qe(void 0 === p ? {} : p) || {},
        h = Object.keys(f).filter(function (e) {
          return "visual-regression" !== e;
        }),
        m = (function (e) {
          var n = 0,
            t = 0;
          return (
            e.forEach(function (e) {
              var r = f[e] || {},
                o = r.running_count,
                i = void 0 === o ? 0 : o,
                a = r.total_count;
              (n += i), (t += void 0 === a ? 0 : a);
            }),
            { totalRunningCount: n, allProductsTotalCount: t }
          );
        })(h),
        _ = m.allProductsTotalCount,
        g = void 0 === _ ? 0 : _,
        v = m.totalRunningCount,
        C = void 0 === v ? 0 : v,
        b = function () {
          window.open("".concat(ve(Z), "/").concat(A), "_self");
        };
      return (0, Qe.jsxs)(Qe.Fragment, {
        children: [
          (0, Qe.jsxs)("div", {
            className: "ltch-popover-content-heading",
            children: [
              (0, Qe.jsx)("div", { children: "Usage Breakdown" }),
              (0, Qe.jsxs)("div", {
                className: "ltch-popover-content-subheading",
                children: [
                  (0, Qe.jsx)("div", {
                    className: "ltch-popover-content-heading-running",
                    children: "Running: ",
                  }),
                  (0, Qe.jsx)("div", {
                    children: "".concat(C, " / ").concat(g),
                  }),
                ],
              }),
            ],
          }),
          h.map(function (e, n) {
            var t = f[e] || {},
              r = t.available_count,
              o = void 0 === r ? 0 : r,
              i = t.label,
              a = void 0 === i ? "" : i,
              s = t.other_products,
              c = void 0 === s ? {} : s,
              u = t.running_count,
              p = void 0 === u ? 0 : u,
              h = t.total_count,
              m = void 0 === h ? 0 : h,
              _ = Object.values(c).reduce(function (e, n) {
                return e + n;
              }, 0),
              g = Object.keys(c).map(function (e) {
                return {
                  title:
                    ((n = e),
                    n
                      .split("-")
                      .map(function (e) {
                        return e.length > 0
                          ? e[0].toUpperCase() + e.slice(1).toLowerCase()
                          : e;
                      })
                      .join(" ")),
                  trailingText: Number(c[e]),
                };
                var n;
              }),
              v = Number(m) - Number(p) - Number(_);
            return (0,
            Qe.jsx)(cn, { keyToSet: "ltch-concurrency-collapsible-panel-".concat(n), name: e, open: l === e, title: a, trailingText: "".concat(p, "/").concat(m), setCurrentOpenPanel: d, concurrencyInfo: { available: v, total: m, used: p, usedByOtherProducts: _ }, children: (0, Qe.jsxs)("div", { className: "ltch-segment-list", children: [(0, Qe.jsx)(_r, { title: "Running", trailingText: p, iconColor: "#0968da" }), (0, Qe.jsx)(_r, { title: "Available", trailingText: o, iconColor: "#fff" }), (0, Qe.jsx)(_r, { title: "Consumed by other products", trailingText: _, iconColor: "#dcecff", subList: g || [] })] }) }, "ltch-concurrency-collapsible-panel-wrapper-".concat(n));
          }),
          " ",
          (0, Qe.jsx)("div", {
            className: "ltch-popover-content-footer",
            children: (0, Qe.jsx)("button", {
              "aria-label": "View Subscriptions",
              tabIndex: 0,
              type: "button",
              className: "ltch-button ".concat(
                u ? "ltch_high_contrast_item" : ""
              ),
              onClick: b,
              onKeyDown: function (e) {
                ("Enter" !== e.key && "Space" !== e.code) || b();
              },
              children: "View Subscriptions",
            }),
          }),
        ],
      });
    };
    function Cr(e, n) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, n) {
          var t =
            null == e
              ? null
              : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                e["@@iterator"];
          if (null != t) {
            var r,
              o,
              i = [],
              a = !0,
              l = !1;
            try {
              for (
                t = t.call(e);
                !(a = (r = t.next()).done) &&
                (i.push(r.value), !n || i.length !== n);
                a = !0
              );
            } catch (e) {
              (l = !0), (o = e);
            } finally {
              try {
                a || null == t.return || t.return();
              } finally {
                if (l) throw o;
              }
            }
            return i;
          }
        })(e, n) ||
        (function (e, n) {
          if (e) {
            if ("string" == typeof e) return br(e, n);
            var t = Object.prototype.toString.call(e).slice(8, -1);
            return (
              "Object" === t && e.constructor && (t = e.constructor.name),
              "Map" === t || "Set" === t
                ? Array.from(e)
                : "Arguments" === t ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
                ? br(e, n)
                : void 0
            );
          }
        })(e, n) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        })()
      );
    }
    function br(e, n) {
      (null == n || n > e.length) && (n = e.length);
      for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
      return r;
    }
    var xr = function () {
        var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          n = $e(e) || {};
        return (0, Qe.jsx)(Qe.Fragment, {
          children: Object.keys(n).map(function (e, t) {
            var r,
              o =
                null === (r = n[e]) || void 0 === r
                  ? void 0
                  : r.available_count;
            return (0,
            Qe.jsxs)("div", { className: "ltch-concurrency-header-items", children: [(0, Qe.jsx)(mr, { color: "#666", type: Ge[e] }), (0, Qe.jsx)("span", { children: o })] }, "concurrency-header-item-".concat(t));
          }),
        });
      },
      yr = function (n) {
        var t = n.onPremPrefixToUse,
          r = void 0 === t ? "" : t,
          o = n.brandName,
          i = void 0 === o ? "" : o,
          a = Cr((0, e.useState)(""), 2),
          l = a[0],
          s = a[1],
          c = Cr((0, e.useState)({}), 2),
          u = c[0],
          d = c[1],
          p = (0, e.useRef)(null);
        (0, e.useEffect)(function () {
          return (
            f(),
            document.addEventListener("visibilitychange", f),
            function () {
              (p.current = null),
                document.removeEventListener("visibilitychange", f);
            }
          );
        }, []);
        var f = function () {
            document.hidden
              ? (clearInterval(p.current), (p.current = null))
              : (h(),
                (p.current = setInterval(function () {
                  h();
                }, 3e4)));
          },
          h = function () {
            var e = ke();
            fetch(
              "".concat(
                ve(se, !1, "https", i, r),
                "/api/organization/concurrency"
              ),
              {
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                  authorization: "Bearer ".concat(e),
                },
              }
            ).then(function (e) {
              200 == e.status &&
                e.json().then(function (e) {
                  d(e);
                  var n =
                      Ye.find(function (e) {
                        var n = e.hostKeyToUse,
                          t = e.intentToUse;
                        if (window.location.hostname.includes(n)) return t;
                      }) || {},
                    t = (function (e, n) {
                      var t = {};
                      return (
                        Object.keys(e).forEach(function (r) {
                          e[r].category === n && (t[r] = e[r]);
                        }),
                        t
                      );
                    })(
                      qe(null == e ? void 0 : e.intent_details),
                      null == n ? void 0 : n.intentToUse
                    );
                  s(t);
                }),
                401 == e.status &&
                  (window.location.href = "".concat(
                    "".concat(ve(F, !1, "https", i, r), "/").concat(C)
                  ));
            });
          };
        return (0, Qe.jsx)(Qe.Fragment, {
          children: (0, Qe.jsx)(Je, {
            content: (0, Qe.jsx)(vr, { concurrencyData: u }),
            children: (0, Qe.jsxs)("div", {
              className: "ltch-concurrency-header-items-container",
              children: [
                (0, Qe.jsx)("span", { children: "Parallels Available" }),
                (0, Qe.jsx)("div", {
                  style: { display: "flex", gap: "4px" },
                  children: Object.keys(l).length > 0 && xr(l),
                }),
              ],
            }),
          }),
        });
      };
    function wr(n) {
      var t = n.concurrencyInfo,
        o = void 0 === t ? [] : t,
        i = n.renderAsListItem,
        a = void 0 !== i && i,
        l = ((0, e.useContext)(r) || {}).isHighContrastThemeEnabled,
        s = void 0 !== l && l;
      return (0, Qe.jsxs)("div", {
        className: "".concat(
          a ? "ltch-test-concurrency-container-col" : "",
          " ltch-test-concurrency-container"
        ),
        children: [
          o.map(function (e, n) {
            var t = e.color,
              r = void 0 === t ? "" : t,
              o = e.hideTotal,
              i = void 0 !== o && o,
              l = e.total,
              c = void 0 === l ? 0 : l,
              u = e.runningCount,
              d = void 0 === u ? 0 : u,
              p = e.title,
              f = void 0 === p ? "" : p,
              h = 0,
              m = "#f4f6f8";
            return (
              d &&
                c &&
                ((m =
                  "green" === r
                    ? "#20d980"
                    : "orange" === r
                    ? "#ffaf90"
                    : "f4f6f8"),
                (h = (parseInt(d) / parseInt(c)) * 100)),
              (0, Qe.jsxs)(
                "div",
                {
                  className: ""
                    .concat(
                      a ? "ltch-test-concurrency-col" : "",
                      " ltch-test-concurrency "
                    )
                    .concat(s ? "ltch_high_contrast_item" : ""),
                  children: [
                    (0, Qe.jsx)("div", {
                      className: "ltch-test-concurrency-value-wrapper",
                      style: {
                        background:
                          "radial-gradient(closest-side, white 70%, transparent 65% 100%), conic-gradient("
                            .concat(m, " ")
                            .concat(h < 5 && 0 !== h ? 5 : h, "%, #ddd 0)"),
                      },
                    }),
                    (0, Qe.jsxs)("p", {
                      className: "".concat(
                        a ? "ltch-test-concurrency-paragraph-col" : "",
                        " ltch-test-concurrency-paragraph"
                      ),
                      children: [
                        (0, Qe.jsx)("span", {
                          className: "ltch-test-concurrency-header",
                          children: f,
                        }),
                        (0, Qe.jsx)("span", {
                          className: "ltch-count-running",
                          children: i
                            ? d || 0
                            : d && c
                            ? "".concat(d, "/").concat(c)
                            : "0/".concat(c || 0),
                        }),
                      ],
                    }),
                  ],
                },
                "ltch-test-concurrency-".concat(n)
              )
            );
          }),
          !a && (0, Qe.jsx)("div", { className: "ltch-section-separator" }),
        ],
      });
    }
    function kr(e, n) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n &&
          (r = r.filter(function (n) {
            return Object.getOwnPropertyDescriptor(e, n).enumerable;
          })),
          t.push.apply(t, r);
      }
      return t;
    }
    function Lr(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2
          ? kr(Object(t), !0).forEach(function (n) {
              jr(e, n, t[n]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : kr(Object(t)).forEach(function (n) {
              Object.defineProperty(
                e,
                n,
                Object.getOwnPropertyDescriptor(t, n)
              );
            });
      }
      return e;
    }
    function jr(e, n, t) {
      return (
        n in e
          ? Object.defineProperty(e, n, {
              value: t,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[n] = t),
        e
      );
    }
    function Er(n) {
      var t = n.Component,
        r = n.ComponentProps,
        o = n.isOpen,
        i = n.onClose,
        a = n.content;
      if (!o) return (0, Qe.jsx)(Qe.Fragment, {});
      (0, e.useEffect)(
        function () {
          if (o) {
            var e = l && l.current;
            if (a && e) {
              var n = e.querySelectorAll(
                'button, [href], input, [tabindex="0"]'
              );
              n.length && n[0].focus();
            }
            document.addEventListener("keydown", s),
              document.addEventListener("click", u);
          }
        },
        [o]
      );
      var l = (0, e.useRef)(),
        s = function (e) {
          var n = document.getElementById("close_demo"),
            t = document.getElementsByClassName("ltch-demo-form-submit")[0];
          try {
            "Tab" === e.key &&
              (document.activeElement !== t || e.shiftKey
                ? document.activeElement === n &&
                  e.shiftKey &&
                  (e.preventDefault(), t.focus())
                : (e.preventDefault(), n.focus())),
              "Escape" === e.key && c();
          } catch (e) {}
        },
        c = function () {
          document.removeEventListener("keydown", s),
            document.removeEventListener("click", u),
            i();
        },
        u = function (e) {
          e.target.matches(".ltch-popup-overlay") && c();
        };
      return (0, Qe.jsx)("div", {
        className: "ltch-popup-overlay",
        ref: l,
        children: (0, Qe.jsx)("div", {
          className: "ltch-popup-content",
          children: a || (0, Qe.jsx)(t, Lr({}, r)),
        }),
      });
    }
    function Sr(e) {
      return (
        (Sr =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (e) {
                return typeof e;
              }
            : function (e) {
                return e &&
                  "function" == typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              }),
        Sr(e)
      );
    }
    function Mr() {
      Mr = function () {
        return e;
      };
      var e = {},
        n = Object.prototype,
        t = n.hasOwnProperty,
        r =
          Object.defineProperty ||
          function (e, n, t) {
            e[n] = t.value;
          },
        o = "function" == typeof Symbol ? Symbol : {},
        i = o.iterator || "@@iterator",
        a = o.asyncIterator || "@@asyncIterator",
        l = o.toStringTag || "@@toStringTag";
      function s(e, n, t) {
        return (
          Object.defineProperty(e, n, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          }),
          e[n]
        );
      }
      try {
        s({}, "");
      } catch (e) {
        s = function (e, n, t) {
          return (e[n] = t);
        };
      }
      function c(e, n, t, o) {
        var i = n && n.prototype instanceof p ? n : p,
          a = Object.create(i.prototype),
          l = new L(o || []);
        return r(a, "_invoke", { value: x(e, t, l) }), a;
      }
      function u(e, n, t) {
        try {
          return { type: "normal", arg: e.call(n, t) };
        } catch (e) {
          return { type: "throw", arg: e };
        }
      }
      e.wrap = c;
      var d = {};
      function p() {}
      function f() {}
      function h() {}
      var m = {};
      s(m, i, function () {
        return this;
      });
      var _ = Object.getPrototypeOf,
        g = _ && _(_(j([])));
      g && g !== n && t.call(g, i) && (m = g);
      var v = (h.prototype = p.prototype = Object.create(m));
      function C(e) {
        ["next", "throw", "return"].forEach(function (n) {
          s(e, n, function (e) {
            return this._invoke(n, e);
          });
        });
      }
      function b(e, n) {
        function o(r, i, a, l) {
          var s = u(e[r], e, i);
          if ("throw" !== s.type) {
            var c = s.arg,
              d = c.value;
            return d && "object" == Sr(d) && t.call(d, "__await")
              ? n.resolve(d.__await).then(
                  function (e) {
                    o("next", e, a, l);
                  },
                  function (e) {
                    o("throw", e, a, l);
                  }
                )
              : n.resolve(d).then(
                  function (e) {
                    (c.value = e), a(c);
                  },
                  function (e) {
                    return o("throw", e, a, l);
                  }
                );
          }
          l(s.arg);
        }
        var i;
        r(this, "_invoke", {
          value: function (e, t) {
            function r() {
              return new n(function (n, r) {
                o(e, t, n, r);
              });
            }
            return (i = i ? i.then(r, r) : r());
          },
        });
      }
      function x(e, n, t) {
        var r = "suspendedStart";
        return function (o, i) {
          if ("executing" === r)
            throw new Error("Generator is already running");
          if ("completed" === r) {
            if ("throw" === o) throw i;
            return { value: void 0, done: !0 };
          }
          for (t.method = o, t.arg = i; ; ) {
            var a = t.delegate;
            if (a) {
              var l = y(a, t);
              if (l) {
                if (l === d) continue;
                return l;
              }
            }
            if ("next" === t.method) t.sent = t._sent = t.arg;
            else if ("throw" === t.method) {
              if ("suspendedStart" === r) throw ((r = "completed"), t.arg);
              t.dispatchException(t.arg);
            } else "return" === t.method && t.abrupt("return", t.arg);
            r = "executing";
            var s = u(e, n, t);
            if ("normal" === s.type) {
              if (((r = t.done ? "completed" : "suspendedYield"), s.arg === d))
                continue;
              return { value: s.arg, done: t.done };
            }
            "throw" === s.type &&
              ((r = "completed"), (t.method = "throw"), (t.arg = s.arg));
          }
        };
      }
      function y(e, n) {
        var t = e.iterator[n.method];
        if (void 0 === t) {
          if (((n.delegate = null), "throw" === n.method)) {
            if (
              e.iterator.return &&
              ((n.method = "return"),
              (n.arg = void 0),
              y(e, n),
              "throw" === n.method)
            )
              return d;
            (n.method = "throw"),
              (n.arg = new TypeError(
                "The iterator does not provide a 'throw' method"
              ));
          }
          return d;
        }
        var r = u(t, e.iterator, n.arg);
        if ("throw" === r.type)
          return (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), d;
        var o = r.arg;
        return o
          ? o.done
            ? ((n[e.resultName] = o.value),
              (n.next = e.nextLoc),
              "return" !== n.method && ((n.method = "next"), (n.arg = void 0)),
              (n.delegate = null),
              d)
            : o
          : ((n.method = "throw"),
            (n.arg = new TypeError("iterator result is not an object")),
            (n.delegate = null),
            d);
      }
      function w(e) {
        var n = { tryLoc: e[0] };
        1 in e && (n.catchLoc = e[1]),
          2 in e && ((n.finallyLoc = e[2]), (n.afterLoc = e[3])),
          this.tryEntries.push(n);
      }
      function k(e) {
        var n = e.completion || {};
        (n.type = "normal"), delete n.arg, (e.completion = n);
      }
      function L(e) {
        (this.tryEntries = [{ tryLoc: "root" }]),
          e.forEach(w, this),
          this.reset(!0);
      }
      function j(e) {
        if (e) {
          var n = e[i];
          if (n) return n.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var r = -1,
              o = function n() {
                for (; ++r < e.length; )
                  if (t.call(e, r)) return (n.value = e[r]), (n.done = !1), n;
                return (n.value = void 0), (n.done = !0), n;
              };
            return (o.next = o);
          }
        }
        return { next: E };
      }
      function E() {
        return { value: void 0, done: !0 };
      }
      return (
        (f.prototype = h),
        r(v, "constructor", { value: h, configurable: !0 }),
        r(h, "constructor", { value: f, configurable: !0 }),
        (f.displayName = s(h, l, "GeneratorFunction")),
        (e.isGeneratorFunction = function (e) {
          var n = "function" == typeof e && e.constructor;
          return (
            !!n &&
            (n === f || "GeneratorFunction" === (n.displayName || n.name))
          );
        }),
        (e.mark = function (e) {
          return (
            Object.setPrototypeOf
              ? Object.setPrototypeOf(e, h)
              : ((e.__proto__ = h), s(e, l, "GeneratorFunction")),
            (e.prototype = Object.create(v)),
            e
          );
        }),
        (e.awrap = function (e) {
          return { __await: e };
        }),
        C(b.prototype),
        s(b.prototype, a, function () {
          return this;
        }),
        (e.AsyncIterator = b),
        (e.async = function (n, t, r, o, i) {
          void 0 === i && (i = Promise);
          var a = new b(c(n, t, r, o), i);
          return e.isGeneratorFunction(t)
            ? a
            : a.next().then(function (e) {
                return e.done ? e.value : a.next();
              });
        }),
        C(v),
        s(v, l, "Generator"),
        s(v, i, function () {
          return this;
        }),
        s(v, "toString", function () {
          return "[object Generator]";
        }),
        (e.keys = function (e) {
          var n = Object(e),
            t = [];
          for (var r in n) t.push(r);
          return (
            t.reverse(),
            function e() {
              for (; t.length; ) {
                var r = t.pop();
                if (r in n) return (e.value = r), (e.done = !1), e;
              }
              return (e.done = !0), e;
            }
          );
        }),
        (e.values = j),
        (L.prototype = {
          constructor: L,
          reset: function (e) {
            if (
              ((this.prev = 0),
              (this.next = 0),
              (this.sent = this._sent = void 0),
              (this.done = !1),
              (this.delegate = null),
              (this.method = "next"),
              (this.arg = void 0),
              this.tryEntries.forEach(k),
              !e)
            )
              for (var n in this)
                "t" === n.charAt(0) &&
                  t.call(this, n) &&
                  !isNaN(+n.slice(1)) &&
                  (this[n] = void 0);
          },
          stop: function () {
            this.done = !0;
            var e = this.tryEntries[0].completion;
            if ("throw" === e.type) throw e.arg;
            return this.rval;
          },
          dispatchException: function (e) {
            if (this.done) throw e;
            var n = this;
            function r(t, r) {
              return (
                (a.type = "throw"),
                (a.arg = e),
                (n.next = t),
                r && ((n.method = "next"), (n.arg = void 0)),
                !!r
              );
            }
            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                a = i.completion;
              if ("root" === i.tryLoc) return r("end");
              if (i.tryLoc <= this.prev) {
                var l = t.call(i, "catchLoc"),
                  s = t.call(i, "finallyLoc");
                if (l && s) {
                  if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                } else if (l) {
                  if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                } else {
                  if (!s)
                    throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function (e, n) {
            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var o = this.tryEntries[r];
              if (
                o.tryLoc <= this.prev &&
                t.call(o, "finallyLoc") &&
                this.prev < o.finallyLoc
              ) {
                var i = o;
                break;
              }
            }
            i &&
              ("break" === e || "continue" === e) &&
              i.tryLoc <= n &&
              n <= i.finallyLoc &&
              (i = null);
            var a = i ? i.completion : {};
            return (
              (a.type = e),
              (a.arg = n),
              i
                ? ((this.method = "next"), (this.next = i.finallyLoc), d)
                : this.complete(a)
            );
          },
          complete: function (e, n) {
            if ("throw" === e.type) throw e.arg;
            return (
              "break" === e.type || "continue" === e.type
                ? (this.next = e.arg)
                : "return" === e.type
                ? ((this.rval = this.arg = e.arg),
                  (this.method = "return"),
                  (this.next = "end"))
                : "normal" === e.type && n && (this.next = n),
              d
            );
          },
          finish: function (e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var t = this.tryEntries[n];
              if (t.finallyLoc === e)
                return this.complete(t.completion, t.afterLoc), k(t), d;
            }
          },
          catch: function (e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var t = this.tryEntries[n];
              if (t.tryLoc === e) {
                var r = t.completion;
                if ("throw" === r.type) {
                  var o = r.arg;
                  k(t);
                }
                return o;
              }
            }
            throw new Error("illegal catch attempt");
          },
          delegateYield: function (e, n, t) {
            return (
              (this.delegate = { iterator: j(e), resultName: n, nextLoc: t }),
              "next" === this.method && (this.arg = void 0),
              d
            );
          },
        }),
        e
      );
    }
    function Tr(e, n, t, r, o, i, a) {
      try {
        var l = e[i](a),
          s = l.value;
      } catch (e) {
        return void t(e);
      }
      l.done ? n(s) : Promise.resolve(s).then(r, o);
    }
    function Nr(e) {
      return function () {
        var n = this,
          t = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(n, t);
          function a(e) {
            Tr(i, r, o, a, l, "next", e);
          }
          function l(e) {
            Tr(i, r, o, a, l, "throw", e);
          }
          a(void 0);
        });
      };
    }
    function Or(e, n) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, n) {
          var t =
            null == e
              ? null
              : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                e["@@iterator"];
          if (null != t) {
            var r,
              o,
              i = [],
              a = !0,
              l = !1;
            try {
              for (
                t = t.call(e);
                !(a = (r = t.next()).done) &&
                (i.push(r.value), !n || i.length !== n);
                a = !0
              );
            } catch (e) {
              (l = !0), (o = e);
            } finally {
              try {
                a || null == t.return || t.return();
              } finally {
                if (l) throw o;
              }
            }
            return i;
          }
        })(e, n) ||
        (function (e, n) {
          if (e) {
            if ("string" == typeof e) return Ar(e, n);
            var t = Object.prototype.toString.call(e).slice(8, -1);
            return (
              "Object" === t && e.constructor && (t = e.constructor.name),
              "Map" === t || "Set" === t
                ? Array.from(e)
                : "Arguments" === t ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
                ? Ar(e, n)
                : void 0
            );
          }
        })(e, n) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        })()
      );
    }
    function Ar(e, n) {
      (null == n || n > e.length) && (n = e.length);
      for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
      return r;
    }
    var Ir = {
      "accounts.lambdatest.com": "LUMS",
      "app.lambdatest.com": "LWC",
      "automation.lambdatest.com": "AUTOMATION",
      "issues.lambdatest.com": "ISSUE TRACKER",
      "integrations.lambdatest.com": "INTEGRATIONS",
    };
    function Pr(n) {
      var t = n.defaultTabIndex,
        r = void 0 === t ? 0 : t,
        o = n.userInfo;
      (0, e.useEffect)(
        function () {
          var e, n, t, r;
          (n = (null == (e = o) ? void 0 : e.promo_details) || {}),
            (t = n.ends_at),
            (r = n.starts_at),
            e.promo_details && Date.parse(r) <= new Date().getTime() && l(!0),
            !e.promo_details && Date.parse(t) <= new Date().getTime() && l(!1),
            Date.parse(t) <= new Date().getTime() && l(!1);
        },
        [o]
      );
      var i = Or((0, e.useState)(!1), 2),
        a = i[0],
        l = i[1],
        s = Or((0, e.useState)(""), 2),
        c = s[0],
        u = s[1],
        d = (0, e.useRef)(0),
        p = function (e) {
          l(!1);
          var n = new Event("closeTopPromo", { bubbles: !0 });
          e.target.dispatchEvent(n),
            Re("header: close offer banner", {
              "offer text":
                o && o.promo_details && o.promo_details.discount_price_message,
              "page url": window.location.href,
            });
        };
      function f() {
        return h.apply(this, arguments);
      }
      function h() {
        return (h = Nr(
          Mr().mark(function e() {
            var n, t, r, i, a;
            return Mr().wrap(
              function (e) {
                for (;;)
                  switch ((e.prev = e.next)) {
                    case 0:
                      return (
                        (n = o.promo_details || {}),
                        (t = n.redirect_url),
                        (r = o && o.promo_details && o.promo_details.code),
                        Re("header: click offer banner", {
                          "offer text":
                            o &&
                            o.promo_details &&
                            o.promo_details.discount_price_message,
                          "page url": window.location.href,
                        }),
                        (i = {
                          userId: Ae("user_id"),
                          event: "promo-banner-clicked",
                          properties: {
                            couponCode: r,
                            app: Ir[window.location.hostname] || "",
                          },
                        }),
                        (e.prev = 5),
                        (e.next = 8),
                        fetch(
                          "https://backend.lambdatest.com/api/analytics/event",
                          {
                            method: "POST",
                            body: JSON.stringify(i),
                            headers: { "Content-Type": "application/json" },
                          }
                        )
                      );
                    case 8:
                      return (a = e.sent), (e.next = 11), a.json();
                    case 11:
                      e.next = 15;
                      break;
                    case 13:
                      (e.prev = 13), (e.t0 = e.catch(5));
                    case 15:
                      document.location.href = t;
                    case 16:
                    case "end":
                      return e.stop();
                  }
              },
              e,
              null,
              [[5, 13]]
            );
          })
        )).apply(this, arguments);
      }
      return (0, Qe.jsx)(Qe.Fragment, {
        children:
          a &&
          (0, Qe.jsx)("div", {
            id: "top_promo",
            children: (function (e) {
              var n = e.organization,
                t = void 0 === n ? {} : n,
                o = (null == e ? void 0 : e.promo_details) || {},
                i = o.code,
                a = o.celebration_message,
                l = o.discount_price_message,
                s = o.duration_message,
                h = o.starts_at,
                m = o.ends_at,
                _ = t.wallet_credit,
                g = void 0 === _ ? {} : _,
                v = t || {},
                C = v.is_reseller_customer,
                b = void 0 !== C && C,
                x = v.subscription_type;
              !(function (e) {
                var n = e.promo_ends_at,
                  t = e.walletCredit,
                  r = e.promoCouponCode,
                  o = null;
                if ((t || r) && !o) {
                  var i;
                  i =
                    t && t.ends_at ? t.ends_at : t ? "2023-02-26T17:33:29Z" : n;
                  var a = new Date(i).getTime();
                  o = setInterval(function () {
                    var e = new Date().getTime(),
                      n = a - e,
                      t = null,
                      r = null,
                      i = null,
                      l = null;
                    n > 0
                      ? ((t = Math.floor(n / 864e5)),
                        (r = Math.floor((n % 864e5) / 36e5)),
                        (i = Math.floor((n % 36e5) / 6e4)),
                        (l = Math.floor((n % 6e4) / 1e3)))
                      : ((t = ""),
                        (r = ""),
                        (i = ""),
                        (l = ""),
                        clearInterval(o)),
                      u(
                        null == t || ("" == t && "" == r && "" == i && "" == l)
                          ? ""
                          : ""
                              .concat(t, "d ")
                              .concat(r, "h ")
                              .concat(i, "m ")
                              .concat(l, "s")
                      );
                  }, 1e3);
                }
              })({ promoCouponCode: i, walletCredit: g, promo_ends_at: m });
              var y,
                w = (0, Qe.jsx)(Qe.Fragment, {});
              if (g) {
                var k = g.credit,
                  L = g.ends_at,
                  j = g.checkout_products;
                w = (0, Qe.jsxs)("div", {
                  className: "ltch-promo-banner-container ltch-wallet-promo",
                  children: [
                    (0, Qe.jsx)(mr, {
                      className: "ltch-wallet-promo-icon",
                      type: ne.WALLET,
                    }),
                    (0, Qe.jsxs)("span", {
                      className: "wallet__promo__banner",
                      children: ["Yayy.. You got $$", k, " in your wallet!"],
                    }),
                    (0, Qe.jsxs)("span", {
                      className: "wallet__promo__banner__msg",
                      id: "wallet_promo_banner_title",
                      onClick:
                        ((y = j),
                        function () {
                          var e = ""
                            .concat(ve(Z), "/checkout?plans=")
                            .concat(y);
                          window.open(e, "_self");
                        }),
                      children: [" ", "Redeem your credits before it expires"],
                    }),
                    L &&
                      (0, Qe.jsx)("span", { id: "promoCounter", children: c }),
                    (0, Qe.jsx)("span", {
                      className: "wallet_promo_banner_celebration",
                      children: "🎉🎉",
                    }),
                  ],
                });
              } else
                i &&
                  "" != i &&
                  "Paid" != x &&
                  Date.parse(h) <= new Date().getTime() &&
                  (w = (0, Qe.jsxs)("div", {
                    className: "ltch-promo-banner-container",
                    children: [
                      (0, Qe.jsx)("div", {
                        className: "ltch-promo-wrapper",
                        children: (0, Qe.jsxs)("span", {
                          id: "promoEntireDivTop",
                          onClick: f,
                          children: [
                            a,
                            (0, Qe.jsx)("span", {
                              className: "ltch-promo-discount",
                              children: l,
                            }),
                            (0, Qe.jsx)("span", {
                              className: "ltch-promo-duration",
                              children: s,
                            }),
                            !b &&
                              (0, Qe.jsxs)(Qe.Fragment, {
                                children: [
                                  (0, Qe.jsx)("span", {
                                    className: "ltch-promo-offer-separator",
                                    children: "|",
                                  }),
                                  (0, Qe.jsx)("span", {
                                    className: "ltch-promo-offer-claim",
                                    onClick: f,
                                    tabIndex: r,
                                    "aria-label": "Claim Now",
                                    role: "button",
                                    onKeyDown: function (e) {
                                      "Enter" === e.key && f();
                                    },
                                    children: "Claim Now",
                                  }),
                                  (0, Qe.jsx)("span", {
                                    className: "ltch-promo-offer-celebration",
                                    children: "🚀🚀",
                                  }),
                                ],
                              }),
                            "( Expires In:",
                            " ",
                            (0, Qe.jsxs)("span", {
                              id: "promoCounter",
                              role: "presentation",
                              children: [c, " )"],
                            }),
                          ],
                        }),
                      }),
                      (0, Qe.jsx)("span", {
                        "aria-label": "Close",
                        id: "close_top_promo",
                        onClick: p,
                        tabIndex: r,
                        role: "button",
                        onKeyDown: function (e) {
                          "Enter" === e.key && p();
                        },
                        children: "X",
                      }),
                    ],
                  }));
              if (d.current <= 30) {
                var E = new Event("TopPromoInitialized", { bubbles: !0 });
                window.dispatchEvent(E), (d.current += 1);
              }
              return w;
            })(o),
          }),
      });
    }
    function Rr(e, n) {
      (null == n || n > e.length) && (n = e.length);
      for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
      return r;
    }
    function Hr(n) {
      var t,
        r,
        o = n.msg,
        i = void 0 === o ? "" : o,
        a = n.showToast,
        l = n.error,
        s = void 0 !== l && l,
        c =
          ((t = (0, e.useState)(!1)),
          (r = 2),
          (function (e) {
            if (Array.isArray(e)) return e;
          })(t) ||
            (function (e, n) {
              var t =
                null == e
                  ? null
                  : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                    e["@@iterator"];
              if (null != t) {
                var r,
                  o,
                  i = [],
                  a = !0,
                  l = !1;
                try {
                  for (
                    t = t.call(e);
                    !(a = (r = t.next()).done) &&
                    (i.push(r.value), !n || i.length !== n);
                    a = !0
                  );
                } catch (e) {
                  (l = !0), (o = e);
                } finally {
                  try {
                    a || null == t.return || t.return();
                  } finally {
                    if (l) throw o;
                  }
                }
                return i;
              }
            })(t, r) ||
            (function (e, n) {
              if (e) {
                if ("string" == typeof e) return Rr(e, n);
                var t = Object.prototype.toString.call(e).slice(8, -1);
                return (
                  "Object" === t && e.constructor && (t = e.constructor.name),
                  "Map" === t || "Set" === t
                    ? Array.from(e)
                    : "Arguments" === t ||
                      /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
                    ? Rr(e, n)
                    : void 0
                );
              }
            })(t, r) ||
            (function () {
              throw new TypeError(
                "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            })()),
        u = c[0],
        d = c[1];
      return (
        (0, e.useEffect)(
          function () {
            d(a);
          },
          [a]
        ),
        (0, Qe.jsx)(Qe.Fragment, {
          children:
            u &&
            (0, Qe.jsx)("div", {
              className: "".concat(
                s ? "ltch-toast-wrapper_error" : "",
                " ltch-toast-wrapper"
              ),
              children: (0, Qe.jsxs)("div", {
                className: "ltch-flex",
                children: [
                  (0, Qe.jsx)(mr, {
                    className: "ltch-toast-icon",
                    type: s ? ne.CROSS_RED : ne.TICK,
                  }),
                  (0, Qe.jsxs)("div", {
                    className: "toastMessage",
                    children: [
                      i,
                      (0, Qe.jsx)("span", {
                        className: "ltch-toast-close-icon",
                        onClick: function () {
                          d(function (e) {
                            return !e;
                          });
                        },
                        children: "X",
                      }),
                    ],
                  }),
                ],
              }),
            }),
        })
      );
    }
    var Vr = t().memo(Hr);
    function Dr(e, n) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, n) {
          var t =
            null == e
              ? null
              : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                e["@@iterator"];
          if (null != t) {
            var r,
              o,
              i = [],
              a = !0,
              l = !1;
            try {
              for (
                t = t.call(e);
                !(a = (r = t.next()).done) &&
                (i.push(r.value), !n || i.length !== n);
                a = !0
              );
            } catch (e) {
              (l = !0), (o = e);
            } finally {
              try {
                a || null == t.return || t.return();
              } finally {
                if (l) throw o;
              }
            }
            return i;
          }
        })(e, n) ||
        (function (e, n) {
          if (e) {
            if ("string" == typeof e) return Br(e, n);
            var t = Object.prototype.toString.call(e).slice(8, -1);
            return (
              "Object" === t && e.constructor && (t = e.constructor.name),
              "Map" === t || "Set" === t
                ? Array.from(e)
                : "Arguments" === t ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
                ? Br(e, n)
                : void 0
            );
          }
        })(e, n) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        })()
      );
    }
    function Br(e, n) {
      (null == n || n > e.length) && (n = e.length);
      for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
      return r;
    }
    function Wr(n) {
      var t,
        r = n.onClose,
        o = void 0 === r ? void 0 : r,
        i = n.defaultTabIndex,
        a = n.doShow,
        l = void 0 !== a && a,
        s = n.userInfo,
        c = (0, e.useRef)([]),
        u = (0, e.useRef)(),
        d = s.email,
        p = s.apiToken,
        f = s.username,
        h = (s.id, Dr((0, e.useState)("website"), 2)),
        m = h[0],
        _ = h[1],
        g = function (e) {
          _(e.target.value);
        },
        v = ""
          .concat(Ee() ? "" : "./", "LT --user ")
          .concat(d, " --key ")
          .concat(p),
        C = ""
          .concat(Ee() ? "" : "./", "LT --user ")
          .concat(d, " --key ")
          .concat(p, " --dir /home/lambda"),
        b = Dr(
          (0, e.useState)({
            tunnel_command_website: !1,
            tunnel_command_folder: !1,
          }),
          2
        ),
        x = b[0],
        y = b[1],
        w = Dr((0, e.useState)("command_line"), 2),
        k = w[0],
        L = w[1],
        j = function () {
          L("command_line" == k ? "desktop_app" : "command_line");
        },
        E = function (e) {
          var n = u.current.getElementsByClassName("ltch-tunnel-tabname")[1];
          Ve(
            e,
            "tunnel_dropdown_hide",
            n && n.parentElement && n.parentElement.tabIndex > -1
              ? "ltch-configure-tunnel-more-details-desktop-tab"
              : "ltch-configure-tunnel-more-details",
            "tunnel__dropdown__toggle__configure",
            u.current
          ),
            "Escape" === e.key && o();
        };
      return (
        (0, e.useEffect)(
          function () {
            var e = u.current;
            return (
              l &&
                (e.getElementsByClassName("tunnel_dropdown_hide")[0].focus(),
                e.addEventListener("keydown", E)),
              function () {
                return e.removeEventListener("keydown", E);
              }
            );
          },
          [l]
        ),
        (0, Qe.jsxs)("div", {
          "aria-labelledby": "lt-tunnel-local-connection",
          "aria-modal": "true",
          className: "lt-dropdown-menu ".concat(
            l ? "open ltch-tunnel-modal-wrapper" : ""
          ),
          id: "tunnel__dropdown__menu__configure",
          role: "dialog",
          ref: u,
          children: [
            !l && (0, Qe.jsx)("div", { className: "tunnel_overlay" }),
            (0, Qe.jsxs)("div", {
              className: "tunnel__dropdown__header",
              children: [
                (0, Qe.jsx)("h4", {
                  id: "lt-tunnel-local-connection",
                  children: "Local Connection",
                }),
                (0, Qe.jsx)("span", {
                  className: "tunnel_dropdown_hide",
                  id: "tunnel__dropdown__toggle__configure--hide",
                  tabIndex: i,
                  role: "button",
                  "aria-label": "Close tunnel dropdown",
                  onClick: function () {
                    o();
                  },
                  onKeyDown: function (e) {
                    "Enter" === e.key && o();
                  },
                  children: (0, Qe.jsx)(mr, { type: ne.PLAIN_CROSS }),
                }),
              ],
            }),
            (0, Qe.jsxs)("div", {
              className: "tunnel__dropdown__tabs",
              children: [
                (0, Qe.jsxs)("ul", {
                  className: "lt-nav lt-nav-tabs",
                  role: "tablist",
                  "aria-labelledby": "lt-tunnel-local-connection",
                  children: [
                    (0, Qe.jsx)("li", {
                      role: "tab",
                      "aria-controls": "lt-tab-content-command_line",
                      id: "command_line",
                      "aria-selected": "command_line" == k,
                      onClick: j,
                      ref: function (e) {
                        return (c.current[0] = e);
                      },
                      tabIndex: "command_line" == k ? i : -1,
                      onKeyDown: function (e) {
                        "Enter" === e.key
                          ? j()
                          : Be({ tabRef: c, index: 0, lastIndex: 1, event: e });
                      },
                      children: (0, Qe.jsx)("div", {
                        id: "toggle__tunnel__dropdown__tab__1",
                        className: "".concat(
                          "command_line" == k ? "active" : "",
                          " ltch-tunnel-tabname"
                        ),
                        "data-amplitude": "H_tunnel_cl",
                        children: "Command Line",
                      }),
                    }),
                    (0, Qe.jsx)("li", {
                      role: "tab",
                      id: "desktop_app",
                      "aria-controls": "lt-tab-content-desktop_app",
                      "aria-selected": "desktop_app" === k,
                      ref: function (e) {
                        return (c.current[1] = e);
                      },
                      onClick: j,
                      tabIndex: "desktop_app" == k ? i : -1,
                      onKeyDown: function (e) {
                        "Enter" === e.key
                          ? j()
                          : Be({ tabRef: c, index: 1, lastIndex: 1, event: e });
                      },
                      children: (0, Qe.jsx)("div", {
                        id: "toggle__tunnel__dropdown__tab__2",
                        className: "".concat(
                          "desktop_app" == k ? "active" : "",
                          " ltch-tunnel-tabname"
                        ),
                        "data-amplitude": "H_tunnel_app",
                        children: "Desktop App",
                      }),
                    }),
                  ],
                }),
                (0, Qe.jsx)("div", {
                  id: "lt-tab-content-command_line",
                  className: "lt-tab-content",
                  style: { display: "command_line" === k ? "block" : "none" },
                  role: "tabpanel",
                  "aria-labelledby": "command_line",
                  children: (0, Qe.jsxs)("div", {
                    className: "lt-tab-pane open",
                    id: "tunnel__dropdown__tab__1",
                    children: [
                      (0, Qe.jsxs)("div", {
                        className: "part__1",
                        children: [
                          (0, Qe.jsxs)("div", {
                            className: "access_key_group",
                            children: [
                              (0, Qe.jsxs)("span", {
                                className: "access__key_code",
                                id: "access__key",
                                children: [
                                  (0, Qe.jsx)("span", {
                                    children: ""
                                      .concat(Ee() ? "" : "./", "LT --user ")
                                      .concat(d, " --key ")
                                      .concat(p, " "),
                                  }),
                                  "folder" === m ? "--dir /home/lambda" : "",
                                ],
                              }),
                              (0, Qe.jsx)("button", {
                                "aria-label": "".concat(
                                  x.tunnel_command_folder ||
                                    x.tunnel_command_website
                                    ? "Copied"
                                    : "Copy",
                                  " Command Line Instructions for accessing tunnel"
                                ),
                                className: "access__key__btn",
                                id: "access__key__btn",
                                "data-amplitude": "H_tunnel_cl_copy",
                                onClick: function () {
                                  "website" === m
                                    ? Te(v, "tunnel_command_website", y)
                                    : Te(C, "tunnel_command_folder", y),
                                    setTimeout(function () {
                                      document
                                        .getElementById("access__key__btn")
                                        .focus();
                                    }, 100);
                                },
                                tabIndex: i,
                                style: { cursor: "pointer" },
                                children:
                                  x.tunnel_command_website ||
                                  x.tunnel_command_folder
                                    ? "Copied"
                                    : "Copy",
                              }),
                            ],
                          }),
                          (0, Qe.jsx)("div", {
                            className: "clearfix access__key__type_radio",
                            children: (0, Qe.jsxs)("fieldset", {
                              className: "ltch-tunnel-fieldset",
                              children: [
                                (0, Qe.jsx)("legend", {
                                  className: "ltch-tunnel-legend",
                                  children: "Tunnel Config",
                                }),
                                (0, Qe.jsx)("div", {
                                  className: "form-check-inline",
                                  children: (0, Qe.jsxs)("label", {
                                    className: "form-check-label",
                                    htmlFor: "connType__website",
                                    tabIndex: -1,
                                    children: [
                                      (0, Qe.jsx)("input", {
                                        "aria-checked": "website" === m,
                                        checked: "website" === m,
                                        className:
                                          "ltch-form-check-input connType__radio",
                                        "data-amplitude": "H_tunnel_cl_website",
                                        id: "connType__website",
                                        name: "connType",
                                        onChange: function (e) {
                                          return g(e);
                                        },
                                        type: "radio",
                                        value: "website",
                                        tabIndex: i,
                                      }),
                                      "Internal Website",
                                    ],
                                  }),
                                }),
                                (0, Qe.jsx)("div", {
                                  className: "form-check-inline",
                                  children: (0, Qe.jsxs)("label", {
                                    className: "form-check-label",
                                    htmlFor: "connType__folder",
                                    tabIndex: -1,
                                    children: [
                                      (0, Qe.jsx)("input", {
                                        "aria-checked": "folder" === m,
                                        checked: "folder" === m,
                                        className:
                                          "ltch-form-check-input connType__radio",
                                        "data-amplitude": "H_tunnel_cl_folder",
                                        id: "connType__folder",
                                        name: "connType",
                                        onChange: function (e) {
                                          return g(e);
                                        },
                                        type: "radio",
                                        value: "folder",
                                        tabIndex: i,
                                      }),
                                      "Folder",
                                    ],
                                  }),
                                }),
                              ],
                            }),
                          }),
                        ],
                      }),
                      (0, Qe.jsx)("div", {
                        className: "part__2",
                        children: (0, Qe.jsxs)("div", {
                          className: "more__info",
                          children: [
                            (0, Qe.jsx)("h3", {
                              children:
                                "Running the binary from the command line:",
                            }),
                            (0, Qe.jsxs)("ul", {
                              children: [
                                (0, Qe.jsxs)("li", {
                                  children: [
                                    " ",
                                    "Download the binary file:",
                                    " ",
                                    (0, Qe.jsx)("a", {
                                      id: "downloadBinaryLink",
                                      href:
                                        ((t = ve(U, !0)),
                                        Ee()
                                          ? "".concat(
                                              t,
                                              "/tunnel/v3/windows/64bit/LT_Windows.zip"
                                            )
                                          : Se()
                                          ? "".concat(
                                              t,
                                              "/tunnel/v3/linux/64bit/LT_Linux.zip"
                                            )
                                          : navigator.platform.indexOf(
                                              "FreeBSD"
                                            ) >= 0 ||
                                            navigator.appVersion.indexOf(
                                              "FreeBSD"
                                            ) >= 0
                                          ? "".concat(
                                              t,
                                              "/tunnel/v3/freebsd/64bit/LT_Freebsd.zip"
                                            )
                                          : "".concat(
                                              t,
                                              "/tunnel/v3/mac/64bit/LT_Mac.zip"
                                            )),
                                      "data-amplitude":
                                        "H_tunnel_cl_downloadLink",
                                      tabIndex: i,
                                      children: "Download Link",
                                    }),
                                  ],
                                }),
                                (0, Qe.jsx)("li", {
                                  children: "Extract it to a folder",
                                }),
                                (0, Qe.jsxs)("li", {
                                  children: [
                                    " ",
                                    "Open up terminal and navigate to the extracted folder.",
                                    " ",
                                  ],
                                }),
                                (0, Qe.jsx)("li", {
                                  id: "command__info__li",
                                  children:
                                    "website" == m
                                      ? "Run the command given above"
                                      : "In the command given above, replace the folder path. Run",
                                }),
                                (0, Qe.jsx)("li", {
                                  children: (0, Qe.jsxs)("p", {
                                    style: { margin: "0px" },
                                    children: [
                                      "More Details",
                                      " ",
                                      (0, Qe.jsx)("a", {
                                        "aria-label":
                                          "More details here about Steps to configure Tunnel via command line",
                                        id: "ltch-configure-tunnel-more-details",
                                        className:
                                          "ltch-configure-tunnel-more-details",
                                        href: "https://www.lambdatest.com/secure-shell-tunnel",
                                        rel: "noreferrer",
                                        target: "_blank",
                                        "data-amplitude":
                                          "H_tunnel_cl_supportDoc",
                                        tabIndex: i,
                                        children: "Here",
                                      }),
                                    ],
                                  }),
                                }),
                              ],
                            }),
                          ],
                        }),
                      }),
                    ],
                  }),
                }),
                (0, Qe.jsx)("div", {
                  className: "lt-tab-content",
                  id: "lt-tab-content-desktop_app",
                  role: "tabpanel",
                  "aria-labelledby": "desktop_app",
                  style: { display: "desktop_app" === k ? "block" : "none" },
                  children: (0, Qe.jsxs)("div", {
                    className: "lt-tab-pane open",
                    id: "tunnel__dropdown__tab__2",
                    children: [
                      (0, Qe.jsx)("div", {
                        className: "part__1",
                        children: (0, Qe.jsxs)("div", {
                          className: "app__download__link",
                          children: [
                            (0, Qe.jsx)("h3", {
                              id: "tunnel__app_heading",
                              children:
                                "Already have the app installed? Click on launch button or else please Download",
                            }),
                            (0, Qe.jsxs)("ul", {
                              className: "ltch-tunnel-btn-download-container",
                              children: [
                                (0, Qe.jsx)("li", {
                                  children: (0, Qe.jsxs)("a", {
                                    href: "https://www.lambdatest.com/underpass/magic-link?user="
                                      .concat(f, "&token=")
                                      .concat(p),
                                    id: "launch__tunnel__app",
                                    className: "app__link__btn",
                                    rel: "noreferrer",
                                    target: "_blank",
                                    "data-amplitude": "H_tunnel_app_launch",
                                    tabIndex: i,
                                    children: [
                                      (0, Qe.jsx)("span", {
                                        children: "Launch App",
                                      }),
                                      (0, Qe.jsx)(mr, { type: ne.ROCKET }),
                                    ],
                                  }),
                                }),
                                (0, Qe.jsx)("li", {
                                  children: (0, Qe.jsxs)("a", {
                                    href: je(),
                                    id: "download__tunnel__app",
                                    className:
                                      "app__link__btn app__link__btn--outline",
                                    "data-amplitude": "H_tunnel_app_download",
                                    tabIndex: i,
                                    children: [
                                      (0, Qe.jsx)("span", {
                                        children: "Download",
                                      }),
                                      (0, Qe.jsx)(mr, { type: ne.DOWNLOAD }),
                                    ],
                                  }),
                                }),
                              ],
                            }),
                          ],
                        }),
                      }),
                      (0, Qe.jsx)("div", {
                        className: "part__2",
                        children: (0, Qe.jsxs)("div", {
                          className: "more__info",
                          children: [
                            (0, Qe.jsx)("h3", {
                              children: "Steps to use Lambda Tunnel App :",
                            }),
                            (0, Qe.jsxs)("ul", {
                              children: [
                                (0, Qe.jsx)("li", {
                                  children:
                                    " Download and Install it in your local system ",
                                }),
                                (0, Qe.jsx)("li", {
                                  children:
                                    "Login using any preferred login method - Email and Password, Google, GitHub or SSO.",
                                }),
                                (0, Qe.jsx)("li", {
                                  children:
                                    "Run local tunnel using the start button",
                                }),
                                (0, Qe.jsx)("li", {
                                  children: (0, Qe.jsxs)("p", {
                                    style: { margin: "0px" },
                                    children: [
                                      "More Details",
                                      " ",
                                      (0, Qe.jsx)("a", {
                                        "aria-label":
                                          "More details here about Steps to configure Tunnel via Desktop app",
                                        className:
                                          "ltch-configure-tunnel-more-details ltch-configure-tunnel-more-details-desktop-tab",
                                        href: " https://www.lambdatest.com/support/docs/underpass-tunnel-application/",
                                        rel: "noreferrer",
                                        target: "_blank",
                                        "data-amplitude":
                                          "H_tunnel_app_supportDoc",
                                        tabIndex: i,
                                        children: "Here",
                                      }),
                                    ],
                                  }),
                                }),
                              ],
                            }),
                          ],
                        }),
                      }),
                    ],
                  }),
                }),
              ],
            }),
          ],
        })
      );
    }
    function zr(n) {
      var t = n.doShow,
        r = n.handleTunnelConfigClick,
        o = void 0 === r ? void 0 : r,
        i = n.stopTunnel,
        a = n.loadBalancedTunnelCount,
        l = n.tunnels,
        s = n.userInfo,
        c = (s.email, s.id),
        u = (0, e.useRef)(),
        d = function (e) {
          return c == e.user_id;
        },
        p = function (e) {
          Ve(
            e,
            "tunnel__dropdown__toggle__configure2",
            "view__all__tunnels",
            "tunnel__dropdown__toggle__list",
            u.current
          );
        };
      return (
        (0, e.useEffect)(
          function () {
            var e = u.current;
            return (
              t &&
                (setTimeout(function () {
                  e.getElementsByTagName("button")[0].focus();
                }, 100),
                e.addEventListener("keydown", p)),
              function () {
                e.removeEventListener("keydown", p);
              }
            );
          },
          [t]
        ),
        (0, Qe.jsxs)("div", {
          className: "lt-dropdown-menu ".concat(
            t ? "open ltch-tunnel-modal-wrapper" : ""
          ),
          id: "tunnel__dropdown__menu__list",
          role: "dialog",
          ref: u,
          children: [
            !t && (0, Qe.jsx)("div", { className: "tunnel_overlay" }),
            (0, Qe.jsx)("div", {
              className: "configure__new__tunnel",
              children: (0, Qe.jsx)("button", {
                className:
                  "configure__new__tunnel__btn tunnel__dropdown__toggle__configure2",
                id: "tunnel__dropdown__toggle__configure2",
                onClick: o,
                children: "Configure New Tunnel",
              }),
            }),
            (0, Qe.jsx)("div", {
              id: "tunnel__list__container",
              children: l.map(function (e) {
                return (0, Qe.jsxs)(
                  "div",
                  {
                    className: "tunnel__list__li",
                    id: "tunnel".concat(e.tunnel_id),
                    children: [
                      (0, Qe.jsxs)("span", {
                        children: [
                          e.tunnel_name,
                          e.load_balanced
                            ? (0, Qe.jsxs)("b", {
                                className: "tunnel__load__balanced__flag",
                                children: ["Load Balanced ", a(e)],
                              })
                            : "",
                        ],
                      }),
                      e.load_balanced
                        ? ""
                        : (0, Qe.jsx)(Qe.Fragment, {
                            children: d(e)
                              ? (0, Qe.jsx)("span", {
                                  className: "tunnel__close__btn",
                                  title: "Close Tunnel",
                                  onClick: function () {
                                    return i(e.tunnel_id);
                                  },
                                  onKeyDown: function (n) {
                                    ("Enter" !== n.key && " " !== n.key) ||
                                      i(e.tunnel_id);
                                  },
                                  "aria-label": "Close Tunnel",
                                  role: "button",
                                  tabIndex: 0,
                                  children: (0, Qe.jsx)(mr, {
                                    type: ne.CROSS_RED,
                                  }),
                                })
                              : (0, Qe.jsx)("span", {
                                  className:
                                    "tunnel__close__btn tunnel__close__btn__disabled",
                                  title:
                                    "Only owner can stop the shared tunnel",
                                  tabIndex: 0,
                                  children: (0, Qe.jsx)(mr, {
                                    type: ne.CROSS_GRAY,
                                  }),
                                }),
                          }),
                    ],
                  },
                  "tunnel-item-".concat(e.tunnel_id)
                );
              }),
            }),
            (0, Qe.jsx)("a", {
              href: "".concat(ve(F), "/").concat("tunnels"),
              className: "view__all__tunnels",
              children: "VIEW ALL",
            }),
          ],
        })
      );
    }
    var Zr = ["renderAsList", "children"];
    function Fr(e, n) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n &&
          (r = r.filter(function (n) {
            return Object.getOwnPropertyDescriptor(e, n).enumerable;
          })),
          t.push.apply(t, r);
      }
      return t;
    }
    function Ur(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2
          ? Fr(Object(t), !0).forEach(function (n) {
              Kr(e, n, t[n]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : Fr(Object(t)).forEach(function (n) {
              Object.defineProperty(
                e,
                n,
                Object.getOwnPropertyDescriptor(t, n)
              );
            });
      }
      return e;
    }
    function Kr(e, n, t) {
      return (
        n in e
          ? Object.defineProperty(e, n, {
              value: t,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[n] = t),
        e
      );
    }
    var Gr = function (e) {
      var n = e.renderAsList,
        t = e.children,
        r = (function (e, n) {
          if (null == e) return {};
          var t,
            r,
            o = (function (e, n) {
              if (null == e) return {};
              var t,
                r,
                o = {},
                i = Object.keys(e);
              for (r = 0; r < i.length; r++)
                (t = i[r]), n.indexOf(t) >= 0 || (o[t] = e[t]);
              return o;
            })(e, n);
          if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            for (r = 0; r < i.length; r++)
              (t = i[r]),
                n.indexOf(t) >= 0 ||
                  (Object.prototype.propertyIsEnumerable.call(e, t) &&
                    (o[t] = e[t]));
          }
          return o;
        })(e, Zr);
      return n
        ? (0, Qe.jsx)("li", {
            children: (0, Qe.jsx)("div", Ur(Ur({}, r), {}, { children: t })),
          })
        : (0, Qe.jsx)("div", Ur(Ur({}, r), {}, { children: t }));
    };
    function Yr(n) {
      var t = n.addTooltipOverlay,
        o = void 0 !== t && t,
        i = n.classToAdd,
        a = n.currentSubscriptionType,
        l = n.defaultTabIndex,
        s = void 0 === l ? 0 : l,
        c = n.eventNameToUse,
        u = void 0 === c ? "H_upgrade_free" : c,
        d = n.isResellerCustomer,
        p = void 0 !== d && d,
        f = n.organizationRole,
        h = n.upgradeBtnTextToDisplay,
        m = void 0 === h ? "" : h,
        _ = n.renderAsList,
        g = void 0 !== _ && _,
        v = ((0, e.useContext)(r) || {}).isHighContrastThemeEnabled,
        C = void 0 !== v && v,
        b = function (e) {
          Re(u, { variant: m || "Upgrade Now", url: window.location.href });
          var n = window.location.host,
            t = "".concat(ve(Z), "/").concat(D),
            r = "";
          "free" === e.toLowerCase() &&
            (n.includes(K)
              ? (r = "?group=3")
              : n.includes(q)
              ? (r = "?group=2")
              : n.includes(z) || n.includes(W)
              ? (r = "?group=1")
              : n.includes(J) && (r = "?group=4")),
            window.open("".concat(t).concat(r), "_self");
        };
      if (f && "Admin" === f && !p) {
        var x =
          "paid" === a.toLowerCase() ? "Upgrade" : "" !== m ? m : "Upgrade Now";
        return (0, Qe.jsx)(Gr, {
          renderAsList: g,
          className:
            "aside__menu__item__bottom aside__menu__item__bottom-upgrade "
              .concat(
                "paid" === a.toLowerCase()
                  ? "aside__menu__item__bottom-upgrade-paid"
                  : "",
                " "
              )
              .concat(C ? "ltch-high-contrast-item" : "", " ")
              .concat(i),
          onClick: function () {
            return b(a);
          },
          onKeyDown: function (e) {
            "Enter" === e.key && b(a);
          },
          tabIndex: s,
          role: "button",
          "aria-label": x,
          children: (0, Qe.jsxs)("div", {
            className: "aside__menu__item__bottom__link",
            children: [
              (0, Qe.jsx)(mr, {
                className: "aside__menu__item__bottom__icon ltch-upgrade-icon",
                color: "paid" === a.toLowerCase() ? "#ef6c00" : "#e9ecec",
                type: ne.UPGRADE,
              }),
              (0, Qe.jsx)("span", {
                className: "ltch-upgrade-btn-text",
                children: x,
              }),
              o &&
                (0, Qe.jsx)("span", {
                  className: "ltch-upgrade-btn-tooltip-overlay",
                  children: x,
                }),
            ],
          }),
        });
      }
      return (0, Qe.jsx)(Qe.Fragment, {});
    }
    function $r() {
      return (
        ($r = Object.assign
          ? Object.assign.bind()
          : function (e) {
              for (var n = 1; n < arguments.length; n++) {
                var t = arguments[n];
                for (var r in t)
                  Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
              }
              return e;
            }),
        $r.apply(this, arguments)
      );
    }
    function qr(e, n, { checkForDefaultPrevented: t = !0 } = {}) {
      return function (r) {
        if ((null == e || e(r), !1 === t || !r.defaultPrevented))
          return null == n ? void 0 : n(r);
      };
    }
    function Qr(...e) {
      return (n) =>
        e.forEach((e) =>
          (function (e, n) {
            "function" == typeof e ? e(n) : null != e && (e.current = n);
          })(e, n)
        );
    }
    function Xr(...n) {
      return (0, e.useCallback)(Qr(...n), n);
    }
    function Jr(n, t = []) {
      let r = [];
      const o = () => {
        const t = r.map((n) => (0, e.createContext)(n));
        return function (r) {
          const o = (null == r ? void 0 : r[n]) || t;
          return (0, e.useMemo)(
            () => ({ [`__scope${n}`]: { ...r, [n]: o } }),
            [r, o]
          );
        };
      };
      return (
        (o.scopeName = n),
        [
          function (t, o) {
            const i = (0, e.createContext)(o),
              a = r.length;
            function l(t) {
              const { scope: r, children: o, ...l } = t,
                s = (null == r ? void 0 : r[n][a]) || i,
                c = (0, e.useMemo)(() => l, Object.values(l));
              return (0, e.createElement)(s.Provider, { value: c }, o);
            }
            return (
              (r = [...r, o]),
              (l.displayName = t + "Provider"),
              [
                l,
                function (r, l) {
                  const s = (null == l ? void 0 : l[n][a]) || i,
                    c = (0, e.useContext)(s);
                  if (c) return c;
                  if (void 0 !== o) return o;
                  throw new Error(`\`${r}\` must be used within \`${t}\``);
                },
              ]
            );
          },
          eo(o, ...t),
        ]
      );
    }
    function eo(...n) {
      const t = n[0];
      if (1 === n.length) return t;
      const r = () => {
        const r = n.map((e) => ({ useScope: e(), scopeName: e.scopeName }));
        return function (n) {
          const o = r.reduce(
            (e, { useScope: t, scopeName: r }) => ({
              ...e,
              ...t(n)[`__scope${r}`],
            }),
            {}
          );
          return (0, e.useMemo)(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
        };
      };
      return (r.scopeName = t.scopeName), r;
    }
    var no = o(935);
    const to = (0, e.forwardRef)((n, t) => {
      const { children: r, ...o } = n,
        i = e.Children.toArray(r),
        a = i.find(io);
      if (a) {
        const n = a.props.children,
          r = i.map((t) =>
            t === a
              ? e.Children.count(n) > 1
                ? e.Children.only(null)
                : (0, e.isValidElement)(n)
                ? n.props.children
                : null
              : t
          );
        return (0, e.createElement)(
          ro,
          $r({}, o, { ref: t }),
          (0, e.isValidElement)(n) ? (0, e.cloneElement)(n, void 0, r) : null
        );
      }
      return (0, e.createElement)(ro, $r({}, o, { ref: t }), r);
    });
    to.displayName = "Slot";
    const ro = (0, e.forwardRef)((n, t) => {
      const { children: r, ...o } = n;
      return (0, e.isValidElement)(r)
        ? (0, e.cloneElement)(r, {
            ...ao(o, r.props),
            ref: t ? Qr(t, r.ref) : r.ref,
          })
        : e.Children.count(r) > 1
        ? e.Children.only(null)
        : null;
    });
    ro.displayName = "SlotClone";
    const oo = ({ children: n }) => (0, e.createElement)(e.Fragment, null, n);
    function io(n) {
      return (0, e.isValidElement)(n) && n.type === oo;
    }
    function ao(e, n) {
      const t = { ...n };
      for (const r in n) {
        const o = e[r],
          i = n[r];
        /^on[A-Z]/.test(r)
          ? o && i
            ? (t[r] = (...e) => {
                i(...e), o(...e);
              })
            : o && (t[r] = o)
          : "style" === r
          ? (t[r] = { ...o, ...i })
          : "className" === r && (t[r] = [o, i].filter(Boolean).join(" "));
      }
      return { ...e, ...t };
    }
    const lo = [
      "a",
      "button",
      "div",
      "form",
      "h2",
      "h3",
      "img",
      "input",
      "label",
      "li",
      "nav",
      "ol",
      "p",
      "span",
      "svg",
      "ul",
    ].reduce((n, t) => {
      const r = (0, e.forwardRef)((n, r) => {
        const { asChild: o, ...i } = n,
          a = o ? to : t;
        return (
          (0, e.useEffect)(() => {
            window[Symbol.for("radix-ui")] = !0;
          }, []),
          (0, e.createElement)(a, $r({}, i, { ref: r }))
        );
      });
      return (r.displayName = `Primitive.${t}`), { ...n, [t]: r };
    }, {});
    function so(n) {
      const t = (0, e.useRef)(n);
      return (
        (0, e.useEffect)(() => {
          t.current = n;
        }),
        (0, e.useMemo)(
          () =>
            (...e) => {
              var n;
              return null === (n = t.current) || void 0 === n
                ? void 0
                : n.call(t, ...e);
            },
          []
        )
      );
    }
    const co = "dismissableLayer.update";
    let uo;
    const po = (0, e.createContext)({
        layers: new Set(),
        layersWithOutsidePointerEventsDisabled: new Set(),
        branches: new Set(),
      }),
      fo = (0, e.forwardRef)((n, t) => {
        var r;
        const {
            disableOutsidePointerEvents: o = !1,
            onEscapeKeyDown: i,
            onPointerDownOutside: a,
            onFocusOutside: l,
            onInteractOutside: s,
            onDismiss: c,
            ...u
          } = n,
          d = (0, e.useContext)(po),
          [p, f] = (0, e.useState)(null),
          h =
            null !== (r = null == p ? void 0 : p.ownerDocument) && void 0 !== r
              ? r
              : null === globalThis || void 0 === globalThis
              ? void 0
              : globalThis.document,
          [, m] = (0, e.useState)({}),
          _ = Xr(t, (e) => f(e)),
          g = Array.from(d.layers),
          [v] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1),
          C = g.indexOf(v),
          b = p ? g.indexOf(p) : -1,
          x = d.layersWithOutsidePointerEventsDisabled.size > 0,
          y = b >= C,
          w = (function (
            n,
            t = null === globalThis || void 0 === globalThis
              ? void 0
              : globalThis.document
          ) {
            const r = so(n),
              o = (0, e.useRef)(!1),
              i = (0, e.useRef)(() => {});
            return (
              (0, e.useEffect)(() => {
                const e = (e) => {
                    if (e.target && !o.current) {
                      const n = { originalEvent: e };
                      function a() {
                        mo("dismissableLayer.pointerDownOutside", r, n, {
                          discrete: !0,
                        });
                      }
                      "touch" === e.pointerType
                        ? (t.removeEventListener("click", i.current),
                          (i.current = a),
                          t.addEventListener("click", i.current, { once: !0 }))
                        : a();
                    } else t.removeEventListener("click", i.current);
                    o.current = !1;
                  },
                  n = window.setTimeout(() => {
                    t.addEventListener("pointerdown", e);
                  }, 0);
                return () => {
                  window.clearTimeout(n),
                    t.removeEventListener("pointerdown", e),
                    t.removeEventListener("click", i.current);
                };
              }, [t, r]),
              { onPointerDownCapture: () => (o.current = !0) }
            );
          })((e) => {
            const n = e.target,
              t = [...d.branches].some((e) => e.contains(n));
            y &&
              !t &&
              (null == a || a(e),
              null == s || s(e),
              e.defaultPrevented || null == c || c());
          }, h),
          k = (function (
            n,
            t = null === globalThis || void 0 === globalThis
              ? void 0
              : globalThis.document
          ) {
            const r = so(n),
              o = (0, e.useRef)(!1);
            return (
              (0, e.useEffect)(() => {
                const e = (e) => {
                  e.target &&
                    !o.current &&
                    mo(
                      "dismissableLayer.focusOutside",
                      r,
                      { originalEvent: e },
                      { discrete: !1 }
                    );
                };
                return (
                  t.addEventListener("focusin", e),
                  () => t.removeEventListener("focusin", e)
                );
              }, [t, r]),
              {
                onFocusCapture: () => (o.current = !0),
                onBlurCapture: () => (o.current = !1),
              }
            );
          })((e) => {
            const n = e.target;
            [...d.branches].some((e) => e.contains(n)) ||
              (null == l || l(e),
              null == s || s(e),
              e.defaultPrevented || null == c || c());
          }, h);
        return (
          (function (
            n,
            t = null === globalThis || void 0 === globalThis
              ? void 0
              : globalThis.document
          ) {
            const r = so(n);
            (0, e.useEffect)(() => {
              const e = (e) => {
                "Escape" === e.key && r(e);
              };
              return (
                t.addEventListener("keydown", e),
                () => t.removeEventListener("keydown", e)
              );
            }, [r, t]);
          })((e) => {
            b === d.layers.size - 1 &&
              (null == i || i(e),
              !e.defaultPrevented && c && (e.preventDefault(), c()));
          }, h),
          (0, e.useEffect)(() => {
            if (p)
              return (
                o &&
                  (0 === d.layersWithOutsidePointerEventsDisabled.size &&
                    ((uo = h.body.style.pointerEvents),
                    (h.body.style.pointerEvents = "none")),
                  d.layersWithOutsidePointerEventsDisabled.add(p)),
                d.layers.add(p),
                ho(),
                () => {
                  o &&
                    1 === d.layersWithOutsidePointerEventsDisabled.size &&
                    (h.body.style.pointerEvents = uo);
                }
              );
          }, [p, h, o, d]),
          (0, e.useEffect)(
            () => () => {
              p &&
                (d.layers.delete(p),
                d.layersWithOutsidePointerEventsDisabled.delete(p),
                ho());
            },
            [p, d]
          ),
          (0, e.useEffect)(() => {
            const e = () => m({});
            return (
              document.addEventListener(co, e),
              () => document.removeEventListener(co, e)
            );
          }, []),
          (0, e.createElement)(
            lo.div,
            $r({}, u, {
              ref: _,
              style: {
                pointerEvents: x ? (y ? "auto" : "none") : void 0,
                ...n.style,
              },
              onFocusCapture: qr(n.onFocusCapture, k.onFocusCapture),
              onBlurCapture: qr(n.onBlurCapture, k.onBlurCapture),
              onPointerDownCapture: qr(
                n.onPointerDownCapture,
                w.onPointerDownCapture
              ),
            })
          )
        );
      });
    function ho() {
      const e = new CustomEvent(co);
      document.dispatchEvent(e);
    }
    function mo(e, n, t, { discrete: r }) {
      const o = t.originalEvent.target,
        i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: t });
      n && o.addEventListener(e, n, { once: !0 }),
        r
          ? (function (e, n) {
              e && (0, no.flushSync)(() => e.dispatchEvent(n));
            })(o, i)
          : o.dispatchEvent(i);
    }
    const _o = Boolean(
        null === globalThis || void 0 === globalThis
          ? void 0
          : globalThis.document
      )
        ? e.useLayoutEffect
        : () => {},
      go = n["useId".toString()] || (() => {});
    let vo = 0;
    const Co = ["top", "right", "bottom", "left"],
      bo = Math.min,
      xo = Math.max,
      yo = Math.round,
      wo = Math.floor,
      ko = (e) => ({ x: e, y: e }),
      Lo = { left: "right", right: "left", bottom: "top", top: "bottom" },
      jo = { start: "end", end: "start" };
    function Eo(e, n, t) {
      return xo(e, bo(n, t));
    }
    function So(e, n) {
      return "function" == typeof e ? e(n) : e;
    }
    function Mo(e) {
      return e.split("-")[0];
    }
    function To(e) {
      return e.split("-")[1];
    }
    function No(e) {
      return "x" === e ? "y" : "x";
    }
    function Oo(e) {
      return "y" === e ? "height" : "width";
    }
    function Ao(e) {
      return ["top", "bottom"].includes(Mo(e)) ? "y" : "x";
    }
    function Io(e) {
      return No(Ao(e));
    }
    function Po(e) {
      return e.replace(/start|end/g, (e) => jo[e]);
    }
    function Ro(e) {
      return e.replace(/left|right|bottom|top/g, (e) => Lo[e]);
    }
    function Ho(e) {
      return "number" != typeof e
        ? (function (e) {
            return { top: 0, right: 0, bottom: 0, left: 0, ...e };
          })(e)
        : { top: e, right: e, bottom: e, left: e };
    }
    function Vo(e) {
      const { x: n, y: t, width: r, height: o } = e;
      return {
        width: r,
        height: o,
        top: t,
        left: n,
        right: n + r,
        bottom: t + o,
        x: n,
        y: t,
      };
    }
    function Do(e, n, t) {
      let { reference: r, floating: o } = e;
      const i = Ao(n),
        a = Io(n),
        l = Oo(a),
        s = Mo(n),
        c = "y" === i,
        u = r.x + r.width / 2 - o.width / 2,
        d = r.y + r.height / 2 - o.height / 2,
        p = r[l] / 2 - o[l] / 2;
      let f;
      switch (s) {
        case "top":
          f = { x: u, y: r.y - o.height };
          break;
        case "bottom":
          f = { x: u, y: r.y + r.height };
          break;
        case "right":
          f = { x: r.x + r.width, y: d };
          break;
        case "left":
          f = { x: r.x - o.width, y: d };
          break;
        default:
          f = { x: r.x, y: r.y };
      }
      switch (To(n)) {
        case "start":
          f[a] -= p * (t && c ? -1 : 1);
          break;
        case "end":
          f[a] += p * (t && c ? -1 : 1);
      }
      return f;
    }
    async function Bo(e, n) {
      var t;
      void 0 === n && (n = {});
      const { x: r, y: o, platform: i, rects: a, elements: l, strategy: s } = e,
        {
          boundary: c = "clippingAncestors",
          rootBoundary: u = "viewport",
          elementContext: d = "floating",
          altBoundary: p = !1,
          padding: f = 0,
        } = So(n, e),
        h = Ho(f),
        m = l[p ? ("floating" === d ? "reference" : "floating") : d],
        _ = Vo(
          await i.getClippingRect({
            element:
              null ==
                (t = await (null == i.isElement ? void 0 : i.isElement(m))) || t
                ? m
                : m.contextElement ||
                  (await (null == i.getDocumentElement
                    ? void 0
                    : i.getDocumentElement(l.floating))),
            boundary: c,
            rootBoundary: u,
            strategy: s,
          })
        ),
        g =
          "floating" === d
            ? { x: r, y: o, width: a.floating.width, height: a.floating.height }
            : a.reference,
        v = await (null == i.getOffsetParent
          ? void 0
          : i.getOffsetParent(l.floating)),
        C = ((await (null == i.isElement ? void 0 : i.isElement(v))) &&
          (await (null == i.getScale ? void 0 : i.getScale(v)))) || {
          x: 1,
          y: 1,
        },
        b = Vo(
          i.convertOffsetParentRelativeRectToViewportRelativeRect
            ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
                elements: l,
                rect: g,
                offsetParent: v,
                strategy: s,
              })
            : g
        );
      return {
        top: (_.top - b.top + h.top) / C.y,
        bottom: (b.bottom - _.bottom + h.bottom) / C.y,
        left: (_.left - b.left + h.left) / C.x,
        right: (b.right - _.right + h.right) / C.x,
      };
    }
    function Wo(e, n) {
      return {
        top: e.top - n.height,
        right: e.right - n.width,
        bottom: e.bottom - n.height,
        left: e.left - n.width,
      };
    }
    function zo(e) {
      return Co.some((n) => e[n] >= 0);
    }
    function Zo() {
      return "undefined" != typeof window;
    }
    function Fo(e) {
      return Go(e) ? (e.nodeName || "").toLowerCase() : "#document";
    }
    function Uo(e) {
      var n;
      return (
        (null == e || null == (n = e.ownerDocument) ? void 0 : n.defaultView) ||
        window
      );
    }
    function Ko(e) {
      var n;
      return null ==
        (n = (Go(e) ? e.ownerDocument : e.document) || window.document)
        ? void 0
        : n.documentElement;
    }
    function Go(e) {
      return !!Zo() && (e instanceof Node || e instanceof Uo(e).Node);
    }
    function Yo(e) {
      return !!Zo() && (e instanceof Element || e instanceof Uo(e).Element);
    }
    function $o(e) {
      return (
        !!Zo() && (e instanceof HTMLElement || e instanceof Uo(e).HTMLElement)
      );
    }
    function qo(e) {
      return (
        !(!Zo() || "undefined" == typeof ShadowRoot) &&
        (e instanceof ShadowRoot || e instanceof Uo(e).ShadowRoot)
      );
    }
    function Qo(e) {
      const { overflow: n, overflowX: t, overflowY: r, display: o } = ri(e);
      return (
        /auto|scroll|overlay|hidden|clip/.test(n + r + t) &&
        !["inline", "contents"].includes(o)
      );
    }
    function Xo(e) {
      return ["table", "td", "th"].includes(Fo(e));
    }
    function Jo(e) {
      return [":popover-open", ":modal"].some((n) => {
        try {
          return e.matches(n);
        } catch (e) {
          return !1;
        }
      });
    }
    function ei(e) {
      const n = ni(),
        t = Yo(e) ? ri(e) : e;
      return (
        "none" !== t.transform ||
        "none" !== t.perspective ||
        (!!t.containerType && "normal" !== t.containerType) ||
        (!n && !!t.backdropFilter && "none" !== t.backdropFilter) ||
        (!n && !!t.filter && "none" !== t.filter) ||
        ["transform", "perspective", "filter"].some((e) =>
          (t.willChange || "").includes(e)
        ) ||
        ["paint", "layout", "strict", "content"].some((e) =>
          (t.contain || "").includes(e)
        )
      );
    }
    function ni() {
      return (
        !("undefined" == typeof CSS || !CSS.supports) &&
        CSS.supports("-webkit-backdrop-filter", "none")
      );
    }
    function ti(e) {
      return ["html", "body", "#document"].includes(Fo(e));
    }
    function ri(e) {
      return Uo(e).getComputedStyle(e);
    }
    function oi(e) {
      return Yo(e)
        ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop }
        : { scrollLeft: e.scrollX, scrollTop: e.scrollY };
    }
    function ii(e) {
      if ("html" === Fo(e)) return e;
      const n = e.assignedSlot || e.parentNode || (qo(e) && e.host) || Ko(e);
      return qo(n) ? n.host : n;
    }
    function ai(e) {
      const n = ii(e);
      return ti(n)
        ? e.ownerDocument
          ? e.ownerDocument.body
          : e.body
        : $o(n) && Qo(n)
        ? n
        : ai(n);
    }
    function li(e, n, t) {
      var r;
      void 0 === n && (n = []), void 0 === t && (t = !0);
      const o = ai(e),
        i = o === (null == (r = e.ownerDocument) ? void 0 : r.body),
        a = Uo(o);
      if (i) {
        const e = si(a);
        return n.concat(
          a,
          a.visualViewport || [],
          Qo(o) ? o : [],
          e && t ? li(e) : []
        );
      }
      return n.concat(o, li(o, [], t));
    }
    function si(e) {
      return e.parent && Object.getPrototypeOf(e.parent)
        ? e.frameElement
        : null;
    }
    function ci(e) {
      const n = ri(e);
      let t = parseFloat(n.width) || 0,
        r = parseFloat(n.height) || 0;
      const o = $o(e),
        i = o ? e.offsetWidth : t,
        a = o ? e.offsetHeight : r,
        l = yo(t) !== i || yo(r) !== a;
      return l && ((t = i), (r = a)), { width: t, height: r, $: l };
    }
    function ui(e) {
      return Yo(e) ? e : e.contextElement;
    }
    function di(e) {
      const n = ui(e);
      if (!$o(n)) return ko(1);
      const t = n.getBoundingClientRect(),
        { width: r, height: o, $: i } = ci(n);
      let a = (i ? yo(t.width) : t.width) / r,
        l = (i ? yo(t.height) : t.height) / o;
      return (
        (a && Number.isFinite(a)) || (a = 1),
        (l && Number.isFinite(l)) || (l = 1),
        { x: a, y: l }
      );
    }
    const pi = ko(0);
    function fi(e) {
      const n = Uo(e);
      return ni() && n.visualViewport
        ? { x: n.visualViewport.offsetLeft, y: n.visualViewport.offsetTop }
        : pi;
    }
    function hi(e, n, t, r) {
      void 0 === n && (n = !1), void 0 === t && (t = !1);
      const o = e.getBoundingClientRect(),
        i = ui(e);
      let a = ko(1);
      n && (r ? Yo(r) && (a = di(r)) : (a = di(e)));
      const l = (function (e, n, t) {
        return void 0 === n && (n = !1), !(!t || (n && t !== Uo(e))) && n;
      })(i, t, r)
        ? fi(i)
        : ko(0);
      let s = (o.left + l.x) / a.x,
        c = (o.top + l.y) / a.y,
        u = o.width / a.x,
        d = o.height / a.y;
      if (i) {
        const e = Uo(i),
          n = r && Yo(r) ? Uo(r) : r;
        let t = e,
          o = si(t);
        for (; o && r && n !== t; ) {
          const e = di(o),
            n = o.getBoundingClientRect(),
            r = ri(o),
            i = n.left + (o.clientLeft + parseFloat(r.paddingLeft)) * e.x,
            a = n.top + (o.clientTop + parseFloat(r.paddingTop)) * e.y;
          (s *= e.x),
            (c *= e.y),
            (u *= e.x),
            (d *= e.y),
            (s += i),
            (c += a),
            (t = Uo(o)),
            (o = si(t));
        }
      }
      return Vo({ width: u, height: d, x: s, y: c });
    }
    function mi(e, n) {
      const t = oi(e).scrollLeft;
      return n ? n.left + t : hi(Ko(e)).left + t;
    }
    function _i(e, n, t) {
      let r;
      if ("viewport" === n)
        r = (function (e, n) {
          const t = Uo(e),
            r = Ko(e),
            o = t.visualViewport;
          let i = r.clientWidth,
            a = r.clientHeight,
            l = 0,
            s = 0;
          if (o) {
            (i = o.width), (a = o.height);
            const e = ni();
            (!e || (e && "fixed" === n)) &&
              ((l = o.offsetLeft), (s = o.offsetTop));
          }
          return { width: i, height: a, x: l, y: s };
        })(e, t);
      else if ("document" === n)
        r = (function (e) {
          const n = Ko(e),
            t = oi(e),
            r = e.ownerDocument.body,
            o = xo(n.scrollWidth, n.clientWidth, r.scrollWidth, r.clientWidth),
            i = xo(
              n.scrollHeight,
              n.clientHeight,
              r.scrollHeight,
              r.clientHeight
            );
          let a = -t.scrollLeft + mi(e);
          const l = -t.scrollTop;
          return (
            "rtl" === ri(r).direction &&
              (a += xo(n.clientWidth, r.clientWidth) - o),
            { width: o, height: i, x: a, y: l }
          );
        })(Ko(e));
      else if (Yo(n))
        r = (function (e, n) {
          const t = hi(e, !0, "fixed" === n),
            r = t.top + e.clientTop,
            o = t.left + e.clientLeft,
            i = $o(e) ? di(e) : ko(1);
          return {
            width: e.clientWidth * i.x,
            height: e.clientHeight * i.y,
            x: o * i.x,
            y: r * i.y,
          };
        })(n, t);
      else {
        const t = fi(e);
        r = { ...n, x: n.x - t.x, y: n.y - t.y };
      }
      return Vo(r);
    }
    function gi(e, n) {
      const t = ii(e);
      return (
        !(t === n || !Yo(t) || ti(t)) &&
        ("fixed" === ri(t).position || gi(t, n))
      );
    }
    function vi(e, n, t) {
      const r = $o(n),
        o = Ko(n),
        i = "fixed" === t,
        a = hi(e, !0, i, n);
      let l = { scrollLeft: 0, scrollTop: 0 };
      const s = ko(0);
      if (r || (!r && !i))
        if ((("body" !== Fo(n) || Qo(o)) && (l = oi(n)), r)) {
          const e = hi(n, !0, i, n);
          (s.x = e.x + n.clientLeft), (s.y = e.y + n.clientTop);
        } else o && (s.x = mi(o));
      let c = 0,
        u = 0;
      if (o && !r && !i) {
        const e = o.getBoundingClientRect();
        (u = e.top + l.scrollTop), (c = e.left + l.scrollLeft - mi(o, e));
      }
      return {
        x: a.left + l.scrollLeft - s.x - c,
        y: a.top + l.scrollTop - s.y - u,
        width: a.width,
        height: a.height,
      };
    }
    function Ci(e) {
      return "static" === ri(e).position;
    }
    function bi(e, n) {
      if (!$o(e) || "fixed" === ri(e).position) return null;
      if (n) return n(e);
      let t = e.offsetParent;
      return Ko(e) === t && (t = t.ownerDocument.body), t;
    }
    function xi(e, n) {
      const t = Uo(e);
      if (Jo(e)) return t;
      if (!$o(e)) {
        let n = ii(e);
        for (; n && !ti(n); ) {
          if (Yo(n) && !Ci(n)) return n;
          n = ii(n);
        }
        return t;
      }
      let r = bi(e, n);
      for (; r && Xo(r) && Ci(r); ) r = bi(r, n);
      return r && ti(r) && Ci(r) && !ei(r)
        ? t
        : r ||
            (function (e) {
              let n = ii(e);
              for (; $o(n) && !ti(n); ) {
                if (ei(n)) return n;
                if (Jo(n)) return null;
                n = ii(n);
              }
              return null;
            })(e) ||
            t;
    }
    const yi = {
      convertOffsetParentRelativeRectToViewportRelativeRect: function (e) {
        let { elements: n, rect: t, offsetParent: r, strategy: o } = e;
        const i = "fixed" === o,
          a = Ko(r),
          l = !!n && Jo(n.floating);
        if (r === a || (l && i)) return t;
        let s = { scrollLeft: 0, scrollTop: 0 },
          c = ko(1);
        const u = ko(0),
          d = $o(r);
        if (
          (d || (!d && !i)) &&
          (("body" !== Fo(r) || Qo(a)) && (s = oi(r)), $o(r))
        ) {
          const e = hi(r);
          (c = di(r)), (u.x = e.x + r.clientLeft), (u.y = e.y + r.clientTop);
        }
        return {
          width: t.width * c.x,
          height: t.height * c.y,
          x: t.x * c.x - s.scrollLeft * c.x + u.x,
          y: t.y * c.y - s.scrollTop * c.y + u.y,
        };
      },
      getDocumentElement: Ko,
      getClippingRect: function (e) {
        let { element: n, boundary: t, rootBoundary: r, strategy: o } = e;
        const i =
            "clippingAncestors" === t
              ? Jo(n)
                ? []
                : (function (e, n) {
                    const t = n.get(e);
                    if (t) return t;
                    let r = li(e, [], !1).filter(
                        (e) => Yo(e) && "body" !== Fo(e)
                      ),
                      o = null;
                    const i = "fixed" === ri(e).position;
                    let a = i ? ii(e) : e;
                    for (; Yo(a) && !ti(a); ) {
                      const n = ri(a),
                        t = ei(a);
                      t || "fixed" !== n.position || (o = null),
                        (
                          i
                            ? !t && !o
                            : (!t &&
                                "static" === n.position &&
                                o &&
                                ["absolute", "fixed"].includes(o.position)) ||
                              (Qo(a) && !t && gi(e, a))
                        )
                          ? (r = r.filter((e) => e !== a))
                          : (o = n),
                        (a = ii(a));
                    }
                    return n.set(e, r), r;
                  })(n, this._c)
              : [].concat(t),
          a = [...i, r],
          l = a[0],
          s = a.reduce((e, t) => {
            const r = _i(n, t, o);
            return (
              (e.top = xo(r.top, e.top)),
              (e.right = bo(r.right, e.right)),
              (e.bottom = bo(r.bottom, e.bottom)),
              (e.left = xo(r.left, e.left)),
              e
            );
          }, _i(n, l, o));
        return {
          width: s.right - s.left,
          height: s.bottom - s.top,
          x: s.left,
          y: s.top,
        };
      },
      getOffsetParent: xi,
      getElementRects: async function (e) {
        const n = this.getOffsetParent || xi,
          t = this.getDimensions,
          r = await t(e.floating);
        return {
          reference: vi(e.reference, await n(e.floating), e.strategy),
          floating: { x: 0, y: 0, width: r.width, height: r.height },
        };
      },
      getClientRects: function (e) {
        return Array.from(e.getClientRects());
      },
      getDimensions: function (e) {
        const { width: n, height: t } = ci(e);
        return { width: n, height: t };
      },
      getScale: di,
      isElement: Yo,
      isRTL: function (e) {
        return "rtl" === ri(e).direction;
      },
    };
    const wi = function (e) {
        return (
          void 0 === e && (e = 0),
          {
            name: "offset",
            options: e,
            async fn(n) {
              var t, r;
              const { x: o, y: i, placement: a, middlewareData: l } = n,
                s = await (async function (e, n) {
                  const { placement: t, platform: r, elements: o } = e,
                    i = await (null == r.isRTL ? void 0 : r.isRTL(o.floating)),
                    a = Mo(t),
                    l = To(t),
                    s = "y" === Ao(t),
                    c = ["left", "top"].includes(a) ? -1 : 1,
                    u = i && s ? -1 : 1,
                    d = So(n, e);
                  let {
                    mainAxis: p,
                    crossAxis: f,
                    alignmentAxis: h,
                  } = "number" == typeof d
                    ? { mainAxis: d, crossAxis: 0, alignmentAxis: null }
                    : {
                        mainAxis: d.mainAxis || 0,
                        crossAxis: d.crossAxis || 0,
                        alignmentAxis: d.alignmentAxis,
                      };
                  return (
                    l && "number" == typeof h && (f = "end" === l ? -1 * h : h),
                    s ? { x: f * u, y: p * c } : { x: p * c, y: f * u }
                  );
                })(n, e);
              return a === (null == (t = l.offset) ? void 0 : t.placement) &&
                null != (r = l.arrow) &&
                r.alignmentOffset
                ? {}
                : { x: o + s.x, y: i + s.y, data: { ...s, placement: a } };
            },
          }
        );
      },
      ki = function (e) {
        return (
          void 0 === e && (e = {}),
          {
            name: "shift",
            options: e,
            async fn(n) {
              const { x: t, y: r, placement: o } = n,
                {
                  mainAxis: i = !0,
                  crossAxis: a = !1,
                  limiter: l = {
                    fn: (e) => {
                      let { x: n, y: t } = e;
                      return { x: n, y: t };
                    },
                  },
                  ...s
                } = So(e, n),
                c = { x: t, y: r },
                u = await Bo(n, s),
                d = Ao(Mo(o)),
                p = No(d);
              let f = c[p],
                h = c[d];
              if (i) {
                const e = "y" === p ? "bottom" : "right";
                f = Eo(f + u["y" === p ? "top" : "left"], f, f - u[e]);
              }
              if (a) {
                const e = "y" === d ? "bottom" : "right";
                h = Eo(h + u["y" === d ? "top" : "left"], h, h - u[e]);
              }
              const m = l.fn({ ...n, [p]: f, [d]: h });
              return {
                ...m,
                data: { x: m.x - t, y: m.y - r, enabled: { [p]: i, [d]: a } },
              };
            },
          }
        );
      },
      Li = function (e) {
        return (
          void 0 === e && (e = {}),
          {
            name: "flip",
            options: e,
            async fn(n) {
              var t, r;
              const {
                  placement: o,
                  middlewareData: i,
                  rects: a,
                  initialPlacement: l,
                  platform: s,
                  elements: c,
                } = n,
                {
                  mainAxis: u = !0,
                  crossAxis: d = !0,
                  fallbackPlacements: p,
                  fallbackStrategy: f = "bestFit",
                  fallbackAxisSideDirection: h = "none",
                  flipAlignment: m = !0,
                  ..._
                } = So(e, n);
              if (null != (t = i.arrow) && t.alignmentOffset) return {};
              const g = Mo(o),
                v = Ao(l),
                C = Mo(l) === l,
                b = await (null == s.isRTL ? void 0 : s.isRTL(c.floating)),
                x =
                  p ||
                  (C || !m
                    ? [Ro(l)]
                    : (function (e) {
                        const n = Ro(e);
                        return [Po(e), n, Po(n)];
                      })(l)),
                y = "none" !== h;
              !p &&
                y &&
                x.push(
                  ...(function (e, n, t, r) {
                    const o = To(e);
                    let i = (function (e, n, t) {
                      const r = ["left", "right"],
                        o = ["right", "left"],
                        i = ["top", "bottom"],
                        a = ["bottom", "top"];
                      switch (e) {
                        case "top":
                        case "bottom":
                          return t ? (n ? o : r) : n ? r : o;
                        case "left":
                        case "right":
                          return n ? i : a;
                        default:
                          return [];
                      }
                    })(Mo(e), "start" === t, r);
                    return (
                      o &&
                        ((i = i.map((e) => e + "-" + o)),
                        n && (i = i.concat(i.map(Po)))),
                      i
                    );
                  })(l, m, h, b)
                );
              const w = [l, ...x],
                k = await Bo(n, _),
                L = [];
              let j = (null == (r = i.flip) ? void 0 : r.overflows) || [];
              if ((u && L.push(k[g]), d)) {
                const e = (function (e, n, t) {
                  void 0 === t && (t = !1);
                  const r = To(e),
                    o = Io(e),
                    i = Oo(o);
                  let a =
                    "x" === o
                      ? r === (t ? "end" : "start")
                        ? "right"
                        : "left"
                      : "start" === r
                      ? "bottom"
                      : "top";
                  return (
                    n.reference[i] > n.floating[i] && (a = Ro(a)), [a, Ro(a)]
                  );
                })(o, a, b);
                L.push(k[e[0]], k[e[1]]);
              }
              if (
                ((j = [...j, { placement: o, overflows: L }]),
                !L.every((e) => e <= 0))
              ) {
                var E, S;
                const e = ((null == (E = i.flip) ? void 0 : E.index) || 0) + 1,
                  n = w[e];
                if (n)
                  return {
                    data: { index: e, overflows: j },
                    reset: { placement: n },
                  };
                let t =
                  null ==
                  (S = j
                    .filter((e) => e.overflows[0] <= 0)
                    .sort((e, n) => e.overflows[1] - n.overflows[1])[0])
                    ? void 0
                    : S.placement;
                if (!t)
                  switch (f) {
                    case "bestFit": {
                      var M;
                      const e =
                        null ==
                        (M = j
                          .filter((e) => {
                            if (y) {
                              const n = Ao(e.placement);
                              return n === v || "y" === n;
                            }
                            return !0;
                          })
                          .map((e) => [
                            e.placement,
                            e.overflows
                              .filter((e) => e > 0)
                              .reduce((e, n) => e + n, 0),
                          ])
                          .sort((e, n) => e[1] - n[1])[0])
                          ? void 0
                          : M[0];
                      e && (t = e);
                      break;
                    }
                    case "initialPlacement":
                      t = l;
                  }
                if (o !== t) return { reset: { placement: t } };
              }
              return {};
            },
          }
        );
      },
      ji = function (e) {
        return (
          void 0 === e && (e = {}),
          {
            name: "size",
            options: e,
            async fn(n) {
              var t, r;
              const { placement: o, rects: i, platform: a, elements: l } = n,
                { apply: s = () => {}, ...c } = So(e, n),
                u = await Bo(n, c),
                d = Mo(o),
                p = To(o),
                f = "y" === Ao(o),
                { width: h, height: m } = i.floating;
              let _, g;
              "top" === d || "bottom" === d
                ? ((_ = d),
                  (g =
                    p ===
                    ((await (null == a.isRTL ? void 0 : a.isRTL(l.floating)))
                      ? "start"
                      : "end")
                      ? "left"
                      : "right"))
                : ((g = d), (_ = "end" === p ? "top" : "bottom"));
              const v = m - u.top - u.bottom,
                C = h - u.left - u.right,
                b = bo(m - u[_], v),
                x = bo(h - u[g], C),
                y = !n.middlewareData.shift;
              let w = b,
                k = x;
              if (
                (null != (t = n.middlewareData.shift) && t.enabled.x && (k = C),
                null != (r = n.middlewareData.shift) && r.enabled.y && (w = v),
                y && !p)
              ) {
                const e = xo(u.left, 0),
                  n = xo(u.right, 0),
                  t = xo(u.top, 0),
                  r = xo(u.bottom, 0);
                f
                  ? (k =
                      h -
                      2 * (0 !== e || 0 !== n ? e + n : xo(u.left, u.right)))
                  : (w =
                      m -
                      2 * (0 !== t || 0 !== r ? t + r : xo(u.top, u.bottom)));
              }
              await s({ ...n, availableWidth: k, availableHeight: w });
              const L = await a.getDimensions(l.floating);
              return h !== L.width || m !== L.height
                ? { reset: { rects: !0 } }
                : {};
            },
          }
        );
      },
      Ei = function (e) {
        return (
          void 0 === e && (e = {}),
          {
            name: "hide",
            options: e,
            async fn(n) {
              const { rects: t } = n,
                { strategy: r = "referenceHidden", ...o } = So(e, n);
              switch (r) {
                case "referenceHidden": {
                  const e = Wo(
                    await Bo(n, { ...o, elementContext: "reference" }),
                    t.reference
                  );
                  return {
                    data: { referenceHiddenOffsets: e, referenceHidden: zo(e) },
                  };
                }
                case "escaped": {
                  const e = Wo(
                    await Bo(n, { ...o, altBoundary: !0 }),
                    t.floating
                  );
                  return { data: { escapedOffsets: e, escaped: zo(e) } };
                }
                default:
                  return {};
              }
            },
          }
        );
      },
      Si = (e) => ({
        name: "arrow",
        options: e,
        async fn(n) {
          const {
              x: t,
              y: r,
              placement: o,
              rects: i,
              platform: a,
              elements: l,
              middlewareData: s,
            } = n,
            { element: c, padding: u = 0 } = So(e, n) || {};
          if (null == c) return {};
          const d = Ho(u),
            p = { x: t, y: r },
            f = Io(o),
            h = Oo(f),
            m = await a.getDimensions(c),
            _ = "y" === f,
            g = _ ? "top" : "left",
            v = _ ? "bottom" : "right",
            C = _ ? "clientHeight" : "clientWidth",
            b = i.reference[h] + i.reference[f] - p[f] - i.floating[h],
            x = p[f] - i.reference[f],
            y = await (null == a.getOffsetParent
              ? void 0
              : a.getOffsetParent(c));
          let w = y ? y[C] : 0;
          (w && (await (null == a.isElement ? void 0 : a.isElement(y)))) ||
            (w = l.floating[C] || i.floating[h]);
          const k = b / 2 - x / 2,
            L = w / 2 - m[h] / 2 - 1,
            j = bo(d[g], L),
            E = bo(d[v], L),
            S = j,
            M = w - m[h] - E,
            T = w / 2 - m[h] / 2 + k,
            N = Eo(S, T, M),
            O =
              !s.arrow &&
              null != To(o) &&
              T !== N &&
              i.reference[h] / 2 - (T < S ? j : E) - m[h] / 2 < 0,
            A = O ? (T < S ? T - S : T - M) : 0;
          return {
            [f]: p[f] + A,
            data: {
              [f]: N,
              centerOffset: T - N - A,
              ...(O && { alignmentOffset: A }),
            },
            reset: O,
          };
        },
      }),
      Mi = function (e) {
        return (
          void 0 === e && (e = {}),
          {
            options: e,
            fn(n) {
              const {
                  x: t,
                  y: r,
                  placement: o,
                  rects: i,
                  middlewareData: a,
                } = n,
                {
                  offset: l = 0,
                  mainAxis: s = !0,
                  crossAxis: c = !0,
                } = So(e, n),
                u = { x: t, y: r },
                d = Ao(o),
                p = No(d);
              let f = u[p],
                h = u[d];
              const m = So(l, n),
                _ =
                  "number" == typeof m
                    ? { mainAxis: m, crossAxis: 0 }
                    : { mainAxis: 0, crossAxis: 0, ...m };
              if (s) {
                const e = "y" === p ? "height" : "width",
                  n = i.reference[p] - i.floating[e] + _.mainAxis,
                  t = i.reference[p] + i.reference[e] - _.mainAxis;
                f < n ? (f = n) : f > t && (f = t);
              }
              if (c) {
                var g, v;
                const e = "y" === p ? "width" : "height",
                  n = ["top", "left"].includes(Mo(o)),
                  t =
                    i.reference[d] -
                    i.floating[e] +
                    ((n && (null == (g = a.offset) ? void 0 : g[d])) || 0) +
                    (n ? 0 : _.crossAxis),
                  r =
                    i.reference[d] +
                    i.reference[e] +
                    (n ? 0 : (null == (v = a.offset) ? void 0 : v[d]) || 0) -
                    (n ? _.crossAxis : 0);
                h < t ? (h = t) : h > r && (h = r);
              }
              return { [p]: f, [d]: h };
            },
          }
        );
      },
      Ti = (e, n, t) => {
        const r = new Map(),
          o = { platform: yi, ...t },
          i = { ...o.platform, _c: r };
        return (async (e, n, t) => {
          const {
              placement: r = "bottom",
              strategy: o = "absolute",
              middleware: i = [],
              platform: a,
            } = t,
            l = i.filter(Boolean),
            s = await (null == a.isRTL ? void 0 : a.isRTL(n));
          let c = await a.getElementRects({
              reference: e,
              floating: n,
              strategy: o,
            }),
            { x: u, y: d } = Do(c, r, s),
            p = r,
            f = {},
            h = 0;
          for (let t = 0; t < l.length; t++) {
            const { name: i, fn: m } = l[t],
              {
                x: _,
                y: g,
                data: v,
                reset: C,
              } = await m({
                x: u,
                y: d,
                initialPlacement: r,
                placement: p,
                strategy: o,
                middlewareData: f,
                rects: c,
                platform: a,
                elements: { reference: e, floating: n },
              });
            (u = null != _ ? _ : u),
              (d = null != g ? g : d),
              (f = { ...f, [i]: { ...f[i], ...v } }),
              C &&
                h <= 50 &&
                (h++,
                "object" == typeof C &&
                  (C.placement && (p = C.placement),
                  C.rects &&
                    (c =
                      !0 === C.rects
                        ? await a.getElementRects({
                            reference: e,
                            floating: n,
                            strategy: o,
                          })
                        : C.rects),
                  ({ x: u, y: d } = Do(c, p, s))),
                (t = -1));
          }
          return { x: u, y: d, placement: p, strategy: o, middlewareData: f };
        })(e, n, { ...o, platform: i });
      };
    var Ni = "undefined" != typeof document ? e.useLayoutEffect : e.useEffect;
    function Oi(e, n) {
      if (e === n) return !0;
      if (typeof e != typeof n) return !1;
      if ("function" == typeof e && e.toString() === n.toString()) return !0;
      let t, r, o;
      if (e && n && "object" == typeof e) {
        if (Array.isArray(e)) {
          if (((t = e.length), t !== n.length)) return !1;
          for (r = t; 0 != r--; ) if (!Oi(e[r], n[r])) return !1;
          return !0;
        }
        if (((o = Object.keys(e)), (t = o.length), t !== Object.keys(n).length))
          return !1;
        for (r = t; 0 != r--; ) if (!{}.hasOwnProperty.call(n, o[r])) return !1;
        for (r = t; 0 != r--; ) {
          const t = o[r];
          if (!(("_owner" === t && e.$$typeof) || Oi(e[t], n[t]))) return !1;
        }
        return !0;
      }
      return e != e && n != n;
    }
    function Ai(e) {
      return "undefined" == typeof window
        ? 1
        : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
    }
    function Ii(e, n) {
      const t = Ai(e);
      return Math.round(n * t) / t;
    }
    function Pi(n) {
      const t = e.useRef(n);
      return (
        Ni(() => {
          t.current = n;
        }),
        t
      );
    }
    const Ri = (e) => ({
        name: "arrow",
        options: e,
        fn(n) {
          const { element: t, padding: r } = "function" == typeof e ? e(n) : e;
          return t && ((o = t), {}.hasOwnProperty.call(o, "current"))
            ? null != t.current
              ? Si({ element: t.current, padding: r }).fn(n)
              : {}
            : t
            ? Si({ element: t, padding: r }).fn(n)
            : {};
          var o;
        },
      }),
      Hi = (e, n) => ({ ...ki(e), options: [e, n] }),
      Vi = (e, n) => ({ ...Mi(e), options: [e, n] }),
      Di = (e, n) => ({ ...Li(e), options: [e, n] }),
      Bi = (e, n) => ({ ...ji(e), options: [e, n] }),
      Wi = (e, n) => ({ ...Ei(e), options: [e, n] }),
      zi = (e, n) => ({ ...Ri(e), options: [e, n] }),
      Zi = (0, e.forwardRef)((n, t) => {
        const { children: r, width: o = 10, height: i = 5, ...a } = n;
        return (0, e.createElement)(
          lo.svg,
          $r({}, a, {
            ref: t,
            width: o,
            height: i,
            viewBox: "0 0 30 10",
            preserveAspectRatio: "none",
          }),
          n.asChild
            ? r
            : (0, e.createElement)("polygon", { points: "0,0 30,0 15,10" })
        );
      }),
      Fi = "Popper",
      [Ui, Ki] = Jr(Fi),
      [Gi, Yi] = Ui(Fi),
      $i = (0, e.forwardRef)((n, t) => {
        const { __scopePopper: r, virtualRef: o, ...i } = n,
          a = Yi("PopperAnchor", r),
          l = (0, e.useRef)(null),
          s = Xr(t, l);
        return (
          (0, e.useEffect)(() => {
            a.onAnchorChange((null == o ? void 0 : o.current) || l.current);
          }),
          o ? null : (0, e.createElement)(lo.div, $r({}, i, { ref: s }))
        );
      }),
      qi = "PopperContent",
      [Qi, Xi] = Ui(qi),
      Ji = (0, e.forwardRef)((n, t) => {
        var r, o, i, a, l, s, c, u;
        const {
            __scopePopper: d,
            side: p = "bottom",
            sideOffset: f = 0,
            align: h = "center",
            alignOffset: m = 0,
            arrowPadding: _ = 0,
            avoidCollisions: g = !0,
            collisionBoundary: v = [],
            collisionPadding: C = 0,
            sticky: b = "partial",
            hideWhenDetached: x = !1,
            updatePositionStrategy: y = "optimized",
            onPlaced: w,
            ...k
          } = n,
          L = Yi(qi, d),
          [j, E] = (0, e.useState)(null),
          S = Xr(t, (e) => E(e)),
          [M, T] = (0, e.useState)(null),
          N = (function (n) {
            const [t, r] = (0, e.useState)(void 0);
            return (
              _o(() => {
                if (n) {
                  r({ width: n.offsetWidth, height: n.offsetHeight });
                  const e = new ResizeObserver((e) => {
                    if (!Array.isArray(e)) return;
                    if (!e.length) return;
                    const t = e[0];
                    let o, i;
                    if ("borderBoxSize" in t) {
                      const e = t.borderBoxSize,
                        n = Array.isArray(e) ? e[0] : e;
                      (o = n.inlineSize), (i = n.blockSize);
                    } else (o = n.offsetWidth), (i = n.offsetHeight);
                    r({ width: o, height: i });
                  });
                  return (
                    e.observe(n, { box: "border-box" }), () => e.unobserve(n)
                  );
                }
                r(void 0);
              }, [n]),
              t
            );
          })(M),
          O =
            null !== (r = null == N ? void 0 : N.width) && void 0 !== r ? r : 0,
          A =
            null !== (o = null == N ? void 0 : N.height) && void 0 !== o
              ? o
              : 0,
          I = p + ("center" !== h ? "-" + h : ""),
          P =
            "number" == typeof C
              ? C
              : { top: 0, right: 0, bottom: 0, left: 0, ...C },
          R = Array.isArray(v) ? v : [v],
          H = R.length > 0,
          V = { padding: P, boundary: R.filter(na), altBoundary: H },
          {
            refs: D,
            floatingStyles: B,
            placement: W,
            isPositioned: z,
            middlewareData: Z,
          } = (function (n) {
            void 0 === n && (n = {});
            const {
                placement: t = "bottom",
                strategy: r = "absolute",
                middleware: o = [],
                platform: i,
                elements: { reference: a, floating: l } = {},
                transform: s = !0,
                whileElementsMounted: c,
                open: u,
              } = n,
              [d, p] = e.useState({
                x: 0,
                y: 0,
                strategy: r,
                placement: t,
                middlewareData: {},
                isPositioned: !1,
              }),
              [f, h] = e.useState(o);
            Oi(f, o) || h(o);
            const [m, _] = e.useState(null),
              [g, v] = e.useState(null),
              C = e.useCallback((e) => {
                e !== w.current && ((w.current = e), _(e));
              }, []),
              b = e.useCallback((e) => {
                e !== k.current && ((k.current = e), v(e));
              }, []),
              x = a || m,
              y = l || g,
              w = e.useRef(null),
              k = e.useRef(null),
              L = e.useRef(d),
              j = null != c,
              E = Pi(c),
              S = Pi(i),
              M = Pi(u),
              T = e.useCallback(() => {
                if (!w.current || !k.current) return;
                const e = { placement: t, strategy: r, middleware: f };
                S.current && (e.platform = S.current),
                  Ti(w.current, k.current, e).then((e) => {
                    const n = { ...e, isPositioned: !1 !== M.current };
                    N.current &&
                      !Oi(L.current, n) &&
                      ((L.current = n),
                      no.flushSync(() => {
                        p(n);
                      }));
                  });
              }, [f, t, r, S, M]);
            Ni(() => {
              !1 === u &&
                L.current.isPositioned &&
                ((L.current.isPositioned = !1),
                p((e) => ({ ...e, isPositioned: !1 })));
            }, [u]);
            const N = e.useRef(!1);
            Ni(
              () => (
                (N.current = !0),
                () => {
                  N.current = !1;
                }
              ),
              []
            ),
              Ni(() => {
                if ((x && (w.current = x), y && (k.current = y), x && y)) {
                  if (E.current) return E.current(x, y, T);
                  T();
                }
              }, [x, y, T, E, j]);
            const O = e.useMemo(
                () => ({
                  reference: w,
                  floating: k,
                  setReference: C,
                  setFloating: b,
                }),
                [C, b]
              ),
              A = e.useMemo(() => ({ reference: x, floating: y }), [x, y]),
              I = e.useMemo(() => {
                const e = { position: r, left: 0, top: 0 };
                if (!A.floating) return e;
                const n = Ii(A.floating, d.x),
                  t = Ii(A.floating, d.y);
                return s
                  ? {
                      ...e,
                      transform: "translate(" + n + "px, " + t + "px)",
                      ...(Ai(A.floating) >= 1.5 && { willChange: "transform" }),
                    }
                  : { position: r, left: n, top: t };
              }, [r, s, A.floating, d.x, d.y]);
            return e.useMemo(
              () => ({
                ...d,
                update: T,
                refs: O,
                elements: A,
                floatingStyles: I,
              }),
              [d, T, O, A, I]
            );
          })({
            strategy: "fixed",
            placement: I,
            whileElementsMounted: (...e) =>
              (function (e, n, t, r) {
                void 0 === r && (r = {});
                const {
                    ancestorScroll: o = !0,
                    ancestorResize: i = !0,
                    elementResize: a = "function" == typeof ResizeObserver,
                    layoutShift: l = "function" == typeof IntersectionObserver,
                    animationFrame: s = !1,
                  } = r,
                  c = ui(e),
                  u = o || i ? [...(c ? li(c) : []), ...li(n)] : [];
                u.forEach((e) => {
                  o && e.addEventListener("scroll", t, { passive: !0 }),
                    i && e.addEventListener("resize", t);
                });
                const d =
                  c && l
                    ? (function (e, n) {
                        let t,
                          r = null;
                        const o = Ko(e);
                        function i() {
                          var e;
                          clearTimeout(t),
                            null == (e = r) || e.disconnect(),
                            (r = null);
                        }
                        return (
                          (function a(l, s) {
                            void 0 === l && (l = !1),
                              void 0 === s && (s = 1),
                              i();
                            const {
                              left: c,
                              top: u,
                              width: d,
                              height: p,
                            } = e.getBoundingClientRect();
                            if ((l || n(), !d || !p)) return;
                            const f = {
                              rootMargin:
                                -wo(u) +
                                "px " +
                                -wo(o.clientWidth - (c + d)) +
                                "px " +
                                -wo(o.clientHeight - (u + p)) +
                                "px " +
                                -wo(c) +
                                "px",
                              threshold: xo(0, bo(1, s)) || 1,
                            };
                            let h = !0;
                            function m(e) {
                              const n = e[0].intersectionRatio;
                              if (n !== s) {
                                if (!h) return a();
                                n
                                  ? a(!1, n)
                                  : (t = setTimeout(() => {
                                      a(!1, 1e-7);
                                    }, 1e3));
                              }
                              h = !1;
                            }
                            try {
                              r = new IntersectionObserver(m, {
                                ...f,
                                root: o.ownerDocument,
                              });
                            } catch (e) {
                              r = new IntersectionObserver(m, f);
                            }
                            r.observe(e);
                          })(!0),
                          i
                        );
                      })(c, t)
                    : null;
                let p,
                  f = -1,
                  h = null;
                a &&
                  ((h = new ResizeObserver((e) => {
                    let [r] = e;
                    r &&
                      r.target === c &&
                      h &&
                      (h.unobserve(n),
                      cancelAnimationFrame(f),
                      (f = requestAnimationFrame(() => {
                        var e;
                        null == (e = h) || e.observe(n);
                      }))),
                      t();
                  })),
                  c && !s && h.observe(c),
                  h.observe(n));
                let m = s ? hi(e) : null;
                return (
                  s &&
                    (function n() {
                      const r = hi(e);
                      !m ||
                        (r.x === m.x &&
                          r.y === m.y &&
                          r.width === m.width &&
                          r.height === m.height) ||
                        t(),
                        (m = r),
                        (p = requestAnimationFrame(n));
                    })(),
                  t(),
                  () => {
                    var e;
                    u.forEach((e) => {
                      o && e.removeEventListener("scroll", t),
                        i && e.removeEventListener("resize", t);
                    }),
                      null == d || d(),
                      null == (e = h) || e.disconnect(),
                      (h = null),
                      s && cancelAnimationFrame(p);
                  }
                );
              })(...e, { animationFrame: "always" === y }),
            elements: { reference: L.anchor },
            middleware: [
              ((F = { mainAxis: f + A, alignmentAxis: m }),
              { ...wi(F), options: [F, undefined] }),
              g &&
                Hi({
                  mainAxis: !0,
                  crossAxis: !1,
                  limiter: "partial" === b ? Vi() : void 0,
                  ...V,
                }),
              g && Di({ ...V }),
              Bi({
                ...V,
                apply: ({
                  elements: e,
                  rects: n,
                  availableWidth: t,
                  availableHeight: r,
                }) => {
                  const { width: o, height: i } = n.reference,
                    a = e.floating.style;
                  a.setProperty("--radix-popper-available-width", `${t}px`),
                    a.setProperty("--radix-popper-available-height", `${r}px`),
                    a.setProperty("--radix-popper-anchor-width", `${o}px`),
                    a.setProperty("--radix-popper-anchor-height", `${i}px`);
                },
              }),
              M && zi({ element: M, padding: _ }),
              ta({ arrowWidth: O, arrowHeight: A }),
              x && Wi({ strategy: "referenceHidden", ...V }),
            ],
          });
        var F;
        const [U, K] = ra(W),
          G = so(w);
        _o(() => {
          z && (null == G || G());
        }, [z, G]);
        const Y = null === (i = Z.arrow) || void 0 === i ? void 0 : i.x,
          $ = null === (a = Z.arrow) || void 0 === a ? void 0 : a.y,
          q =
            0 !==
            (null === (l = Z.arrow) || void 0 === l ? void 0 : l.centerOffset),
          [Q, X] = (0, e.useState)();
        return (
          _o(() => {
            j && X(window.getComputedStyle(j).zIndex);
          }, [j]),
          (0, e.createElement)(
            "div",
            {
              ref: D.setFloating,
              "data-radix-popper-content-wrapper": "",
              style: {
                ...B,
                transform: z ? B.transform : "translate(0, -200%)",
                minWidth: "max-content",
                zIndex: Q,
                "--radix-popper-transform-origin": [
                  null === (s = Z.transformOrigin) || void 0 === s
                    ? void 0
                    : s.x,
                  null === (c = Z.transformOrigin) || void 0 === c
                    ? void 0
                    : c.y,
                ].join(" "),
              },
              dir: n.dir,
            },
            (0, e.createElement)(
              Qi,
              {
                scope: d,
                placedSide: U,
                onArrowChange: T,
                arrowX: Y,
                arrowY: $,
                shouldHideArrow: q,
              },
              (0, e.createElement)(
                lo.div,
                $r({ "data-side": U, "data-align": K }, k, {
                  ref: S,
                  style: {
                    ...k.style,
                    animation: z ? void 0 : "none",
                    opacity:
                      null !== (u = Z.hide) && void 0 !== u && u.referenceHidden
                        ? 0
                        : void 0,
                  },
                })
              )
            )
          )
        );
      }),
      ea = { top: "bottom", right: "left", bottom: "top", left: "right" };
    function na(e) {
      return null !== e;
    }
    const ta = (e) => ({
      name: "transformOrigin",
      options: e,
      fn(n) {
        var t, r, o, i, a;
        const { placement: l, rects: s, middlewareData: c } = n,
          u =
            0 !==
            (null === (t = c.arrow) || void 0 === t ? void 0 : t.centerOffset),
          d = u ? 0 : e.arrowWidth,
          p = u ? 0 : e.arrowHeight,
          [f, h] = ra(l),
          m = { start: "0%", center: "50%", end: "100%" }[h],
          _ =
            (null !==
              (r = null === (o = c.arrow) || void 0 === o ? void 0 : o.x) &&
            void 0 !== r
              ? r
              : 0) +
            d / 2,
          g =
            (null !==
              (i = null === (a = c.arrow) || void 0 === a ? void 0 : a.y) &&
            void 0 !== i
              ? i
              : 0) +
            p / 2;
        let v = "",
          C = "";
        return (
          "bottom" === f
            ? ((v = u ? m : `${_}px`), (C = -p + "px"))
            : "top" === f
            ? ((v = u ? m : `${_}px`), (C = `${s.floating.height + p}px`))
            : "right" === f
            ? ((v = -p + "px"), (C = u ? m : `${g}px`))
            : "left" === f &&
              ((v = `${s.floating.width + p}px`), (C = u ? m : `${g}px`)),
          { data: { x: v, y: C } }
        );
      },
    });
    function ra(e) {
      const [n, t = "center"] = e.split("-");
      return [n, t];
    }
    const oa = (n) => {
        const { __scopePopper: t, children: r } = n,
          [o, i] = (0, e.useState)(null);
        return (0, e.createElement)(
          Gi,
          { scope: t, anchor: o, onAnchorChange: i },
          r
        );
      },
      ia = $i,
      aa = Ji,
      la = (0, e.forwardRef)(function (n, t) {
        const { __scopePopper: r, ...o } = n,
          i = Xi("PopperArrow", r),
          a = ea[i.placedSide];
        return (0,
        e.createElement)("span", { ref: i.onArrowChange, style: { position: "absolute", left: i.arrowX, top: i.arrowY, [a]: 0, transformOrigin: { top: "", right: "0 0", bottom: "center 0", left: "100% 0" }[i.placedSide], transform: { top: "translateY(100%)", right: "translateY(50%) rotate(90deg) translateX(-50%)", bottom: "rotate(180deg)", left: "translateY(50%) rotate(-90deg) translateX(50%)" }[i.placedSide], visibility: i.shouldHideArrow ? "hidden" : void 0 } }, (0, e.createElement)(Zi, $r({}, o, { ref: t, style: { ...o.style, display: "block" } })));
      }),
      sa = (0, e.forwardRef)((n, t) => {
        var r;
        const {
          container: o = null === globalThis ||
          void 0 === globalThis ||
          null === (r = globalThis.document) ||
          void 0 === r
            ? void 0
            : r.body,
          ...i
        } = n;
        return o
          ? no.createPortal(
              (0, e.createElement)(lo.div, $r({}, i, { ref: t })),
              o
            )
          : null;
      }),
      ca = (n) => {
        const { present: t, children: r } = n,
          o = (function (n) {
            const [t, r] = (0, e.useState)(),
              o = (0, e.useRef)({}),
              i = (0, e.useRef)(n),
              a = (0, e.useRef)("none"),
              l = n ? "mounted" : "unmounted",
              [s, c] = (function (n, t) {
                return (0, e.useReducer)((e, n) => {
                  const r = t[e][n];
                  return null != r ? r : e;
                }, n);
              })(l, {
                mounted: {
                  UNMOUNT: "unmounted",
                  ANIMATION_OUT: "unmountSuspended",
                },
                unmountSuspended: {
                  MOUNT: "mounted",
                  ANIMATION_END: "unmounted",
                },
                unmounted: { MOUNT: "mounted" },
              });
            return (
              (0, e.useEffect)(() => {
                const e = ua(o.current);
                a.current = "mounted" === s ? e : "none";
              }, [s]),
              _o(() => {
                const e = o.current,
                  t = i.current;
                if (t !== n) {
                  const r = a.current,
                    o = ua(e);
                  if (n) c("MOUNT");
                  else if (
                    "none" === o ||
                    "none" === (null == e ? void 0 : e.display)
                  )
                    c("UNMOUNT");
                  else {
                    const e = r !== o;
                    c(t && e ? "ANIMATION_OUT" : "UNMOUNT");
                  }
                  i.current = n;
                }
              }, [n, c]),
              _o(() => {
                if (t) {
                  const e = (e) => {
                      const n = ua(o.current).includes(e.animationName);
                      e.target === t &&
                        n &&
                        (0, no.flushSync)(() => c("ANIMATION_END"));
                    },
                    n = (e) => {
                      e.target === t && (a.current = ua(o.current));
                    };
                  return (
                    t.addEventListener("animationstart", n),
                    t.addEventListener("animationcancel", e),
                    t.addEventListener("animationend", e),
                    () => {
                      t.removeEventListener("animationstart", n),
                        t.removeEventListener("animationcancel", e),
                        t.removeEventListener("animationend", e);
                    }
                  );
                }
                c("ANIMATION_END");
              }, [t, c]),
              {
                isPresent: ["mounted", "unmountSuspended"].includes(s),
                ref: (0, e.useCallback)((e) => {
                  e && (o.current = getComputedStyle(e)), r(e);
                }, []),
              }
            );
          })(t),
          i =
            "function" == typeof r
              ? r({ present: o.isPresent })
              : e.Children.only(r),
          a = Xr(o.ref, i.ref);
        return "function" == typeof r || o.isPresent
          ? (0, e.cloneElement)(i, { ref: a })
          : null;
      };
    function ua(e) {
      return (null == e ? void 0 : e.animationName) || "none";
    }
    ca.displayName = "Presence";
    const da = (0, e.forwardRef)((n, t) =>
        (0, e.createElement)(
          lo.span,
          $r({}, n, {
            ref: t,
            style: {
              position: "absolute",
              border: 0,
              width: 1,
              height: 1,
              padding: 0,
              margin: -1,
              overflow: "hidden",
              clip: "rect(0, 0, 0, 0)",
              whiteSpace: "nowrap",
              wordWrap: "normal",
              ...n.style,
            },
          })
        )
      ),
      [pa, fa] = Jr("Tooltip", [Ki]),
      ha = Ki(),
      ma = 700,
      _a = "tooltip.open",
      [ga, va] = pa("TooltipProvider"),
      Ca = "Tooltip",
      [ba, xa] = pa(Ca),
      ya = "TooltipTrigger",
      wa = (0, e.forwardRef)((n, t) => {
        const { __scopeTooltip: r, ...o } = n,
          i = xa(ya, r),
          a = va(ya, r),
          l = ha(r),
          s = Xr(t, (0, e.useRef)(null), i.onTriggerChange),
          c = (0, e.useRef)(!1),
          u = (0, e.useRef)(!1),
          d = (0, e.useCallback)(() => (c.current = !1), []);
        return (
          (0, e.useEffect)(
            () => () => document.removeEventListener("pointerup", d),
            [d]
          ),
          (0, e.createElement)(
            ia,
            $r({ asChild: !0 }, l),
            (0, e.createElement)(
              lo.button,
              $r(
                {
                  "aria-describedby": i.open ? i.contentId : void 0,
                  "data-state": i.stateAttribute,
                },
                o,
                {
                  ref: s,
                  onPointerMove: qr(n.onPointerMove, (e) => {
                    "touch" !== e.pointerType &&
                      (u.current ||
                        a.isPointerInTransitRef.current ||
                        (i.onTriggerEnter(), (u.current = !0)));
                  }),
                  onPointerLeave: qr(n.onPointerLeave, () => {
                    i.onTriggerLeave(), (u.current = !1);
                  }),
                  onPointerDown: qr(n.onPointerDown, () => {
                    (c.current = !0),
                      document.addEventListener("pointerup", d, { once: !0 });
                  }),
                  onFocus: qr(n.onFocus, () => {
                    c.current || i.onOpen();
                  }),
                  onBlur: qr(n.onBlur, i.onClose),
                  onClick: qr(n.onClick, i.onClose),
                }
              )
            )
          )
        );
      }),
      ka = "TooltipPortal",
      [La, ja] = pa(ka, { forceMount: void 0 }),
      Ea = "TooltipContent",
      Sa = (0, e.forwardRef)((n, t) => {
        const r = ja(Ea, n.__scopeTooltip),
          { forceMount: o = r.forceMount, side: i = "top", ...a } = n,
          l = xa(Ea, n.__scopeTooltip);
        return (0, e.createElement)(
          ca,
          { present: o || l.open },
          l.disableHoverableContent
            ? (0, e.createElement)(Oa, $r({ side: i }, a, { ref: t }))
            : (0, e.createElement)(Ma, $r({ side: i }, a, { ref: t }))
        );
      }),
      Ma = (0, e.forwardRef)((n, t) => {
        const r = xa(Ea, n.__scopeTooltip),
          o = va(Ea, n.__scopeTooltip),
          i = (0, e.useRef)(null),
          a = Xr(t, i),
          [l, s] = (0, e.useState)(null),
          { trigger: c, onClose: u } = r,
          d = i.current,
          { onPointerInTransitChange: p } = o,
          f = (0, e.useCallback)(() => {
            s(null), p(!1);
          }, [p]),
          h = (0, e.useCallback)(
            (e, n) => {
              const t = e.currentTarget,
                r = { x: e.clientX, y: e.clientY },
                o = (function (e, n, t = 5) {
                  const r = [];
                  switch (n) {
                    case "top":
                      r.push(
                        { x: e.x - t, y: e.y + t },
                        { x: e.x + t, y: e.y + t }
                      );
                      break;
                    case "bottom":
                      r.push(
                        { x: e.x - t, y: e.y - t },
                        { x: e.x + t, y: e.y - t }
                      );
                      break;
                    case "left":
                      r.push(
                        { x: e.x + t, y: e.y - t },
                        { x: e.x + t, y: e.y + t }
                      );
                      break;
                    case "right":
                      r.push(
                        { x: e.x - t, y: e.y - t },
                        { x: e.x - t, y: e.y + t }
                      );
                  }
                  return r;
                })(
                  r,
                  (function (e, n) {
                    const t = Math.abs(n.top - e.y),
                      r = Math.abs(n.bottom - e.y),
                      o = Math.abs(n.right - e.x),
                      i = Math.abs(n.left - e.x);
                    switch (Math.min(t, r, o, i)) {
                      case i:
                        return "left";
                      case o:
                        return "right";
                      case t:
                        return "top";
                      case r:
                        return "bottom";
                      default:
                        throw new Error("unreachable");
                    }
                  })(r, t.getBoundingClientRect())
                ),
                i = (function (e) {
                  const n = e.slice();
                  return (
                    n.sort((e, n) =>
                      e.x < n.x
                        ? -1
                        : e.x > n.x
                        ? 1
                        : e.y < n.y
                        ? -1
                        : e.y > n.y
                        ? 1
                        : 0
                    ),
                    (function (e) {
                      if (e.length <= 1) return e.slice();
                      const n = [];
                      for (let t = 0; t < e.length; t++) {
                        const r = e[t];
                        for (; n.length >= 2; ) {
                          const e = n[n.length - 1],
                            t = n[n.length - 2];
                          if (
                            !(
                              (e.x - t.x) * (r.y - t.y) >=
                              (e.y - t.y) * (r.x - t.x)
                            )
                          )
                            break;
                          n.pop();
                        }
                        n.push(r);
                      }
                      n.pop();
                      const t = [];
                      for (let n = e.length - 1; n >= 0; n--) {
                        const r = e[n];
                        for (; t.length >= 2; ) {
                          const e = t[t.length - 1],
                            n = t[t.length - 2];
                          if (
                            !(
                              (e.x - n.x) * (r.y - n.y) >=
                              (e.y - n.y) * (r.x - n.x)
                            )
                          )
                            break;
                          t.pop();
                        }
                        t.push(r);
                      }
                      return (
                        t.pop(),
                        1 === n.length &&
                        1 === t.length &&
                        n[0].x === t[0].x &&
                        n[0].y === t[0].y
                          ? n
                          : n.concat(t)
                      );
                    })(n)
                  );
                })([
                  ...o,
                  ...(function (e) {
                    const { top: n, right: t, bottom: r, left: o } = e;
                    return [
                      { x: o, y: n },
                      { x: t, y: n },
                      { x: t, y: r },
                      { x: o, y: r },
                    ];
                  })(n.getBoundingClientRect()),
                ]);
              s(i), p(!0);
            },
            [p]
          );
        return (
          (0, e.useEffect)(() => () => f(), [f]),
          (0, e.useEffect)(() => {
            if (c && d) {
              const e = (e) => h(e, d),
                n = (e) => h(e, c);
              return (
                c.addEventListener("pointerleave", e),
                d.addEventListener("pointerleave", n),
                () => {
                  c.removeEventListener("pointerleave", e),
                    d.removeEventListener("pointerleave", n);
                }
              );
            }
          }, [c, d, h, f]),
          (0, e.useEffect)(() => {
            if (l) {
              const e = (e) => {
                const n = e.target,
                  t = { x: e.clientX, y: e.clientY },
                  r =
                    (null == c ? void 0 : c.contains(n)) ||
                    (null == d ? void 0 : d.contains(n)),
                  o = !(function (e, n) {
                    const { x: t, y: r } = e;
                    let o = !1;
                    for (let e = 0, i = n.length - 1; e < n.length; i = e++) {
                      const a = n[e].x,
                        l = n[e].y,
                        s = n[i].x,
                        c = n[i].y;
                      l > r != c > r &&
                        t < ((s - a) * (r - l)) / (c - l) + a &&
                        (o = !o);
                    }
                    return o;
                  })(t, l);
                r ? f() : o && (f(), u());
              };
              return (
                document.addEventListener("pointermove", e),
                () => document.removeEventListener("pointermove", e)
              );
            }
          }, [c, d, l, u, f]),
          (0, e.createElement)(Oa, $r({}, n, { ref: a }))
        );
      }),
      [Ta, Na] = pa(Ca, { isInside: !1 }),
      Oa = (0, e.forwardRef)((n, t) => {
        const {
            __scopeTooltip: r,
            children: o,
            "aria-label": i,
            onEscapeKeyDown: a,
            onPointerDownOutside: l,
            ...s
          } = n,
          c = xa(Ea, r),
          u = ha(r),
          { onClose: d } = c;
        return (
          (0, e.useEffect)(
            () => (
              document.addEventListener(_a, d),
              () => document.removeEventListener(_a, d)
            ),
            [d]
          ),
          (0, e.useEffect)(() => {
            if (c.trigger) {
              const e = (e) => {
                const n = e.target;
                null != n && n.contains(c.trigger) && d();
              };
              return (
                window.addEventListener("scroll", e, { capture: !0 }),
                () => window.removeEventListener("scroll", e, { capture: !0 })
              );
            }
          }, [c.trigger, d]),
          (0, e.createElement)(
            fo,
            {
              asChild: !0,
              disableOutsidePointerEvents: !1,
              onEscapeKeyDown: a,
              onPointerDownOutside: l,
              onFocusOutside: (e) => e.preventDefault(),
              onDismiss: d,
            },
            (0, e.createElement)(
              aa,
              $r({ "data-state": c.stateAttribute }, u, s, {
                ref: t,
                style: {
                  ...s.style,
                  "--radix-tooltip-content-transform-origin":
                    "var(--radix-popper-transform-origin)",
                  "--radix-tooltip-content-available-width":
                    "var(--radix-popper-available-width)",
                  "--radix-tooltip-content-available-height":
                    "var(--radix-popper-available-height)",
                  "--radix-tooltip-trigger-width":
                    "var(--radix-popper-anchor-width)",
                  "--radix-tooltip-trigger-height":
                    "var(--radix-popper-anchor-height)",
                },
              }),
              (0, e.createElement)(oo, null, o),
              (0, e.createElement)(
                Ta,
                { scope: r, isInside: !0 },
                (0, e.createElement)(
                  da,
                  { id: c.contentId, role: "tooltip" },
                  i || o
                )
              )
            )
          )
        );
      }),
      Aa = (n) => {
        const {
            __scopeTooltip: t,
            delayDuration: r = ma,
            skipDelayDuration: o = 300,
            disableHoverableContent: i = !1,
            children: a,
          } = n,
          [l, s] = (0, e.useState)(!0),
          c = (0, e.useRef)(!1),
          u = (0, e.useRef)(0);
        return (
          (0, e.useEffect)(() => {
            const e = u.current;
            return () => window.clearTimeout(e);
          }, []),
          (0, e.createElement)(
            ga,
            {
              scope: t,
              isOpenDelayed: l,
              delayDuration: r,
              onOpen: (0, e.useCallback)(() => {
                window.clearTimeout(u.current), s(!1);
              }, []),
              onClose: (0, e.useCallback)(() => {
                window.clearTimeout(u.current),
                  (u.current = window.setTimeout(() => s(!0), o));
              }, [o]),
              isPointerInTransitRef: c,
              onPointerInTransitChange: (0, e.useCallback)((e) => {
                c.current = e;
              }, []),
              disableHoverableContent: i,
            },
            a
          )
        );
      },
      Ia = (n) => {
        const {
            __scopeTooltip: t,
            children: r,
            open: o,
            defaultOpen: i = !1,
            onOpenChange: a,
            disableHoverableContent: l,
            delayDuration: s,
          } = n,
          c = va(Ca, n.__scopeTooltip),
          u = ha(t),
          [d, p] = (0, e.useState)(null),
          f = (function (n) {
            const [t, r] = e.useState(go());
            return (
              _o(() => {
                r((e) => (null != e ? e : String(vo++)));
              }, [n]),
              t ? `radix-${t}` : ""
            );
          })(),
          h = (0, e.useRef)(0),
          m = null != l ? l : c.disableHoverableContent,
          _ = null != s ? s : c.delayDuration,
          g = (0, e.useRef)(!1),
          [v = !1, C] = (function ({
            prop: n,
            defaultProp: t,
            onChange: r = () => {},
          }) {
            const [o, i] = (function ({ defaultProp: n, onChange: t }) {
                const r = (0, e.useState)(n),
                  [o] = r,
                  i = (0, e.useRef)(o),
                  a = so(t);
                return (
                  (0, e.useEffect)(() => {
                    i.current !== o && (a(o), (i.current = o));
                  }, [o, i, a]),
                  r
                );
              })({ defaultProp: t, onChange: r }),
              a = void 0 !== n,
              l = a ? n : o,
              s = so(r);
            return [
              l,
              (0, e.useCallback)(
                (e) => {
                  if (a) {
                    const t = e,
                      r = "function" == typeof e ? t(n) : e;
                    r !== n && s(r);
                  } else i(e);
                },
                [a, n, i, s]
              ),
            ];
          })({
            prop: o,
            defaultProp: i,
            onChange: (e) => {
              e
                ? (c.onOpen(), document.dispatchEvent(new CustomEvent(_a)))
                : c.onClose(),
                null == a || a(e);
            },
          }),
          b = (0, e.useMemo)(
            () =>
              v ? (g.current ? "delayed-open" : "instant-open") : "closed",
            [v]
          ),
          x = (0, e.useCallback)(() => {
            window.clearTimeout(h.current), (g.current = !1), C(!0);
          }, [C]),
          y = (0, e.useCallback)(() => {
            window.clearTimeout(h.current), C(!1);
          }, [C]),
          w = (0, e.useCallback)(() => {
            window.clearTimeout(h.current),
              (h.current = window.setTimeout(() => {
                (g.current = !0), C(!0);
              }, _));
          }, [_, C]);
        return (
          (0, e.useEffect)(() => () => window.clearTimeout(h.current), []),
          (0, e.createElement)(
            oa,
            u,
            (0, e.createElement)(
              ba,
              {
                scope: t,
                contentId: f,
                open: v,
                stateAttribute: b,
                trigger: d,
                onTriggerChange: p,
                onTriggerEnter: (0, e.useCallback)(() => {
                  c.isOpenDelayed ? w() : x();
                }, [c.isOpenDelayed, w, x]),
                onTriggerLeave: (0, e.useCallback)(() => {
                  m ? y() : window.clearTimeout(h.current);
                }, [y, m]),
                onOpen: x,
                onClose: y,
                disableHoverableContent: m,
              },
              r
            )
          )
        );
      },
      Pa = wa,
      Ra = (n) => {
        const {
            __scopeTooltip: t,
            forceMount: r,
            children: o,
            container: i,
          } = n,
          a = xa(ka, t);
        return (0, e.createElement)(
          La,
          { scope: t, forceMount: r },
          (0, e.createElement)(
            ca,
            { present: r || a.open },
            (0, e.createElement)(sa, { asChild: !0, container: i }, o)
          )
        );
      },
      Ha = Sa,
      Va = (0, e.forwardRef)((n, t) => {
        const { __scopeTooltip: r, ...o } = n,
          i = ha(r);
        return Na("TooltipArrow", r).isInside
          ? null
          : (0, e.createElement)(la, $r({}, i, o, { ref: t }));
      });
    var Da = o(615),
      Ba = o.n(Da),
      Wa =
        (o(413),
        function (e) {
          var n = e.className,
            t = e.children,
            r = e.customTriggerStyle,
            o = e.direction,
            i = e.text,
            a = e.delayDuration,
            l = void 0 === a ? 400 : a;
          return i
            ? (0, Qe.jsx)(Aa, {
                children: (0, Qe.jsxs)(Ia, {
                  delayDuration: l,
                  children: [
                    (0, Qe.jsx)(Pa, {
                      asChild: !0,
                      className: "lt-tooltip-trigger",
                      style: r,
                      children: (0, Qe.jsx)("div", {
                        className: "tooltipChildrenWrapper",
                        children: t,
                      }),
                    }),
                    (0, Qe.jsx)(Ra, {
                      children: (0, Qe.jsxs)(Ha, {
                        className: "".concat(n, " TooltipContent"),
                        side: o,
                        sideOffset: 5,
                        children: [
                          i,
                          (0, Qe.jsx)(Va, { className: "TooltipArrow" }),
                        ],
                      }),
                    }),
                  ],
                }),
              })
            : (0, Qe.jsx)(Qe.Fragment, { children: t });
        });
    (Wa.Direction = {
      BOTTOM: "bottom",
      LEFT: "left",
      RIGHT: "right",
      TOP: "top",
    }),
      (Wa.propTypes = {
        children: Ba().node,
        customTriggerStyle: Ba().object,
        direction: Ba().string,
        noDelay: Ba().bool,
        text: Ba().string,
        wrap: Ba().bool,
      });
    var za = Wa;
    function Za(e) {
      return (
        (Za =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (e) {
                return typeof e;
              }
            : function (e) {
                return e &&
                  "function" == typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              }),
        Za(e)
      );
    }
    function Fa(e, n) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n &&
          (r = r.filter(function (n) {
            return Object.getOwnPropertyDescriptor(e, n).enumerable;
          })),
          t.push.apply(t, r);
      }
      return t;
    }
    function Ua(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2
          ? Fa(Object(t), !0).forEach(function (n) {
              Ka(e, n, t[n]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : Fa(Object(t)).forEach(function (n) {
              Object.defineProperty(
                e,
                n,
                Object.getOwnPropertyDescriptor(t, n)
              );
            });
      }
      return e;
    }
    function Ka(e, n, t) {
      return (
        n in e
          ? Object.defineProperty(e, n, {
              value: t,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[n] = t),
        e
      );
    }
    function Ga() {
      Ga = function () {
        return e;
      };
      var e = {},
        n = Object.prototype,
        t = n.hasOwnProperty,
        r =
          Object.defineProperty ||
          function (e, n, t) {
            e[n] = t.value;
          },
        o = "function" == typeof Symbol ? Symbol : {},
        i = o.iterator || "@@iterator",
        a = o.asyncIterator || "@@asyncIterator",
        l = o.toStringTag || "@@toStringTag";
      function s(e, n, t) {
        return (
          Object.defineProperty(e, n, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          }),
          e[n]
        );
      }
      try {
        s({}, "");
      } catch (e) {
        s = function (e, n, t) {
          return (e[n] = t);
        };
      }
      function c(e, n, t, o) {
        var i = n && n.prototype instanceof p ? n : p,
          a = Object.create(i.prototype),
          l = new L(o || []);
        return r(a, "_invoke", { value: x(e, t, l) }), a;
      }
      function u(e, n, t) {
        try {
          return { type: "normal", arg: e.call(n, t) };
        } catch (e) {
          return { type: "throw", arg: e };
        }
      }
      e.wrap = c;
      var d = {};
      function p() {}
      function f() {}
      function h() {}
      var m = {};
      s(m, i, function () {
        return this;
      });
      var _ = Object.getPrototypeOf,
        g = _ && _(_(j([])));
      g && g !== n && t.call(g, i) && (m = g);
      var v = (h.prototype = p.prototype = Object.create(m));
      function C(e) {
        ["next", "throw", "return"].forEach(function (n) {
          s(e, n, function (e) {
            return this._invoke(n, e);
          });
        });
      }
      function b(e, n) {
        function o(r, i, a, l) {
          var s = u(e[r], e, i);
          if ("throw" !== s.type) {
            var c = s.arg,
              d = c.value;
            return d && "object" == Za(d) && t.call(d, "__await")
              ? n.resolve(d.__await).then(
                  function (e) {
                    o("next", e, a, l);
                  },
                  function (e) {
                    o("throw", e, a, l);
                  }
                )
              : n.resolve(d).then(
                  function (e) {
                    (c.value = e), a(c);
                  },
                  function (e) {
                    return o("throw", e, a, l);
                  }
                );
          }
          l(s.arg);
        }
        var i;
        r(this, "_invoke", {
          value: function (e, t) {
            function r() {
              return new n(function (n, r) {
                o(e, t, n, r);
              });
            }
            return (i = i ? i.then(r, r) : r());
          },
        });
      }
      function x(e, n, t) {
        var r = "suspendedStart";
        return function (o, i) {
          if ("executing" === r)
            throw new Error("Generator is already running");
          if ("completed" === r) {
            if ("throw" === o) throw i;
            return { value: void 0, done: !0 };
          }
          for (t.method = o, t.arg = i; ; ) {
            var a = t.delegate;
            if (a) {
              var l = y(a, t);
              if (l) {
                if (l === d) continue;
                return l;
              }
            }
            if ("next" === t.method) t.sent = t._sent = t.arg;
            else if ("throw" === t.method) {
              if ("suspendedStart" === r) throw ((r = "completed"), t.arg);
              t.dispatchException(t.arg);
            } else "return" === t.method && t.abrupt("return", t.arg);
            r = "executing";
            var s = u(e, n, t);
            if ("normal" === s.type) {
              if (((r = t.done ? "completed" : "suspendedYield"), s.arg === d))
                continue;
              return { value: s.arg, done: t.done };
            }
            "throw" === s.type &&
              ((r = "completed"), (t.method = "throw"), (t.arg = s.arg));
          }
        };
      }
      function y(e, n) {
        var t = e.iterator[n.method];
        if (void 0 === t) {
          if (((n.delegate = null), "throw" === n.method)) {
            if (
              e.iterator.return &&
              ((n.method = "return"),
              (n.arg = void 0),
              y(e, n),
              "throw" === n.method)
            )
              return d;
            (n.method = "throw"),
              (n.arg = new TypeError(
                "The iterator does not provide a 'throw' method"
              ));
          }
          return d;
        }
        var r = u(t, e.iterator, n.arg);
        if ("throw" === r.type)
          return (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), d;
        var o = r.arg;
        return o
          ? o.done
            ? ((n[e.resultName] = o.value),
              (n.next = e.nextLoc),
              "return" !== n.method && ((n.method = "next"), (n.arg = void 0)),
              (n.delegate = null),
              d)
            : o
          : ((n.method = "throw"),
            (n.arg = new TypeError("iterator result is not an object")),
            (n.delegate = null),
            d);
      }
      function w(e) {
        var n = { tryLoc: e[0] };
        1 in e && (n.catchLoc = e[1]),
          2 in e && ((n.finallyLoc = e[2]), (n.afterLoc = e[3])),
          this.tryEntries.push(n);
      }
      function k(e) {
        var n = e.completion || {};
        (n.type = "normal"), delete n.arg, (e.completion = n);
      }
      function L(e) {
        (this.tryEntries = [{ tryLoc: "root" }]),
          e.forEach(w, this),
          this.reset(!0);
      }
      function j(e) {
        if (e) {
          var n = e[i];
          if (n) return n.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var r = -1,
              o = function n() {
                for (; ++r < e.length; )
                  if (t.call(e, r)) return (n.value = e[r]), (n.done = !1), n;
                return (n.value = void 0), (n.done = !0), n;
              };
            return (o.next = o);
          }
        }
        return { next: E };
      }
      function E() {
        return { value: void 0, done: !0 };
      }
      return (
        (f.prototype = h),
        r(v, "constructor", { value: h, configurable: !0 }),
        r(h, "constructor", { value: f, configurable: !0 }),
        (f.displayName = s(h, l, "GeneratorFunction")),
        (e.isGeneratorFunction = function (e) {
          var n = "function" == typeof e && e.constructor;
          return (
            !!n &&
            (n === f || "GeneratorFunction" === (n.displayName || n.name))
          );
        }),
        (e.mark = function (e) {
          return (
            Object.setPrototypeOf
              ? Object.setPrototypeOf(e, h)
              : ((e.__proto__ = h), s(e, l, "GeneratorFunction")),
            (e.prototype = Object.create(v)),
            e
          );
        }),
        (e.awrap = function (e) {
          return { __await: e };
        }),
        C(b.prototype),
        s(b.prototype, a, function () {
          return this;
        }),
        (e.AsyncIterator = b),
        (e.async = function (n, t, r, o, i) {
          void 0 === i && (i = Promise);
          var a = new b(c(n, t, r, o), i);
          return e.isGeneratorFunction(t)
            ? a
            : a.next().then(function (e) {
                return e.done ? e.value : a.next();
              });
        }),
        C(v),
        s(v, l, "Generator"),
        s(v, i, function () {
          return this;
        }),
        s(v, "toString", function () {
          return "[object Generator]";
        }),
        (e.keys = function (e) {
          var n = Object(e),
            t = [];
          for (var r in n) t.push(r);
          return (
            t.reverse(),
            function e() {
              for (; t.length; ) {
                var r = t.pop();
                if (r in n) return (e.value = r), (e.done = !1), e;
              }
              return (e.done = !0), e;
            }
          );
        }),
        (e.values = j),
        (L.prototype = {
          constructor: L,
          reset: function (e) {
            if (
              ((this.prev = 0),
              (this.next = 0),
              (this.sent = this._sent = void 0),
              (this.done = !1),
              (this.delegate = null),
              (this.method = "next"),
              (this.arg = void 0),
              this.tryEntries.forEach(k),
              !e)
            )
              for (var n in this)
                "t" === n.charAt(0) &&
                  t.call(this, n) &&
                  !isNaN(+n.slice(1)) &&
                  (this[n] = void 0);
          },
          stop: function () {
            this.done = !0;
            var e = this.tryEntries[0].completion;
            if ("throw" === e.type) throw e.arg;
            return this.rval;
          },
          dispatchException: function (e) {
            if (this.done) throw e;
            var n = this;
            function r(t, r) {
              return (
                (a.type = "throw"),
                (a.arg = e),
                (n.next = t),
                r && ((n.method = "next"), (n.arg = void 0)),
                !!r
              );
            }
            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                a = i.completion;
              if ("root" === i.tryLoc) return r("end");
              if (i.tryLoc <= this.prev) {
                var l = t.call(i, "catchLoc"),
                  s = t.call(i, "finallyLoc");
                if (l && s) {
                  if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                } else if (l) {
                  if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                } else {
                  if (!s)
                    throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function (e, n) {
            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var o = this.tryEntries[r];
              if (
                o.tryLoc <= this.prev &&
                t.call(o, "finallyLoc") &&
                this.prev < o.finallyLoc
              ) {
                var i = o;
                break;
              }
            }
            i &&
              ("break" === e || "continue" === e) &&
              i.tryLoc <= n &&
              n <= i.finallyLoc &&
              (i = null);
            var a = i ? i.completion : {};
            return (
              (a.type = e),
              (a.arg = n),
              i
                ? ((this.method = "next"), (this.next = i.finallyLoc), d)
                : this.complete(a)
            );
          },
          complete: function (e, n) {
            if ("throw" === e.type) throw e.arg;
            return (
              "break" === e.type || "continue" === e.type
                ? (this.next = e.arg)
                : "return" === e.type
                ? ((this.rval = this.arg = e.arg),
                  (this.method = "return"),
                  (this.next = "end"))
                : "normal" === e.type && n && (this.next = n),
              d
            );
          },
          finish: function (e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var t = this.tryEntries[n];
              if (t.finallyLoc === e)
                return this.complete(t.completion, t.afterLoc), k(t), d;
            }
          },
          catch: function (e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var t = this.tryEntries[n];
              if (t.tryLoc === e) {
                var r = t.completion;
                if ("throw" === r.type) {
                  var o = r.arg;
                  k(t);
                }
                return o;
              }
            }
            throw new Error("illegal catch attempt");
          },
          delegateYield: function (e, n, t) {
            return (
              (this.delegate = { iterator: j(e), resultName: n, nextLoc: t }),
              "next" === this.method && (this.arg = void 0),
              d
            );
          },
        }),
        e
      );
    }
    function Ya(e, n, t, r, o, i, a) {
      try {
        var l = e[i](a),
          s = l.value;
      } catch (e) {
        return void t(e);
      }
      l.done ? n(s) : Promise.resolve(s).then(r, o);
    }
    function $a(e) {
      return function () {
        var n = this,
          t = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(n, t);
          function a(e) {
            Ya(i, r, o, a, l, "next", e);
          }
          function l(e) {
            Ya(i, r, o, a, l, "throw", e);
          }
          a(void 0);
        });
      };
    }
    function qa(e, n) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, n) {
          var t =
            null == e
              ? null
              : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                e["@@iterator"];
          if (null != t) {
            var r,
              o,
              i = [],
              a = !0,
              l = !1;
            try {
              for (
                t = t.call(e);
                !(a = (r = t.next()).done) &&
                (i.push(r.value), !n || i.length !== n);
                a = !0
              );
            } catch (e) {
              (l = !0), (o = e);
            } finally {
              try {
                a || null == t.return || t.return();
              } finally {
                if (l) throw o;
              }
            }
            return i;
          }
        })(e, n) ||
        (function (e, n) {
          if (e) {
            if ("string" == typeof e) return Qa(e, n);
            var t = Object.prototype.toString.call(e).slice(8, -1);
            return (
              "Object" === t && e.constructor && (t = e.constructor.name),
              "Map" === t || "Set" === t
                ? Array.from(e)
                : "Arguments" === t ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
                ? Qa(e, n)
                : void 0
            );
          }
        })(e, n) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        })()
      );
    }
    function Qa(e, n) {
      (null == n || n > e.length) && (n = e.length);
      for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
      return r;
    }
    var Xa = "Configure Tunnel",
      Ja = "Active Tunnels";
    function el(n) {
      var t = n.areFeatureFlagsFetched,
        o = void 0 !== t && t,
        i = n.brandName,
        a = void 0 === i ? "" : i,
        l = n.concurrencyInfo,
        s = void 0 === l ? [] : l,
        c = n.customProductHeader,
        u = void 0 === c ? null : c,
        d = n.defaultTabIndex,
        p = void 0 === d ? 0 : d,
        f = n.lowResNavItems,
        m = void 0 === f ? [] : f,
        g = n.isCollapsed,
        v = void 0 !== g && g,
        b = n.isNewThemeEnabled,
        w = void 0 !== b && b,
        k = n.onPremPrefixToUse,
        L = void 0 === k ? "" : k,
        j = n.showTunnel,
        E = void 0 !== j && j,
        S = n.showA11yWarning,
        M = void 0 !== S && S,
        T = n.setIsSideBarCollapsed,
        N = n.topNavCustomInfo,
        O = void 0 === N ? void 0 : N,
        A = n.topNavButtons,
        R = void 0 === A ? void 0 : A,
        H = n.upgradeBtnTextToDisplay,
        V = void 0 === H ? "" : H,
        B = n.userInfo,
        W = qa((0, e.useState)(!1), 2),
        z = W[0],
        U = W[1],
        K = (0, e.useContext)(r) || {},
        G = K.isHighContrastThemeEnabled,
        Y = void 0 !== G && G,
        $ = K.enableNewSidebar,
        q = void 0 !== $ && $,
        Q = K.enableSanctumWidget,
        X = void 0 !== Q && Q,
        J = K.isNewToReferral,
        ee = void 0 !== J && J,
        te = qa((0, e.useState)(!1), 2),
        re = te[0],
        oe = te[1],
        ie = qa((0, e.useState)(null), 2),
        ae = ie[0],
        le = ie[1],
        ce = qa((0, e.useState)({}), 2),
        de = ce[0],
        pe = ce[1],
        he = ((0, e.useRef)(), (0, e.useRef)()),
        me = (0, e.useRef)(),
        _e = (0, e.useRef)(),
        ge = function (e) {
          Ve(
            e,
            "tunnel_dropdown_hide",
            document.getElementById("desktop_app").tabIndex > -1
              ? "ltch-configure-tunnel-more-details-desktop-tab"
              : "ltch-configure-tunnel-more-details",
            "tunnel__dropdown__toggle__configure"
          ),
            "Escape" === e.key &&
              document
                .getElementById("tunnel__dropdown__toggle__configure")
                .click(),
            e.key;
        },
        Ce = function (e) {
          if ((We(e, he, "profile__menu__item"), "Escape" === e.key)) {
            var n = document.getElementById("profile__dropdown");
            n.click(), n.focus();
          }
        },
        be = function (e) {
          if ((We(e, me, "ltch-more-options-item"), "Escape" === e.key)) {
            var n = document.getElementsByClassName("ltch-more-options-btn")[0];
            n.click(), n.focus();
          }
        },
        xe = function (e) {
          e.classList.remove("open"),
            e.setAttribute("aria-expanded", !1),
            e.hasAttribute("aria-controls") &&
              e.removeAttribute("aria-controls"),
            He(!0),
            document.removeEventListener("keydown", ge),
            setTimeout(function () {
              document
                .getElementById("tunnel__dropdown__toggle__configure")
                .focus();
            }, 100);
        },
        ye = qa((0, e.useState)(ne.COLLAPSE), 2),
        we = ye[0],
        je = ye[1],
        Ee = function (e) {
          var n = e.customDomToShow,
            t = void 0 === n ? (0, Qe.jsx)(Qe.Fragment, {}) : n,
            r = e.popupContentType;
          document
            .getElementsByClassName("ltch-more-options-wrapper")[0]
            .classList.remove("open"),
            oe(!0),
            r === Xa
              ? pe({
                  Component: Wr,
                  ComponentProps: {
                    defaultTabIndex: p,
                    onClose: _n,
                    doShow: !0,
                    userInfo: B,
                  },
                })
              : r === Ja
              ? pe({
                  Component: zr,
                  ComponentProps: {
                    doShow: !0,
                    tunnels: rn,
                    handleTunnelConfigClick: mn,
                    loadBalancedTunnelCount: hn,
                    stopTunnel: fn,
                    userInfo: B,
                  },
                })
              : le(t);
        },
        Se = function () {
          oe(!1), le(null);
          var e = document.getElementsByClassName("ltch-more-options-btn")[0];
          e &&
            setTimeout(function () {
              e.focus();
            }, 100);
        },
        Te = function () {
          if (!q) {
            var e = document.getElementById("top_navbar_header"),
              n = document.getElementById("left_sidebar_header-items"),
              t = document.getElementById("lt-ch-left-nav"),
              r = document.getElementsByClassName("ltch-sidebar-overlay")[0],
              o = {
                userId: Ae("user_id"),
                shouldSidebarCollapse: !e.classList.contains("collapsed"),
              },
              i = btoa(JSON.stringify(o));
            if ((v || Le("sidebarStateObject", i, 30), e)) {
              e.classList.toggle("collapsed");
              var a = e.classList.contains("collapsed")
                ? ne.EXPAND
                : ne.COLLAPSE;
              je(a);
              var l = new CustomEvent("LTCH_IsSidebarCollapsed", {
                detail: { collapsed: e.classList.contains("collapsed") },
              });
              window.dispatchEvent(l);
            }
            n &&
              (r || T(!n.classList.contains("collapsed")),
              n.classList.toggle("collapsed")),
              t && t.classList.toggle("collapsed");
          }
        };
      (0, e.useEffect)(function () {
        !(function () {
          var e = document.getElementById(
              "tunnel__dropdown__toggle__configure"
            ),
            n = document.getElementById("tunnel__dropdown__menu__configure"),
            t = document.getElementById("tunnel__dropdown__toggle__configure2"),
            r = document.getElementById("tunnel__dropdown__menu__list"),
            o = document.getElementById("tunnel__dropdown__toggle__list"),
            i = document.querySelector(
              "#tunnel__dropdown__menu__configure .tunnel_overlay"
            ),
            a = document.querySelector(
              "#tunnel__dropdown__menu__list .tunnel_overlay"
            );
          e &&
            (e.onclick = function (t) {
              if (n) {
                var r = n.classList.contains("open");
                e.setAttribute("aria-expanded", !r),
                  r
                    ? e.removeAttribute("aria-controls")
                    : e.setAttribute(
                        "aria-controls",
                        "tunnel__dropdown__menu__configure"
                      ),
                  He(r),
                  n.classList.toggle("open");
                var o = document.getElementsByClassName("tunnel_overlay")[0];
                if (r) document.removeEventListener("keydown", ge);
                else {
                  var i = document.getElementById(
                    "tunnel__dropdown__toggle__configure--hide"
                  );
                  i && i.focus(), o && document.addEventListener("keydown", ge);
                }
              }
            }),
            t &&
              (t.onclick = function () {
                var e = t.classList.contains("open");
                t.setAttribute("aria-expanded", !e),
                  He(!e),
                  r && r.classList.remove("open"),
                  n && n.classList.add("open");
              });
          var l = document.getElementById(
            "tunnel__dropdown__toggle__configure--hide"
          );
          l &&
            ((l.onclick = function () {
              n && xe(n);
            }),
            (l.onkeydown = function (e) {
              n && "Enter" === e.key && xe(n);
            }));
          var s = document.getElementById("profile__dropdown__parent"),
            c = document.getElementById("profile__dropdown"),
            u = document.getElementsByClassName("ltch-more-options-wrapper")[0];
          c &&
            ((c.onclick = function () {
              if (
                (c.setAttribute("aria-expanded", !s.classList.contains("open")),
                s.classList.contains("open")
                  ? c.removeAttribute("aria-controls")
                  : c.setAttribute("aria-controls", "ltch_profile_container"),
                s && (s.classList.toggle("open"), s.classList.contains("open")))
              ) {
                var e = document.getElementsByClassName(
                  "ltch-profile-account-settings"
                )[0];
                e && e.focus();
              }
              r && r.classList.remove("open"),
                n && n.classList.remove("open"),
                u && u.classList.remove("open");
            }),
            (c.onkeydown = function (e) {
              if (
                (c.setAttribute("aria-expanded", !s.classList.contains("open")),
                s.classList.contains("open")
                  ? c.removeAttribute("aria-controls")
                  : c.setAttribute("aria-controls", "ltch_profile_container"),
                "Enter" === e.key)
              ) {
                if (
                  s &&
                  (s.classList.toggle("open"), s.classList.contains("open"))
                ) {
                  var t = document.getElementsByClassName(
                    "ltch-profile-account-settings"
                  )[0];
                  t && t.focus();
                }
                r && r.classList.remove("open"),
                  n && n.classList.remove("open"),
                  u && u.classList.remove("open");
              }
            }),
            s.classList.contains("open")
              ? he.current.removeEventListener("keydown", Ce)
              : he.current.addEventListener("keydown", Ce)),
            (i || a) &&
              ((i.onclick = function () {
                r && r.classList.remove("open"),
                  n && n.classList.remove("open"),
                  e &&
                    (e.setAttribute("aria-expanded", !1),
                    e.removeAttribute("aria-controls"),
                    He(!0));
              }),
              (a.onclick = function () {
                r && r.classList.remove("open"),
                  o && (o.setAttribute("aria-expanded", !1), He(!0)),
                  n && n.classList.remove("open");
              }));
        })();
      }, []);
      var Ne = B.avatar,
        Oe = void 0 === Ne ? "" : Ne,
        Pe = B.name,
        De = B.email,
        Be = (B.apiToken, B.organization),
        Fe = void 0 === Be ? {} : Be,
        Ue = B.organization_role,
        Ke = void 0 === Ue ? "" : Ue,
        Ge = (B.username, B.id, Fe.current_subscription_type),
        Ye = void 0 === Ge ? "" : Ge,
        $e = Fe.is_reseller_customer,
        qe = void 0 !== $e && $e,
        Xe = Fe.new_lums_ui_enabled,
        Je = void 0 !== Xe && Xe,
        en = Fe.id,
        nn = void 0 === en ? "" : en,
        tn = qa((0, e.useState)([]), 2),
        rn = tn[0],
        on = tn[1],
        an = qa((0, e.useState)([]), 2),
        ln = an[0],
        sn = an[1],
        cn = qa((0, e.useState)([]), 2),
        un = cn[0],
        dn = cn[1];
      (0, e.useEffect)(
        function () {
          De && E && pn();
        },
        [De, E]
      ),
        (0, e.useEffect)(
          function () {
            _e.current = rn;
          },
          [rn]
        );
      var pn = (function () {
          var e = $a(
            Ga().mark(function e() {
              var n, t, r, o, i;
              return Ga().wrap(
                function (e) {
                  for (;;)
                    switch ((e.prev = e.next)) {
                      case 0:
                        return (
                          (e.prev = 0),
                          (n = "".concat(ve(ue, !0), "/v1.0/user/tunnels")),
                          (e.next = 4),
                          fetch(n, {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + ke(),
                            },
                          })
                        );
                      case 4:
                        return (t = e.sent), (e.next = 7), t.json();
                      case 7:
                        (r = e.sent),
                          (o = r.filter(function (e, n, t) {
                            return (
                              t.findIndex(function (n) {
                                return (
                                  n.user_id === e.user_id &&
                                  n.load_balanced === e.load_balanced &&
                                  n.tunnel_name === e.tunnel_name
                                );
                              }) === n
                            );
                          })),
                          on(o || []),
                          sn(r || []),
                          (i = r.filter(function (e) {
                            if (e.load_balanced) return e;
                          })),
                          dn(i),
                          pe({
                            Component: zr,
                            ComponentProps: {
                              tunnels: o,
                              handleTunnelConfigClick: mn,
                              loadBalancedTunnelCount: hn,
                              stopTunnel: fn,
                              userInfo: B,
                            },
                          }),
                          window.dispatchEvent(
                            new CustomEvent("fetchlambdatunnel", {
                              detail: r || [],
                            })
                          ),
                          (e.next = 19);
                        break;
                      case 17:
                        (e.prev = 17), (e.t0 = e.catch(0));
                      case 19:
                      case "end":
                        return e.stop();
                    }
                },
                e,
                null,
                [[0, 17]]
              );
            })
          );
          return function () {
            return e.apply(this, arguments);
          };
        })(),
        fn = (function () {
          var e = $a(
            Ga().mark(function e(n) {
              var t, r, o, i, a;
              return Ga().wrap(
                function (e) {
                  for (;;)
                    switch ((e.prev = e.next)) {
                      case 0:
                        return (
                          (e.prev = 0),
                          ve(ue),
                          (t = "".concat(ve(ue, !0), "/v1.0/stop/").concat(n)),
                          (e.next = 5),
                          fetch(t, {
                            method: "DELETE",
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + ke(),
                            },
                            body: JSON.stringify({ tunnel_id: n }),
                          })
                        );
                      case 5:
                        return (r = e.sent), (e.next = 8), r.json();
                      case 8:
                        if (((o = e.sent), 200 != r.status)) {
                          e.next = 21;
                          break;
                        }
                        Re("H_tunnel_close"),
                          (i = _e.current.filter(function (e) {
                            return e.tunnel_id !== n;
                          })),
                          window.dispatchEvent(
                            new CustomEvent("fetchlambdatunnel", {
                              detail: i || [],
                            })
                          ),
                          0 === i.length &&
                            (document
                              .getElementById("tunnel__dropdown__menu__list")
                              .classList.remove("open"),
                            Se()),
                          on(i),
                          sn(i),
                          U(!0),
                          pe({
                            Component: zr,
                            ComponentProps: {
                              doShow: !0,
                              tunnels: i,
                              handleTunnelConfigClick: mn,
                              loadBalancedTunnelCount: hn,
                              stopTunnel: fn,
                              userInfo: B,
                            },
                          }),
                          setTimeout(function () {
                            U(!1);
                          }, 2e3),
                          (e.next = 23);
                        break;
                      case 21:
                        throw (
                          ((a =
                            o && o.error && "string" == typeof o.error
                              ? o.error
                              : "Error in removing the tunnel"),
                          new Error(a))
                        );
                      case 23:
                        e.next = 28;
                        break;
                      case 25:
                        (e.prev = 25),
                          (e.t0 = e.catch(0)),
                          e.t0.message.includes("No running tunnel") && pn();
                      case 28:
                      case "end":
                        return e.stop();
                    }
                },
                e,
                null,
                [[0, 25]]
              );
            })
          );
          return function (n) {
            return e.apply(this, arguments);
          };
        })(),
        hn = function (e) {
          var n = [];
          return (
            un.forEach(function (t) {
              e.tunnel_name == t.tunnel_name &&
                e.user_id == t.user_id &&
                n.push(t);
            }),
            n.length
          );
        },
        mn = function (e) {
          pe({
            Component: Wr,
            ComponentProps: {
              defaultTabIndex: p,
              onClose: _n,
              doShow: !0,
              userInfo: B,
            },
          });
        },
        _n = function () {
          Se();
        },
        gn = qa((0, e.useState)(""), 2),
        vn = gn[0],
        Cn = gn[1];
      (0, e.useLayoutEffect)(function () {
        var e = JSON.parse(localStorage.getItem("ltchactivemenu"));
        e && Cn(e.name);
        var n,
          t,
          r = Ae("sidebarStateObject"),
          o = Ae("user_id"),
          i = document.getElementById("top_navbar_header"),
          a = i.classList.contains("collapsed");
        if (r) {
          var l = atob(r);
          (n = JSON.parse(l).shouldSidebarCollapse), (t = JSON.parse(l).userId);
        }
        if ((t === o && !v && i && ((n && !a) || (!n && a)) && Te(), v)) {
          var s = document.getElementById("top_navbar_header");
          s && !s.classList.contains("collapsed") && Te();
        }
      }, []);
      var bn = qa((0, e.useState)(""), 2),
        xn = bn[0],
        yn = bn[1],
        wn = qa((0, e.useState)({}), 2),
        kn = wn[0],
        Ln = wn[1],
        jn = qa((0, e.useState)(!1), 2),
        En = jn[0],
        Sn = jn[1],
        Mn = ke();
      (0, e.useEffect)(
        function () {
          yn(Mn);
        },
        [Mn]
      ),
        (0, e.useEffect)(
          function () {
            xn && Ln(Ie(xn));
          },
          [xn]
        ),
        (0, e.useEffect)(
          function () {
            kn &&
              kn.identity_assumed_by &&
              0 !== kn.identity_assumed_by &&
              Sn(!0);
          },
          [xn, kn]
        );
      var Tn = function (e) {
          Ve(
            e,
            "tunnel__dropdown__toggle__configure2",
            "view__all__tunnels",
            "tunnel__dropdown__toggle__list"
          ),
            "Escape" === e.key &&
              document.getElementById("tunnel__dropdown__toggle__list").click();
        },
        Nn = E || s.length > 0 || m.length > 0;
      return (0, Qe.jsxs)("div", {
        className: "Top_Nav",
        children: [
          M &&
            (0, Qe.jsxs)("div", {
              className: "ltch-responsive_parent",
              children: [
                (0, Qe.jsx)(mr, { type: ne.NO_ACCESSIBILITY }),
                (0, Qe.jsxs)("div", {
                  children: [
                    (0, Qe.jsx)("div", {
                      className: "ltch-responsive_title",
                      children: "Screen Resolution Alert for Accessibility",
                    }),
                    (0, Qe.jsx)("div", {
                      children:
                        "For the best accessibility experience, it’s advisable to increase your screen resolution to 1280 pixels or higher, as some features may be restricted in this window size.",
                    }),
                  ],
                }),
              ],
            }),
          (0, Qe.jsx)(Pr, { defaultTabIndex: p, userInfo: B }),
          (0, Qe.jsxs)("div", {
            className: "header__top__menu ".concat(q ? "collapsed" : ""),
            id: "top_navbar_header",
            children: [
              !q &&
                (0, Qe.jsxs)("div", {
                  id: "lambda_logo_top_nav",
                  className: "lambda__logo__wrapper",
                  children: [
                    (0, Qe.jsx)("a", {
                      "aria-label": "LambdaTest Home Dashboard",
                      href: "".concat(ve(F, !1, "https", a, L), "/").concat(_),
                      className: "ltch_lambda__logo",
                      "data-amplitude": "SB_lambdatest",
                      role: "button",
                      tabIndex: p,
                      children: (0, Qe.jsx)(mr, {
                        className: "lambda__logo__img",
                        type: ne.LOGO,
                      }),
                    }),
                    (0, Qe.jsx)("div", {
                      className: "menu__collapse__toggle",
                      onClick: Te,
                      tabIndex: p,
                      role: "button",
                      "aria-label": we,
                      onKeyDown: function (e) {
                        "Enter" === e.key && Te();
                      },
                      children: (0, Qe.jsx)(mr, {
                        id: "menu__toggle",
                        type: we,
                      }),
                    }),
                  ],
                }),
              (0, Qe.jsxs)("div", {
                className: "top__nav__items ".concat(
                  q ? "new__sidebar__top__nav__items" : ""
                ),
                children: [
                  (0, Qe.jsx)("div", {
                    className: "top__nav__product__title",
                    children: u || vn,
                  }),
                  (0, Qe.jsx)("aside", {
                    "aria-label": "Header menu items",
                    className: "ltch-topnav-aside-menu",
                    children: (0, Qe.jsxs)("ul", {
                      className: "menu__items",
                      children: [
                        O &&
                          (0, Qe.jsxs)("li", {
                            className:
                              "ltch-top-nav-custom-info-wrapper ltch-high-res-items",
                            children: [
                              (0, Qe.jsx)("div", { children: O }),
                              (0, Qe.jsx)("div", {
                                className: "ltch-section-separator",
                              }),
                            ],
                          }),
                        o &&
                          Ze(X) &&
                          (0, Qe.jsx)("li", {
                            className: "ltch-high-res-items",
                            children: (0, Qe.jsx)(yr, {}),
                          }),
                        o &&
                          !X &&
                          s.length > 0 &&
                          (0, Qe.jsx)("li", {
                            className: "ltch-high-res-items",
                            children: (0, Qe.jsx)(wr, { concurrencyInfo: s }),
                          }),
                        E &&
                          (0, Qe.jsxs)("li", {
                            className:
                              "nav__item lt-dropdown tunnel__dropdown ltch-high-res-items",
                            children: [
                              (0, Qe.jsx)(za, {
                                text: w ? "Configure Tunnel" : "",
                                children: (0, Qe.jsx)("button", {
                                  "aria-label": w ? "Configure Tunnel" : void 0,
                                  "aria-expanded": !1,
                                  "aria-haspopup": "dialog",
                                  tabIndex: p,
                                  type: "button",
                                  className:
                                    "tunnel__dropdown__toggle tunnel__dropdown__toggle__configure "
                                      .concat(
                                        w
                                          ? "tunnel__dropdown__toggle-new"
                                          : "tunnel__dropdown__toggle",
                                        " "
                                      )
                                      .concat(
                                        Y ? "ltch_high_contrast_item" : ""
                                      ),
                                  id: "tunnel__dropdown__toggle__configure",
                                  "data-amplitude":
                                    "header: click configure tunnel",
                                  "data-amplitude-property-name": "page url",
                                  style: {
                                    display:
                                      ln && 0 === ln.length ? "block" : "none",
                                  },
                                  children: w
                                    ? (0, Qe.jsx)(mr, { type: ne.TUNNEL })
                                    : "Configure Tunnel",
                                }),
                              }),
                              (0, Qe.jsx)(za, {
                                text: w && ln.length > 0 ? Ja : "",
                                children: (0, Qe.jsx)("button", {
                                  "aria-label": w
                                    ? "".concat(ln.length, " Active Tunnels")
                                    : void 0,
                                  type: "button",
                                  className:
                                    "tunnel__dropdown__toggle tunnel__dropdown__toggle__list "
                                      .concat(w ? "ltch-tunnel-btn" : "", " ")
                                      .concat(
                                        Y ? "ltch_high_contrast_item" : ""
                                      ),
                                  id: "tunnel__dropdown__toggle__list",
                                  style: {
                                    display:
                                      ln && ln.length > 0 ? "block" : "none",
                                  },
                                  onClick: function (e) {
                                    var n = e.target,
                                      t = document.getElementById(
                                        "tunnel__dropdown__toggle__list"
                                      );
                                    n.setAttribute(
                                      "aria-expanded",
                                      !t.classList.contains("open")
                                    );
                                    var r = document.getElementById(
                                      "tunnel__dropdown__menu__list"
                                    );
                                    if (r) {
                                      var o = r.classList.contains("open");
                                      r.classList.toggle("open");
                                      var i =
                                        document.getElementsByClassName(
                                          "tunnel_overlay"
                                        )[0];
                                      o
                                        ? document.removeEventListener(
                                            "keydown",
                                            Tn
                                          )
                                        : (document
                                            .getElementById(
                                              "tunnel__dropdown__toggle__configure2"
                                            )
                                            .focus(),
                                          i &&
                                            document.addEventListener(
                                              "keydown",
                                              Tn
                                            ));
                                    }
                                  },
                                  children: w
                                    ? (0, Qe.jsxs)(Qe.Fragment, {
                                        children: [
                                          (0, Qe.jsx)(mr, {
                                            color: "#176F2C",
                                            type: ne.TUNNEL,
                                          }),
                                          (0, Qe.jsx)("span", {
                                            className:
                                              "ltch-tunnel-count-container",
                                            children: (0, Qe.jsx)("span", {
                                              className: "ltch-tunnel-count",
                                              children: ln.length,
                                            }),
                                          }),
                                        ],
                                      })
                                    : (0, Qe.jsxs)(Qe.Fragment, {
                                        children: [
                                          (0, Qe.jsx)("span", {
                                            className: "tunnel__dot",
                                          }),
                                          (0, Qe.jsx)("span", {
                                            children: "Tunnel Active",
                                          }),
                                          " ",
                                          (0, Qe.jsx)("span", {
                                            className: "tunnel__lenght",
                                            id: "tunnel__lenght",
                                            children: ln.length,
                                          }),
                                        ],
                                      }),
                                }),
                              }),
                              (0, Qe.jsx)(zr, {
                                tunnels: rn,
                                fetchTunnel: pn,
                                loadBalancedTunnelCount: hn,
                                stopTunnel: fn,
                                userInfo: B,
                              }),
                              (0, Qe.jsx)(Wr, {
                                defaultTabIndex: p,
                                userInfo: B,
                              }),
                            ],
                          }),
                        w &&
                          R &&
                          (0, Qe.jsx)("li", {
                            className: "ltch-high-res-items",
                            children: R,
                          }),
                        !fe.includes(nn) &&
                          !Y &&
                          (0, Qe.jsx)("li", {
                            className:
                              "ltch-high-res-items nav__item announcekit__widget__li",
                            children: (0, Qe.jsx)(za, {
                              text: w ? "Announcements" : "",
                              children: (0, Qe.jsx)("div", {
                                className: ""
                                  .concat(
                                    w ? "announcekit__widget-new" : "",
                                    " announcekit-widget announcekit__widget "
                                  )
                                  .concat(Y ? "ltch_high_contrast_item" : ""),
                                tabIndex: p,
                                role: "button",
                                "aria-label": "notification",
                                children: w
                                  ? (0, Qe.jsx)(mr, { type: ne.ANNOUNCEMENT })
                                  : (0, Qe.jsx)(mr, {
                                      type: ne.NOTIFICATION,
                                      width: "24px",
                                      height: "24px",
                                    }),
                              }),
                            }),
                          }),
                        Nn &&
                          (0, Qe.jsxs)("li", {
                            className:
                              "nav__item lt-dropdown ltch-more-options-wrapper",
                            children: [
                              (0, Qe.jsx)("button", {
                                "aria-label": "More Options",
                                "aria-expanded": !1,
                                tabIndex: p,
                                onClick: function (e) {
                                  e.stopPropagation();
                                  var n = document.getElementsByClassName(
                                    "ltch-more-options-wrapper"
                                  )[0];
                                  if (
                                    (n && n.classList.toggle("open"),
                                    n.classList.contains("open"))
                                  ) {
                                    me.current.addEventListener("keydown", be);
                                    var t = document.querySelector(
                                      ".ltch-more-options-item:not(.ltch-more-options-item-read-only)"
                                    );
                                    t && t.focus();
                                  } else
                                    me.current.removeEventListener(
                                      "keydown",
                                      be
                                    );
                                  var r = document.getElementById(
                                    "profile__dropdown__parent"
                                  );
                                  r && r.classList.remove("open");
                                },
                                type: "button",
                                className:
                                  "ltch-icon-btn ltch-more-options-btn ".concat(
                                    Y ? "ltch_high_contrast_item" : ""
                                  ),
                                children: (0, Qe.jsx)(mr, {
                                  className: "ltch-flex",
                                  type: ne.KEBAB_ELLIPSIS,
                                }),
                              }),
                              (0, Qe.jsx)("div", {
                                className: "lt-dropdown-menu",
                                children: (0, Qe.jsxs)("ul", {
                                  ref: me,
                                  children: [
                                    s.length > 0 &&
                                      (0, Qe.jsxs)("li", {
                                        className:
                                          "ltch-concurrency-low-res-wrapper",
                                        children: [
                                          (0, Qe.jsx)(wr, {
                                            concurrencyInfo: s,
                                            renderAsListItem: !0,
                                          }),
                                          (0, Qe.jsx)("div", {
                                            className:
                                              "ltch-concurrency-low-res-separator",
                                          }),
                                        ],
                                      }),
                                    E &&
                                      (0, Qe.jsxs)("li", {
                                        className:
                                          "ltch-more-options-item ".concat(
                                            Y ? "ltch_high_contrast_item" : ""
                                          ),
                                        onClick: function () {
                                          return Ee({
                                            popupContentType:
                                              0 === ln.length ? Xa : Ja,
                                          });
                                        },
                                        onKeyDown: function (e) {
                                          "Enter" === e.key &&
                                            Ee({
                                              popupContentType:
                                                0 === ln.length ? Xa : Ja,
                                            });
                                        },
                                        tabIndex: p,
                                        children: [
                                          (0, Qe.jsx)(mr, {
                                            className:
                                              "ltch-more-options-menu-item-icon",
                                            type: ne.TUNNEL,
                                          }),
                                          0 === ln.length
                                            ? Xa
                                            : (0, Qe.jsxs)("div", {
                                                className: "ltch-tunnel-name",
                                                children: [
                                                  (0, Qe.jsx)("div", {
                                                    children: Ja,
                                                  }),
                                                  (0, Qe.jsx)("div", {
                                                    children: ln.length,
                                                  }),
                                                ],
                                              }),
                                        ],
                                      }),
                                    m.map(function (e, n) {
                                      var t = e.label,
                                        r = e.icon,
                                        o =
                                          void 0 === r
                                            ? (0, Qe.jsx)(Qe.Fragment, {})
                                            : r,
                                        i = e.onClick,
                                        a = void 0 === i ? void 0 : i,
                                        l = e.contentToShow,
                                        s = e.isReadOnly,
                                        c = void 0 !== s && s;
                                      return (0, Qe.jsxs)(
                                        "li",
                                        {
                                          className: ""
                                            .concat(
                                              Y
                                                ? "ltch_high_contrast_item"
                                                : "",
                                              " "
                                            )
                                            .concat(
                                              c
                                                ? "ltch-more-options-item-read-only"
                                                : "ltch-more-options-item"
                                            ),
                                          onClick: function (e) {
                                            a && a(e),
                                              l &&
                                                Ee({
                                                  popupContentType: "custom",
                                                  customDomToShow: l,
                                                });
                                          },
                                          onKeyDown: function (e) {
                                            "Enter" === e.key &&
                                              (a && a(e),
                                              l &&
                                                Ee({
                                                  popupContentType: "custom",
                                                  customDomToShow: l,
                                                }));
                                          },
                                          tabIndex: p,
                                          children: [o, t],
                                        },
                                        "low-res-nav-item-".concat(n)
                                      );
                                    }),
                                  ],
                                }),
                              }),
                            ],
                          }),
                        (0, Qe.jsxs)("li", {
                          className: "nav__item lt-dropdown profile__dropdown",
                          id: "profile__dropdown__parent",
                          children: [
                            (0, Qe.jsxs)("a", {
                              "aria-label": "Profile dropdown ".concat(Me(Pe)),
                              "aria-expanded": !1,
                              "aria-haspopup": !0,
                              className: "nav__link lt-dropdown-toggle",
                              id: "profile__dropdown",
                              "data-amplitude": "header: click user icon",
                              "data-amplitude-property-name": "page url",
                              role: "button",
                              tabIndex: p,
                              children: [
                                !En &&
                                  (0, Qe.jsxs)("div", {
                                    className: "ltch-profile-bubble-container",
                                    children: [
                                      Oe
                                        ? (0, Qe.jsx)("img", {
                                            alt: "User Avatar",
                                            className: "user_initial",
                                            src: Oe,
                                            role: "button",
                                            "aria-hidden": !0,
                                          })
                                        : (0, Qe.jsx)("span", {
                                            className: "user_initial",
                                            children: Me(Pe),
                                          }),
                                      !w &&
                                        (0, Qe.jsx)(mr, {
                                          className:
                                            "ltch-profile-bubble-arrow",
                                          type: ne.ARROW_DOWN,
                                        }),
                                    ],
                                  }),
                                En &&
                                  (0, Qe.jsxs)("div", {
                                    className: "ltch-profile-bubble-container",
                                    children: [
                                      (0, Qe.jsx)(mr, { type: ne.USER_LOCK }),
                                      (0, Qe.jsx)(mr, {
                                        className: "ltch-profile-bubble-arrow",
                                        type: ne.ARROW_DOWN,
                                      }),
                                    ],
                                  }),
                              ],
                            }),
                            (0, Qe.jsxs)("div", {
                              "aria-label": "Profile Menu",
                              "aria-modal": "true",
                              className: "lt-dropdown-menu",
                              id: "ltch_profile_container",
                              role: "dialog",
                              children: [
                                En &&
                                  (0, Qe.jsxs)("div", {
                                    className: "assumed_identity",
                                    children: ["Assumed Identity of:", " "],
                                  }),
                                (0, Qe.jsxs)("div", {
                                  className:
                                    "profile__menu__item profile__dropdown__label profile__dropdown__label__initial",
                                  children: [
                                    Oe
                                      ? (0, Qe.jsx)("img", {
                                          alt: "User Avatar",
                                          className: "user_initial",
                                          src: Oe,
                                          "aria-hidden": !0,
                                        })
                                      : (0, Qe.jsx)("span", {
                                          className: "user_initial",
                                          children: Me(Pe),
                                        }),
                                    (0, Qe.jsxs)("span", {
                                      className: "user_profile_name",
                                      children: [
                                        Pe,
                                        (0, Qe.jsx)("small", { children: De }),
                                      ],
                                    }),
                                  ],
                                }),
                                (0, Qe.jsxs)("ul", {
                                  className:
                                    "ltch-top-nav-profile-items-wrapper",
                                  ref: he,
                                  children: [
                                    (0, Qe.jsx)("li", {
                                      children: (0, Qe.jsx)("a", {
                                        href: ""
                                          .concat(ve(F, !1, "https", a, L), "/")
                                          .concat(Je ? x : y),
                                        className:
                                          "profile__menu__item ltch-profile-account-settings ".concat(
                                            Y ? "ltch_high_contrast_item" : ""
                                          ),
                                        "data-amplitude":
                                          "header: click profile - user settings",
                                        "data-amplitude-property-name":
                                          "page url",
                                        children: (0, Qe.jsxs)("span", {
                                          className: "img_with_text_center",
                                          children: [
                                            (0, Qe.jsx)(mr, {
                                              color: "#666",
                                              type: ne.KEY,
                                            }),
                                            " ",
                                            (0, Qe.jsx)("span", {
                                              children: "Account Settings",
                                            }),
                                          ],
                                        }),
                                      }),
                                    }),
                                    Ke &&
                                      "Admin" === Ke &&
                                      (0, Qe.jsxs)(Qe.Fragment, {
                                        children: [
                                          (0, Qe.jsx)("li", {
                                            children: (0, Qe.jsx)("a", {
                                              href: ""
                                                .concat(
                                                  ve(F, !1, "https", a, L),
                                                  "/"
                                                )
                                                .concat(Je ? P : I),
                                              className:
                                                "profile__menu__item ".concat(
                                                  Y
                                                    ? "ltch_high_contrast_item"
                                                    : ""
                                                ),
                                              id: "ltch-org-settings",
                                              "data-amplitude":
                                                "header: click organization settings - user settings",
                                              "data-amplitude-property-name":
                                                "page url",
                                              children: (0, Qe.jsxs)("span", {
                                                className:
                                                  "img_with_text_center",
                                                children: [
                                                  (0, Qe.jsx)(mr, {
                                                    color: "#666",
                                                    type: ne.ORG_SETTINGS,
                                                  }),
                                                  " ",
                                                  (0, Qe.jsx)("span", {
                                                    children:
                                                      "Organization Settings",
                                                  }),
                                                ],
                                              }),
                                            }),
                                          }),
                                          !qe &&
                                            !L &&
                                            (0, Qe.jsxs)(Qe.Fragment, {
                                              children: [
                                                (0, Qe.jsx)("li", {
                                                  children: (0, Qe.jsx)("a", {
                                                    href: ""
                                                      .concat(ve(Z), "/")
                                                      .concat(
                                                        "billing/subscriptions"
                                                      ),
                                                    className:
                                                      "profile__menu__item ".concat(
                                                        Y
                                                          ? "ltch_high_contrast_item"
                                                          : ""
                                                      ),
                                                    id: "ltch-billing",
                                                    "data-amplitude":
                                                      "header: click billing subscriptions - user settings",
                                                    "data-amplitude-property-name":
                                                      "page url",
                                                    children: (0, Qe.jsxs)(
                                                      "span",
                                                      {
                                                        className:
                                                          "img_with_text_center",
                                                        children: [
                                                          (0, Qe.jsx)(mr, {
                                                            color: "#666",
                                                            type: ne.BILLING,
                                                          }),
                                                          " ",
                                                          (0, Qe.jsx)("span", {
                                                            children:
                                                              "Billing & Subscriptions",
                                                          }),
                                                        ],
                                                      }
                                                    ),
                                                  }),
                                                }),
                                                (0, Qe.jsx)("li", {
                                                  children: (0, Qe.jsx)("a", {
                                                    href: ""
                                                      .concat(ve(Z), "/")
                                                      .concat(D),
                                                    className:
                                                      "profile__menu__item ".concat(
                                                        Y
                                                          ? "ltch_high_contrast_item"
                                                          : ""
                                                      ),
                                                    id: "ltch-upgrade",
                                                    "data-amplitude":
                                                      "header: click upgrade - user settings",
                                                    "data-amplitude-property-name":
                                                      "page url",
                                                    children: (0, Qe.jsxs)(
                                                      "span",
                                                      {
                                                        className:
                                                          "img_with_text_center",
                                                        children: [
                                                          (0, Qe.jsx)(mr, {
                                                            color: "#666",
                                                            strokeWidth: "1",
                                                            type: ne.UPGRADE,
                                                          }),
                                                          " ",
                                                          (0, Qe.jsx)("span", {
                                                            children: "Upgrade",
                                                          }),
                                                        ],
                                                      }
                                                    ),
                                                  }),
                                                }),
                                              ],
                                            }),
                                        ],
                                      }),
                                    !L &&
                                      ze(B) &&
                                      (0, Qe.jsx)("li", {
                                        children: (0, Qe.jsx)("a", {
                                          href: ""
                                            .concat(ve(Z, !1, "https", a), "/")
                                            .concat(h),
                                          className:
                                            "profile__menu__item ".concat(
                                              Y ? "ltch_high_contrast_item" : ""
                                            ),
                                          "data-amplitude":
                                            "header: click ".concat(
                                              ee
                                                ? "Refer & Earn"
                                                : "Referral Dashboard",
                                              " - user settings"
                                            ),
                                          "data-amplitude-property-name":
                                            "page url",
                                          children: (0, Qe.jsxs)("span", {
                                            className: "img_with_text_center",
                                            children: [
                                              (0, Qe.jsx)(mr, {
                                                type: ne.GIFT,
                                              }),
                                              " ",
                                              (0, Qe.jsx)("span", {
                                                children: ee
                                                  ? "Refer & Earn"
                                                  : "Referral Dashboard",
                                              }),
                                            ],
                                          }),
                                        }),
                                      }),
                                    !En &&
                                      (0, Qe.jsx)("li", {
                                        children: (0, Qe.jsx)("a", {
                                          href: ""
                                            .concat(
                                              ve(F, !1, "https", a, L),
                                              "/"
                                            )
                                            .concat(C),
                                          className:
                                            "profile__menu__item ".concat(
                                              Y
                                                ? "ltch_high_contrast_item"
                                                : "",
                                              " logout_option_item"
                                            ),
                                          id: "app__logout",
                                          "data-amplitude":
                                            "header: click logout - user settings",
                                          "data-amplitude-property-name":
                                            "page url",
                                          children: (0, Qe.jsxs)("span", {
                                            className: "img_with_text_center",
                                            children: [
                                              (0, Qe.jsx)(mr, {
                                                type: ne.SIGN_OUT,
                                              }),
                                              " ",
                                              (0, Qe.jsx)("span", {
                                                children: "Logout",
                                              }),
                                            ],
                                          }),
                                        }),
                                      }),
                                    En &&
                                      (0, Qe.jsx)("li", {
                                        children: (0, Qe.jsx)("a", {
                                          onClick: function () {
                                            var e = "".concat(
                                                ve(se, !1, "https", a, L),
                                                "/api/organization/revert-identity"
                                              ),
                                              n = ke();
                                            fetch(e, {
                                              method: "POST",
                                              credentials: "include",
                                              headers: {
                                                "Content-Type":
                                                  "application/json",
                                                Accept: "application/json",
                                                authorization: "Bearer ".concat(
                                                  n
                                                ),
                                              },
                                            }).then(function (e) {
                                              200 == e.status &&
                                                (window.location.href = ""
                                                  .concat(
                                                    ve(F, !1, "https", a, L),
                                                    "/"
                                                  )
                                                  .concat(_)),
                                                401 == e.status &&
                                                  (window.location.href =
                                                    "".concat(
                                                      ""
                                                        .concat(
                                                          ve(
                                                            F,
                                                            !1,
                                                            "https",
                                                            a,
                                                            L
                                                          ),
                                                          "/"
                                                        )
                                                        .concat(C)
                                                    ));
                                            });
                                          },
                                          className:
                                            "profile__menu__item ".concat(
                                              Y ? "ltch_high_contrast_item" : ""
                                            ),
                                          id: "app__logout_Session",
                                          children: (0, Qe.jsxs)("span", {
                                            className: "img_with_text_center",
                                            children: [
                                              (0, Qe.jsx)(mr, {
                                                type: ne.SIGN_OUT,
                                              }),
                                              " ",
                                              (0, Qe.jsx)("span", {
                                                children:
                                                  "Go Back to your session",
                                              }),
                                            ],
                                          }),
                                        }),
                                      }),
                                  ],
                                }),
                              ],
                            }),
                          ],
                        }),
                        !L &&
                          o &&
                          (0, Qe.jsx)(Yr, {
                            classToAdd: "ltch-top-upgrade-btn",
                            currentSubscriptionType: Ye,
                            defaultTabIndex: p,
                            eventNameToUse: "H_upgrade_free",
                            isResellerCustomer: qe,
                            organizationRole: Ke,
                            upgradeBtnTextToDisplay: V,
                            renderAsList: !0,
                          }),
                      ],
                    }),
                  }),
                ],
              }),
            ],
          }),
          (0, Qe.jsx)(Vr, { msg: "Tunnel has been stopped", showToast: z }),
          (0, Qe.jsx)(Er, Ua({ isOpen: re, onClose: Se, content: ae }, de)),
        ],
      });
    }
    function nl(e) {
      return (
        (function (e) {
          if (Array.isArray(e)) return tl(e);
        })(e) ||
        (function (e) {
          if (
            ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
            null != e["@@iterator"]
          )
            return Array.from(e);
        })(e) ||
        (function (e, n) {
          if (e) {
            if ("string" == typeof e) return tl(e, n);
            var t = Object.prototype.toString.call(e).slice(8, -1);
            return (
              "Object" === t && e.constructor && (t = e.constructor.name),
              "Map" === t || "Set" === t
                ? Array.from(e)
                : "Arguments" === t ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
                ? tl(e, n)
                : void 0
            );
          }
        })(e) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        })()
      );
    }
    function tl(e, n) {
      (null == n || n > e.length) && (n = e.length);
      for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
      return r;
    }
    function rl(e, n, t) {
      return (
        n in e
          ? Object.defineProperty(e, n, {
              value: t,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[n] = t),
        e
      );
    }
    var ol = function (e) {
      var n = e.enableNewSidebar,
        t = e.children;
      return n
        ? (0, Qe.jsxs)("div", {
            "aria-labelledby": "ltch-dialog-nav-title",
            className: "Left_Nav ".concat(
              n ? "ltch-left-nav-overlay collapsed" : ""
            ),
            id: "lt-ch-left-nav",
            children: [
              (0, Qe.jsx)("h1", {
                className: "ltch-dialog-nav-title sr-only",
                id: "ltch-dialog-nav-title",
                children: "Product Navigation",
              }),
              t,
            ],
          })
        : (0, Qe.jsx)("div", {
            id: "lt-ch-left-nav",
            className: "Left_Nav",
            children: t,
          });
    };
    function il(e, n) {
      (null == n || n > e.length) && (n = e.length);
      for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
      return r;
    }
    var al = "Help",
      ll = "Credential",
      sl = "Quick Action",
      cl = function (n) {
        var t,
          o,
          i = n.selectedMenu,
          a = void 0 === i ? "" : i,
          l = n.brandName,
          s = n.onPremPrefixToUse,
          c = void 0 === s ? "" : s,
          u = n.userInfo,
          d =
            ((t = (0, e.useState)({ apiToken: !1, username: !1 })),
            (o = 2),
            (function (e) {
              if (Array.isArray(e)) return e;
            })(t) ||
              (function (e, n) {
                var t =
                  null == e
                    ? null
                    : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                      e["@@iterator"];
                if (null != t) {
                  var r,
                    o,
                    i = [],
                    a = !0,
                    l = !1;
                  try {
                    for (
                      t = t.call(e);
                      !(a = (r = t.next()).done) &&
                      (i.push(r.value), !n || i.length !== n);
                      a = !0
                    );
                  } catch (e) {
                    (l = !0), (o = e);
                  } finally {
                    try {
                      a || null == t.return || t.return();
                    } finally {
                      if (l) throw o;
                    }
                  }
                  return i;
                }
              })(t, o) ||
              (function (e, n) {
                if (e) {
                  if ("string" == typeof e) return il(e, n);
                  var t = Object.prototype.toString.call(e).slice(8, -1);
                  return (
                    "Object" === t && e.constructor && (t = e.constructor.name),
                    "Map" === t || "Set" === t
                      ? Array.from(e)
                      : "Arguments" === t ||
                        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
                      ? il(e, n)
                      : void 0
                  );
                }
              })(t, o) ||
              (function () {
                throw new TypeError(
                  "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                );
              })()),
          p = d[0],
          f = d[1],
          m = (0, e.useRef)([]),
          _ = u.apiToken,
          g = void 0 === _ ? "" : _,
          v = (u.id, u.organization),
          C = void 0 === v ? {} : v,
          b = u.organization_role,
          x = void 0 === b ? "" : b,
          w = u.username,
          k = void 0 === w ? "" : w,
          L = (0, e.useContext)(r) || {},
          j = L.enableNewSidebar,
          E = void 0 !== j && j,
          S = L.isHighContrastThemeEnabled,
          M = void 0 !== S && S,
          T = L.isNewToReferral,
          N = void 0 !== T && T,
          O = C.new_lums_ui_enabled,
          A = void 0 !== O && O;
        if (!a) return null;
        var R = 0,
          H = function (e) {
            m.current[R++] = e;
          };
        (0, e.useEffect)(
          function () {
            var e, n;
            null === (e = m.current) ||
              void 0 === e ||
              null === (n = e[0]) ||
              void 0 === n ||
              n.focus();
          },
          [a]
        );
        var V,
          D = C && C.helpdesk_login_allowed,
          B =
            ((V = []),
            a === al &&
              (V.push(
                (0, Qe.jsxs)("a", {
                  href: "https://www.lambdatest.com/video/",
                  className: "aside__menu__bottom__submenu__item ".concat(
                    M ? "ltch_high_contrast_item" : ""
                  ),
                  "data-amplitude": "sidebar: Video - help",
                  "data-amplitude-property-name": "page url",
                  target: "_blank",
                  role: "menuitem",
                  tabIndex: 0,
                  ref: H,
                  children: [
                    (0, Qe.jsx)("div", {
                      "aria-hidden": !0,
                      children: (0, Qe.jsx)(mr, {
                        type: ne.MONITOR,
                        isHighContrastThemeEnabled: M,
                        className: "aside__menu__bottom__submenu__item__icon",
                      }),
                    }),
                    "Video",
                  ],
                })
              ),
              V.push(
                (0, Qe.jsxs)("a", {
                  href: "https://www.lambdatest.com/support/docs/",
                  className: "aside__menu__bottom__submenu__item ".concat(
                    M ? "ltch_high_contrast_item" : ""
                  ),
                  "data-amplitude": "sidebar: documentation - help",
                  "data-amplitude-property-name": "page url",
                  target: "_blank",
                  role: "menuitem",
                  tabIndex: "-1",
                  ref: H,
                  children: [
                    (0, Qe.jsx)("div", {
                      "aria-hidden": !0,
                      children: (0, Qe.jsx)(mr, {
                        className: "aside__menu__bottom__submenu__item__icon",
                        isHighContrastThemeEnabled: M,
                        type: ne.DOCUMENTATION,
                      }),
                    }),
                    "Documentation",
                  ],
                })
              ),
              V.push(
                (0, Qe.jsxs)("a", {
                  href: "https://www.lambdatest.com/support/faq/",
                  className:
                    "aside__menu__bottom__submenu__item aside__menu__bottom__submenu__item__faq ".concat(
                      M ? "ltch_high_contrast_item" : ""
                    ),
                  "data-amplitude": "sidebar: faq's - help",
                  "data-amplitude-property-name": "page url",
                  target: "_blank",
                  role: "menuitem",
                  tabIndex: "-1",
                  ref: H,
                  children: [
                    (0, Qe.jsx)("div", {
                      "aria-hidden": !0,
                      children: (0, Qe.jsx)(mr, {
                        className: "aside__menu__bottom__submenu__item__icon",
                        isHighContrastThemeEnabled: M,
                        type: ne.FAQ,
                      }),
                    }),
                    "FAQ's",
                  ],
                })
              ),
              D
                ? V.push(
                    (0, Qe.jsxs)("a", {
                      className: "aside__menu__bottom__submenu__item ".concat(
                        M ? "ltch_high_contrast_item" : ""
                      ),
                      "data-amplitude": "sidebar: support portal - help",
                      "data-amplitude-property-name": "page url",
                      href: "https://support.lambdatest.com",
                      role: "menuitem",
                      tabIndex: "-1",
                      ref: H,
                      children: [
                        (0, Qe.jsx)("div", {
                          "aria-hidden": !0,
                          children: (0, Qe.jsx)(mr, {
                            className:
                              "aside__menu__bottom__submenu__item__icon",
                            isHighContrastThemeEnabled: M,
                            type: ne.CHAT,
                          }),
                        }),
                        "Support Portal",
                      ],
                    })
                  )
                : V.push(
                    (0, Qe.jsxs)("a", {
                      className: "aside__menu__bottom__submenu__item ".concat(
                        M ? "ltch_high_contrast_item" : ""
                      ),
                      "data-amplitude": "sidebar: contact us - help",
                      "data-amplitude-property-name": "page url",
                      href: "https://www.lambdatest.com/contact-us",
                      target: "_blank",
                      role: "menuitem",
                      tabIndex: "-1",
                      ref: H,
                      children: [
                        (0, Qe.jsx)("div", {
                          "aria-hidden": !0,
                          children: (0, Qe.jsx)(mr, {
                            className:
                              "aside__menu__bottom__submenu__item__icon",
                            isHighContrastThemeEnabled: M,
                            type: ne.PHONE,
                          }),
                        }),
                        "Contact Us",
                      ],
                    })
                  ),
              V.push(
                (0, Qe.jsxs)("a", {
                  className: "aside__menu__bottom__submenu__item ".concat(
                    M ? "ltch_high_contrast_item" : ""
                  ),
                  "data-amplitude": "sidebar: uptime monitor - help",
                  "data-amplitude-property-name": "page url",
                  href: "https://status.lambdatest.io/",
                  target: "_blank",
                  role: "menuitem",
                  tabIndex: "-1",
                  ref: H,
                  children: [
                    (0, Qe.jsx)("div", {
                      "aria-hidden": !0,
                      children: (0, Qe.jsx)(mr, {
                        className: "aside__menu__bottom__submenu__item__icon",
                        isHighContrastThemeEnabled: M,
                        type: ne.UPTIME_MONITOR,
                      }),
                    }),
                    "Uptime",
                  ],
                })
              )),
            a === ll &&
              (V.push(
                (0, Qe.jsxs)("div", {
                  className:
                    "aside__menu__bottom__submenu__item ltch_space_between ltch_access_control ".concat(
                      M ? "ltch_high_contrast_item" : ""
                    ),
                  "data-amplitude": "sidebar: copy username - credentials",
                  "data-amplitude-property-name": "page url",
                  onClick: function (e) {
                    e.stopPropagation(),
                      Te(k, "username", f),
                      e.currentTarget.focus();
                  },
                  onKeyDown: function (e) {
                    "Enter" === e.key &&
                      (e.stopPropagation(),
                      Te(k, "username", f),
                      e.currentTarget.focus());
                  },
                  ref: H,
                  "aria-label": "Copy Username",
                  role: "menuitem",
                  tabIndex: 0,
                  children: [
                    (0, Qe.jsxs)("span", {
                      className: "ltch_flex ltch_items_center",
                      "aria-hidden": !0,
                      children: [
                        (0, Qe.jsx)(mr, {
                          className: "aside__menu__bottom__submenu__item__icon",
                          isHighContrastThemeEnabled: M,
                          type: ne.USER_CIRCLE,
                        }),
                        "Username",
                      ],
                    }),
                    p.username
                      ? (0, Qe.jsx)("div", {
                          "aria-hidden": !0,
                          children: (0, Qe.jsx)(mr, {
                            className:
                              "aside__menu__bottom__submenu__item__icon ltch-copy-tick",
                            color: E ? "#176F2C" : "#fff",
                            type: ne.SUCCESS,
                          }),
                        })
                      : (0, Qe.jsx)("div", {
                          "aria-hidden": !0,
                          children: (0, Qe.jsx)(mr, {
                            className:
                              "aside__menu__bottom__submenu__item__icon",
                            isHighContrastThemeEnabled: M,
                            type: ne.COPY,
                          }),
                        }),
                  ],
                })
              ),
              V.push(
                (0, Qe.jsxs)("div", {
                  className:
                    "aside__menu__bottom__submenu__item ltch_space_between ltch_access_control ".concat(
                      M ? "ltch_high_contrast_item" : ""
                    ),
                  "data-amplitude": "sidebar: copy access key - credentials",
                  "data-amplitude-property-name": "page url",
                  onClick: function (e) {
                    e.stopPropagation(),
                      Te(g, "apiToken", f),
                      e.currentTarget.focus();
                  },
                  onKeyDown: function (e) {
                    "Enter" === e.key &&
                      (e.stopPropagation(),
                      Te(g, "apiToken", f),
                      e.currentTarget.focus());
                  },
                  ref: H,
                  tabIndex: "-1",
                  "aria-label": "Copy Access Key",
                  role: "menuitem",
                  children: [
                    (0, Qe.jsxs)("span", {
                      className: "ltch_flex ltch_items_center",
                      "aria-hidden": !0,
                      children: [
                        (0, Qe.jsx)(mr, {
                          className: "aside__menu__bottom__submenu__item__icon",
                          isHighContrastThemeEnabled: M,
                          type: ne.ACCESS_KEY,
                        }),
                        "Access Key",
                      ],
                    }),
                    p.apiToken
                      ? (0, Qe.jsx)("div", {
                          "aria-hidden": !0,
                          children: (0, Qe.jsx)(mr, {
                            className:
                              "aside__menu__bottom__submenu__item__icon ltch-copy-tick",
                            color: E ? "#176F2C" : "#fff",
                            type: ne.SUCCESS,
                          }),
                        })
                      : (0, Qe.jsx)("div", {
                          "aria-hidden": !0,
                          children: (0, Qe.jsx)(mr, {
                            className:
                              "aside__menu__bottom__submenu__item__icon",
                            isHighContrastThemeEnabled: M,
                            type: ne.COPY,
                          }),
                        }),
                  ],
                })
              ),
              V.push(
                (0, Qe.jsxs)("a", {
                  href: ""
                    .concat(ve(F, !1, "https", l, c), "/")
                    .concat(A ? "security" : y),
                  className:
                    "aside__menu__bottom__submenu__item aside__menu__bottom__submenu__item-link aside__menu__bottom__submenu__item ltch-manage-credentials ".concat(
                      M ? "ltch_high_contrast_item" : ""
                    ),
                  "data-amplitude": "sidebar: manage credentials - credentials",
                  "data-amplitude-property-name": "page url",
                  ref: H,
                  tabIndex: -1,
                  role: "menuitem",
                  children: [
                    "Manage Credentials",
                    (0, Qe.jsx)("div", {
                      "aria-hidden": !0,
                      children: (0, Qe.jsx)(mr, {
                        className: "aside__menu__bottom__submenu__item__icon",
                        isHighContrastThemeEnabled: M,
                        type: ne.WINDOW,
                      }),
                    }),
                  ],
                })
              )),
            a === sl &&
              (c ||
                V.push(
                  (0, Qe.jsxs)("a", {
                    href: "".concat(ve(G)),
                    className: "aside__menu__bottom__submenu__item ".concat(
                      M ? "ltch_high_contrast_item" : ""
                    ),
                    "data-amplitude": "sidebar: integrations - quick actions",
                    "data-amplitude-property-name": "page url",
                    role: "menuitem",
                    ref: H,
                    tabIndex: 0,
                    children: [
                      (0, Qe.jsx)("div", {
                        "aria-hidden": !0,
                        children: (0, Qe.jsx)(mr, {
                          className: "aside__menu__bottom__submenu__item__icon",
                          isHighContrastThemeEnabled: M,
                          type: ne.INTEGRATIONS,
                        }),
                      }),
                      "Integrations",
                    ],
                  })
                ),
              "Admin" === x &&
                V.push(
                  (0, Qe.jsxs)("a", {
                    className: "aside__menu__bottom__submenu__item ".concat(
                      M ? "ltch_high_contrast_item" : ""
                    ),
                    "data-amplitude": "sidebar: add team - quick actions",
                    "data-amplitude-property-name": "page url",
                    href: ""
                      .concat(ve(F, !1, "https", l, c), "/")
                      .concat(A ? P : I),
                    ref: H,
                    tabIndex: "-1",
                    role: "menuitem",
                    children: [
                      (0, Qe.jsx)("div", {
                        "aria-hidden": !0,
                        children: (0, Qe.jsx)(mr, {
                          className: "aside__menu__bottom__submenu__item__icon",
                          isHighContrastThemeEnabled: M,
                          type: ne.ADD_TEAM,
                        }),
                      }),
                      "Invite Users",
                    ],
                  })
                ),
              !c &&
                ze(u) &&
                V.push(
                  (0, Qe.jsxs)("a", {
                    className: "aside__menu__bottom__submenu__item ".concat(
                      M ? "ltch_high_contrast_item" : ""
                    ),
                    "data-amplitude": "sidebar: ".concat(
                      N ? "Refer & Earn" : "Referral Dashboard",
                      " - quick actions"
                    ),
                    "data-amplitude-property-name": "page url",
                    href: "".concat(ve(Z), "/").concat(h),
                    ref: H,
                    tabIndex: "-1",
                    role: "menuitem",
                    children: [
                      (0, Qe.jsx)("div", {
                        "aria-hidden": !0,
                        children: (0, Qe.jsx)(mr, {
                          className: "aside__menu__bottom__submenu__item__icon",
                          isHighContrastThemeEnabled: M,
                          type: ne.GIFT,
                        }),
                      }),
                      N ? "Refer & Earn" : "Referral Dashboard",
                    ],
                  })
                )),
            V || []),
          W = null == a ? void 0 : a.toLowerCase().split(" ").join("-");
        return (0, Qe.jsxs)("div", {
          "aria-label": "".concat(a, " Options"),
          className: "aside__menu__bottom__submenu",
          id: "".concat(W, "-bottom-submenu"),
          children: [
            (0, Qe.jsx)("span", {
              className:
                "aside__menu__bottom__submenu__item aside__menu__bottom__submenu__item-title",
              role: "presentation",
              "aria-hidden": !0,
              children: a,
            }),
            (0, Qe.jsx)("ul", {
              className: "ltch-aside-menu-bottom-submenu-item-wrapper",
              role: "menu",
              children: B.map(function (e, n) {
                return (0, Qe.jsx)(
                  "li",
                  {
                    role: "none",
                    onKeyDown: function (e) {
                      return Be({
                        orientation: "vertical",
                        tabRef: m,
                        index: n,
                        lastIndex: B.length - 1,
                        event: e,
                      });
                    },
                    children: e,
                  },
                  n
                );
              }),
            }),
          ],
        });
      },
      ul = function (n) {
        var t = n.defaultTabIndex,
          o = n.brandName,
          i = n.onPremPrefixToUse,
          a = n.userInfo,
          l = (0, e.useRef)(null),
          s = (0, e.useContext)(r) || {},
          c = (s.enableNewSidebar, s.isHighContrastThemeEnabled),
          u = void 0 !== c && c,
          d = s.selectedMenu,
          p = s.setSelectedMenu;
        (0, e.useState)(function () {
          var e = function (e) {
            l && l.current && !l.current.contains(e.target) && p(null);
          };
          return (
            document.addEventListener("click", e),
            function () {
              return document.removeEventListener("click", e);
            }
          );
        }, []);
        var f = function (e) {
            p(e === d ? null : e);
          },
          h = function (e, n) {
            ("Escape" !== e.key && "Tab" !== e.key) ||
              (e.stopPropagation(),
              (function (e) {
                var n;
                p(null);
                var t =
                  null ===
                    (n = e.currentTarget.getElementsByClassName(
                      "aside__menu__item__bottom__link"
                    )) || void 0 === n
                    ? void 0
                    : n[0];
                null == t || t.focus();
              })(e)),
              ("Enter" !== e.key && "Space" !== e.code) ||
                (e &&
                e.target &&
                e.target.classList.contains(
                  "aside__menu__bottom__submenu__item"
                )
                  ? e.stopPropagation()
                  : f(n));
          };
        return (0, Qe.jsxs)("ul", {
          className: "aside__menu__items-useful",
          ref: l,
          children: [
            (0, Qe.jsxs)("li", {
              className: "aside__menu__item__bottom ".concat(
                u ? "ltch_high_contrast_item" : ""
              ),
              onKeyDown: function (e) {
                return h(e, al);
              },
              onClick: function (e) {
                return f(al);
              },
              children: [
                (0, Qe.jsx)("a", {
                  className:
                    "aside__menu__item__bottom__link aside__menu__item__bottom_help",
                  role: "button",
                  "aria-controls": d === al ? "help-bottom-submenu" : void 0,
                  "aria-haspopup": "true",
                  "aria-label": "help",
                  "aria-expanded": d === al,
                  tabIndex: t,
                  children: (0, Qe.jsx)("div", {
                    "aria-hidden": !0,
                    children: (0, Qe.jsx)(mr, {
                      className: "aside__menu__bottom__submenu__item__icon",
                      isHighContrastThemeEnabled: u,
                      type: ne.QUESTION,
                    }),
                  }),
                }),
                d === al &&
                  (0, Qe.jsx)(cl, {
                    selectedMenu: d,
                    brandName: o,
                    onPremPrefixToUse: i,
                    userInfo: a,
                  }),
              ],
            }),
            (0, Qe.jsxs)("li", {
              className:
                "aside__menu__item__bottom ltch-access-key-wrapper ".concat(
                  u ? "ltch_high_contrast_item" : ""
                ),
              onKeyDown: function (e) {
                return h(e, ll);
              },
              onClick: function (e) {
                return f(ll);
              },
              children: [
                (0, Qe.jsx)("a", {
                  className: "aside__menu__item__bottom__link",
                  role: "button",
                  "aria-controls":
                    d === ll ? "credential-bottom-submenu" : void 0,
                  "aria-label": "Access key",
                  "aria-haspopup": "true",
                  "aria-expanded": d === ll,
                  tabIndex: t,
                  children: (0, Qe.jsx)("div", {
                    "aria-hidden": !0,
                    children: (0, Qe.jsx)(mr, {
                      className: "aside__menu__bottom__submenu__item__icon",
                      isHighContrastThemeEnabled: u,
                      type: ne.KEY,
                      "aria-label": "Access key",
                      role: "img",
                    }),
                  }),
                }),
                d === ll &&
                  (0, Qe.jsx)(cl, {
                    onPremPrefixToUse: i,
                    selectedMenu: d,
                    brandName: o,
                    userInfo: a,
                  }),
              ],
            }),
            (0, Qe.jsxs)("li", {
              className:
                "aside__menu__item__bottom ltch-quick-actions-wrapper ".concat(
                  u ? "ltch_high_contrast_item" : ""
                ),
              onKeyDown: function (e) {
                return h(e, sl);
              },
              onClick: function (e) {
                return f(sl);
              },
              children: [
                (0, Qe.jsx)("a", {
                  className: "aside__menu__item__bottom__link",
                  role: "button",
                  "aria-haspopup": "true",
                  "aria-controls":
                    d === sl ? "quick-action-bottom-submenu" : void 0,
                  "aria-label": "Quick actions",
                  "aria-expanded": d === sl,
                  tabIndex: t,
                  children: (0, Qe.jsx)("div", {
                    "aria-hidden": !0,
                    children: (0, Qe.jsx)(mr, {
                      className: "aside__menu__bottom__submenu__item__icon",
                      isHighContrastThemeEnabled: u,
                      type: ne.QUICK_ACTIONS,
                      "aria-label": "Quick Actions",
                      role: "img",
                    }),
                  }),
                }),
                d === sl &&
                  (0, Qe.jsx)(cl, {
                    onPremPrefixToUse: i,
                    selectedMenu: d,
                    brandName: o,
                    userInfo: a,
                  }),
              ],
            }),
          ],
        });
      },
      dl = function (e) {
        var n = e.iconColor,
          t = void 0 === n ? "#333" : n;
        return (0, Qe.jsx)("svg", {
          "aria-hidden": !0,
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          role: "img",
          children: (0, Qe.jsx)("path", {
            d: "M6.35355 2.64645C6.15829 2.45118 5.84171 2.45118 5.64645 2.64645C5.45118 2.84171 5.45118 3.15829 5.64645 3.35355L6.35355 2.64645ZM11 8L11.3536 8.35355L11.7071 8L11.3536 7.64645L11 8ZM5.64645 12.6464L5.29289 13L6 13.7071L6.35355 13.3536L5.64645 12.6464ZM5.64645 3.35355L10.6464 8.35355L11.3536 7.64645L6.35355 2.64645L5.64645 3.35355ZM10.6464 7.64645L5.64645 12.6464L6.35355 13.3536L11.3536 8.35355L10.6464 7.64645Z",
            fill: t,
          }),
        });
      };
    function pl(e, n) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n &&
          (r = r.filter(function (n) {
            return Object.getOwnPropertyDescriptor(e, n).enumerable;
          })),
          t.push.apply(t, r);
      }
      return t;
    }
    function fl(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2
          ? pl(Object(t), !0).forEach(function (n) {
              hl(e, n, t[n]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : pl(Object(t)).forEach(function (n) {
              Object.defineProperty(
                e,
                n,
                Object.getOwnPropertyDescriptor(t, n)
              );
            });
      }
      return e;
    }
    function hl(e, n, t) {
      return (
        n in e
          ? Object.defineProperty(e, n, {
              value: t,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[n] = t),
        e
      );
    }
    function ml(e, n) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, n) {
          var t =
            null == e
              ? null
              : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                e["@@iterator"];
          if (null != t) {
            var r,
              o,
              i = [],
              a = !0,
              l = !1;
            try {
              for (
                t = t.call(e);
                !(a = (r = t.next()).done) &&
                (i.push(r.value), !n || i.length !== n);
                a = !0
              );
            } catch (e) {
              (l = !0), (o = e);
            } finally {
              try {
                a || null == t.return || t.return();
              } finally {
                if (l) throw o;
              }
            }
            return i;
          }
        })(e, n) ||
        (function (e, n) {
          if (e) {
            if ("string" == typeof e) return _l(e, n);
            var t = Object.prototype.toString.call(e).slice(8, -1);
            return (
              "Object" === t && e.constructor && (t = e.constructor.name),
              "Map" === t || "Set" === t
                ? Array.from(e)
                : "Arguments" === t ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
                ? _l(e, n)
                : void 0
            );
          }
        })(e, n) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        })()
      );
    }
    function _l(e, n) {
      (null == n || n > e.length) && (n = e.length);
      for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
      return r;
    }
    var gl = "updateActiveProduct",
      vl = new Event("productNavExpanded", { bubbles: !0 });
    function Cl(n) {
      var t,
        o,
        i,
        C,
        U,
        te = n.areFeatureFlagsFetched,
        re = void 0 !== te && te,
        oe = n.brandName,
        ie = void 0 === oe ? "" : oe,
        ae = n.detailedProductNav,
        le = void 0 === ae ? void 0 : ae,
        se = n.defaultTabIndex,
        ce = void 0 === se ? 0 : se,
        ue = (n.isNewThemeEnabled, n.isSideBarCollapsed),
        de = void 0 !== ue && ue,
        pe = n.onPremPrefixToUse,
        fe = void 0 === pe ? "" : pe,
        he = n.showAccessibilityOption,
        me = void 0 !== he && he,
        _e = n.showKaneAI,
        ge = void 0 !== _e && _e,
        Ce = n.showNonCompliantWCAGMenuOption,
        be = void 0 !== Ce && Ce,
        xe = n.showTooltip,
        we = void 0 !== xe && xe,
        ke = n.showTestManager,
        Le = void 0 !== ke && ke,
        je = n.upgradeBtnTextToDisplay,
        Ee = void 0 === je ? "" : je,
        Se = n.userInfo,
        Me = (0, e.useContext)(r) || {},
        Te = Me.enableNewSidebar,
        Ne = void 0 !== Te && Te,
        Oe = Me.isHighContrastThemeEnabled,
        Ae = void 0 !== Oe && Oe,
        Ie = Me.isNewDashboardShown,
        He = void 0 !== Ie && Ie,
        Ve = (function (e) {
          var n,
            t = e.brandName,
            r = e.onPremPrefixToUse;
          return (
            rl((n = {}), "".concat(ve(F, !1, "https", t, r), "/").concat(_), {
              isExpandable: !1,
              key: "accounts",
            }),
            rl(n, "".concat(ve(ee), "/").concat(R), {
              isExpandable: !0,
              key: "testManager",
            }),
            rl(n, "".concat(ve(Q), "/").concat(E), {
              isExpandable: !0,
              key: "realtime",
            }),
            rl(n, "".concat(ve(Q), "/").concat(j), {
              isExpandable: !0,
              key: "realtime",
            }),
            rl(n, "".concat(ve(Q), "/").concat(S), {
              isExpandable: !0,
              key: "realtime",
            }),
            rl(n, "".concat(ve(Q), "/").concat(M), {
              isExpandable: !0,
              key: "realtime",
            }),
            rl(n, "".concat(ve(Q), "/").concat(T), {
              isExpandable: !0,
              key: "realtime",
            }),
            rl(n, "".concat(ve(Q), "/").concat(O), {
              isExpandable: !0,
              key: "more_tools",
            }),
            rl(n, "".concat(ve(Q), "/").concat(N), {
              isExpandable: !0,
              key: "more_tools",
            }),
            rl(n, "".concat(ve(Q), "/").concat(V), {
              isExpandable: !0,
              key: "more_tools",
            }),
            rl(n, "".concat(ve(Q), "/").concat(b), {
              isExpandable: !0,
              key: "more_tools",
            }),
            rl(n, "".concat(ve(Q), "/").concat(w), {
              isExpandable: !0,
              key: "more_tools",
            }),
            rl(n, "".concat(ve(Q), "/").concat(H), {
              isExpandable: !0,
              key: "more_tools",
            }),
            rl(n, "".concat(ve(X), "/").concat(k), {
              isExpandable: !0,
              key: "realdevice",
            }),
            rl(n, "".concat(ve(X), "/").concat(L), {
              isExpandable: !0,
              key: "realdevice",
            }),
            rl(n, "".concat(ve(X)), { isExpandable: !0, key: "realdevice" }),
            rl(n, "".concat(ve(z, !1, "https", t, r), "/").concat(m), {
              isExpandable: !0,
              key: "automation",
            }),
            rl(n, "".concat(ve(z, !1, "https", t, r), "/").concat(p), {
              isExpandable: !0,
              key: "automation",
            }),
            rl(n, "".concat(ve(z, !1, "https", t, r)), {
              isExpandable: !0,
              key: "automation",
            }),
            rl(n, "".concat(ve(q), "/").concat(m), {
              isExpandable: !0,
              key: "automation",
            }),
            rl(n, "".concat(ve(q)), { isExpandable: !0, key: "automation" }),
            rl(n, "".concat(ve(J)), { isExpandable: !0, key: "smartui" }),
            rl(n, "".concat(ve(K, !1, "https", t, r), "/").concat(g), {
              isExpandable: !0,
              key: "hyperexecute",
            }),
            rl(n, "".concat(ve(K, !1, "https", t, r), "/").concat(v), {
              isExpandable: !0,
              key: "hyperexecute",
            }),
            rl(
              n,
              ""
                .concat(ve(K, !1, "https", t, r), "/")
                .concat("hyperexecute/projects/detail"),
              { isExpandable: !0, key: "hyperexecute" }
            ),
            rl(n, "".concat(ve(K, !1, "https", t, r)), {
              isExpandable: !0,
              key: "hyperexecute",
            }),
            rl(
              n,
              ye() && !window.location.hostname.includes("eu-")
                ? "".concat(ve("beta-analytics"), "/").concat(u)
                : "".concat(ve(W), "/").concat(u),
              { isExpandable: !0, key: "insights" }
            ),
            rl(
              n,
              ye() && !window.location.hostname.includes("eu-")
                ? "".concat(ve("beta-analytics"), "/").concat(d)
                : "".concat(ve(W), "/").concat(d),
              { isExpandable: !0, key: "insights" }
            ),
            rl(
              n,
              ye() && !window.location.hostname.includes("eu-")
                ? "".concat(ve("beta-analytics"))
                : "".concat(ve(W)),
              { isExpandable: !0, key: "insights" }
            ),
            rl(n, "".concat(ve(Y)), { isExpandable: !0, key: "more_tools" }),
            rl(n, "".concat(ve(G)), { isExpandable: !0, key: "settings" }),
            rl(n, "".concat(ve(F, !1, "https", t, r), "/").concat(x), {
              isExpandable: !0,
              key: "settings",
            }),
            rl(n, "".concat(ve(F, !1, "https", t, r), "/").concat(P), {
              isExpandable: !0,
              key: "settings",
            }),
            rl(n, "".concat(ve(F, !1, "https", t, r), "/").concat(c), {
              isExpandable: !0,
              key: "settings",
            }),
            rl(n, "".concat(ve(F, !1, "https", t, r), "/").concat(s), {
              isExpandable: !0,
              key: "settings",
            }),
            rl(n, "".concat(ve(F, !1, "https", t, r), "/").concat(l), {
              isExpandable: !0,
              key: "settings",
            }),
            rl(n, "".concat(ve(F, !1, "https", t, r), "/").concat(f), {
              isExpandable: !0,
              key: "settings",
            }),
            rl(n, "".concat(ve(Z), "/").concat(A), {
              isExpandable: !0,
              key: "settings",
            }),
            rl(n, "".concat(ve(Z), "/").concat(D), {
              isExpandable: !0,
              key: "settings",
            }),
            rl(n, "".concat(ve(Z), "/").concat(h), {
              isExpandable: !0,
              key: "settings",
            }),
            rl(n, "".concat(ve(Z)), { isExpandable: !0, key: "settings" }),
            rl(n, "".concat(ve(F, !1, "https", t, r)), {
              isExpandable: !0,
              key: "settings",
            }),
            rl(n, "".concat(ve(B), "/").concat(a), {
              isExpandable: !0,
              key: "accessibility",
            }),
            rl(n, "".concat(ve(B)), { isExpandable: !0, key: "accessibility" }),
            rl(n, "".concat(ve($)), { isExpandable: !1, key: "kaneai" }),
            n
          );
        })({ brandName: ie, onPremPrefixToUse: fe }),
        De = (Se.apiToken, Se.id, Se.organization),
        Be = void 0 === De ? {} : De,
        We = Se.organization_role,
        ze = void 0 === We ? "" : We,
        Ze = (Se.username, Be.current_subscription_type),
        Fe = void 0 === Ze ? "" : Ze,
        Ue = Be.is_reseller_customer,
        Ke = void 0 !== Ue && Ue,
        Ge = Be.new_lums_ui_enabled,
        Ye = void 0 !== Ge && Ge,
        $e = (function (e) {
          var n = e.isNewDashboardShown,
            t = e.brandName,
            r = e.onPremPrefixToUse,
            o = e.showAccessibilityOption,
            i = e.showKaneAI,
            a = e.showTestManager,
            l = e.new_lums_ui_enabled;
          return [
            {
              name: n ? "Home" : "Dashboard",
              product_key: "accounts",
              iconType: n ? ne.DASHBOARD : ne.OLD_DASHBOARD,
              has_dropdown: !1,
              url: "".concat(ve(F, !1, "https", t, r), "/").concat(_),
            },
          ].concat(
            nl(
              i
                ? [
                    {
                      name: "KaneAI",
                      product_key: "kaneai",
                      iconType: ne.KANE_AI,
                      has_dropdown: !1,
                      url: "".concat(ve($)),
                      shouldHideMenuOption: !!r,
                    },
                  ]
                : []
            ),
            [
              {
                name: "Real Time",
                product_key: "realtime",
                iconType: n ? ne.REAL_TIME : ne.OLD_REAL_TIME,
                has_dropdown: !0,
                url: "".concat(ve(Q), "/").concat(E),
                shouldHideMenuOption: !!r,
              },
              {
                name: "Real Device",
                product_key: "realdevice",
                iconType: n ? ne.REAL_DEVICE : ne.OLD_REAL_DEVICE,
                has_dropdown: !0,
                url: "".concat(ve(X), "/").concat(k),
                shouldHideMenuOption: !!r,
              },
              {
                name: "Automation",
                product_key: "automation",
                iconType: n ? ne.AUTOMATION : ne.OLD_AUTOMATION,
                has_dropdown: !0,
                url: "".concat(ve(z, !1, "https", t, r), "/").concat(m),
              },
              {
                name: "Smart UI",
                product_key: "smartui",
                iconType: n ? ne.SMART_UI : ne.OLD_SMART_UI,
                has_dropdown: !1,
                url: "".concat(ve(J)),
                shouldHideMenuOption: !!r,
              },
              {
                name: "HyperExecute",
                product_key: "hyperexecute",
                iconType: n ? ne.HYPEREXECUTE : ne.OLD_HYPEREXECUTE,
                has_dropdown: !1,
                url: "".concat(ve(K, !1, "https", t, r), "/").concat(g),
              },
              {
                name: "Insights",
                product_key: "insights",
                iconType: n ? ne.INSIGHTS : ne.OLD_INSIGHTS,
                has_dropdown: !1,
                url:
                  !ye() || window.location.hostname.includes("eu-") || Pe()
                    ? "".concat(ve(W))
                    : "".concat(ve("beta-analytics")),
                shouldHideMenuOption: !!r,
              },
            ],
            nl(
              a
                ? [
                    {
                      name: "Test Manager",
                      product_key: "testManager",
                      iconType: ne.TEST_MANAGER,
                      has_dropdown: !1,
                      url: "".concat(ve(ee, !1, "https"), "/").concat(R),
                      shouldHideMenuOption: !!r,
                    },
                  ]
                : []
            ),
            nl(
              o
                ? [
                    {
                      name: "Accessibility",
                      product_key: "accessibility",
                      iconType: ne.ACCESSIBILITY,
                      has_dropdown: !0,
                      url: "".concat(ve(B)),
                      shouldHideMenuOption: !!r,
                    },
                  ]
                : []
            ),
            [
              {
                name: "More Tools",
                product_key: "more_tools",
                iconType: ne.MORE_TOOLS,
                has_dropdown: !0,
                url: "".concat(ve(Q), "/").concat(O),
                shouldHideMenuOption: !!r,
              },
              {
                name: "Settings",
                product_key: "settings",
                iconType: n ? ne.FADERS_SETTING : ne.OLD_FADERS_SETTING,
                has_dropdown: !0,
                url: "".concat(ve(F, !1, "https", t, r), "/").concat(l ? x : y),
              },
            ]
          );
        })({
          isNewDashboardShown: He,
          brandName: ie,
          onPremPrefixToUse: fe,
          showKaneAI: ge,
          showTestManager: Le,
          showAccessibilityOption: me,
          new_lums_ui_enabled: Ye,
        }),
        qe = ml((0, e.useState)({ name: "", primaryProductKey: "" }), 2),
        Xe = qe[0],
        Je = qe[1],
        en = ml((0, e.useState)({ name: "", primaryProductKey: "" }), 2),
        nn = en[0],
        tn = en[1],
        rn = ml((0, e.useState)(!1), 2),
        on = rn[0],
        an = rn[1],
        ln = (0, e.useRef)(Xe);
      (0, e.useEffect)(
        function () {
          ln.current = Xe;
        },
        [Xe]
      );
      var sn = (function (e) {
          var n = e.brandName,
            t = e.onPremPrefixToUse,
            r = e.showNonCompliantWCAGMenuOption,
            o = e.organization_role,
            i = e.userInfo,
            _ = e.new_lums_ui_enabled,
            C = e.is_reseller_customer;
          return {
            testManager: {
              name: "Test Manager",
              id: "testManager",
              title: "Test Manager",
              items: [
                {
                  name: "Projects",
                  iconType: ne.TMS_PROJECTS,
                  idToAdd: "testManager__menu",
                  has_dropdown: !1,
                  key: "test-manager",
                  amplitude_event: "sidebar: Test Manager - projects",
                  url: "".concat(ve(ee), "/").concat(R),
                  hideByDefault: !1,
                },
              ],
            },
            realtime: {
              name: "Real Time",
              id: "realtime",
              title: "Real Time Testing",
              items: [
                {
                  additionalHeader: "Web Browser Testing",
                  name: "Desktop",
                  iconType: ne.GLOBE,
                  idToAdd: "realtime__browser__menu",
                  has_dropdown: !1,
                  key: "browser-testing",
                  amplitude_event: "sidebar: browser testing - real time",
                  url: "".concat(ve(Q), "/").concat(E),
                },
                {
                  name: "Virtual Mobile",
                  iconType: ne.REAL_TIME_VIRTUAL_MOBILE,
                  idToAdd: "realtime__app__menu",
                  key: "app-testing",
                  has_dropdown: !1,
                  amplitude_event: "sidebar: virtual testing - real time",
                  url: "".concat(ve(Q), "/").concat(S),
                },
                {
                  additionalHeader: "App Testing",
                  name: "Virtual Mobile",
                  iconType: ne.REAL_TIME_APP,
                  idToAdd: "realtime__virtual__app__menu",
                  key: "virtual-app-testing",
                  has_dropdown: !1,
                  amplitude_event: "sidebar: app testing - real time",
                  url: "".concat(ve(Q), "/").concat(j),
                },
              ],
            },
            realdevice: {
              name: "Real Device",
              id: "realdevice",
              title: "Real Device",
              items: [
                {
                  name: "App Testing",
                  key: "rd-app-testing",
                  iconType: ne.REAL_DEVICE,
                  idToAdd: "realdevice__app__menu",
                  has_dropdown: !1,
                  amplitude_event: "sidebar: app testing - real device",
                  url: "".concat(ve(X), "/").concat(k),
                },
                {
                  name: "Browser Testing",
                  key: "rd-browser-testing",
                  iconType: ne.GLOBE,
                  idToAdd: "realdevice__browser__menu",
                  has_dropdown: !1,
                  amplitude_event: "sidebar: browser testing - real device",
                  url: "".concat(ve(X), "/").concat(L),
                },
              ],
            },
            automation: {
              name: "Automation",
              id: "automation",
              title: "Automation",
              items: [
                {
                  key: "web-automation",
                  name: "Web Automation",
                  iconType: ne.WEB_AUTOMATION,
                  has_dropdown: !1,
                  amplitude_event: "sidebar: web automation - automation",
                  url: "".concat(ve(z, !1, "https", n, t), "/").concat(m),
                },
                {
                  name: "App Automation",
                  key: "app-automation",
                  iconType: ne.APP_AUTOMATION,
                  has_dropdown: !1,
                  amplitude_event: "sidebar: app automation - automation",
                  url: "".concat(ve(q), "/").concat(m),
                  secondaryUrls: ["".concat(ve(q))],
                  hideByDefault: !!t,
                },
                {
                  name: "Archives",
                  key: "web-automation-archives",
                  iconType: ne.ARCHIVES,
                  has_dropdown: !1,
                  amplitude_event: "sidebar: archives - automation",
                  url: "".concat(ve(z, !1, "https", n, t), "/").concat(p),
                  hideByDefault: !r,
                },
                ,
              ],
            },
            hyperexecute: {
              name: "HyperExecute",
              id: "hyperexecute",
              title: "HyperExecute",
              items: [
                {
                  name: "Jobs",
                  key: "jobs",
                  iconType: ne.HE_JOBS,
                  has_dropdown: !1,
                  amplitude_event: "sidebar: jobs - hyperexecute",
                  url: "".concat(ve(K, !1, "https", n, t), "/").concat(g),
                },
                {
                  name: "Projects",
                  key: "he-projects",
                  iconType: ne.HE_PROJECTS,
                  has_dropdown: !1,
                  hideByDefault: !0,
                  amplitude_event: "sidebar: projects - hyperexecute",
                  url: "".concat(ve(K, !1, "https", n, t), "/").concat(v),
                },
                {
                  name: "Insights",
                  key: "he-insights",
                  iconType: ne.HE_INSIGHTS,
                  has_dropdown: !1,
                  hideByDefault: !0,
                  isBeta: !0,
                  amplitude_event: "sidebar: insights - hyperexecute",
                  url: ""
                    .concat(ve(K, !1, "https", n, t), "/")
                    .concat("hyperexecute/insights/overview"),
                },
                {
                  name: "Workflows",
                  key: "he-workflows",
                  iconType: ne.HE_WORKFLOWS,
                  has_dropdown: !1,
                  isBeta: !0,
                  hideByDefault: !0,
                  amplitude_event: "sidebar: workflows - hyperexecute",
                  url: ""
                    .concat(ve(K, !1, "https", n, t), "/")
                    .concat("hyperexecute/workflows"),
                },
              ],
            },
            insights: {
              name: "Insights",
              id: "insights",
              title: "Insights",
              items: [
                {
                  name: "Dashboards",
                  key: "dashboards",
                  iconType: ne.ANALYTICS,
                  has_dropdown: !1,
                  url:
                    ye() && !window.location.hostname.includes("eu-")
                      ? "".concat(ve("beta-analytics"))
                      : "".concat(ve(W)),
                },
                {
                  name: "Private Real Devices",
                  key: "private-real-device",
                  iconType: ne.ANALYTICS_PRIVATE_REAL_DEVICE,
                  has_dropdown: !1,
                  url:
                    ye() && !window.location.hostname.includes("eu-")
                      ? "".concat(ve("beta-analytics"), "/").concat(u)
                      : "".concat(ve(W), "/").concat(u),
                },
                {
                  name: "Usage Reports",
                  key: "usage-report",
                  iconType: ne.ANALYTICS_USAGE_REPORT,
                  has_dropdown: !1,
                  url:
                    ye() && !window.location.hostname.includes("eu-")
                      ? "".concat(ve("beta-analytics"), "/").concat(d)
                      : "".concat(ve(W), "/").concat(d),
                },
              ],
            },
            smartui: {
              name: "Smart UI",
              id: "smartui",
              title: "Smart UI",
              items: [
                {
                  name: "".concat("Admin" === o ? "All" : "", " Projects"),
                  key: "projects",
                  iconType: ne.SMART_UI_PROJECTS,
                  has_dropdown: !1,
                  url: "".concat(ve(J), "/").concat("projects"),
                  hideByDefault: 0 === Object.keys(i).length,
                },
                {
                  name: "Approver Projects",
                  key: "approver-projects",
                  iconType: ne.SMART_UI_APPROVER_PROJECTS,
                  has_dropdown: !1,
                  url: "".concat(ve(J), "/").concat("approverProjects"),
                  hideByDefault: 0 === Object.keys(i).length || "Admin" === o,
                },
              ],
            },
            more_tools: {
              name: "More Tools",
              id: "more_tools",
              title: "More Tools",
              items: [
                {
                  name: "Screenshot",
                  key: "screenshot",
                  iconType: ne.SCREENSHOT,
                  has_dropdown: !1,
                  amplitude_event: "sidebar: screenshot - more tools",
                  url: "".concat(ve(Q), "/").concat(O),
                },
                {
                  name: "Responsive",
                  key: "responsive",
                  iconType: ne.RESPONSIVE,
                  has_dropdown: !1,
                  amplitude_event: "sidebar: responsive - more tools",
                  url: "".concat(ve(Q), "/").concat(N),
                },
                {
                  name: "UI Comparison",
                  key: "ui-comparison",
                  iconType: ne.OLD_SMART_UI,
                  has_dropdown: !1,
                  amplitude_event: "sidebar: ui comparison - more tools",
                  url: "".concat(ve(Q), "/").concat(V),
                },
                {
                  name: "LT Browser",
                  key: "lt-browser",
                  iconType: ne.GLOBE,
                  has_dropdown: !1,
                  amplitude_event: "sidebar: lt browser - more tools",
                  url: "".concat(ve(Q), "/").concat(b),
                },
              ].concat(
                nl(
                  r
                    ? [
                        {
                          name: "Issue Tracker",
                          key: "issue-tracker",
                          iconType: ne.BUG,
                          has_dropdown: !1,
                          amplitude_event:
                            "sidebar: issue tracker - more tools",
                          url: "".concat(ve(Y)),
                        },
                      ]
                    : []
                ),
                [
                  {
                    name: "Test Logs",
                    key: "test-logs",
                    iconType: ne.DOCUMENTATION,
                    has_dropdown: !1,
                    amplitude_event: "sidebar: test logs - more tools",
                    url: "".concat(ve(Q), "/").concat(H),
                  },
                  {
                    name: "Projects",
                    key: "projects",
                    iconType: ne.FOLDER,
                    has_dropdown: !1,
                    amplitude_event: "sidebar: projects - more tools",
                    url: "".concat(ve(Q), "/").concat(w),
                  },
                ]
              ),
            },
            settings: {
              name: "Settings",
              id: "settings",
              title: "Settings",
              items: [
                {
                  name: "Account Settings",
                  key: "account-settings",
                  iconType: ne.KEY,
                  has_dropdown: !1,
                  amplitude_event: "sidebar: account settings - settings",
                  url: ""
                    .concat(ve(F, !1, "https", n, t), "/")
                    .concat(_ ? x : y),
                },
              ].concat(
                nl(
                  "Admin" !== o
                    ? []
                    : [
                        {
                          name: "Organization Settings",
                          key: "org-settings",
                          iconType: ne.ORG_SETTINGS,
                          has_dropdown: !1,
                          amplitude_event:
                            "sidebar: organization settings - settings",
                          url: ""
                            .concat(ve(F, !1, "https", n, t), "/")
                            .concat(_ ? P : I),
                          secondaryUrls: [
                            "".concat(ve(F, !1, "https", n, t), "/").concat(c),
                            "".concat(ve(F, !1, "https", n, t), "/").concat(s),
                            "".concat(ve(F, !1, "https", n, t), "/").concat(l),
                            "".concat(ve(F, !1, "https", n, t), "/").concat(P),
                            "".concat(ve(F, !1, "https", n, t), "/").concat(I),
                            "".concat(ve(F, !1, "https", n, t), "/").concat(f),
                          ],
                        },
                      ]
                ),
                nl(
                  Pe() || t || "Admin" !== o || C
                    ? []
                    : [
                        {
                          name: "Billing",
                          key: "billing",
                          iconType: ne.BILLING,
                          has_dropdown: !1,
                          amplitude_event: "sidebar: billing - settings",
                          url: "".concat(ve(Z), "/").concat(A),
                          secondaryUrls: [
                            "".concat(ve(Z), "/").concat(D),
                            "".concat(ve(Z), "/").concat(h),
                          ],
                        },
                      ]
                ),
                [
                  {
                    name: "Integrations",
                    key: "integrations",
                    iconType: ne.INTEGRATIONS,
                    has_dropdown: !1,
                    amplitude_event: "sidebar: integrations - settings",
                    url: "".concat(ve(G)),
                    hideByDefault: !!t,
                  },
                ]
              ),
            },
            accessibility: {
              name: "Accessibility",
              id: "accessibility",
              title: "Accessibility",
              items: [
                {
                  name: "Manual Reports",
                  iconType: ne.ACCESSIBILITY_MANUAL,
                  has_dropdown: !1,
                  key: "accessibility-manual",
                  amplitude_event: "sidebar: accessibility - manual reports",
                  url: "".concat(ve(B)),
                },
                {
                  name: "Automation Reports",
                  iconType: ne.ACCESSIBILITY_AUTOMATED,
                  key: "accessibility-automated",
                  has_dropdown: !1,
                  amplitude_event:
                    "sidebar: accessibility - automation reports",
                  url: "".concat(ve(B), "/").concat(a),
                },
              ],
            },
            accounts: {
              name: "Accounts",
              id: "accounts",
              title: "Accounts",
              items: [],
            },
            kaneai: {
              name: "KaneAI",
              id: "kaneai",
              title: "KaneAI",
              items: [],
            },
          };
        })({
          brandName: ie,
          onPremPrefixToUse: fe,
          showNonCompliantWCAGMenuOption: be,
          organization_role: ze,
          userInfo: Se,
          new_lums_ui_enabled: Ye,
          is_reseller_customer: Ke,
        }),
        cn = ml((0, e.useState)(!1), 2),
        un = cn[0],
        dn = cn[1],
        pn = function (e) {
          var n =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : null,
            t = arguments.length > 2 ? arguments[2] : void 0,
            r =
              arguments.length > 3 && void 0 !== arguments[3]
                ? arguments[3]
                : "",
            o =
              arguments.length > 4 && void 0 !== arguments[4]
                ? arguments[4]
                : "",
            i = arguments.length > 5 && void 0 !== arguments[5] && arguments[5];
          if (n) {
            if (window.amplitude) {
              var a = {
                "switch from page": window.location.href,
                "switch to page": n,
              };
              r && (a["switch from category"] = r),
                o && (a["target category"] = o),
                Re("sidebar: switch category", a);
            }
            return (
              t && t.metaKey
                ? (t.preventDefault(), window.open(n, "_blank"))
                : (window.location.href = n),
              void hn(e)
            );
          }
          !un && i && (Je(fl({}, e)), an(!0), window.dispatchEvent(vl)),
            i || (an(!1), tn(fl({}, e)));
          var l = e.isExpandable,
            s = void 0 !== l && l;
          (s ||
            (null != nn &&
              nn.primaryProductKey &&
              (null == nn ? void 0 : nn.primaryProductKey) !==
                (null == Xe ? void 0 : Xe.primaryProductKey))) &&
            dn(!un);
        },
        fn = function (e) {
          return e.replace(/\/$/, "");
        },
        hn = function (e) {
          localStorage.setItem("ltchactivemenu", JSON.stringify(e));
        },
        mn = function (e) {
          var n = Ve[e],
            t = n.isExpandable,
            r = void 0 !== t && t,
            o = n.key,
            i = void 0 === o ? "" : o;
          if (r) {
            var a = sn[i].items || [],
              l = 0;
            a.forEach(function (n, t) {
              e.includes(fn(n.url)) && (l = t),
                (n.secondaryUrls || []).includes(e) && (l = t);
            });
            var s = a[l];
            Je({
              isExpandable: !0,
              name: s.name,
              primaryProductKey: i,
              secondaryNavProductKey: s.key,
            }),
              an(!0),
              dn(!0);
          } else {
            var c;
            Je({
              isExpandable: !1,
              name: null === (c = sn[i]) || void 0 === c ? void 0 : c.name,
              primaryProductKey: i,
            });
          }
        },
        _n = function (e) {
          var n = ln && ln.current;
          if (n && n.primaryProductKey) {
            var t = n.primaryProductKey,
              r = sn[t].items || [],
              o = e.detail;
            if (o) {
              var i = o.productNameToHighlight,
                a = r.find(function (e) {
                  return e.name === i;
                });
              a &&
                Je({
                  isExpandable: !0,
                  name: a.name,
                  primaryProductKey: t,
                  secondaryNavProductKey: a.key,
                });
            }
          }
        };
      return (
        (0, e.useLayoutEffect)(
          function () {
            return (
              (function () {
                var e = fn(
                  ""
                    .concat(window.location.origin)
                    .concat(window.location.pathname)
                );
                if (e in Ve) mn(e);
                else {
                  var n = Object.keys(Ve),
                    t = n.findIndex(function (n) {
                      return e.includes(n);
                    });
                  if (t > -1) {
                    var r = n[t];
                    mn(r);
                  } else
                    window.location.origin in Ve && mn(window.location.origin);
                }
              })(),
              window.addEventListener(gl, _n),
              function () {
                window.removeEventListener(gl, _n);
              }
            );
          },
          [ie, Se]
        ),
        (0, Qe.jsxs)(ol, {
          id: "lt-ch-left-nav",
          className: "Left_Nav ".concat(Ne ? "collapsed" : ""),
          enableNewSidebar: Ne,
          children: [
            (0, Qe.jsx)("div", {
              id: "ltch-lambda-logo-wrapper",
              className:
                "lambda__logo__wrapper lambda__logo__wrapper__left__nav",
              children: (0, Qe.jsx)("a", {
                "aria-label": "LambdaTest Home Dashboard",
                href: "".concat(ve(F, !1, "https", ie), "/").concat(_),
                className: "ltch_lambda__logo",
                "data-amplitude": "SB_lambdatest",
                role: "button",
                tabIndex: ce,
                children: (0, Qe.jsxs)("div", {
                  className: "ltch-left-nav-logo-wrapper",
                  children: [
                    (0, Qe.jsx)(mr, {
                      className: "lambda__logo__img",
                      isHighContrastThemeEnabled: Ae,
                      type: ne.LOGO_BLACK_SMALL,
                    }),
                    (0, Qe.jsx)(mr, {
                      className: "lambda__logo__img lambda__logo__black__text",
                      isHighContrastThemeEnabled: Ae,
                      type: ne.LAMBDATEST,
                    }),
                  ],
                }),
              }),
            }),
            (0, Qe.jsxs)("div", {
              className: "header__aside__menu ".concat(Ne ? "collapsed" : ""),
              id: "left_sidebar_header-items",
              children: [
                un
                  ? (0, Qe.jsx)("nav", {
                      children: (0, Qe.jsxs)("ul", {
                        className:
                          "aside__menu__items aside__menu__items__level1",
                        children: [
                          (0, Qe.jsx)("li", {
                            children: (0, Qe.jsx)("div", {
                              className:
                                "aside__menu__item aside__menu__item__product__title ltch-aside__menu__item ltch-product-name-back-container ".concat(
                                  Ae ? "ltch_high_contrast_item" : ""
                                ),
                              "data-amplitude":
                                "sidebar: click back to products",
                              onClick: function () {
                                pn(fl({}, Xe));
                              },
                              onKeyDown: function (e) {
                                "Enter" === e.key && pn(fl({}, Xe));
                              },
                              tabIndex: ce,
                              role: "button",
                              "aria-label":
                                (null ===
                                  (t =
                                    sn[
                                      null == nn ? void 0 : nn.primaryProductKey
                                    ]) || void 0 === t
                                  ? void 0
                                  : t.name) || sn[Xe.primaryProductKey].name,
                              children: (0, Qe.jsx)("div", {
                                className:
                                  "aside__menu__link aside__menu__link__anchor",
                                "aria-hidden": !0,
                                children: (0, Qe.jsxs)("span", {
                                  className: "ltch-product-name-container",
                                  children: [
                                    (0, Qe.jsx)(mr, {
                                      className: "aside__menu__icon",
                                      isHighContrastThemeEnabled: Ae,
                                      type: ne.ARROW_LEFT,
                                    }),
                                    (0, Qe.jsx)("span", {
                                      className:
                                        "ltch-product-name ltch-product-nav-title",
                                      children:
                                        (null ===
                                          (o =
                                            sn[
                                              null == nn
                                                ? void 0
                                                : nn.primaryProductKey
                                            ]) || void 0 === o
                                          ? void 0
                                          : o.name) ||
                                        sn[Xe.primaryProductKey].name,
                                    }),
                                  ],
                                }),
                              }),
                            }),
                          }),
                          (null ===
                            (i =
                              sn[
                                (null == nn ? void 0 : nn.primaryProductKey) ||
                                  Xe.primaryProductKey
                              ]) || void 0 === i
                            ? void 0
                            : i.items) &&
                            (null ===
                              (C =
                                sn[
                                  (null == nn
                                    ? void 0
                                    : nn.primaryProductKey) ||
                                    Xe.primaryProductKey
                                ]) || void 0 === C
                              ? void 0
                              : C.items.length) > 0 &&
                            (null ===
                              (U =
                                sn[
                                  (null == nn
                                    ? void 0
                                    : nn.primaryProductKey) ||
                                    Xe.primaryProductKey
                                ]) || void 0 === U
                              ? void 0
                              : U.items.map(function (e, n) {
                                  return (0, Qe.jsxs)(Qe.Fragment, {
                                    children: [
                                      (null == e
                                        ? void 0
                                        : e.additionalHeader) &&
                                        (0, Qe.jsx)("li", {
                                          className:
                                            "ltch-left-nav-menu-title ".concat(
                                              0 === n
                                                ? ""
                                                : "ltch-left-nav-menu-title-with-border"
                                            ),
                                          "aria-label":
                                            null == e
                                              ? void 0
                                              : e.additionalHeader,
                                          children:
                                            null == e
                                              ? void 0
                                              : e.additionalHeader,
                                        }),
                                      (0, Qe.jsx)(
                                        "li",
                                        {
                                          className:
                                            "aside__menu__item ltch-aside__menu__item aside__menu__secondary__item aside__menu__secondary__item__"
                                              .concat(e.key, " ")
                                              .concat(
                                                (null == nn
                                                  ? void 0
                                                  : nn.secondaryNavProductKey) ===
                                                  e.key ||
                                                  Xe.secondaryNavProductKey ===
                                                    e.key
                                                  ? "active"
                                                  : "",
                                                "\n                    "
                                              )
                                              .concat(
                                                e.hideByDefault
                                                  ? "ltch-hidden"
                                                  : "",
                                                "\n                    "
                                              )
                                              .concat(
                                                Ae
                                                  ? "ltch_high_contrast_item"
                                                  : "",
                                                "\n                  "
                                              ),
                                          id: e.idToAdd || null,
                                          children: (0, Qe.jsx)(za, {
                                            text:
                                              (!Ne && de) || we ? e.name : "",
                                            direction: za.Direction.RIGHT,
                                            children: (0, Qe.jsx)("a", {
                                              href: "".concat(e.url),
                                              onClick: function (n) {
                                                return (
                                                  (t = n),
                                                  (r = e.url),
                                                  t.preventDefault(),
                                                  void (t && t.metaKey
                                                    ? window.open(r, "_blank")
                                                    : fn(
                                                        window.location.href
                                                      ) === r ||
                                                      (window.location.href =
                                                        r))
                                                );
                                                var t, r;
                                              },
                                              className:
                                                "aside__menu__link aside__menu__link__anchor",
                                              "data-amplitude": "".concat(
                                                e.amplitude_event
                                              ),
                                              "data-amplitude-property-name":
                                                "switch from page",
                                              role: "button",
                                              "aria-label": e.name,
                                              tabIndex: ce,
                                              children: (0, Qe.jsxs)("span", {
                                                className:
                                                  "ltch-product-name-container",
                                                "aria-hidden": !0,
                                                children: [
                                                  (0, Qe.jsx)(mr, {
                                                    className:
                                                      "aside__menu__icon",
                                                    isHighContrastThemeEnabled:
                                                      Ae,
                                                    type: e.iconType,
                                                  }),
                                                  (0, Qe.jsxs)("span", {
                                                    className:
                                                      "ltch-product-name",
                                                    children: [
                                                      e.name,
                                                      e.isBeta &&
                                                        (0, Qe.jsx)("span", {
                                                          className:
                                                            "ltch-beta-tag",
                                                          children: "beta",
                                                        }),
                                                    ],
                                                  }),
                                                ],
                                              }),
                                            }),
                                          }),
                                        },
                                        "aside__menu__secondary__item__".concat(
                                          e.key
                                        )
                                      ),
                                    ],
                                  });
                                })),
                          le &&
                            on &&
                            (0, Qe.jsx)("li", {
                              children: (0, Qe.jsx)("div", {
                                className: "ltch-detailed-product-nav",
                                children: le,
                              }),
                            }),
                        ],
                      }),
                    })
                  : (0, Qe.jsx)("nav", {
                      children: (0, Qe.jsx)("ul", {
                        className: "aside__menu__items",
                        children:
                          $e &&
                          $e.length > 0 &&
                          $e.map(function (e) {
                            return (0, Qe.jsx)(
                              "li",
                              {
                                className:
                                  "aside__menu__item aside__menu__item__main__menu ltch-aside__menu__item aside__menu__item__"
                                    .concat(e.product_key, " ")
                                    .concat(
                                      Xe.primaryProductKey === e.product_key
                                        ? "active"
                                        : "",
                                      " "
                                    )
                                    .concat(
                                      e.shouldHideMenuOption
                                        ? "ltch-hidden"
                                        : "",
                                      " \n                  "
                                    )
                                    .concat(
                                      Ae ? "ltch_high_contrast_item" : "",
                                      " \n                  "
                                    )
                                    .concat(
                                      He
                                        ? "ltch-new-dashboard-item"
                                        : "ltch-old-dashboard-item"
                                    ),
                                onClick: function (n) {
                                  pn(
                                    Xe.primaryProductKey === e.product_key
                                      ? fl({}, Xe)
                                      : {
                                          isExpandable: e.has_dropdown,
                                          name: e.name,
                                          primaryProductKey: e.product_key,
                                        },
                                    (Ne && e.has_dropdown) ||
                                      Xe.primaryProductKey === e.product_key
                                      ? null
                                      : e.url,
                                    n,
                                    Xe.primaryProductKey,
                                    e.product_key,
                                    Xe.primaryProductKey === e.product_key
                                  );
                                },
                                onKeyDown: function (n) {
                                  "Enter" === n.key &&
                                    pn(
                                      Xe.primaryProductKey === e.product_key
                                        ? fl({}, Xe)
                                        : {
                                            isExpandable: e.has_dropdown,
                                            name: e.name,
                                            primaryProductKey: e.product_key,
                                          },
                                      (Ne && e.has_dropdown) ||
                                        Xe.primaryProductKey === e.product_key
                                        ? null
                                        : e.url,
                                      n,
                                      Xe.primaryProductKey,
                                      e.product_key,
                                      Xe.primaryProductKey === e.product_key
                                    );
                                },
                                children: (0, Qe.jsx)(za, {
                                  text: (!Ne && de) || we ? e.name : "",
                                  direction: za.Direction.RIGHT,
                                  children: (0, Qe.jsxs)(
                                    "a",
                                    fl(
                                      fl(
                                        {
                                          className:
                                            "aside__menu__link aside__menu__link__anchor ".concat(
                                              Ne && e.has_dropdown
                                                ? "aside__menu__link__anchor__expandable"
                                                : ""
                                            ),
                                        },
                                        Xe.primaryProductKey ===
                                          e.product_key ||
                                          (Ne && e.has_dropdown)
                                          ? {}
                                          : { href: e.url }
                                      ),
                                      {},
                                      {
                                        role: "button",
                                        id: "aside-menu-link-".concat(
                                          e.product_key
                                        ),
                                        tabIndex: ce,
                                        "aria-label": e.name,
                                        children: [
                                          (0, Qe.jsxs)("span", {
                                            className:
                                              "ltch-product-name-container",
                                            "aria-hidden": !0,
                                            children: [
                                              (0, Qe.jsx)(mr, {
                                                className: "aside__menu__icon",
                                                isHighContrastThemeEnabled: Ae,
                                                type: e.iconType,
                                              }),
                                              (0, Qe.jsx)("span", {
                                                className: "ltch-product-name",
                                                children: e.name,
                                              }),
                                            ],
                                          }),
                                          Ne &&
                                            e.has_dropdown &&
                                            (0, Qe.jsx)("span", {
                                              className: "ltch-caret-right",
                                              children: (0, Qe.jsx)(dl, {}),
                                            }),
                                        ],
                                      }
                                    )
                                  ),
                                }),
                              },
                              "aside__menu__item__".concat(e.product_key)
                            );
                          }),
                      }),
                    }),
                (0, Qe.jsxs)("div", {
                  className: "aside__menu__bottom",
                  children: [
                    (0, Qe.jsx)(ul, {
                      defaultTabIndex: ce,
                      organization: Be,
                      brandName: ie,
                      userInfo: Se,
                      onPremPrefixToUse: fe,
                    }),
                    re &&
                      !fe &&
                      (0, Qe.jsx)(Yr, {
                        addTooltipOverlay: !0,
                        classToAdd: "ltch-bottom-upgrade-btn",
                        currentSubscriptionType: Fe,
                        defaultTabIndex: ce,
                        eventNameToUse: "sidebar: click upgrade",
                        isResellerCustomer: Ke,
                        organizationRole: ze,
                        upgradeBtnTextToDisplay: Ee,
                      }),
                  ],
                }),
              ],
            }),
          ],
        })
      );
    }
    function bl(e) {
      return (
        (bl =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (e) {
                return typeof e;
              }
            : function (e) {
                return e &&
                  "function" == typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              }),
        bl(e)
      );
    }
    function xl() {
      xl = function () {
        return e;
      };
      var e = {},
        n = Object.prototype,
        t = n.hasOwnProperty,
        r =
          Object.defineProperty ||
          function (e, n, t) {
            e[n] = t.value;
          },
        o = "function" == typeof Symbol ? Symbol : {},
        i = o.iterator || "@@iterator",
        a = o.asyncIterator || "@@asyncIterator",
        l = o.toStringTag || "@@toStringTag";
      function s(e, n, t) {
        return (
          Object.defineProperty(e, n, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          }),
          e[n]
        );
      }
      try {
        s({}, "");
      } catch (e) {
        s = function (e, n, t) {
          return (e[n] = t);
        };
      }
      function c(e, n, t, o) {
        var i = n && n.prototype instanceof p ? n : p,
          a = Object.create(i.prototype),
          l = new L(o || []);
        return r(a, "_invoke", { value: x(e, t, l) }), a;
      }
      function u(e, n, t) {
        try {
          return { type: "normal", arg: e.call(n, t) };
        } catch (e) {
          return { type: "throw", arg: e };
        }
      }
      e.wrap = c;
      var d = {};
      function p() {}
      function f() {}
      function h() {}
      var m = {};
      s(m, i, function () {
        return this;
      });
      var _ = Object.getPrototypeOf,
        g = _ && _(_(j([])));
      g && g !== n && t.call(g, i) && (m = g);
      var v = (h.prototype = p.prototype = Object.create(m));
      function C(e) {
        ["next", "throw", "return"].forEach(function (n) {
          s(e, n, function (e) {
            return this._invoke(n, e);
          });
        });
      }
      function b(e, n) {
        function o(r, i, a, l) {
          var s = u(e[r], e, i);
          if ("throw" !== s.type) {
            var c = s.arg,
              d = c.value;
            return d && "object" == bl(d) && t.call(d, "__await")
              ? n.resolve(d.__await).then(
                  function (e) {
                    o("next", e, a, l);
                  },
                  function (e) {
                    o("throw", e, a, l);
                  }
                )
              : n.resolve(d).then(
                  function (e) {
                    (c.value = e), a(c);
                  },
                  function (e) {
                    return o("throw", e, a, l);
                  }
                );
          }
          l(s.arg);
        }
        var i;
        r(this, "_invoke", {
          value: function (e, t) {
            function r() {
              return new n(function (n, r) {
                o(e, t, n, r);
              });
            }
            return (i = i ? i.then(r, r) : r());
          },
        });
      }
      function x(e, n, t) {
        var r = "suspendedStart";
        return function (o, i) {
          if ("executing" === r)
            throw new Error("Generator is already running");
          if ("completed" === r) {
            if ("throw" === o) throw i;
            return { value: void 0, done: !0 };
          }
          for (t.method = o, t.arg = i; ; ) {
            var a = t.delegate;
            if (a) {
              var l = y(a, t);
              if (l) {
                if (l === d) continue;
                return l;
              }
            }
            if ("next" === t.method) t.sent = t._sent = t.arg;
            else if ("throw" === t.method) {
              if ("suspendedStart" === r) throw ((r = "completed"), t.arg);
              t.dispatchException(t.arg);
            } else "return" === t.method && t.abrupt("return", t.arg);
            r = "executing";
            var s = u(e, n, t);
            if ("normal" === s.type) {
              if (((r = t.done ? "completed" : "suspendedYield"), s.arg === d))
                continue;
              return { value: s.arg, done: t.done };
            }
            "throw" === s.type &&
              ((r = "completed"), (t.method = "throw"), (t.arg = s.arg));
          }
        };
      }
      function y(e, n) {
        var t = e.iterator[n.method];
        if (void 0 === t) {
          if (((n.delegate = null), "throw" === n.method)) {
            if (
              e.iterator.return &&
              ((n.method = "return"),
              (n.arg = void 0),
              y(e, n),
              "throw" === n.method)
            )
              return d;
            (n.method = "throw"),
              (n.arg = new TypeError(
                "The iterator does not provide a 'throw' method"
              ));
          }
          return d;
        }
        var r = u(t, e.iterator, n.arg);
        if ("throw" === r.type)
          return (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), d;
        var o = r.arg;
        return o
          ? o.done
            ? ((n[e.resultName] = o.value),
              (n.next = e.nextLoc),
              "return" !== n.method && ((n.method = "next"), (n.arg = void 0)),
              (n.delegate = null),
              d)
            : o
          : ((n.method = "throw"),
            (n.arg = new TypeError("iterator result is not an object")),
            (n.delegate = null),
            d);
      }
      function w(e) {
        var n = { tryLoc: e[0] };
        1 in e && (n.catchLoc = e[1]),
          2 in e && ((n.finallyLoc = e[2]), (n.afterLoc = e[3])),
          this.tryEntries.push(n);
      }
      function k(e) {
        var n = e.completion || {};
        (n.type = "normal"), delete n.arg, (e.completion = n);
      }
      function L(e) {
        (this.tryEntries = [{ tryLoc: "root" }]),
          e.forEach(w, this),
          this.reset(!0);
      }
      function j(e) {
        if (e) {
          var n = e[i];
          if (n) return n.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var r = -1,
              o = function n() {
                for (; ++r < e.length; )
                  if (t.call(e, r)) return (n.value = e[r]), (n.done = !1), n;
                return (n.value = void 0), (n.done = !0), n;
              };
            return (o.next = o);
          }
        }
        return { next: E };
      }
      function E() {
        return { value: void 0, done: !0 };
      }
      return (
        (f.prototype = h),
        r(v, "constructor", { value: h, configurable: !0 }),
        r(h, "constructor", { value: f, configurable: !0 }),
        (f.displayName = s(h, l, "GeneratorFunction")),
        (e.isGeneratorFunction = function (e) {
          var n = "function" == typeof e && e.constructor;
          return (
            !!n &&
            (n === f || "GeneratorFunction" === (n.displayName || n.name))
          );
        }),
        (e.mark = function (e) {
          return (
            Object.setPrototypeOf
              ? Object.setPrototypeOf(e, h)
              : ((e.__proto__ = h), s(e, l, "GeneratorFunction")),
            (e.prototype = Object.create(v)),
            e
          );
        }),
        (e.awrap = function (e) {
          return { __await: e };
        }),
        C(b.prototype),
        s(b.prototype, a, function () {
          return this;
        }),
        (e.AsyncIterator = b),
        (e.async = function (n, t, r, o, i) {
          void 0 === i && (i = Promise);
          var a = new b(c(n, t, r, o), i);
          return e.isGeneratorFunction(t)
            ? a
            : a.next().then(function (e) {
                return e.done ? e.value : a.next();
              });
        }),
        C(v),
        s(v, l, "Generator"),
        s(v, i, function () {
          return this;
        }),
        s(v, "toString", function () {
          return "[object Generator]";
        }),
        (e.keys = function (e) {
          var n = Object(e),
            t = [];
          for (var r in n) t.push(r);
          return (
            t.reverse(),
            function e() {
              for (; t.length; ) {
                var r = t.pop();
                if (r in n) return (e.value = r), (e.done = !1), e;
              }
              return (e.done = !0), e;
            }
          );
        }),
        (e.values = j),
        (L.prototype = {
          constructor: L,
          reset: function (e) {
            if (
              ((this.prev = 0),
              (this.next = 0),
              (this.sent = this._sent = void 0),
              (this.done = !1),
              (this.delegate = null),
              (this.method = "next"),
              (this.arg = void 0),
              this.tryEntries.forEach(k),
              !e)
            )
              for (var n in this)
                "t" === n.charAt(0) &&
                  t.call(this, n) &&
                  !isNaN(+n.slice(1)) &&
                  (this[n] = void 0);
          },
          stop: function () {
            this.done = !0;
            var e = this.tryEntries[0].completion;
            if ("throw" === e.type) throw e.arg;
            return this.rval;
          },
          dispatchException: function (e) {
            if (this.done) throw e;
            var n = this;
            function r(t, r) {
              return (
                (a.type = "throw"),
                (a.arg = e),
                (n.next = t),
                r && ((n.method = "next"), (n.arg = void 0)),
                !!r
              );
            }
            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                a = i.completion;
              if ("root" === i.tryLoc) return r("end");
              if (i.tryLoc <= this.prev) {
                var l = t.call(i, "catchLoc"),
                  s = t.call(i, "finallyLoc");
                if (l && s) {
                  if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                } else if (l) {
                  if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                } else {
                  if (!s)
                    throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function (e, n) {
            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var o = this.tryEntries[r];
              if (
                o.tryLoc <= this.prev &&
                t.call(o, "finallyLoc") &&
                this.prev < o.finallyLoc
              ) {
                var i = o;
                break;
              }
            }
            i &&
              ("break" === e || "continue" === e) &&
              i.tryLoc <= n &&
              n <= i.finallyLoc &&
              (i = null);
            var a = i ? i.completion : {};
            return (
              (a.type = e),
              (a.arg = n),
              i
                ? ((this.method = "next"), (this.next = i.finallyLoc), d)
                : this.complete(a)
            );
          },
          complete: function (e, n) {
            if ("throw" === e.type) throw e.arg;
            return (
              "break" === e.type || "continue" === e.type
                ? (this.next = e.arg)
                : "return" === e.type
                ? ((this.rval = this.arg = e.arg),
                  (this.method = "return"),
                  (this.next = "end"))
                : "normal" === e.type && n && (this.next = n),
              d
            );
          },
          finish: function (e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var t = this.tryEntries[n];
              if (t.finallyLoc === e)
                return this.complete(t.completion, t.afterLoc), k(t), d;
            }
          },
          catch: function (e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var t = this.tryEntries[n];
              if (t.tryLoc === e) {
                var r = t.completion;
                if ("throw" === r.type) {
                  var o = r.arg;
                  k(t);
                }
                return o;
              }
            }
            throw new Error("illegal catch attempt");
          },
          delegateYield: function (e, n, t) {
            return (
              (this.delegate = { iterator: j(e), resultName: n, nextLoc: t }),
              "next" === this.method && (this.arg = void 0),
              d
            );
          },
        }),
        e
      );
    }
    function yl(e, n, t, r, o, i, a) {
      try {
        var l = e[i](a),
          s = l.value;
      } catch (e) {
        return void t(e);
      }
      l.done ? n(s) : Promise.resolve(s).then(r, o);
    }
    function wl(e, n) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n &&
          (r = r.filter(function (n) {
            return Object.getOwnPropertyDescriptor(e, n).enumerable;
          })),
          t.push.apply(t, r);
      }
      return t;
    }
    function kl(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2
          ? wl(Object(t), !0).forEach(function (n) {
              Ll(e, n, t[n]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : wl(Object(t)).forEach(function (n) {
              Object.defineProperty(
                e,
                n,
                Object.getOwnPropertyDescriptor(t, n)
              );
            });
      }
      return e;
    }
    function Ll(e, n, t) {
      return (
        n in e
          ? Object.defineProperty(e, n, {
              value: t,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[n] = t),
        e
      );
    }
    function jl(e, n) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, n) {
          var t =
            null == e
              ? null
              : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                e["@@iterator"];
          if (null != t) {
            var r,
              o,
              i = [],
              a = !0,
              l = !1;
            try {
              for (
                t = t.call(e);
                !(a = (r = t.next()).done) &&
                (i.push(r.value), !n || i.length !== n);
                a = !0
              );
            } catch (e) {
              (l = !0), (o = e);
            } finally {
              try {
                a || null == t.return || t.return();
              } finally {
                if (l) throw o;
              }
            }
            return i;
          }
        })(e, n) ||
        (function (e, n) {
          if (e) {
            if ("string" == typeof e) return El(e, n);
            var t = Object.prototype.toString.call(e).slice(8, -1);
            return (
              "Object" === t && e.constructor && (t = e.constructor.name),
              "Map" === t || "Set" === t
                ? Array.from(e)
                : "Arguments" === t ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
                ? El(e, n)
                : void 0
            );
          }
        })(e, n) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        })()
      );
    }
    function El(e, n) {
      (null == n || n > e.length) && (n = e.length);
      for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
      return r;
    }
    var Sl =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    function Ml(n) {
      var t = n.userInfo,
        r = void 0 === t ? {} : t,
        o = jl((0, e.useState)({}), 2),
        i = o[0],
        a = o[1],
        l = jl((0, e.useState)(!1), 2),
        s = l[0],
        c = l[1],
        u = jl((0, e.useState)([]), 2),
        d = u[0],
        p = u[1],
        f = jl((0, e.useState)(""), 2),
        h = f[0],
        m = f[1],
        _ = jl((0, e.useState)(!1), 2),
        g = _[0],
        v = _[1],
        C = jl((0, e.useState)(!1), 2),
        b = C[0],
        x = C[1],
        y = jl((0, e.useState)(""), 2),
        w = y[0],
        k = y[1],
        L = jl((0, e.useState)(!1), 2),
        j = L[0],
        E = L[1],
        S = jl((0, e.useState)({}), 2),
        M = S[0],
        T = S[1],
        N = (0, e.useRef)();
      (0, e.useEffect)(
        function () {
          var e = r.email,
            n = void 0 === e ? "" : e,
            t = r.phone,
            o = void 0 === t ? "" : t,
            i = r.name,
            l = (void 0 === i ? "" : i).split(" "),
            s = l.shift(),
            c = l.join(" ");
          a({
            email: n,
            first_name: s,
            last_name: c,
            mobile_no: o,
            message: "",
          });
        },
        [r]
      ),
        (0, e.useEffect)(function () {
          (window.displayDemoForm = I),
            (window.renderBookADemoBtn = O),
            (window.hideBookADemoBtn = A);
        }, []);
      var O = function (e) {
          var n =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {},
            t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          t || Re("Clicked : book a demo", { product: e }), k(e), x(!0), T(n);
        },
        A = function () {
          k(""), x(!1);
        },
        I = function (e) {
          v(!0),
            k(e),
            setTimeout(function () {
              (N && N.current).addEventListener("keydown", P);
            }, 500);
        },
        P = function (e) {
          var n = document.getElementById("close_demo"),
            t = document.getElementsByClassName("ltch-demo-form-submit")[0];
          try {
            "Tab" === e.key &&
              (document.activeElement !== t || e.shiftKey
                ? document.activeElement === n &&
                  e.shiftKey &&
                  (e.preventDefault(), t.focus())
                : (e.preventDefault(), n.focus())),
              "Escape" === e.key && G();
          } catch (e) {}
        },
        R = i.email,
        H = void 0 === R ? "" : R,
        V = i.first_name,
        D = void 0 === V ? "" : V,
        B = i.last_name,
        W = void 0 === B ? "" : B,
        z = i.mobile_no,
        Z = void 0 === z ? "" : z,
        F = i.message,
        U = void 0 === F ? "" : F,
        K = function (e, n) {
          var t = n.target.value,
            r = kl(kl({}, i), {}, Ll({}, e, t));
          a(r);
        },
        G = function () {
          (N && N.current).removeEventListener("keydown", P), v(!1);
        },
        Y = (function () {
          var e,
            n =
              ((e = xl().mark(function e() {
                var n, t, r, o, a, l;
                return xl().wrap(
                  function (e) {
                    for (;;)
                      switch ((e.prev = e.next)) {
                        case 0:
                          if (
                            (G(),
                            (n = kl(
                              kl({}, i),
                              {},
                              {
                                product_interested_in: w,
                                query_type: "Schedule a Demo",
                                source: "Web Submissions",
                                source_page_title: document.title,
                                source_page_url: window.location.href,
                              }
                            )),
                            (e.prev = 2),
                            !window.RevenueHero)
                          ) {
                            e.next = 13;
                            break;
                          }
                          return (
                            (e.next = 6),
                            fetch("".concat(ve(se), "/api/country-details"))
                          );
                        case 6:
                          return (t = e.sent), (e.next = 9), t.json();
                        case 9:
                          (r = e.sent),
                            (o = kl(kl({}, n), r)),
                            (a = new window.RevenueHero({
                              routerId: "630",
                              showLoader: !0,
                            }))
                              .submit(kl({}, o))
                              .then(function (e) {
                                a.dialog.open(e);
                              })
                              .catch(function (e) {});
                        case 13:
                          return (
                            (e.next = 15),
                            fetch(
                              "".concat(ve("forms", !0), "/api/forms/contact"),
                              {
                                method: "POST",
                                body: JSON.stringify(n),
                                headers: { "Content-Type": "application/json" },
                              }
                            )
                          );
                        case 15:
                          return (l = e.sent), (e.next = 18), l.json();
                        case 18:
                          e.sent &&
                            (E(!0),
                            setTimeout(function () {
                              E(!1);
                            }, 2e3)),
                            Re("book_a_demo_success", {
                              product_interested_in: w,
                            }),
                            (e.next = 25);
                          break;
                        case 23:
                          (e.prev = 23), (e.t0 = e.catch(2));
                        case 25:
                        case "end":
                          return e.stop();
                      }
                  },
                  e,
                  null,
                  [[2, 23]]
                );
              })),
              function () {
                var n = this,
                  t = arguments;
                return new Promise(function (r, o) {
                  var i = e.apply(n, t);
                  function a(e) {
                    yl(i, r, o, a, l, "next", e);
                  }
                  function l(e) {
                    yl(i, r, o, a, l, "throw", e);
                  }
                  a(void 0);
                });
              });
          return function () {
            return n.apply(this, arguments);
          };
        })();
      return (0, Qe.jsxs)(Qe.Fragment, {
        children: [
          b &&
            (0, Qe.jsxs)("button", {
              "aria-label": "Book a demo",
              className: "ltch-book-a-demo-btn",
              style: kl({}, M),
              onClick: function () {
                window.displayDemoForm(w, M);
              },
              type: "submit",
              children: [
                (0, Qe.jsx)("span", {
                  "aria-hidden": !0,
                  children: (0, Qe.jsx)(mr, { type: ne.HEADPHONE }),
                }),
                "Book A Demo",
              ],
            }),
          g &&
            (0, Qe.jsx)("div", {
              id: "ltch-demo-form-wrapper",
              children: (0, Qe.jsx)("div", {
                className: "ltch-demo-form-container",
                ref: N,
                children: (0, Qe.jsxs)("div", {
                  className: "contact-form contact__form",
                  children: [
                    (0, Qe.jsxs)("div", {
                      className: "ltch-demo-form-header",
                      children: [
                        "Schedule Your Personal Demo",
                        " ",
                        (0, Qe.jsx)("span", {
                          id: "close_demo",
                          className: "ltch-demo-form-close",
                          onClick: G,
                          onKeyDown: function (e) {
                            ("Enter" !== e.key && "Space" !== e.code) || G();
                          },
                          role: "button",
                          "aria-label": "Close Demo Popup",
                          tabIndex: 0,
                          children: (0, Qe.jsx)(mr, { type: ne.CROSS }),
                        }),
                      ],
                    }),
                    s &&
                      (0, Qe.jsx)("span", {
                        className: "ltch-demo-form-warning",
                        children: h,
                      }),
                    (0, Qe.jsxs)("form", {
                      className: "ltch-demo-form",
                      children: [
                        (0, Qe.jsxs)("div", {
                          className:
                            "ltch-flex-column ltch-demo-form-fields-wrapper",
                          children: [
                            (0, Qe.jsxs)("div", {
                              className: "ltch-flex ltch-demo-form-name-fields",
                              children: [
                                (0, Qe.jsxs)("div", {
                                  className:
                                    "ltch-flex-column ltch-demo-form-field-container",
                                  children: [
                                    (0, Qe.jsxs)("label", {
                                      children: [
                                        "First Name",
                                        " ",
                                        (0, Qe.jsx)("span", {
                                          className: "ltch-demo-form-asteriek",
                                          children: "*",
                                        }),
                                      ],
                                    }),
                                    (0, Qe.jsx)("input", {
                                      "aria-invalid": d.includes("first_name"),
                                      placeholder: "First Name",
                                      onChange: function (e) {
                                        return K("first_name", e);
                                      },
                                      type: "text",
                                      value: D,
                                    }),
                                  ],
                                }),
                                (0, Qe.jsxs)("div", {
                                  className:
                                    "ltch-flex-column ltch-demo-form-field-container",
                                  children: [
                                    (0, Qe.jsxs)("label", {
                                      children: [
                                        "Last Name",
                                        " ",
                                        (0, Qe.jsx)("span", {
                                          className: "ltch-demo-form-asteriek",
                                          children: "*",
                                        }),
                                      ],
                                    }),
                                    (0, Qe.jsx)("input", {
                                      "aria-invalid": d.includes("last_name"),
                                      placeholder: "Last Name",
                                      onChange: function (e) {
                                        return K("last_name", e);
                                      },
                                      type: "text",
                                      value: W,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            (0, Qe.jsxs)("div", {
                              className:
                                "ltch-flex-column ltch-demo-form-field-container",
                              children: [
                                (0, Qe.jsxs)("label", {
                                  children: [
                                    "Work Email",
                                    " ",
                                    (0, Qe.jsx)("span", {
                                      className: "ltch-demo-form-asteriek",
                                      children: "*",
                                    }),
                                  ],
                                }),
                                (0, Qe.jsx)("input", {
                                  "aria-invalid": d.includes("email"),
                                  placeholder: "Email",
                                  onChange: function (e) {
                                    return K("email", e);
                                  },
                                  type: "text",
                                  value: H,
                                }),
                              ],
                            }),
                            (0, Qe.jsxs)("div", {
                              className:
                                "ltch-flex-column ltch-demo-form-field-container",
                              children: [
                                (0, Qe.jsxs)("label", {
                                  children: [
                                    "Phone Number",
                                    " ",
                                    (0, Qe.jsx)("span", {
                                      className: "ltch-demo-form-asteriek",
                                      children: "*",
                                    }),
                                  ],
                                }),
                                (0, Qe.jsx)("input", {
                                  "aria-invalid": d.includes("mobile_no"),
                                  placeholder: "Phone number",
                                  onChange: function (e) {
                                    return K("mobile_no", e);
                                  },
                                  type: "text",
                                  value: Z,
                                }),
                              ],
                            }),
                            (0, Qe.jsxs)("div", {
                              className:
                                "ltch-flex-column ltch-demo-form-field-container",
                              children: [
                                (0, Qe.jsxs)("label", {
                                  children: [
                                    "Your Message",
                                    " ",
                                    (0, Qe.jsx)("span", {
                                      className: "ltch-demo-form-asteriek",
                                      children: "*",
                                    }),
                                  ],
                                }),
                                (0, Qe.jsx)("textarea", {
                                  autoFocus: !0,
                                  "aria-invalid": d.includes("message"),
                                  placeholder: "Tell us how can we help you",
                                  onChange: function (e) {
                                    return K("message", e);
                                  },
                                  required: !0,
                                  value: U,
                                }),
                              ],
                            }),
                          ],
                        }),
                        (0, Qe.jsx)("div", {
                          className: "ltch-demo-form-submit-btn-container",
                          children: (0, Qe.jsx)("button", {
                            className: "ltch-demo-form-submit",
                            onClick: function (e) {
                              c(!1), m(""), p([]), e.preventDefault();
                              var n = Object.keys(i).filter(function (e) {
                                return !i[e].trim();
                              });
                              n.length > 0
                                ? (c(!0),
                                  m("Please fill all mandatory fields"),
                                  p(n))
                                : i.email.match(Sl)
                                ? Y()
                                : (c(!0),
                                  m("Please enter a valid email"),
                                  p(["email"]));
                            },
                            type: "submit",
                            children: "Schedule demo",
                          }),
                        }),
                      ],
                    }),
                  ],
                }),
              }),
            }),
          (0, Qe.jsx)(Vr, {
            msg: "Your response has been submitted",
            showToast: j,
          }),
        ],
      });
    }
    o(411);
    var Tl = function () {
        var e =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : "isNewSidebarEnabled",
          n = localStorage.getItem(e) || "{}",
          t = JSON.parse(n);
        return t;
      },
      Nl = function (e, n) {
        localStorage.setItem(e, JSON.stringify(n));
      };
    function Ol(e) {
      return (
        (Ol =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (e) {
                return typeof e;
              }
            : function (e) {
                return e &&
                  "function" == typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              }),
        Ol(e)
      );
    }
    function Al() {
      Al = function () {
        return e;
      };
      var e = {},
        n = Object.prototype,
        t = n.hasOwnProperty,
        r =
          Object.defineProperty ||
          function (e, n, t) {
            e[n] = t.value;
          },
        o = "function" == typeof Symbol ? Symbol : {},
        i = o.iterator || "@@iterator",
        a = o.asyncIterator || "@@asyncIterator",
        l = o.toStringTag || "@@toStringTag";
      function s(e, n, t) {
        return (
          Object.defineProperty(e, n, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          }),
          e[n]
        );
      }
      try {
        s({}, "");
      } catch (e) {
        s = function (e, n, t) {
          return (e[n] = t);
        };
      }
      function c(e, n, t, o) {
        var i = n && n.prototype instanceof p ? n : p,
          a = Object.create(i.prototype),
          l = new L(o || []);
        return r(a, "_invoke", { value: x(e, t, l) }), a;
      }
      function u(e, n, t) {
        try {
          return { type: "normal", arg: e.call(n, t) };
        } catch (e) {
          return { type: "throw", arg: e };
        }
      }
      e.wrap = c;
      var d = {};
      function p() {}
      function f() {}
      function h() {}
      var m = {};
      s(m, i, function () {
        return this;
      });
      var _ = Object.getPrototypeOf,
        g = _ && _(_(j([])));
      g && g !== n && t.call(g, i) && (m = g);
      var v = (h.prototype = p.prototype = Object.create(m));
      function C(e) {
        ["next", "throw", "return"].forEach(function (n) {
          s(e, n, function (e) {
            return this._invoke(n, e);
          });
        });
      }
      function b(e, n) {
        function o(r, i, a, l) {
          var s = u(e[r], e, i);
          if ("throw" !== s.type) {
            var c = s.arg,
              d = c.value;
            return d && "object" == Ol(d) && t.call(d, "__await")
              ? n.resolve(d.__await).then(
                  function (e) {
                    o("next", e, a, l);
                  },
                  function (e) {
                    o("throw", e, a, l);
                  }
                )
              : n.resolve(d).then(
                  function (e) {
                    (c.value = e), a(c);
                  },
                  function (e) {
                    return o("throw", e, a, l);
                  }
                );
          }
          l(s.arg);
        }
        var i;
        r(this, "_invoke", {
          value: function (e, t) {
            function r() {
              return new n(function (n, r) {
                o(e, t, n, r);
              });
            }
            return (i = i ? i.then(r, r) : r());
          },
        });
      }
      function x(e, n, t) {
        var r = "suspendedStart";
        return function (o, i) {
          if ("executing" === r)
            throw new Error("Generator is already running");
          if ("completed" === r) {
            if ("throw" === o) throw i;
            return { value: void 0, done: !0 };
          }
          for (t.method = o, t.arg = i; ; ) {
            var a = t.delegate;
            if (a) {
              var l = y(a, t);
              if (l) {
                if (l === d) continue;
                return l;
              }
            }
            if ("next" === t.method) t.sent = t._sent = t.arg;
            else if ("throw" === t.method) {
              if ("suspendedStart" === r) throw ((r = "completed"), t.arg);
              t.dispatchException(t.arg);
            } else "return" === t.method && t.abrupt("return", t.arg);
            r = "executing";
            var s = u(e, n, t);
            if ("normal" === s.type) {
              if (((r = t.done ? "completed" : "suspendedYield"), s.arg === d))
                continue;
              return { value: s.arg, done: t.done };
            }
            "throw" === s.type &&
              ((r = "completed"), (t.method = "throw"), (t.arg = s.arg));
          }
        };
      }
      function y(e, n) {
        var t = e.iterator[n.method];
        if (void 0 === t) {
          if (((n.delegate = null), "throw" === n.method)) {
            if (
              e.iterator.return &&
              ((n.method = "return"),
              (n.arg = void 0),
              y(e, n),
              "throw" === n.method)
            )
              return d;
            (n.method = "throw"),
              (n.arg = new TypeError(
                "The iterator does not provide a 'throw' method"
              ));
          }
          return d;
        }
        var r = u(t, e.iterator, n.arg);
        if ("throw" === r.type)
          return (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), d;
        var o = r.arg;
        return o
          ? o.done
            ? ((n[e.resultName] = o.value),
              (n.next = e.nextLoc),
              "return" !== n.method && ((n.method = "next"), (n.arg = void 0)),
              (n.delegate = null),
              d)
            : o
          : ((n.method = "throw"),
            (n.arg = new TypeError("iterator result is not an object")),
            (n.delegate = null),
            d);
      }
      function w(e) {
        var n = { tryLoc: e[0] };
        1 in e && (n.catchLoc = e[1]),
          2 in e && ((n.finallyLoc = e[2]), (n.afterLoc = e[3])),
          this.tryEntries.push(n);
      }
      function k(e) {
        var n = e.completion || {};
        (n.type = "normal"), delete n.arg, (e.completion = n);
      }
      function L(e) {
        (this.tryEntries = [{ tryLoc: "root" }]),
          e.forEach(w, this),
          this.reset(!0);
      }
      function j(e) {
        if (e) {
          var n = e[i];
          if (n) return n.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var r = -1,
              o = function n() {
                for (; ++r < e.length; )
                  if (t.call(e, r)) return (n.value = e[r]), (n.done = !1), n;
                return (n.value = void 0), (n.done = !0), n;
              };
            return (o.next = o);
          }
        }
        return { next: E };
      }
      function E() {
        return { value: void 0, done: !0 };
      }
      return (
        (f.prototype = h),
        r(v, "constructor", { value: h, configurable: !0 }),
        r(h, "constructor", { value: f, configurable: !0 }),
        (f.displayName = s(h, l, "GeneratorFunction")),
        (e.isGeneratorFunction = function (e) {
          var n = "function" == typeof e && e.constructor;
          return (
            !!n &&
            (n === f || "GeneratorFunction" === (n.displayName || n.name))
          );
        }),
        (e.mark = function (e) {
          return (
            Object.setPrototypeOf
              ? Object.setPrototypeOf(e, h)
              : ((e.__proto__ = h), s(e, l, "GeneratorFunction")),
            (e.prototype = Object.create(v)),
            e
          );
        }),
        (e.awrap = function (e) {
          return { __await: e };
        }),
        C(b.prototype),
        s(b.prototype, a, function () {
          return this;
        }),
        (e.AsyncIterator = b),
        (e.async = function (n, t, r, o, i) {
          void 0 === i && (i = Promise);
          var a = new b(c(n, t, r, o), i);
          return e.isGeneratorFunction(t)
            ? a
            : a.next().then(function (e) {
                return e.done ? e.value : a.next();
              });
        }),
        C(v),
        s(v, l, "Generator"),
        s(v, i, function () {
          return this;
        }),
        s(v, "toString", function () {
          return "[object Generator]";
        }),
        (e.keys = function (e) {
          var n = Object(e),
            t = [];
          for (var r in n) t.push(r);
          return (
            t.reverse(),
            function e() {
              for (; t.length; ) {
                var r = t.pop();
                if (r in n) return (e.value = r), (e.done = !1), e;
              }
              return (e.done = !0), e;
            }
          );
        }),
        (e.values = j),
        (L.prototype = {
          constructor: L,
          reset: function (e) {
            if (
              ((this.prev = 0),
              (this.next = 0),
              (this.sent = this._sent = void 0),
              (this.done = !1),
              (this.delegate = null),
              (this.method = "next"),
              (this.arg = void 0),
              this.tryEntries.forEach(k),
              !e)
            )
              for (var n in this)
                "t" === n.charAt(0) &&
                  t.call(this, n) &&
                  !isNaN(+n.slice(1)) &&
                  (this[n] = void 0);
          },
          stop: function () {
            this.done = !0;
            var e = this.tryEntries[0].completion;
            if ("throw" === e.type) throw e.arg;
            return this.rval;
          },
          dispatchException: function (e) {
            if (this.done) throw e;
            var n = this;
            function r(t, r) {
              return (
                (a.type = "throw"),
                (a.arg = e),
                (n.next = t),
                r && ((n.method = "next"), (n.arg = void 0)),
                !!r
              );
            }
            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                a = i.completion;
              if ("root" === i.tryLoc) return r("end");
              if (i.tryLoc <= this.prev) {
                var l = t.call(i, "catchLoc"),
                  s = t.call(i, "finallyLoc");
                if (l && s) {
                  if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                } else if (l) {
                  if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                } else {
                  if (!s)
                    throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function (e, n) {
            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var o = this.tryEntries[r];
              if (
                o.tryLoc <= this.prev &&
                t.call(o, "finallyLoc") &&
                this.prev < o.finallyLoc
              ) {
                var i = o;
                break;
              }
            }
            i &&
              ("break" === e || "continue" === e) &&
              i.tryLoc <= n &&
              n <= i.finallyLoc &&
              (i = null);
            var a = i ? i.completion : {};
            return (
              (a.type = e),
              (a.arg = n),
              i
                ? ((this.method = "next"), (this.next = i.finallyLoc), d)
                : this.complete(a)
            );
          },
          complete: function (e, n) {
            if ("throw" === e.type) throw e.arg;
            return (
              "break" === e.type || "continue" === e.type
                ? (this.next = e.arg)
                : "return" === e.type
                ? ((this.rval = this.arg = e.arg),
                  (this.method = "return"),
                  (this.next = "end"))
                : "normal" === e.type && n && (this.next = n),
              d
            );
          },
          finish: function (e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var t = this.tryEntries[n];
              if (t.finallyLoc === e)
                return this.complete(t.completion, t.afterLoc), k(t), d;
            }
          },
          catch: function (e) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var t = this.tryEntries[n];
              if (t.tryLoc === e) {
                var r = t.completion;
                if ("throw" === r.type) {
                  var o = r.arg;
                  k(t);
                }
                return o;
              }
            }
            throw new Error("illegal catch attempt");
          },
          delegateYield: function (e, n, t) {
            return (
              (this.delegate = { iterator: j(e), resultName: n, nextLoc: t }),
              "next" === this.method && (this.arg = void 0),
              d
            );
          },
        }),
        e
      );
    }
    function Il(e, n, t, r, o, i, a) {
      try {
        var l = e[i](a),
          s = l.value;
      } catch (e) {
        return void t(e);
      }
      l.done ? n(s) : Promise.resolve(s).then(r, o);
    }
    function Pl(e) {
      return function () {
        var n = this,
          t = arguments;
        return new Promise(function (r, o) {
          var i = e.apply(n, t);
          function a(e) {
            Il(i, r, o, a, l, "next", e);
          }
          function l(e) {
            Il(i, r, o, a, l, "throw", e);
          }
          a(void 0);
        });
      };
    }
    function Rl(e, n) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, n) {
          var t =
            null == e
              ? null
              : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                e["@@iterator"];
          if (null != t) {
            var r,
              o,
              i = [],
              a = !0,
              l = !1;
            try {
              for (
                t = t.call(e);
                !(a = (r = t.next()).done) &&
                (i.push(r.value), !n || i.length !== n);
                a = !0
              );
            } catch (e) {
              (l = !0), (o = e);
            } finally {
              try {
                a || null == t.return || t.return();
              } finally {
                if (l) throw o;
              }
            }
            return i;
          }
        })(e, n) ||
        (function (e, n) {
          if (e) {
            if ("string" == typeof e) return Hl(e, n);
            var t = Object.prototype.toString.call(e).slice(8, -1);
            return (
              "Object" === t && e.constructor && (t = e.constructor.name),
              "Map" === t || "Set" === t
                ? Array.from(e)
                : "Arguments" === t ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
                ? Hl(e, n)
                : void 0
            );
          }
        })(e, n) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        })()
      );
    }
    function Hl(e, n) {
      (null == n || n > e.length) && (n = e.length);
      for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
      return r;
    }
    var Vl = function (n) {
      var t,
        i = n.concurrencyInfo,
        a = void 0 === i ? [] : i,
        l = n.customProductHeader,
        s = void 0 === l ? void 0 : l,
        c = n.children,
        u = n.defaultTabIndex,
        d = void 0 === u ? 0 : u,
        p = n.detailedProductNav,
        f = void 0 === p ? void 0 : p,
        h = n.isCollapsed,
        m = void 0 !== h && h,
        _ = n.isNewThemeEnabled,
        g = void 0 !== _ && _,
        v = n.isHighContrastThemeEnabled,
        x = void 0 !== v && v,
        y = n.onPremPrefixToUse,
        w = void 0 === y ? "" : y,
        S = n.showA11yWarning,
        A = void 0 !== S && S,
        I = n.showTunnel,
        P = void 0 !== I && I,
        R = n.topNavCustomInfo,
        H = n.topNavButtons,
        D = void 0 === H ? void 0 : H,
        B = n.lowResNavItems,
        U = void 0 === B ? [] : B,
        G = ((t = ke()) ? Ie(t) : {}).id,
        Y = void 0 === G ? "" : G,
        $ = Tl("isNewSidebarEnabled"),
        ee = Tl("isNewDashboardEnabled"),
        ne = !1,
        te = {
          isNewSidebarEnabledForUser: !1,
          isNewDashboardEnabledForUser: !1,
        };
      Y &&
        Object.keys($).includes(Y.toString()) &&
        Object.keys(ee).includes(Y.toString()) &&
        ((ne = !0),
        (te.isNewSidebarEnabledForUser = $[Y]),
        (te.isNewDashboardEnabledForUser = ee[Y]));
      var re = Rl((0, e.useState)({}), 2),
        oe = re[0],
        ie = re[1],
        ae = Rl((0, e.useState)(""), 2),
        le = ae[0],
        ue = ae[1],
        de = Rl((0, e.useState)(null), 2),
        pe = de[0],
        he = de[1],
        me = Rl((0, e.useState)(!1), 2),
        _e = me[0],
        ge = me[1],
        Ce = Rl((0, e.useState)(""), 2),
        be = Ce[0],
        xe = Ce[1],
        ye = Rl((0, e.useState)(!1), 2),
        je = ye[0],
        Ee = ye[1],
        Se = Rl((0, e.useState)(!1), 2),
        Me = Se[0],
        Te = Se[1],
        He = Rl((0, e.useState)(!1), 2),
        Ve = He[0],
        Be = He[1],
        We = Rl((0, e.useState)(!1), 2),
        ze = We[0],
        Ze = We[1],
        Fe = Rl((0, e.useState)(!1), 2),
        Ue = Fe[0],
        Ke = Fe[1],
        Ge = Rl((0, e.useState)(te.isNewSidebarEnabledForUser), 2),
        Ye = Ge[0],
        $e = Ge[1],
        qe = Rl((0, e.useState)(), 2),
        Xe = qe[0],
        Je = qe[1],
        en = Rl((0, e.useState)(te.isNewDashboardEnabledForUser), 2),
        nn = en[0],
        tn = en[1],
        rn = Rl((0, e.useState)(!1), 2),
        on = rn[0],
        an = rn[1],
        ln = Rl((0, e.useState)(!0), 2),
        sn = ln[0],
        cn = ln[1];
      (0, e.useEffect)(
        function () {
          if (pe) {
            var e = document.getElementById("lt-ch-left-nav"),
              n = document
                .getElementById("left_sidebar_header-items")
                .classList.contains("collapsed");
            e && Ye && n && fn(!0);
          }
        },
        [pe]
      ),
        (0, e.useEffect)(function () {
          Ye && Je(!0);
        }, []);
      var un = document.getElementById("lt-ch-left-nav"),
        dn = document.getElementById("lambda_logo_top_nav"),
        pn = function () {
          var e = document.getElementById("left_sidebar_header-items"),
            n = document.getElementById("top_navbar_header");
          e &&
            n &&
            un &&
            (e.classList.toggle("collapsed"),
            n.classList.toggle("collapsed"),
            un.classList.toggle("collapsed"));
        },
        fn = function () {
          var e =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          pn(),
            e
              ? (un.setAttribute("role", "dialog"),
                un.setAttribute("aria-modal", "true"))
              : (un.removeAttribute("role"),
                un.removeAttribute("aria-modal"),
                he(null)),
            setTimeout(function () {
              an(!e);
            }, 180);
          var n = new CustomEvent("LTCH_IsNewSidebarShown", {
            detail: { shown: e },
          });
          window.dispatchEvent(n);
        },
        hn = function (e) {
          var n = document.getElementsByClassName("lambda__logo__wrapper")[0];
          n &&
            n.classList.toggle(
              "ltch-left-nav-hovered",
              "mouseenter" === e.type
            );
          var t = document.getElementById("left_sidebar_header-items"),
            r = document.getElementById("top_navbar_header"),
            o = t && r && un,
            i = t.classList.contains("collapsed");
          o &&
            Ye &&
            ("mouseenter" === e.type && i
              ? fn(!0)
              : "mouseleave" !== e.type || i || fn());
        },
        mn = function () {
          dn && Ye && dn.removeEventListener("mouseenter", hn),
            un &&
              (un.removeEventListener("mouseenter", hn),
              un.removeEventListener("mouseleave", hn));
        },
        _n = function (e) {
          !(function (e, n) {
            var t = e.target.classList.contains(
              "aside__menu__bottom__submenu__item"
            );
            if (
              !document
                .getElementById("left_sidebar_header-items")
                .classList.contains("collapsed")
            ) {
              if ("Escape" === e.key && !t) {
                var r = document.activeElement.id;
                n(),
                  setTimeout(function () {
                    var e = document.getElementById(r);
                    e && e.focus();
                  }, 180);
              }
              var o = document.getElementsByClassName("ltch_lambda__logo")[0],
                i = document.getElementsByClassName(
                  "ltch-bottom-upgrade-btn"
                )[0];
              try {
                De(e, o, i);
              } catch (e) {}
            }
          })(e, fn);
        };
      function gn() {
        return (
          (gn = Pl(
            Al().mark(function e(n) {
              var t,
                r,
                o,
                i,
                a,
                l,
                s,
                c,
                u,
                d,
                p,
                f,
                h,
                m,
                _,
                g,
                v,
                C,
                b,
                x,
                y,
                w,
                k,
                L,
                j,
                E,
                S,
                M,
                T,
                N,
                O,
                A,
                I,
                P,
                R,
                H,
                V,
                D,
                B,
                W,
                z,
                Z,
                F,
                U,
                K,
                G,
                Y,
                $,
                q;
              return Al().wrap(
                function (e) {
                  for (;;)
                    switch ((e.prev = e.next)) {
                      case 0:
                        return (
                          (t = n.id),
                          (r = void 0 === t ? "" : t),
                          (o = n.organization),
                          (i = (void 0 === o ? {} : o).id),
                          (a = void 0 === i ? "" : i),
                          (e.prev = 2),
                          (l = ke()),
                          (e.next = 6),
                          fetch(
                            "".concat(ve("api", !0), "/sdk/v1/user/flags"),
                            {
                              headers: {
                                "Content-Type": "application/json",
                                Accept: "application/json",
                                authorization: "Bearer ".concat(l),
                              },
                              method: "POST",
                              body: JSON.stringify({
                                org_id: "".concat(a),
                                user_id: "".concat(r),
                              }),
                            }
                          )
                        );
                      case 6:
                        return (s = e.sent), (e.next = 9), s.json();
                      case 9:
                        (c = e.sent),
                          (u = c.result),
                          (p = (d = void 0 === u ? {} : u)[
                            "header-upgrade-cta"
                          ]) &&
                            ((f = p.variant || {}),
                            (h = f.key),
                            (m = void 0 === h ? "off" : h),
                            (_ = f.payload),
                            (g = void 0 === _ ? {} : _),
                            "off" !== m && ((v = g.btnText), xe(v))),
                          (C = d.ml_show_archives_menu_option) &&
                            ((b = C.variant || {}),
                            (x = b.key),
                            Ee("off" !== (void 0 === x ? "off" : x))),
                          (y = d["accessibility-tool-access"]) &&
                            !we() &&
                            ((w = y.variant || {}),
                            (k = w.key),
                            Te("off" !== (void 0 === k ? "off" : k))),
                          (L = d["test-manager"]),
                          (j = {}),
                          (E = "off"),
                          L && ((j = L.variant || {}), (E = j.key || "off")),
                          Be(
                            ("Guest" !== n.organization_role && "off" !== E) ||
                              (n.tms_access_state &&
                                "inactive" !== n.tms_access_state)
                          ),
                          (S = d.kane_ai_user_access),
                          (M = {}),
                          (T = "off"),
                          S && ((M = S.variant || {}), (T = M.key || "off")),
                          (N =
                            "true" === T ||
                            (n.kaneAI_access_state &&
                              "inactive" !== n.kaneAI_access_state)),
                          Ze(N),
                          (O = d.sanctum_widget_frontend) &&
                            ((A = O.variant || {}),
                            (I = A.key),
                            Ke("off" !== (void 0 === I ? "off" : I))),
                          (P = d.enable_new_sidebar) &&
                            ((R = P.variant || {}),
                            (H = R.key),
                            (V = "off" !== (void 0 === H ? "off" : H) || N),
                            (D = document.getElementById(
                              "left_sidebar_header-items"
                            )),
                            (B = D && D.classList.contains("collapsed")),
                            V &&
                              !B &&
                              setTimeout(function () {
                                Je(!0);
                              }, 0),
                            $e(V),
                            ((W = Tl("isNewSidebarEnabled"))[r] = V),
                            Nl("isNewSidebarEnabled", W),
                            V &&
                              (z = Ae("sidebarStateObject")) &&
                              ((Z = atob(z)),
                              ((F = JSON.parse(Z)).shouldSidebarCollapse = !1),
                              (U = btoa(JSON.stringify(F))),
                              Le("sidebarStateObject", U, 30))),
                          (K = d.new_dashboard) &&
                            ((G = K.variant || {}),
                            (Y = G.key),
                            tn(($ = "off" !== (void 0 === Y ? "off" : Y))),
                            ((q = Tl("isNewDashboardEnabled"))[r] = $),
                            Nl("isNewDashboardEnabled", q)),
                          (e.next = 38);
                        break;
                      case 36:
                        (e.prev = 36), (e.t0 = e.catch(2));
                      case 38:
                        ge(!0);
                      case 39:
                      case "end":
                        return e.stop();
                    }
                },
                e,
                null,
                [[2, 36]]
              );
            })
          )),
          gn.apply(this, arguments)
        );
      }
      (0, e.useEffect)(
        function () {
          if (un)
            return (
              mn(),
              dn && Ye && dn.addEventListener("mouseenter", hn),
              un &&
                (un.addEventListener("mouseenter", hn),
                un.addEventListener("mouseleave", hn)),
              Ye && un.addEventListener("keydown", _n),
              function () {
                Ye && un.removeEventListener("keydown", _n), mn();
              }
            );
        },
        [un, Ye]
      ),
        (0, e.useEffect)(function () {
          window &&
            window.addEventListener("click", function (e) {
              if (!e.target.matches(".lt-dropdown-toggle"))
                for (
                  var n = document.getElementsByClassName("lt-dropdown"), t = 0;
                  t < n.length;
                  t++
                ) {
                  var r = n[t];
                  if (r.classList.contains("open")) {
                    r.classList.remove("open");
                    var o = r.getElementsByClassName("lt-dropdown-toggle")[0];
                    o &&
                      (o.setAttribute("aria-expanded", !1),
                      o.removeAttribute("aria-controls"));
                  }
                }
              var i = e.target.closest("[data-amplitude]");
              if (i && i.dataset && i.dataset.amplitude && window.amplitude) {
                var a = i.dataset.amplitudePropertyName,
                  l = {};
                a && (l[a] = window.location.href), Re(i.dataset.amplitude, l);
              }
              e.target.parentNode &&
                "zsiq_float" === e.target.parentNode.id &&
                Re("Chat");
            }),
            (function () {
              var e = [
                  "".concat(ve(Q), "/").concat(b),
                  "".concat(ve(X), "/").concat(L),
                  "".concat(ve(X), "/").concat(k),
                  "".concat(ve(Q), "/").concat(k),
                  "".concat(ve(Q), "/").concat(j),
                  "".concat(ve(Q), "/").concat(E),
                  "".concat(ve(Q), "/").concat(M),
                  "".concat(ve(Q), "/").concat(T),
                  "".concat(ve(Q), "/").concat(O),
                  "".concat(ve(Q), "/").concat(N),
                  "".concat(ve(Q), "/").concat(V),
                ],
                n = [W, z, Z, K, q, J],
                t = window.location.href,
                r = Ae("user_id");
              if (e.includes(t)) {
                var o = { userId: r, url: t },
                  i = btoa(JSON.stringify(o));
                Le("last_visited_url", i, 30, !0);
              }
              var a = window.location.host.split(".")[0];
              if (
                !e.includes(t) &&
                n.some(function (e) {
                  return a.includes(e);
                })
              ) {
                var l = { userId: r, url: window.location.origin },
                  s = btoa(JSON.stringify(l));
                Le("last_visited_url", s, 30, !0);
              }
            })();
          var e = ke();
          fetch("".concat(ve(se, !1, "https", "", w), "/api/user"), {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              authorization: "Bearer ".concat(e),
            },
          })
            .then(function (e) {
              if (401 != e.status) return e.json();
              window.location = ""
                .concat(ve(F, !1, "https", "", w), "/")
                .concat(C);
            })
            .then(function (e) {
              var n, t;
              if ((ie(e), e.brand_host))
                ue(e.brand_host),
                  (function (e) {
                    var n,
                      t = window.location.host;
                    "automation.lambdatest.com" === t ||
                    "stage-automation.lambdatestinternal.com" === t
                      ? (n = Oe(z, e))
                      : "hyperexecute.lambdatest.com" === t ||
                        "stage-hyperexecute.lambdatestinternal.com" === t
                      ? (n = Oe(K, e))
                      : ("accounts.lambdatest.com" !== t &&
                          "stage-accounts.lambdatestinternal.com" !== t) ||
                        (n = Oe(F, e)),
                      Pe() &&
                        (t.includes("automation") &&
                          !t.includes("automation.".concat(e)) &&
                          (n = Oe(z, e, !0)),
                        t.includes("accounts") &&
                          !t.includes("accounts.".concat(e)) &&
                          (n = Oe(F, e, !0)),
                        t.includes("dashboard") &&
                          !t.includes("dashboard.".concat(e)) &&
                          (n = Oe("dashboard", e, !0))),
                      n && (window.location.host = n);
                  })(e.brand_host);
              else {
                var r = window.location.host;
                if (r) {
                  var i = r.split(".").length;
                  !w &&
                    i > 3 &&
                    (window.location = ""
                      .concat(ve(F, !1, "https", "", w), "/")
                      .concat(C));
                }
              }
              var a,
                l,
                s,
                c,
                u,
                d =
                  null == e || null === (n = e.organization) || void 0 === n
                    ? void 0
                    : n.id;
              (fe.includes(d) && !x) ||
                ((a = null == e ? void 0 : e.id),
                (o.g.announcekit = o.g.announcekit || {
                  queue: [],
                  on: function (e, n) {
                    o.g.announcekit.queue.push([e, n]);
                  },
                  push: function (e) {
                    o.g.announcekit.queue.push(e);
                  },
                }),
                o.g.announcekit.push({
                  widget: "https://announcekit.app/widget/aeESs",
                  selector: ".announcekit-widget",
                  version: 2,
                  data: { user_id: a },
                })),
                w ||
                  (function (e) {
                    var n = "".concat(
                        ve(ce),
                        "/api/v2/organization/customer-currency"
                      ),
                      t = ke();
                    fetch(n, {
                      headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        authorization: "Bearer ".concat(t),
                      },
                    })
                      .then(function (e) {
                        return e.json();
                      })
                      .then(function (n) {
                        return (function (e, n) {
                          try {
                            window.appboy.changeUser(e),
                              window.appboy
                                .getUser()
                                .setCustomUserAttribute("currency", n);
                          } catch (e) {}
                        })(e, n.organization.customer_currency);
                      });
                  })(null == e ? void 0 : e.uuid),
                (function (e) {
                  var n = new Date().getTime(),
                    t = new Date(e.created_at).getTime(),
                    r = new Date(new Date().setDate(new Date().getDate() - 30)),
                    o = window.location.hostname;
                  if (
                    ((e && "Free" === e.organization.subscription_type) ||
                      o.includes(K) ||
                      o.includes(z)) &&
                    ((n >= t && t >= r) || o.includes(K) || o.includes(z))
                  )
                    try {
                      userflow.identify(e.id, {
                        name: e.name,
                        email: e.email,
                        signed_up_at: e.created_at,
                        status: e.status,
                        username: e.username,
                        subscription_type: e.organization.subscription_type,
                      });
                    } catch (e) {}
                })(e),
                (function (e) {
                  var n = window.Appcues;
                  if (e && null != e && e.email_verified && n)
                    try {
                      var t = e.created_at,
                        r = void 0 === t ? "" : t,
                        o = e.email,
                        i = void 0 === o ? "" : o,
                        a = e.id,
                        l = void 0 === a ? "" : a,
                        s = e.organization,
                        c = void 0 === s ? {} : s,
                        u = e.name,
                        d = void 0 === u ? "" : u,
                        p = e.status,
                        f = void 0 === p ? "" : p,
                        h = e.username,
                        m = void 0 === h ? "" : h,
                        _ = window.location.hostname.includes("lambdatest.com")
                          ? "prod_"
                          : "stage_";
                      n.identify("".concat(_).concat(l.toString()), {
                        name: d,
                        email: i,
                        signed_up_at: r,
                        status: f,
                        username: m,
                        subscription_type:
                          null == c ? void 0 : c.subscription_type,
                      });
                    } catch (e) {
                      console.log(e);
                    }
                })(e),
                (u = e),
                window.location.host.includes(F) ||
                  window.location.host.includes(Z) ||
                  (!u ||
                  "Free" !== u.organization.subscription_type ||
                  u.email_verified
                    ? u &&
                      "Free" === u.organization.subscription_type &&
                      u.show_updated_profile &&
                      (o.g.location.href = "".concat(ve(F), "/profile/setup"))
                    : (o.g.location.href = "".concat(ve(F), "/email/verify"))),
                (function (e) {
                  var n = {
                    "current subscription status":
                      e.organization.subscription_type,
                    "user status": null == e ? void 0 : e.status,
                    "signed up at": null == e ? void 0 : e.created_at,
                  };
                  try {
                    if (window.amplitude)
                      if (void 0 !== window.amplitude.getInstance)
                        window.amplitude.getInstance().setUserProperties(n);
                      else {
                        var t = new window.amplitude.Identify();
                        t
                          .set(
                            "current subscription status",
                            e.organization.subscription_type
                          )
                          .set("user status", null == e ? void 0 : e.status)
                          .set(
                            "signed up at",
                            null == e ? void 0 : e.created_at
                          ),
                          amplitude.identify(t);
                      }
                  } catch (e) {}
                })(e),
                (function (e) {
                  var n = o.g.location.host;
                  if (
                    n.includes("automation.lambdatest") ||
                    n.includes("applive.lambdatest") ||
                    n.includes("smartui.lambdatest")
                  ) {
                    var t = n.split(".")[0];
                    e && !n.includes("eu-")
                      ? (window.location = Ne(!0, t))
                      : !e &&
                        n.includes("eu-") &&
                        (window.location = Ne(!1, t));
                  }
                })(
                  null === (t = e.organization) || void 0 === t
                    ? void 0
                    : t.is_compliance
                ),
                w ||
                  ((l = e) &&
                    l.ip_changed &&
                    !window.location.hostname.includes(F) &&
                    (bn(!0),
                    setTimeout(function () {
                      bn(!1),
                        (window.location = "".concat(ve(F), "/").concat(C));
                    }, 3e3))),
                window.location.host.includes("lambdatest")
                  ? ((function (e) {
                      gn.apply(this, arguments);
                    })(e),
                    ((c = document.createElement("script")).src =
                      "https://app.revenuehero.io/scheduler.min.js"),
                    (c.async = !0),
                    document.body.appendChild(c),
                    (function () {
                      var e = "".concat(ve(ce), "/api/v1/promoter-details"),
                        n = ke();
                      fetch(e, {
                        headers: {
                          "Content-Type": "application/json",
                          Accept: "application/json",
                          authorization: "Bearer ".concat(n),
                        },
                      })
                        .then(function (e) {
                          return e.json();
                        })
                        .then(function (e) {
                          var n = (e || {}).referral_link;
                          cn(!(void 0 !== n && n));
                        });
                    })(),
                    (function (e, n, t) {
                      var r = window.location.host;
                      if (
                        r.includes("hyperexecute.lambdatest") ||
                        r.includes("automation.lambdatest") ||
                        r.includes("accounts.lambdatest")
                      ) {
                        var o = ""
                            .concat(
                              ve(se, !1, "https", t, n),
                              "/api/org_preferences/"
                            )
                            .concat(e),
                          i = ke();
                        fetch(o, {
                          headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                            authorization: "Bearer ".concat(i),
                          },
                        })
                          .then(function (e) {
                            return e.json();
                          })
                          .then(function (e) {
                            if (e) {
                              var n = e.hyperexecuteOnPremEnabled;
                              if (void 0 !== n && n) {
                                var t = r.includes("automation")
                                  ? "automation"
                                  : r.includes("accounts")
                                  ? "accounts"
                                  : "dashboard";
                                window.location = "https://".concat(
                                  t,
                                  ".hyperexecute.cloud"
                                );
                              }
                            }
                          });
                      }
                    })(
                      null === (s = e.organization) || void 0 === s
                        ? void 0
                        : s.id,
                      w,
                      e.brand_host || ""
                    ))
                  : ge(!0);
            });
        }, []);
      var vn = Rl((0, e.useState)(!1), 2),
        Cn = vn[0],
        bn = vn[1];
      return _e || ne
        ? (0, Qe.jsx)(r.Provider, {
            value: {
              isHighContrastThemeEnabled: x,
              isNewDashboardShown: nn,
              isNewToReferral: sn,
              enableNewSidebar: Ye,
              enableSanctumWidget: Ue,
              selectedMenu: pe,
              setSelectedMenu: he,
            },
            children: (0, Qe.jsxs)("div", {
              className: "".concat(
                Ye ? "ltch-sidebar-overlay" : "",
                " wrapper"
              ),
              children: [
                (0, Qe.jsx)("a", {
                  href: "#start-of-content",
                  className: "ltch-skip-to-content",
                  onClick: function (e) {
                    e.preventDefault(),
                      document.getElementById("start-of-content").focus();
                  },
                  children: "Skip to content",
                }),
                (0, Qe.jsx)(el, {
                  areFeatureFlagsFetched: _e,
                  brandName: le,
                  concurrencyInfo: a,
                  customProductHeader: s,
                  defaultTabIndex: d,
                  isCollapsed: m,
                  isNewThemeEnabled: g,
                  onPremPrefixToUse: w,
                  lowResNavItems: U,
                  showA11yWarning: A,
                  showTunnel: !w && P,
                  setIsSideBarCollapsed: Je,
                  topNavCustomInfo: R,
                  topNavButtons: D,
                  upgradeBtnTextToDisplay: be,
                  userInfo: oe,
                }),
                (0, Qe.jsxs)("div", {
                  className: "main_section",
                  children: [
                    (0, Qe.jsx)(Cl, {
                      areFeatureFlagsFetched: _e,
                      brandName: le,
                      defaultTabIndex: d,
                      detailedProductNav: f,
                      isNewThemeEnabled: g,
                      isSideBarCollapsed: Xe,
                      onPremPrefixToUse: w,
                      showAccessibilityOption: Me,
                      showKaneAI: ze,
                      showTooltip: on,
                      showNonCompliantWCAGMenuOption: je,
                      showTestManager: Ve,
                      upgradeBtnTextToDisplay: be,
                      userInfo: oe,
                    }),
                    (0, Qe.jsxs)("div", {
                      className: "product_main_content",
                      children: [
                        (0, Qe.jsx)("div", {
                          id: "start-of-content",
                          className: "ltch-start-of-content",
                          tabIndex: -1,
                        }),
                        c,
                      ],
                    }),
                  ],
                }),
                (0, Qe.jsx)(Ml, { userInfo: oe }),
                Cn &&
                  (0, Qe.jsx)(Vr, {
                    msg: "You are not allowed to login with current IP",
                    showToast: Cn,
                    error: !0,
                  }),
              ],
            }),
          })
        : (0, Qe.jsx)(Qe.Fragment, {});
    };
  })(),
    (module.exports = i);
})();
